import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  IsoDateTime: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  LimitedInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** ObjectId custom scalar type */
  ObjectId: { input: any; output: any; }
  Upload: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type AcceptRequestedPublicGroupInput = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export enum AccountRoles {
  Applicant = 'APPLICANT',
  Mentor = 'MENTOR',
  University = 'UNIVERSITY'
}

export type ActivateApplicantsMutation = {
  __typename?: 'ActivateApplicantsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivateMentorsMutation = {
  __typename?: 'ActivateMentorsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivityField = {
  __typename?: 'ActivityField';
  activitySource?: Maybe<ActivitySourceField>;
  app?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  user?: Maybe<AnyUserField>;
};

export type ActivitySourceField = {
  __typename?: 'ActivitySourceField';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
};

export type AddAttributeOptionMutation = {
  __typename?: 'AddAttributeOptionMutation';
  university?: Maybe<UniversityField>;
};

export type AddBotToChatGroupMutation = {
  __typename?: 'AddBotToChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type AddCustomAttributeMutation = {
  __typename?: 'AddCustomAttributeMutation';
  university?: Maybe<UniversityField>;
};

export type AddDegreeLevelsMutation = {
  __typename?: 'AddDegreeLevelsMutation';
  degreeLevels?: Maybe<Array<Maybe<DegreeLevelField>>>;
};

export type AddDegreesMutation = {
  __typename?: 'AddDegreesMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type AddHobsonsConnectIntegration = {
  __typename?: 'AddHobsonsConnectIntegration';
  integration?: Maybe<CampusManagementConnectIntegrationField>;
};

export type AddLocalesToApp = {
  __typename?: 'AddLocalesToApp';
  appLocales?: Maybe<Array<Maybe<AppLocaleField>>>;
};

export type AddResearchTimeMutation = {
  __typename?: 'AddResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type AddYearOfStudyMutation = {
  __typename?: 'AddYearOfStudyMutation';
  yearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
};

export type AdminDeleteApplicantMutation = {
  __typename?: 'AdminDeleteApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type AdminRecommendation = {
  __typename?: 'AdminRecommendation';
  active: Scalars['Boolean']['output'];
  cohort?: Maybe<Cohort>;
  description: Scalars['String']['output'];
  forDecisionStage: DecisionStageEnum;
  id: Scalars['ObjectId']['output'];
  resourceType: RecommendationResourceType;
  title: Scalars['String']['output'];
  universityId: Scalars['ObjectId']['output'];
  url: Scalars['String']['output'];
};

export type AdminRecommendationCountPerDecisionStage = {
  __typename?: 'AdminRecommendationCountPerDecisionStage';
  forDecisionStage: DecisionStageEnum;
  recommendationCount: Scalars['Int']['output'];
};

export type AdminRecommendationInput = {
  cohort?: InputMaybe<CohortInput>;
  description: Scalars['String']['input'];
  forDecisionStage: DecisionStageEnum;
  resourceType: RecommendationResourceTypeEnum;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AdminUpdateMentorMutation = {
  __typename?: 'AdminUpdateMentorMutation';
  mentor?: Maybe<MentorField>;
};

export type AdminUserField = {
  __typename?: 'AdminUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AgeVerificationInfoField = {
  __typename?: 'AgeVerificationInfoField';
  age?: Maybe<Scalars['Int']['output']>;
  consentAgeForCountry?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  isMinor?: Maybe<Scalars['Boolean']['output']>;
};

export type AgeVerificationInfoInputField = {
  age?: InputMaybe<Scalars['Int']['input']>;
  consentAgeForCountry?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  isMinor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertField = {
  __typename?: 'AlertField';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};

export type AllPostsField = {
  __typename?: 'AllPostsField';
  blogPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  blogPostsAuthors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blogPostsCount?: Maybe<Scalars['Int']['output']>;
  blogPostsDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  blogPostsTopics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AmbassadorField = {
  __typename?: 'AmbassadorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
};

export type AmbassadorProfileInformation = {
  __typename?: 'AmbassadorProfileInformation';
  accountRole: Buddies;
  bio: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  degreeName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  universityId?: Maybe<Scalars['String']['output']>;
};

export type AmbassadorRecommendation = {
  __typename?: 'AmbassadorRecommendation';
  active: Scalars['Boolean']['output'];
  ambassadorId: Scalars['ObjectId']['output'];
  forDecisionStage?: Maybe<DecisionStageEnum>;
  id: Scalars['ObjectId']['output'];
  resourceType: AmbassadorRecommendationResourceType;
  resourceURL: Scalars['String']['output'];
  sharedWithUser: Scalars['ObjectId']['output'];
  universityId: Scalars['ObjectId']['output'];
};

export type AmbassadorRecommendationInput = {
  resourceType: AmbassadorRecommendationResourceTypeEnum;
  resourceURL: Scalars['String']['input'];
  sharedWithUser: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type AmbassadorRecommendationResourceType = {
  __typename?: 'AmbassadorRecommendationResourceType';
  displayName: Scalars['String']['output'];
  name: AmbassadorRecommendationResourceTypeEnum;
};

export enum AmbassadorRecommendationResourceTypeEnum {
  Ambassador = 'AMBASSADOR',
  Blog = 'BLOG'
}

export type Analytics = {
  __typename?: 'Analytics';
  attendees: Attendees;
  id: Scalars['ObjectId']['output'];
  messagesSent: Scalars['Float']['output'];
  signups: Scalars['Float']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type AnalyticsBuddyField = {
  __typename?: 'AnalyticsBuddyField';
  buddyId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<GraphField>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDashboardAuthField = {
  __typename?: 'AnalyticsDashboardAuthField';
  key?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDashboardMetadata = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsMentorField = {
  __typename?: 'AnalyticsMentorField';
  data?: Maybe<GraphField>;
  degree?: Maybe<Scalars['String']['output']>;
  mentorId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AnyChatUserField = {
  __typename?: 'AnyChatUserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  chatIntroMessage?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  headlineInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboxInfoOne?: Maybe<Scalars['String']['output']>;
  inboxInfoTwo?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};


export type AnyChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnyUserField = {
  __typename?: 'AnyUserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<DegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  domesticRegion?: Maybe<DomesticRegionField>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserField>;
  university?: Maybe<UniversityField>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type AppLocaleField = {
  __typename?: 'AppLocaleField';
  locales?: Maybe<Array<Maybe<Locale>>>;
  name?: Maybe<Scalars['String']['output']>;
  universityLocalePreferenceApplies?: Maybe<Scalars['Boolean']['output']>;
};

export type AppLocalesFieldInput = {
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantBroadcastMessageMutation = {
  __typename?: 'ApplicantBroadcastMessageMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicantCollectionField = {
  __typename?: 'ApplicantCollectionField';
  fieldName?: Maybe<Scalars['String']['output']>;
  isCustomField?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ApplicantConversationField = {
  __typename?: 'ApplicantConversationField';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApplicantCountField = {
  __typename?: 'ApplicantCountField';
  applicantCount?: Maybe<Scalars['Int']['output']>;
};

export type ApplicantField = {
  __typename?: 'ApplicantField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  ageVerificationInfo?: Maybe<AgeVerificationInfoField>;
  applicantUniversities?: Maybe<Array<Maybe<ApplicantUniversityLinkField>>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAcceptedMarketing?: Maybe<Scalars['Boolean']['output']>;
  hasAppliedToCurrentUniversity?: Maybe<Scalars['Boolean']['output']>;
  hasReadChatRules?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkWithUniversity?: Maybe<ApplicantUniversityLinkField>;
  localePreference?: Maybe<UserLocalePreference>;
  marketplaces?: Maybe<Array<Maybe<ApplicantMarketplaceObjectField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<ApplicantPreferencesField>;
  primaryApp?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<ApplicantSchoolHistory>;
  signUpLocation?: Maybe<Scalars['String']['output']>;
  unibuddyServicesConsentAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated favoring applicant_universities */
  universitiesApplied?: Maybe<Array<Maybe<ApplicantUniversityLinkField>>>;
  universitiesInterested?: Maybe<Array<Maybe<UniversityField>>>;
};


export type ApplicantFieldLinkWithUniversityArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantInboxField = {
  __typename?: 'ApplicantInboxField';
  botChatGroup?: Maybe<ChatGroupField>;
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  universityClearingChatGroup?: Maybe<ChatGroupField>;
};

export type ApplicantInvite = {
  __typename?: 'ApplicantInvite';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantLabelField = {
  __typename?: 'ApplicantLabelField';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicantMarketplaceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  userData?: InputMaybe<MarketplaceApplicantData>;
};

export type ApplicantMarketplaceObjectField = {
  __typename?: 'ApplicantMarketplaceObjectField';
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<MarketplaceApplicantUserData>;
};

export type ApplicantPreferencesField = {
  __typename?: 'ApplicantPreferencesField';
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicantSchoolHistory = {
  __typename?: 'ApplicantSchoolHistory';
  highSchool?: Maybe<HighSchoolField>;
};

export type ApplicantSignupStats = {
  __typename?: 'ApplicantSignupStats';
  xAxis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  yAxis?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ApplicantUniversityLinkField = {
  __typename?: 'ApplicantUniversityLinkField';
  applied?: Maybe<Scalars['Boolean']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  delinked?: Maybe<Scalars['Boolean']['output']>;
  hasAcceptedMarketing?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  setupComplete?: Maybe<Scalars['Boolean']['output']>;
  university?: Maybe<UniversityField>;
};


export type ApplicantUniversityLinkFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicantUserField = ChatUserField & {
  __typename?: 'ApplicantUserField';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ApplicantsAppliedStats = {
  __typename?: 'ApplicantsAppliedStats';
  applied?: Maybe<Scalars['Int']['output']>;
  notApplied?: Maybe<Scalars['Int']['output']>;
  notReplied?: Maybe<Scalars['Int']['output']>;
};

export type ApplicantsMessagedCount = {
  __typename?: 'ApplicantsMessagedCount';
  messagedCount?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationField = {
  __typename?: 'ApplicationField';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationInsightModel = {
  __typename?: 'ApplicationInsightModel';
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['output'];
  id: Scalars['ObjectId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  totalApplied: Scalars['Int']['output'];
  university: UniversityField;
};

export type AppliedUsersCountInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type AppliedUsersCountModel = {
  __typename?: 'AppliedUsersCountModel';
  appliedUsersCount: Scalars['Int']['output'];
};

export type AssistantConversationFeedback = {
  __typename?: 'AssistantConversationFeedback';
  /** When the feedback was created */
  createdAt: Scalars['DateTime']['output'];
  /** Rating from 1-5 on the quality of the conversation */
  rating: Scalars['Float']['output'];
  /** Optional free text for the conversation feedback */
  text?: Maybe<Scalars['String']['output']>;
  /** When the feedback was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AssistantConversationHistory = {
  __typename?: 'AssistantConversationHistory';
  feedback?: Maybe<AssistantConversationFeedback>;
  id: Scalars['String']['output'];
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<AssistantConversationMessage>;
  universityId: Scalars['String']['output'];
};

export type AssistantConversationHistoryWithToken = {
  __typename?: 'AssistantConversationHistoryWithToken';
  feedback?: Maybe<AssistantConversationFeedback>;
  id: Scalars['String']['output'];
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<AssistantConversationMessage>;
  token?: Maybe<Scalars['String']['output']>;
  universityId: Scalars['String']['output'];
};

export type AssistantConversationLead = {
  __typename?: 'AssistantConversationLead';
  conversationId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  marketingConsent?: Maybe<Scalars['Boolean']['output']>;
  ubConsent: Scalars['Boolean']['output'];
  universityId: Scalars['String']['output'];
};

export type AssistantConversationMessage = {
  __typename?: 'AssistantConversationMessage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<AssistantMessageFeedback>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<MessageMetadata>;
  sender: SenderRole;
  universityId: Scalars['String']['output'];
};

export type AssistantMessageFeedback = {
  __typename?: 'AssistantMessageFeedback';
  freeText?: Maybe<Scalars['String']['output']>;
  type: AssistantMessageFeedbackType;
};

export type AssistantMessageFeedbackInput = {
  freeText?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  type: AssistantMessageFeedbackType;
};

export enum AssistantMessageFeedbackType {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type Attachment = {
  __typename?: 'Attachment';
  fileName?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  type: AttachmentType;
};

export type AttachmentDto = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  type: AttachmentType;
};

export type AttachmentField = {
  __typename?: 'AttachmentField';
  payload?: Maybe<PayloadField>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentType {
  Pdf = 'PDF'
}

export type AttendeeAnalytics = {
  __typename?: 'AttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type AttendeeData = {
  accountRole: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ObjectId']['input'];
  virtualEventId: Scalars['ObjectId']['input'];
};

export type Attendees = {
  __typename?: 'Attendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type AuthField = {
  __typename?: 'AuthField';
  accessToken?: Maybe<Scalars['String']['output']>;
  device?: Maybe<DeviceField>;
  me?: Maybe<MeField>;
};

export type AuthorSnippetField = {
  __typename?: 'AuthorSnippetField';
  author?: Maybe<MentorField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type BaseCustomAttributeField = CustomAttributeField & {
  __typename?: 'BaseCustomAttributeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BlockUserMutation = {
  __typename?: 'BlockUserMutation';
  objectsBlockedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockUserMutationV2 = {
  __typename?: 'BlockUserMutationV2';
  objectsBlockedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BlockerField = {
  __typename?: 'BlockerField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BlogCommentField = {
  __typename?: 'BlogCommentField';
  author?: Maybe<AnyUserField>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BlogPostField = {
  __typename?: 'BlogPostField';
  approved?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  author?: Maybe<MentorField>;
  body?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<BlogCommentField>>>;
  coverImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  flaggedByUser?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<AnyUserField>;
  modified?: Maybe<Scalars['String']['output']>;
  numberOfViews?: Maybe<Scalars['Int']['output']>;
  ogShareUrl?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['Int']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BlogStatus>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<BlogTopicField>;
  university?: Maybe<UniversityField>;
  videoContent?: Maybe<VideoContent>;
  wordCount?: Maybe<Scalars['Int']['output']>;
  youtubeVideo?: Maybe<Scalars['String']['output']>;
};


export type BlogPostFieldCoverImagesArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogPostFieldImageArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BlogStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  ReadyToPublish = 'READY_TO_PUBLISH',
  Unpublished = 'UNPUBLISHED'
}

export type BlogTopicField = {
  __typename?: 'BlogTopicField';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BlogcardSnippetField = {
  __typename?: 'BlogcardSnippetField';
  authorSnippets?: Maybe<Array<Maybe<AuthorSnippetField>>>;
  description?: Maybe<DescriptionField>;
  topicSnippets?: Maybe<Array<Maybe<TopicSnippetField>>>;
};

export type BotUserField = {
  __typename?: 'BotUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export enum Buddies {
  Ambassador = 'AMBASSADOR',
  Staff = 'STAFF'
}

export type BuddiesField = {
  __typename?: 'BuddiesField';
  count?: Maybe<Scalars['Int']['output']>;
  randomizeListSeed?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<BuddyField>>>;
};

export type BuddiesFilterOptionsField = {
  __typename?: 'BuddiesFilterOptionsField';
  customAttributesFilters?: Maybe<Array<Maybe<CustomAttributesFilterField>>>;
  departments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BuddiesListFilterField = {
  __typename?: 'BuddiesListFilterField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BuddiesListFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BuddyApplicantChatGroupField = {
  __typename?: 'BuddyApplicantChatGroupField';
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  unanswered?: Maybe<Scalars['Boolean']['output']>;
};

export type BuddyApplicantChatGroupFieldV2 = {
  __typename?: 'BuddyApplicantChatGroupFieldV2';
  applicant?: Maybe<ApplicantField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageText?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  staff?: Maybe<StaffField>;
};

export type BuddyApplicantChatInterventionBuddyField = {
  __typename?: 'BuddyApplicantChatInterventionBuddyField';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
};


export type BuddyApplicantChatInterventionBuddyFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuddyField = {
  __typename?: 'BuddyField';
  active?: Maybe<Scalars['Boolean']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
  university?: Maybe<UniversityField>;
};


export type BuddyFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuddyFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuddyInviteField = {
  __typename?: 'BuddyInviteField';
  buddyInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BuddyInviteListField = {
  __typename?: 'BuddyInviteListField';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  notFound?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BulkApplicantField = {
  __typename?: 'BulkApplicantField';
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>;
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  applied?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  blockedByUniversity?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributesField>>>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  degreesInterested?: Maybe<Array<Maybe<DegreeField>>>;
  domesticRegion?: Maybe<DomesticRegionField>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<ApplicantLabelField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryApp?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<ApplicantSchoolHistory>;
  signUpLocation?: Maybe<Scalars['String']['output']>;
  signupSource?: Maybe<Scalars['String']['output']>;
  sourceTrackingParams?: Maybe<SourceTrackingParamsField>;
  universitiesInterested?: Maybe<Array<Maybe<UniversityField>>>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkOptOutMarketplaceUniversityMarketingMutation = {
  __typename?: 'BulkOptOutMarketplaceUniversityMarketingMutation';
  me?: Maybe<MeField>;
};

export type ButtonField = {
  __typename?: 'ButtonField';
  inline?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CrmApplicantField = {
  __typename?: 'CRMApplicantField';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CrmField = {
  __typename?: 'CRMField';
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  crmMetaData?: Maybe<CrmMetaDataField>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CrmIntegrationField = {
  __typename?: 'CRMIntegrationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  connection?: Maybe<CrmConnectionField>;
  crm?: Maybe<CrmField>;
  crmApplicantRecords?: Maybe<Array<Maybe<CrmApplicantRecordField>>>;
  crmIdentifier?: Maybe<Scalars['String']['output']>;
  fieldMapping?: Maybe<Array<Maybe<FieldMappingField>>>;
  id?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<Array<Maybe<CrmSyncJobField>>>;
  lastSyncJob?: Maybe<CrmSyncJobField>;
  syncErrorCount?: Maybe<Scalars['Int']['output']>;
  syncSuccessCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};


export type CrmIntegrationFieldCrmApplicantRecordsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CrmMetaDataField = {
  __typename?: 'CRMMetaDataField';
  additionalInfoLink?: Maybe<Scalars['String']['output']>;
  additionalInfoText?: Maybe<Scalars['String']['output']>;
  logoData?: Maybe<Array<Maybe<LogoDataField>>>;
};

export type CsvUploadAmbassadorFieldsMutation = {
  __typename?: 'CSVUploadAmbassadorFieldsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CsvUploadApplicantsMutation = {
  __typename?: 'CSVUploadApplicantsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampusManagementConnectIntegrationField = {
  __typename?: 'CampusManagementConnectIntegrationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  crm?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  passKey?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  webServiceUrl?: Maybe<Scalars['String']['output']>;
};

export type CanonicalQuestionField = {
  __typename?: 'CanonicalQuestionField';
  answers?: Maybe<Array<Maybe<FaqAnswerField>>>;
  id: Scalars['String']['output'];
  subTopic?: Maybe<SubTopicField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CarouselSnippetField = {
  __typename?: 'CarouselSnippetField';
  defaultSnippet?: Maybe<Scalars['String']['output']>;
  description?: Maybe<DescriptionField>;
};

export type ChatConversation = {
  __typename?: 'ChatConversation';
  communityChatDescription?: Maybe<Scalars['String']['output']>;
  communityChatDynamicLink?: Maybe<Scalars['String']['output']>;
  communityChatMembers?: Maybe<Array<UserField>>;
  communityChatTitle?: Maybe<Scalars['String']['output']>;
  communityId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<UserField>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  isNewsFeed: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Labels>>;
  lastMessage?: Maybe<ChatMessage>;
  members?: Maybe<Array<UserField>>;
  mutedBy: Array<Scalars['ID']['output']>;
  pinnedMessages: Array<ChatMessage>;
  pinnedMessagesCount: Scalars['Int']['output'];
  product: Product;
  tags?: Maybe<Array<ConversationTag>>;
  totalMemberCount?: Maybe<Scalars['Float']['output']>;
  university: UniversityField;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};


export type ChatConversationCommunityChatMembersArgs = {
  offsetPagination: OffsetPagination;
};


export type ChatConversationMembersArgs = {
  offsetPagination?: InputMaybe<OffsetPaginationDto>;
};

export type ChatConversationInboxInputDto = {
  product?: InputMaybe<Product>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatGroupAndMessages = {
  __typename?: 'ChatGroupAndMessages';
  chatGroup?: Maybe<ChatGroupField>;
  error?: Maybe<Scalars['String']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
  offsetId?: Maybe<Scalars['String']['output']>;
};

export type ChatGroupAuxiliaryField = {
  __typename?: 'ChatGroupAuxiliaryField';
  id?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<ChatGroupLabelField>>>;
  willReply?: Maybe<WillReplyField>;
};

export type ChatGroupField = {
  __typename?: 'ChatGroupField';
  applicant?: Maybe<AnyChatUserField>;
  aux?: Maybe<ChatGroupAuxiliaryField>;
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  delinked?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<LastMessageField>;
  members?: Maybe<Array<Maybe<AnyUserField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
  messagesForModeration?: Maybe<Array<Maybe<MessageField>>>;
  opponent?: Maybe<AnyChatUserField>;
  pinnedMessages?: Maybe<Array<Maybe<PinnedMessageField>>>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  sendbirdChannelUrl?: Maybe<Scalars['String']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};


export type ChatGroupFieldMessagesArgs = {
  lastFetched?: InputMaybe<Scalars['String']['input']>;
  messagesToFetch?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatGroupFieldMessagesForModerationArgs = {
  lastFetched?: InputMaybe<Scalars['String']['input']>;
  messagesToFetch?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatGroupLabelField = {
  __typename?: 'ChatGroupLabelField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatInboxField = InboxItemInterface & {
  __typename?: 'ChatInboxField';
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  likes: Array<Scalars['ObjectId']['output']>;
  likesCount: Scalars['Int']['output'];
  reactions?: Maybe<Array<Reaction>>;
  resolved: Scalars['Boolean']['output'];
  richContent?: Maybe<RichMessageContent>;
  sender: UserField;
  text: Scalars['String']['output'];
};

export type ChatPermission = {
  __typename?: 'ChatPermission';
  id: Scalars['ID']['output'];
  isMember: Scalars['Boolean']['output'];
};

export type ChatReport = {
  __typename?: 'ChatReport';
  actionTaken?: Maybe<Scalars['String']['output']>;
  community: Community;
  conversation: ChatConversation;
  creationTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: ChatMessage;
  moderationTime?: Maybe<Scalars['DateTime']['output']>;
  moderator?: Maybe<UserField>;
  moderatorComment?: Maybe<Scalars['String']['output']>;
  modificationTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  reportee: UserField;
  reporter: UserField;
  reporterComment: Scalars['String']['output'];
  reporterReason: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  university: UniversityField;
};

export type ChatReportModeratorInputDto = {
  actionTaken?: InputMaybe<Scalars['String']['input']>;
  chatReportId: Scalars['ObjectID']['input'];
  moderatorComment: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
};

export type ChatReportUserInputDto = {
  conversationId: Scalars['ObjectID']['input'];
  messageId: Scalars['ObjectID']['input'];
  product: Product;
  reporteeId: Scalars['ObjectID']['input'];
  reporterComment: Scalars['String']['input'];
  reporterReason: Scalars['String']['input'];
  universityId: Scalars['ObjectID']['input'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  chatRoomAnalytics: ChatRoomAnalytics;
  conversation: ChatConversation;
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type ChatRoomAnalytics = {
  __typename?: 'ChatRoomAnalytics';
  chatRoomAttendees: ChatRoomAttendees;
  chatRoomId: Scalars['ObjectId']['output'];
  chatRoomMessagesSent: Scalars['Float']['output'];
  id: Scalars['ObjectId']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type ChatRoomAttendeeAnalytics = {
  __typename?: 'ChatRoomAttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  chatRoomId: Scalars['ObjectId']['output'];
  id: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type ChatRoomAttendeeData = {
  accountRole: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  chatRoomId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type ChatRoomAttendees = {
  __typename?: 'ChatRoomAttendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type ChatSummaryField = {
  __typename?: 'ChatSummaryField';
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatSummary?: Maybe<Scalars['String']['output']>;
  generatedOn?: Maybe<Scalars['DateTime']['output']>;
  prospectId?: Maybe<Scalars['String']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
};

export type ChatUserField = {
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CheckEmailMutation = {
  __typename?: 'CheckEmailMutation';
  emailExists?: Maybe<Scalars['Boolean']['output']>;
  passwordSetEmailSent?: Maybe<Scalars['Boolean']['output']>;
};

export type ChildOrganisationField = {
  __typename?: 'ChildOrganisationField';
  hasOrganisationAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClassificationField = {
  __typename?: 'ClassificationField';
  id?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  topSubTopic?: Maybe<TopSubTopicField>;
};

export type CloneLiveEventAndChannelsMutation = {
  __typename?: 'CloneLiveEventAndChannelsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type Cohort = {
  __typename?: 'Cohort';
  active?: Maybe<Scalars['Boolean']['output']>;
  areaOfStudies?: Maybe<Array<DegreeField>>;
  areaOfStudyIds?: Maybe<Array<Scalars['String']['output']>>;
  countries?: Maybe<Array<CountryField>>;
  countryIds?: Maybe<Array<Scalars['String']['output']>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  degreeLevelIds?: Maybe<Array<Scalars['String']['output']>>;
  degreeLevels?: Maybe<Array<DegreeLevelField>>;
  domesticRegionIds?: Maybe<Array<Scalars['String']['output']>>;
  domesticRegions?: Maybe<Array<DomesticRegionField>>;
  expectedEntryFrom?: Maybe<Scalars['DateTime']['output']>;
  expectedEntryTo?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  universityId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type CohortInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  areaOfStudyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  degreeLevelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  domesticRegionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedEntryFrom?: InputMaybe<Scalars['DateTime']['input']>;
  expectedEntryTo?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};

export type CommentMutation = {
  __typename?: 'CommentMutation';
  comment?: Maybe<BlogCommentField>;
};

export type Community = {
  __typename?: 'Community';
  archived: Scalars['Boolean']['output'];
  blockedMembers?: Maybe<Array<UserField>>;
  communityChatGroups: Array<CommunityChatGroup>;
  communityMemberCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutions?: Maybe<Array<UniversityField>>;
  inviteLinks: Array<InviteLinkDto>;
  members?: Maybe<Array<UserField>>;
  newsFeedGroups?: Maybe<Array<NewsFeedGroup>>;
  requestedPublicGroups: Scalars['Int']['output'];
  settings?: Maybe<SettingsObjectType>;
  title?: Maybe<Scalars['String']['output']>;
  welcomeText?: Maybe<Scalars['String']['output']>;
};

export type CommunityChatGroup = {
  __typename?: 'CommunityChatGroup';
  communityId: Scalars['ID']['output'];
  conversation: ChatConversation;
  createdBy?: Maybe<UserField>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDirect: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Labels>>;
  members?: Maybe<Array<UserField>>;
  mutedBy: Array<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type CommunityField = {
  __typename?: 'CommunityField';
  id?: Maybe<Scalars['String']['output']>;
};

export type CommunityInviteResponse = {
  __typename?: 'CommunityInviteResponse';
  accepted: Scalars['Boolean']['output'];
  communityId: Scalars['String']['output'];
};

export type CommunityInvites = {
  __typename?: 'CommunityInvites';
  accepted: Scalars['Boolean']['output'];
  accountRole?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  invitedEmail: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  usedInviteLink: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommunityJoinResponse = {
  __typename?: 'CommunityJoinResponse';
  alreadyJoined?: Maybe<Scalars['Boolean']['output']>;
  community: Community;
  joined: Scalars['Boolean']['output'];
};

export type CompletedEvent = {
  __typename?: 'CompletedEvent';
  activeAttendees?: Maybe<Scalars['Int']['output']>;
  attendees?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messagesSent?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newSignUps?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CompletedEventsOverview = {
  __typename?: 'CompletedEventsOverview';
  events?: Maybe<Array<Maybe<CompletedEvent>>>;
  eventsCount?: Maybe<Scalars['Int']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentBriefField = {
  __typename?: 'ContentBriefField';
  brief?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isValuable?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Int']['output']>;
  minDuration?: Maybe<Scalars['Int']['output']>;
  sourceMetrics?: Maybe<Array<Maybe<MetricDataPoint>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Context = {
  __typename?: 'Context';
  id: Scalars['String']['output'];
  type: ContextType;
};

export enum ContextType {
  IsDirectConversation = 'isDirectConversation',
  IsNewsFeedConversation = 'isNewsFeedConversation',
  Marketplace = 'marketplace',
  University = 'university'
}

export type ConversationContextChatGroupField = {
  __typename?: 'ConversationContextChatGroupField';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConversationContextField = {
  __typename?: 'ConversationContextField';
  ambassador?: Maybe<AmbassadorField>;
  applicantMsg?: Maybe<Scalars['String']['output']>;
  chatGroup?: Maybe<ConversationContextChatGroupField>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ConversationInbox = {
  __typename?: 'ConversationInbox';
  /** The contexts the conversations on this entity belong to. We should not try to resolve this from the FE as this should be set explicitly on the specific inbox resolvers. */
  contexts: Array<Context>;
  conversations: Array<ChatConversation>;
};

export type ConversationTag = {
  __typename?: 'ConversationTag';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CookieConsentInputDto = {
  preferences: PreferencesInputType;
  uniqueId: Scalars['String']['input'];
};

export type CookieConsentOutputDto = {
  __typename?: 'CookieConsentOutputDTO';
  preferences: PreferencesOutputType;
  uniqueId: Scalars['String']['output'];
};

export type CountPerEpoch = {
  __typename?: 'CountPerEpoch';
  count?: Maybe<Scalars['Int']['output']>;
  epoch?: Maybe<Scalars['String']['output']>;
};

export type CountryAnalyticsValue = {
  __typename?: 'CountryAnalyticsValue';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type CountryField = {
  __typename?: 'CountryField';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  subRegion?: Maybe<Scalars['String']['output']>;
};

export type CountrySnippetField = {
  __typename?: 'CountrySnippetField';
  country?: Maybe<CountryField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type CountryStatField = {
  __typename?: 'CountryStatField';
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type CourseSnippetField = {
  __typename?: 'CourseSnippetField';
  degreeSnippets?: Maybe<Array<Maybe<DegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type CreateAlertMutation = {
  __typename?: 'CreateAlertMutation';
  alert?: Maybe<AlertField>;
};

export type CreateApplicantInsightInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  totalApplied: Scalars['Int']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type CreateApplicantMutation = {
  __typename?: 'CreateApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type CreateApplicantMutationV2 = {
  __typename?: 'CreateApplicantMutationV2';
  applicant?: Maybe<ApplicantField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateAssistantConversationInput = {
  universityId: Scalars['String']['input'];
};

export type CreateBlogTopicMutation = {
  __typename?: 'CreateBlogTopicMutation';
  blogTopic?: Maybe<BlogTopicField>;
};

export type CreateBuddyMutation = {
  __typename?: 'CreateBuddyMutation';
  error?: Maybe<Scalars['String']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  noInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCanonicalQuestion = {
  __typename?: 'CreateCanonicalQuestion';
  question?: Maybe<CanonicalQuestionField>;
};

export type CreateCommunityApplicantMutation = {
  __typename?: 'CreateCommunityApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type CreateCommunityApplicantMutationV2 = {
  __typename?: 'CreateCommunityApplicantMutationV2';
  applicant?: Maybe<ApplicantField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateCommunityChatGroupInput = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicLink?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type CreateCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type CreateCommunityDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  universityId: Scalars['ID']['input'];
};

export type CreateCrmServiceUniversityConfigMutation = {
  __typename?: 'CreateCrmServiceUniversityConfigMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityConfiguration?: Maybe<CrmServiceUniversityConfig>;
};

export type CreateExternalEventMutation = {
  __typename?: 'CreateExternalEventMutation';
  externalEvent?: Maybe<ExternalEventField>;
};

export type CreateFaqAnswer = {
  __typename?: 'CreateFaqAnswer';
  faqAnswer?: Maybe<FaqAnswerField>;
};

export type CreateFresherMutation = {
  __typename?: 'CreateFresherMutation';
  error?: Maybe<Scalars['String']['output']>;
  fresher?: Maybe<ApplicantField>;
};

export type CreateLiveEventDetailsMutation = {
  __typename?: 'CreateLiveEventDetailsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type CreateLiveEventFeedMutation = {
  __typename?: 'CreateLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
};

export type CreateLiveEventFeedSessionsMutation = {
  __typename?: 'CreateLiveEventFeedSessionsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLiveEventMutation = {
  __typename?: 'CreateLiveEventMutation';
  errors?: Maybe<Array<Maybe<FormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type CreateMarketplaceApplicantMutation = {
  __typename?: 'CreateMarketplaceApplicantMutation';
  authenticatedApplicant?: Maybe<AuthField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type CreateMarketplaceMutation = {
  __typename?: 'CreateMarketplaceMutation';
  marketplace?: Maybe<MarketplaceField>;
};

export type CreateMentorMutation = {
  __typename?: 'CreateMentorMutation';
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  mentor?: Maybe<MentorField>;
  noInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpenDayMutation = {
  __typename?: 'CreateOpenDayMutation';
  openDay?: Maybe<OpenDayField>;
};

export type CreateOrganisationBuddyLinkMutation = {
  __typename?: 'CreateOrganisationBuddyLinkMutation';
  organisationBuddyLink?: Maybe<OrganisationBuddyLinkField>;
};

export type CreateOrganisationMutation = {
  __typename?: 'CreateOrganisationMutation';
  organisation?: Maybe<OrganisationField>;
};

export type CreatePostMutation = {
  __typename?: 'CreatePostMutation';
  error?: Maybe<Scalars['String']['output']>;
  post?: Maybe<BlogPostField>;
};

export type CreateRequestedPublicGroupInput = {
  communityId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSubTopicMutation = {
  __typename?: 'CreateSubTopicMutation';
  subTopic?: Maybe<SubTopicField>;
};

export type CreateTagMutation = {
  __typename?: 'CreateTagMutation';
  tag?: Maybe<TagField>;
};

export type CreateTodoInputDto = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  status: TodoStatus;
  targetAudience: Array<TargetAudienceDto>;
  title: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type CreateTopicMutation = {
  __typename?: 'CreateTopicMutation';
  topic?: Maybe<TopicField>;
};

export type CreateUniversityBlockReportMutation = {
  __typename?: 'CreateUniversityBlockReportMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityBlockReport?: Maybe<UniversityBlockReportField>;
};

export type CreateUniversityMutation = {
  __typename?: 'CreateUniversityMutation';
  university?: Maybe<UniversityField>;
};

export type CreateUniversityUserMutation = {
  __typename?: 'CreateUniversityUserMutation';
  universityUser?: Maybe<UniversityUserField>;
};

export type CreateUserMutation = {
  __typename?: 'CreateUserMutation';
  user?: Maybe<UserField>;
};

export type CreateVirtualEventInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  /** the name of the event */
  title: Scalars['String']['input'];
};

export type CreationSource = {
  __typename?: 'CreationSource';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CrmApplicantRecordField = {
  __typename?: 'CrmApplicantRecordField';
  applicant?: Maybe<CrmApplicantField>;
  crmApplicantId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSync?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmAttributeField = {
  __typename?: 'CrmAttributeField';
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmConnectionField = {
  __typename?: 'CrmConnectionField';
  connectionError?: Maybe<Scalars['String']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmDataField = {
  __typename?: 'CrmDataField';
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  isCustomField?: Maybe<Scalars['Boolean']['output']>;
  sampleValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CrmFieldInputType = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  isCustomField?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CrmFieldSyncStatus = {
  __typename?: 'CrmFieldSyncStatus';
  fieldName?: Maybe<Scalars['String']['output']>;
  isSyncActive?: Maybe<Scalars['Boolean']['output']>;
};

export type CrmServiceUniversityConfig = {
  __typename?: 'CrmServiceUniversityConfig';
  allFields?: Maybe<Array<Maybe<CrmDataField>>>;
  connectorEndpoint?: Maybe<Scalars['String']['output']>;
  connectorName?: Maybe<Scalars['String']['output']>;
  dataFormatConfigs?: Maybe<Array<Maybe<DataFormatConfig>>>;
  error?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<CrmDataField>>>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncActive?: Maybe<Scalars['Boolean']['output']>;
  universityId?: Maybe<Scalars['String']['output']>;
  universitySlug?: Maybe<Scalars['String']['output']>;
  zapierWebhook?: Maybe<Scalars['String']['output']>;
};

export type CrmSyncJobField = {
  __typename?: 'CrmSyncJobField';
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  synced?: Maybe<Scalars['Int']['output']>;
  toSync?: Maybe<Scalars['Int']['output']>;
};

export type CurrentDecisionStageOutput = {
  __typename?: 'CurrentDecisionStageOutput';
  decisionStage?: Maybe<DecisionStageEnum>;
  decisionStageLocation?: Maybe<DecisionStageLocationEnum>;
  notInterestedReason?: Maybe<NotInterestedReasonEnum>;
  universityId: Scalars['ObjectId']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ObjectId']['output'];
};

export type CurrentUserDecisionStageQueryInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type CustomAttributeField = {
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomAttributeOptionField = {
  __typename?: 'CustomAttributeOptionField';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeValueField = {
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeValueInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributesField = {
  __typename?: 'CustomAttributesField';
  attribute?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributesFilterField = {
  __typename?: 'CustomAttributesFilterField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributesFilterOptionField>>>;
};

export type CustomAttributesFilterInputField = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributesFilterOptionField = {
  __typename?: 'CustomAttributesFilterOptionField';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DataFormatConfig = {
  __typename?: 'DataFormatConfig';
  dataFormatConfigName?: Maybe<Scalars['String']['output']>;
  dataFormatConfigValue?: Maybe<Scalars['String']['output']>;
};

export type DataFormatConfigInputType = {
  dataFormatConfigName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigValue?: InputMaybe<Scalars['String']['input']>;
};

export type DateValueField = CustomAttributeValueField & {
  __typename?: 'DateValueField';
  attribute?: Maybe<CustomAttributeField>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeactivateApplicantsMutation = {
  __typename?: 'DeactivateApplicantsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export type DeactivateMentorsMutation = {
  __typename?: 'DeactivateMentorsMutation';
  updateCount?: Maybe<Scalars['Int']['output']>;
};

export enum DecisionStageEnum {
  Admitted = 'ADMITTED',
  Applied = 'APPLIED',
  Comparing = 'COMPARING',
  Enrolled = 'ENROLLED',
  GatheringInfo = 'GATHERING_INFO',
  Narrowed = 'NARROWED',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  NotInterested = 'NOT_INTERESTED',
  Preparing = 'PREPARING'
}

export enum DecisionStageLocationEnum {
  ApplicantInsightsPage = 'APPLICANT_INSIGHTS_PAGE',
  CommunityPopUp = 'COMMUNITY_POP_UP',
  EnrolledInsightsPage = 'ENROLLED_INSIGHTS_PAGE',
  WidgetChat = 'WIDGET_CHAT',
  WidgetDecisionPage = 'WIDGET_DECISION_PAGE',
  WidgetForYou = 'WIDGET_FOR_YOU',
  WidgetInbox = 'WIDGET_INBOX',
  WidgetNotInterestedPage = 'WIDGET_NOT_INTERESTED_PAGE',
  WidgetSignup = 'WIDGET_SIGNUP'
}

export type DefaultQuestionsField = {
  __typename?: 'DefaultQuestionsField';
  id?: Maybe<Scalars['String']['output']>;
  subTopic?: Maybe<SubTopicField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DegreeCategoriesAnalyticsValue = {
  __typename?: 'DegreeCategoriesAnalyticsValue';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type DegreeCategoryField = {
  __typename?: 'DegreeCategoryField';
  categoryType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchyRank?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parents?: Maybe<Array<Maybe<DegreeCategoryParentField>>>;
  relatedKeywords?: Maybe<Scalars['String']['output']>;
};

export type DegreeCategoryParentField = {
  __typename?: 'DegreeCategoryParentField';
  categoryType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  hierarchyRank?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeChatUserField = {
  __typename?: 'DegreeChatUserField';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeField = {
  __typename?: 'DegreeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<DegreeCategoryField>>>;
  degreeLevel?: Maybe<DegreeLevelField>;
  degreeType?: Maybe<Array<Maybe<DegreeType>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeLevelField = {
  __typename?: 'DegreeLevelField';
  archived?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
  yearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
};


export type DegreeLevelFieldYearOfStudyArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DegreeSnippetField = {
  __typename?: 'DegreeSnippetField';
  degree?: Maybe<DegreeField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type DegreeStatField = {
  __typename?: 'DegreeStatField';
  count?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
};

export enum DegreeType {
  Bachelor = 'BACHELOR',
  Certification = 'CERTIFICATION',
  Concentration = 'CONCENTRATION',
  Faculty = 'FACULTY',
  Honors = 'HONORS',
  JointHonors = 'JOINT_HONORS',
  Major = 'MAJOR',
  Master = 'MASTER',
  Minor = 'MINOR',
  Phd = 'PHD',
  Program = 'PROGRAM',
  Specialisation = 'SPECIALISATION',
  SpecialProgramme = 'SPECIAL_PROGRAMME'
}

export type DegreeTypeOrderField = {
  __typename?: 'DegreeTypeOrderField';
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DegreeType>;
};

export type DegreeTypeOrderInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DegreeType>;
};

export type DeleteApplicantMutation = {
  __typename?: 'DeleteApplicantMutation';
  applicant?: Maybe<ApplicantField>;
};

export type DeleteAttributeOptionsMutation = {
  __typename?: 'DeleteAttributeOptionsMutation';
  university?: Maybe<UniversityField>;
};

export type DeleteCanonicalQuestion = {
  __typename?: 'DeleteCanonicalQuestion';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};

export type DeleteCustomAttributesMutation = {
  __typename?: 'DeleteCustomAttributesMutation';
  university?: Maybe<UniversityField>;
};

export type DeleteDegreeLevelMutation = {
  __typename?: 'DeleteDegreeLevelMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type DeleteFaqAnswer = {
  __typename?: 'DeleteFaqAnswer';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteKnowledgeBaseEntriesByPatternMatchInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  pattern: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type DeleteKnowledgeBaseEntriesByPatternMismatchInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  pattern: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type DeleteKnowledgeBaseEntriesByUrlListInput = {
  dryRun: Scalars['Boolean']['input'];
  pagination: GraphQlOffsetPaginationInput;
  universityId: Scalars['String']['input'];
  urlsToDelete: Array<Scalars['String']['input']>;
};

export type DeleteKnowledgeBaseEntriesOutput = {
  __typename?: 'DeleteKnowledgeBaseEntriesOutput';
  totalCount: Scalars['Float']['output'];
  universityId: Scalars['String']['output'];
  urls: Array<Scalars['String']['output']>;
};

export type DeleteLiveEventFeedMutation = {
  __typename?: 'DeleteLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLiveEventMessageMutation = {
  __typename?: 'DeleteLiveEventMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLiveEventMutation = {
  __typename?: 'DeleteLiveEventMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type DeletePostMutation = {
  __typename?: 'DeletePostMutation';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRecordingResponse = {
  __typename?: 'DeleteRecordingResponse';
  message: Scalars['String']['output'];
  recordingId: Scalars['ObjectId']['output'];
};

export type DeleteResearchTimeMutation = {
  __typename?: 'DeleteResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSubTopicMutation = {
  __typename?: 'DeleteSubTopicMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTopicMutation = {
  __typename?: 'DeleteTopicMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUniversityUserMutation = {
  __typename?: 'DeleteUniversityUserMutation';
  universityUser?: Maybe<UniversityUserField>;
};

export type DeleteUserMutation = {
  __typename?: 'DeleteUserMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteYearOfStudyMutation = {
  __typename?: 'DeleteYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type DepartmentSnippetField = {
  __typename?: 'DepartmentSnippetField';
  department?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type DescriptionField = {
  __typename?: 'DescriptionField';
  descriptionTag?: Maybe<Scalars['String']['output']>;
  instructionTag?: Maybe<Scalars['String']['output']>;
};

export type DeviceField = {
  __typename?: 'DeviceField';
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DeviceMutation = {
  __typename?: 'DeviceMutation';
  device?: Maybe<DeviceField>;
};

export type DeviceToken = {
  __typename?: 'DeviceToken';
  active: Scalars['Boolean']['output'];
  deviceToken: Scalars['String']['output'];
  system: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type DirectConversationDto = {
  communityId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  userToConverseWith: Scalars['String']['input'];
};

export type DirectMessagingApplicant = {
  __typename?: 'DirectMessagingApplicant';
  applicant?: Maybe<ApplicantField>;
  chatGroup?: Maybe<ChatGroupField>;
};

export type DirectMessagingEnquiryTeam = {
  __typename?: 'DirectMessagingEnquiryTeam';
  chatGroup?: Maybe<ChatGroupField>;
  university?: Maybe<UniversityField>;
};

export type DirectMessagingMentor = {
  __typename?: 'DirectMessagingMentor';
  chatGroup?: Maybe<ChatGroupField>;
  mentor?: Maybe<PublicMentorField>;
};

export type DirectMessagingStaffMember = {
  __typename?: 'DirectMessagingStaffMember';
  chatGroup?: Maybe<ChatGroupField>;
  staffMember?: Maybe<BuddyField>;
};

export type Display = {
  __typename?: 'Display';
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DomesticOrInternational {
  Domestic = 'domestic',
  International = 'international'
}

export type DomesticRegionField = {
  __typename?: 'DomesticRegionField';
  country?: Maybe<CountryField>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EditAlertMutation = {
  __typename?: 'EditAlertMutation';
  alert?: Maybe<AlertField>;
};

export type EditAttributeOptionMutation = {
  __typename?: 'EditAttributeOptionMutation';
  university?: Maybe<UniversityField>;
};

export type EditBlogTopicMutation = {
  __typename?: 'EditBlogTopicMutation';
  blogTopic?: Maybe<BlogTopicField>;
};

export type EditCommunityConversationDto = {
  communityId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Tag>>;
  title: Scalars['String']['input'];
};

export type EditCommunityDto = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingsDto>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditCustomAttributeMutation = {
  __typename?: 'EditCustomAttributeMutation';
  customAttribute?: Maybe<CustomAttributeField>;
};

export type EditCustomAttributesMutation = {
  __typename?: 'EditCustomAttributesMutation';
  customAttributes?: Maybe<Array<Maybe<CustomAttributeField>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type EditCustomWelcomeMessageMutation = {
  __typename?: 'EditCustomWelcomeMessageMutation';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type EditDegreeLevelMutation = {
  __typename?: 'EditDegreeLevelMutation';
  degreeLevel?: Maybe<DegreeLevelField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type EditDegreeNameMutation = {
  __typename?: 'EditDegreeNameMutation';
  degree?: Maybe<DegreeField>;
};

export type EditDegreesMutation = {
  __typename?: 'EditDegreesMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type EditExternalEventMutation = {
  __typename?: 'EditExternalEventMutation';
  externalEvent?: Maybe<ExternalEventField>;
};

export type EditLiveEventDetailsMutation = {
  __typename?: 'EditLiveEventDetailsMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type EditLiveEventFeedMutation = {
  __typename?: 'EditLiveEventFeedMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
};

export type EditLiveEventMutation = {
  __typename?: 'EditLiveEventMutation';
  errors?: Maybe<Array<Maybe<FormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type EditLiveEventsLandingPageMutation = {
  __typename?: 'EditLiveEventsLandingPageMutation';
  liveEventLandingPage?: Maybe<LiveEventLandingPageField>;
};

export type EditOpenDayMutation = {
  __typename?: 'EditOpenDayMutation';
  openDay?: Maybe<OpenDayField>;
};

export type EditOrganisationMutation = {
  __typename?: 'EditOrganisationMutation';
  organisation?: Maybe<OrganisationField>;
};

export type EditPostMutation = {
  __typename?: 'EditPostMutation';
  error?: Maybe<Scalars['String']['output']>;
  post?: Maybe<BlogPostField>;
};

export type EditUniversityMutation = {
  __typename?: 'EditUniversityMutation';
  university?: Maybe<UniversityField>;
};

export type EditYearOfStudyMutation = {
  __typename?: 'EditYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
  yearOfStudy?: Maybe<YearOfStudyField>;
};

export type EmbeddedEventField = {
  __typename?: 'EmbeddedEventField';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type EmbeddedEventSnippetField = {
  __typename?: 'EmbeddedEventSnippetField';
  description?: Maybe<DescriptionField>;
  embeddedEvents?: Maybe<Array<Maybe<EmbeddedEventField>>>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type EnableCustomWelcomeMessageMutation = {
  __typename?: 'EnableCustomWelcomeMessageMutation';
  university?: Maybe<UniversityField>;
};

export type EnableCustomWelcomeMessageStaffMutation = {
  __typename?: 'EnableCustomWelcomeMessageStaffMutation';
  university?: Maybe<UniversityField>;
};

export type EnableFeaturesMutation = {
  __typename?: 'EnableFeaturesMutation';
  university?: Maybe<UniversityField>;
};

export type EnrolledInsightResponse = {
  __typename?: 'EnrolledInsightResponse';
  community: CommunityField;
  id: Scalars['ObjectId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  totalApplicants: Scalars['Float']['output'];
  totalEnrolled: Scalars['Float']['output'];
  university: UniversityField;
};

export type EnrolledInsightsInput = {
  communityId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type EnterpriseAddOns = {
  __typename?: 'EnterpriseAddOns';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EnterpriseMentorField = {
  __typename?: 'EnterpriseMentorField';
  active?: Maybe<Scalars['Boolean']['output']>;
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<DegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedToOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  sourceOrganisation?: Maybe<OrganisationField>;
  year?: Maybe<Scalars['String']['output']>;
};

export type EntriesField = {
  __typename?: 'EntriesField';
  active?: Maybe<Scalars['Boolean']['output']>;
  entryMonths?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type EntriesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  entryMonths?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type EventPage = {
  __typename?: 'EventPage';
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  /** the name of the page */
  name: Scalars['String']['output'];
  pageImageUrl: Scalars['String']['output'];
};

export type EventPageData = {
  description: Scalars['String']['input'];
  /** the name of the page */
  name: Scalars['String']['input'];
  pageImageUrl: Scalars['String']['input'];
};

export type EventPagesDisplayedOn = {
  __typename?: 'EventPagesDisplayedOn';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type ExportAnalyticsCsvMutation = {
  __typename?: 'ExportAnalyticsCsvMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type ExportTimeSheetDataField = {
  __typename?: 'ExportTimeSheetDataField';
  usersTimesheetData?: Maybe<Array<Maybe<UserTimeSheetExportField>>>;
};

export type ExportedReportField = {
  __typename?: 'ExportedReportField';
  created?: Maybe<Scalars['String']['output']>;
  fileLink?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExternalContent = {
  __typename?: 'ExternalContent';
  description: Scalars['String']['output'];
  eventPagesDisplayedOn: Array<EventPagesDisplayedOn>;
  eventPagesIds: Array<Scalars['ObjectId']['output']>;
  externalContentImageUrl: Scalars['String']['output'];
  externalContentUrl: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  /** the name of the external content */
  name: Scalars['String']['output'];
  showOnHomepage: Scalars['Boolean']['output'];
};

export type ExternalContentData = {
  description: Scalars['String']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  externalContentImageUrl: Scalars['String']['input'];
  externalContentUrl: Scalars['String']['input'];
  /** the name of the external content */
  name: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalEventField = {
  __typename?: 'ExternalEventField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FaqAnswerField = {
  __typename?: 'FaqAnswerField';
  id: Scalars['String']['output'];
  mentor: MentorField;
  text: Scalars['String']['output'];
};

export type FeatureField = {
  __typename?: 'FeatureField';
  description?: Maybe<Scalars['String']['output']>;
  descriptionClickablePart?: Maybe<Scalars['String']['output']>;
  descriptionLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureInputField = {
  enabledByUnibuddy: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  universityCanToggleFeature: Scalars['Boolean']['input'];
};

export type FeatureNotificationRequestDto = {
  applicableRoles: Array<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  featureFlag: Scalars['String']['input'];
  title: Scalars['String']['input'];
  universityIds: Array<Scalars['String']['input']>;
};

export type FeatureRulesDto = {
  __typename?: 'FeatureRulesDTO';
  roles?: Maybe<Array<Scalars['String']['output']>>;
  universities?: Maybe<Array<UniversityOutput>>;
};

export type FeatureToggleInputField = {
  enabledByUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FieldMappingField = {
  __typename?: 'FieldMappingField';
  applicationField?: Maybe<Scalars['String']['output']>;
  crmId?: Maybe<Scalars['String']['output']>;
  crmName?: Maybe<Scalars['String']['output']>;
};

export type FieldMappingInput = {
  applicationField?: InputMaybe<Scalars['String']['input']>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  crmName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUsersDto = {
  areaOfStudy?: InputMaybe<Array<Scalars['String']['input']>>;
  communityId: Scalars['String']['input'];
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  hideSelf?: InputMaybe<Scalars['Boolean']['input']>;
  housingTypes?: InputMaybe<Array<HousingInput>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FlagField = {
  __typename?: 'FlagField';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FormFieldValidationError = {
  __typename?: 'FormFieldValidationError';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ForwardApplicantToUniversity = {
  __typename?: 'ForwardApplicantToUniversity';
  chatGroup?: Maybe<ChatGroupField>;
  messages?: Maybe<Array<Maybe<MessageField>>>;
};

export type GeckoUniversityData = {
  __typename?: 'GeckoUniversityData';
  geckoUniversityId?: Maybe<Scalars['String']['output']>;
  geckoUniversityName?: Maybe<Scalars['String']['output']>;
};

export type GenerateAnalyticsDashboardTokenMutation = {
  __typename?: 'GenerateAnalyticsDashboardTokenMutation';
  analyticsAuth?: Maybe<AnalyticsDashboardAuthField>;
};

export type GenerateLiveEventReport = {
  __typename?: 'GenerateLiveEventReport';
  liveEvent?: Maybe<LiveEventField>;
};

export type GenerateRecommendationsInput = {
  areaOfStudyIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  batchSize: Scalars['Int']['input'];
  countryId?: InputMaybe<Scalars['ObjectId']['input']>;
  degreeLevelId?: InputMaybe<Scalars['ObjectId']['input']>;
  domesticRegionId?: InputMaybe<Scalars['ObjectId']['input']>;
  expectedEntry?: InputMaybe<Scalars['DateTime']['input']>;
  universityId: Scalars['ObjectId']['input'];
};

export type GetAssistantConversationInput = {
  id: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type GetChatReportsDto = {
  product: Product;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityId: Scalars['ObjectID']['input'];
};

export type GetDownloadableUrlMutation = {
  __typename?: 'GetDownloadableURLMutation';
  url?: Maybe<Scalars['String']['output']>;
};

export type GetInvitesForEmailDto = {
  __typename?: 'GetInvitesForEmailDTO';
  community: Community;
  id: Scalars['ID']['output'];
};

export type GetMarketplaceApplicantMutation = {
  __typename?: 'GetMarketplaceApplicantMutation';
  authenticatedApplicant?: Maybe<AuthField>;
};

export type GetMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offsetId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type GetOrCreateApiKeyMutation = {
  __typename?: 'GetOrCreateApiKeyMutation';
  apiKey?: Maybe<Scalars['String']['output']>;
};

export type GetRandomAmbassadorsInput = {
  count: Scalars['Float']['input'];
  universityId: Scalars['String']['input'];
};

export type GetRecordingFailureIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type GetRecordingFailureIdsResponse = {
  __typename?: 'GetRecordingFailureIdsResponse';
  failedIds: Array<RecordingFailureId>;
};

export type GetSignedS3PostFieldsMutation = {
  __typename?: 'GetSignedS3PostFieldsMutation';
  postFieldsObject?: Maybe<SignedS3PostFields>;
};

export type GetSignedS3UrlMutation = {
  __typename?: 'GetSignedS3UrlMutation';
  signedObject?: Maybe<SignedS3UrlField>;
};

export type GetUserReportsDto = {
  product: Product;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityId: Scalars['ObjectID']['input'];
};

export type GifDto = {
  aspectRatio: Scalars['Float']['input'];
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  type: GifType;
  width: Scalars['Int']['input'];
};

export enum GifType {
  Gif = 'Gif',
  Sticker = 'Sticker'
}

export type Giphy = {
  __typename?: 'Giphy';
  aspectRatio: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  type: GifType;
  width: Scalars['Int']['output'];
};

export type GraphField = {
  __typename?: 'GraphField';
  xAxis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  yAxis?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  yWeights?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GraphQlOffsetPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type GroupField = {
  __typename?: 'GroupField';
  type?: Maybe<Scalars['String']['output']>;
};

export type HideMentorInMarketplaceMutation = {
  __typename?: 'HideMentorInMarketplaceMutation';
  mentor?: Maybe<MentorField>;
};

export type HighSchoolField = {
  __typename?: 'HighSchoolField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HighSchoolTypeField = {
  __typename?: 'HighSchoolTypeField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum HousingCategory {
  Na = 'NA',
  Private = 'PRIVATE',
  University = 'UNIVERSITY'
}

export type HousingInput = {
  category: HousingCategory;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HousingObject = {
  __typename?: 'HousingObject';
  category: HousingCategory;
  name?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  url: Scalars['String']['output'];
};

export type ImageDto = {
  url: Scalars['String']['input'];
};

export type InboxItemInterface = {
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type InboxItemLastMessageField = {
  __typename?: 'InboxItemLastMessageField';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFromUser?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type InboxItemUnion = ChatInboxField | UniversityChatInboxField;

export type InboxPromptAnswer = {
  __typename?: 'InboxPromptAnswer';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type InboxPromptAnswerInput = {
  answers: Array<InboxPromptAnswerInputItem>;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type InboxPromptAnswerInputItem = {
  id: Scalars['ObjectId']['input'];
  text: Scalars['String']['input'];
};

export type InboxPromptInput = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  universityId: Scalars['ObjectId']['input'];
};

export type InboxPromptOption = {
  __typename?: 'InboxPromptOption';
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type InboxPromptQuestion = {
  __typename?: 'InboxPromptQuestion';
  active: Scalars['Boolean']['output'];
  answers: Array<InboxPromptAnswer>;
  id: Scalars['ObjectId']['output'];
  options: Array<InboxPromptOption>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};


export type InboxPromptQuestionAnswersArgs = {
  inboxPromptInput: InboxPromptInput;
};

export type InboxUniversityField = {
  __typename?: 'InboxUniversityField';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  squareLogo?: Maybe<Scalars['String']['output']>;
};

export type InitialiseRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type InitialiseRecordingResponse = {
  __typename?: 'InitialiseRecordingResponse';
  channelId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  layoutMode: Scalars['Float']['output'];
  layoutStatus: Scalars['String']['output'];
  recordingStatus: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type InputField = {
  __typename?: 'InputField';
  action?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Insights = {
  __typename?: 'Insights';
  communityId: Scalars['ID']['output'];
  totalApplicantsInCommunity: Scalars['Float']['output'];
  totalEnrolled: Scalars['Float']['output'];
};

export type InsightsField = {
  __typename?: 'InsightsField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<TopicStatisticField>>>;
};

export type Interest = {
  __typename?: 'Interest';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type InterestInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InterestObject = {
  __typename?: 'InterestObject';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InterventionMessageField = {
  __typename?: 'InterventionMessageField';
  message?: Maybe<MessageField>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Invite = {
  __typename?: 'Invite';
  communityId: Scalars['String']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedEmail: Scalars['String']['output'];
  reminderStatus?: Maybe<Scalars['String']['output']>;
  sendUnibuddyEmail?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteApplicantsMutation = {
  __typename?: 'InviteApplicantsMutation';
  alreadyExistingInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successfulInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InviteBuddiesMutation = {
  __typename?: 'InviteBuddiesMutation';
  failedInvites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  successfulInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
};

export type InviteFilter = {
  accountRole?: InputMaybe<Array<AccountRoles>>;
  inviteMethod?: InputMaybe<Array<InviteMethods>>;
  status?: InputMaybe<Array<InviteStatus>>;
};

export type InviteInformation = {
  __typename?: 'InviteInformation';
  community: Community;
  id: Scalars['ID']['output'];
  invite?: Maybe<Invite>;
  /** Whether the user is a member of the community. Requires authentication. Returns "null" if user is not authenticated, "false" if user is authenticated but not a member, and "true" if user is authenticated and a member. */
  isPartOfCommunity?: Maybe<Scalars['Boolean']['output']>;
  university: UniversityField;
};

export type InviteInformationInput = {
  inviteId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteLinkDto = {
  __typename?: 'InviteLinkDto';
  active: Scalars['Boolean']['output'];
  communityId: Scalars['String']['output'];
  expiringAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
};

export type InviteLinkInfoDto = {
  __typename?: 'InviteLinkInfoDto';
  communityId: Scalars['String']['output'];
  communityTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  universityName: Scalars['String']['output'];
  universitySlug: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type InviteLinkInput = {
  active: Scalars['Boolean']['input'];
  communityId: Scalars['ID']['input'];
  labels: Array<Scalars['String']['input']>;
};

export type InviteMentorsMutation = {
  __typename?: 'InviteMentorsMutation';
  successfulInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
};

export enum InviteMethods {
  Email = 'EMAIL',
  Invitelink = 'INVITELINK'
}

export enum InviteStatus {
  Invited = 'INVITED',
  Joined = 'JOINED'
}

export type JoinChatGroupMutation = {
  __typename?: 'JoinChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type KnowledgeBaseDeleteEntryInput = {
  id: Scalars['String']['input'];
};

export type KnowledgeBaseDeleteEntryOutput = {
  __typename?: 'KnowledgeBaseDeleteEntryOutput';
  ok: Scalars['Boolean']['output'];
};

export type KnowledgeBaseEmbedding = {
  __typename?: 'KnowledgeBaseEmbedding';
  createdAt: Scalars['DateTime']['output'];
  ids: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseSourceQueryInput = {
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
  universityId: Scalars['String']['input'];
};

export type KnowledgeBaseSourcesByUrl = {
  __typename?: 'KnowledgeBaseSourcesByUrl';
  ids: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseSourcesListInput = {
  universityId: Scalars['String']['input'];
  urlSearchPattern: Scalars['String']['input'];
};

export type LabelSentenceMutation = {
  __typename?: 'LabelSentenceMutation';
  labelSentence: LabellingField;
};

export type LabellingField = {
  __typename?: 'LabellingField';
  chatGroupId?: Maybe<Scalars['String']['output']>;
  classifiedSentenceId?: Maybe<Scalars['String']['output']>;
  embeddedSubTopic?: Maybe<TopSubTopicField>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  subTopicExternalId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topicExternalId?: Maybe<Scalars['String']['output']>;
};

export type LabellingSentenceCandidate = {
  __typename?: 'LabellingSentenceCandidate';
  classifiedSentenceId?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topSubTopics?: Maybe<Array<Maybe<TopSubTopicField>>>;
};

export type Labels = {
  __typename?: 'Labels';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LanguageField = {
  __typename?: 'LanguageField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LastMessageField = {
  __typename?: 'LastMessageField';
  created?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<AnyUserField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LastRead = {
  __typename?: 'LastRead';
  conversationId: Scalars['String']['output'];
  messageId: Scalars['ObjectId']['output'];
  userId: Scalars['String']['output'];
};

export type LeaveChatGroupMutation = {
  __typename?: 'LeaveChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type LevelSnippetField = {
  __typename?: 'LevelSnippetField';
  level?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type LikeMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type LikeMessageMutation = {
  __typename?: 'LikeMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LinkOrganisationsMutation = {
  __typename?: 'LinkOrganisationsMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ListAdminRecommendationInput = {
  forDecisionStage: DecisionStageEnum;
};

export type ListBuddyApplicantConversationsField = {
  __typename?: 'ListBuddyApplicantConversationsField';
  conversations?: Maybe<Array<Maybe<BuddyApplicantChatGroupFieldV2>>>;
  totalConversations?: Maybe<Scalars['Int']['output']>;
};

export type ListMentorApplicantConversationsField = {
  __typename?: 'ListMentorApplicantConversationsField';
  conversations?: Maybe<Array<Maybe<MentorApplicantChatGroupField>>>;
  totalConversations?: Maybe<Scalars['Int']['output']>;
};

export type ListUniversityAssistantConversationsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  universityId: Scalars['String']['input'];
};

export type ListUniversityAssistantConversationsOutput = {
  __typename?: 'ListUniversityAssistantConversationsOutput';
  conversationCount: Scalars['Float']['output'];
  conversations: Array<UniversityAssistantConversation>;
  universityId: Scalars['String']['output'];
};

export type LiveEventChatGroupField = {
  __typename?: 'LiveEventChatGroupField';
  applicantCount?: Maybe<Scalars['Int']['output']>;
  applicants?: Maybe<Array<Maybe<ApplicantField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  description?: Maybe<Scalars['String']['output']>;
  hasEnquiryTeam?: Maybe<Scalars['Boolean']['output']>;
  hostIdsVideoSessions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  name?: Maybe<Scalars['String']['output']>;
  recordingEnabled?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Array<Maybe<UserField>>>;
  university?: Maybe<UniversityField>;
  universityUsers?: Maybe<Array<Maybe<UniversityUserField>>>;
  videoEnabled?: Maybe<Scalars['Boolean']['output']>;
  videoSessions?: Maybe<Array<Maybe<VideoSessionField>>>;
};

export type LiveEventChatGroupsInputField = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};

export type LiveEventDetailedReport = {
  __typename?: 'LiveEventDetailedReport';
  applicantCountries?: Maybe<Array<Maybe<LiveEventDetailedReportCountryStats>>>;
  liveEventId?: Maybe<Scalars['String']['output']>;
  messagesPerChannel?: Maybe<Array<Maybe<LiveEventDetailedReportChannelStats>>>;
  prospectInLiveEvent?: Maybe<Scalars['Int']['output']>;
  prospectLoggedIn?: Maybe<Scalars['Int']['output']>;
  prospectSignUps?: Maybe<Scalars['Int']['output']>;
  prospectsInLiveEventChatGroups?: Maybe<Scalars['Int']['output']>;
  prospectsSendDirectMessage?: Maybe<Scalars['Int']['output']>;
  prospectsSendMessage?: Maybe<Scalars['Int']['output']>;
};

export type LiveEventDetailedReportChannelStats = {
  __typename?: 'LiveEventDetailedReportChannelStats';
  applicants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  len?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDetailedReportCountryStats = {
  __typename?: 'LiveEventDetailedReportCountryStats';
  count?: Maybe<Scalars['Int']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDetailsField = {
  __typename?: 'LiveEventDetailsField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isUserRegistered?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type LiveEventDirectMessaging = {
  __typename?: 'LiveEventDirectMessaging';
  applicants?: Maybe<Array<Maybe<DirectMessagingApplicant>>>;
  enquiryTeam?: Maybe<DirectMessagingEnquiryTeam>;
  mentors?: Maybe<Array<Maybe<DirectMessagingMentor>>>;
  staff?: Maybe<Array<Maybe<DirectMessagingStaffMember>>>;
};

export type LiveEventFeedbackFormMutation = {
  __typename?: 'LiveEventFeedbackFormMutation';
  feedBackForm?: Maybe<LiveEventProspectFeedbackFormField>;
};

export type LiveEventField = {
  __typename?: 'LiveEventField';
  allMentors?: Maybe<Array<Maybe<MentorField>>>;
  allStaff?: Maybe<Array<Maybe<BuddyField>>>;
  applicants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  createdByUniversity?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailedReport?: Maybe<LiveEventDetailedReport>;
  directMessagingMentors?: Maybe<Array<Maybe<MentorField>>>;
  directMessagingStaff?: Maybe<Array<Maybe<BuddyField>>>;
  directMessagingUniversity?: Maybe<Scalars['Boolean']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inbox?: Maybe<LiveEventInboxField>;
  liveFeeds?: Maybe<Array<Maybe<LiveEventChatGroupField>>>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  setupCompleted?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};


export type LiveEventFieldInboxArgs = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveEventInboxField = {
  __typename?: 'LiveEventInboxField';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<InboxItemUnion>>>;
};

export type LiveEventLandingPageField = {
  __typename?: 'LiveEventLandingPageField';
  description?: Maybe<Scalars['String']['output']>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LiveEventProspectFeedbackFormField = {
  __typename?: 'LiveEventProspectFeedbackFormField';
  accountRole?: Maybe<Scalars['String']['output']>;
  eventExperience?: Maybe<Scalars['Int']['output']>;
  eventFeedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<LiveEventField>;
  university?: Maybe<UniversityField>;
  user?: Maybe<UserField>;
};

export type LiveEventsFormFieldValidationError = {
  __typename?: 'LiveEventsFormFieldValidationError';
  code?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LiveSession = {
  __typename?: 'LiveSession';
  conversation: ChatConversation;
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  eventPagesDisplayedOn: Array<EventPagesDisplayedOn>;
  eventPagesIds: Array<Scalars['ObjectId']['output']>;
  id: Scalars['ObjectId']['output'];
  isSavedByMe: Scalars['Boolean']['output'];
  /** the name of the event */
  name: Scalars['String']['output'];
  presenters: Array<UserField>;
  recordingEnabled: Scalars['Boolean']['output'];
  sessionAnalytics: SessionAnalytics;
  sessionImageUrl: Scalars['String']['output'];
  showOnHomepage: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LocaleField = {
  __typename?: 'LocaleField';
  androidCode?: Maybe<Scalars['String']['output']>;
  dialectOf?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  osxCode?: Maybe<Scalars['String']['output']>;
  osxLocale?: Maybe<Scalars['String']['output']>;
  textDirection?: Maybe<Scalars['String']['output']>;
  threeLettersCode?: Maybe<Scalars['String']['output']>;
  twoLettersCode?: Maybe<Scalars['String']['output']>;
};

export type LogoDataField = {
  __typename?: 'LogoDataField';
  logoText?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type LogoutMutation = {
  __typename?: 'LogoutMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ManageOrganisationAccessMutation = {
  __typename?: 'ManageOrganisationAccessMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ManuallyClassifyMutation = {
  __typename?: 'ManuallyClassifyMutation';
  classification: ClassificationField;
};

export type MarkAssistantConversationAsViewedInput = {
  conversationId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type MarkReadMessageDto = {
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type MarketplaceApplicantCountries = {
  __typename?: 'MarketplaceApplicantCountries';
  countries?: Maybe<Array<Maybe<CountryAnalyticsValue>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceApplicantData = {
  custom?: InputMaybe<Scalars['JSONString']['input']>;
  degreeCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  personalDataCollectionAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfEntry?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceApplicantDegreeCategories = {
  __typename?: 'MarketplaceApplicantDegreeCategories';
  categories?: Maybe<Array<Maybe<DegreeCategoriesAnalyticsValue>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceApplicantUserData = {
  __typename?: 'MarketplaceApplicantUserData';
  custom?: Maybe<Scalars['GenericScalar']['output']>;
  degreeCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  marketingConsentAccepted?: Maybe<Scalars['Boolean']['output']>;
  personalDataCollectionAccepted?: Maybe<Scalars['Boolean']['output']>;
  yearOfEntry?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceField = {
  __typename?: 'MarketplaceField';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowUniversityProspectDataAccess?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  customBuddyWord?: Maybe<Scalars['String']['output']>;
  customFilters?: Maybe<Array<Maybe<MarketplaceFilters>>>;
  disableExternalNotification?: Maybe<Scalars['Boolean']['output']>;
  faAppId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketplaceMarketingConsentCollectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketplaceMarketingConsentMessage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personalDataApiEnabled?: Maybe<Scalars['Boolean']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  unibuddyMarketingConsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  universityMarketingConsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  widgetDescription?: Maybe<Scalars['String']['output']>;
  widgetTitle?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceFilterInput = {
  filterSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceFilters = {
  __typename?: 'MarketplaceFilters';
  filterSlug?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceInboxField = {
  __typename?: 'MarketplaceInboxField';
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
};

export type MarketplaceMentorList = {
  __typename?: 'MarketplaceMentorList';
  mentorSeed?: Maybe<Scalars['Int']['output']>;
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  totalMentors?: Maybe<Scalars['Int']['output']>;
  universitySeed?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceSnippetField = {
  __typename?: 'MarketplaceSnippetField';
  error?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type MatchedUser = {
  __typename?: 'MatchedUser';
  matchingCriteria: Array<Scalars['String']['output']>;
  matchingPercentage: Scalars['Float']['output'];
  user: UserField;
};

/** Types of matching criteria */
export enum MatchingCriteriaEnum {
  AreaOfStudy = 'AreaOfStudy',
  Nationality = 'Nationality'
}

export type MeField = {
  __typename?: 'MeField';
  admin?: Maybe<AdminUserField>;
  anyUser?: Maybe<AnyUserField>;
  applicant?: Maybe<ApplicantField>;
  mentor?: Maybe<MentorField>;
  staff?: Maybe<UserField>;
  universityUser?: Maybe<UniversityUserField>;
};

export type MentorApplicantChatGroupField = {
  __typename?: 'MentorApplicantChatGroupField';
  applicant?: Maybe<ApplicantField>;
  created?: Maybe<Scalars['String']['output']>;
  creationSource?: Maybe<CreationSource>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageText?: Maybe<Scalars['String']['output']>;
  mentor?: Maybe<MentorField>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorBroadcastMessageMutation = {
  __typename?: 'MentorBroadcastMessageMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorChatUserField = ChatUserField & {
  __typename?: 'MentorChatUserField';
  degree?: Maybe<DegreeChatUserField>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
};


export type MentorChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MentorDegreeField = {
  __typename?: 'MentorDegreeField';
  degree?: Maybe<DegreeField>;
  degreeType?: Maybe<DegreeType>;
};

export type MentorDegreeFieldInput = {
  degree: Scalars['String']['input'];
  degreeType: DegreeType;
};

export type MentorDegreeHistory = {
  __typename?: 'MentorDegreeHistory';
  degree?: Maybe<DegreeField>;
  university?: Maybe<UniversityField>;
};

export type MentorField = {
  __typename?: 'MentorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  cardComplete?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  degree?: Maybe<DegreeField>;
  degreeHistory?: Maybe<MentorDegreeHistory>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  email?: Maybe<Scalars['String']['output']>;
  favouriteModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasUnansweredConversation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Array<Maybe<MentorInterestField>>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  mentorFields?: Maybe<MentorFields>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  pastQualification?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<MentorPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  resolvedUnansweredConversations?: Maybe<Scalars['Boolean']['output']>;
  schoolHistory?: Maybe<MentorSchoolHistoryField>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  showIn?: Maybe<Array<Maybe<Display>>>;
  societies?: Maybe<Array<Maybe<MentorSocietyField>>>;
  stageOneComplete?: Maybe<Scalars['Boolean']['output']>;
  stageTwoComplete?: Maybe<Scalars['Boolean']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};


export type MentorFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MentorFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MentorFieldOrderField = {
  __typename?: 'MentorFieldOrderField';
  field?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type MentorFieldOrderInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type MentorFields = {
  __typename?: 'MentorFields';
  primaryFlag?: Maybe<FlagField>;
  secondaryFlag?: Maybe<FlagField>;
};

export type MentorFilterField = {
  __typename?: 'MentorFilterField';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<MentorFilterOptionField>>>;
};

export type MentorFilterInputField = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MentorFilterOptionField = {
  __typename?: 'MentorFilterOptionField';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type MentorInboxField = {
  __typename?: 'MentorInboxField';
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  chatGroupsCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorInterestField = {
  __typename?: 'MentorInterestField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MentorInterventionQueryField = {
  __typename?: 'MentorInterventionQueryField';
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorIntroMessageField = {
  __typename?: 'MentorIntroMessageField';
  introMessage?: Maybe<MessageField>;
};

export type MentorInviteCountField = {
  __typename?: 'MentorInviteCountField';
  mentorInviteCount?: Maybe<Scalars['Int']['output']>;
};

export type MentorInviteField = {
  __typename?: 'MentorInviteField';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notFound?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorListField = {
  __typename?: 'MentorListField';
  countries?: Maybe<Array<Maybe<CountryField>>>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  validCombination?: Maybe<Scalars['Boolean']['output']>;
};

export type MentorListFilterChoice = {
  __typename?: 'MentorListFilterChoice';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type MentorListFilterChoiceInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MentorModuleField = {
  __typename?: 'MentorModuleField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MentorPreferencesField = {
  __typename?: 'MentorPreferencesField';
  id?: Maybe<Scalars['String']['output']>;
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MentorSchoolHistoryField = {
  __typename?: 'MentorSchoolHistoryField';
  highSchool?: Maybe<HighSchoolField>;
  highSchoolType?: Maybe<HighSchoolTypeField>;
};

export type MentorSnippetField = {
  __typename?: 'MentorSnippetField';
  mentor?: Maybe<MentorField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type MentorSocietyField = {
  __typename?: 'MentorSocietyField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MentorcardSnippetField = {
  __typename?: 'MentorcardSnippetField';
  countrySnippets?: Maybe<Array<Maybe<CountrySnippetField>>>;
  degreeSnippets?: Maybe<Array<Maybe<DegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
  mentorSnippets?: Maybe<Array<Maybe<MentorSnippetField>>>;
};

export type MessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  richContent?: InputMaybe<RichContentDto>;
  text: Scalars['String']['input'];
};

export type MessageField = {
  __typename?: 'MessageField';
  attachment?: Maybe<AttachmentField>;
  chatGroupId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  input?: Maybe<InputField>;
  instantAction?: Maybe<Scalars['String']['output']>;
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ownMessage?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  richContent?: Maybe<RichContentOutputField>;
  sender?: Maybe<AnyUserField>;
  text?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['String']['output']>;
};

export type MessageMetadata = {
  __typename?: 'MessageMetadata';
  ambassadorProfile?: Maybe<AmbassadorProfileInformation>;
  staffProfile?: Maybe<StaffProfileInformation>;
};

export type MessagePublicBotMutation = {
  __typename?: 'MessagePublicBotMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
};

export type Metadata = {
  qssMetadata?: InputMaybe<QssMetadata>;
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptRequestedPublicGroup: RequestedPublicGroup;
  activateApplicants?: Maybe<ActivateApplicantsMutation>;
  activateMentors?: Maybe<ActivateMentorsMutation>;
  addAttendees?: Maybe<AttendeeAnalytics>;
  addBotToChatGroup?: Maybe<AddBotToChatGroupMutation>;
  addChatRoomAttendees?: Maybe<ChatRoomAttendeeAnalytics>;
  addCustomAttribute?: Maybe<AddCustomAttributeMutation>;
  addCustomAttributeOption?: Maybe<AddAttributeOptionMutation>;
  addDegreeLevels?: Maybe<AddDegreeLevelsMutation>;
  addDegrees?: Maybe<AddDegreesMutation>;
  addDevice?: Maybe<DeviceMutation>;
  addHobsonsConnectIntegration?: Maybe<AddHobsonsConnectIntegration>;
  addLocalesToApp?: Maybe<AddLocalesToApp>;
  addMatchingCriteria: UpdatedResults;
  addReactionToMessage: ChatMessage;
  addResearchTime?: Maybe<AddResearchTimeMutation>;
  addSessionAttendees?: Maybe<SessionAttendeeAnalytics>;
  addToFeatureExperiment: Scalars['Boolean']['output'];
  addUserToCommunityConversation: ChatConversation;
  addVote: Poll;
  addYearOfStudy?: Maybe<AddYearOfStudyMutation>;
  adminDeleteApplicant?: Maybe<AdminDeleteApplicantMutation>;
  adminDeleteBuddy?: Maybe<DeleteUserMutation>;
  adminUpdateMentor?: Maybe<AdminUpdateMentorMutation>;
  applicantBroadcastMessage?: Maybe<ApplicantBroadcastMessageMutation>;
  bulkOptOutMarketplaceUniversityMarketing?: Maybe<BulkOptOutMarketplaceUniversityMarketingMutation>;
  checkEmail?: Maybe<CheckEmailMutation>;
  cloneCommunity: Community;
  cloneLiveEventAndChannels?: Maybe<CloneLiveEventAndChannelsMutation>;
  createAlert?: Maybe<CreateAlertMutation>;
  createApplicant?: Maybe<CreateApplicantMutation>;
  createApplicantV2?: Maybe<CreateApplicantMutationV2>;
  createApplicationInsight: ApplicationInsightModel;
  createAssistantConversation: AssistantConversationHistoryWithToken;
  createAssistantMessageFeedback: Scalars['Boolean']['output'];
  createBlogTopic?: Maybe<CreateBlogTopicMutation>;
  createBuddy?: Maybe<CreateBuddyMutation>;
  createCanonicalQuestion?: Maybe<CreateCanonicalQuestion>;
  /** Create a chat report. This mutation is available to all user types. */
  createChatReport: ChatReport;
  createChatRoom: ChatRoom;
  createComment?: Maybe<CommentMutation>;
  createCommunity: Community;
  createCommunityApplicant?: Maybe<CreateCommunityApplicantMutation>;
  createCommunityApplicantV2?: Maybe<CreateCommunityApplicantMutationV2>;
  /** @deprecated Deprecated, please use createCommunityConversation */
  createCommunityChatGroup: CommunityChatGroup;
  createCommunityConversation: ChatConversation;
  createCommunityFromTemplate: Community;
  createCrmServiceUniversityConfig?: Maybe<CreateCrmServiceUniversityConfigMutation>;
  createDirectConversation: ChatConversation;
  createEventPage: EventPage;
  createExternalContent: ExternalContent;
  createExternalEvent?: Maybe<CreateExternalEventMutation>;
  createFaqAnswer?: Maybe<CreateFaqAnswer>;
  createFresher?: Maybe<CreateFresherMutation>;
  createInviteLink: InviteLinkDto;
  createLiveEvent?: Maybe<CreateLiveEventMutation>;
  createLiveEventDetails?: Maybe<CreateLiveEventDetailsMutation>;
  createLiveEventFeed?: Maybe<CreateLiveEventFeedMutation>;
  createLiveEventFeedSessions?: Maybe<CreateLiveEventFeedSessionsMutation>;
  createLiveSession: LiveSession;
  createMarketplace?: Maybe<CreateMarketplaceMutation>;
  createMarketplaceApplicant?: Maybe<CreateMarketplaceApplicantMutation>;
  createMentor?: Maybe<CreateMentorMutation>;
  createOpenDay?: Maybe<CreateOpenDayMutation>;
  createOrUpdateUniversityAssistantPromptContext: UniversityAssistantConfigurationPromptContextOutput;
  createOrUpdateUniversityAssistantScrapeIgnoreUrls: UniversityAssistantConfigurationScrapeIgnoreUrlsOutput;
  createOrganisation?: Maybe<CreateOrganisationMutation>;
  createOrganisationBuddyLink?: Maybe<CreateOrganisationBuddyLinkMutation>;
  createPost?: Maybe<CreatePostMutation>;
  createStaffContact: StaffContactOutput;
  createSubTopic?: Maybe<CreateSubTopicMutation>;
  createTag?: Maybe<CreateTagMutation>;
  createTodo: TodosEntity;
  createTopic?: Maybe<CreateTopicMutation>;
  createUniversity?: Maybe<CreateUniversityMutation>;
  createUniversityAssistantEventLink: UniversityAssistantConfigurationEventOutput;
  createUniversityBlockReport?: Maybe<CreateUniversityBlockReportMutation>;
  createUniversityScrape: UniversityScrapeOutput;
  createUniversityScrapeBatch: UniversityScrapeOutput;
  createUniversityScrapeOne: UniversityScrapeOutput;
  createUniversityUser?: Maybe<CreateUniversityUserMutation>;
  createUserMutation?: Maybe<CreateUserMutation>;
  /** Create a user report. This mutation is available to all user types. */
  createUserReport: UserReport;
  createVideoUploadLink: VideoUploadLink;
  createVirtualEvent: VirtualEvent;
  createVirtualEventProspectReport?: Maybe<ReportAnalytics>;
  csvUploadAmbassadorFields?: Maybe<CsvUploadAmbassadorFieldsMutation>;
  csvUploadApplicants?: Maybe<CsvUploadApplicantsMutation>;
  deactivateApplicants?: Maybe<DeactivateApplicantsMutation>;
  deactivateMentors?: Maybe<DeactivateMentorsMutation>;
  deleteAdminRecommendation: AdminRecommendation;
  deleteApplicant?: Maybe<DeleteApplicantMutation>;
  deleteBlogPost?: Maybe<DeletePostMutation>;
  deleteCanonicalQuestion?: Maybe<DeleteCanonicalQuestion>;
  deleteChatRoom: Scalars['Boolean']['output'];
  deleteCommunityConversation: ChatConversation;
  deleteConversationMessage: ChatMessage;
  deleteCustomAttributeOptions?: Maybe<DeleteAttributeOptionsMutation>;
  deleteCustomAttributes?: Maybe<DeleteCustomAttributesMutation>;
  deleteDegreeLevel?: Maybe<DeleteDegreeLevelMutation>;
  deleteEventPage: Scalars['Boolean']['output'];
  deleteExternalContent: Scalars['Boolean']['output'];
  deleteFaqAnswer?: Maybe<DeleteFaqAnswer>;
  deleteLiveEvent?: Maybe<DeleteLiveEventMutation>;
  deleteLiveEventFeed?: Maybe<DeleteLiveEventFeedMutation>;
  deleteLiveEventMessageMutation?: Maybe<DeleteLiveEventMessageMutation>;
  deleteLiveSession: Scalars['Boolean']['output'];
  deleteRecording: DeleteRecordingResponse;
  deleteResearchTime?: Maybe<DeleteResearchTimeMutation>;
  deleteSubTopic?: Maybe<DeleteSubTopicMutation>;
  deleteTopic?: Maybe<DeleteTopicMutation>;
  deleteUniversityKnowledgeBaseSourceById: KnowledgeBaseDeleteEntryOutput;
  deleteUniversityKnowledgeBaseSourceByPatternMatch: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityKnowledgeBaseSourceByPatternMismatch: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityKnowledgeBaseSourceByUrlList: DeleteKnowledgeBaseEntriesOutput;
  deleteUniversityUser?: Maybe<DeleteUniversityUserMutation>;
  deleteVirtualEvent: Scalars['Boolean']['output'];
  deleteYearOfStudy?: Maybe<DeleteYearOfStudyMutation>;
  editAdminRecommendation: AdminRecommendation;
  editAlert?: Maybe<EditAlertMutation>;
  editBlogPost?: Maybe<EditPostMutation>;
  editBlogTopic?: Maybe<EditBlogTopicMutation>;
  editCommunity: Community;
  editCommunityConversation: ChatConversation;
  editCookieConsentPreferences: CookieConsentOutputDto;
  editCustomAttribute?: Maybe<EditCustomAttributeMutation>;
  editCustomAttributeOption?: Maybe<EditAttributeOptionMutation>;
  editCustomAttributes?: Maybe<EditCustomAttributesMutation>;
  editCustomWelcomeMessage?: Maybe<EditCustomWelcomeMessageMutation>;
  editDegreeLevel?: Maybe<EditDegreeLevelMutation>;
  editDegreeName?: Maybe<EditDegreeNameMutation>;
  editDegrees?: Maybe<EditDegreesMutation>;
  editExternalEvent?: Maybe<EditExternalEventMutation>;
  editLiveEvent?: Maybe<EditLiveEventMutation>;
  editLiveEventDetails?: Maybe<EditLiveEventDetailsMutation>;
  editLiveEventFeed?: Maybe<EditLiveEventFeedMutation>;
  editLiveEventsLandingPage?: Maybe<EditLiveEventsLandingPageMutation>;
  editOpenDay?: Maybe<EditOpenDayMutation>;
  editOrganisation?: Maybe<EditOrganisationMutation>;
  editUniversity?: Maybe<EditUniversityMutation>;
  editYearOfStudy?: Maybe<EditYearOfStudyMutation>;
  emailInvitesDataForCommunity: Scalars['Boolean']['output'];
  enableCustomWelcomeMessage?: Maybe<EnableCustomWelcomeMessageMutation>;
  enableCustomWelcomeMessageStaff?: Maybe<EnableCustomWelcomeMessageStaffMutation>;
  enableFeatures?: Maybe<EnableFeaturesMutation>;
  exportAnalyticsCsv?: Maybe<ExportAnalyticsCsvMutation>;
  forwardApplicantToUniversity?: Maybe<ForwardApplicantToUniversity>;
  generateAnalyticsDashboardToken?: Maybe<GenerateAnalyticsDashboardTokenMutation>;
  generateDownloadUrl?: Maybe<GetDownloadableUrlMutation>;
  generateLiveEventReport?: Maybe<GenerateLiveEventReport>;
  generateRecommendations: Array<Recommendation>;
  getMarketplaceApplicant?: Maybe<GetMarketplaceApplicantMutation>;
  getOrCreateApiKey?: Maybe<GetOrCreateApiKeyMutation>;
  getOrCreateWidgetConversation: ChatConversation;
  getSignedS3PostFields?: Maybe<GetSignedS3PostFieldsMutation>;
  getSignedS3Url?: Maybe<GetSignedS3UrlMutation>;
  hideMentorInMarketplace?: Maybe<HideMentorInMarketplaceMutation>;
  initialiseRecording: InitialiseRecordingResponse;
  initiateUserDeletion: Scalars['Boolean']['output'];
  inviteApplicants?: Maybe<InviteApplicantsMutation>;
  inviteBuddies?: Maybe<InviteBuddiesMutation>;
  inviteEmailsToCommunity: CommunityInviteResponse;
  inviteMentors?: Maybe<InviteMentorsMutation>;
  joinChatGroup?: Maybe<JoinChatGroupMutation>;
  joinCommunity: CommunityJoinResponse;
  joinCommunityByInviteLink: CommunityJoinResponse;
  joinCommunityConversation: ChatConversation;
  joinCommunityForAdmins: CommunityJoinResponse;
  labelSentence?: Maybe<LabelSentenceMutation>;
  leaveChatGroup?: Maybe<LeaveChatGroupMutation>;
  leaveCommunityChatGroup: ChatConversation;
  likeConversationMessage: ChatMessage;
  likeMessage?: Maybe<LikeMessageMutation>;
  linkOrganisations?: Maybe<LinkOrganisationsMutation>;
  liveEventFeedbackForm?: Maybe<LiveEventFeedbackFormMutation>;
  logout?: Maybe<LogoutMutation>;
  manageOrganisationAccess?: Maybe<ManageOrganisationAccessMutation>;
  manuallyClassify?: Maybe<ManuallyClassifyMutation>;
  markAssistantConversationAsViewed: AssistantConversationHistory;
  mentorBroadcastMessage?: Maybe<MentorBroadcastMessageMutation>;
  messagePublicBot?: Maybe<MessagePublicBotMutation>;
  /** Moderate a chat report. This mutation is available only to university users and admins. */
  moderateChatReport: ChatReport;
  /** Moderate a user report. This mutation is available only to university users and admins. */
  moderateUserReport: UserReport;
  pinMessage?: Maybe<PinMessageMutation>;
  pinMessageInConversation: ChatConversation;
  readChat?: Maybe<ReadChatMutation>;
  recordConsent: RecordingConsent;
  recordFailure: RecordingFailureResponse;
  recordLastMessageReadByUser: LastRead;
  recordUserActivity?: Maybe<RecordUserActivityMutation>;
  registerToLiveEvent?: Maybe<RegisterToLiveEvent>;
  rejectRequestedPublicGroup: RequestedPublicGroup;
  removeApplicationInsight: Scalars['Boolean']['output'];
  removeBuddyInvites?: Maybe<RemoveBuddyInvitesMutation>;
  removeDevice?: Maybe<RemoveDeviceMutation>;
  removeMembersFromCommunity: Scalars['Boolean']['output'];
  removeMentorInvites?: Maybe<RemoveMentorInvitesMutation>;
  removeReactionFromMessage: ChatMessage;
  removeUserFromCommunityChatGroup: Scalars['Boolean']['output'];
  removeVote: Poll;
  requestAnalyticsExport?: Maybe<RequestAnalyticsExportMutation>;
  requestPasswordReset?: Maybe<RequestPasswordResetMutation>;
  requestPasswordSet?: Maybe<RequestPasswordSetMutation>;
  requestPublicGroup: RequestedPublicGroup;
  requestResetPassword?: Maybe<ResetPasswordMobileMutation>;
  requestResetPasswordMobile?: Maybe<PasswordResetMobileMutation>;
  requestResetPasswordMobileV2?: Maybe<PasswordResetMobileMutationV2>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  resetPasswordEmail?: Maybe<SendResetPasswordEmail>;
  resetPasswordV2?: Maybe<ResetPasswordMutationV2>;
  resolveChats?: Maybe<ResolveUniversityChatsMutation>;
  resolveConversationMessage: ChatMessage;
  runManageCommand?: Maybe<RunManageCommandMutation>;
  saveAdminRecommendation: AdminRecommendation;
  saveAmbassadorRecommendation: AmbassadorRecommendation;
  saveAppliedUsers: SaveAppliedUsersModel;
  saveAssistantConversationEmailLead: AssistantConversationLead;
  saveAssistantConversationFeedback: AssistantConversationFeedback;
  saveCookieConsentPreferences: CookieConsentOutputDto;
  saveInboxPromptAnswer: Array<InboxPromptAnswer>;
  saveInsightsByCommunity: Insights;
  saveNotInterestedStage: UserDecisionStageOutput;
  saveSatisfactionSurvey: SatisfactionSurveyEntity;
  saveUniversityInterested: UniversityInterestedEntity;
  saveUniversityQuestionAnswer: Array<UniversityQuestionAnswer>;
  saveUserDecisionStage: UserDecisionStageOutput;
  saveVisitedRecommendation: Recommendation;
  sendAssistantMessage: AssistantConversationMessage;
  sendCommunityVerificationCode?: Maybe<SendCommunityVerificationCode>;
  sendConversationMessage: ChatMessage;
  /** sends feature push notification to all users with applicable roles in given university list. */
  sendFeatureNotification: Scalars['Boolean']['output'];
  sendFeedMessage?: Maybe<SendFeedMessageMutation>;
  sendLiveEventMessage?: Maybe<SendLiveEventMessageMutation>;
  sendMessage?: Maybe<SendMessageMutation>;
  sendOpenDayProspectReport?: Maybe<SendOpenDayProspectReport>;
  sendVerificationCode?: Maybe<SendVerificationCode>;
  setActiveBlogTopics?: Maybe<SetActiveBlogTopicsMutation>;
  setAllNotificationsRead?: Maybe<SetAllNotificationsReadMutation>;
  setArchivedContentBrief?: Maybe<SetArchivedContentBriefMutation>;
  setArchivedDegreeLevel?: Maybe<SetArchivedDegreeLevelMutation>;
  setArchivedYearOfStudy?: Maybe<SetArchivedYearOfStudyMutation>;
  setBlockUser?: Maybe<BlockUserMutation>;
  setBlockUserV2?: Maybe<BlockUserMutationV2>;
  setBlogPostStatus?: Maybe<UpdatePostStatusMutation>;
  setBuddiesListFilters?: Maybe<SetBuddiesListFilters>;
  setChatGroupLabels?: Maybe<SetChatGroupLabelsMutation>;
  setDeviceToken: DeviceToken;
  setInterestsForUser: Array<UserInterest>;
  setMentorFieldOrder?: Maybe<SetMentorFieldOrderMutation>;
  setMentorListFilterSelection?: Maybe<SetMentorListFilterSelection>;
  setOnline?: Maybe<SetOnlineMutation>;
  setResolveChatGroup?: Maybe<SetResolveChatGroupMutation>;
  setUniversityUnblockUsers?: Maybe<UniversityBlockUsersMutation>;
  setUserProfile: UserProfile;
  setWillReply?: Maybe<SetWillReplyMutation>;
  showMentorInMarketplace?: Maybe<ShowMentorInMarketplaceMutation>;
  startRecordingVideo?: Maybe<RecordingResponse>;
  stopRecordingVideo?: Maybe<RecordingResponse>;
  stopUniversityCrawl?: Maybe<UniversityScrapeStopOutput>;
  toggleCommunityChatGroupMute: ChatConversation;
  toggleCrmIntegrationSync?: Maybe<ToggleCrmIntegrationSync>;
  toggleCustomAttributeCrmSync?: Maybe<ToggleCustomAttributeCrmSyncMutation>;
  toggleDegreesActive?: Maybe<ToggleDegreesActiveMutation>;
  toggleFeatureAvailability?: Maybe<ToggleFeatureAvailabilityMutation>;
  trackLiveEvent?: Maybe<TrackLiveEventMutation>;
  trackOpenDay?: Maybe<TrackOpenDayMutation>;
  unlikeConversationMessage: ChatMessage;
  unpinMessage?: Maybe<UnpinMessageMutation>;
  unpinMessageInConversation: ChatConversation;
  unresolveConversationMessage: ChatMessage;
  updateApplicant?: Maybe<UpdateApplicantMutation>;
  updateApplicantPreferences?: Maybe<UpdateApplicantPreferencesMutation>;
  updateCanonicalQuestion?: Maybe<UpdateCanonicalQuestion>;
  updateChatRoom: ChatRoom;
  updateCommunityApplicantSignupsource?: Maybe<UpdateCommunityApplicantSignupSourceMutation>;
  updateCrmServiceUniversityConfig?: Maybe<UpdateUniversityConfigMutation>;
  updateDirectMessagingMembersForLiveEvent?: Maybe<UpdateDirectMessagingMembersForLiveEventMutation>;
  updateEventPage: EventPage;
  updateExternalContent: ExternalContent;
  updateFaqAnswer?: Maybe<UpdateFaqAnswer>;
  updateHobsonsConnectIntegration?: Maybe<UpdateHobsonsConnectIntegration>;
  updateIntegrationFieldMapping?: Maybe<UpdateIntegrationFieldMapping>;
  updateLiveEventFeedSessionData?: Maybe<UpdateLiveEventFeedSessionDataMutation>;
  updateLiveSession: LiveSession;
  updateLiveSessionAnyUser: LiveSession;
  updateManyUserMutation?: Maybe<UpdateManyUserMutation>;
  updateMarketplace?: Maybe<UpdateMarketplaceMutation>;
  updateMarketplaceApplicant?: Maybe<UpdateMarketplaceApplicantMutation>;
  updateMarketplaceApplicantUniversityLink?: Maybe<UpdateMarketplaceApplicantUniversityLinkMutation>;
  updateMentor?: Maybe<UpdateMentorMutation>;
  updateMentorPreferences?: Maybe<UpdateMentorPreferences>;
  updateMyUniversityLink?: Maybe<UpdateMyUniversityLinkMutation>;
  updateRecordingLayout?: Maybe<RecordingResponse>;
  updateResearchTime?: Maybe<UpdateResearchTimeMutation>;
  updateStaff?: Maybe<UpdateStaffMutation>;
  updateStaffContact: StaffContactOutput;
  updateSubTopic?: Maybe<UpdateSubTopicMutation>;
  updateTag?: Maybe<UpdateTagMutation>;
  updateTodoAction: Scalars['String']['output'];
  updateTodoStatus: TodosEntity;
  updateTopic?: Maybe<UpdateTopicMutation>;
  updateUniversityAssistantScrapeStartingPoint: UniversityAssistantConfigurationScrapeStartPointOutput;
  updateUniversityBlockReport?: Maybe<UpdateUniversityBlockReportMutation>;
  updateUniversityUser?: Maybe<UpdateUniversityUserMutation>;
  updateUniversityUserPreferences?: Maybe<UpdateUniversityUserPreferencesMutation>;
  updateUserMutation?: Maybe<UpdateUserMutation>;
  updateUserPreferencesMutation?: Maybe<UpdateUserPreferences>;
  updateVirtualEvent: VirtualEvent;
  verifyAccount?: Maybe<VerifyAccount>;
  viewBlog?: Maybe<ViewBlogMutation>;
};


export type MutationAcceptRequestedPublicGroupArgs = {
  acceptRequestedPublicGroupInput: AcceptRequestedPublicGroupInput;
};


export type MutationActivateApplicantsArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationActivateMentorsArgs = {
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAddAttendeesArgs = {
  attendeeData: AttendeeData;
};


export type MutationAddBotToChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddChatRoomAttendeesArgs = {
  chatRoomAttendeeData: ChatRoomAttendeeData;
};


export type MutationAddCustomAttributeArgs = {
  attributeValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  destination?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCustomAttributeOptionArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDegreeLevelsArgs = {
  degreeLevelNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDegreesArgs = {
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  degreeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeTypes?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddDeviceArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddHobsonsConnectIntegrationArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  passKey?: InputMaybe<Scalars['String']['input']>;
  webServiceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddLocalesToAppArgs = {
  appLocales: Array<InputMaybe<AppLocalesFieldInput>>;
};


export type MutationAddReactionToMessageArgs = {
  reactionDto: ReactionDto;
};


export type MutationAddResearchTimeArgs = {
  researchTimeData: ResearchTimeInput;
};


export type MutationAddSessionAttendeesArgs = {
  sessionAttendeeData: SessionAttendeeData;
};


export type MutationAddToFeatureExperimentArgs = {
  experimentName: Scalars['String']['input'];
  metadata: Scalars['String']['input'];
};


export type MutationAddUserToCommunityConversationArgs = {
  conversationId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type MutationAddVoteArgs = {
  chatMessageId: Scalars['ObjectId']['input'];
  option: Scalars['String']['input'];
};


export type MutationAddYearOfStudyArgs = {
  degreeLevelName: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyNames: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationAdminDeleteApplicantArgs = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminDeleteBuddyArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminUpdateMentorArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApplicantBroadcastMessageArgs = {
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkOptOutMarketplaceUniversityMarketingArgs = {
  marketplaceSlug: Scalars['String']['input'];
  universitySlugs: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationCheckEmailArgs = {
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloneCommunityArgs = {
  sourceCommmunityId: Scalars['String']['input'];
};


export type MutationCloneLiveEventAndChannelsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAlertArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicantArgs = {
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  primaryApp?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicantV2Args = {
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  checkForAmbassador?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  primaryApp?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApplicationInsightArgs = {
  createApplicantInsightInput: CreateApplicantInsightInput;
};


export type MutationCreateAssistantConversationArgs = {
  createAssistantConversationInput: CreateAssistantConversationInput;
};


export type MutationCreateAssistantMessageFeedbackArgs = {
  assistantMessageFeedbackInput: AssistantMessageFeedbackInput;
};


export type MutationCreateBlogTopicArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBuddyArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCanonicalQuestionArgs = {
  defaultQuestion?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  subTopic: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateChatReportArgs = {
  chatReportUserInputDTO: ChatReportUserInputDto;
};


export type MutationCreateChatRoomArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateCommentArgs = {
  postId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityArgs = {
  CreateCommunityDTO: CreateCommunityDto;
};


export type MutationCreateCommunityApplicantArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityApplicantV2Args = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommunityChatGroupArgs = {
  createCommunityChatGroupInput: CreateCommunityChatGroupInput;
};


export type MutationCreateCommunityConversationArgs = {
  CreateCommunityConversationDTO: CreateCommunityConversationDto;
};


export type MutationCreateCommunityFromTemplateArgs = {
  CreateCommunityDTO: CreateCommunityDto;
  communityUseCase: Scalars['String']['input'];
};


export type MutationCreateCrmServiceUniversityConfigArgs = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  connectorEndpoint?: InputMaybe<Scalars['String']['input']>;
  connectorName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigs?: InputMaybe<Array<InputMaybe<DataFormatConfigInputType>>>;
  fields?: InputMaybe<Array<InputMaybe<CrmFieldInputType>>>;
  isSyncActive?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  zapierWebhook?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDirectConversationArgs = {
  DirectConversationDTO: DirectConversationDto;
};


export type MutationCreateEventPageArgs = {
  eventPageData: EventPageData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateExternalContentArgs = {
  externalContentData: ExternalContentData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateExternalEventArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFaqAnswerArgs = {
  answer: Scalars['String']['input'];
  canonicalQuestion: Scalars['String']['input'];
};


export type MutationCreateFresherArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInviteLinkArgs = {
  inviteLinkInput: InviteLinkInput;
};


export type MutationCreateLiveEventArgs = {
  chatGroups?: InputMaybe<Array<InputMaybe<LiveEventChatGroupsInputField>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLiveEventDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLiveEventFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};


export type MutationCreateLiveEventFeedSessionsArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSession>>>;
};


export type MutationCreateLiveSessionArgs = {
  sessionData: SessionData;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCreateMarketplaceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowUniversityProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  customBuddyWord?: InputMaybe<Scalars['String']['input']>;
  customFilters?: InputMaybe<Array<InputMaybe<MarketplaceFilterInput>>>;
  disableExternalNotification?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentCollectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentMessage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  personalDataApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  unibuddyMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  universityMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
  widgetDescription?: InputMaybe<Scalars['String']['input']>;
  widgetTitle?: InputMaybe<Scalars['String']['input']>;
  widgetUrl: Scalars['String']['input'];
};


export type MutationCreateMarketplaceApplicantArgs = {
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  marketplace: ApplicantMarketplaceInput;
  password: Scalars['String']['input'];
  unibuddyServicesConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMentorArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOpenDayArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isStaffCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentsCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  navigateTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};


export type MutationCreateOrUpdateUniversityAssistantPromptContextArgs = {
  universityAssistantConfigurationPromptContextInput: UniversityAssistantConfigurationPromptContextInput;
};


export type MutationCreateOrUpdateUniversityAssistantScrapeIgnoreUrlsArgs = {
  universityAssistantConfigurationScrapeIgnoreUrlsInput: UniversityAssistantConfigurationScrapeIgnoreUrlsInput;
};


export type MutationCreateOrganisationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedInstanceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationType: OrganisationType;
  parentOrganisationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrganisationBuddyLinkArgs = {
  organisation: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  user: Scalars['String']['input'];
};


export type MutationCreatePostArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  coverImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  youtubeVideo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateStaffContactArgs = {
  staffContactInput: StaffContactInput;
};


export type MutationCreateSubTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTodoArgs = {
  CreateTodoInputDto: CreateTodoInputDto;
};


export type MutationCreateTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUniversityArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUniversityAssistantEventLinkArgs = {
  universityAssistantConfigurationEventInput: UniversityAssistantConfigurationEventInput;
};


export type MutationCreateUniversityBlockReportArgs = {
  blocked?: InputMaybe<Scalars['String']['input']>;
  chatGroup?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conversation?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  triggeredFrom?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUniversityScrapeArgs = {
  universityScrapeInput: UniversityScrapeInput;
};


export type MutationCreateUniversityScrapeBatchArgs = {
  universityScrapeManualInput: UniversityScrapeManualInput;
};


export type MutationCreateUniversityScrapeOneArgs = {
  universityScrapeInput: UniversityScrapeInput;
};


export type MutationCreateUniversityUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserReportArgs = {
  userReportUserInputDTO: UserReportUserInputDto;
};


export type MutationCreateVideoUploadLinkArgs = {
  videoUploadLinkInput: VideoUploadLinkInput;
};


export type MutationCreateVirtualEventArgs = {
  createVirtualEventInput: CreateVirtualEventInput;
  universityId: Scalars['ObjectId']['input'];
};


export type MutationCreateVirtualEventProspectReportArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationCsvUploadAmbassadorFieldsArgs = {
  file: Scalars['Upload']['input'];
  uniSlug: Scalars['String']['input'];
};


export type MutationCsvUploadApplicantsArgs = {
  file: Scalars['Upload']['input'];
  password: Scalars['String']['input'];
  uniSlug: Scalars['String']['input'];
};


export type MutationDeactivateApplicantsArgs = {
  applicantIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeactivateMentorsArgs = {
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteAdminRecommendationArgs = {
  recommendationId: Scalars['String']['input'];
};


export type MutationDeleteBlogPostArgs = {
  blogPostId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCanonicalQuestionArgs = {
  question: Scalars['String']['input'];
};


export type MutationDeleteChatRoomArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
};


export type MutationDeleteCommunityConversationArgs = {
  DeleteCommunityConversationDTO: DeleteCommunityConversationDto;
};


export type MutationDeleteConversationMessageArgs = {
  deleteMessageDto: DeleteMessageDto;
};


export type MutationDeleteCustomAttributeOptionsArgs = {
  optionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteCustomAttributesArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteDegreeLevelArgs = {
  degreeLevelId: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationDeleteEventPageArgs = {
  eventPageId: Scalars['ObjectId']['input'];
};


export type MutationDeleteExternalContentArgs = {
  externalContentId: Scalars['ObjectId']['input'];
};


export type MutationDeleteFaqAnswerArgs = {
  answer: Scalars['String']['input'];
};


export type MutationDeleteLiveEventArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveEventFeedArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveEventMessageMutationArgs = {
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteLiveSessionArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
};


export type MutationDeleteRecordingArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  sid: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type MutationDeleteResearchTimeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSubTopicArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTopicArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUniversityKnowledgeBaseSourceByIdArgs = {
  knowledgeBaseDeleteEntryInput: KnowledgeBaseDeleteEntryInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByPatternMatchArgs = {
  deleteKnowledgeBaseEntriesByPatternMatchInput: DeleteKnowledgeBaseEntriesByPatternMatchInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByPatternMismatchArgs = {
  deleteKnowledgeBaseEntriesByPatternMismatchInput: DeleteKnowledgeBaseEntriesByPatternMismatchInput;
};


export type MutationDeleteUniversityKnowledgeBaseSourceByUrlListArgs = {
  deleteKnowledgeBaseEntriesByUrlListInput: DeleteKnowledgeBaseEntriesByUrlListInput;
};


export type MutationDeleteUniversityUserArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteVirtualEventArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationDeleteYearOfStudyArgs = {
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationEditAdminRecommendationArgs = {
  adminRecommendationInput: AdminRecommendationInput;
  recommendationId: Scalars['String']['input'];
};


export type MutationEditAlertArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditBlogPostArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  coverImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  youtubeVideo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditBlogTopicArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCommunityArgs = {
  EditCommunityDTO: EditCommunityDto;
};


export type MutationEditCommunityConversationArgs = {
  EditCommunityConversationDTO: EditCommunityConversationDto;
};


export type MutationEditCookieConsentPreferencesArgs = {
  CookieConsentInputDTO: CookieConsentInputDto;
};


export type MutationEditCustomAttributeArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditCustomAttributeOptionArgs = {
  newValue?: InputMaybe<Scalars['String']['input']>;
  optionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCustomAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<CustomAttributeInput>>>;
};


export type MutationEditCustomWelcomeMessageArgs = {
  defaultProspectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreeLevelArgs = {
  degreeLevelId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreeNameArgs = {
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  newDegreeName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditDegreesArgs = {
  degreeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  degreeTypes?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditExternalEventArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventArgs = {
  chatGroups?: InputMaybe<Array<InputMaybe<LiveEventChatGroupsInputField>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventFeedArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  hostIdsVideoSessions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  mentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLiveEventsLandingPageArgs = {
  description: Scalars['String']['input'];
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditOpenDayArgs = {
  description: Scalars['String']['input'];
  end?: InputMaybe<Scalars['String']['input']>;
  externalEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isStaffCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentsCarouselEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveEventIds: Array<InputMaybe<Scalars['String']['input']>>;
  navigateTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openDayId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};


export type MutationEditOrganisationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};


export type MutationEditUniversityArgs = {
  churned?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  customChatBubbleTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  customMarketingConsentText?: InputMaybe<Scalars['String']['input']>;
  customMarketingConsentTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  customPreSignupText?: InputMaybe<Scalars['String']['input']>;
  customPreSignupTextInLocales?: InputMaybe<Array<InputMaybe<TextInLocaleInput>>>;
  degreeTypeOrder?: InputMaybe<Array<InputMaybe<DegreeTypeOrderInput>>>;
  domesticRegions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entries?: InputMaybe<EntriesInput>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  marketplaces?: InputMaybe<Array<InputMaybe<UniversityMarketplaceInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  squareLogo?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  whiteLogo?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetUrls?: InputMaybe<Array<InputMaybe<WidgetUrlsInput>>>;
};


export type MutationEditYearOfStudyArgs = {
  degreeLevelName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationEmailInvitesDataForCommunityArgs = {
  communityId: Scalars['String']['input'];
  filters: InviteFilter;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableCustomWelcomeMessageArgs = {
  allowWelcomeMessageCustomization?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableCustomWelcomeMessageStaffArgs = {
  allowWelcomeMessageCustomizationStaff?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEnableFeaturesArgs = {
  features?: InputMaybe<Array<InputMaybe<FeatureInputField>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportAnalyticsCsvArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForwardApplicantToUniversityArgs = {
  applicantId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateAnalyticsDashboardTokenArgs = {
  collectionId?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<AnalyticsDashboardMetadata>>>;
};


export type MutationGenerateDownloadUrlArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateLiveEventReportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateRecommendationsArgs = {
  generateRecommendationsInput: GenerateRecommendationsInput;
};


export type MutationGetMarketplaceApplicantArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  marketplaceUser?: InputMaybe<Scalars['JSONString']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetOrCreateApiKeyArgs = {
  integration: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type MutationGetOrCreateWidgetConversationArgs = {
  widgetConversationDto: WidgetConversationDto;
};


export type MutationGetSignedS3PostFieldsArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetSignedS3UrlArgs = {
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHideMentorInMarketplaceArgs = {
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorId: Scalars['String']['input'];
};


export type MutationInitialiseRecordingArgs = {
  data: InitialiseRecordingArgs;
};


export type MutationInviteApplicantsArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteBuddiesArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteEmailsToCommunityArgs = {
  communityId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteMentorsArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationJoinChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinCommunityArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationJoinCommunityByInviteLinkArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationJoinCommunityConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationJoinCommunityForAdminsArgs = {
  communityId: Scalars['String']['input'];
};


export type MutationLabelSentenceArgs = {
  chatGroupId: Scalars['String']['input'];
  classifiedSentenceId: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  subTopicExternalId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  topicExternalId: Scalars['String']['input'];
};


export type MutationLeaveChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLeaveCommunityChatGroupArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationLikeConversationMessageArgs = {
  likeMessageDto: LikeMessageDto;
};


export type MutationLikeMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkOrganisationsArgs = {
  childOrganisationId: Scalars['String']['input'];
  parentOrganisationId: Scalars['String']['input'];
};


export type MutationLiveEventFeedbackFormArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  eventExperience?: InputMaybe<Scalars['Int']['input']>;
  eventFeedback?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationManageOrganisationAccessArgs = {
  access: Scalars['Boolean']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationManuallyClassifyArgs = {
  classificationId: Scalars['String']['input'];
  subTopicExternalId?: InputMaybe<Scalars['String']['input']>;
  subTopicId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkAssistantConversationAsViewedArgs = {
  markAssistantConversationAsViewedInput: MarkAssistantConversationAsViewedInput;
};


export type MutationMentorBroadcastMessageArgs = {
  receiverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMessagePublicBotArgs = {
  botAction?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationModerateChatReportArgs = {
  chatReportModeratorInputDTO: ChatReportModeratorInputDto;
};


export type MutationModerateUserReportArgs = {
  userReportModeratorInputDTO: UserReportModeratorInputDto;
};


export type MutationPinMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPinMessageInConversationArgs = {
  pinMessageDTO: PinMessageDto;
};


export type MutationReadChatArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordConsentArgs = {
  channelId: Scalars['ObjectId']['input'];
  time: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};


export type MutationRecordFailureArgs = {
  data: RecordingFailureArgs;
};


export type MutationRecordLastMessageReadByUserArgs = {
  markReadMessageDto: MarkReadMessageDto;
};


export type MutationRecordUserActivityArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activitySource?: InputMaybe<Scalars['JSONString']['input']>;
  app?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterToLiveEventArgs = {
  liveEventSlug: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationRejectRequestedPublicGroupArgs = {
  rejectRequestedPublicGroupInput: RejectRequestedPublicGroupInput;
};


export type MutationRemoveApplicationInsightArgs = {
  removeApplicantInsightInput: RemoveApplicantInsightInput;
};


export type MutationRemoveBuddyInvitesArgs = {
  inviteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveDeviceArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMembersFromCommunityArgs = {
  removeMembersDTO: RemoveMembersFromCommunityInputDto;
};


export type MutationRemoveMentorInvitesArgs = {
  inviteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRemoveReactionFromMessageArgs = {
  reactionDto: ReactionDto;
};


export type MutationRemoveUserFromCommunityChatGroupArgs = {
  conversationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveVoteArgs = {
  chatMessageId: Scalars['ObjectId']['input'];
  option: Scalars['String']['input'];
};


export type MutationRequestAnalyticsExportArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<RootUrlEnum>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordSetArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<RootUrlEnum>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPublicGroupArgs = {
  requestPublicGroupInput: CreateRequestedPublicGroupInput;
};


export type MutationRequestResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestResetPasswordMobileArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestResetPasswordMobileV2Args = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordV2Args = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveChatsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveConversationMessageArgs = {
  resolveMessageDto: ResolveMessageDto;
};


export type MutationRunManageCommandArgs = {
  command?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveAdminRecommendationArgs = {
  adminRecommendationInput: AdminRecommendationInput;
};


export type MutationSaveAmbassadorRecommendationArgs = {
  ambassadorRecommendationInput: AmbassadorRecommendationInput;
};


export type MutationSaveAppliedUsersArgs = {
  saveAppliedUsersInput: SaveAppliedUsersInput;
};


export type MutationSaveAssistantConversationEmailLeadArgs = {
  saveAssistantConversationEmailLeadInput: SaveAssistantConversationEmailLeadInput;
};


export type MutationSaveAssistantConversationFeedbackArgs = {
  saveAssistantConversationFeedbackInput: SaveAssistantConversationFeedbackInput;
};


export type MutationSaveCookieConsentPreferencesArgs = {
  CookieConsentInputDTO: CookieConsentInputDto;
};


export type MutationSaveInboxPromptAnswerArgs = {
  inboxPromptAnswerInput: InboxPromptAnswerInput;
};


export type MutationSaveInsightsByCommunityArgs = {
  communityId: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveNotInterestedStageArgs = {
  notInterestedStageInput: UserNotInterestedStageInput;
};


export type MutationSaveSatisfactionSurveyArgs = {
  SatisfactionSurveyDTO: SatisfactionSurveyDto;
};


export type MutationSaveUniversityInterestedArgs = {
  UniversityInterestedDTO: UniversityInterestedDto;
};


export type MutationSaveUniversityQuestionAnswerArgs = {
  saveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
};


export type MutationSaveUserDecisionStageArgs = {
  decisionStageInput: UserDecisionStageInput;
};


export type MutationSaveVisitedRecommendationArgs = {
  saveVisitedRecommendationInput: SaveVisitedRecommendationInput;
};


export type MutationSendAssistantMessageArgs = {
  sendAssistantMessageInput: SendAssistantMessageInput;
};


export type MutationSendConversationMessageArgs = {
  messageDto: MessageDto;
};


export type MutationSendFeatureNotificationArgs = {
  FeatureNotificationRequestDTO: FeatureNotificationRequestDto;
};


export type MutationSendFeedMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  richContent?: InputMaybe<RichContentInputField>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendLiveEventMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  richContent?: InputMaybe<RichContentInputField>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendMessageArgs = {
  botAction?: InputMaybe<Scalars['String']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Metadata>;
  origin?: InputMaybe<OriginField>;
  richContent?: InputMaybe<RichContentInputField>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendOpenDayProspectReportArgs = {
  openDayId: Scalars['String']['input'];
};


export type MutationSendVerificationCodeArgs = {
  source: SourceInputField;
};


export type MutationSetActiveBlogTopicsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blogTopicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetArchivedContentBriefArgs = {
  archived: Scalars['Boolean']['input'];
  contentBriefId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
  valuable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetArchivedDegreeLevelArgs = {
  archived: Scalars['Boolean']['input'];
  degreeLevelId: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationSetArchivedYearOfStudyArgs = {
  archived: Scalars['Boolean']['input'];
  universitySlug: Scalars['String']['input'];
  yearOfStudyId: Scalars['String']['input'];
};


export type MutationSetBlockUserArgs = {
  setBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetBlockUserV2Args = {
  setBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetBlogPostStatusArgs = {
  blogPostId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogStatus>;
};


export type MutationSetBuddiesListFiltersArgs = {
  filters?: InputMaybe<Array<InputMaybe<BuddiesListFilterInput>>>;
};


export type MutationSetChatGroupLabelsArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  labelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetDeviceTokenArgs = {
  SetDeviceTokenDTO: SetDeviceTokenDto;
};


export type MutationSetInterestsForUserArgs = {
  setUserInterestsInput: SetUserInterestsInput;
};


export type MutationSetMentorFieldOrderArgs = {
  order?: InputMaybe<Array<InputMaybe<MentorFieldOrderInput>>>;
};


export type MutationSetMentorListFilterSelectionArgs = {
  choices?: InputMaybe<Array<InputMaybe<MentorListFilterChoiceInput>>>;
};


export type MutationSetOnlineArgs = {
  online?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetResolveChatGroupArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetUniversityUnblockUsersArgs = {
  setUnblocked?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationSetUserProfileArgs = {
  data: UpdateUserProfile;
};


export type MutationSetWillReplyArgs = {
  applicant?: InputMaybe<Scalars['String']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  mobileAdded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationShowMentorInMarketplaceArgs = {
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorId: Scalars['String']['input'];
};


export type MutationStartRecordingVideoArgs = {
  data: StartRecordingArgs;
};


export type MutationStopRecordingVideoArgs = {
  data: StopRecordingArgs;
};


export type MutationStopUniversityCrawlArgs = {
  universityStopCrawlInput: UniversityStopCrawlInput;
};


export type MutationToggleCommunityChatGroupMuteArgs = {
  conversationId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationToggleCrmIntegrationSyncArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleCustomAttributeCrmSyncArgs = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleDegreesActiveArgs = {
  degreeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  degreeLevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleFeatureAvailabilityArgs = {
  features?: InputMaybe<Array<InputMaybe<FeatureToggleInputField>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackLiveEventArgs = {
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTrackOpenDayArgs = {
  name: Scalars['String']['input'];
  openDayId: Scalars['String']['input'];
  product: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationUnlikeConversationMessageArgs = {
  likeMessageDto: LikeMessageDto;
};


export type MutationUnpinMessageArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpinMessageInConversationArgs = {
  unpinMessageDTO: UnpinMessageDto;
};


export type MutationUnresolveConversationMessageArgs = {
  resolveMessageDto: ResolveMessageDto;
};


export type MutationUpdateApplicantArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  ageVerificationInfo?: InputMaybe<AgeVerificationInfoInputField>;
  country?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasReadChatRules?: InputMaybe<Scalars['Boolean']['input']>;
  highSchool?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<UserLocalePreferenceInput>;
  pastUniversity?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApplicantPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateCanonicalQuestionArgs = {
  question?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  subTopic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateChatRoomArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
  updateChatRoomInput: UpdateChatRoomInput;
};


export type MutationUpdateCommunityApplicantSignupsourceArgs = {
  communityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCrmServiceUniversityConfigArgs = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  connectorEndpoint?: InputMaybe<Scalars['String']['input']>;
  connectorName?: InputMaybe<Scalars['String']['input']>;
  dataFormatConfigs?: InputMaybe<Array<InputMaybe<DataFormatConfigInputType>>>;
  fields?: InputMaybe<Array<InputMaybe<CrmFieldInputType>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSyncActive?: InputMaybe<Scalars['Boolean']['input']>;
  sendSampleData?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  zapierWebhook?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDirectMessagingMembersForLiveEventArgs = {
  directMessagingMentors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  directMessagingStaff?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventPageArgs = {
  eventPageId: Scalars['ObjectId']['input'];
  updateEventPageInput: UpdateEventPageInput;
};


export type MutationUpdateExternalContentArgs = {
  externalContentId: Scalars['ObjectId']['input'];
  updateExternalContentInput: UpdateExternalContentInput;
};


export type MutationUpdateFaqAnswerArgs = {
  answer?: InputMaybe<Scalars['String']['input']>;
  answerId: Scalars['String']['input'];
  canonicalQuestion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHobsonsConnectIntegrationArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  passKey?: InputMaybe<Scalars['String']['input']>;
  webServiceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateIntegrationFieldMappingArgs = {
  fieldMapping?: InputMaybe<Array<InputMaybe<FieldMappingInput>>>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLiveEventFeedSessionDataArgs = {
  liveEventFeedId?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  videoSessions?: InputMaybe<Array<InputMaybe<VideoSessionToUpdateField>>>;
};


export type MutationUpdateLiveSessionArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
  updateLiveSessionInput: UpdateLiveSessionInput;
};


export type MutationUpdateLiveSessionAnyUserArgs = {
  liveSessionId: Scalars['ObjectId']['input'];
  updateLiveSessionInput: UpdateLiveSessionAnyUserInput;
};


export type MutationUpdateManyUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMarketplaceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowUniversityProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  customBuddyWord?: InputMaybe<Scalars['String']['input']>;
  customFilters?: InputMaybe<Array<InputMaybe<MarketplaceFilterInput>>>;
  disableExternalNotification?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  marketplaceMarketingConsentCollectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceMarketingConsentMessage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personalDataApiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  unibuddyMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  universityMarketingConsentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
  widgetDescription?: InputMaybe<Scalars['String']['input']>;
  widgetTitle?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMarketplaceApplicantArgs = {
  marketplace: ApplicantMarketplaceInput;
};


export type MutationUpdateMarketplaceApplicantUniversityLinkArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSlug: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type MutationUpdateMentorArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  chatIntro?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  degree?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<MentorDegreeFieldInput>>>;
  favouriteModules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  interests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  pastQualification?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  primaryFlag?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  secondaryFlag?: InputMaybe<Scalars['String']['input']>;
  societies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMentorPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateMyUniversityLinkArgs = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  applied?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  dateOfEntry?: InputMaybe<Scalars['Date']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreesInterested?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  localePreference?: InputMaybe<UserLocalePreferenceInput>;
  sourceMetadata?: InputMaybe<SourceMetadataField>;
  sourceTrackingParams?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRecordingLayoutArgs = {
  data: UpdateRecordingLayoutArgs;
};


export type MutationUpdateResearchTimeArgs = {
  researchTimeData: ResearchTimeInput;
};


export type MutationUpdateStaffArgs = {
  bio?: InputMaybe<Scalars['String']['input']>;
  customAttributes?: InputMaybe<Array<InputMaybe<CustomAttributeValueInput>>>;
  department?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStaffContactArgs = {
  updateStaffContactInput: UpdateStaffContactInput;
};


export type MutationUpdateSubTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTagArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTodoActionArgs = {
  action: TodoAction;
  id: Scalars['String']['input'];
};


export type MutationUpdateTodoStatusArgs = {
  id: Scalars['String']['input'];
  status: TodoStatus;
};


export type MutationUpdateTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityAssistantScrapeStartingPointArgs = {
  universityAssistantConfigurationScrapeStartPointInput: UniversityAssistantConfigurationScrapeStartPointInput;
};


export type MutationUpdateUniversityBlockReportArgs = {
  blockedUser?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  universityBlockReportId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUniversityUserPreferencesArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateUserMutationArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserPreferencesMutationArgs = {
  newMessageNotifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateVirtualEventArgs = {
  updateVirtualEventInput: UpdateVirtualEventInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type MutationVerifyAccountArgs = {
  code: Scalars['String']['input'];
};


export type MutationViewBlogArgs = {
  blogId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NewsFeedGroup = {
  __typename?: 'NewsFeedGroup';
  conversationId: Scalars['String']['output'];
};

export enum NotInterestedReasonEnum {
  NotInterestedInApplyingToUni = 'NOT_INTERESTED_IN_APPLYING_TO_UNI',
  NotInterestedInUpdatesFromUni = 'NOT_INTERESTED_IN_UPDATES_FROM_UNI',
  NotInterestedOther = 'NOT_INTERESTED_OTHER'
}

export type NotificationField = {
  __typename?: 'NotificationField';
  id?: Maybe<Scalars['String']['output']>;
};

export type OffsetPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OffsetPaginationDto = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenDayField = {
  __typename?: 'OpenDayField';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isStaffCarouselEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStudentsCarouselEnabled?: Maybe<Scalars['Boolean']['output']>;
  liveEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  navigateOpenDays?: Maybe<Array<Maybe<OpenDayField>>>;
  navigateTags?: Maybe<Array<Maybe<TagField>>>;
  prospectLogins?: Maybe<OpenDaysLoginField>;
  prospectSignups?: Maybe<OpenDaysSignupField>;
  prospectsAttending?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<TagField>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OpenDaysLoginField = {
  __typename?: 'OpenDaysLoginField';
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<Scalars['Int']['output']>;
  openDay?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  widget?: Maybe<Scalars['Int']['output']>;
};

export type OpenDaysSignupField = {
  __typename?: 'OpenDaysSignupField';
  id?: Maybe<Scalars['String']['output']>;
  liveEvent?: Maybe<Scalars['Int']['output']>;
  openDay?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  widget?: Maybe<Scalars['Int']['output']>;
};

export type OpenTextFieldValueField = CustomAttributeValueField & {
  __typename?: 'OpenTextFieldValueField';
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OrderByLiveSessionsInput = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganisationBuddyLinkField = {
  __typename?: 'OrganisationBuddyLinkField';
  organisation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type OrganisationField = {
  __typename?: 'OrganisationField';
  active?: Maybe<Scalars['Boolean']['output']>;
  childOrganisations?: Maybe<Array<Maybe<ChildOrganisationField>>>;
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkedInstance?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationType: Scalars['String']['output'];
  parentOrganisation?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export enum OrganisationType {
  Enterprise = 'ENTERPRISE',
  University = 'UNIVERSITY'
}

export type OriginField = {
  slug?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type OutboxChatGroupField = {
  __typename?: 'OutboxChatGroupField';
  aux?: Maybe<ChatGroupAuxiliaryField>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessage?: Maybe<LastMessageField>;
  members?: Maybe<Array<Maybe<AnyUserField>>>;
  opponent?: Maybe<AnyChatUserField>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  sendbirdChannelUrl?: Maybe<Scalars['String']['output']>;
  unansweredByMentor?: Maybe<Scalars['Boolean']['output']>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type OutputField = {
  __typename?: 'OutputField';
  returncode?: Maybe<Scalars['Int']['output']>;
  stderr?: Maybe<Scalars['String']['output']>;
  stdout?: Maybe<Scalars['String']['output']>;
};

export type PageMentorField = {
  __typename?: 'PageMentorField';
  mentors?: Maybe<Array<Maybe<MentorField>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedAdminRecommendation = {
  __typename?: 'PaginatedAdminRecommendation';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AdminRecommendation>;
};

export type PaginatedApplicantInsightInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type PaginatedApplicantInvite = {
  __typename?: 'PaginatedApplicantInvite';
  data?: Maybe<Array<Maybe<ApplicantInvite>>>;
  totalNum?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedApplicationInsightModel = {
  __typename?: 'PaginatedApplicationInsightModel';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ApplicationInsightModel>;
};

export type PaginatedChatMessages = {
  __typename?: 'PaginatedChatMessages';
  hasMore: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
};

export type PaginatedChatRooms = {
  __typename?: 'PaginatedChatRooms';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ChatRoom>;
};

export type PaginatedEventPages = {
  __typename?: 'PaginatedEventPages';
  hasMore: Scalars['Boolean']['output'];
  items: Array<EventPage>;
};

export type PaginatedExternalContents = {
  __typename?: 'PaginatedExternalContents';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ExternalContent>;
};

export type PaginatedLiveSessions = {
  __typename?: 'PaginatedLiveSessions';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LiveSession>;
};

export type PaginatedVirtualEvents = {
  __typename?: 'PaginatedVirtualEvents';
  hasMore: Scalars['Boolean']['output'];
  items: Array<VirtualEvent>;
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PasswordResetMobileMutation = {
  __typename?: 'PasswordResetMobileMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PasswordResetMobileMutationV2 = {
  __typename?: 'PasswordResetMobileMutationV2';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PayloadField = {
  __typename?: 'PayloadField';
  buttons?: Maybe<Array<Maybe<ButtonField>>>;
  relativePath?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PinMessageMutation = {
  __typename?: 'PinMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PinnedMessageField = {
  __typename?: 'PinnedMessageField';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<PinnedMessageSenderField>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PinnedMessageSenderField = {
  __typename?: 'PinnedMessageSenderField';
  accountRole?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type Poll = {
  __typename?: 'Poll';
  allowMultipleAnswers: Scalars['Boolean']['output'];
  options: Array<PollOption>;
  question: Scalars['String']['output'];
};

export type PollDto = {
  allowMultipleAnswers: Scalars['Boolean']['input'];
  options: Array<PollOptionDto>;
  question: Scalars['String']['input'];
};

export type PollOption = {
  __typename?: 'PollOption';
  option: Scalars['String']['output'];
  votes: Array<Scalars['ObjectId']['output']>;
};

export type PollOptionDto = {
  option: Scalars['String']['input'];
  votes?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
};

export type PopCardDegreeSnippetField = {
  __typename?: 'PopCardDegreeSnippetField';
  description?: Maybe<Scalars['String']['output']>;
  getSnippet?: Maybe<Array<Maybe<DegreeSnippetField>>>;
};

export type PopCardLevelSnippetField = {
  __typename?: 'PopCardLevelSnippetField';
  description?: Maybe<Scalars['String']['output']>;
  getSnippet?: Maybe<Array<Maybe<LevelSnippetField>>>;
};

export type PopCardWidgetField = {
  __typename?: 'PopCardWidgetField';
  description?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type PopcardSnippetField = {
  __typename?: 'PopcardSnippetField';
  defaultSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
  degreeSnippets?: Maybe<Array<Maybe<PopCardDegreeSnippetField>>>;
  description?: Maybe<DescriptionField>;
  internationalSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
  levelSnippets?: Maybe<Array<Maybe<PopCardLevelSnippetField>>>;
  nationalSnippet?: Maybe<Array<Maybe<PopCardWidgetField>>>;
};

export type PostFields = {
  __typename?: 'PostFields';
  acl?: Maybe<Scalars['String']['output']>;
  awsAccessKeyId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  xAmzSecurityToken?: Maybe<Scalars['String']['output']>;
};

export type PreferencesInputType = {
  analyticsCookies: Scalars['Boolean']['input'];
  strictCookies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreferencesObjectType = {
  __typename?: 'PreferencesObjectType';
  analyticsCookies: Scalars['Boolean']['output'];
  strictCookies: Scalars['Boolean']['output'];
};

export type PreferencesOutputType = {
  __typename?: 'PreferencesOutputType';
  analyticsCookies: Scalars['Boolean']['output'];
  strictCookies: Scalars['Boolean']['output'];
};

export enum Product {
  Community = 'community',
  VirtualEvent = 'virtualEvent',
  Widget = 'widget'
}

export type ProspectStageStatField = {
  __typename?: 'ProspectStageStatField';
  changeComparedToLastPeriod?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type ProspectStageSummaryField = {
  __typename?: 'ProspectStageSummaryField';
  summary?: Maybe<Array<Maybe<ProspectStageStatField>>>;
};

export enum PublicGroupStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type PublicMentorField = {
  __typename?: 'PublicMentorField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['String']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  degree?: Maybe<DegreeField>;
  degreeHistory?: Maybe<MentorDegreeHistory>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<MentorDegreeField>>>;
  favouriteModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Array<Maybe<MentorInterestField>>>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  mentorFields?: Maybe<MentorFields>;
  pastQualification?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  schoolHistory?: Maybe<MentorSchoolHistoryField>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  slowSocieties?: Maybe<Array<Maybe<MentorSocietyField>>>;
  societies?: Maybe<Array<Maybe<MentorSocietyField>>>;
  university?: Maybe<UniversityField>;
  year?: Maybe<Scalars['String']['output']>;
};


export type PublicMentorFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PublicMentorFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PublicMentorFieldShareUrlArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};

export type PublicUserField = {
  __typename?: 'PublicUserField';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type QssMetadata = {
  allQuestions?: InputMaybe<Array<InputMaybe<QssQuestion>>>;
  originalQuestionText?: InputMaybe<Scalars['String']['input']>;
  questionModified?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  userChoseQss?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QssQuestion = {
  questionId?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activeUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  adminMentor?: Maybe<MentorField>;
  adminRecommendationCountPerDecisionStage: Array<AdminRecommendationCountPerDecisionStage>;
  adminSearchMentors?: Maybe<Array<Maybe<MentorField>>>;
  agenda: PaginatedLiveSessions;
  alert?: Maybe<AlertField>;
  allAdminApplicants?: Maybe<Array<Maybe<BulkApplicantField>>>;
  allAppLocales?: Maybe<Array<Maybe<AppLocaleField>>>;
  allApplicantConversations?: Maybe<Array<Maybe<ApplicantConversationField>>>;
  allApplicantCount?: Maybe<ApplicantCountField>;
  allApplicantSignUps?: Maybe<Array<Maybe<CountPerEpoch>>>;
  allApplicants?: Maybe<Array<Maybe<BulkApplicantField>>>;
  allBuddyInvites?: Maybe<BuddyInviteField>;
  allChatGroupCount?: Maybe<Array<Maybe<CountPerEpoch>>>;
  allChatGroupsByDay?: Maybe<Array<Maybe<ChatGroupField>>>;
  allContentBriefs?: Maybe<Array<Maybe<ContentBriefField>>>;
  allCountries?: Maybe<Array<Maybe<CountryField>>>;
  allCrmIntegrations?: Maybe<Array<Maybe<CrmIntegrationField>>>;
  allCrms?: Maybe<Array<Maybe<CrmField>>>;
  allDegreeLevels?: Maybe<Array<Maybe<DegreeLevelField>>>;
  allDegreeTypes?: Maybe<Array<Maybe<DegreeType>>>;
  allDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  allHighSchoolTypes?: Maybe<Array<Maybe<HighSchoolTypeField>>>;
  allHighSchools?: Maybe<Array<Maybe<HighSchoolField>>>;
  allLanguages?: Maybe<Array<Maybe<LanguageField>>>;
  allLocales?: Maybe<Array<Maybe<LocaleField>>>;
  allMentorInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
  allMentors?: Maybe<Array<Maybe<MentorField>>>;
  allMentorsOfEnterprise?: Maybe<Array<Maybe<EnterpriseMentorField>>>;
  allMentorsTimeSpent?: Maybe<UsersTimeSpentData>;
  allPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  allPostsInfo?: Maybe<AllPostsField>;
  allStaff?: Maybe<StaffUserListField>;
  allSubCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  allSubRegions?: Maybe<Array<Maybe<TopRegionField>>>;
  allTopCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  allTopDegrees?: Maybe<Array<Maybe<TopDegreeField>>>;
  allTopRegions?: Maybe<Array<Maybe<TopRegionField>>>;
  allUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  allUserIds?: Maybe<UserIdsListField>;
  allUsers?: Maybe<UserListField>;
  allYearOfStudy?: Maybe<Array<Maybe<YearOfStudyField>>>;
  analytics: Analytics;
  appLocales?: Maybe<AppLocaleField>;
  applicant?: Maybe<ApplicantField>;
  applicantCollectionFields?: Maybe<Array<Maybe<ApplicantCollectionField>>>;
  applicantCount?: Maybe<ApplicantCountField>;
  applicantCountryCount?: Maybe<Scalars['Int']['output']>;
  applicantDegreeCount?: Maybe<Scalars['Int']['output']>;
  applicantDomesticRegionCount?: Maybe<Scalars['Int']['output']>;
  applicantInbox?: Maybe<ApplicantInboxField>;
  applicantInvites?: Maybe<Array<Maybe<ApplicantInvite>>>;
  applicantSignUps?: Maybe<Array<Maybe<CountPerEpoch>>>;
  applicantsApplied?: Maybe<ApplicantsAppliedStats>;
  applicantsMessaged?: Maybe<ApplicantsMessagedCount>;
  applicationInsights: PaginatedApplicationInsightModel;
  appliedUsersCount: AppliedUsersCountModel;
  askQuestion?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  availableDegreeTypes?: Maybe<Array<Maybe<DegreeType>>>;
  blockedUsersByMe?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  botUser?: Maybe<BotUserField>;
  buddies?: Maybe<BuddiesField>;
  buddiesFilterOptions?: Maybe<BuddiesFilterOptionsField>;
  buddy?: Maybe<BuddyField>;
  buddyApplicantChatGroupCount?: Maybe<Scalars['Int']['output']>;
  buddyApplicantChatGroups?: Maybe<Array<Maybe<BuddyApplicantChatGroupField>>>;
  buddyApplicantChatIntervention?: Maybe<Array<Maybe<BuddyApplicantChatInterventionBuddyField>>>;
  buddyApplicantChatInterventionTotalCount?: Maybe<Scalars['Int']['output']>;
  buddyInvite?: Maybe<BuddyInviteListField>;
  buddyResponseTime?: Maybe<Array<Maybe<AnalyticsBuddyField>>>;
  canonicalQuestions?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  chatGroupAux?: Maybe<ChatGroupAuxiliaryField>;
  chatGroupById?: Maybe<ChatGroupField>;
  chatGroupCount?: Maybe<Array<Maybe<CountPerEpoch>>>;
  chatGroupLabellingCandidates?: Maybe<Array<Maybe<LabellingSentenceCandidate>>>;
  chatGroupLabels?: Maybe<Array<Maybe<ChatGroupLabelField>>>;
  chatGroupSuggestions?: Maybe<Array<Maybe<SuggestionField>>>;
  chatGroupsByDay?: Maybe<Array<Maybe<ChatGroupField>>>;
  chatInterventionMentors?: Maybe<MentorInterventionQueryField>;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomAnalytics?: Maybe<ChatRoomAnalytics>;
  chatRooms: PaginatedChatRooms;
  /** @deprecated Deprecated, please use communityUserSearch which has totalUsers count */
  communityUserDirectory: Array<UserField>;
  communityUserSearch: UserDirectoryResult;
  completedEvents?: Maybe<CompletedEventsOverview>;
  conversationContext?: Maybe<Array<Maybe<ConversationContextField>>>;
  /** @deprecated Do not use query. See implementation for more details. */
  conversationInboxDoNotUse: Array<ConversationInbox>;
  conversationStats?: Maybe<Array<Maybe<TrendingTopicsField>>>;
  country?: Maybe<CountryField>;
  crmApplicationFields?: Maybe<Array<Maybe<ApplicationField>>>;
  crmAttributes?: Maybe<Array<Maybe<CrmAttributeField>>>;
  crmDateFormats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  crmIntegration?: Maybe<CrmIntegrationField>;
  crmServiceUniversityConfig?: Maybe<CrmServiceUniversityConfig>;
  crmSyncJob?: Maybe<CrmSyncJobField>;
  currentUserDecisionStage: CurrentDecisionStageOutput;
  degreeCategories?: Maybe<Array<Maybe<DegreeCategoryField>>>;
  degreeCategoriesCount?: Maybe<Scalars['Int']['output']>;
  degreeCategory?: Maybe<DegreeCategoryField>;
  discoverableUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  domesticRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  enrolledInsightsByCommunity: EnrolledInsightResponse;
  enterpriseAddOns?: Maybe<Array<Maybe<EnterpriseAddOns>>>;
  enterpriseDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  enterpriseMentorCount?: Maybe<Scalars['Int']['output']>;
  eventAnalytics: Analytics;
  eventPage?: Maybe<EventPage>;
  eventPages: PaginatedEventPages;
  exampleGraphQLQuery: Scalars['Boolean']['output'];
  exportTimesheetReport?: Maybe<ExportTimeSheetDataField>;
  externalContent?: Maybe<ExternalContent>;
  externalContents: PaginatedExternalContents;
  externalEvent?: Maybe<ExternalEventField>;
  externalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  filterUsersEnterprise?: Maybe<Array<Maybe<UserCustomAttributesFilterField>>>;
  getAssistantConversation?: Maybe<AssistantConversationHistory>;
  getChatConversation: ChatConversation;
  getChatConversationFromLegacyId?: Maybe<ChatConversation>;
  getChatConversationInbox: Array<ChatConversation>;
  getChatConversationMessages: PaginatedChatMessages;
  getChatConversationsForUser: Array<ChatConversation>;
  /** @deprecated Deprecated, please use getCommunityConversations */
  getChatGroupsForCommunity: Array<CommunityChatGroup>;
  /** Get chat reports for a university based on product (currently supports community and virtualEvent). The query is available to only university users and admins. */
  getChatReports: Array<ChatReport>;
  /** Paginated query to get community chat members */
  getCommunityChatMembers: Array<UserField>;
  /** This differs from the getChatConversation resolver in that it checks for the ReadCommunity permissions instead of ReadConversation permissions. */
  getCommunityConversation: ChatConversation;
  getCommunityConversations: Array<ChatConversation>;
  getCommunityForUniOrAdmin: Community;
  getCommunityForUser: Community;
  getCommunityMembers: Array<UserField>;
  getCommunityTemplates: Array<Array<Scalars['String']['output']>>;
  getConversationPermission: ChatPermission;
  getExperimentalTodos: Scalars['String']['output'];
  getGeckoUniversityId?: Maybe<GeckoUniversityData>;
  getIdpToken?: Maybe<AuthField>;
  getInterests: Array<Interest>;
  getInterestsForUser: Array<UserInterest>;
  getInviteFromId: Invite;
  getInviteInformation: InviteInformation;
  getInviteLinkInfo: InviteLinkInfoDto;
  getInvitesForCommunity: Array<CommunityInvites>;
  getInvitesForEmail: Array<GetInvitesForEmailDto>;
  getLabels: Array<Labels>;
  getLiveEventsById?: Maybe<Array<Maybe<LiveEventField>>>;
  /** @deprecated This query has now been deprecated, please use getChatConversationMessages */
  getMessagesForChatConversation: Array<ChatMessage>;
  getOrCreateBotChatGroup?: Maybe<ChatGroupField>;
  getOrCreateChatGroup?: Maybe<ChatGroupField>;
  getOrCreateCommunitiesForInstitution: Array<Community>;
  getOrCreateUniversityChatGroup?: Maybe<ChatGroupAndMessages>;
  getRandomAmbassadors?: Maybe<Array<AmbassadorProfileInformation>>;
  getRecommendedConversations: Array<ChatConversation>;
  getRecommendedUsers: UserRecommendation;
  getRecording?: Maybe<RecordingDownloadResponse>;
  getRecordingFailuresByChannelId: GetRecordingFailureIdsResponse;
  getRecordingFailuresByEventId: GetRecordingFailureIdsResponse;
  getRecordingList?: Maybe<RecordingListResponse>;
  getRecordingUploadingCount: RecordingUploadingResponse;
  getTodosForUniversity: Array<TodosEntity>;
  getTodosForUser: Array<TodosEntity>;
  getToken?: Maybe<AuthField>;
  getTokenForEnterpriseView?: Maybe<AuthField>;
  /** Gets all universities which pass the feature flag check via launch darkly based on universitySlug. */
  getUniversitiesByFeatureFlag: FeatureRulesDto;
  getUniversityAssistantConfig?: Maybe<UniversityAssistantConfiguration>;
  getUser?: Maybe<UserField>;
  getUserByEmail?: Maybe<UserField>;
  getUserByIds?: Maybe<Array<Maybe<UserField>>>;
  getUserProfile: UserProfile;
  /** Get user reports for a university based on product (currently supports community and virtualEvent). The query is available to only university users and admins. */
  getUserReports: Array<UserReport>;
  getUsersCommunityConversations: Array<ChatConversation>;
  getUsersCommunityPrivateConversations: Array<ChatConversation>;
  getVideoContent: VideoContent;
  globalAlerts?: Maybe<Array<Maybe<AlertField>>>;
  hasContent: UniversityContent;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  helloCommunityService: Scalars['String']['output'];
  hobsonsConnectIntegration?: Maybe<CampusManagementConnectIntegrationField>;
  inboxPromptQuestionByQuestionId: InboxPromptQuestion;
  inboxPromptQuestions: Array<InboxPromptQuestion>;
  interventionMessageList?: Maybe<Array<Maybe<InterventionMessageField>>>;
  /** Health check resolver for moderation-service */
  isModerationHealthy: Scalars['Boolean']['output'];
  isProspectGuidanceHealthy: Scalars['Boolean']['output'];
  isUserInDirectMessages?: Maybe<Scalars['Boolean']['output']>;
  isUserProfilingHealthy: Scalars['Boolean']['output'];
  isVideoContentHealthy: Scalars['Boolean']['output'];
  latestExportedReport?: Maybe<ExportedReportField>;
  listAdminRecommendationResourceTypes: Array<RecommendationResourceType>;
  listAdminRecommendations: PaginatedAdminRecommendation;
  listArchivedCommunitiesForAnInstitution: Array<Community>;
  listBuddyApplicantConversations?: Maybe<ListBuddyApplicantConversationsField>;
  listCommunitiesForAnInstitution: Array<Community>;
  listMentorApplicantConversations?: Maybe<ListMentorApplicantConversationsField>;
  listUniversityAssistantConversations?: Maybe<ListUniversityAssistantConversationsOutput>;
  listUniversityKnowledgeBaseSources: Array<KnowledgeBaseEmbedding>;
  listUniversityKnowledgeBaseSourcesByUrlPattern: Array<KnowledgeBaseSourcesByUrl>;
  liveEvent?: Maybe<LiveEventField>;
  liveEventLandingPage?: Maybe<LiveEventLandingPageField>;
  liveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  liveFeed?: Maybe<LiveEventChatGroupField>;
  liveSession?: Maybe<LiveSession>;
  liveSessions: PaginatedLiveSessions;
  marketplace?: Maybe<MarketplaceField>;
  marketplaceApplicantChatGroupsCount?: Maybe<Scalars['Int']['output']>;
  marketplaceApplicantCountries?: Maybe<MarketplaceApplicantCountries>;
  marketplaceApplicantDegreeCategories?: Maybe<MarketplaceApplicantDegreeCategories>;
  marketplaceApplicantsCount?: Maybe<Scalars['Int']['output']>;
  marketplaceInbox?: Maybe<MarketplaceInboxField>;
  marketplaceMentorCountries?: Maybe<Array<Maybe<CountryField>>>;
  marketplaceMentorDegreeCategories?: Maybe<Array<Maybe<UniversityField>>>;
  marketplaceMentorList?: Maybe<MarketplaceMentorList>;
  marketplaceMentorRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  marketplaceMentorUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  marketplaceSnippets?: Maybe<MarketplaceSnippetField>;
  marketplaceUniversitiesSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketplaceUniversityCountries?: Maybe<Array<Maybe<CountryField>>>;
  marketplaceUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  marketplaces?: Maybe<Array<Maybe<MarketplaceField>>>;
  marketplacesCount?: Maybe<Scalars['Int']['output']>;
  me?: Maybe<MeField>;
  memberOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  mentorApplicantChatGroupCount?: Maybe<Scalars['Int']['output']>;
  mentorApplicantChatGroups?: Maybe<Array<Maybe<MentorApplicantChatGroupField>>>;
  mentorCount?: Maybe<Scalars['Int']['output']>;
  mentorInbox?: Maybe<MentorInboxField>;
  mentorInterests?: Maybe<Array<Maybe<MentorInterestField>>>;
  mentorIntroMessage?: Maybe<MentorIntroMessageField>;
  mentorInvite?: Maybe<MentorInviteField>;
  mentorInviteCount?: Maybe<MentorInviteCountField>;
  mentorList?: Maybe<MentorListField>;
  mentorModules?: Maybe<Array<Maybe<MentorModuleField>>>;
  mentorPosts?: Maybe<Array<Maybe<BlogPostField>>>;
  mentorResponseTime?: Maybe<Array<Maybe<AnalyticsMentorField>>>;
  mentorSocieties?: Maybe<Array<Maybe<MentorSocietyField>>>;
  mentorTimeSpent?: Maybe<Array<Maybe<AnalyticsMentorField>>>;
  messages?: Maybe<ChatGroupAndMessages>;
  myAgenda: PaginatedLiveSessions;
  myBlogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  myLiveEventDirectMessaging?: Maybe<LiveEventDirectMessaging>;
  myLiveEventFeeds?: Maybe<Array<Maybe<LiveEventChatGroupField>>>;
  myRegisteredEvents?: Maybe<Array<Maybe<LiveEventDetailsField>>>;
  myUniversityDegrees?: Maybe<Array<Maybe<DegreeField>>>;
  myUniversityLink?: Maybe<ApplicantUniversityLinkField>;
  offsetId?: Maybe<Scalars['String']['output']>;
  openDay?: Maybe<OpenDayField>;
  openDays?: Maybe<Array<Maybe<OpenDayField>>>;
  openDaysWithViewFilter?: Maybe<Array<Maybe<OpenDayField>>>;
  organisation?: Maybe<OrganisationField>;
  organisations?: Maybe<Array<Maybe<OrganisationField>>>;
  outbox?: Maybe<Array<Maybe<OutboxChatGroupField>>>;
  outboxCount?: Maybe<Scalars['Int']['output']>;
  pageMentors?: Maybe<PageMentorField>;
  paginatedApplicantInvites?: Maybe<PaginatedApplicantInvite>;
  pingUserDirectory: Scalars['String']['output'];
  popularSession?: Maybe<SessionAnalytics>;
  post?: Maybe<BlogPostField>;
  prospectChatSummary?: Maybe<ChatSummaryField>;
  prospectChatSummaryV2?: Maybe<ChatSummaryField>;
  prospectStageStats?: Maybe<ProspectStageSummaryField>;
  publicLiveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  publicMentor?: Maybe<PublicMentorField>;
  publicMentorIntroMessage?: Maybe<MentorIntroMessageField>;
  publicStaffCount?: Maybe<Scalars['Int']['output']>;
  publicUser?: Maybe<PublicUserField>;
  qssQuestions?: Maybe<Array<Maybe<QuestionField>>>;
  queryRecording: QueryRecordingResponse;
  queryUniversityIndexing?: Maybe<UniversityScrapeIndexingOutput>;
  randomBuddy?: Maybe<BuddyField>;
  randomDefaultQuestions?: Maybe<Array<Maybe<DefaultQuestionsField>>>;
  randomMentor?: Maybe<PublicMentorField>;
  randomMentorsList?: Maybe<RandomMentorsListField>;
  requestedPublicGroups: Array<RequestedPublicGroup>;
  researchTime?: Maybe<ResearchTimeResult>;
  researchTimeLog?: Maybe<Array<Maybe<ResearchTimeLogResult>>>;
  searchUniversityKnowledgeBase: Array<SearchResult>;
  sequenceFilterMentorList?: Maybe<SequenceFilterMentorListField>;
  serverTime?: Maybe<Scalars['String']['output']>;
  signupsOverTime?: Maybe<ApplicantSignupStats>;
  singleInstanceOrganisations?: Maybe<Array<Maybe<OrganisationField>>>;
  staffContactByUniversityId?: Maybe<StaffContactOutput>;
  subTopic?: Maybe<SubTopicField>;
  subTopics?: Maybe<Array<Maybe<SubTopicField>>>;
  switchUniversities?: Maybe<SwitchUniversitiesField>;
  tag?: Maybe<TagField>;
  tags?: Maybe<Array<Maybe<TagField>>>;
  timeTaken?: Maybe<TimeTakenField>;
  topCountries?: Maybe<Array<Maybe<TopCountryField>>>;
  topDegrees?: Maybe<Array<Maybe<TopDegreeField>>>;
  topDomesticRegions?: Maybe<Array<Maybe<TopDomesticRegionField>>>;
  topSignupsByCountry?: Maybe<Array<Maybe<CountryStatField>>>;
  topSignupsByDegree?: Maybe<Array<Maybe<DegreeStatField>>>;
  topSignupsByState?: Maybe<Array<Maybe<StateStatField>>>;
  topic?: Maybe<TopicField>;
  topicStatistics?: Maybe<Array<Maybe<InsightsField>>>;
  topics?: Maybe<Array<Maybe<TopicField>>>;
  totalSignups?: Maybe<SignUpsCount>;
  triggerDegreeExport?: Maybe<Scalars['String']['output']>;
  triggerMentorExport?: Maybe<Scalars['String']['output']>;
  triggerProspectExportEmail?: Maybe<Scalars['String']['output']>;
  triggerReportExport?: Maybe<Scalars['String']['output']>;
  triggerTopicStatisticsExport?: Maybe<Scalars['String']['output']>;
  uniApplicantSignUps?: Maybe<GraphField>;
  uniApplicantSignUpsBenchmark?: Maybe<GraphField>;
  uniChatGroups?: Maybe<GraphField>;
  uniChatGroupsBenchmark?: Maybe<GraphField>;
  uniConversionRate?: Maybe<GraphField>;
  uniConversionRateBenchmark?: Maybe<GraphField>;
  uniMessages?: Maybe<ChatGroupAndMessages>;
  uniMessagesPerChatGroup?: Maybe<GraphField>;
  uniResponseTime?: Maybe<GraphField>;
  uniResponseTimeBenchmark?: Maybe<GraphField>;
  uniSentences?: Maybe<GraphField>;
  uniSentencesBenchmark?: Maybe<GraphField>;
  uniSentencesPerChatGroup?: Maybe<GraphField>;
  uniSentencesPerChatGroupBenchmark?: Maybe<GraphField>;
  uniTimeSpent?: Maybe<GraphField>;
  uniTimeSpentBenchmark?: Maybe<GraphField>;
  uniUniqueVisits?: Maybe<GraphField>;
  uniUniqueVisitsBenchmark?: Maybe<GraphField>;
  university?: Maybe<UniversityField>;
  universityAdmins?: Maybe<Array<Maybe<UniversityUserField>>>;
  universityAlerts?: Maybe<Array<Maybe<AlertField>>>;
  universityBlockReports?: Maybe<Array<Maybe<UniversityBlockReportField>>>;
  universityBlockReportsCount?: Maybe<Scalars['Int']['output']>;
  universityBlogPosts?: Maybe<UniversityBlogPostsField>;
  universityBlogPostsCount?: Maybe<Scalars['Int']['output']>;
  universityBlogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
  universityInbox?: Maybe<UniversityInboxField>;
  universityMentor?: Maybe<MentorField>;
  universityQuestionById: UniversityQuestion;
  universityQuestions: Array<UniversityQuestion>;
  universitySnippets?: Maybe<UniversitySnippetField>;
  universityUsers?: Maybe<Array<Maybe<UniversityUserField>>>;
  unreadCount?: Maybe<UnreadCountField>;
  upcomingExternalEvents?: Maybe<Array<Maybe<ExternalEventField>>>;
  upcomingLiveEvents?: Maybe<Array<Maybe<LiveEventField>>>;
  userChatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
  userPartialSearch?: Maybe<Array<Maybe<UserCustomAttributesFilterField>>>;
  userPartialSearchMultipleFields?: Maybe<Array<Maybe<UserPartialSearchFields>>>;
  userPermissions?: Maybe<UserPermissionsListField>;
  userTimeSpentBreakdown?: Maybe<UserTimeSpentBreakdown>;
  userUnreadMessageCount?: Maybe<UnreadMessageCountField>;
  verifyCode?: Maybe<VerifyCodeField>;
  virtualEvent?: Maybe<VirtualEvent>;
  virtualEventAttendees: Array<UserField>;
  virtualEventProspectReport?: Maybe<ReportAnalytics>;
  virtualEvents: PaginatedVirtualEvents;
  virtualEventsByUniversityIds: PaginatedVirtualEvents;
};


export type QueryAdminMentorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminRecommendationCountPerDecisionStageArgs = {
  universityId: Scalars['ObjectId']['input'];
};


export type QueryAdminSearchMentorsArgs = {
  propName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgendaArgs = {
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  pagination: PaginationInput;
  rangeDate?: InputMaybe<RangeDateInput>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryAlertArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAdminApplicantsArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantConversationsArgs = {
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantCountArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantSignUpsArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllApplicantsArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllBuddyInvitesArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  roleSelected?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllChatGroupCountArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllChatGroupsByDayArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllContentBriefsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDegreeLevelsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllDegreesArgs = {
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeType?: InputMaybe<Array<InputMaybe<DegreeType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllHighSchoolsArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorInvitesArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllMentorsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorsOfEnterpriseArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllMentorsTimeSpentArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPostsArgs = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPostsInfoArgs = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  randomise?: InputMaybe<Scalars['Boolean']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStaffArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSubCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  inputRegion?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllSubRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  inputRegion?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopDegreesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTopRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUniversitiesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUserIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUsersWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUsersWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllYearOfStudyArgs = {
  degreeLevelId?: InputMaybe<Scalars['String']['input']>;
  degreeLevelName?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryAppLocalesArgs = {
  appName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantCollectionFieldsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantCountArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryApplicantInboxArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantInvitesArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryApplicantSignUpsArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApplicantsAppliedArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApplicantsMessagedArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApplicationInsightsArgs = {
  paginatedApplicantInsightInput: PaginatedApplicantInsightInput;
  pagination: GraphQlOffsetPaginationInput;
};


export type QueryAppliedUsersCountArgs = {
  appliedUsersCountInput: AppliedUsersCountInput;
};


export type QueryAskQuestionArgs = {
  question: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
};


export type QueryAvailableDegreeTypesArgs = {
  universitySlug: Scalars['String']['input'];
};


export type QueryBlogTopicsArgs = {
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBotUserArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddiesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customAttributesFilters?: InputMaybe<Array<InputMaybe<CustomAttributesFilterInputField>>>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  randomizeListSeed?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  useRandomizeStaffFeature?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddiesFilterOptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<InputMaybe<BuddiesListFilterInput>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddyArgs = {
  id: Scalars['String']['input'];
};


export type QueryBuddyApplicantChatGroupCountArgs = {
  buddyId?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatGroupsArgs = {
  buddyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatInterventionArgs = {
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyApplicantChatInterventionTotalCountArgs = {
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBuddyInviteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuddyResponseTimeArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanonicalQuestionsArgs = {
  subTopics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  opponentId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupAuxArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupByIdArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupCountArgs = {
  per?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatGroupLabellingCandidatesArgs = {
  chatGroupId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  topicLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatGroupSuggestionsArgs = {
  chatGroupId: Scalars['String']['input'];
};


export type QueryChatGroupsByDayArgs = {
  day?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatInterventionMentorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatRoomArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryChatRoomAnalyticsArgs = {
  chatRoomId: Scalars['ObjectId']['input'];
};


export type QueryChatRoomsArgs = {
  pagination: PaginationInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryCommunityUserDirectoryArgs = {
  filterUsersDTO: FilterUsersDto;
  pagination: OffsetPagination;
};


export type QueryCommunityUserSearchArgs = {
  filterUsersDTO: FilterUsersDto;
  pagination: OffsetPagination;
};


export type QueryCompletedEventsArgs = {
  endDate: Scalars['DateTime']['input'];
  filterByName?: InputMaybe<Scalars['String']['input']>;
  filterByType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryConversationContextArgs = {
  endDate: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  subGroupById?: InputMaybe<Scalars['String']['input']>;
  subTopic: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


export type QueryConversationStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountryArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmAttributesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmIntegrationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmServiceUniversityConfigArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmSyncJobArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentUserDecisionStageArgs = {
  currentUserDecisionStageQueryInput: CurrentUserDecisionStageQueryInput;
};


export type QueryDegreeCategoriesArgs = {
  categoryType?: InputMaybe<Scalars['String']['input']>;
  hierarchyRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDegreeCategoriesCountArgs = {
  categoryType?: InputMaybe<Scalars['String']['input']>;
  hierarchyRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDegreeCategoryArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscoverableUniversitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  randomizeSeed?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDomesticRegionsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnrolledInsightsByCommunityArgs = {
  enrolledInsightsInput: EnrolledInsightsInput;
};


export type QueryEnterpriseDegreesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnterpriseMentorCountArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventAnalyticsArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryEventPageArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryEventPagesArgs = {
  pagination: PaginationInput;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryExportTimesheetReportArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalContentArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryExternalContentsArgs = {
  eventPageId?: InputMaybe<Scalars['ObjectId']['input']>;
  pagination: PaginationInput;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryExternalEventArgs = {
  externalEventId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalEventsArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterUsersEnterpriseArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAssistantConversationArgs = {
  getAssistantConversationInput: GetAssistantConversationInput;
};


export type QueryGetChatConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetChatConversationFromLegacyIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetChatConversationInboxArgs = {
  ChatConversationInboxInputDto: ChatConversationInboxInputDto;
};


export type QueryGetChatConversationMessagesArgs = {
  getMessageDto: GetMessageDto;
};


export type QueryGetChatConversationsForUserArgs = {
  offsetPagination?: InputMaybe<OffsetPaginationDto>;
};


export type QueryGetChatGroupsForCommunityArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetChatReportsArgs = {
  getChatReportsDTO: GetChatReportsDto;
};


export type QueryGetCommunityChatMembersArgs = {
  conversationId: Scalars['String']['input'];
  offsetPagination: OffsetPagination;
};


export type QueryGetCommunityConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCommunityConversationsArgs = {
  communityId: Scalars['String']['input'];
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityForUniOrAdminArgs = {
  communityId: Scalars['String']['input'];
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCommunityForUserArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetCommunityMembersArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetConversationPermissionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGeckoUniversityIdArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetIdpTokenArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  idpToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInviteFromIdArgs = {
  inviteId: Scalars['String']['input'];
};


export type QueryGetInviteInformationArgs = {
  InviteInformationInput: InviteInformationInput;
};


export type QueryGetInviteLinkInfoArgs = {
  inviteLinkId: Scalars['String']['input'];
};


export type QueryGetInvitesForCommunityArgs = {
  communityId: Scalars['String']['input'];
  filters: InviteFilter;
  retrieveArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvitesForEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetLiveEventsByIdArgs = {
  liveEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMessagesForChatConversationArgs = {
  getMessageDto: GetMessageDto;
};


export type QueryGetOrCreateBotChatGroupArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrCreateChatGroupArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  opponentId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrCreateCommunitiesForInstitutionArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetOrCreateUniversityChatGroupArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRandomAmbassadorsArgs = {
  getRandomAmbassadorsInput: GetRandomAmbassadorsInput;
};


export type QueryGetRecommendedConversationsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetRecommendedUsersArgs = {
  communityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchingCriterion?: InputMaybe<MatchingCriteriaEnum>;
  pagination?: InputMaybe<OffsetPagination>;
};


export type QueryGetRecordingArgs = {
  path: Scalars['String']['input'];
};


export type QueryGetRecordingFailuresByChannelIdArgs = {
  data: GetRecordingFailureIdsArgs;
};


export type QueryGetRecordingFailuresByEventIdArgs = {
  data: GetRecordingFailureIdsArgs;
};


export type QueryGetRecordingListArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecordingUploadingCountArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};


export type QueryGetTodosForUniversityArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  notificationToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTokenForEnterpriseViewArgs = {
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUniversitiesByFeatureFlagArgs = {
  featureFlag: Scalars['String']['input'];
};


export type QueryGetUniversityAssistantConfigArgs = {
  universityId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserByIdsArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  prospectWelcomeMessage?: InputMaybe<Scalars['String']['input']>;
  smudged?: InputMaybe<Scalars['Boolean']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserReportsArgs = {
  getUserReportsDTO: GetUserReportsDto;
};


export type QueryGetUsersCommunityConversationsArgs = {
  communityId: Scalars['String']['input'];
  offsetPagination?: InputMaybe<OffsetPagination>;
};


export type QueryGetUsersCommunityPrivateConversationsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGlobalAlertsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHasContentArgs = {
  universityContentInput: UniversityContentInput;
};


export type QueryHelloCommunityServiceArgs = {
  throwError?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHobsonsConnectIntegrationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInboxPromptQuestionByQuestionIdArgs = {
  questionId: Scalars['ObjectId']['input'];
};


export type QueryInboxPromptQuestionsArgs = {
  inboxPromptInput: InboxPromptInput;
};


export type QueryInterventionMessageListArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsUserInDirectMessagesArgs = {
  liveEventSlug: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryLatestExportedReportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  openDayId?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAdminRecommendationsArgs = {
  listAdminRecommendationInput: ListAdminRecommendationInput;
  pagination: GraphQlOffsetPaginationInput;
};


export type QueryListArchivedCommunitiesForAnInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryListBuddyApplicantConversationsArgs = {
  activeBuddies?: InputMaybe<Scalars['Boolean']['input']>;
  buddyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCommunitiesForAnInstitutionArgs = {
  institutionId: Scalars['String']['input'];
};


export type QueryListMentorApplicantConversationsArgs = {
  activeMentors?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  mentorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUniversityAssistantConversationsArgs = {
  listUniversityAssistantConversationsInput: ListUniversityAssistantConversationsInput;
};


export type QueryListUniversityKnowledgeBaseSourcesArgs = {
  knowledgeBaseSourceQueryInput: KnowledgeBaseSourceQueryInput;
};


export type QueryListUniversityKnowledgeBaseSourcesByUrlPatternArgs = {
  knowledgeBaseSourcesListInput: KnowledgeBaseSourcesListInput;
};


export type QueryLiveEventArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveEventLandingPageArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveEventsArgs = {
  viewFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveFeedArgs = {
  liveFeedId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveSessionArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryLiveSessionsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  eventPageId?: InputMaybe<Scalars['ObjectId']['input']>;
  orderBy?: InputMaybe<OrderByLiveSessionsInput>;
  pagination: PaginationInput;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryMarketplaceArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceApplicantChatGroupsCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceApplicantCountriesArgs = {
  createdAfter?: InputMaybe<Scalars['IsoDateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['IsoDateTime']['input']>;
  degreeCategoryFilter?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug: Scalars['String']['input'];
};


export type QueryMarketplaceApplicantDegreeCategoriesArgs = {
  countryFilter?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['IsoDateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['IsoDateTime']['input']>;
  marketplaceSlug: Scalars['String']['input'];
};


export type QueryMarketplaceApplicantsCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceInboxArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorCountriesArgs = {
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorDegreeCategoriesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryRank?: InputMaybe<Scalars['Int']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  parentDegreeCategory?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorListArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySeed?: InputMaybe<Scalars['Int']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorRegionsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceMentorUniversitiesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  domesticRegion?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityCountry?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceSnippetsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUniversitiesSlugsArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUniversityCountriesArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryId?: InputMaybe<Scalars['String']['input']>;
  degreeCategoryType?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceUnreadMessageCountArgs = {
  marketplaceSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplacesArgs = {
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketplacesCountArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorApplicantChatGroupCountArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMentorApplicantChatGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unanswered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMentorCountArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorInboxArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
};


export type QueryMentorInterestsArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorIntroMessageArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorInviteArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorInviteCountArgs = {
  accepted?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorListArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  filterIncompleteProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  mentorId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorModulesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorPostsArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorResponseTimeArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorSocietiesArgs = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMentorTimeSpentArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagesArgs = {
  allowDelinked?: InputMaybe<Scalars['Boolean']['input']>;
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offsetId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyAgendaArgs = {
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  filterBySavedSessions?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  rangeDate?: InputMaybe<RangeDateInput>;
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryMyLiveEventDirectMessagingArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyLiveEventFeedsArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  liveEventSlug?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyUniversityDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyUniversityLinkArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDayArgs = {
  openDayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDaysArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenDaysWithViewFilterArgs = {
  viewFilter: Scalars['String']['input'];
};


export type QueryOrganisationArgs = {
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  organisationType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutboxArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageMentorsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lifecycleStatus?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  uniId?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaginatedApplicantInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  universityId: Scalars['String']['input'];
};


export type QueryPopularSessionArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectChatSummaryArgs = {
  prospectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProspectChatSummaryV2Args = {
  prospectId: Scalars['String']['input'];
};


export type QueryProspectStageStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPublicLiveEventsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicMentorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicMentorIntroMessageArgs = {
  mentorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicStaffCountArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryRecordingArgs = {
  data: QueryRecordingArgs;
};


export type QueryQueryUniversityIndexingArgs = {
  UniversityScrapeIndexingQueryInput: UniversityScrapeIndexingQueryInput;
};


export type QueryRandomBuddyArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  staffFields?: InputMaybe<Scalars['JSONString']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRandomDefaultQuestionsArgs = {
  limit: Scalars['LimitedInt']['input'];
  mentor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRandomMentorArgs = {
  degreeId?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  sameCountryAsUniversity?: InputMaybe<Scalars['Boolean']['input']>;
  universitySlug: Scalars['String']['input'];
};


export type QueryRandomMentorsListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  universitySlug: Scalars['String']['input'];
};


export type QueryRequestedPublicGroupsArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryResearchTimeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResearchTimeLogArgs = {
  fromTime?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUniversityKnowledgeBaseArgs = {
  limit: Scalars['Float']['input'];
  searchTerm: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};


export type QuerySequenceFilterMentorListArgs = {
  ambassadorSearch?: InputMaybe<Scalars['String']['input']>;
  applyDegreeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  degreeTypesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  domesticOrInternational?: InputMaybe<DomesticOrInternational>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  sequenceFilter?: InputMaybe<Array<InputMaybe<MentorFilterInputField>>>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySignupsOverTimeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySingleInstanceOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaffContactByUniversityIdArgs = {
  staffContactByUniversityIdInput: StaffContactByUniversityIdInput;
};


export type QuerySubTopicsArgs = {
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTimeTakenArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopCountriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopDegreesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopDomesticRegionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopSignupsByCountryArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopSignupsByDegreeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopSignupsByStateArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  topX?: InputMaybe<Scalars['Int']['input']>;
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTopicArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicStatisticsArgs = {
  dateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTotalSignupsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  universityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTriggerDegreeExportArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerMentorExportArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  degreeLevel?: InputMaybe<Scalars['String']['input']>;
  degreeName?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onlyMentorsWithUnreads?: InputMaybe<Scalars['Boolean']['input']>;
  reportType?: InputMaybe<Scalars['String']['input']>;
  staffRole?: InputMaybe<Scalars['String']['input']>;
  timeSpentFromDate?: InputMaybe<Scalars['String']['input']>;
  timeSpentToDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerProspectExportEmailArgs = {
  includeSmudged?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  updatedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  updatedTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTriggerReportExportArgs = {
  liveEventId?: InputMaybe<Scalars['String']['input']>;
  openDayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTriggerTopicStatisticsExportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryUniApplicantSignUpsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniApplicantSignUpsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniChatGroupsArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniChatGroupsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniConversionRateArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniConversionRateBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniMessagesArgs = {
  chatGroupId?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniMessagesPerChatGroupArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniResponseTimeArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniResponseTimeBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesArgs = {
  groupType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesPerChatGroupArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniSentencesPerChatGroupBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniTimeSpentArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniTimeSpentBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniUniqueVisitsArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniUniqueVisitsBenchmarkArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityAlertsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  universityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityBlockReportsArgs = {
  itemsPerPage?: InputMaybe<Scalars['LimitedInt']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  resolved?: InputMaybe<ResolvedEnum>;
  triggeredFrom?: InputMaybe<TriggeredFromEnum>;
};


export type QueryUniversityBlockReportsCountArgs = {
  resolved?: InputMaybe<ResolvedEnum>;
  triggeredFrom?: InputMaybe<TriggeredFromEnum>;
};


export type QueryUniversityBlogPostsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  safeLimit?: InputMaybe<Scalars['LimitedInt']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUniversityBlogPostsCountArgs = {
  status?: InputMaybe<BlogStatus>;
};


export type QueryUniversityInboxArgs = {
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUniversityMentorArgs = {
  id: Scalars['String']['input'];
};


export type QueryUniversityQuestionByIdArgs = {
  universityQuestionByIdInput: UniversityQuestionByIdInput;
};


export type QueryUniversityQuestionsArgs = {
  universityQuestionInput: UniversityQuestionInput;
};


export type QueryUniversitySnippetsArgs = {
  popCardAlign?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUniversityUsersArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingExternalEventsArgs = {
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingLiveEventsArgs = {
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserChatGroupsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPartialSearchArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPartialSearchMultipleFieldsArgs = {
  accountRole?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTimeSpentBreakdownArgs = {
  fromTime?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifyCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVirtualEventArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventAttendeesArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventProspectReportArgs = {
  virtualEventId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  pagination: PaginationInput;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  universityId: Scalars['ObjectId']['input'];
};


export type QueryVirtualEventsByUniversityIdsArgs = {
  endAfter?: InputMaybe<Scalars['DateTime']['input']>;
  endBefore?: InputMaybe<Scalars['DateTime']['input']>;
  pagination: PaginationInput;
  startAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startBefore?: InputMaybe<Scalars['DateTime']['input']>;
  universityIds: Array<Scalars['ObjectId']['input']>;
};

export type QueryRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type QueryRecordingResponse = {
  __typename?: 'QueryRecordingResponse';
  recording?: Maybe<RecordingModel>;
};

export type QuestionField = {
  __typename?: 'QuestionField';
  questionId?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type RandomMentorsListField = {
  __typename?: 'RandomMentorsListField';
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
};

export type RangeDateInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Reaction = {
  __typename?: 'Reaction';
  reaction: Scalars['String']['output'];
  reactionUnicode: Scalars['String']['output'];
  userIds: Array<Scalars['String']['output']>;
};

export type ReactionDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  reaction: Scalars['String']['input'];
  reactionUnicode: Scalars['String']['input'];
};

export type ReadChatMutation = {
  __typename?: 'ReadChatMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  batchId: Scalars['ObjectId']['output'];
  contentId: Scalars['ObjectId']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  source: RecommendationSource;
  title: Scalars['String']['output'];
  type: RecommendationResourceTypeEnum;
  url: Scalars['String']['output'];
};

export type RecommendationResourceType = {
  __typename?: 'RecommendationResourceType';
  displayName: Scalars['String']['output'];
  name: RecommendationResourceTypeEnum;
};

export enum RecommendationResourceTypeEnum {
  Ambassador = 'AMBASSADOR',
  Article = 'ARTICLE',
  Blog = 'BLOG',
  Community = 'COMMUNITY',
  Event = 'EVENT',
  InPersonEvent = 'IN_PERSON_EVENT',
  Newsletter = 'NEWSLETTER',
  Other = 'OTHER',
  UniversityWebpage = 'UNIVERSITY_WEBPAGE',
  Video = 'VIDEO'
}

export enum RecommendationSource {
  Admin = 'ADMIN',
  ApiRandom = 'API_RANDOM'
}

export type RecordUserActivityMutation = {
  __typename?: 'RecordUserActivityMutation';
  newActivity?: Maybe<ActivityField>;
};

export type RecordingConsent = {
  __typename?: 'RecordingConsent';
  channelId: Scalars['ObjectId']['output'];
  id: Scalars['ObjectId']['output'];
  time: Scalars['DateTime']['output'];
  universityId: Scalars['ObjectId']['output'];
};

export type RecordingDownloadResponse = {
  __typename?: 'RecordingDownloadResponse';
  url: Scalars['String']['output'];
};

export type RecordingFailureArgs = {
  channelId: Scalars['ObjectId']['input'];
  eventId: Scalars['ObjectId']['input'];
};

export type RecordingFailureId = {
  __typename?: 'RecordingFailureId';
  id: Scalars['ObjectId']['output'];
};

export type RecordingFailureResponse = {
  __typename?: 'RecordingFailureResponse';
  success: Scalars['Boolean']['output'];
};

export type RecordingListResponse = {
  __typename?: 'RecordingListResponse';
  files: Array<VideoFile>;
};

export type RecordingModel = {
  __typename?: 'RecordingModel';
  channelId: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectId']['output'];
  layoutMode: Scalars['Float']['output'];
  layoutStatus: Scalars['String']['output'];
  recordingStatus: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type RecordingResponse = {
  __typename?: 'RecordingResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecordingUploadingResponse = {
  __typename?: 'RecordingUploadingResponse';
  count: Scalars['Float']['output'];
};

export type RegisterToLiveEvent = {
  __typename?: 'RegisterToLiveEvent';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectRequestedPublicGroupInput = {
  id: Scalars['String']['input'];
};

export type RemoveApplicantInsightInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
};

export type RemoveBuddyInvitesMutation = {
  __typename?: 'RemoveBuddyInvitesMutation';
  successfulInvites?: Maybe<Array<Maybe<BuddyInviteListField>>>;
};

export type RemoveDeviceMutation = {
  __typename?: 'RemoveDeviceMutation';
  result?: Maybe<Scalars['String']['output']>;
};

export type RemoveMembersFromCommunityInputDto = {
  communityId: Scalars['String']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds: Array<Scalars['String']['input']>;
};

export type RemoveMentorInvitesMutation = {
  __typename?: 'RemoveMentorInvitesMutation';
  mentorInvites?: Maybe<Array<Maybe<MentorInviteField>>>;
};

export type ReplyInputField = {
  messageCreated?: InputMaybe<Scalars['DateTime']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  senderAccountRole?: InputMaybe<Scalars['String']['input']>;
  senderFirstName?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};

export type ReplyMessage = {
  __typename?: 'ReplyMessage';
  id: Scalars['ObjectId']['output'];
};

export type ReplyMessageDto = {
  id: Scalars['ObjectId']['input'];
};

export type ReplyOutputField = {
  __typename?: 'ReplyOutputField';
  isSenderBlocked?: Maybe<Scalars['Boolean']['output']>;
  messageCreated?: Maybe<Scalars['DateTime']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  originalMessageText?: Maybe<Scalars['String']['output']>;
  senderAccountRole?: Maybe<Scalars['String']['output']>;
  senderFirstName?: Maybe<Scalars['String']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
};

export type ReportAnalytics = {
  __typename?: 'ReportAnalytics';
  id: Scalars['ObjectId']['output'];
  reportLink?: Maybe<Scalars['String']['output']>;
  reportStatus: Scalars['String']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type RequestAnalyticsExportMutation = {
  __typename?: 'RequestAnalyticsExportMutation';
  error?: Maybe<Scalars['String']['output']>;
};

export type RequestPasswordResetMutation = {
  __typename?: 'RequestPasswordResetMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestPasswordSetMutation = {
  __typename?: 'RequestPasswordSetMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestedPublicGroup = {
  __typename?: 'RequestedPublicGroup';
  community: Community;
  conversation: ChatConversation;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  requestedBy: UserField;
  resolvedBy: UserField;
  status: PublicGroupStatus;
  title: Scalars['String']['output'];
};

export type ResearchTimeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  logDate?: InputMaybe<Scalars['String']['input']>;
  timeSpentSeconds?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  university?: InputMaybe<Scalars['String']['input']>;
};

export type ResearchTimeLogResult = {
  __typename?: 'ResearchTimeLogResult';
  id?: Maybe<Scalars['Int']['output']>;
  timeSpentSeconds?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResearchTimeResult = {
  __typename?: 'ResearchTimeResult';
  description?: Maybe<Scalars['String']['output']>;
  logDate?: Maybe<Scalars['String']['output']>;
  timeSpentSeconds?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordMobileMutation = {
  __typename?: 'ResetPasswordMobileMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordMutationV2 = {
  __typename?: 'ResetPasswordMutationV2';
  error?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResolveMessageDto = {
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type ResolveUniversityChatsMutation = {
  __typename?: 'ResolveUniversityChatsMutation';
  count?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
};

export enum ResolvedEnum {
  All = 'ALL',
  False = 'FALSE',
  True = 'TRUE'
}

export type RichContentDto = {
  attachments?: InputMaybe<Array<AttachmentDto>>;
  giphy?: InputMaybe<GifDto>;
  images?: InputMaybe<Array<ImageDto>>;
  poll?: InputMaybe<PollDto>;
  reply?: InputMaybe<ReplyMessageDto>;
};

export type RichContentInputField = {
  reply?: InputMaybe<ReplyInputField>;
};

export type RichContentOutputField = {
  __typename?: 'RichContentOutputField';
  reply?: Maybe<ReplyOutputField>;
};

export type RichMessageContent = {
  __typename?: 'RichMessageContent';
  attachments?: Maybe<Array<Attachment>>;
  giphy?: Maybe<Giphy>;
  images?: Maybe<Array<Image>>;
  poll?: Maybe<Poll>;
  reply?: Maybe<ChatMessage>;
};

export enum RootUrlEnum {
  AbraUrl = 'ABRA_URL',
  AmbassadorDashboardUrl = 'AMBASSADOR_DASHBOARD_URL',
  CommunityUrl = 'COMMUNITY_URL',
  HorseaUrl = 'HORSEA_URL',
  OnixUrl = 'ONIX_URL',
  RapidashUrl = 'RAPIDASH_URL'
}

export type RunManageCommandMutation = {
  __typename?: 'RunManageCommandMutation';
  output?: Maybe<OutputField>;
};

export type SatisfactionSurveyDto = {
  communityId: Scalars['String']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  universitySlug: Scalars['String']['input'];
};

export type SatisfactionSurveyEntity = {
  __typename?: 'SatisfactionSurveyEntity';
  communityId: Scalars['String']['output'];
  universitySlug: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SaveAppliedUsersInput = {
  /** Date in UTC timezone */
  entryDate: Scalars['DateTime']['input'];
  universityId: Scalars['ObjectId']['input'];
  userIds: Array<Scalars['ObjectId']['input']>;
};

export type SaveAppliedUsersModel = {
  __typename?: 'SaveAppliedUsersModel';
  saved: Scalars['Boolean']['output'];
};

export type SaveAssistantConversationEmailLeadInput = {
  conversationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  ubConsent: Scalars['Boolean']['input'];
  universityId: Scalars['String']['input'];
};

export type SaveAssistantConversationFeedbackInput = {
  /** The conversation to rate */
  conversationId: Scalars['String']['input'];
  /** Rating from 1-5 on the quality of the conversation */
  rating: Scalars['Float']['input'];
  /** Optional free text for the conversation feedback */
  text?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type SaveUniversityQuestionAnswerInput = {
  answers: Array<UniversityQuestionAnswerInputItem>;
  context: UniversityQuestionContextInput;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type SaveVisitedRecommendationInput = {
  batchId: Scalars['ObjectId']['input'];
  contentId: Scalars['ObjectId']['input'];
};

/** Defines scope for the starting point scrape */
export enum ScrapeScope {
  ScopeFull = 'SCOPE_FULL',
  ScopePartial = 'SCOPE_PARTIAL'
}

export enum ScraperJobStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Started = 'STARTED',
  Stopped = 'STOPPED'
}

export enum ScraperTaskStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Skipped = 'SKIPPED',
  Started = 'STARTED'
}

export type SearchResult = {
  __typename?: 'SearchResult';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SendAssistantMessageInput = {
  conversationId: Scalars['String']['input'];
  input: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
};

export type SendCommunityVerificationCode = {
  __typename?: 'SendCommunityVerificationCode';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendFeedMessageMutation = {
  __typename?: 'SendFeedMessageMutation';
  message?: Maybe<MessageField>;
};

export type SendLiveEventMessageMutation = {
  __typename?: 'SendLiveEventMessageMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  message?: Maybe<MessageField>;
};

export type SendMessageMutation = {
  __typename?: 'SendMessageMutation';
  botMessages?: Maybe<Array<Maybe<MessageField>>>;
  chatGroup?: Maybe<ChatGroupField>;
  message?: Maybe<MessageField>;
};

export type SendOpenDayProspectReport = {
  __typename?: 'SendOpenDayProspectReport';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendResetPasswordEmail = {
  __typename?: 'SendResetPasswordEmail';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendVerificationCode = {
  __typename?: 'SendVerificationCode';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum SenderRole {
  Assistant = 'ASSISTANT',
  Function = 'FUNCTION',
  System = 'SYSTEM',
  Tool = 'TOOL',
  User = 'USER'
}

export type SequenceFilterMentorListField = {
  __typename?: 'SequenceFilterMentorListField';
  countries?: Maybe<Array<Maybe<CountryField>>>;
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
  filters?: Maybe<Array<Maybe<MentorFilterField>>>;
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mentorSeed?: Maybe<Scalars['Int']['output']>;
  mentors?: Maybe<Array<Maybe<PublicMentorField>>>;
  validCombination?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionAnalytics = {
  __typename?: 'SessionAnalytics';
  id: Scalars['ObjectId']['output'];
  liveSessionId: Scalars['ObjectId']['output'];
  session?: Maybe<LiveSession>;
  sessionAttendees: SessionAttendees;
  sessionMessagesSent: Scalars['Float']['output'];
  virtualEventId: Scalars['ObjectId']['output'];
};

export type SessionAttendeeAnalytics = {
  __typename?: 'SessionAttendeeAnalytics';
  accountRole: Scalars['String']['output'];
  id: Scalars['ObjectId']['output'];
  liveSessionId: Scalars['ObjectId']['output'];
  userId: Scalars['ObjectId']['output'];
};

export type SessionAttendeeData = {
  accountRole: Scalars['String']['input'];
  liveSessionId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type SessionAttendees = {
  __typename?: 'SessionAttendees';
  activeApplicants: Scalars['Float']['output'];
  applicants: Scalars['Float']['output'];
};

export type SessionData = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  /** the name of the event */
  name: Scalars['String']['input'];
  presenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  savedByUserIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  sessionImageUrl: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type SetActiveBlogTopicsMutation = {
  __typename?: 'SetActiveBlogTopicsMutation';
  blogTopics?: Maybe<Array<Maybe<BlogTopicField>>>;
};

export type SetAllNotificationsReadMutation = {
  __typename?: 'SetAllNotificationsReadMutation';
  notifications?: Maybe<Array<Maybe<NotificationField>>>;
};

export type SetArchivedContentBriefMutation = {
  __typename?: 'SetArchivedContentBriefMutation';
  contentBrief?: Maybe<ContentBriefField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SetArchivedDegreeLevelMutation = {
  __typename?: 'SetArchivedDegreeLevelMutation';
  degreeLevel?: Maybe<DegreeLevelField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SetArchivedYearOfStudyMutation = {
  __typename?: 'SetArchivedYearOfStudyMutation';
  error?: Maybe<Scalars['String']['output']>;
  yearOfStudy?: Maybe<YearOfStudyField>;
};

export type SetBuddiesListFilters = {
  __typename?: 'SetBuddiesListFilters';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetChatGroupLabelsMutation = {
  __typename?: 'SetChatGroupLabelsMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type SetDeviceTokenDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken: Scalars['String']['input'];
  system: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SetMentorFieldOrderMutation = {
  __typename?: 'SetMentorFieldOrderMutation';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetMentorListFilterSelection = {
  __typename?: 'SetMentorListFilterSelection';
  error?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type SetOnlineMutation = {
  __typename?: 'SetOnlineMutation';
  online?: Maybe<Scalars['Boolean']['output']>;
};

export type SetResolveChatGroupMutation = {
  __typename?: 'SetResolveChatGroupMutation';
  chatGroup?: Maybe<ChatGroupField>;
};

export type SetUserInterestsInput = {
  interestIds: Array<Scalars['String']['input']>;
};

export type SetWillReplyMutation = {
  __typename?: 'SetWillReplyMutation';
  chatGroupAux?: Maybe<ChatGroupAuxiliaryField>;
};

export type SettingsDto = {
  allowDirectChat?: InputMaybe<Scalars['Boolean']['input']>;
  allowExternalEventsIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  allowGifs?: InputMaybe<Scalars['Boolean']['input']>;
  allowImages?: InputMaybe<Scalars['Boolean']['input']>;
  allowNewsFeed?: InputMaybe<Scalars['Boolean']['input']>;
  allowPrivateGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsObjectType = {
  __typename?: 'SettingsObjectType';
  allowDirectChat: Scalars['Boolean']['output'];
  allowExternalEventsIntegration: Scalars['Boolean']['output'];
  allowGifs?: Maybe<Scalars['Boolean']['output']>;
  allowImages: Scalars['Boolean']['output'];
  allowNewsFeed: Scalars['Boolean']['output'];
  allowPrivateGroups: Scalars['Boolean']['output'];
};

export type ShowMentorInMarketplaceMutation = {
  __typename?: 'ShowMentorInMarketplaceMutation';
  mentor?: Maybe<MentorField>;
};

export type SignUpsCount = {
  __typename?: 'SignUpsCount';
  totalSignups?: Maybe<Scalars['Int']['output']>;
};

export type SignedS3PostFields = {
  __typename?: 'SignedS3POSTFields';
  fields?: Maybe<PostFields>;
  fileName?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SignedS3UrlField = {
  __typename?: 'SignedS3URLField';
  mediaUrl?: Maybe<Scalars['String']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type SingleChoiceAttributeField = CustomAttributeField & {
  __typename?: 'SingleChoiceAttributeField';
  active?: Maybe<Scalars['Boolean']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SingleChoiceValueField = CustomAttributeValueField & {
  __typename?: 'SingleChoiceValueField';
  attribute?: Maybe<CustomAttributeField>;
  id?: Maybe<Scalars['String']['output']>;
  option?: Maybe<CustomAttributeOptionField>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SourceInputField = {
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SourceMetadataField = {
  data?: InputMaybe<Scalars['JSONString']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SourceTrackingParamsField = {
  __typename?: 'SourceTrackingParamsField';
  ubCampaign?: Maybe<Scalars['String']['output']>;
  ubContent?: Maybe<Scalars['String']['output']>;
  ubMedium?: Maybe<Scalars['String']['output']>;
  ubSource?: Maybe<Scalars['String']['output']>;
};

export type StaffBuddycardSnippetField = {
  __typename?: 'StaffBuddycardSnippetField';
  departmentSnippet?: Maybe<Array<Maybe<DepartmentSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type StaffChatUserField = ChatUserField & {
  __typename?: 'StaffChatUserField';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffFieldsChatUserField>;
};


export type StaffChatUserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffContactByUniversityIdInput = {
  universityId: Scalars['String']['input'];
};

export type StaffContactInput = {
  contact: Scalars['String']['input'];
  description: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type StaffContactOutput = {
  __typename?: 'StaffContactOutput';
  contact: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffField = {
  __typename?: 'StaffField';
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lifecycleStatus?: Maybe<Scalars['String']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
};


export type StaffFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffFieldsChatUserField = {
  __typename?: 'StaffFieldsChatUserField';
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffPopcardSnippetField = {
  __typename?: 'StaffPopcardSnippetField';
  departmentSnippet?: Maybe<Array<Maybe<DepartmentSnippetField>>>;
  description?: Maybe<DescriptionField>;
};

export type StaffProfileInformation = {
  __typename?: 'StaffProfileInformation';
  accountRole: Buddies;
  bio: Scalars['String']['output'];
  department: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profilePhoto: Scalars['String']['output'];
  profileUrl: Scalars['String']['output'];
  role: Scalars['String']['output'];
  universityId?: Maybe<Scalars['String']['output']>;
};

export type StaffUserField = {
  __typename?: 'StaffUserField';
  bio?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffUserFieldsField = {
  __typename?: 'StaffUserFieldsField';
  bio?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type StaffUserListField = {
  __typename?: 'StaffUserListField';
  count?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<StaffField>>>;
};

export type StartRecordingArgs = {
  channelId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  universityId: Scalars['String']['input'];
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type StateStatField = {
  __typename?: 'StateStatField';
  count?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StopRecordingArgs = {
  channelId: Scalars['String']['input'];
};

export type SubTopicField = {
  __typename?: 'SubTopicField';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<TopicField>;
};

export type SubTopicStatField = {
  __typename?: 'SubTopicStatField';
  messageCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type SubTopicStatisticField = {
  __typename?: 'SubTopicStatisticField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SuggestionField = {
  __typename?: 'SuggestionField';
  canonicalQuestions?: Maybe<Array<Maybe<CanonicalQuestionField>>>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  topSubTopic?: Maybe<TopSubTopicField>;
  topSubTopics?: Maybe<Array<Maybe<TopSubTopicField>>>;
};

export type SwitchUniversitiesField = {
  __typename?: 'SwitchUniversitiesField';
  universities?: Maybe<Array<Maybe<SwitchUniversityListField>>>;
};

export type SwitchUniversityField = {
  __typename?: 'SwitchUniversityField';
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  whiteLogo?: Maybe<Scalars['String']['output']>;
};

export type SwitchUniversityListField = {
  __typename?: 'SwitchUniversityListField';
  university?: Maybe<SwitchUniversityField>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type Tag = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TagField = {
  __typename?: 'TagField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TargetAudienceDto = {
  id: Scalars['String']['input'];
  type: TodoTargetAudienceType;
};

export type TextInLocale = {
  __typename?: 'TextInLocale';
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TextInLocaleInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTakenField = {
  __typename?: 'TimeTakenField';
  totalTime?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum TodoAction {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE'
}

export enum TodoStatus {
  Published = 'published',
  Unpublished = 'unpublished'
}

export type TodoTargetAudience = Community;

export enum TodoTargetAudienceType {
  Community = 'community'
}

export type TodosEntity = {
  __typename?: 'TodosEntity';
  createdBy: Scalars['String']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: TodoStatus;
  targetAudience: Array<TodoTargetAudience>;
  title: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
};

export type ToggleCrmIntegrationSync = {
  __typename?: 'ToggleCrmIntegrationSync';
  integration?: Maybe<CrmIntegrationField>;
};

export type ToggleCustomAttributeCrmSyncMutation = {
  __typename?: 'ToggleCustomAttributeCrmSyncMutation';
  customAttributeNewSyncStatus?: Maybe<CrmFieldSyncStatus>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ToggleDegreesActiveMutation = {
  __typename?: 'ToggleDegreesActiveMutation';
  degrees?: Maybe<Array<Maybe<DegreeField>>>;
};

export type ToggleFeatureAvailabilityMutation = {
  __typename?: 'ToggleFeatureAvailabilityMutation';
  university?: Maybe<UniversityField>;
};

export type TopCountryField = {
  __typename?: 'TopCountryField';
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type TopDegreeField = {
  __typename?: 'TopDegreeField';
  count?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
};

export type TopDomesticRegionField = {
  __typename?: 'TopDomesticRegionField';
  count?: Maybe<Scalars['Int']['output']>;
  domesticRegion?: Maybe<Scalars['String']['output']>;
};

export type TopRegionField = {
  __typename?: 'TopRegionField';
  count?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type TopSubTopicField = {
  __typename?: 'TopSubTopicField';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  topic?: Maybe<TopTopicField>;
};

export type TopTopicField = {
  __typename?: 'TopTopicField';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
};

export type TopicField = {
  __typename?: 'TopicField';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicField>>>;
};

export type TopicSnippetField = {
  __typename?: 'TopicSnippetField';
  snippet?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<BlogTopicField>;
};

export type TopicStatisticField = {
  __typename?: 'TopicStatisticField';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicStatisticField>>>;
};

export type TopicsStatField = {
  __typename?: 'TopicsStatField';
  messageCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  subTopics?: Maybe<Array<Maybe<SubTopicStatField>>>;
};

export type TrackLiveEventMutation = {
  __typename?: 'TrackLiveEventMutation';
  liveEvent?: Maybe<LiveEventField>;
};

export type TrackOpenDayMutation = {
  __typename?: 'TrackOpenDayMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TrendingTopicsField = {
  __typename?: 'TrendingTopicsField';
  aggregatedCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<TopicsStatField>>>;
};

export enum TriggeredFromEnum {
  All = 'ALL',
  Chat = 'CHAT',
  Community = 'COMMUNITY'
}

export type UniversityAssistantConfiguration = {
  __typename?: 'UniversityAssistantConfiguration';
  /** university event url */
  eventUrls?: Maybe<Array<UniversityAssistantConfigurationEventUrls>>;
  /** Extra context to be added to prompt */
  promptContext?: Maybe<Scalars['String']['output']>;
  /** university scrape urls to ignore */
  scrapeIgnoreUrls?: Maybe<Array<UniversityAssistantScrapeIgnoreUrls>>;
  /** university scrape starting point scope */
  scrapeScope?: Maybe<ScrapeScope>;
  /** university scrape starting point */
  scrapeStartingPoint?: Maybe<Scalars['String']['output']>;
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationEventInput = {
  /** A description of the url */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A universityId */
  universityId: Scalars['String']['input'];
  /** A url to a universities event page */
  url: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationEventOutput = {
  __typename?: 'UniversityAssistantConfigurationEventOutput';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** A universityId */
  universityId: Scalars['String']['output'];
  /** A url to a universities event page */
  url: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationEventUrls = {
  __typename?: 'UniversityAssistantConfigurationEventUrls';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** A url to a universities event page */
  url: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationPromptContextInput = {
  /** Extra context to be added to prompt */
  promptContext: Scalars['String']['input'];
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationPromptContextOutput = {
  __typename?: 'UniversityAssistantConfigurationPromptContextOutput';
  /** Extra context to be added to prompt */
  promptContext: Scalars['String']['output'];
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationScrapeIgnoreUrlsInput = {
  /** Scrape ignore urls */
  scrapeIgnoreUrls: Array<UniversityAssistantScrapeIgnoreUrlsInput>;
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationScrapeIgnoreUrlsOutput = {
  __typename?: 'UniversityAssistantConfigurationScrapeIgnoreUrlsOutput';
  /** Scrape ignore urls */
  scrapeIgnoreUrls: Array<UniversityAssistantScrapeIgnoreUrls>;
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConfigurationScrapeStartPointInput = {
  /** A description of the url */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Scrape starting point scope */
  scrapeScope?: InputMaybe<ScrapeScope>;
  /** Scrape starting point */
  scrapeStartingPoint: Scalars['String']['input'];
  /** A universityId */
  universityId: Scalars['String']['input'];
};

export type UniversityAssistantConfigurationScrapeStartPointOutput = {
  __typename?: 'UniversityAssistantConfigurationScrapeStartPointOutput';
  /** A description of the url */
  description?: Maybe<Scalars['String']['output']>;
  /** university scrape starting point scope */
  scrapeScope?: Maybe<ScrapeScope>;
  /** Scrape starting point */
  scrapeStartingPoint: Scalars['String']['output'];
  /** A universityId */
  universityId: Scalars['String']['output'];
};

export type UniversityAssistantConversation = {
  __typename?: 'UniversityAssistantConversation';
  conversationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UniversityAssistantScrapeIgnoreUrls = {
  __typename?: 'UniversityAssistantScrapeIgnoreUrls';
  /** A boolean to determine whether to ignore subpages of an ignored url */
  ignoreSubpages: Scalars['Boolean']['output'];
  /** A url to ignore when scraping a university website */
  url: Scalars['String']['output'];
};

export type UniversityAssistantScrapeIgnoreUrlsInput = {
  /** A boolean to determine whether to ignore subpages of an ignored url */
  ignoreSubpages: Scalars['Boolean']['input'];
  /** A url to ignore when scraping a university website */
  url: Scalars['String']['input'];
};

export type UniversityBlockReportField = {
  __typename?: 'UniversityBlockReportField';
  blocked?: Maybe<ApplicantField>;
  blocker?: Maybe<AnyUserField>;
  chatGroup?: Maybe<ChatGroupField>;
  comment?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  triggeredFrom?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type UniversityBlockUsersMutation = {
  __typename?: 'UniversityBlockUsersMutation';
  count?: Maybe<Scalars['String']['output']>;
};

export type UniversityBlogPostsField = {
  __typename?: 'UniversityBlogPostsField';
  blogPostCount?: Maybe<Scalars['Int']['output']>;
  blogPosts?: Maybe<Array<Maybe<BlogPostField>>>;
};

export type UniversityChatInboxField = InboxItemInterface & {
  __typename?: 'UniversityChatInboxField';
  id: Scalars['String']['output'];
  lastMessage?: Maybe<InboxItemLastMessageField>;
  members?: Maybe<Array<Maybe<ChatUserField>>>;
  university?: Maybe<InboxUniversityField>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type UniversityConfigField = {
  __typename?: 'UniversityConfigField';
  features?: Maybe<Array<Maybe<UniversityFeatureField>>>;
  featuresWithUniversityControl?: Maybe<Array<Maybe<UniversityFeatureField>>>;
};

export type UniversityContent = {
  __typename?: 'UniversityContent';
  hasContent: Scalars['Boolean']['output'];
};

export type UniversityContentInput = {
  universityId: Scalars['ObjectId']['input'];
};

export type UniversityFeatureField = {
  __typename?: 'UniversityFeatureField';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enabledByUnibuddy?: Maybe<Scalars['Boolean']['output']>;
  enabledByUniversity?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<FeatureField>;
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  universityCanToggleFeature?: Maybe<Scalars['Boolean']['output']>;
};

export type UniversityField = {
  __typename?: 'UniversityField';
  active?: Maybe<Scalars['Boolean']['output']>;
  allowWelcomeMessageCustomization?: Maybe<Scalars['Boolean']['output']>;
  allowWelcomeMessageCustomizationStaff?: Maybe<Scalars['Boolean']['output']>;
  buddiesListFilters?: Maybe<Array<Maybe<BuddiesListFilterField>>>;
  chatboxUrl?: Maybe<Scalars['String']['output']>;
  churned?: Maybe<Scalars['Boolean']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  config?: Maybe<UniversityConfigField>;
  country?: Maybe<CountryField>;
  customAttribute?: Maybe<CustomAttributeField>;
  customAttributeOptions?: Maybe<Array<Maybe<CustomAttributeOptionField>>>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeField>>>;
  customChatBubbleTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  customMarketingConsentText?: Maybe<Scalars['String']['output']>;
  customMarketingConsentTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  customPreSignupText?: Maybe<Scalars['String']['output']>;
  customPreSignupTextInLocales?: Maybe<Array<Maybe<TextInLocale>>>;
  defaultProspectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  defaultProspectWelcomeMessageStaff?: Maybe<Scalars['String']['output']>;
  degreeTypeOrder?: Maybe<Array<Maybe<DegreeTypeOrderField>>>;
  domesticRegions?: Maybe<Array<Maybe<DomesticRegionField>>>;
  entries?: Maybe<EntriesField>;
  id?: Maybe<Scalars['String']['output']>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  isFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeatureReadOnly?: Maybe<Scalars['Boolean']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isReadyToLaunch?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Removed because CRM sync toggle is on CRM graph */
  isSyncedWithCrm?: Maybe<Scalars['Boolean']['output']>;
  launchDate?: Maybe<Scalars['String']['output']>;
  localePreference?: Maybe<Locale>;
  logo?: Maybe<Scalars['String']['output']>;
  marketplaces?: Maybe<Array<Maybe<UniversityMarketplaceField>>>;
  mentorFieldOrder?: Maybe<Array<Maybe<MentorFieldOrderField>>>;
  mentorListFilters?: Maybe<Array<Maybe<MentorListFilterChoice>>>;
  mentorMessagesCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  /** @deprecated Removed because unoptimized */
  onlineMentorAvatars?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organisation?: Maybe<Scalars['String']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  squareLogo?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whiteLogo?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
  widgetUrls?: Maybe<Array<Maybe<WidgetUrlField>>>;
};


export type UniversityFieldCustomAttributeArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldCustomAttributeOptionsArgs = {
  attributeId?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldIsFeatureEnabledArgs = {
  feature?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldIsFeatureReadOnlyArgs = {
  feature?: InputMaybe<Scalars['String']['input']>;
};


export type UniversityFieldWidgetUrlsArgs = {
  selectedLocale?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityInboxField = {
  __typename?: 'UniversityInboxField';
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatGroups?: Maybe<Array<Maybe<ChatGroupField>>>;
};

export type UniversityInterestedDto = {
  name: Scalars['String']['input'];
};

export type UniversityInterestedEntity = {
  __typename?: 'UniversityInterestedEntity';
  name: Scalars['String']['output'];
};

export type UniversityMarketplaceField = {
  __typename?: 'UniversityMarketplaceField';
  allowProspectDataAccess?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  marketingOptInWording?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tncWording?: Maybe<Scalars['String']['output']>;
  universityMarketplaceId?: Maybe<Scalars['String']['output']>;
};

export type UniversityMarketplaceInput = {
  allowProspectDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  marketingOptInWording?: InputMaybe<Scalars['String']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  tncWording?: InputMaybe<Scalars['String']['input']>;
  universityMarketplaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityOutput = {
  __typename?: 'UniversityOutput';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type UniversityQuestion = {
  __typename?: 'UniversityQuestion';
  active: Scalars['Boolean']['output'];
  answers: Array<UniversityQuestionAnswer>;
  contexts: Array<UniversityQuestionContext>;
  id: Scalars['ObjectId']['output'];
  isMultipleAnswersAllowed: Scalars['Boolean']['output'];
  options?: Maybe<Array<UniversityQuestionOption>>;
  text: Scalars['String']['output'];
  type: UniversityQuestionType;
};


export type UniversityQuestionAnswersArgs = {
  universityQuestionAnswerInput: UniversityQuestionAnswerInput;
};

export type UniversityQuestionAnswer = {
  __typename?: 'UniversityQuestionAnswer';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  context?: Maybe<UniversityQuestionContext>;
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export type UniversityQuestionAnswerInput = {
  context: UniversityQuestionContextInput;
  universityId: Scalars['ObjectId']['input'];
};

export type UniversityQuestionAnswerInputItem = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  text: Scalars['String']['input'];
};

export type UniversityQuestionByIdInput = {
  context: UniversityQuestionContextInput;
  questionId: Scalars['ObjectId']['input'];
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityQuestionContext = {
  __typename?: 'UniversityQuestionContext';
  id?: Maybe<Scalars['ObjectId']['output']>;
  type: Scalars['String']['output'];
};

export type UniversityQuestionContextInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  type: Scalars['String']['input'];
};

export type UniversityQuestionInput = {
  context: UniversityQuestionContextInput;
  universityId: Scalars['ObjectId']['input'];
  universityName?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
};

export type UniversityQuestionOption = {
  __typename?: 'UniversityQuestionOption';
  active: Scalars['Boolean']['output'];
  id: Scalars['ObjectId']['output'];
  text: Scalars['String']['output'];
};

export enum UniversityQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT'
}

export type UniversityScrapeIndexingOutput = {
  __typename?: 'UniversityScrapeIndexingOutput';
  createdAt: Scalars['DateTime']['output'];
  jobStatus: ScraperJobStatus;
  taskCompletedCount: Scalars['Float']['output'];
  taskInFlightCount: Scalars['Float']['output'];
  taskQueuedCount: Scalars['Float']['output'];
  tasks: Array<UniversityScrapeTask>;
  universityId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UniversityScrapeIndexingQueryInput = {
  httpStatus?: InputMaybe<Scalars['Float']['input']>;
  jobId: Scalars['String']['input'];
  requestDurationEquality?: InputMaybe<Scalars['String']['input']>;
  requestDurationMs?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortByDir?: InputMaybe<Scalars['String']['input']>;
  taskStatus?: InputMaybe<ScraperTaskStatus>;
  universityId: Scalars['String']['input'];
};

export type UniversityScrapeInput = {
  universityId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** For scraping a list of urls, will only visit the urls defined in the 'urls' field */
export type UniversityScrapeManualInput = {
  /** The universities home page */
  rootUrl: Scalars['String']['input'];
  /** id of the university */
  universityId: Scalars['String']['input'];
  /** List of urls to scrape */
  urls: Array<Scalars['String']['input']>;
};

export type UniversityScrapeOutput = {
  __typename?: 'UniversityScrapeOutput';
  created: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  jobStatus: ScraperJobStatus;
  rootUrl: Scalars['String']['output'];
  started: Scalars['Boolean']['output'];
  universityId: Scalars['String']['output'];
};

export type UniversityScrapeStopOutput = {
  __typename?: 'UniversityScrapeStopOutput';
  created: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  jobStatus: ScraperJobStatus;
  rootUrl: Scalars['String']['output'];
  universityId: Scalars['String']['output'];
};

export type UniversityScrapeTask = {
  __typename?: 'UniversityScrapeTask';
  created: Scalars['DateTime']['output'];
  depth: Scalars['Float']['output'];
  error: Scalars['String']['output'];
  httpStatus: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  requestDurationMs: Scalars['Float']['output'];
  rootUrl: Scalars['String']['output'];
  taskStatus: ScraperTaskStatus;
  universityId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type UniversitySnippetField = {
  __typename?: 'UniversitySnippetField';
  blogcardSnippets?: Maybe<BlogcardSnippetField>;
  carouselWidgetSnippets?: Maybe<CarouselSnippetField>;
  courseWidgetSnippets?: Maybe<CourseSnippetField>;
  embeddedEventSnippet?: Maybe<EmbeddedEventSnippetField>;
  error?: Maybe<Scalars['String']['output']>;
  mentorcardExternalSnippets?: Maybe<MentorcardSnippetField>;
  mentorcardInternalSnippets?: Maybe<MentorcardSnippetField>;
  popcardSnippets?: Maybe<PopcardSnippetField>;
  staffBuddycardExternalSnippet?: Maybe<StaffBuddycardSnippetField>;
  staffBuddycardInternalSnippet?: Maybe<StaffBuddycardSnippetField>;
  staffPopcardSnippet?: Maybe<StaffPopcardSnippetField>;
  university?: Maybe<UniversityField>;
  widgetSnippet?: Maybe<WidgetSnippetField>;
};

export type UniversityStopCrawlInput = {
  jobId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type UniversityUserField = {
  __typename?: 'UniversityUserField';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  id?: Maybe<Scalars['String']['output']>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UniversityUserPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  university?: Maybe<UniversityField>;
};

export type UniversityUserPreferencesField = {
  __typename?: 'UniversityUserPreferencesField';
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UnpinMessageMutation = {
  __typename?: 'UnpinMessageMutation';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnreadCountField = {
  __typename?: 'UnreadCountField';
  count?: Maybe<Scalars['Int']['output']>;
};

export type UnreadMessageCountField = {
  __typename?: 'UnreadMessageCountField';
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateApplicantMutation = {
  __typename?: 'UpdateApplicantMutation';
  error?: Maybe<Scalars['String']['output']>;
  me?: Maybe<MeField>;
};

export type UpdateApplicantPreferencesMutation = {
  __typename?: 'UpdateApplicantPreferencesMutation';
  me?: Maybe<MeField>;
};

export type UpdateCanonicalQuestion = {
  __typename?: 'UpdateCanonicalQuestion';
  canonicalQuestion?: Maybe<CanonicalQuestionField>;
};

export type UpdateChatRoomInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCommunityApplicantSignupSourceMutation = {
  __typename?: 'UpdateCommunityApplicantSignupSourceMutation';
  me?: Maybe<MeField>;
};

export type UpdateDirectMessagingMembersForLiveEventMutation = {
  __typename?: 'UpdateDirectMessagingMembersForLiveEventMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEvent?: Maybe<LiveEventField>;
};

export type UpdateEventPageInput = {
  description: Scalars['String']['input'];
  /** the name of the page */
  name: Scalars['String']['input'];
  pageImageUrl: Scalars['String']['input'];
};

export type UpdateExternalContentInput = {
  description: Scalars['String']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  externalContentImageUrl: Scalars['String']['input'];
  externalContentUrl: Scalars['String']['input'];
  /** the name of the external content */
  name: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFaqAnswer = {
  __typename?: 'UpdateFaqAnswer';
  faqAnswer?: Maybe<FaqAnswerField>;
};

export type UpdateHobsonsConnectIntegration = {
  __typename?: 'UpdateHobsonsConnectIntegration';
  integration?: Maybe<CampusManagementConnectIntegrationField>;
};

export type UpdateIntegrationFieldMapping = {
  __typename?: 'UpdateIntegrationFieldMapping';
  integration?: Maybe<CrmIntegrationField>;
};

export type UpdateLiveEventFeedSessionDataMutation = {
  __typename?: 'UpdateLiveEventFeedSessionDataMutation';
  errors?: Maybe<Array<Maybe<LiveEventsFormFieldValidationError>>>;
  liveEventFeed?: Maybe<LiveEventChatGroupField>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLiveSessionAnyUserInput = {
  addSavedByUserId?: InputMaybe<Scalars['ObjectId']['input']>;
  removeSavedByUserId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type UpdateLiveSessionInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  eventPagesIds?: InputMaybe<Array<Scalars['ObjectId']['input']>>;
  /** the name of the event */
  name: Scalars['String']['input'];
  presenterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sessionImageUrl: Scalars['String']['input'];
  showOnHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type UpdateManyUserMutation = {
  __typename?: 'UpdateManyUserMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateMarketplaceApplicantMutation = {
  __typename?: 'UpdateMarketplaceApplicantMutation';
  me?: Maybe<MeField>;
};

export type UpdateMarketplaceApplicantUniversityLinkMutation = {
  __typename?: 'UpdateMarketplaceApplicantUniversityLinkMutation';
  me?: Maybe<MeField>;
};

export type UpdateMarketplaceMutation = {
  __typename?: 'UpdateMarketplaceMutation';
  marketplace?: Maybe<MarketplaceField>;
};

export type UpdateMentorMutation = {
  __typename?: 'UpdateMentorMutation';
  me?: Maybe<MeField>;
};

export type UpdateMentorPreferences = {
  __typename?: 'UpdateMentorPreferences';
  preferences?: Maybe<MentorPreferencesField>;
};

export type UpdateMyUniversityLinkMutation = {
  __typename?: 'UpdateMyUniversityLinkMutation';
  me?: Maybe<MeField>;
};

export type UpdatePostStatusMutation = {
  __typename?: 'UpdatePostStatusMutation';
  blogPost?: Maybe<BlogPostField>;
  error?: Maybe<Scalars['String']['output']>;
};

export type UpdateRecordingLayoutArgs = {
  channelId: Scalars['String']['input'];
  mode: Scalars['Int']['input'];
  screenShareUid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResearchTimeMutation = {
  __typename?: 'UpdateResearchTimeMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStaffContactInput = {
  contact: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type UpdateStaffMutation = {
  __typename?: 'UpdateStaffMutation';
  me?: Maybe<MeField>;
};

export type UpdateSubTopicMutation = {
  __typename?: 'UpdateSubTopicMutation';
  subTopic?: Maybe<SubTopicField>;
};

export type UpdateTagMutation = {
  __typename?: 'UpdateTagMutation';
  tag?: Maybe<TagField>;
};

export type UpdateTopicMutation = {
  __typename?: 'UpdateTopicMutation';
  topic?: Maybe<TopicField>;
};

export type UpdateUniversityBlockReportMutation = {
  __typename?: 'UpdateUniversityBlockReportMutation';
  universityBlockReport?: Maybe<UniversityBlockReportField>;
};

export type UpdateUniversityConfigMutation = {
  __typename?: 'UpdateUniversityConfigMutation';
  error?: Maybe<Scalars['String']['output']>;
  universityConfiguration?: Maybe<CrmServiceUniversityConfig>;
};

export type UpdateUniversityUserMutation = {
  __typename?: 'UpdateUniversityUserMutation';
  error?: Maybe<Scalars['String']['output']>;
  me?: Maybe<MeField>;
};

export type UpdateUniversityUserPreferencesMutation = {
  __typename?: 'UpdateUniversityUserPreferencesMutation';
  me?: Maybe<MeField>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<UserField>;
};

export type UpdateUserPreferences = {
  __typename?: 'UpdateUserPreferences';
  preferences?: Maybe<UserPreferencesField>;
};

export type UpdateUserProfile = {
  areaOfStudy?: InputMaybe<Array<Scalars['String']['input']>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<Array<Scalars['String']['input']>>;
  housing?: InputMaybe<HousingInput>;
  interests?: InputMaybe<Array<InterestInput>>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVirtualEventInput = {
  description: Scalars['String']['input'];
  end: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  /** the name of the event */
  title: Scalars['String']['input'];
};

export type UpdatedResults = {
  __typename?: 'UpdatedResults';
  acknowledged: Scalars['Boolean']['output'];
  matchedCount: Scalars['Float']['output'];
  modifiedCount: Scalars['Float']['output'];
  upsertedCount: Scalars['Float']['output'];
  upsertedId: Scalars['String']['output'];
};

export type UserCustomAttributesFilterField = {
  __typename?: 'UserCustomAttributesFilterField';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserDecisionStageInput = {
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  universityId: Scalars['ObjectId']['input'];
};

export type UserDecisionStageOutput = {
  __typename?: 'UserDecisionStageOutput';
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  notInterestedReason?: Maybe<NotInterestedReasonEnum>;
  userId: Scalars['ObjectId']['output'];
};

export type UserDegreeField = {
  __typename?: 'UserDegreeField';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserDirectoryResult = {
  __typename?: 'UserDirectoryResult';
  result: Array<UserField>;
  totalUsers: Scalars['Float']['output'];
};

export type UserField = {
  __typename?: 'UserField';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  blockedByMentors?: Maybe<Array<Maybe<BlockerField>>>;
  blockedByUniversities?: Maybe<Array<Maybe<UniversityField>>>;
  chatGroupCount?: Maybe<Scalars['Int']['output']>;
  chatIntro?: Maybe<Scalars['String']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  communities?: Maybe<Array<Community>>;
  communityProfile?: Maybe<UserProfile>;
  country?: Maybe<CountryField>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customAttributes?: Maybe<Array<Maybe<CustomAttributeValueField>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupField>>>;
  hasUnansweredConversation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interests: Array<Interest>;
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<LanguageField>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  placeName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferencesField>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  prospectWelcomeMessage?: Maybe<Scalars['String']['output']>;
  resolvedUnansweredConversations?: Maybe<Scalars['Boolean']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  smudged?: Maybe<Scalars['Boolean']['output']>;
  staffFields?: Maybe<StaffUserFieldsField>;
  stageOneComplete?: Maybe<Scalars['Boolean']['output']>;
  stageTwoComplete?: Maybe<Scalars['Boolean']['output']>;
  unansweredCount?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<UniversityField>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};


export type UserFieldCustomAttributesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserFieldProfilePhotoArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserIdsListField = {
  __typename?: 'UserIdsListField';
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserInterest = {
  __typename?: 'UserInterest';
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
};

export type UserListField = {
  __typename?: 'UserListField';
  count?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<UserField>>>;
};

export type UserLocalePreference = {
  __typename?: 'UserLocalePreference';
  id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserLocalePreferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotInterestedStageInput = {
  decisionStage: DecisionStageEnum;
  decisionStageLocation: DecisionStageLocationEnum;
  notInterestedReason: NotInterestedReasonEnum;
  universityId: Scalars['ObjectId']['input'];
};

export type UserPartialSearchFields = {
  __typename?: 'UserPartialSearchFields';
  accountRole?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['String']['output']>;
  concatenatedFields?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
};

export type UserPermissionsListField = {
  __typename?: 'UserPermissionsListField';
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserPreferencesField = {
  __typename?: 'UserPreferencesField';
  id?: Maybe<Scalars['String']['output']>;
  newMessageNotifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  areaOfStudy?: Maybe<Array<DegreeField>>;
  bio?: Maybe<Scalars['String']['output']>;
  communities?: Maybe<Array<Scalars['String']['output']>>;
  housing?: Maybe<HousingObject>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<InterestObject>>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserRecommendation = {
  __typename?: 'UserRecommendation';
  currentUser: UserField;
  matches: Array<MatchedUser>;
  totalMatches: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UserReport = {
  __typename?: 'UserReport';
  actionTaken?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Community>;
  creationTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  moderationTime?: Maybe<Scalars['DateTime']['output']>;
  moderator?: Maybe<UserField>;
  moderatorComment?: Maybe<Scalars['String']['output']>;
  modificationTime?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  reportee: UserField;
  reporter: UserField;
  reporterComment: Scalars['String']['output'];
  reporterReason: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  university: UniversityField;
};

export type UserReportModeratorInputDto = {
  actionTaken?: InputMaybe<Scalars['String']['input']>;
  moderatorComment: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
  userReportId: Scalars['ObjectID']['input'];
};

export type UserReportUserInputDto = {
  communityId?: InputMaybe<Scalars['ObjectID']['input']>;
  product: Product;
  reporteeId: Scalars['ObjectID']['input'];
  reporterComment: Scalars['String']['input'];
  reporterReason: Scalars['String']['input'];
  universityId: Scalars['ObjectID']['input'];
};

export type UserTimeSheetExportField = {
  __typename?: 'UserTimeSheetExportField';
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type UserTimeSpentBreakdown = {
  __typename?: 'UserTimeSpentBreakdown';
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export type UserTimeSpentStatsField = {
  __typename?: 'UserTimeSpentStatsField';
  active?: Maybe<Scalars['Boolean']['output']>;
  blogs?: Maybe<Scalars['Int']['output']>;
  conversations?: Maybe<Scalars['Int']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<UserDegreeField>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fromTime?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveEvents?: Maybe<Scalars['Int']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  research?: Maybe<Scalars['Int']['output']>;
  toTime?: Maybe<Scalars['String']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type UsersTimeSpentData = {
  __typename?: 'UsersTimeSpentData';
  userCount?: Maybe<Scalars['Int']['output']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userTimeStats?: Maybe<Array<Maybe<UserTimeSpentStatsField>>>;
};

export type VerifyAccount = {
  __typename?: 'VerifyAccount';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyCodeField = {
  __typename?: 'VerifyCodeField';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoContent = {
  __typename?: 'VideoContent';
  id: Scalars['ID']['output'];
  status: VideoStatus;
  type: VideoTypeEnum;
  url: VideoUrl;
};

export type VideoFile = {
  __typename?: 'VideoFile';
  end?: Maybe<Scalars['DateTime']['output']>;
  fileIndex: Scalars['Float']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  recordingNumber: Scalars['Float']['output'];
  sid: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  splitNumber?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type VideoSession = {
  coverS3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type VideoSessionField = {
  __typename?: 'VideoSessionField';
  coverS3Url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type VideoSessionToUpdateField = {
  coverS3Url: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum VideoStatus {
  Error = 'ERROR',
  PresignedUrlGenerated = 'PRESIGNED_URL_GENERATED',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export enum VideoTypeEnum {
  Short = 'SHORT'
}

export type VideoUploadLink = {
  __typename?: 'VideoUploadLink';
  fields: Array<VideoUploadPresignedFields>;
  id: Scalars['ID']['output'];
  presignedUrl: Scalars['String']['output'];
};

export type VideoUploadLinkInput = {
  type: VideoTypeEnum;
  universityId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};

export type VideoUploadPresignedFields = {
  __typename?: 'VideoUploadPresignedFields';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VideoUrl = {
  __typename?: 'VideoUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type ViewBlogMutation = {
  __typename?: 'ViewBlogMutation';
  post?: Maybe<BlogPostField>;
};

export type VirtualEvent = {
  __typename?: 'VirtualEvent';
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ObjectId']['output'];
  imageUrl: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  /** the name of the event */
  title: Scalars['String']['output'];
  university: UniversityField;
};

export type WidgetConversationDto = {
  ambassadorId: Scalars['String']['input'];
  universityId: Scalars['String']['input'];
};

export type WidgetSnippetField = {
  __typename?: 'WidgetSnippetField';
  description?: Maybe<DescriptionField>;
  embeddedEventSnippet?: Maybe<EmbeddedEventSnippetField>;
  snippet?: Maybe<Scalars['String']['output']>;
};

export type WidgetUrlField = {
  __typename?: 'WidgetUrlField';
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WidgetUrlsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WillReplyField = {
  __typename?: 'WillReplyField';
  created?: Maybe<Scalars['String']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  mobileAdded?: Maybe<Scalars['Boolean']['output']>;
};

export type YearOfStudyField = {
  __typename?: 'YearOfStudyField';
  archived?: Maybe<Scalars['Boolean']['output']>;
  degreeLevel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
};

export type PinMessageDto = {
  conversationId: Scalars['String']['input'];
  messageId: Scalars['ObjectId']['input'];
};

export type UnpinMessageDto = {
  conversationId: Scalars['String']['input'];
  messageId: Scalars['ObjectId']['input'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  InboxItemUnion: ( Omit<ChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<_RefType['ChatUserField']>>> } ) | ( Omit<UniversityChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<_RefType['ChatUserField']>>> } );
  TodoTargetAudience: ( Omit<Community, 'blockedMembers' | 'communityChatGroups' | 'institutions' | 'members'> & { blockedMembers?: Maybe<Array<_RefType['UserField']>>, communityChatGroups: Array<_RefType['CommunityChatGroup']>, institutions?: Maybe<Array<_RefType['UniversityField']>>, members?: Maybe<Array<_RefType['UserField']>> } );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  ChatUserField: ( ApplicantUserField ) | ( MentorChatUserField ) | ( StaffChatUserField );
  CustomAttributeField: ( BaseCustomAttributeField ) | ( SingleChoiceAttributeField );
  CustomAttributeValueField: ( Omit<DateValueField, 'attribute'> & { attribute?: Maybe<_RefType['CustomAttributeField']> } ) | ( Omit<OpenTextFieldValueField, 'attribute'> & { attribute?: Maybe<_RefType['CustomAttributeField']> } ) | ( Omit<SingleChoiceValueField, 'attribute'> & { attribute?: Maybe<_RefType['CustomAttributeField']> } );
  InboxItemInterface: ( Omit<ChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<_RefType['ChatUserField']>>> } ) | ( Omit<UniversityChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<_RefType['ChatUserField']>>> } );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptRequestedPublicGroupInput: AcceptRequestedPublicGroupInput;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  AccountRoles: AccountRoles;
  ActivateApplicantsMutation: ResolverTypeWrapper<ActivateApplicantsMutation>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  ActivateMentorsMutation: ResolverTypeWrapper<ActivateMentorsMutation>;
  ActivityField: ResolverTypeWrapper<Omit<ActivityField, 'user'> & { user?: Maybe<ResolversTypes['AnyUserField']> }>;
  ActivitySourceField: ResolverTypeWrapper<ActivitySourceField>;
  AddAttributeOptionMutation: ResolverTypeWrapper<Omit<AddAttributeOptionMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  AddBotToChatGroupMutation: ResolverTypeWrapper<Omit<AddBotToChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  AddCustomAttributeMutation: ResolverTypeWrapper<Omit<AddCustomAttributeMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  AddDegreeLevelsMutation: ResolverTypeWrapper<Omit<AddDegreeLevelsMutation, 'degreeLevels'> & { degreeLevels?: Maybe<Array<Maybe<ResolversTypes['DegreeLevelField']>>> }>;
  AddDegreesMutation: ResolverTypeWrapper<Omit<AddDegreesMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>> }>;
  AddHobsonsConnectIntegration: ResolverTypeWrapper<AddHobsonsConnectIntegration>;
  AddLocalesToApp: ResolverTypeWrapper<AddLocalesToApp>;
  AddResearchTimeMutation: ResolverTypeWrapper<AddResearchTimeMutation>;
  AddYearOfStudyMutation: ResolverTypeWrapper<AddYearOfStudyMutation>;
  AdminDeleteApplicantMutation: ResolverTypeWrapper<Omit<AdminDeleteApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  AdminRecommendation: ResolverTypeWrapper<Omit<AdminRecommendation, 'cohort'> & { cohort?: Maybe<ResolversTypes['Cohort']> }>;
  AdminRecommendationCountPerDecisionStage: ResolverTypeWrapper<AdminRecommendationCountPerDecisionStage>;
  AdminRecommendationInput: AdminRecommendationInput;
  AdminUpdateMentorMutation: ResolverTypeWrapper<Omit<AdminUpdateMentorMutation, 'mentor'> & { mentor?: Maybe<ResolversTypes['MentorField']> }>;
  AdminUserField: ResolverTypeWrapper<AdminUserField>;
  AgeVerificationInfoField: ResolverTypeWrapper<AgeVerificationInfoField>;
  AgeVerificationInfoInputField: AgeVerificationInfoInputField;
  AlertField: ResolverTypeWrapper<AlertField>;
  AllPostsField: ResolverTypeWrapper<Omit<AllPostsField, 'blogPosts' | 'blogPostsDegrees'> & { blogPosts?: Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>>, blogPostsDegrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>> }>;
  AmbassadorField: ResolverTypeWrapper<AmbassadorField>;
  AmbassadorProfileInformation: ResolverTypeWrapper<AmbassadorProfileInformation>;
  AmbassadorRecommendation: ResolverTypeWrapper<AmbassadorRecommendation>;
  AmbassadorRecommendationInput: AmbassadorRecommendationInput;
  AmbassadorRecommendationResourceType: ResolverTypeWrapper<AmbassadorRecommendationResourceType>;
  AmbassadorRecommendationResourceTypeEnum: AmbassadorRecommendationResourceTypeEnum;
  Analytics: ResolverTypeWrapper<Analytics>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  AnalyticsBuddyField: ResolverTypeWrapper<AnalyticsBuddyField>;
  AnalyticsDashboardAuthField: ResolverTypeWrapper<AnalyticsDashboardAuthField>;
  AnalyticsDashboardMetadata: AnalyticsDashboardMetadata;
  AnalyticsMentorField: ResolverTypeWrapper<AnalyticsMentorField>;
  AnyChatUserField: ResolverTypeWrapper<Omit<AnyChatUserField, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>> }>;
  AnyUserField: ResolverTypeWrapper<Omit<AnyUserField, 'country' | 'degree' | 'degrees' | 'university'> & { country?: Maybe<ResolversTypes['CountryField']>, degree?: Maybe<ResolversTypes['DegreeField']>, degrees?: Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  AppLocaleField: ResolverTypeWrapper<AppLocaleField>;
  AppLocalesFieldInput: AppLocalesFieldInput;
  ApplicantBroadcastMessageMutation: ResolverTypeWrapper<ApplicantBroadcastMessageMutation>;
  ApplicantCollectionField: ResolverTypeWrapper<ApplicantCollectionField>;
  ApplicantConversationField: ResolverTypeWrapper<ApplicantConversationField>;
  ApplicantCountField: ResolverTypeWrapper<ApplicantCountField>;
  ApplicantField: ResolverTypeWrapper<Omit<ApplicantField, 'ageVerificationInfo' | 'applicantUniversities' | 'country' | 'degreeLevel' | 'degreesInterested' | 'linkWithUniversity' | 'universitiesApplied' | 'universitiesInterested'> & { ageVerificationInfo?: Maybe<ResolversTypes['AgeVerificationInfoField']>, applicantUniversities?: Maybe<Array<Maybe<ResolversTypes['ApplicantUniversityLinkField']>>>, country?: Maybe<ResolversTypes['CountryField']>, degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']>, degreesInterested?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, linkWithUniversity?: Maybe<ResolversTypes['ApplicantUniversityLinkField']>, universitiesApplied?: Maybe<Array<Maybe<ResolversTypes['ApplicantUniversityLinkField']>>>, universitiesInterested?: Maybe<Array<Maybe<ResolversTypes['UniversityField']>>> }>;
  ApplicantInboxField: ResolverTypeWrapper<Omit<ApplicantInboxField, 'botChatGroup' | 'chatGroups' | 'universityClearingChatGroup'> & { botChatGroup?: Maybe<ResolversTypes['ChatGroupField']>, chatGroups?: Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, universityClearingChatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  ApplicantInvite: ResolverTypeWrapper<ApplicantInvite>;
  ApplicantLabelField: ResolverTypeWrapper<ApplicantLabelField>;
  ApplicantMarketplaceInput: ApplicantMarketplaceInput;
  ApplicantMarketplaceObjectField: ResolverTypeWrapper<ApplicantMarketplaceObjectField>;
  ApplicantPreferencesField: ResolverTypeWrapper<ApplicantPreferencesField>;
  ApplicantSchoolHistory: ResolverTypeWrapper<ApplicantSchoolHistory>;
  ApplicantSignupStats: ResolverTypeWrapper<ApplicantSignupStats>;
  ApplicantUniversityLinkField: ResolverTypeWrapper<Omit<ApplicantUniversityLinkField, 'customAttributes' | 'degreeLevel' | 'degreesInterested' | 'university'> & { customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']>, degreesInterested?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  ApplicantUserField: ResolverTypeWrapper<ApplicantUserField>;
  ApplicantsAppliedStats: ResolverTypeWrapper<ApplicantsAppliedStats>;
  ApplicantsMessagedCount: ResolverTypeWrapper<ApplicantsMessagedCount>;
  ApplicationField: ResolverTypeWrapper<ApplicationField>;
  ApplicationInsightModel: ResolverTypeWrapper<Omit<ApplicationInsightModel, 'university'> & { university: ResolversTypes['UniversityField'] }>;
  AppliedUsersCountInput: AppliedUsersCountInput;
  AppliedUsersCountModel: ResolverTypeWrapper<AppliedUsersCountModel>;
  AssistantConversationFeedback: ResolverTypeWrapper<AssistantConversationFeedback>;
  AssistantConversationHistory: ResolverTypeWrapper<AssistantConversationHistory>;
  AssistantConversationHistoryWithToken: ResolverTypeWrapper<AssistantConversationHistoryWithToken>;
  AssistantConversationLead: ResolverTypeWrapper<AssistantConversationLead>;
  AssistantConversationMessage: ResolverTypeWrapper<AssistantConversationMessage>;
  AssistantMessageFeedback: ResolverTypeWrapper<AssistantMessageFeedback>;
  AssistantMessageFeedbackInput: AssistantMessageFeedbackInput;
  AssistantMessageFeedbackType: AssistantMessageFeedbackType;
  Attachment: ResolverTypeWrapper<Attachment>;
  AttachmentDto: AttachmentDto;
  AttachmentField: ResolverTypeWrapper<AttachmentField>;
  AttachmentType: AttachmentType;
  AttendeeAnalytics: ResolverTypeWrapper<AttendeeAnalytics>;
  AttendeeData: AttendeeData;
  Attendees: ResolverTypeWrapper<Attendees>;
  AuthField: ResolverTypeWrapper<Omit<AuthField, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  AuthorSnippetField: ResolverTypeWrapper<Omit<AuthorSnippetField, 'author'> & { author?: Maybe<ResolversTypes['MentorField']> }>;
  BaseCustomAttributeField: ResolverTypeWrapper<BaseCustomAttributeField>;
  BlockUserMutation: ResolverTypeWrapper<BlockUserMutation>;
  BlockUserMutationV2: ResolverTypeWrapper<BlockUserMutationV2>;
  BlockerField: ResolverTypeWrapper<BlockerField>;
  BlogCommentField: ResolverTypeWrapper<Omit<BlogCommentField, 'author'> & { author?: Maybe<ResolversTypes['AnyUserField']> }>;
  BlogPostField: ResolverTypeWrapper<Omit<BlogPostField, 'author' | 'comments' | 'lastUpdatedBy' | 'university'> & { author?: Maybe<ResolversTypes['MentorField']>, comments?: Maybe<Array<Maybe<ResolversTypes['BlogCommentField']>>>, lastUpdatedBy?: Maybe<ResolversTypes['AnyUserField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  BlogStatus: BlogStatus;
  BlogTopicField: ResolverTypeWrapper<BlogTopicField>;
  BlogcardSnippetField: ResolverTypeWrapper<Omit<BlogcardSnippetField, 'authorSnippets'> & { authorSnippets?: Maybe<Array<Maybe<ResolversTypes['AuthorSnippetField']>>> }>;
  BotUserField: ResolverTypeWrapper<Omit<BotUserField, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  Buddies: Buddies;
  BuddiesField: ResolverTypeWrapper<Omit<BuddiesField, 'users'> & { users?: Maybe<Array<Maybe<ResolversTypes['BuddyField']>>> }>;
  BuddiesFilterOptionsField: ResolverTypeWrapper<BuddiesFilterOptionsField>;
  BuddiesListFilterField: ResolverTypeWrapper<BuddiesListFilterField>;
  BuddiesListFilterInput: BuddiesListFilterInput;
  BuddyApplicantChatGroupField: ResolverTypeWrapper<BuddyApplicantChatGroupField>;
  BuddyApplicantChatGroupFieldV2: ResolverTypeWrapper<Omit<BuddyApplicantChatGroupFieldV2, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  BuddyApplicantChatInterventionBuddyField: ResolverTypeWrapper<BuddyApplicantChatInterventionBuddyField>;
  BuddyField: ResolverTypeWrapper<Omit<BuddyField, 'customAttributes' | 'university'> & { customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  BuddyInviteField: ResolverTypeWrapper<BuddyInviteField>;
  BuddyInviteListField: ResolverTypeWrapper<BuddyInviteListField>;
  BulkApplicantField: ResolverTypeWrapper<Omit<BulkApplicantField, 'country' | 'degreeLevel' | 'degrees' | 'degreesInterested' | 'universitiesInterested'> & { country?: Maybe<ResolversTypes['CountryField']>, degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']>, degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, degreesInterested?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, universitiesInterested?: Maybe<Array<Maybe<ResolversTypes['UniversityField']>>> }>;
  BulkOptOutMarketplaceUniversityMarketingMutation: ResolverTypeWrapper<Omit<BulkOptOutMarketplaceUniversityMarketingMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  ButtonField: ResolverTypeWrapper<ButtonField>;
  CRMApplicantField: ResolverTypeWrapper<CrmApplicantField>;
  CRMField: ResolverTypeWrapper<CrmField>;
  CRMIntegrationField: ResolverTypeWrapper<CrmIntegrationField>;
  CRMMetaDataField: ResolverTypeWrapper<CrmMetaDataField>;
  CSVUploadAmbassadorFieldsMutation: ResolverTypeWrapper<CsvUploadAmbassadorFieldsMutation>;
  CSVUploadApplicantsMutation: ResolverTypeWrapper<CsvUploadApplicantsMutation>;
  CampusManagementConnectIntegrationField: ResolverTypeWrapper<CampusManagementConnectIntegrationField>;
  CanonicalQuestionField: ResolverTypeWrapper<Omit<CanonicalQuestionField, 'answers'> & { answers?: Maybe<Array<Maybe<ResolversTypes['FaqAnswerField']>>> }>;
  CarouselSnippetField: ResolverTypeWrapper<CarouselSnippetField>;
  ChatConversation: ResolverTypeWrapper<Omit<ChatConversation, 'communityChatMembers' | 'createdBy' | 'lastMessage' | 'members' | 'pinnedMessages' | 'university'> & { communityChatMembers?: Maybe<Array<ResolversTypes['UserField']>>, createdBy?: Maybe<ResolversTypes['UserField']>, lastMessage?: Maybe<ResolversTypes['ChatMessage']>, members?: Maybe<Array<ResolversTypes['UserField']>>, pinnedMessages: Array<ResolversTypes['ChatMessage']>, university: ResolversTypes['UniversityField'] }>;
  ChatConversationInboxInputDto: ChatConversationInboxInputDto;
  ChatGroupAndMessages: ResolverTypeWrapper<Omit<ChatGroupAndMessages, 'chatGroup' | 'messages'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, messages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>> }>;
  ChatGroupAuxiliaryField: ResolverTypeWrapper<ChatGroupAuxiliaryField>;
  ChatGroupField: ResolverTypeWrapper<Omit<ChatGroupField, 'applicant' | 'lastMessage' | 'members' | 'messages' | 'messagesForModeration' | 'opponent' | 'university'> & { applicant?: Maybe<ResolversTypes['AnyChatUserField']>, lastMessage?: Maybe<ResolversTypes['LastMessageField']>, members?: Maybe<Array<Maybe<ResolversTypes['AnyUserField']>>>, messages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, messagesForModeration?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, opponent?: Maybe<ResolversTypes['AnyChatUserField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  ChatGroupLabelField: ResolverTypeWrapper<ChatGroupLabelField>;
  ChatInboxField: ResolverTypeWrapper<Omit<ChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<ResolversTypes['ChatUserField']>>> }>;
  ChatMessage: ResolverTypeWrapper<Omit<ChatMessage, 'reactions' | 'sender'> & { reactions?: Maybe<Array<ResolversTypes['Reaction']>>, sender: ResolversTypes['UserField'] }>;
  ChatPermission: ResolverTypeWrapper<ChatPermission>;
  ChatReport: ResolverTypeWrapper<Omit<ChatReport, 'community' | 'conversation' | 'message' | 'moderator' | 'reportee' | 'reporter' | 'university'> & { community: ResolversTypes['Community'], conversation: ResolversTypes['ChatConversation'], message: ResolversTypes['ChatMessage'], moderator?: Maybe<ResolversTypes['UserField']>, reportee: ResolversTypes['UserField'], reporter: ResolversTypes['UserField'], university: ResolversTypes['UniversityField'] }>;
  ChatReportModeratorInputDTO: ChatReportModeratorInputDto;
  ChatReportUserInputDTO: ChatReportUserInputDto;
  ChatRoom: ResolverTypeWrapper<Omit<ChatRoom, 'conversation'> & { conversation: ResolversTypes['ChatConversation'] }>;
  ChatRoomAnalytics: ResolverTypeWrapper<ChatRoomAnalytics>;
  ChatRoomAttendeeAnalytics: ResolverTypeWrapper<ChatRoomAttendeeAnalytics>;
  ChatRoomAttendeeData: ChatRoomAttendeeData;
  ChatRoomAttendees: ResolverTypeWrapper<ChatRoomAttendees>;
  ChatSummaryField: ResolverTypeWrapper<ChatSummaryField>;
  ChatUserField: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ChatUserField']>;
  CheckEmailMutation: ResolverTypeWrapper<CheckEmailMutation>;
  ChildOrganisationField: ResolverTypeWrapper<ChildOrganisationField>;
  ClassificationField: ResolverTypeWrapper<ClassificationField>;
  CloneLiveEventAndChannelsMutation: ResolverTypeWrapper<Omit<CloneLiveEventAndChannelsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  Cohort: ResolverTypeWrapper<Omit<Cohort, 'areaOfStudies' | 'countries' | 'degreeLevels'> & { areaOfStudies?: Maybe<Array<ResolversTypes['DegreeField']>>, countries?: Maybe<Array<ResolversTypes['CountryField']>>, degreeLevels?: Maybe<Array<ResolversTypes['DegreeLevelField']>> }>;
  CohortInput: CohortInput;
  CommentMutation: ResolverTypeWrapper<Omit<CommentMutation, 'comment'> & { comment?: Maybe<ResolversTypes['BlogCommentField']> }>;
  Community: ResolverTypeWrapper<Omit<Community, 'blockedMembers' | 'communityChatGroups' | 'institutions' | 'members'> & { blockedMembers?: Maybe<Array<ResolversTypes['UserField']>>, communityChatGroups: Array<ResolversTypes['CommunityChatGroup']>, institutions?: Maybe<Array<ResolversTypes['UniversityField']>>, members?: Maybe<Array<ResolversTypes['UserField']>> }>;
  CommunityChatGroup: ResolverTypeWrapper<Omit<CommunityChatGroup, 'conversation' | 'createdBy' | 'members'> & { conversation: ResolversTypes['ChatConversation'], createdBy?: Maybe<ResolversTypes['UserField']>, members?: Maybe<Array<ResolversTypes['UserField']>> }>;
  CommunityField: ResolverTypeWrapper<CommunityField>;
  CommunityInviteResponse: ResolverTypeWrapper<CommunityInviteResponse>;
  CommunityInvites: ResolverTypeWrapper<CommunityInvites>;
  CommunityJoinResponse: ResolverTypeWrapper<Omit<CommunityJoinResponse, 'community'> & { community: ResolversTypes['Community'] }>;
  CompletedEvent: ResolverTypeWrapper<CompletedEvent>;
  CompletedEventsOverview: ResolverTypeWrapper<CompletedEventsOverview>;
  ContentBriefField: ResolverTypeWrapper<ContentBriefField>;
  Context: ResolverTypeWrapper<Context>;
  ContextType: ContextType;
  ConversationContextChatGroupField: ResolverTypeWrapper<ConversationContextChatGroupField>;
  ConversationContextField: ResolverTypeWrapper<ConversationContextField>;
  ConversationInbox: ResolverTypeWrapper<Omit<ConversationInbox, 'conversations'> & { conversations: Array<ResolversTypes['ChatConversation']> }>;
  ConversationTag: ResolverTypeWrapper<ConversationTag>;
  CookieConsentInputDTO: CookieConsentInputDto;
  CookieConsentOutputDTO: ResolverTypeWrapper<CookieConsentOutputDto>;
  CountPerEpoch: ResolverTypeWrapper<CountPerEpoch>;
  CountryAnalyticsValue: ResolverTypeWrapper<CountryAnalyticsValue>;
  CountryField: ResolverTypeWrapper<CountryField>;
  CountrySnippetField: ResolverTypeWrapper<Omit<CountrySnippetField, 'country'> & { country?: Maybe<ResolversTypes['CountryField']> }>;
  CountryStatField: ResolverTypeWrapper<CountryStatField>;
  CourseSnippetField: ResolverTypeWrapper<Omit<CourseSnippetField, 'degreeSnippets'> & { degreeSnippets?: Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>> }>;
  CreateAlertMutation: ResolverTypeWrapper<CreateAlertMutation>;
  CreateApplicantInsightInput: CreateApplicantInsightInput;
  CreateApplicantMutation: ResolverTypeWrapper<Omit<CreateApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  CreateApplicantMutationV2: ResolverTypeWrapper<Omit<CreateApplicantMutationV2, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  CreateAssistantConversationInput: CreateAssistantConversationInput;
  CreateBlogTopicMutation: ResolverTypeWrapper<CreateBlogTopicMutation>;
  CreateBuddyMutation: ResolverTypeWrapper<CreateBuddyMutation>;
  CreateCanonicalQuestion: ResolverTypeWrapper<Omit<CreateCanonicalQuestion, 'question'> & { question?: Maybe<ResolversTypes['CanonicalQuestionField']> }>;
  CreateCommunityApplicantMutation: ResolverTypeWrapper<Omit<CreateCommunityApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  CreateCommunityApplicantMutationV2: ResolverTypeWrapper<Omit<CreateCommunityApplicantMutationV2, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  CreateCommunityChatGroupInput: CreateCommunityChatGroupInput;
  CreateCommunityConversationDTO: CreateCommunityConversationDto;
  CreateCommunityDTO: CreateCommunityDto;
  CreateCrmServiceUniversityConfigMutation: ResolverTypeWrapper<CreateCrmServiceUniversityConfigMutation>;
  CreateExternalEventMutation: ResolverTypeWrapper<CreateExternalEventMutation>;
  CreateFaqAnswer: ResolverTypeWrapper<Omit<CreateFaqAnswer, 'faqAnswer'> & { faqAnswer?: Maybe<ResolversTypes['FaqAnswerField']> }>;
  CreateFresherMutation: ResolverTypeWrapper<Omit<CreateFresherMutation, 'fresher'> & { fresher?: Maybe<ResolversTypes['ApplicantField']> }>;
  CreateLiveEventDetailsMutation: ResolverTypeWrapper<Omit<CreateLiveEventDetailsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  CreateLiveEventFeedMutation: ResolverTypeWrapper<Omit<CreateLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversTypes['LiveEventChatGroupField']> }>;
  CreateLiveEventFeedSessionsMutation: ResolverTypeWrapper<Omit<CreateLiveEventFeedSessionsMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversTypes['LiveEventChatGroupField']> }>;
  CreateLiveEventMutation: ResolverTypeWrapper<Omit<CreateLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  CreateMarketplaceApplicantMutation: ResolverTypeWrapper<Omit<CreateMarketplaceApplicantMutation, 'authenticatedApplicant'> & { authenticatedApplicant?: Maybe<ResolversTypes['AuthField']> }>;
  CreateMarketplaceMutation: ResolverTypeWrapper<CreateMarketplaceMutation>;
  CreateMentorMutation: ResolverTypeWrapper<Omit<CreateMentorMutation, 'mentor'> & { mentor?: Maybe<ResolversTypes['MentorField']> }>;
  CreateOpenDayMutation: ResolverTypeWrapper<CreateOpenDayMutation>;
  CreateOrganisationBuddyLinkMutation: ResolverTypeWrapper<CreateOrganisationBuddyLinkMutation>;
  CreateOrganisationMutation: ResolverTypeWrapper<Omit<CreateOrganisationMutation, 'organisation'> & { organisation?: Maybe<ResolversTypes['OrganisationField']> }>;
  CreatePostMutation: ResolverTypeWrapper<Omit<CreatePostMutation, 'post'> & { post?: Maybe<ResolversTypes['BlogPostField']> }>;
  CreateRequestedPublicGroupInput: CreateRequestedPublicGroupInput;
  CreateSubTopicMutation: ResolverTypeWrapper<CreateSubTopicMutation>;
  CreateTagMutation: ResolverTypeWrapper<CreateTagMutation>;
  CreateTodoInputDto: CreateTodoInputDto;
  CreateTopicMutation: ResolverTypeWrapper<CreateTopicMutation>;
  CreateUniversityBlockReportMutation: ResolverTypeWrapper<Omit<CreateUniversityBlockReportMutation, 'universityBlockReport'> & { universityBlockReport?: Maybe<ResolversTypes['UniversityBlockReportField']> }>;
  CreateUniversityMutation: ResolverTypeWrapper<Omit<CreateUniversityMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  CreateUniversityUserMutation: ResolverTypeWrapper<Omit<CreateUniversityUserMutation, 'universityUser'> & { universityUser?: Maybe<ResolversTypes['UniversityUserField']> }>;
  CreateUserMutation: ResolverTypeWrapper<Omit<CreateUserMutation, 'user'> & { user?: Maybe<ResolversTypes['UserField']> }>;
  CreateVirtualEventInput: CreateVirtualEventInput;
  CreationSource: ResolverTypeWrapper<CreationSource>;
  CrmApplicantRecordField: ResolverTypeWrapper<CrmApplicantRecordField>;
  CrmAttributeField: ResolverTypeWrapper<CrmAttributeField>;
  CrmConnectionField: ResolverTypeWrapper<CrmConnectionField>;
  CrmDataField: ResolverTypeWrapper<CrmDataField>;
  CrmFieldInputType: CrmFieldInputType;
  CrmFieldSyncStatus: ResolverTypeWrapper<CrmFieldSyncStatus>;
  CrmServiceUniversityConfig: ResolverTypeWrapper<CrmServiceUniversityConfig>;
  CrmSyncJobField: ResolverTypeWrapper<CrmSyncJobField>;
  CurrentDecisionStageOutput: ResolverTypeWrapper<CurrentDecisionStageOutput>;
  CurrentUserDecisionStageQueryInput: CurrentUserDecisionStageQueryInput;
  CustomAttributeField: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomAttributeField']>;
  CustomAttributeInput: CustomAttributeInput;
  CustomAttributeOptionField: ResolverTypeWrapper<CustomAttributeOptionField>;
  CustomAttributeValueField: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomAttributeValueField']>;
  CustomAttributeValueInput: CustomAttributeValueInput;
  CustomAttributesField: ResolverTypeWrapper<CustomAttributesField>;
  CustomAttributesFilterField: ResolverTypeWrapper<CustomAttributesFilterField>;
  CustomAttributesFilterInputField: CustomAttributesFilterInputField;
  CustomAttributesFilterOptionField: ResolverTypeWrapper<CustomAttributesFilterOptionField>;
  DataFormatConfig: ResolverTypeWrapper<DataFormatConfig>;
  DataFormatConfigInputType: DataFormatConfigInputType;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateValueField: ResolverTypeWrapper<Omit<DateValueField, 'attribute'> & { attribute?: Maybe<ResolversTypes['CustomAttributeField']> }>;
  DeactivateApplicantsMutation: ResolverTypeWrapper<DeactivateApplicantsMutation>;
  DeactivateMentorsMutation: ResolverTypeWrapper<DeactivateMentorsMutation>;
  DecisionStageEnum: DecisionStageEnum;
  DecisionStageLocationEnum: DecisionStageLocationEnum;
  DefaultQuestionsField: ResolverTypeWrapper<DefaultQuestionsField>;
  DegreeCategoriesAnalyticsValue: ResolverTypeWrapper<DegreeCategoriesAnalyticsValue>;
  DegreeCategoryField: ResolverTypeWrapper<DegreeCategoryField>;
  DegreeCategoryParentField: ResolverTypeWrapper<DegreeCategoryParentField>;
  DegreeChatUserField: ResolverTypeWrapper<DegreeChatUserField>;
  DegreeField: ResolverTypeWrapper<Omit<DegreeField, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']> }>;
  DegreeLevelField: ResolverTypeWrapper<Omit<DegreeLevelField, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  DegreeSnippetField: ResolverTypeWrapper<Omit<DegreeSnippetField, 'degree'> & { degree?: Maybe<ResolversTypes['DegreeField']> }>;
  DegreeStatField: ResolverTypeWrapper<DegreeStatField>;
  DegreeType: DegreeType;
  DegreeTypeOrderField: ResolverTypeWrapper<DegreeTypeOrderField>;
  DegreeTypeOrderInput: DegreeTypeOrderInput;
  DeleteApplicantMutation: ResolverTypeWrapper<Omit<DeleteApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversTypes['ApplicantField']> }>;
  DeleteAttributeOptionsMutation: ResolverTypeWrapper<Omit<DeleteAttributeOptionsMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  DeleteCanonicalQuestion: ResolverTypeWrapper<DeleteCanonicalQuestion>;
  DeleteCommunityConversationDTO: DeleteCommunityConversationDto;
  DeleteCustomAttributesMutation: ResolverTypeWrapper<Omit<DeleteCustomAttributesMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  DeleteDegreeLevelMutation: ResolverTypeWrapper<DeleteDegreeLevelMutation>;
  DeleteFaqAnswer: ResolverTypeWrapper<DeleteFaqAnswer>;
  DeleteKnowledgeBaseEntriesByPatternMatchInput: DeleteKnowledgeBaseEntriesByPatternMatchInput;
  DeleteKnowledgeBaseEntriesByPatternMismatchInput: DeleteKnowledgeBaseEntriesByPatternMismatchInput;
  DeleteKnowledgeBaseEntriesByUrlListInput: DeleteKnowledgeBaseEntriesByUrlListInput;
  DeleteKnowledgeBaseEntriesOutput: ResolverTypeWrapper<DeleteKnowledgeBaseEntriesOutput>;
  DeleteLiveEventFeedMutation: ResolverTypeWrapper<Omit<DeleteLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversTypes['LiveEventChatGroupField']> }>;
  DeleteLiveEventMessageMutation: ResolverTypeWrapper<DeleteLiveEventMessageMutation>;
  DeleteLiveEventMutation: ResolverTypeWrapper<DeleteLiveEventMutation>;
  DeleteMessageDto: DeleteMessageDto;
  DeletePostMutation: ResolverTypeWrapper<DeletePostMutation>;
  DeleteRecordingResponse: ResolverTypeWrapper<DeleteRecordingResponse>;
  DeleteResearchTimeMutation: ResolverTypeWrapper<DeleteResearchTimeMutation>;
  DeleteSubTopicMutation: ResolverTypeWrapper<DeleteSubTopicMutation>;
  DeleteTopicMutation: ResolverTypeWrapper<DeleteTopicMutation>;
  DeleteUniversityUserMutation: ResolverTypeWrapper<Omit<DeleteUniversityUserMutation, 'universityUser'> & { universityUser?: Maybe<ResolversTypes['UniversityUserField']> }>;
  DeleteUserMutation: ResolverTypeWrapper<DeleteUserMutation>;
  DeleteYearOfStudyMutation: ResolverTypeWrapper<DeleteYearOfStudyMutation>;
  DepartmentSnippetField: ResolverTypeWrapper<DepartmentSnippetField>;
  DescriptionField: ResolverTypeWrapper<DescriptionField>;
  DeviceField: ResolverTypeWrapper<DeviceField>;
  DeviceMutation: ResolverTypeWrapper<DeviceMutation>;
  DeviceToken: ResolverTypeWrapper<DeviceToken>;
  DirectConversationDTO: DirectConversationDto;
  DirectMessagingApplicant: ResolverTypeWrapper<Omit<DirectMessagingApplicant, 'applicant' | 'chatGroup'> & { applicant?: Maybe<ResolversTypes['ApplicantField']>, chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  DirectMessagingEnquiryTeam: ResolverTypeWrapper<Omit<DirectMessagingEnquiryTeam, 'chatGroup' | 'university'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  DirectMessagingMentor: ResolverTypeWrapper<Omit<DirectMessagingMentor, 'chatGroup' | 'mentor'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, mentor?: Maybe<ResolversTypes['PublicMentorField']> }>;
  DirectMessagingStaffMember: ResolverTypeWrapper<Omit<DirectMessagingStaffMember, 'chatGroup' | 'staffMember'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, staffMember?: Maybe<ResolversTypes['BuddyField']> }>;
  Display: ResolverTypeWrapper<Display>;
  DomesticOrInternational: DomesticOrInternational;
  DomesticRegionField: ResolverTypeWrapper<Omit<DomesticRegionField, 'country'> & { country?: Maybe<ResolversTypes['CountryField']> }>;
  EditAlertMutation: ResolverTypeWrapper<EditAlertMutation>;
  EditAttributeOptionMutation: ResolverTypeWrapper<Omit<EditAttributeOptionMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EditBlogTopicMutation: ResolverTypeWrapper<EditBlogTopicMutation>;
  EditCommunityConversationDTO: EditCommunityConversationDto;
  EditCommunityDTO: EditCommunityDto;
  EditCustomAttributeMutation: ResolverTypeWrapper<Omit<EditCustomAttributeMutation, 'customAttribute'> & { customAttribute?: Maybe<ResolversTypes['CustomAttributeField']> }>;
  EditCustomAttributesMutation: ResolverTypeWrapper<Omit<EditCustomAttributesMutation, 'customAttributes'> & { customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeField']>>> }>;
  EditCustomWelcomeMessageMutation: ResolverTypeWrapper<Omit<EditCustomWelcomeMessageMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EditDegreeLevelMutation: ResolverTypeWrapper<Omit<EditDegreeLevelMutation, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']> }>;
  EditDegreeNameMutation: ResolverTypeWrapper<Omit<EditDegreeNameMutation, 'degree'> & { degree?: Maybe<ResolversTypes['DegreeField']> }>;
  EditDegreesMutation: ResolverTypeWrapper<Omit<EditDegreesMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>> }>;
  EditExternalEventMutation: ResolverTypeWrapper<EditExternalEventMutation>;
  EditLiveEventDetailsMutation: ResolverTypeWrapper<Omit<EditLiveEventDetailsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  EditLiveEventFeedMutation: ResolverTypeWrapper<Omit<EditLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversTypes['LiveEventChatGroupField']> }>;
  EditLiveEventMutation: ResolverTypeWrapper<Omit<EditLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  EditLiveEventsLandingPageMutation: ResolverTypeWrapper<EditLiveEventsLandingPageMutation>;
  EditOpenDayMutation: ResolverTypeWrapper<EditOpenDayMutation>;
  EditOrganisationMutation: ResolverTypeWrapper<Omit<EditOrganisationMutation, 'organisation'> & { organisation?: Maybe<ResolversTypes['OrganisationField']> }>;
  EditPostMutation: ResolverTypeWrapper<Omit<EditPostMutation, 'post'> & { post?: Maybe<ResolversTypes['BlogPostField']> }>;
  EditUniversityMutation: ResolverTypeWrapper<Omit<EditUniversityMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EditYearOfStudyMutation: ResolverTypeWrapper<EditYearOfStudyMutation>;
  EmbeddedEventField: ResolverTypeWrapper<EmbeddedEventField>;
  EmbeddedEventSnippetField: ResolverTypeWrapper<EmbeddedEventSnippetField>;
  EnableCustomWelcomeMessageMutation: ResolverTypeWrapper<Omit<EnableCustomWelcomeMessageMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EnableCustomWelcomeMessageStaffMutation: ResolverTypeWrapper<Omit<EnableCustomWelcomeMessageStaffMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EnableFeaturesMutation: ResolverTypeWrapper<Omit<EnableFeaturesMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  EnrolledInsightResponse: ResolverTypeWrapper<Omit<EnrolledInsightResponse, 'university'> & { university: ResolversTypes['UniversityField'] }>;
  EnrolledInsightsInput: EnrolledInsightsInput;
  EnterpriseAddOns: ResolverTypeWrapper<EnterpriseAddOns>;
  EnterpriseMentorField: ResolverTypeWrapper<Omit<EnterpriseMentorField, 'degree' | 'linkedToOrganisations' | 'sourceOrganisation'> & { degree?: Maybe<ResolversTypes['DegreeField']>, linkedToOrganisations?: Maybe<Array<Maybe<ResolversTypes['OrganisationField']>>>, sourceOrganisation?: Maybe<ResolversTypes['OrganisationField']> }>;
  EntriesField: ResolverTypeWrapper<EntriesField>;
  EntriesInput: EntriesInput;
  EventPage: ResolverTypeWrapper<EventPage>;
  EventPageData: EventPageData;
  EventPagesDisplayedOn: ResolverTypeWrapper<EventPagesDisplayedOn>;
  ExportAnalyticsCsvMutation: ResolverTypeWrapper<ExportAnalyticsCsvMutation>;
  ExportTimeSheetDataField: ResolverTypeWrapper<ExportTimeSheetDataField>;
  ExportedReportField: ResolverTypeWrapper<ExportedReportField>;
  ExternalContent: ResolverTypeWrapper<ExternalContent>;
  ExternalContentData: ExternalContentData;
  ExternalEventField: ResolverTypeWrapper<ExternalEventField>;
  FaqAnswerField: ResolverTypeWrapper<Omit<FaqAnswerField, 'mentor'> & { mentor: ResolversTypes['MentorField'] }>;
  FeatureField: ResolverTypeWrapper<FeatureField>;
  FeatureInputField: FeatureInputField;
  FeatureNotificationRequestDTO: FeatureNotificationRequestDto;
  FeatureRulesDTO: ResolverTypeWrapper<FeatureRulesDto>;
  FeatureToggleInputField: FeatureToggleInputField;
  FieldMappingField: ResolverTypeWrapper<FieldMappingField>;
  FieldMappingInput: FieldMappingInput;
  FilterUsersDTO: FilterUsersDto;
  FlagField: ResolverTypeWrapper<FlagField>;
  FormFieldValidationError: ResolverTypeWrapper<FormFieldValidationError>;
  ForwardApplicantToUniversity: ResolverTypeWrapper<Omit<ForwardApplicantToUniversity, 'chatGroup' | 'messages'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, messages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>> }>;
  GeckoUniversityData: ResolverTypeWrapper<GeckoUniversityData>;
  GenerateAnalyticsDashboardTokenMutation: ResolverTypeWrapper<GenerateAnalyticsDashboardTokenMutation>;
  GenerateLiveEventReport: ResolverTypeWrapper<Omit<GenerateLiveEventReport, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  GenerateRecommendationsInput: GenerateRecommendationsInput;
  GenericScalar: ResolverTypeWrapper<Scalars['GenericScalar']['output']>;
  GetAssistantConversationInput: GetAssistantConversationInput;
  GetChatReportsDTO: GetChatReportsDto;
  GetDownloadableURLMutation: ResolverTypeWrapper<GetDownloadableUrlMutation>;
  GetInvitesForEmailDTO: ResolverTypeWrapper<Omit<GetInvitesForEmailDto, 'community'> & { community: ResolversTypes['Community'] }>;
  GetMarketplaceApplicantMutation: ResolverTypeWrapper<Omit<GetMarketplaceApplicantMutation, 'authenticatedApplicant'> & { authenticatedApplicant?: Maybe<ResolversTypes['AuthField']> }>;
  GetMessageDto: GetMessageDto;
  GetOrCreateApiKeyMutation: ResolverTypeWrapper<GetOrCreateApiKeyMutation>;
  GetRandomAmbassadorsInput: GetRandomAmbassadorsInput;
  GetRecordingFailureIdsArgs: GetRecordingFailureIdsArgs;
  GetRecordingFailureIdsResponse: ResolverTypeWrapper<GetRecordingFailureIdsResponse>;
  GetSignedS3PostFieldsMutation: ResolverTypeWrapper<GetSignedS3PostFieldsMutation>;
  GetSignedS3UrlMutation: ResolverTypeWrapper<GetSignedS3UrlMutation>;
  GetUserReportsDTO: GetUserReportsDto;
  GifDto: GifDto;
  GifType: GifType;
  Giphy: ResolverTypeWrapper<Giphy>;
  GraphField: ResolverTypeWrapper<GraphField>;
  GraphQLOffsetPaginationInput: GraphQlOffsetPaginationInput;
  GroupField: ResolverTypeWrapper<GroupField>;
  HideMentorInMarketplaceMutation: ResolverTypeWrapper<Omit<HideMentorInMarketplaceMutation, 'mentor'> & { mentor?: Maybe<ResolversTypes['MentorField']> }>;
  HighSchoolField: ResolverTypeWrapper<HighSchoolField>;
  HighSchoolTypeField: ResolverTypeWrapper<HighSchoolTypeField>;
  HousingCategory: HousingCategory;
  HousingInput: HousingInput;
  HousingObject: ResolverTypeWrapper<HousingObject>;
  Image: ResolverTypeWrapper<Image>;
  ImageDto: ImageDto;
  InboxItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['InboxItemInterface']>;
  InboxItemLastMessageField: ResolverTypeWrapper<InboxItemLastMessageField>;
  InboxItemUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InboxItemUnion']>;
  InboxPromptAnswer: ResolverTypeWrapper<InboxPromptAnswer>;
  InboxPromptAnswerInput: InboxPromptAnswerInput;
  InboxPromptAnswerInputItem: InboxPromptAnswerInputItem;
  InboxPromptInput: InboxPromptInput;
  InboxPromptOption: ResolverTypeWrapper<InboxPromptOption>;
  InboxPromptQuestion: ResolverTypeWrapper<InboxPromptQuestion>;
  InboxUniversityField: ResolverTypeWrapper<InboxUniversityField>;
  InitialiseRecordingArgs: InitialiseRecordingArgs;
  InitialiseRecordingResponse: ResolverTypeWrapper<InitialiseRecordingResponse>;
  InputField: ResolverTypeWrapper<InputField>;
  Insights: ResolverTypeWrapper<Insights>;
  InsightsField: ResolverTypeWrapper<InsightsField>;
  Interest: ResolverTypeWrapper<Interest>;
  InterestInput: InterestInput;
  InterestObject: ResolverTypeWrapper<InterestObject>;
  InterventionMessageField: ResolverTypeWrapper<Omit<InterventionMessageField, 'message'> & { message?: Maybe<ResolversTypes['MessageField']> }>;
  Invite: ResolverTypeWrapper<Invite>;
  InviteApplicantsMutation: ResolverTypeWrapper<InviteApplicantsMutation>;
  InviteBuddiesMutation: ResolverTypeWrapper<InviteBuddiesMutation>;
  InviteFilter: InviteFilter;
  InviteInformation: ResolverTypeWrapper<Omit<InviteInformation, 'community' | 'university'> & { community: ResolversTypes['Community'], university: ResolversTypes['UniversityField'] }>;
  InviteInformationInput: InviteInformationInput;
  InviteLinkDto: ResolverTypeWrapper<InviteLinkDto>;
  InviteLinkInfoDto: ResolverTypeWrapper<InviteLinkInfoDto>;
  InviteLinkInput: InviteLinkInput;
  InviteMentorsMutation: ResolverTypeWrapper<InviteMentorsMutation>;
  InviteMethods: InviteMethods;
  InviteStatus: InviteStatus;
  IsoDateTime: ResolverTypeWrapper<Scalars['IsoDateTime']['output']>;
  JSONString: ResolverTypeWrapper<Scalars['JSONString']['output']>;
  JoinChatGroupMutation: ResolverTypeWrapper<Omit<JoinChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  KnowledgeBaseDeleteEntryInput: KnowledgeBaseDeleteEntryInput;
  KnowledgeBaseDeleteEntryOutput: ResolverTypeWrapper<KnowledgeBaseDeleteEntryOutput>;
  KnowledgeBaseEmbedding: ResolverTypeWrapper<KnowledgeBaseEmbedding>;
  KnowledgeBaseSourceQueryInput: KnowledgeBaseSourceQueryInput;
  KnowledgeBaseSourcesByUrl: ResolverTypeWrapper<KnowledgeBaseSourcesByUrl>;
  KnowledgeBaseSourcesListInput: KnowledgeBaseSourcesListInput;
  LabelSentenceMutation: ResolverTypeWrapper<LabelSentenceMutation>;
  LabellingField: ResolverTypeWrapper<LabellingField>;
  LabellingSentenceCandidate: ResolverTypeWrapper<LabellingSentenceCandidate>;
  Labels: ResolverTypeWrapper<Labels>;
  LanguageField: ResolverTypeWrapper<LanguageField>;
  LastMessageField: ResolverTypeWrapper<Omit<LastMessageField, 'sender'> & { sender?: Maybe<ResolversTypes['AnyUserField']> }>;
  LastRead: ResolverTypeWrapper<LastRead>;
  LeaveChatGroupMutation: ResolverTypeWrapper<Omit<LeaveChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  LevelSnippetField: ResolverTypeWrapper<LevelSnippetField>;
  LikeMessageDto: LikeMessageDto;
  LikeMessageMutation: ResolverTypeWrapper<LikeMessageMutation>;
  LimitedInt: ResolverTypeWrapper<Scalars['LimitedInt']['output']>;
  LinkOrganisationsMutation: ResolverTypeWrapper<LinkOrganisationsMutation>;
  ListAdminRecommendationInput: ListAdminRecommendationInput;
  ListBuddyApplicantConversationsField: ResolverTypeWrapper<Omit<ListBuddyApplicantConversationsField, 'conversations'> & { conversations?: Maybe<Array<Maybe<ResolversTypes['BuddyApplicantChatGroupFieldV2']>>> }>;
  ListMentorApplicantConversationsField: ResolverTypeWrapper<Omit<ListMentorApplicantConversationsField, 'conversations'> & { conversations?: Maybe<Array<Maybe<ResolversTypes['MentorApplicantChatGroupField']>>> }>;
  ListUniversityAssistantConversationsInput: ListUniversityAssistantConversationsInput;
  ListUniversityAssistantConversationsOutput: ResolverTypeWrapper<ListUniversityAssistantConversationsOutput>;
  LiveEventChatGroupField: ResolverTypeWrapper<Omit<LiveEventChatGroupField, 'applicants' | 'chatGroup' | 'mentors' | 'staff' | 'university' | 'universityUsers'> & { applicants?: Maybe<Array<Maybe<ResolversTypes['ApplicantField']>>>, chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, mentors?: Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, staff?: Maybe<Array<Maybe<ResolversTypes['UserField']>>>, university?: Maybe<ResolversTypes['UniversityField']>, universityUsers?: Maybe<Array<Maybe<ResolversTypes['UniversityUserField']>>> }>;
  LiveEventChatGroupsInputField: LiveEventChatGroupsInputField;
  LiveEventDetailedReport: ResolverTypeWrapper<LiveEventDetailedReport>;
  LiveEventDetailedReportChannelStats: ResolverTypeWrapper<LiveEventDetailedReportChannelStats>;
  LiveEventDetailedReportCountryStats: ResolverTypeWrapper<LiveEventDetailedReportCountryStats>;
  LiveEventDetailsField: ResolverTypeWrapper<LiveEventDetailsField>;
  LiveEventDirectMessaging: ResolverTypeWrapper<Omit<LiveEventDirectMessaging, 'applicants' | 'enquiryTeam' | 'mentors' | 'staff'> & { applicants?: Maybe<Array<Maybe<ResolversTypes['DirectMessagingApplicant']>>>, enquiryTeam?: Maybe<ResolversTypes['DirectMessagingEnquiryTeam']>, mentors?: Maybe<Array<Maybe<ResolversTypes['DirectMessagingMentor']>>>, staff?: Maybe<Array<Maybe<ResolversTypes['DirectMessagingStaffMember']>>> }>;
  LiveEventFeedbackFormMutation: ResolverTypeWrapper<Omit<LiveEventFeedbackFormMutation, 'feedBackForm'> & { feedBackForm?: Maybe<ResolversTypes['LiveEventProspectFeedbackFormField']> }>;
  LiveEventField: ResolverTypeWrapper<Omit<LiveEventField, 'allMentors' | 'allStaff' | 'directMessagingMentors' | 'directMessagingStaff' | 'inbox' | 'liveFeeds' | 'university'> & { allMentors?: Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, allStaff?: Maybe<Array<Maybe<ResolversTypes['BuddyField']>>>, directMessagingMentors?: Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, directMessagingStaff?: Maybe<Array<Maybe<ResolversTypes['BuddyField']>>>, inbox?: Maybe<ResolversTypes['LiveEventInboxField']>, liveFeeds?: Maybe<Array<Maybe<ResolversTypes['LiveEventChatGroupField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  LiveEventInboxField: ResolverTypeWrapper<Omit<LiveEventInboxField, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['InboxItemUnion']>>> }>;
  LiveEventLandingPageField: ResolverTypeWrapper<LiveEventLandingPageField>;
  LiveEventProspectFeedbackFormField: ResolverTypeWrapper<Omit<LiveEventProspectFeedbackFormField, 'liveEvent' | 'university' | 'user'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']>, university?: Maybe<ResolversTypes['UniversityField']>, user?: Maybe<ResolversTypes['UserField']> }>;
  LiveEventsFormFieldValidationError: ResolverTypeWrapper<LiveEventsFormFieldValidationError>;
  LiveSession: ResolverTypeWrapper<Omit<LiveSession, 'conversation' | 'presenters' | 'sessionAnalytics'> & { conversation: ResolversTypes['ChatConversation'], presenters: Array<ResolversTypes['UserField']>, sessionAnalytics: ResolversTypes['SessionAnalytics'] }>;
  Locale: ResolverTypeWrapper<Locale>;
  LocaleField: ResolverTypeWrapper<LocaleField>;
  LogoDataField: ResolverTypeWrapper<LogoDataField>;
  LogoutMutation: ResolverTypeWrapper<LogoutMutation>;
  ManageOrganisationAccessMutation: ResolverTypeWrapper<ManageOrganisationAccessMutation>;
  ManuallyClassifyMutation: ResolverTypeWrapper<ManuallyClassifyMutation>;
  MarkAssistantConversationAsViewedInput: MarkAssistantConversationAsViewedInput;
  MarkReadMessageDTO: MarkReadMessageDto;
  MarketplaceApplicantCountries: ResolverTypeWrapper<MarketplaceApplicantCountries>;
  MarketplaceApplicantData: MarketplaceApplicantData;
  MarketplaceApplicantDegreeCategories: ResolverTypeWrapper<MarketplaceApplicantDegreeCategories>;
  MarketplaceApplicantUserData: ResolverTypeWrapper<MarketplaceApplicantUserData>;
  MarketplaceField: ResolverTypeWrapper<MarketplaceField>;
  MarketplaceFilterInput: MarketplaceFilterInput;
  MarketplaceFilters: ResolverTypeWrapper<MarketplaceFilters>;
  MarketplaceInboxField: ResolverTypeWrapper<Omit<MarketplaceInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>> }>;
  MarketplaceMentorList: ResolverTypeWrapper<Omit<MarketplaceMentorList, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>> }>;
  MarketplaceSnippetField: ResolverTypeWrapper<MarketplaceSnippetField>;
  MatchedUser: ResolverTypeWrapper<Omit<MatchedUser, 'user'> & { user: ResolversTypes['UserField'] }>;
  MatchingCriteriaEnum: MatchingCriteriaEnum;
  MeField: ResolverTypeWrapper<Omit<MeField, 'admin' | 'anyUser' | 'applicant' | 'mentor' | 'staff' | 'universityUser'> & { admin?: Maybe<ResolversTypes['AdminUserField']>, anyUser?: Maybe<ResolversTypes['AnyUserField']>, applicant?: Maybe<ResolversTypes['ApplicantField']>, mentor?: Maybe<ResolversTypes['MentorField']>, staff?: Maybe<ResolversTypes['UserField']>, universityUser?: Maybe<ResolversTypes['UniversityUserField']> }>;
  MentorApplicantChatGroupField: ResolverTypeWrapper<Omit<MentorApplicantChatGroupField, 'applicant' | 'mentor'> & { applicant?: Maybe<ResolversTypes['ApplicantField']>, mentor?: Maybe<ResolversTypes['MentorField']> }>;
  MentorBroadcastMessageMutation: ResolverTypeWrapper<MentorBroadcastMessageMutation>;
  MentorChatUserField: ResolverTypeWrapper<MentorChatUserField>;
  MentorDegreeField: ResolverTypeWrapper<Omit<MentorDegreeField, 'degree'> & { degree?: Maybe<ResolversTypes['DegreeField']> }>;
  MentorDegreeFieldInput: MentorDegreeFieldInput;
  MentorDegreeHistory: ResolverTypeWrapper<Omit<MentorDegreeHistory, 'degree' | 'university'> & { degree?: Maybe<ResolversTypes['DegreeField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  MentorField: ResolverTypeWrapper<Omit<MentorField, 'country' | 'customAttributes' | 'degree' | 'degreeHistory' | 'degrees' | 'university'> & { country?: Maybe<ResolversTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, degree?: Maybe<ResolversTypes['DegreeField']>, degreeHistory?: Maybe<ResolversTypes['MentorDegreeHistory']>, degrees?: Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  MentorFieldOrderField: ResolverTypeWrapper<MentorFieldOrderField>;
  MentorFieldOrderInput: MentorFieldOrderInput;
  MentorFields: ResolverTypeWrapper<MentorFields>;
  MentorFilterField: ResolverTypeWrapper<MentorFilterField>;
  MentorFilterInputField: MentorFilterInputField;
  MentorFilterOptionField: ResolverTypeWrapper<MentorFilterOptionField>;
  MentorInboxField: ResolverTypeWrapper<Omit<MentorInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>> }>;
  MentorInterestField: ResolverTypeWrapper<MentorInterestField>;
  MentorInterventionQueryField: ResolverTypeWrapper<Omit<MentorInterventionQueryField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversTypes['MentorField']>>> }>;
  MentorIntroMessageField: ResolverTypeWrapper<Omit<MentorIntroMessageField, 'introMessage'> & { introMessage?: Maybe<ResolversTypes['MessageField']> }>;
  MentorInviteCountField: ResolverTypeWrapper<MentorInviteCountField>;
  MentorInviteField: ResolverTypeWrapper<MentorInviteField>;
  MentorListField: ResolverTypeWrapper<Omit<MentorListField, 'countries' | 'degrees' | 'mentors'> & { countries?: Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, mentors?: Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>> }>;
  MentorListFilterChoice: ResolverTypeWrapper<MentorListFilterChoice>;
  MentorListFilterChoiceInput: MentorListFilterChoiceInput;
  MentorModuleField: ResolverTypeWrapper<MentorModuleField>;
  MentorPreferencesField: ResolverTypeWrapper<MentorPreferencesField>;
  MentorSchoolHistoryField: ResolverTypeWrapper<MentorSchoolHistoryField>;
  MentorSnippetField: ResolverTypeWrapper<Omit<MentorSnippetField, 'mentor'> & { mentor?: Maybe<ResolversTypes['MentorField']> }>;
  MentorSocietyField: ResolverTypeWrapper<MentorSocietyField>;
  MentorcardSnippetField: ResolverTypeWrapper<Omit<MentorcardSnippetField, 'countrySnippets' | 'degreeSnippets' | 'mentorSnippets'> & { countrySnippets?: Maybe<Array<Maybe<ResolversTypes['CountrySnippetField']>>>, degreeSnippets?: Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>>, mentorSnippets?: Maybe<Array<Maybe<ResolversTypes['MentorSnippetField']>>> }>;
  MessageDto: MessageDto;
  MessageField: ResolverTypeWrapper<Omit<MessageField, 'input' | 'sender'> & { input?: Maybe<ResolversTypes['InputField']>, sender?: Maybe<ResolversTypes['AnyUserField']> }>;
  MessageMetadata: ResolverTypeWrapper<MessageMetadata>;
  MessagePublicBotMutation: ResolverTypeWrapper<Omit<MessagePublicBotMutation, 'botMessages'> & { botMessages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>> }>;
  Metadata: Metadata;
  MetricDataPoint: ResolverTypeWrapper<MetricDataPoint>;
  Mutation: ResolverTypeWrapper<{}>;
  NewsFeedGroup: ResolverTypeWrapper<NewsFeedGroup>;
  NotInterestedReasonEnum: NotInterestedReasonEnum;
  NotificationField: ResolverTypeWrapper<NotificationField>;
  ObjectID: ResolverTypeWrapper<Scalars['ObjectID']['output']>;
  ObjectId: ResolverTypeWrapper<Scalars['ObjectId']['output']>;
  OffsetPagination: OffsetPagination;
  OffsetPaginationDto: OffsetPaginationDto;
  OpenDayField: ResolverTypeWrapper<OpenDayField>;
  OpenDaysLoginField: ResolverTypeWrapper<OpenDaysLoginField>;
  OpenDaysSignupField: ResolverTypeWrapper<OpenDaysSignupField>;
  OpenTextFieldValueField: ResolverTypeWrapper<Omit<OpenTextFieldValueField, 'attribute'> & { attribute?: Maybe<ResolversTypes['CustomAttributeField']> }>;
  OrderByLiveSessionsInput: OrderByLiveSessionsInput;
  OrganisationBuddyLinkField: ResolverTypeWrapper<OrganisationBuddyLinkField>;
  OrganisationField: ResolverTypeWrapper<Omit<OrganisationField, 'childOrganisations' | 'university'> & { childOrganisations?: Maybe<Array<Maybe<ResolversTypes['ChildOrganisationField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  OrganisationType: OrganisationType;
  OriginField: OriginField;
  OutboxChatGroupField: ResolverTypeWrapper<Omit<OutboxChatGroupField, 'lastMessage' | 'members' | 'opponent'> & { lastMessage?: Maybe<ResolversTypes['LastMessageField']>, members?: Maybe<Array<Maybe<ResolversTypes['AnyUserField']>>>, opponent?: Maybe<ResolversTypes['AnyChatUserField']> }>;
  OutputField: ResolverTypeWrapper<OutputField>;
  PageMentorField: ResolverTypeWrapper<Omit<PageMentorField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversTypes['MentorField']>>> }>;
  PaginatedAdminRecommendation: ResolverTypeWrapper<Omit<PaginatedAdminRecommendation, 'items'> & { items: Array<ResolversTypes['AdminRecommendation']> }>;
  PaginatedApplicantInsightInput: PaginatedApplicantInsightInput;
  PaginatedApplicantInvite: ResolverTypeWrapper<PaginatedApplicantInvite>;
  PaginatedApplicationInsightModel: ResolverTypeWrapper<Omit<PaginatedApplicationInsightModel, 'items'> & { items: Array<ResolversTypes['ApplicationInsightModel']> }>;
  PaginatedChatMessages: ResolverTypeWrapper<Omit<PaginatedChatMessages, 'messages'> & { messages: Array<ResolversTypes['ChatMessage']> }>;
  PaginatedChatRooms: ResolverTypeWrapper<Omit<PaginatedChatRooms, 'items'> & { items: Array<ResolversTypes['ChatRoom']> }>;
  PaginatedEventPages: ResolverTypeWrapper<PaginatedEventPages>;
  PaginatedExternalContents: ResolverTypeWrapper<PaginatedExternalContents>;
  PaginatedLiveSessions: ResolverTypeWrapper<Omit<PaginatedLiveSessions, 'items'> & { items: Array<ResolversTypes['LiveSession']> }>;
  PaginatedVirtualEvents: ResolverTypeWrapper<Omit<PaginatedVirtualEvents, 'items'> & { items: Array<ResolversTypes['VirtualEvent']> }>;
  PaginationInput: PaginationInput;
  PasswordResetMobileMutation: ResolverTypeWrapper<PasswordResetMobileMutation>;
  PasswordResetMobileMutationV2: ResolverTypeWrapper<PasswordResetMobileMutationV2>;
  PayloadField: ResolverTypeWrapper<PayloadField>;
  PinMessageMutation: ResolverTypeWrapper<PinMessageMutation>;
  PinnedMessageField: ResolverTypeWrapper<PinnedMessageField>;
  PinnedMessageSenderField: ResolverTypeWrapper<PinnedMessageSenderField>;
  Poll: ResolverTypeWrapper<Poll>;
  PollDto: PollDto;
  PollOption: ResolverTypeWrapper<PollOption>;
  PollOptionDto: PollOptionDto;
  PopCardDegreeSnippetField: ResolverTypeWrapper<Omit<PopCardDegreeSnippetField, 'getSnippet'> & { getSnippet?: Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>> }>;
  PopCardLevelSnippetField: ResolverTypeWrapper<PopCardLevelSnippetField>;
  PopCardWidgetField: ResolverTypeWrapper<PopCardWidgetField>;
  PopcardSnippetField: ResolverTypeWrapper<Omit<PopcardSnippetField, 'degreeSnippets'> & { degreeSnippets?: Maybe<Array<Maybe<ResolversTypes['PopCardDegreeSnippetField']>>> }>;
  PostFields: ResolverTypeWrapper<PostFields>;
  PreferencesInputType: PreferencesInputType;
  PreferencesObjectType: ResolverTypeWrapper<PreferencesObjectType>;
  PreferencesOutputType: ResolverTypeWrapper<PreferencesOutputType>;
  Product: Product;
  ProspectStageStatField: ResolverTypeWrapper<ProspectStageStatField>;
  ProspectStageSummaryField: ResolverTypeWrapper<ProspectStageSummaryField>;
  PublicGroupStatus: PublicGroupStatus;
  PublicMentorField: ResolverTypeWrapper<Omit<PublicMentorField, 'country' | 'customAttributes' | 'degree' | 'degreeHistory' | 'degrees' | 'university'> & { country?: Maybe<ResolversTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, degree?: Maybe<ResolversTypes['DegreeField']>, degreeHistory?: Maybe<ResolversTypes['MentorDegreeHistory']>, degrees?: Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  PublicUserField: ResolverTypeWrapper<PublicUserField>;
  QssMetadata: QssMetadata;
  QssQuestion: QssQuestion;
  Query: ResolverTypeWrapper<{}>;
  QueryRecordingArgs: QueryRecordingArgs;
  QueryRecordingResponse: ResolverTypeWrapper<QueryRecordingResponse>;
  QuestionField: ResolverTypeWrapper<QuestionField>;
  RandomMentorsListField: ResolverTypeWrapper<Omit<RandomMentorsListField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>> }>;
  RangeDateInput: RangeDateInput;
  Reaction: ResolverTypeWrapper<Reaction>;
  ReactionDto: ReactionDto;
  ReadChatMutation: ResolverTypeWrapper<Omit<ReadChatMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  Recommendation: ResolverTypeWrapper<Recommendation>;
  RecommendationResourceType: ResolverTypeWrapper<RecommendationResourceType>;
  RecommendationResourceTypeEnum: RecommendationResourceTypeEnum;
  RecommendationSource: RecommendationSource;
  RecordUserActivityMutation: ResolverTypeWrapper<Omit<RecordUserActivityMutation, 'newActivity'> & { newActivity?: Maybe<ResolversTypes['ActivityField']> }>;
  RecordingConsent: ResolverTypeWrapper<RecordingConsent>;
  RecordingDownloadResponse: ResolverTypeWrapper<RecordingDownloadResponse>;
  RecordingFailureArgs: RecordingFailureArgs;
  RecordingFailureId: ResolverTypeWrapper<RecordingFailureId>;
  RecordingFailureResponse: ResolverTypeWrapper<RecordingFailureResponse>;
  RecordingListResponse: ResolverTypeWrapper<RecordingListResponse>;
  RecordingModel: ResolverTypeWrapper<RecordingModel>;
  RecordingResponse: ResolverTypeWrapper<RecordingResponse>;
  RecordingUploadingResponse: ResolverTypeWrapper<RecordingUploadingResponse>;
  RegisterToLiveEvent: ResolverTypeWrapper<RegisterToLiveEvent>;
  RejectRequestedPublicGroupInput: RejectRequestedPublicGroupInput;
  RemoveApplicantInsightInput: RemoveApplicantInsightInput;
  RemoveBuddyInvitesMutation: ResolverTypeWrapper<RemoveBuddyInvitesMutation>;
  RemoveDeviceMutation: ResolverTypeWrapper<RemoveDeviceMutation>;
  RemoveMembersFromCommunityInputDTO: RemoveMembersFromCommunityInputDto;
  RemoveMentorInvitesMutation: ResolverTypeWrapper<RemoveMentorInvitesMutation>;
  ReplyInputField: ReplyInputField;
  ReplyMessage: ResolverTypeWrapper<ReplyMessage>;
  ReplyMessageDto: ReplyMessageDto;
  ReplyOutputField: ResolverTypeWrapper<ReplyOutputField>;
  ReportAnalytics: ResolverTypeWrapper<ReportAnalytics>;
  RequestAnalyticsExportMutation: ResolverTypeWrapper<RequestAnalyticsExportMutation>;
  RequestPasswordResetMutation: ResolverTypeWrapper<RequestPasswordResetMutation>;
  RequestPasswordSetMutation: ResolverTypeWrapper<RequestPasswordSetMutation>;
  RequestedPublicGroup: ResolverTypeWrapper<Omit<RequestedPublicGroup, 'community' | 'conversation' | 'requestedBy' | 'resolvedBy'> & { community: ResolversTypes['Community'], conversation: ResolversTypes['ChatConversation'], requestedBy: ResolversTypes['UserField'], resolvedBy: ResolversTypes['UserField'] }>;
  ResearchTimeInput: ResearchTimeInput;
  ResearchTimeLogResult: ResolverTypeWrapper<ResearchTimeLogResult>;
  ResearchTimeResult: ResolverTypeWrapper<ResearchTimeResult>;
  ResetPasswordMobileMutation: ResolverTypeWrapper<ResetPasswordMobileMutation>;
  ResetPasswordMutation: ResolverTypeWrapper<ResetPasswordMutation>;
  ResetPasswordMutationV2: ResolverTypeWrapper<ResetPasswordMutationV2>;
  ResolveMessageDto: ResolveMessageDto;
  ResolveUniversityChatsMutation: ResolverTypeWrapper<Omit<ResolveUniversityChatsMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  ResolvedEnum: ResolvedEnum;
  RichContentDto: RichContentDto;
  RichContentInputField: RichContentInputField;
  RichContentOutputField: ResolverTypeWrapper<RichContentOutputField>;
  RichMessageContent: ResolverTypeWrapper<Omit<RichMessageContent, 'reply'> & { reply?: Maybe<ResolversTypes['ChatMessage']> }>;
  RootURLEnum: RootUrlEnum;
  RunManageCommandMutation: ResolverTypeWrapper<RunManageCommandMutation>;
  SatisfactionSurveyDTO: SatisfactionSurveyDto;
  SatisfactionSurveyEntity: ResolverTypeWrapper<SatisfactionSurveyEntity>;
  SaveAppliedUsersInput: SaveAppliedUsersInput;
  SaveAppliedUsersModel: ResolverTypeWrapper<SaveAppliedUsersModel>;
  SaveAssistantConversationEmailLeadInput: SaveAssistantConversationEmailLeadInput;
  SaveAssistantConversationFeedbackInput: SaveAssistantConversationFeedbackInput;
  SaveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
  SaveVisitedRecommendationInput: SaveVisitedRecommendationInput;
  ScrapeScope: ScrapeScope;
  ScraperJobStatus: ScraperJobStatus;
  ScraperTaskStatus: ScraperTaskStatus;
  SearchResult: ResolverTypeWrapper<SearchResult>;
  SendAssistantMessageInput: SendAssistantMessageInput;
  SendCommunityVerificationCode: ResolverTypeWrapper<SendCommunityVerificationCode>;
  SendFeedMessageMutation: ResolverTypeWrapper<Omit<SendFeedMessageMutation, 'message'> & { message?: Maybe<ResolversTypes['MessageField']> }>;
  SendLiveEventMessageMutation: ResolverTypeWrapper<Omit<SendLiveEventMessageMutation, 'botMessages' | 'chatGroup' | 'message'> & { botMessages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, message?: Maybe<ResolversTypes['MessageField']> }>;
  SendMessageMutation: ResolverTypeWrapper<Omit<SendMessageMutation, 'botMessages' | 'chatGroup' | 'message'> & { botMessages?: Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, message?: Maybe<ResolversTypes['MessageField']> }>;
  SendOpenDayProspectReport: ResolverTypeWrapper<SendOpenDayProspectReport>;
  SendResetPasswordEmail: ResolverTypeWrapper<SendResetPasswordEmail>;
  SendVerificationCode: ResolverTypeWrapper<SendVerificationCode>;
  SenderRole: SenderRole;
  SequenceFilterMentorListField: ResolverTypeWrapper<Omit<SequenceFilterMentorListField, 'countries' | 'degrees' | 'mentors'> & { countries?: Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, mentors?: Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>> }>;
  SessionAnalytics: ResolverTypeWrapper<Omit<SessionAnalytics, 'session'> & { session?: Maybe<ResolversTypes['LiveSession']> }>;
  SessionAttendeeAnalytics: ResolverTypeWrapper<SessionAttendeeAnalytics>;
  SessionAttendeeData: SessionAttendeeData;
  SessionAttendees: ResolverTypeWrapper<SessionAttendees>;
  SessionData: SessionData;
  SetActiveBlogTopicsMutation: ResolverTypeWrapper<SetActiveBlogTopicsMutation>;
  SetAllNotificationsReadMutation: ResolverTypeWrapper<SetAllNotificationsReadMutation>;
  SetArchivedContentBriefMutation: ResolverTypeWrapper<SetArchivedContentBriefMutation>;
  SetArchivedDegreeLevelMutation: ResolverTypeWrapper<Omit<SetArchivedDegreeLevelMutation, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversTypes['DegreeLevelField']> }>;
  SetArchivedYearOfStudyMutation: ResolverTypeWrapper<SetArchivedYearOfStudyMutation>;
  SetBuddiesListFilters: ResolverTypeWrapper<Omit<SetBuddiesListFilters, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  SetChatGroupLabelsMutation: ResolverTypeWrapper<Omit<SetChatGroupLabelsMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  SetDeviceTokenDTO: SetDeviceTokenDto;
  SetMentorFieldOrderMutation: ResolverTypeWrapper<Omit<SetMentorFieldOrderMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  SetMentorListFilterSelection: ResolverTypeWrapper<Omit<SetMentorListFilterSelection, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  SetOnlineMutation: ResolverTypeWrapper<SetOnlineMutation>;
  SetResolveChatGroupMutation: ResolverTypeWrapper<Omit<SetResolveChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversTypes['ChatGroupField']> }>;
  SetUserInterestsInput: SetUserInterestsInput;
  SetWillReplyMutation: ResolverTypeWrapper<SetWillReplyMutation>;
  SettingsDTO: SettingsDto;
  SettingsObjectType: ResolverTypeWrapper<SettingsObjectType>;
  ShowMentorInMarketplaceMutation: ResolverTypeWrapper<Omit<ShowMentorInMarketplaceMutation, 'mentor'> & { mentor?: Maybe<ResolversTypes['MentorField']> }>;
  SignUpsCount: ResolverTypeWrapper<SignUpsCount>;
  SignedS3POSTFields: ResolverTypeWrapper<SignedS3PostFields>;
  SignedS3URLField: ResolverTypeWrapper<SignedS3UrlField>;
  SingleChoiceAttributeField: ResolverTypeWrapper<SingleChoiceAttributeField>;
  SingleChoiceValueField: ResolverTypeWrapper<Omit<SingleChoiceValueField, 'attribute'> & { attribute?: Maybe<ResolversTypes['CustomAttributeField']> }>;
  SourceInputField: SourceInputField;
  SourceMetadataField: SourceMetadataField;
  SourceTrackingParamsField: ResolverTypeWrapper<SourceTrackingParamsField>;
  StaffBuddycardSnippetField: ResolverTypeWrapper<StaffBuddycardSnippetField>;
  StaffChatUserField: ResolverTypeWrapper<StaffChatUserField>;
  StaffContactByUniversityIdInput: StaffContactByUniversityIdInput;
  StaffContactInput: StaffContactInput;
  StaffContactOutput: ResolverTypeWrapper<StaffContactOutput>;
  StaffField: ResolverTypeWrapper<StaffField>;
  StaffFieldsChatUserField: ResolverTypeWrapper<StaffFieldsChatUserField>;
  StaffPopcardSnippetField: ResolverTypeWrapper<StaffPopcardSnippetField>;
  StaffProfileInformation: ResolverTypeWrapper<StaffProfileInformation>;
  StaffUserField: ResolverTypeWrapper<StaffUserField>;
  StaffUserFieldsField: ResolverTypeWrapper<StaffUserFieldsField>;
  StaffUserListField: ResolverTypeWrapper<StaffUserListField>;
  StartRecordingArgs: StartRecordingArgs;
  StateStatField: ResolverTypeWrapper<StateStatField>;
  StopRecordingArgs: StopRecordingArgs;
  SubTopicField: ResolverTypeWrapper<SubTopicField>;
  SubTopicStatField: ResolverTypeWrapper<SubTopicStatField>;
  SubTopicStatisticField: ResolverTypeWrapper<SubTopicStatisticField>;
  SuggestionField: ResolverTypeWrapper<Omit<SuggestionField, 'canonicalQuestions'> & { canonicalQuestions?: Maybe<Array<Maybe<ResolversTypes['CanonicalQuestionField']>>> }>;
  SwitchUniversitiesField: ResolverTypeWrapper<SwitchUniversitiesField>;
  SwitchUniversityField: ResolverTypeWrapper<SwitchUniversityField>;
  SwitchUniversityListField: ResolverTypeWrapper<SwitchUniversityListField>;
  Tag: Tag;
  TagField: ResolverTypeWrapper<TagField>;
  TargetAudienceDto: TargetAudienceDto;
  TextInLocale: ResolverTypeWrapper<TextInLocale>;
  TextInLocaleInput: TextInLocaleInput;
  TimeTakenField: ResolverTypeWrapper<TimeTakenField>;
  TodoAction: TodoAction;
  TodoStatus: TodoStatus;
  TodoTargetAudience: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TodoTargetAudience']>;
  TodoTargetAudienceType: TodoTargetAudienceType;
  TodosEntity: ResolverTypeWrapper<Omit<TodosEntity, 'targetAudience'> & { targetAudience: Array<ResolversTypes['TodoTargetAudience']> }>;
  ToggleCrmIntegrationSync: ResolverTypeWrapper<ToggleCrmIntegrationSync>;
  ToggleCustomAttributeCrmSyncMutation: ResolverTypeWrapper<ToggleCustomAttributeCrmSyncMutation>;
  ToggleDegreesActiveMutation: ResolverTypeWrapper<Omit<ToggleDegreesActiveMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversTypes['DegreeField']>>> }>;
  ToggleFeatureAvailabilityMutation: ResolverTypeWrapper<Omit<ToggleFeatureAvailabilityMutation, 'university'> & { university?: Maybe<ResolversTypes['UniversityField']> }>;
  TopCountryField: ResolverTypeWrapper<TopCountryField>;
  TopDegreeField: ResolverTypeWrapper<TopDegreeField>;
  TopDomesticRegionField: ResolverTypeWrapper<TopDomesticRegionField>;
  TopRegionField: ResolverTypeWrapper<TopRegionField>;
  TopSubTopicField: ResolverTypeWrapper<TopSubTopicField>;
  TopTopicField: ResolverTypeWrapper<TopTopicField>;
  TopicField: ResolverTypeWrapper<TopicField>;
  TopicSnippetField: ResolverTypeWrapper<TopicSnippetField>;
  TopicStatisticField: ResolverTypeWrapper<TopicStatisticField>;
  TopicsStatField: ResolverTypeWrapper<TopicsStatField>;
  TrackLiveEventMutation: ResolverTypeWrapper<Omit<TrackLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  TrackOpenDayMutation: ResolverTypeWrapper<TrackOpenDayMutation>;
  TrendingTopicsField: ResolverTypeWrapper<TrendingTopicsField>;
  TriggeredFromEnum: TriggeredFromEnum;
  UniversityAssistantConfiguration: ResolverTypeWrapper<UniversityAssistantConfiguration>;
  UniversityAssistantConfigurationEventInput: UniversityAssistantConfigurationEventInput;
  UniversityAssistantConfigurationEventOutput: ResolverTypeWrapper<UniversityAssistantConfigurationEventOutput>;
  UniversityAssistantConfigurationEventUrls: ResolverTypeWrapper<UniversityAssistantConfigurationEventUrls>;
  UniversityAssistantConfigurationPromptContextInput: UniversityAssistantConfigurationPromptContextInput;
  UniversityAssistantConfigurationPromptContextOutput: ResolverTypeWrapper<UniversityAssistantConfigurationPromptContextOutput>;
  UniversityAssistantConfigurationScrapeIgnoreUrlsInput: UniversityAssistantConfigurationScrapeIgnoreUrlsInput;
  UniversityAssistantConfigurationScrapeIgnoreUrlsOutput: ResolverTypeWrapper<UniversityAssistantConfigurationScrapeIgnoreUrlsOutput>;
  UniversityAssistantConfigurationScrapeStartPointInput: UniversityAssistantConfigurationScrapeStartPointInput;
  UniversityAssistantConfigurationScrapeStartPointOutput: ResolverTypeWrapper<UniversityAssistantConfigurationScrapeStartPointOutput>;
  UniversityAssistantConversation: ResolverTypeWrapper<UniversityAssistantConversation>;
  UniversityAssistantScrapeIgnoreUrls: ResolverTypeWrapper<UniversityAssistantScrapeIgnoreUrls>;
  UniversityAssistantScrapeIgnoreUrlsInput: UniversityAssistantScrapeIgnoreUrlsInput;
  UniversityBlockReportField: ResolverTypeWrapper<Omit<UniversityBlockReportField, 'blocked' | 'blocker' | 'chatGroup' | 'university'> & { blocked?: Maybe<ResolversTypes['ApplicantField']>, blocker?: Maybe<ResolversTypes['AnyUserField']>, chatGroup?: Maybe<ResolversTypes['ChatGroupField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  UniversityBlockUsersMutation: ResolverTypeWrapper<UniversityBlockUsersMutation>;
  UniversityBlogPostsField: ResolverTypeWrapper<Omit<UniversityBlogPostsField, 'blogPosts'> & { blogPosts?: Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>> }>;
  UniversityChatInboxField: ResolverTypeWrapper<Omit<UniversityChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<ResolversTypes['ChatUserField']>>> }>;
  UniversityConfigField: ResolverTypeWrapper<UniversityConfigField>;
  UniversityContent: ResolverTypeWrapper<UniversityContent>;
  UniversityContentInput: UniversityContentInput;
  UniversityFeatureField: ResolverTypeWrapper<UniversityFeatureField>;
  UniversityField: ResolverTypeWrapper<Omit<UniversityField, 'buddiesListFilters' | 'country' | 'customAttribute' | 'customAttributes'> & { buddiesListFilters?: Maybe<Array<Maybe<ResolversTypes['BuddiesListFilterField']>>>, country?: Maybe<ResolversTypes['CountryField']>, customAttribute?: Maybe<ResolversTypes['CustomAttributeField']>, customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeField']>>> }>;
  UniversityInboxField: ResolverTypeWrapper<Omit<UniversityInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>> }>;
  UniversityInterestedDTO: UniversityInterestedDto;
  UniversityInterestedEntity: ResolverTypeWrapper<UniversityInterestedEntity>;
  UniversityMarketplaceField: ResolverTypeWrapper<UniversityMarketplaceField>;
  UniversityMarketplaceInput: UniversityMarketplaceInput;
  UniversityOutput: ResolverTypeWrapper<UniversityOutput>;
  UniversityQuestion: ResolverTypeWrapper<UniversityQuestion>;
  UniversityQuestionAnswer: ResolverTypeWrapper<UniversityQuestionAnswer>;
  UniversityQuestionAnswerInput: UniversityQuestionAnswerInput;
  UniversityQuestionAnswerInputItem: UniversityQuestionAnswerInputItem;
  UniversityQuestionByIdInput: UniversityQuestionByIdInput;
  UniversityQuestionContext: ResolverTypeWrapper<UniversityQuestionContext>;
  UniversityQuestionContextInput: UniversityQuestionContextInput;
  UniversityQuestionInput: UniversityQuestionInput;
  UniversityQuestionOption: ResolverTypeWrapper<UniversityQuestionOption>;
  UniversityQuestionType: UniversityQuestionType;
  UniversityScrapeIndexingOutput: ResolverTypeWrapper<UniversityScrapeIndexingOutput>;
  UniversityScrapeIndexingQueryInput: UniversityScrapeIndexingQueryInput;
  UniversityScrapeInput: UniversityScrapeInput;
  UniversityScrapeManualInput: UniversityScrapeManualInput;
  UniversityScrapeOutput: ResolverTypeWrapper<UniversityScrapeOutput>;
  UniversityScrapeStopOutput: ResolverTypeWrapper<UniversityScrapeStopOutput>;
  UniversityScrapeTask: ResolverTypeWrapper<UniversityScrapeTask>;
  UniversitySnippetField: ResolverTypeWrapper<Omit<UniversitySnippetField, 'blogcardSnippets' | 'courseWidgetSnippets' | 'mentorcardExternalSnippets' | 'mentorcardInternalSnippets' | 'popcardSnippets' | 'university'> & { blogcardSnippets?: Maybe<ResolversTypes['BlogcardSnippetField']>, courseWidgetSnippets?: Maybe<ResolversTypes['CourseSnippetField']>, mentorcardExternalSnippets?: Maybe<ResolversTypes['MentorcardSnippetField']>, mentorcardInternalSnippets?: Maybe<ResolversTypes['MentorcardSnippetField']>, popcardSnippets?: Maybe<ResolversTypes['PopcardSnippetField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  UniversityStopCrawlInput: UniversityStopCrawlInput;
  UniversityUserField: ResolverTypeWrapper<Omit<UniversityUserField, 'preferences' | 'university'> & { preferences?: Maybe<ResolversTypes['UniversityUserPreferencesField']>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  UniversityUserPreferencesField: ResolverTypeWrapper<UniversityUserPreferencesField>;
  UnpinMessageMutation: ResolverTypeWrapper<UnpinMessageMutation>;
  UnreadCountField: ResolverTypeWrapper<UnreadCountField>;
  UnreadMessageCountField: ResolverTypeWrapper<UnreadMessageCountField>;
  UpdateApplicantMutation: ResolverTypeWrapper<Omit<UpdateApplicantMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateApplicantPreferencesMutation: ResolverTypeWrapper<Omit<UpdateApplicantPreferencesMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateCanonicalQuestion: ResolverTypeWrapper<Omit<UpdateCanonicalQuestion, 'canonicalQuestion'> & { canonicalQuestion?: Maybe<ResolversTypes['CanonicalQuestionField']> }>;
  UpdateChatRoomInput: UpdateChatRoomInput;
  UpdateCommunityApplicantSignupSourceMutation: ResolverTypeWrapper<Omit<UpdateCommunityApplicantSignupSourceMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateDirectMessagingMembersForLiveEventMutation: ResolverTypeWrapper<Omit<UpdateDirectMessagingMembersForLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversTypes['LiveEventField']> }>;
  UpdateEventPageInput: UpdateEventPageInput;
  UpdateExternalContentInput: UpdateExternalContentInput;
  UpdateFaqAnswer: ResolverTypeWrapper<Omit<UpdateFaqAnswer, 'faqAnswer'> & { faqAnswer?: Maybe<ResolversTypes['FaqAnswerField']> }>;
  UpdateHobsonsConnectIntegration: ResolverTypeWrapper<UpdateHobsonsConnectIntegration>;
  UpdateIntegrationFieldMapping: ResolverTypeWrapper<UpdateIntegrationFieldMapping>;
  UpdateLiveEventFeedSessionDataMutation: ResolverTypeWrapper<Omit<UpdateLiveEventFeedSessionDataMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversTypes['LiveEventChatGroupField']> }>;
  UpdateLiveSessionAnyUserInput: UpdateLiveSessionAnyUserInput;
  UpdateLiveSessionInput: UpdateLiveSessionInput;
  UpdateManyUserMutation: ResolverTypeWrapper<UpdateManyUserMutation>;
  UpdateMarketplaceApplicantMutation: ResolverTypeWrapper<Omit<UpdateMarketplaceApplicantMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateMarketplaceApplicantUniversityLinkMutation: ResolverTypeWrapper<Omit<UpdateMarketplaceApplicantUniversityLinkMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateMarketplaceMutation: ResolverTypeWrapper<UpdateMarketplaceMutation>;
  UpdateMentorMutation: ResolverTypeWrapper<Omit<UpdateMentorMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateMentorPreferences: ResolverTypeWrapper<UpdateMentorPreferences>;
  UpdateMyUniversityLinkMutation: ResolverTypeWrapper<Omit<UpdateMyUniversityLinkMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdatePostStatusMutation: ResolverTypeWrapper<Omit<UpdatePostStatusMutation, 'blogPost'> & { blogPost?: Maybe<ResolversTypes['BlogPostField']> }>;
  UpdateRecordingLayoutArgs: UpdateRecordingLayoutArgs;
  UpdateResearchTimeMutation: ResolverTypeWrapper<UpdateResearchTimeMutation>;
  UpdateStaffContactInput: UpdateStaffContactInput;
  UpdateStaffMutation: ResolverTypeWrapper<Omit<UpdateStaffMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateSubTopicMutation: ResolverTypeWrapper<UpdateSubTopicMutation>;
  UpdateTagMutation: ResolverTypeWrapper<UpdateTagMutation>;
  UpdateTopicMutation: ResolverTypeWrapper<UpdateTopicMutation>;
  UpdateUniversityBlockReportMutation: ResolverTypeWrapper<Omit<UpdateUniversityBlockReportMutation, 'universityBlockReport'> & { universityBlockReport?: Maybe<ResolversTypes['UniversityBlockReportField']> }>;
  UpdateUniversityConfigMutation: ResolverTypeWrapper<UpdateUniversityConfigMutation>;
  UpdateUniversityUserMutation: ResolverTypeWrapper<Omit<UpdateUniversityUserMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateUniversityUserPreferencesMutation: ResolverTypeWrapper<Omit<UpdateUniversityUserPreferencesMutation, 'me'> & { me?: Maybe<ResolversTypes['MeField']> }>;
  UpdateUserMutation: ResolverTypeWrapper<Omit<UpdateUserMutation, 'user'> & { user?: Maybe<ResolversTypes['UserField']> }>;
  UpdateUserPreferences: ResolverTypeWrapper<UpdateUserPreferences>;
  UpdateUserProfile: UpdateUserProfile;
  UpdateVirtualEventInput: UpdateVirtualEventInput;
  UpdatedResults: ResolverTypeWrapper<UpdatedResults>;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UserCustomAttributesFilterField: ResolverTypeWrapper<UserCustomAttributesFilterField>;
  UserDecisionStageInput: UserDecisionStageInput;
  UserDecisionStageOutput: ResolverTypeWrapper<UserDecisionStageOutput>;
  UserDegreeField: ResolverTypeWrapper<UserDegreeField>;
  UserDirectoryResult: ResolverTypeWrapper<Omit<UserDirectoryResult, 'result'> & { result: Array<ResolversTypes['UserField']> }>;
  UserField: ResolverTypeWrapper<Omit<UserField, 'blockedByMentors' | 'blockedByUniversities' | 'communities' | 'communityProfile' | 'country' | 'customAttributes' | 'university'> & { blockedByMentors?: Maybe<Array<Maybe<ResolversTypes['BlockerField']>>>, blockedByUniversities?: Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, communities?: Maybe<Array<ResolversTypes['Community']>>, communityProfile?: Maybe<ResolversTypes['UserProfile']>, country?: Maybe<ResolversTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, university?: Maybe<ResolversTypes['UniversityField']> }>;
  UserIdsListField: ResolverTypeWrapper<UserIdsListField>;
  UserInterest: ResolverTypeWrapper<UserInterest>;
  UserListField: ResolverTypeWrapper<Omit<UserListField, 'users'> & { users?: Maybe<Array<Maybe<ResolversTypes['UserField']>>> }>;
  UserLocalePreference: ResolverTypeWrapper<UserLocalePreference>;
  UserLocalePreferenceInput: UserLocalePreferenceInput;
  UserNotInterestedStageInput: UserNotInterestedStageInput;
  UserPartialSearchFields: ResolverTypeWrapper<UserPartialSearchFields>;
  UserPermissionsListField: ResolverTypeWrapper<UserPermissionsListField>;
  UserPreferencesField: ResolverTypeWrapper<UserPreferencesField>;
  UserProfile: ResolverTypeWrapper<Omit<UserProfile, 'areaOfStudy'> & { areaOfStudy?: Maybe<Array<ResolversTypes['DegreeField']>> }>;
  UserRecommendation: ResolverTypeWrapper<Omit<UserRecommendation, 'currentUser' | 'matches'> & { currentUser: ResolversTypes['UserField'], matches: Array<ResolversTypes['MatchedUser']> }>;
  UserReport: ResolverTypeWrapper<Omit<UserReport, 'community' | 'moderator' | 'reportee' | 'reporter' | 'university'> & { community?: Maybe<ResolversTypes['Community']>, moderator?: Maybe<ResolversTypes['UserField']>, reportee: ResolversTypes['UserField'], reporter: ResolversTypes['UserField'], university: ResolversTypes['UniversityField'] }>;
  UserReportModeratorInputDTO: UserReportModeratorInputDto;
  UserReportUserInputDTO: UserReportUserInputDto;
  UserTimeSheetExportField: ResolverTypeWrapper<UserTimeSheetExportField>;
  UserTimeSpentBreakdown: ResolverTypeWrapper<UserTimeSpentBreakdown>;
  UserTimeSpentStatsField: ResolverTypeWrapper<UserTimeSpentStatsField>;
  UsersTimeSpentData: ResolverTypeWrapper<UsersTimeSpentData>;
  VerifyAccount: ResolverTypeWrapper<VerifyAccount>;
  VerifyCodeField: ResolverTypeWrapper<VerifyCodeField>;
  VideoContent: ResolverTypeWrapper<VideoContent>;
  VideoFile: ResolverTypeWrapper<VideoFile>;
  VideoSession: VideoSession;
  VideoSessionField: ResolverTypeWrapper<VideoSessionField>;
  VideoSessionToUpdateField: VideoSessionToUpdateField;
  VideoStatus: VideoStatus;
  VideoTypeEnum: VideoTypeEnum;
  VideoUploadLink: ResolverTypeWrapper<VideoUploadLink>;
  VideoUploadLinkInput: VideoUploadLinkInput;
  VideoUploadPresignedFields: ResolverTypeWrapper<VideoUploadPresignedFields>;
  VideoUrl: ResolverTypeWrapper<VideoUrl>;
  ViewBlogMutation: ResolverTypeWrapper<Omit<ViewBlogMutation, 'post'> & { post?: Maybe<ResolversTypes['BlogPostField']> }>;
  VirtualEvent: ResolverTypeWrapper<Omit<VirtualEvent, 'university'> & { university: ResolversTypes['UniversityField'] }>;
  WidgetConversationDto: WidgetConversationDto;
  WidgetSnippetField: ResolverTypeWrapper<WidgetSnippetField>;
  WidgetUrlField: ResolverTypeWrapper<WidgetUrlField>;
  WidgetUrlsInput: WidgetUrlsInput;
  WillReplyField: ResolverTypeWrapper<WillReplyField>;
  YearOfStudyField: ResolverTypeWrapper<YearOfStudyField>;
  pinMessageDTO: PinMessageDto;
  unpinMessageDTO: UnpinMessageDto;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptRequestedPublicGroupInput: AcceptRequestedPublicGroupInput;
  ID: Scalars['ID']['output'];
  String: Scalars['String']['output'];
  Boolean: Scalars['Boolean']['output'];
  ActivateApplicantsMutation: ActivateApplicantsMutation;
  Int: Scalars['Int']['output'];
  ActivateMentorsMutation: ActivateMentorsMutation;
  ActivityField: Omit<ActivityField, 'user'> & { user?: Maybe<ResolversParentTypes['AnyUserField']> };
  ActivitySourceField: ActivitySourceField;
  AddAttributeOptionMutation: Omit<AddAttributeOptionMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  AddBotToChatGroupMutation: Omit<AddBotToChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  AddCustomAttributeMutation: Omit<AddCustomAttributeMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  AddDegreeLevelsMutation: Omit<AddDegreeLevelsMutation, 'degreeLevels'> & { degreeLevels?: Maybe<Array<Maybe<ResolversParentTypes['DegreeLevelField']>>> };
  AddDegreesMutation: Omit<AddDegreesMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>> };
  AddHobsonsConnectIntegration: AddHobsonsConnectIntegration;
  AddLocalesToApp: AddLocalesToApp;
  AddResearchTimeMutation: AddResearchTimeMutation;
  AddYearOfStudyMutation: AddYearOfStudyMutation;
  AdminDeleteApplicantMutation: Omit<AdminDeleteApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  AdminRecommendation: Omit<AdminRecommendation, 'cohort'> & { cohort?: Maybe<ResolversParentTypes['Cohort']> };
  AdminRecommendationCountPerDecisionStage: AdminRecommendationCountPerDecisionStage;
  AdminRecommendationInput: AdminRecommendationInput;
  AdminUpdateMentorMutation: Omit<AdminUpdateMentorMutation, 'mentor'> & { mentor?: Maybe<ResolversParentTypes['MentorField']> };
  AdminUserField: AdminUserField;
  AgeVerificationInfoField: AgeVerificationInfoField;
  AgeVerificationInfoInputField: AgeVerificationInfoInputField;
  AlertField: AlertField;
  AllPostsField: Omit<AllPostsField, 'blogPosts' | 'blogPostsDegrees'> & { blogPosts?: Maybe<Array<Maybe<ResolversParentTypes['BlogPostField']>>>, blogPostsDegrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>> };
  AmbassadorField: AmbassadorField;
  AmbassadorProfileInformation: AmbassadorProfileInformation;
  AmbassadorRecommendation: AmbassadorRecommendation;
  AmbassadorRecommendationInput: AmbassadorRecommendationInput;
  AmbassadorRecommendationResourceType: AmbassadorRecommendationResourceType;
  Analytics: Analytics;
  Float: Scalars['Float']['output'];
  AnalyticsBuddyField: AnalyticsBuddyField;
  AnalyticsDashboardAuthField: AnalyticsDashboardAuthField;
  AnalyticsDashboardMetadata: AnalyticsDashboardMetadata;
  AnalyticsMentorField: AnalyticsMentorField;
  AnyChatUserField: Omit<AnyChatUserField, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversParentTypes['MentorDegreeField']>>> };
  AnyUserField: Omit<AnyUserField, 'country' | 'degree' | 'degrees' | 'university'> & { country?: Maybe<ResolversParentTypes['CountryField']>, degree?: Maybe<ResolversParentTypes['DegreeField']>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['MentorDegreeField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  AppLocaleField: AppLocaleField;
  AppLocalesFieldInput: AppLocalesFieldInput;
  ApplicantBroadcastMessageMutation: ApplicantBroadcastMessageMutation;
  ApplicantCollectionField: ApplicantCollectionField;
  ApplicantConversationField: ApplicantConversationField;
  ApplicantCountField: ApplicantCountField;
  ApplicantField: Omit<ApplicantField, 'ageVerificationInfo' | 'applicantUniversities' | 'country' | 'degreeLevel' | 'degreesInterested' | 'linkWithUniversity' | 'universitiesApplied' | 'universitiesInterested'> & { ageVerificationInfo?: Maybe<ResolversParentTypes['AgeVerificationInfoField']>, applicantUniversities?: Maybe<Array<Maybe<ResolversParentTypes['ApplicantUniversityLinkField']>>>, country?: Maybe<ResolversParentTypes['CountryField']>, degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']>, degreesInterested?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, linkWithUniversity?: Maybe<ResolversParentTypes['ApplicantUniversityLinkField']>, universitiesApplied?: Maybe<Array<Maybe<ResolversParentTypes['ApplicantUniversityLinkField']>>>, universitiesInterested?: Maybe<Array<Maybe<ResolversParentTypes['UniversityField']>>> };
  ApplicantInboxField: Omit<ApplicantInboxField, 'botChatGroup' | 'chatGroups' | 'universityClearingChatGroup'> & { botChatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, chatGroups?: Maybe<Array<Maybe<ResolversParentTypes['ChatGroupField']>>>, universityClearingChatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  ApplicantInvite: ApplicantInvite;
  ApplicantLabelField: ApplicantLabelField;
  ApplicantMarketplaceInput: ApplicantMarketplaceInput;
  ApplicantMarketplaceObjectField: ApplicantMarketplaceObjectField;
  ApplicantPreferencesField: ApplicantPreferencesField;
  ApplicantSchoolHistory: ApplicantSchoolHistory;
  ApplicantSignupStats: ApplicantSignupStats;
  ApplicantUniversityLinkField: Omit<ApplicantUniversityLinkField, 'customAttributes' | 'degreeLevel' | 'degreesInterested' | 'university'> & { customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeValueField']>>>, degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']>, degreesInterested?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  ApplicantUserField: ApplicantUserField;
  ApplicantsAppliedStats: ApplicantsAppliedStats;
  ApplicantsMessagedCount: ApplicantsMessagedCount;
  ApplicationField: ApplicationField;
  ApplicationInsightModel: Omit<ApplicationInsightModel, 'university'> & { university: ResolversParentTypes['UniversityField'] };
  AppliedUsersCountInput: AppliedUsersCountInput;
  AppliedUsersCountModel: AppliedUsersCountModel;
  AssistantConversationFeedback: AssistantConversationFeedback;
  AssistantConversationHistory: AssistantConversationHistory;
  AssistantConversationHistoryWithToken: AssistantConversationHistoryWithToken;
  AssistantConversationLead: AssistantConversationLead;
  AssistantConversationMessage: AssistantConversationMessage;
  AssistantMessageFeedback: AssistantMessageFeedback;
  AssistantMessageFeedbackInput: AssistantMessageFeedbackInput;
  Attachment: Attachment;
  AttachmentDto: AttachmentDto;
  AttachmentField: AttachmentField;
  AttendeeAnalytics: AttendeeAnalytics;
  AttendeeData: AttendeeData;
  Attendees: Attendees;
  AuthField: Omit<AuthField, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  AuthorSnippetField: Omit<AuthorSnippetField, 'author'> & { author?: Maybe<ResolversParentTypes['MentorField']> };
  BaseCustomAttributeField: BaseCustomAttributeField;
  BlockUserMutation: BlockUserMutation;
  BlockUserMutationV2: BlockUserMutationV2;
  BlockerField: BlockerField;
  BlogCommentField: Omit<BlogCommentField, 'author'> & { author?: Maybe<ResolversParentTypes['AnyUserField']> };
  BlogPostField: Omit<BlogPostField, 'author' | 'comments' | 'lastUpdatedBy' | 'university'> & { author?: Maybe<ResolversParentTypes['MentorField']>, comments?: Maybe<Array<Maybe<ResolversParentTypes['BlogCommentField']>>>, lastUpdatedBy?: Maybe<ResolversParentTypes['AnyUserField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  BlogTopicField: BlogTopicField;
  BlogcardSnippetField: Omit<BlogcardSnippetField, 'authorSnippets'> & { authorSnippets?: Maybe<Array<Maybe<ResolversParentTypes['AuthorSnippetField']>>> };
  BotUserField: Omit<BotUserField, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  BuddiesField: Omit<BuddiesField, 'users'> & { users?: Maybe<Array<Maybe<ResolversParentTypes['BuddyField']>>> };
  BuddiesFilterOptionsField: BuddiesFilterOptionsField;
  BuddiesListFilterField: BuddiesListFilterField;
  BuddiesListFilterInput: BuddiesListFilterInput;
  BuddyApplicantChatGroupField: BuddyApplicantChatGroupField;
  BuddyApplicantChatGroupFieldV2: Omit<BuddyApplicantChatGroupFieldV2, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  BuddyApplicantChatInterventionBuddyField: BuddyApplicantChatInterventionBuddyField;
  BuddyField: Omit<BuddyField, 'customAttributes' | 'university'> & { customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeValueField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  BuddyInviteField: BuddyInviteField;
  BuddyInviteListField: BuddyInviteListField;
  BulkApplicantField: Omit<BulkApplicantField, 'country' | 'degreeLevel' | 'degrees' | 'degreesInterested' | 'universitiesInterested'> & { country?: Maybe<ResolversParentTypes['CountryField']>, degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, degreesInterested?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, universitiesInterested?: Maybe<Array<Maybe<ResolversParentTypes['UniversityField']>>> };
  BulkOptOutMarketplaceUniversityMarketingMutation: Omit<BulkOptOutMarketplaceUniversityMarketingMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  ButtonField: ButtonField;
  CRMApplicantField: CrmApplicantField;
  CRMField: CrmField;
  CRMIntegrationField: CrmIntegrationField;
  CRMMetaDataField: CrmMetaDataField;
  CSVUploadAmbassadorFieldsMutation: CsvUploadAmbassadorFieldsMutation;
  CSVUploadApplicantsMutation: CsvUploadApplicantsMutation;
  CampusManagementConnectIntegrationField: CampusManagementConnectIntegrationField;
  CanonicalQuestionField: Omit<CanonicalQuestionField, 'answers'> & { answers?: Maybe<Array<Maybe<ResolversParentTypes['FaqAnswerField']>>> };
  CarouselSnippetField: CarouselSnippetField;
  ChatConversation: Omit<ChatConversation, 'communityChatMembers' | 'createdBy' | 'lastMessage' | 'members' | 'pinnedMessages' | 'university'> & { communityChatMembers?: Maybe<Array<ResolversParentTypes['UserField']>>, createdBy?: Maybe<ResolversParentTypes['UserField']>, lastMessage?: Maybe<ResolversParentTypes['ChatMessage']>, members?: Maybe<Array<ResolversParentTypes['UserField']>>, pinnedMessages: Array<ResolversParentTypes['ChatMessage']>, university: ResolversParentTypes['UniversityField'] };
  ChatConversationInboxInputDto: ChatConversationInboxInputDto;
  ChatGroupAndMessages: Omit<ChatGroupAndMessages, 'chatGroup' | 'messages'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, messages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>> };
  ChatGroupAuxiliaryField: ChatGroupAuxiliaryField;
  ChatGroupField: Omit<ChatGroupField, 'applicant' | 'lastMessage' | 'members' | 'messages' | 'messagesForModeration' | 'opponent' | 'university'> & { applicant?: Maybe<ResolversParentTypes['AnyChatUserField']>, lastMessage?: Maybe<ResolversParentTypes['LastMessageField']>, members?: Maybe<Array<Maybe<ResolversParentTypes['AnyUserField']>>>, messages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>>, messagesForModeration?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>>, opponent?: Maybe<ResolversParentTypes['AnyChatUserField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  ChatGroupLabelField: ChatGroupLabelField;
  ChatInboxField: Omit<ChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<ResolversParentTypes['ChatUserField']>>> };
  ChatMessage: Omit<ChatMessage, 'reactions' | 'sender'> & { reactions?: Maybe<Array<ResolversParentTypes['Reaction']>>, sender: ResolversParentTypes['UserField'] };
  ChatPermission: ChatPermission;
  ChatReport: Omit<ChatReport, 'community' | 'conversation' | 'message' | 'moderator' | 'reportee' | 'reporter' | 'university'> & { community: ResolversParentTypes['Community'], conversation: ResolversParentTypes['ChatConversation'], message: ResolversParentTypes['ChatMessage'], moderator?: Maybe<ResolversParentTypes['UserField']>, reportee: ResolversParentTypes['UserField'], reporter: ResolversParentTypes['UserField'], university: ResolversParentTypes['UniversityField'] };
  ChatReportModeratorInputDTO: ChatReportModeratorInputDto;
  ChatReportUserInputDTO: ChatReportUserInputDto;
  ChatRoom: Omit<ChatRoom, 'conversation'> & { conversation: ResolversParentTypes['ChatConversation'] };
  ChatRoomAnalytics: ChatRoomAnalytics;
  ChatRoomAttendeeAnalytics: ChatRoomAttendeeAnalytics;
  ChatRoomAttendeeData: ChatRoomAttendeeData;
  ChatRoomAttendees: ChatRoomAttendees;
  ChatSummaryField: ChatSummaryField;
  ChatUserField: ResolversInterfaceTypes<ResolversParentTypes>['ChatUserField'];
  CheckEmailMutation: CheckEmailMutation;
  ChildOrganisationField: ChildOrganisationField;
  ClassificationField: ClassificationField;
  CloneLiveEventAndChannelsMutation: Omit<CloneLiveEventAndChannelsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  Cohort: Omit<Cohort, 'areaOfStudies' | 'countries' | 'degreeLevels'> & { areaOfStudies?: Maybe<Array<ResolversParentTypes['DegreeField']>>, countries?: Maybe<Array<ResolversParentTypes['CountryField']>>, degreeLevels?: Maybe<Array<ResolversParentTypes['DegreeLevelField']>> };
  CohortInput: CohortInput;
  CommentMutation: Omit<CommentMutation, 'comment'> & { comment?: Maybe<ResolversParentTypes['BlogCommentField']> };
  Community: Omit<Community, 'blockedMembers' | 'communityChatGroups' | 'institutions' | 'members'> & { blockedMembers?: Maybe<Array<ResolversParentTypes['UserField']>>, communityChatGroups: Array<ResolversParentTypes['CommunityChatGroup']>, institutions?: Maybe<Array<ResolversParentTypes['UniversityField']>>, members?: Maybe<Array<ResolversParentTypes['UserField']>> };
  CommunityChatGroup: Omit<CommunityChatGroup, 'conversation' | 'createdBy' | 'members'> & { conversation: ResolversParentTypes['ChatConversation'], createdBy?: Maybe<ResolversParentTypes['UserField']>, members?: Maybe<Array<ResolversParentTypes['UserField']>> };
  CommunityField: CommunityField;
  CommunityInviteResponse: CommunityInviteResponse;
  CommunityInvites: CommunityInvites;
  CommunityJoinResponse: Omit<CommunityJoinResponse, 'community'> & { community: ResolversParentTypes['Community'] };
  CompletedEvent: CompletedEvent;
  CompletedEventsOverview: CompletedEventsOverview;
  ContentBriefField: ContentBriefField;
  Context: Context;
  ConversationContextChatGroupField: ConversationContextChatGroupField;
  ConversationContextField: ConversationContextField;
  ConversationInbox: Omit<ConversationInbox, 'conversations'> & { conversations: Array<ResolversParentTypes['ChatConversation']> };
  ConversationTag: ConversationTag;
  CookieConsentInputDTO: CookieConsentInputDto;
  CookieConsentOutputDTO: CookieConsentOutputDto;
  CountPerEpoch: CountPerEpoch;
  CountryAnalyticsValue: CountryAnalyticsValue;
  CountryField: CountryField;
  CountrySnippetField: Omit<CountrySnippetField, 'country'> & { country?: Maybe<ResolversParentTypes['CountryField']> };
  CountryStatField: CountryStatField;
  CourseSnippetField: Omit<CourseSnippetField, 'degreeSnippets'> & { degreeSnippets?: Maybe<Array<Maybe<ResolversParentTypes['DegreeSnippetField']>>> };
  CreateAlertMutation: CreateAlertMutation;
  CreateApplicantInsightInput: CreateApplicantInsightInput;
  CreateApplicantMutation: Omit<CreateApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  CreateApplicantMutationV2: Omit<CreateApplicantMutationV2, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  CreateAssistantConversationInput: CreateAssistantConversationInput;
  CreateBlogTopicMutation: CreateBlogTopicMutation;
  CreateBuddyMutation: CreateBuddyMutation;
  CreateCanonicalQuestion: Omit<CreateCanonicalQuestion, 'question'> & { question?: Maybe<ResolversParentTypes['CanonicalQuestionField']> };
  CreateCommunityApplicantMutation: Omit<CreateCommunityApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  CreateCommunityApplicantMutationV2: Omit<CreateCommunityApplicantMutationV2, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  CreateCommunityChatGroupInput: CreateCommunityChatGroupInput;
  CreateCommunityConversationDTO: CreateCommunityConversationDto;
  CreateCommunityDTO: CreateCommunityDto;
  CreateCrmServiceUniversityConfigMutation: CreateCrmServiceUniversityConfigMutation;
  CreateExternalEventMutation: CreateExternalEventMutation;
  CreateFaqAnswer: Omit<CreateFaqAnswer, 'faqAnswer'> & { faqAnswer?: Maybe<ResolversParentTypes['FaqAnswerField']> };
  CreateFresherMutation: Omit<CreateFresherMutation, 'fresher'> & { fresher?: Maybe<ResolversParentTypes['ApplicantField']> };
  CreateLiveEventDetailsMutation: Omit<CreateLiveEventDetailsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  CreateLiveEventFeedMutation: Omit<CreateLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversParentTypes['LiveEventChatGroupField']> };
  CreateLiveEventFeedSessionsMutation: Omit<CreateLiveEventFeedSessionsMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversParentTypes['LiveEventChatGroupField']> };
  CreateLiveEventMutation: Omit<CreateLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  CreateMarketplaceApplicantMutation: Omit<CreateMarketplaceApplicantMutation, 'authenticatedApplicant'> & { authenticatedApplicant?: Maybe<ResolversParentTypes['AuthField']> };
  CreateMarketplaceMutation: CreateMarketplaceMutation;
  CreateMentorMutation: Omit<CreateMentorMutation, 'mentor'> & { mentor?: Maybe<ResolversParentTypes['MentorField']> };
  CreateOpenDayMutation: CreateOpenDayMutation;
  CreateOrganisationBuddyLinkMutation: CreateOrganisationBuddyLinkMutation;
  CreateOrganisationMutation: Omit<CreateOrganisationMutation, 'organisation'> & { organisation?: Maybe<ResolversParentTypes['OrganisationField']> };
  CreatePostMutation: Omit<CreatePostMutation, 'post'> & { post?: Maybe<ResolversParentTypes['BlogPostField']> };
  CreateRequestedPublicGroupInput: CreateRequestedPublicGroupInput;
  CreateSubTopicMutation: CreateSubTopicMutation;
  CreateTagMutation: CreateTagMutation;
  CreateTodoInputDto: CreateTodoInputDto;
  CreateTopicMutation: CreateTopicMutation;
  CreateUniversityBlockReportMutation: Omit<CreateUniversityBlockReportMutation, 'universityBlockReport'> & { universityBlockReport?: Maybe<ResolversParentTypes['UniversityBlockReportField']> };
  CreateUniversityMutation: Omit<CreateUniversityMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  CreateUniversityUserMutation: Omit<CreateUniversityUserMutation, 'universityUser'> & { universityUser?: Maybe<ResolversParentTypes['UniversityUserField']> };
  CreateUserMutation: Omit<CreateUserMutation, 'user'> & { user?: Maybe<ResolversParentTypes['UserField']> };
  CreateVirtualEventInput: CreateVirtualEventInput;
  CreationSource: CreationSource;
  CrmApplicantRecordField: CrmApplicantRecordField;
  CrmAttributeField: CrmAttributeField;
  CrmConnectionField: CrmConnectionField;
  CrmDataField: CrmDataField;
  CrmFieldInputType: CrmFieldInputType;
  CrmFieldSyncStatus: CrmFieldSyncStatus;
  CrmServiceUniversityConfig: CrmServiceUniversityConfig;
  CrmSyncJobField: CrmSyncJobField;
  CurrentDecisionStageOutput: CurrentDecisionStageOutput;
  CurrentUserDecisionStageQueryInput: CurrentUserDecisionStageQueryInput;
  CustomAttributeField: ResolversInterfaceTypes<ResolversParentTypes>['CustomAttributeField'];
  CustomAttributeInput: CustomAttributeInput;
  CustomAttributeOptionField: CustomAttributeOptionField;
  CustomAttributeValueField: ResolversInterfaceTypes<ResolversParentTypes>['CustomAttributeValueField'];
  CustomAttributeValueInput: CustomAttributeValueInput;
  CustomAttributesField: CustomAttributesField;
  CustomAttributesFilterField: CustomAttributesFilterField;
  CustomAttributesFilterInputField: CustomAttributesFilterInputField;
  CustomAttributesFilterOptionField: CustomAttributesFilterOptionField;
  DataFormatConfig: DataFormatConfig;
  DataFormatConfigInputType: DataFormatConfigInputType;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  DateValueField: Omit<DateValueField, 'attribute'> & { attribute?: Maybe<ResolversParentTypes['CustomAttributeField']> };
  DeactivateApplicantsMutation: DeactivateApplicantsMutation;
  DeactivateMentorsMutation: DeactivateMentorsMutation;
  DefaultQuestionsField: DefaultQuestionsField;
  DegreeCategoriesAnalyticsValue: DegreeCategoriesAnalyticsValue;
  DegreeCategoryField: DegreeCategoryField;
  DegreeCategoryParentField: DegreeCategoryParentField;
  DegreeChatUserField: DegreeChatUserField;
  DegreeField: Omit<DegreeField, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']> };
  DegreeLevelField: Omit<DegreeLevelField, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  DegreeSnippetField: Omit<DegreeSnippetField, 'degree'> & { degree?: Maybe<ResolversParentTypes['DegreeField']> };
  DegreeStatField: DegreeStatField;
  DegreeTypeOrderField: DegreeTypeOrderField;
  DegreeTypeOrderInput: DegreeTypeOrderInput;
  DeleteApplicantMutation: Omit<DeleteApplicantMutation, 'applicant'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']> };
  DeleteAttributeOptionsMutation: Omit<DeleteAttributeOptionsMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  DeleteCanonicalQuestion: DeleteCanonicalQuestion;
  DeleteCommunityConversationDTO: DeleteCommunityConversationDto;
  DeleteCustomAttributesMutation: Omit<DeleteCustomAttributesMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  DeleteDegreeLevelMutation: DeleteDegreeLevelMutation;
  DeleteFaqAnswer: DeleteFaqAnswer;
  DeleteKnowledgeBaseEntriesByPatternMatchInput: DeleteKnowledgeBaseEntriesByPatternMatchInput;
  DeleteKnowledgeBaseEntriesByPatternMismatchInput: DeleteKnowledgeBaseEntriesByPatternMismatchInput;
  DeleteKnowledgeBaseEntriesByUrlListInput: DeleteKnowledgeBaseEntriesByUrlListInput;
  DeleteKnowledgeBaseEntriesOutput: DeleteKnowledgeBaseEntriesOutput;
  DeleteLiveEventFeedMutation: Omit<DeleteLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversParentTypes['LiveEventChatGroupField']> };
  DeleteLiveEventMessageMutation: DeleteLiveEventMessageMutation;
  DeleteLiveEventMutation: DeleteLiveEventMutation;
  DeleteMessageDto: DeleteMessageDto;
  DeletePostMutation: DeletePostMutation;
  DeleteRecordingResponse: DeleteRecordingResponse;
  DeleteResearchTimeMutation: DeleteResearchTimeMutation;
  DeleteSubTopicMutation: DeleteSubTopicMutation;
  DeleteTopicMutation: DeleteTopicMutation;
  DeleteUniversityUserMutation: Omit<DeleteUniversityUserMutation, 'universityUser'> & { universityUser?: Maybe<ResolversParentTypes['UniversityUserField']> };
  DeleteUserMutation: DeleteUserMutation;
  DeleteYearOfStudyMutation: DeleteYearOfStudyMutation;
  DepartmentSnippetField: DepartmentSnippetField;
  DescriptionField: DescriptionField;
  DeviceField: DeviceField;
  DeviceMutation: DeviceMutation;
  DeviceToken: DeviceToken;
  DirectConversationDTO: DirectConversationDto;
  DirectMessagingApplicant: Omit<DirectMessagingApplicant, 'applicant' | 'chatGroup'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']>, chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  DirectMessagingEnquiryTeam: Omit<DirectMessagingEnquiryTeam, 'chatGroup' | 'university'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  DirectMessagingMentor: Omit<DirectMessagingMentor, 'chatGroup' | 'mentor'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, mentor?: Maybe<ResolversParentTypes['PublicMentorField']> };
  DirectMessagingStaffMember: Omit<DirectMessagingStaffMember, 'chatGroup' | 'staffMember'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, staffMember?: Maybe<ResolversParentTypes['BuddyField']> };
  Display: Display;
  DomesticRegionField: Omit<DomesticRegionField, 'country'> & { country?: Maybe<ResolversParentTypes['CountryField']> };
  EditAlertMutation: EditAlertMutation;
  EditAttributeOptionMutation: Omit<EditAttributeOptionMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EditBlogTopicMutation: EditBlogTopicMutation;
  EditCommunityConversationDTO: EditCommunityConversationDto;
  EditCommunityDTO: EditCommunityDto;
  EditCustomAttributeMutation: Omit<EditCustomAttributeMutation, 'customAttribute'> & { customAttribute?: Maybe<ResolversParentTypes['CustomAttributeField']> };
  EditCustomAttributesMutation: Omit<EditCustomAttributesMutation, 'customAttributes'> & { customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeField']>>> };
  EditCustomWelcomeMessageMutation: Omit<EditCustomWelcomeMessageMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EditDegreeLevelMutation: Omit<EditDegreeLevelMutation, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']> };
  EditDegreeNameMutation: Omit<EditDegreeNameMutation, 'degree'> & { degree?: Maybe<ResolversParentTypes['DegreeField']> };
  EditDegreesMutation: Omit<EditDegreesMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>> };
  EditExternalEventMutation: EditExternalEventMutation;
  EditLiveEventDetailsMutation: Omit<EditLiveEventDetailsMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  EditLiveEventFeedMutation: Omit<EditLiveEventFeedMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversParentTypes['LiveEventChatGroupField']> };
  EditLiveEventMutation: Omit<EditLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  EditLiveEventsLandingPageMutation: EditLiveEventsLandingPageMutation;
  EditOpenDayMutation: EditOpenDayMutation;
  EditOrganisationMutation: Omit<EditOrganisationMutation, 'organisation'> & { organisation?: Maybe<ResolversParentTypes['OrganisationField']> };
  EditPostMutation: Omit<EditPostMutation, 'post'> & { post?: Maybe<ResolversParentTypes['BlogPostField']> };
  EditUniversityMutation: Omit<EditUniversityMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EditYearOfStudyMutation: EditYearOfStudyMutation;
  EmbeddedEventField: EmbeddedEventField;
  EmbeddedEventSnippetField: EmbeddedEventSnippetField;
  EnableCustomWelcomeMessageMutation: Omit<EnableCustomWelcomeMessageMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EnableCustomWelcomeMessageStaffMutation: Omit<EnableCustomWelcomeMessageStaffMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EnableFeaturesMutation: Omit<EnableFeaturesMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  EnrolledInsightResponse: Omit<EnrolledInsightResponse, 'university'> & { university: ResolversParentTypes['UniversityField'] };
  EnrolledInsightsInput: EnrolledInsightsInput;
  EnterpriseAddOns: EnterpriseAddOns;
  EnterpriseMentorField: Omit<EnterpriseMentorField, 'degree' | 'linkedToOrganisations' | 'sourceOrganisation'> & { degree?: Maybe<ResolversParentTypes['DegreeField']>, linkedToOrganisations?: Maybe<Array<Maybe<ResolversParentTypes['OrganisationField']>>>, sourceOrganisation?: Maybe<ResolversParentTypes['OrganisationField']> };
  EntriesField: EntriesField;
  EntriesInput: EntriesInput;
  EventPage: EventPage;
  EventPageData: EventPageData;
  EventPagesDisplayedOn: EventPagesDisplayedOn;
  ExportAnalyticsCsvMutation: ExportAnalyticsCsvMutation;
  ExportTimeSheetDataField: ExportTimeSheetDataField;
  ExportedReportField: ExportedReportField;
  ExternalContent: ExternalContent;
  ExternalContentData: ExternalContentData;
  ExternalEventField: ExternalEventField;
  FaqAnswerField: Omit<FaqAnswerField, 'mentor'> & { mentor: ResolversParentTypes['MentorField'] };
  FeatureField: FeatureField;
  FeatureInputField: FeatureInputField;
  FeatureNotificationRequestDTO: FeatureNotificationRequestDto;
  FeatureRulesDTO: FeatureRulesDto;
  FeatureToggleInputField: FeatureToggleInputField;
  FieldMappingField: FieldMappingField;
  FieldMappingInput: FieldMappingInput;
  FilterUsersDTO: FilterUsersDto;
  FlagField: FlagField;
  FormFieldValidationError: FormFieldValidationError;
  ForwardApplicantToUniversity: Omit<ForwardApplicantToUniversity, 'chatGroup' | 'messages'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, messages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>> };
  GeckoUniversityData: GeckoUniversityData;
  GenerateAnalyticsDashboardTokenMutation: GenerateAnalyticsDashboardTokenMutation;
  GenerateLiveEventReport: Omit<GenerateLiveEventReport, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  GenerateRecommendationsInput: GenerateRecommendationsInput;
  GenericScalar: Scalars['GenericScalar']['output'];
  GetAssistantConversationInput: GetAssistantConversationInput;
  GetChatReportsDTO: GetChatReportsDto;
  GetDownloadableURLMutation: GetDownloadableUrlMutation;
  GetInvitesForEmailDTO: Omit<GetInvitesForEmailDto, 'community'> & { community: ResolversParentTypes['Community'] };
  GetMarketplaceApplicantMutation: Omit<GetMarketplaceApplicantMutation, 'authenticatedApplicant'> & { authenticatedApplicant?: Maybe<ResolversParentTypes['AuthField']> };
  GetMessageDto: GetMessageDto;
  GetOrCreateApiKeyMutation: GetOrCreateApiKeyMutation;
  GetRandomAmbassadorsInput: GetRandomAmbassadorsInput;
  GetRecordingFailureIdsArgs: GetRecordingFailureIdsArgs;
  GetRecordingFailureIdsResponse: GetRecordingFailureIdsResponse;
  GetSignedS3PostFieldsMutation: GetSignedS3PostFieldsMutation;
  GetSignedS3UrlMutation: GetSignedS3UrlMutation;
  GetUserReportsDTO: GetUserReportsDto;
  GifDto: GifDto;
  Giphy: Giphy;
  GraphField: GraphField;
  GraphQLOffsetPaginationInput: GraphQlOffsetPaginationInput;
  GroupField: GroupField;
  HideMentorInMarketplaceMutation: Omit<HideMentorInMarketplaceMutation, 'mentor'> & { mentor?: Maybe<ResolversParentTypes['MentorField']> };
  HighSchoolField: HighSchoolField;
  HighSchoolTypeField: HighSchoolTypeField;
  HousingInput: HousingInput;
  HousingObject: HousingObject;
  Image: Image;
  ImageDto: ImageDto;
  InboxItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['InboxItemInterface'];
  InboxItemLastMessageField: InboxItemLastMessageField;
  InboxItemUnion: ResolversUnionTypes<ResolversParentTypes>['InboxItemUnion'];
  InboxPromptAnswer: InboxPromptAnswer;
  InboxPromptAnswerInput: InboxPromptAnswerInput;
  InboxPromptAnswerInputItem: InboxPromptAnswerInputItem;
  InboxPromptInput: InboxPromptInput;
  InboxPromptOption: InboxPromptOption;
  InboxPromptQuestion: InboxPromptQuestion;
  InboxUniversityField: InboxUniversityField;
  InitialiseRecordingArgs: InitialiseRecordingArgs;
  InitialiseRecordingResponse: InitialiseRecordingResponse;
  InputField: InputField;
  Insights: Insights;
  InsightsField: InsightsField;
  Interest: Interest;
  InterestInput: InterestInput;
  InterestObject: InterestObject;
  InterventionMessageField: Omit<InterventionMessageField, 'message'> & { message?: Maybe<ResolversParentTypes['MessageField']> };
  Invite: Invite;
  InviteApplicantsMutation: InviteApplicantsMutation;
  InviteBuddiesMutation: InviteBuddiesMutation;
  InviteFilter: InviteFilter;
  InviteInformation: Omit<InviteInformation, 'community' | 'university'> & { community: ResolversParentTypes['Community'], university: ResolversParentTypes['UniversityField'] };
  InviteInformationInput: InviteInformationInput;
  InviteLinkDto: InviteLinkDto;
  InviteLinkInfoDto: InviteLinkInfoDto;
  InviteLinkInput: InviteLinkInput;
  InviteMentorsMutation: InviteMentorsMutation;
  IsoDateTime: Scalars['IsoDateTime']['output'];
  JSONString: Scalars['JSONString']['output'];
  JoinChatGroupMutation: Omit<JoinChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  KnowledgeBaseDeleteEntryInput: KnowledgeBaseDeleteEntryInput;
  KnowledgeBaseDeleteEntryOutput: KnowledgeBaseDeleteEntryOutput;
  KnowledgeBaseEmbedding: KnowledgeBaseEmbedding;
  KnowledgeBaseSourceQueryInput: KnowledgeBaseSourceQueryInput;
  KnowledgeBaseSourcesByUrl: KnowledgeBaseSourcesByUrl;
  KnowledgeBaseSourcesListInput: KnowledgeBaseSourcesListInput;
  LabelSentenceMutation: LabelSentenceMutation;
  LabellingField: LabellingField;
  LabellingSentenceCandidate: LabellingSentenceCandidate;
  Labels: Labels;
  LanguageField: LanguageField;
  LastMessageField: Omit<LastMessageField, 'sender'> & { sender?: Maybe<ResolversParentTypes['AnyUserField']> };
  LastRead: LastRead;
  LeaveChatGroupMutation: Omit<LeaveChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  LevelSnippetField: LevelSnippetField;
  LikeMessageDto: LikeMessageDto;
  LikeMessageMutation: LikeMessageMutation;
  LimitedInt: Scalars['LimitedInt']['output'];
  LinkOrganisationsMutation: LinkOrganisationsMutation;
  ListAdminRecommendationInput: ListAdminRecommendationInput;
  ListBuddyApplicantConversationsField: Omit<ListBuddyApplicantConversationsField, 'conversations'> & { conversations?: Maybe<Array<Maybe<ResolversParentTypes['BuddyApplicantChatGroupFieldV2']>>> };
  ListMentorApplicantConversationsField: Omit<ListMentorApplicantConversationsField, 'conversations'> & { conversations?: Maybe<Array<Maybe<ResolversParentTypes['MentorApplicantChatGroupField']>>> };
  ListUniversityAssistantConversationsInput: ListUniversityAssistantConversationsInput;
  ListUniversityAssistantConversationsOutput: ListUniversityAssistantConversationsOutput;
  LiveEventChatGroupField: Omit<LiveEventChatGroupField, 'applicants' | 'chatGroup' | 'mentors' | 'staff' | 'university' | 'universityUsers'> & { applicants?: Maybe<Array<Maybe<ResolversParentTypes['ApplicantField']>>>, chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, mentors?: Maybe<Array<Maybe<ResolversParentTypes['MentorField']>>>, staff?: Maybe<Array<Maybe<ResolversParentTypes['UserField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']>, universityUsers?: Maybe<Array<Maybe<ResolversParentTypes['UniversityUserField']>>> };
  LiveEventChatGroupsInputField: LiveEventChatGroupsInputField;
  LiveEventDetailedReport: LiveEventDetailedReport;
  LiveEventDetailedReportChannelStats: LiveEventDetailedReportChannelStats;
  LiveEventDetailedReportCountryStats: LiveEventDetailedReportCountryStats;
  LiveEventDetailsField: LiveEventDetailsField;
  LiveEventDirectMessaging: Omit<LiveEventDirectMessaging, 'applicants' | 'enquiryTeam' | 'mentors' | 'staff'> & { applicants?: Maybe<Array<Maybe<ResolversParentTypes['DirectMessagingApplicant']>>>, enquiryTeam?: Maybe<ResolversParentTypes['DirectMessagingEnquiryTeam']>, mentors?: Maybe<Array<Maybe<ResolversParentTypes['DirectMessagingMentor']>>>, staff?: Maybe<Array<Maybe<ResolversParentTypes['DirectMessagingStaffMember']>>> };
  LiveEventFeedbackFormMutation: Omit<LiveEventFeedbackFormMutation, 'feedBackForm'> & { feedBackForm?: Maybe<ResolversParentTypes['LiveEventProspectFeedbackFormField']> };
  LiveEventField: Omit<LiveEventField, 'allMentors' | 'allStaff' | 'directMessagingMentors' | 'directMessagingStaff' | 'inbox' | 'liveFeeds' | 'university'> & { allMentors?: Maybe<Array<Maybe<ResolversParentTypes['MentorField']>>>, allStaff?: Maybe<Array<Maybe<ResolversParentTypes['BuddyField']>>>, directMessagingMentors?: Maybe<Array<Maybe<ResolversParentTypes['MentorField']>>>, directMessagingStaff?: Maybe<Array<Maybe<ResolversParentTypes['BuddyField']>>>, inbox?: Maybe<ResolversParentTypes['LiveEventInboxField']>, liveFeeds?: Maybe<Array<Maybe<ResolversParentTypes['LiveEventChatGroupField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  LiveEventInboxField: Omit<LiveEventInboxField, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['InboxItemUnion']>>> };
  LiveEventLandingPageField: LiveEventLandingPageField;
  LiveEventProspectFeedbackFormField: Omit<LiveEventProspectFeedbackFormField, 'liveEvent' | 'university' | 'user'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']>, university?: Maybe<ResolversParentTypes['UniversityField']>, user?: Maybe<ResolversParentTypes['UserField']> };
  LiveEventsFormFieldValidationError: LiveEventsFormFieldValidationError;
  LiveSession: Omit<LiveSession, 'conversation' | 'presenters' | 'sessionAnalytics'> & { conversation: ResolversParentTypes['ChatConversation'], presenters: Array<ResolversParentTypes['UserField']>, sessionAnalytics: ResolversParentTypes['SessionAnalytics'] };
  Locale: Locale;
  LocaleField: LocaleField;
  LogoDataField: LogoDataField;
  LogoutMutation: LogoutMutation;
  ManageOrganisationAccessMutation: ManageOrganisationAccessMutation;
  ManuallyClassifyMutation: ManuallyClassifyMutation;
  MarkAssistantConversationAsViewedInput: MarkAssistantConversationAsViewedInput;
  MarkReadMessageDTO: MarkReadMessageDto;
  MarketplaceApplicantCountries: MarketplaceApplicantCountries;
  MarketplaceApplicantData: MarketplaceApplicantData;
  MarketplaceApplicantDegreeCategories: MarketplaceApplicantDegreeCategories;
  MarketplaceApplicantUserData: MarketplaceApplicantUserData;
  MarketplaceField: MarketplaceField;
  MarketplaceFilterInput: MarketplaceFilterInput;
  MarketplaceFilters: MarketplaceFilters;
  MarketplaceInboxField: Omit<MarketplaceInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversParentTypes['ChatGroupField']>>> };
  MarketplaceMentorList: Omit<MarketplaceMentorList, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversParentTypes['PublicMentorField']>>> };
  MarketplaceSnippetField: MarketplaceSnippetField;
  MatchedUser: Omit<MatchedUser, 'user'> & { user: ResolversParentTypes['UserField'] };
  MeField: Omit<MeField, 'admin' | 'anyUser' | 'applicant' | 'mentor' | 'staff' | 'universityUser'> & { admin?: Maybe<ResolversParentTypes['AdminUserField']>, anyUser?: Maybe<ResolversParentTypes['AnyUserField']>, applicant?: Maybe<ResolversParentTypes['ApplicantField']>, mentor?: Maybe<ResolversParentTypes['MentorField']>, staff?: Maybe<ResolversParentTypes['UserField']>, universityUser?: Maybe<ResolversParentTypes['UniversityUserField']> };
  MentorApplicantChatGroupField: Omit<MentorApplicantChatGroupField, 'applicant' | 'mentor'> & { applicant?: Maybe<ResolversParentTypes['ApplicantField']>, mentor?: Maybe<ResolversParentTypes['MentorField']> };
  MentorBroadcastMessageMutation: MentorBroadcastMessageMutation;
  MentorChatUserField: MentorChatUserField;
  MentorDegreeField: Omit<MentorDegreeField, 'degree'> & { degree?: Maybe<ResolversParentTypes['DegreeField']> };
  MentorDegreeFieldInput: MentorDegreeFieldInput;
  MentorDegreeHistory: Omit<MentorDegreeHistory, 'degree' | 'university'> & { degree?: Maybe<ResolversParentTypes['DegreeField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  MentorField: Omit<MentorField, 'country' | 'customAttributes' | 'degree' | 'degreeHistory' | 'degrees' | 'university'> & { country?: Maybe<ResolversParentTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeValueField']>>>, degree?: Maybe<ResolversParentTypes['DegreeField']>, degreeHistory?: Maybe<ResolversParentTypes['MentorDegreeHistory']>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['MentorDegreeField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  MentorFieldOrderField: MentorFieldOrderField;
  MentorFieldOrderInput: MentorFieldOrderInput;
  MentorFields: MentorFields;
  MentorFilterField: MentorFilterField;
  MentorFilterInputField: MentorFilterInputField;
  MentorFilterOptionField: MentorFilterOptionField;
  MentorInboxField: Omit<MentorInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversParentTypes['ChatGroupField']>>> };
  MentorInterestField: MentorInterestField;
  MentorInterventionQueryField: Omit<MentorInterventionQueryField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversParentTypes['MentorField']>>> };
  MentorIntroMessageField: Omit<MentorIntroMessageField, 'introMessage'> & { introMessage?: Maybe<ResolversParentTypes['MessageField']> };
  MentorInviteCountField: MentorInviteCountField;
  MentorInviteField: MentorInviteField;
  MentorListField: Omit<MentorListField, 'countries' | 'degrees' | 'mentors'> & { countries?: Maybe<Array<Maybe<ResolversParentTypes['CountryField']>>>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, mentors?: Maybe<Array<Maybe<ResolversParentTypes['PublicMentorField']>>> };
  MentorListFilterChoice: MentorListFilterChoice;
  MentorListFilterChoiceInput: MentorListFilterChoiceInput;
  MentorModuleField: MentorModuleField;
  MentorPreferencesField: MentorPreferencesField;
  MentorSchoolHistoryField: MentorSchoolHistoryField;
  MentorSnippetField: Omit<MentorSnippetField, 'mentor'> & { mentor?: Maybe<ResolversParentTypes['MentorField']> };
  MentorSocietyField: MentorSocietyField;
  MentorcardSnippetField: Omit<MentorcardSnippetField, 'countrySnippets' | 'degreeSnippets' | 'mentorSnippets'> & { countrySnippets?: Maybe<Array<Maybe<ResolversParentTypes['CountrySnippetField']>>>, degreeSnippets?: Maybe<Array<Maybe<ResolversParentTypes['DegreeSnippetField']>>>, mentorSnippets?: Maybe<Array<Maybe<ResolversParentTypes['MentorSnippetField']>>> };
  MessageDto: MessageDto;
  MessageField: Omit<MessageField, 'input' | 'sender'> & { input?: Maybe<ResolversParentTypes['InputField']>, sender?: Maybe<ResolversParentTypes['AnyUserField']> };
  MessageMetadata: MessageMetadata;
  MessagePublicBotMutation: Omit<MessagePublicBotMutation, 'botMessages'> & { botMessages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>> };
  Metadata: Metadata;
  MetricDataPoint: MetricDataPoint;
  Mutation: {};
  NewsFeedGroup: NewsFeedGroup;
  NotificationField: NotificationField;
  ObjectID: Scalars['ObjectID']['output'];
  ObjectId: Scalars['ObjectId']['output'];
  OffsetPagination: OffsetPagination;
  OffsetPaginationDto: OffsetPaginationDto;
  OpenDayField: OpenDayField;
  OpenDaysLoginField: OpenDaysLoginField;
  OpenDaysSignupField: OpenDaysSignupField;
  OpenTextFieldValueField: Omit<OpenTextFieldValueField, 'attribute'> & { attribute?: Maybe<ResolversParentTypes['CustomAttributeField']> };
  OrderByLiveSessionsInput: OrderByLiveSessionsInput;
  OrganisationBuddyLinkField: OrganisationBuddyLinkField;
  OrganisationField: Omit<OrganisationField, 'childOrganisations' | 'university'> & { childOrganisations?: Maybe<Array<Maybe<ResolversParentTypes['ChildOrganisationField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  OriginField: OriginField;
  OutboxChatGroupField: Omit<OutboxChatGroupField, 'lastMessage' | 'members' | 'opponent'> & { lastMessage?: Maybe<ResolversParentTypes['LastMessageField']>, members?: Maybe<Array<Maybe<ResolversParentTypes['AnyUserField']>>>, opponent?: Maybe<ResolversParentTypes['AnyChatUserField']> };
  OutputField: OutputField;
  PageMentorField: Omit<PageMentorField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversParentTypes['MentorField']>>> };
  PaginatedAdminRecommendation: Omit<PaginatedAdminRecommendation, 'items'> & { items: Array<ResolversParentTypes['AdminRecommendation']> };
  PaginatedApplicantInsightInput: PaginatedApplicantInsightInput;
  PaginatedApplicantInvite: PaginatedApplicantInvite;
  PaginatedApplicationInsightModel: Omit<PaginatedApplicationInsightModel, 'items'> & { items: Array<ResolversParentTypes['ApplicationInsightModel']> };
  PaginatedChatMessages: Omit<PaginatedChatMessages, 'messages'> & { messages: Array<ResolversParentTypes['ChatMessage']> };
  PaginatedChatRooms: Omit<PaginatedChatRooms, 'items'> & { items: Array<ResolversParentTypes['ChatRoom']> };
  PaginatedEventPages: PaginatedEventPages;
  PaginatedExternalContents: PaginatedExternalContents;
  PaginatedLiveSessions: Omit<PaginatedLiveSessions, 'items'> & { items: Array<ResolversParentTypes['LiveSession']> };
  PaginatedVirtualEvents: Omit<PaginatedVirtualEvents, 'items'> & { items: Array<ResolversParentTypes['VirtualEvent']> };
  PaginationInput: PaginationInput;
  PasswordResetMobileMutation: PasswordResetMobileMutation;
  PasswordResetMobileMutationV2: PasswordResetMobileMutationV2;
  PayloadField: PayloadField;
  PinMessageMutation: PinMessageMutation;
  PinnedMessageField: PinnedMessageField;
  PinnedMessageSenderField: PinnedMessageSenderField;
  Poll: Poll;
  PollDto: PollDto;
  PollOption: PollOption;
  PollOptionDto: PollOptionDto;
  PopCardDegreeSnippetField: Omit<PopCardDegreeSnippetField, 'getSnippet'> & { getSnippet?: Maybe<Array<Maybe<ResolversParentTypes['DegreeSnippetField']>>> };
  PopCardLevelSnippetField: PopCardLevelSnippetField;
  PopCardWidgetField: PopCardWidgetField;
  PopcardSnippetField: Omit<PopcardSnippetField, 'degreeSnippets'> & { degreeSnippets?: Maybe<Array<Maybe<ResolversParentTypes['PopCardDegreeSnippetField']>>> };
  PostFields: PostFields;
  PreferencesInputType: PreferencesInputType;
  PreferencesObjectType: PreferencesObjectType;
  PreferencesOutputType: PreferencesOutputType;
  ProspectStageStatField: ProspectStageStatField;
  ProspectStageSummaryField: ProspectStageSummaryField;
  PublicMentorField: Omit<PublicMentorField, 'country' | 'customAttributes' | 'degree' | 'degreeHistory' | 'degrees' | 'university'> & { country?: Maybe<ResolversParentTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeValueField']>>>, degree?: Maybe<ResolversParentTypes['DegreeField']>, degreeHistory?: Maybe<ResolversParentTypes['MentorDegreeHistory']>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['MentorDegreeField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  PublicUserField: PublicUserField;
  QssMetadata: QssMetadata;
  QssQuestion: QssQuestion;
  Query: {};
  QueryRecordingArgs: QueryRecordingArgs;
  QueryRecordingResponse: QueryRecordingResponse;
  QuestionField: QuestionField;
  RandomMentorsListField: Omit<RandomMentorsListField, 'mentors'> & { mentors?: Maybe<Array<Maybe<ResolversParentTypes['PublicMentorField']>>> };
  RangeDateInput: RangeDateInput;
  Reaction: Reaction;
  ReactionDto: ReactionDto;
  ReadChatMutation: Omit<ReadChatMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  Recommendation: Recommendation;
  RecommendationResourceType: RecommendationResourceType;
  RecordUserActivityMutation: Omit<RecordUserActivityMutation, 'newActivity'> & { newActivity?: Maybe<ResolversParentTypes['ActivityField']> };
  RecordingConsent: RecordingConsent;
  RecordingDownloadResponse: RecordingDownloadResponse;
  RecordingFailureArgs: RecordingFailureArgs;
  RecordingFailureId: RecordingFailureId;
  RecordingFailureResponse: RecordingFailureResponse;
  RecordingListResponse: RecordingListResponse;
  RecordingModel: RecordingModel;
  RecordingResponse: RecordingResponse;
  RecordingUploadingResponse: RecordingUploadingResponse;
  RegisterToLiveEvent: RegisterToLiveEvent;
  RejectRequestedPublicGroupInput: RejectRequestedPublicGroupInput;
  RemoveApplicantInsightInput: RemoveApplicantInsightInput;
  RemoveBuddyInvitesMutation: RemoveBuddyInvitesMutation;
  RemoveDeviceMutation: RemoveDeviceMutation;
  RemoveMembersFromCommunityInputDTO: RemoveMembersFromCommunityInputDto;
  RemoveMentorInvitesMutation: RemoveMentorInvitesMutation;
  ReplyInputField: ReplyInputField;
  ReplyMessage: ReplyMessage;
  ReplyMessageDto: ReplyMessageDto;
  ReplyOutputField: ReplyOutputField;
  ReportAnalytics: ReportAnalytics;
  RequestAnalyticsExportMutation: RequestAnalyticsExportMutation;
  RequestPasswordResetMutation: RequestPasswordResetMutation;
  RequestPasswordSetMutation: RequestPasswordSetMutation;
  RequestedPublicGroup: Omit<RequestedPublicGroup, 'community' | 'conversation' | 'requestedBy' | 'resolvedBy'> & { community: ResolversParentTypes['Community'], conversation: ResolversParentTypes['ChatConversation'], requestedBy: ResolversParentTypes['UserField'], resolvedBy: ResolversParentTypes['UserField'] };
  ResearchTimeInput: ResearchTimeInput;
  ResearchTimeLogResult: ResearchTimeLogResult;
  ResearchTimeResult: ResearchTimeResult;
  ResetPasswordMobileMutation: ResetPasswordMobileMutation;
  ResetPasswordMutation: ResetPasswordMutation;
  ResetPasswordMutationV2: ResetPasswordMutationV2;
  ResolveMessageDto: ResolveMessageDto;
  ResolveUniversityChatsMutation: Omit<ResolveUniversityChatsMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  RichContentDto: RichContentDto;
  RichContentInputField: RichContentInputField;
  RichContentOutputField: RichContentOutputField;
  RichMessageContent: Omit<RichMessageContent, 'reply'> & { reply?: Maybe<ResolversParentTypes['ChatMessage']> };
  RunManageCommandMutation: RunManageCommandMutation;
  SatisfactionSurveyDTO: SatisfactionSurveyDto;
  SatisfactionSurveyEntity: SatisfactionSurveyEntity;
  SaveAppliedUsersInput: SaveAppliedUsersInput;
  SaveAppliedUsersModel: SaveAppliedUsersModel;
  SaveAssistantConversationEmailLeadInput: SaveAssistantConversationEmailLeadInput;
  SaveAssistantConversationFeedbackInput: SaveAssistantConversationFeedbackInput;
  SaveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
  SaveVisitedRecommendationInput: SaveVisitedRecommendationInput;
  SearchResult: SearchResult;
  SendAssistantMessageInput: SendAssistantMessageInput;
  SendCommunityVerificationCode: SendCommunityVerificationCode;
  SendFeedMessageMutation: Omit<SendFeedMessageMutation, 'message'> & { message?: Maybe<ResolversParentTypes['MessageField']> };
  SendLiveEventMessageMutation: Omit<SendLiveEventMessageMutation, 'botMessages' | 'chatGroup' | 'message'> & { botMessages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>>, chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, message?: Maybe<ResolversParentTypes['MessageField']> };
  SendMessageMutation: Omit<SendMessageMutation, 'botMessages' | 'chatGroup' | 'message'> & { botMessages?: Maybe<Array<Maybe<ResolversParentTypes['MessageField']>>>, chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, message?: Maybe<ResolversParentTypes['MessageField']> };
  SendOpenDayProspectReport: SendOpenDayProspectReport;
  SendResetPasswordEmail: SendResetPasswordEmail;
  SendVerificationCode: SendVerificationCode;
  SequenceFilterMentorListField: Omit<SequenceFilterMentorListField, 'countries' | 'degrees' | 'mentors'> & { countries?: Maybe<Array<Maybe<ResolversParentTypes['CountryField']>>>, degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>>, mentors?: Maybe<Array<Maybe<ResolversParentTypes['PublicMentorField']>>> };
  SessionAnalytics: Omit<SessionAnalytics, 'session'> & { session?: Maybe<ResolversParentTypes['LiveSession']> };
  SessionAttendeeAnalytics: SessionAttendeeAnalytics;
  SessionAttendeeData: SessionAttendeeData;
  SessionAttendees: SessionAttendees;
  SessionData: SessionData;
  SetActiveBlogTopicsMutation: SetActiveBlogTopicsMutation;
  SetAllNotificationsReadMutation: SetAllNotificationsReadMutation;
  SetArchivedContentBriefMutation: SetArchivedContentBriefMutation;
  SetArchivedDegreeLevelMutation: Omit<SetArchivedDegreeLevelMutation, 'degreeLevel'> & { degreeLevel?: Maybe<ResolversParentTypes['DegreeLevelField']> };
  SetArchivedYearOfStudyMutation: SetArchivedYearOfStudyMutation;
  SetBuddiesListFilters: Omit<SetBuddiesListFilters, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  SetChatGroupLabelsMutation: Omit<SetChatGroupLabelsMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  SetDeviceTokenDTO: SetDeviceTokenDto;
  SetMentorFieldOrderMutation: Omit<SetMentorFieldOrderMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  SetMentorListFilterSelection: Omit<SetMentorListFilterSelection, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  SetOnlineMutation: SetOnlineMutation;
  SetResolveChatGroupMutation: Omit<SetResolveChatGroupMutation, 'chatGroup'> & { chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']> };
  SetUserInterestsInput: SetUserInterestsInput;
  SetWillReplyMutation: SetWillReplyMutation;
  SettingsDTO: SettingsDto;
  SettingsObjectType: SettingsObjectType;
  ShowMentorInMarketplaceMutation: Omit<ShowMentorInMarketplaceMutation, 'mentor'> & { mentor?: Maybe<ResolversParentTypes['MentorField']> };
  SignUpsCount: SignUpsCount;
  SignedS3POSTFields: SignedS3PostFields;
  SignedS3URLField: SignedS3UrlField;
  SingleChoiceAttributeField: SingleChoiceAttributeField;
  SingleChoiceValueField: Omit<SingleChoiceValueField, 'attribute'> & { attribute?: Maybe<ResolversParentTypes['CustomAttributeField']> };
  SourceInputField: SourceInputField;
  SourceMetadataField: SourceMetadataField;
  SourceTrackingParamsField: SourceTrackingParamsField;
  StaffBuddycardSnippetField: StaffBuddycardSnippetField;
  StaffChatUserField: StaffChatUserField;
  StaffContactByUniversityIdInput: StaffContactByUniversityIdInput;
  StaffContactInput: StaffContactInput;
  StaffContactOutput: StaffContactOutput;
  StaffField: StaffField;
  StaffFieldsChatUserField: StaffFieldsChatUserField;
  StaffPopcardSnippetField: StaffPopcardSnippetField;
  StaffProfileInformation: StaffProfileInformation;
  StaffUserField: StaffUserField;
  StaffUserFieldsField: StaffUserFieldsField;
  StaffUserListField: StaffUserListField;
  StartRecordingArgs: StartRecordingArgs;
  StateStatField: StateStatField;
  StopRecordingArgs: StopRecordingArgs;
  SubTopicField: SubTopicField;
  SubTopicStatField: SubTopicStatField;
  SubTopicStatisticField: SubTopicStatisticField;
  SuggestionField: Omit<SuggestionField, 'canonicalQuestions'> & { canonicalQuestions?: Maybe<Array<Maybe<ResolversParentTypes['CanonicalQuestionField']>>> };
  SwitchUniversitiesField: SwitchUniversitiesField;
  SwitchUniversityField: SwitchUniversityField;
  SwitchUniversityListField: SwitchUniversityListField;
  Tag: Tag;
  TagField: TagField;
  TargetAudienceDto: TargetAudienceDto;
  TextInLocale: TextInLocale;
  TextInLocaleInput: TextInLocaleInput;
  TimeTakenField: TimeTakenField;
  TodoTargetAudience: ResolversUnionTypes<ResolversParentTypes>['TodoTargetAudience'];
  TodosEntity: Omit<TodosEntity, 'targetAudience'> & { targetAudience: Array<ResolversParentTypes['TodoTargetAudience']> };
  ToggleCrmIntegrationSync: ToggleCrmIntegrationSync;
  ToggleCustomAttributeCrmSyncMutation: ToggleCustomAttributeCrmSyncMutation;
  ToggleDegreesActiveMutation: Omit<ToggleDegreesActiveMutation, 'degrees'> & { degrees?: Maybe<Array<Maybe<ResolversParentTypes['DegreeField']>>> };
  ToggleFeatureAvailabilityMutation: Omit<ToggleFeatureAvailabilityMutation, 'university'> & { university?: Maybe<ResolversParentTypes['UniversityField']> };
  TopCountryField: TopCountryField;
  TopDegreeField: TopDegreeField;
  TopDomesticRegionField: TopDomesticRegionField;
  TopRegionField: TopRegionField;
  TopSubTopicField: TopSubTopicField;
  TopTopicField: TopTopicField;
  TopicField: TopicField;
  TopicSnippetField: TopicSnippetField;
  TopicStatisticField: TopicStatisticField;
  TopicsStatField: TopicsStatField;
  TrackLiveEventMutation: Omit<TrackLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  TrackOpenDayMutation: TrackOpenDayMutation;
  TrendingTopicsField: TrendingTopicsField;
  UniversityAssistantConfiguration: UniversityAssistantConfiguration;
  UniversityAssistantConfigurationEventInput: UniversityAssistantConfigurationEventInput;
  UniversityAssistantConfigurationEventOutput: UniversityAssistantConfigurationEventOutput;
  UniversityAssistantConfigurationEventUrls: UniversityAssistantConfigurationEventUrls;
  UniversityAssistantConfigurationPromptContextInput: UniversityAssistantConfigurationPromptContextInput;
  UniversityAssistantConfigurationPromptContextOutput: UniversityAssistantConfigurationPromptContextOutput;
  UniversityAssistantConfigurationScrapeIgnoreUrlsInput: UniversityAssistantConfigurationScrapeIgnoreUrlsInput;
  UniversityAssistantConfigurationScrapeIgnoreUrlsOutput: UniversityAssistantConfigurationScrapeIgnoreUrlsOutput;
  UniversityAssistantConfigurationScrapeStartPointInput: UniversityAssistantConfigurationScrapeStartPointInput;
  UniversityAssistantConfigurationScrapeStartPointOutput: UniversityAssistantConfigurationScrapeStartPointOutput;
  UniversityAssistantConversation: UniversityAssistantConversation;
  UniversityAssistantScrapeIgnoreUrls: UniversityAssistantScrapeIgnoreUrls;
  UniversityAssistantScrapeIgnoreUrlsInput: UniversityAssistantScrapeIgnoreUrlsInput;
  UniversityBlockReportField: Omit<UniversityBlockReportField, 'blocked' | 'blocker' | 'chatGroup' | 'university'> & { blocked?: Maybe<ResolversParentTypes['ApplicantField']>, blocker?: Maybe<ResolversParentTypes['AnyUserField']>, chatGroup?: Maybe<ResolversParentTypes['ChatGroupField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  UniversityBlockUsersMutation: UniversityBlockUsersMutation;
  UniversityBlogPostsField: Omit<UniversityBlogPostsField, 'blogPosts'> & { blogPosts?: Maybe<Array<Maybe<ResolversParentTypes['BlogPostField']>>> };
  UniversityChatInboxField: Omit<UniversityChatInboxField, 'members'> & { members?: Maybe<Array<Maybe<ResolversParentTypes['ChatUserField']>>> };
  UniversityConfigField: UniversityConfigField;
  UniversityContent: UniversityContent;
  UniversityContentInput: UniversityContentInput;
  UniversityFeatureField: UniversityFeatureField;
  UniversityField: Omit<UniversityField, 'buddiesListFilters' | 'country' | 'customAttribute' | 'customAttributes'> & { buddiesListFilters?: Maybe<Array<Maybe<ResolversParentTypes['BuddiesListFilterField']>>>, country?: Maybe<ResolversParentTypes['CountryField']>, customAttribute?: Maybe<ResolversParentTypes['CustomAttributeField']>, customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeField']>>> };
  UniversityInboxField: Omit<UniversityInboxField, 'chatGroups'> & { chatGroups?: Maybe<Array<Maybe<ResolversParentTypes['ChatGroupField']>>> };
  UniversityInterestedDTO: UniversityInterestedDto;
  UniversityInterestedEntity: UniversityInterestedEntity;
  UniversityMarketplaceField: UniversityMarketplaceField;
  UniversityMarketplaceInput: UniversityMarketplaceInput;
  UniversityOutput: UniversityOutput;
  UniversityQuestion: UniversityQuestion;
  UniversityQuestionAnswer: UniversityQuestionAnswer;
  UniversityQuestionAnswerInput: UniversityQuestionAnswerInput;
  UniversityQuestionAnswerInputItem: UniversityQuestionAnswerInputItem;
  UniversityQuestionByIdInput: UniversityQuestionByIdInput;
  UniversityQuestionContext: UniversityQuestionContext;
  UniversityQuestionContextInput: UniversityQuestionContextInput;
  UniversityQuestionInput: UniversityQuestionInput;
  UniversityQuestionOption: UniversityQuestionOption;
  UniversityScrapeIndexingOutput: UniversityScrapeIndexingOutput;
  UniversityScrapeIndexingQueryInput: UniversityScrapeIndexingQueryInput;
  UniversityScrapeInput: UniversityScrapeInput;
  UniversityScrapeManualInput: UniversityScrapeManualInput;
  UniversityScrapeOutput: UniversityScrapeOutput;
  UniversityScrapeStopOutput: UniversityScrapeStopOutput;
  UniversityScrapeTask: UniversityScrapeTask;
  UniversitySnippetField: Omit<UniversitySnippetField, 'blogcardSnippets' | 'courseWidgetSnippets' | 'mentorcardExternalSnippets' | 'mentorcardInternalSnippets' | 'popcardSnippets' | 'university'> & { blogcardSnippets?: Maybe<ResolversParentTypes['BlogcardSnippetField']>, courseWidgetSnippets?: Maybe<ResolversParentTypes['CourseSnippetField']>, mentorcardExternalSnippets?: Maybe<ResolversParentTypes['MentorcardSnippetField']>, mentorcardInternalSnippets?: Maybe<ResolversParentTypes['MentorcardSnippetField']>, popcardSnippets?: Maybe<ResolversParentTypes['PopcardSnippetField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  UniversityStopCrawlInput: UniversityStopCrawlInput;
  UniversityUserField: Omit<UniversityUserField, 'preferences' | 'university'> & { preferences?: Maybe<ResolversParentTypes['UniversityUserPreferencesField']>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  UniversityUserPreferencesField: UniversityUserPreferencesField;
  UnpinMessageMutation: UnpinMessageMutation;
  UnreadCountField: UnreadCountField;
  UnreadMessageCountField: UnreadMessageCountField;
  UpdateApplicantMutation: Omit<UpdateApplicantMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateApplicantPreferencesMutation: Omit<UpdateApplicantPreferencesMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateCanonicalQuestion: Omit<UpdateCanonicalQuestion, 'canonicalQuestion'> & { canonicalQuestion?: Maybe<ResolversParentTypes['CanonicalQuestionField']> };
  UpdateChatRoomInput: UpdateChatRoomInput;
  UpdateCommunityApplicantSignupSourceMutation: Omit<UpdateCommunityApplicantSignupSourceMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateDirectMessagingMembersForLiveEventMutation: Omit<UpdateDirectMessagingMembersForLiveEventMutation, 'liveEvent'> & { liveEvent?: Maybe<ResolversParentTypes['LiveEventField']> };
  UpdateEventPageInput: UpdateEventPageInput;
  UpdateExternalContentInput: UpdateExternalContentInput;
  UpdateFaqAnswer: Omit<UpdateFaqAnswer, 'faqAnswer'> & { faqAnswer?: Maybe<ResolversParentTypes['FaqAnswerField']> };
  UpdateHobsonsConnectIntegration: UpdateHobsonsConnectIntegration;
  UpdateIntegrationFieldMapping: UpdateIntegrationFieldMapping;
  UpdateLiveEventFeedSessionDataMutation: Omit<UpdateLiveEventFeedSessionDataMutation, 'liveEventFeed'> & { liveEventFeed?: Maybe<ResolversParentTypes['LiveEventChatGroupField']> };
  UpdateLiveSessionAnyUserInput: UpdateLiveSessionAnyUserInput;
  UpdateLiveSessionInput: UpdateLiveSessionInput;
  UpdateManyUserMutation: UpdateManyUserMutation;
  UpdateMarketplaceApplicantMutation: Omit<UpdateMarketplaceApplicantMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateMarketplaceApplicantUniversityLinkMutation: Omit<UpdateMarketplaceApplicantUniversityLinkMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateMarketplaceMutation: UpdateMarketplaceMutation;
  UpdateMentorMutation: Omit<UpdateMentorMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateMentorPreferences: UpdateMentorPreferences;
  UpdateMyUniversityLinkMutation: Omit<UpdateMyUniversityLinkMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdatePostStatusMutation: Omit<UpdatePostStatusMutation, 'blogPost'> & { blogPost?: Maybe<ResolversParentTypes['BlogPostField']> };
  UpdateRecordingLayoutArgs: UpdateRecordingLayoutArgs;
  UpdateResearchTimeMutation: UpdateResearchTimeMutation;
  UpdateStaffContactInput: UpdateStaffContactInput;
  UpdateStaffMutation: Omit<UpdateStaffMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateSubTopicMutation: UpdateSubTopicMutation;
  UpdateTagMutation: UpdateTagMutation;
  UpdateTopicMutation: UpdateTopicMutation;
  UpdateUniversityBlockReportMutation: Omit<UpdateUniversityBlockReportMutation, 'universityBlockReport'> & { universityBlockReport?: Maybe<ResolversParentTypes['UniversityBlockReportField']> };
  UpdateUniversityConfigMutation: UpdateUniversityConfigMutation;
  UpdateUniversityUserMutation: Omit<UpdateUniversityUserMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateUniversityUserPreferencesMutation: Omit<UpdateUniversityUserPreferencesMutation, 'me'> & { me?: Maybe<ResolversParentTypes['MeField']> };
  UpdateUserMutation: Omit<UpdateUserMutation, 'user'> & { user?: Maybe<ResolversParentTypes['UserField']> };
  UpdateUserPreferences: UpdateUserPreferences;
  UpdateUserProfile: UpdateUserProfile;
  UpdateVirtualEventInput: UpdateVirtualEventInput;
  UpdatedResults: UpdatedResults;
  Upload: Scalars['Upload']['output'];
  UserCustomAttributesFilterField: UserCustomAttributesFilterField;
  UserDecisionStageInput: UserDecisionStageInput;
  UserDecisionStageOutput: UserDecisionStageOutput;
  UserDegreeField: UserDegreeField;
  UserDirectoryResult: Omit<UserDirectoryResult, 'result'> & { result: Array<ResolversParentTypes['UserField']> };
  UserField: Omit<UserField, 'blockedByMentors' | 'blockedByUniversities' | 'communities' | 'communityProfile' | 'country' | 'customAttributes' | 'university'> & { blockedByMentors?: Maybe<Array<Maybe<ResolversParentTypes['BlockerField']>>>, blockedByUniversities?: Maybe<Array<Maybe<ResolversParentTypes['UniversityField']>>>, communities?: Maybe<Array<ResolversParentTypes['Community']>>, communityProfile?: Maybe<ResolversParentTypes['UserProfile']>, country?: Maybe<ResolversParentTypes['CountryField']>, customAttributes?: Maybe<Array<Maybe<ResolversParentTypes['CustomAttributeValueField']>>>, university?: Maybe<ResolversParentTypes['UniversityField']> };
  UserIdsListField: UserIdsListField;
  UserInterest: UserInterest;
  UserListField: Omit<UserListField, 'users'> & { users?: Maybe<Array<Maybe<ResolversParentTypes['UserField']>>> };
  UserLocalePreference: UserLocalePreference;
  UserLocalePreferenceInput: UserLocalePreferenceInput;
  UserNotInterestedStageInput: UserNotInterestedStageInput;
  UserPartialSearchFields: UserPartialSearchFields;
  UserPermissionsListField: UserPermissionsListField;
  UserPreferencesField: UserPreferencesField;
  UserProfile: Omit<UserProfile, 'areaOfStudy'> & { areaOfStudy?: Maybe<Array<ResolversParentTypes['DegreeField']>> };
  UserRecommendation: Omit<UserRecommendation, 'currentUser' | 'matches'> & { currentUser: ResolversParentTypes['UserField'], matches: Array<ResolversParentTypes['MatchedUser']> };
  UserReport: Omit<UserReport, 'community' | 'moderator' | 'reportee' | 'reporter' | 'university'> & { community?: Maybe<ResolversParentTypes['Community']>, moderator?: Maybe<ResolversParentTypes['UserField']>, reportee: ResolversParentTypes['UserField'], reporter: ResolversParentTypes['UserField'], university: ResolversParentTypes['UniversityField'] };
  UserReportModeratorInputDTO: UserReportModeratorInputDto;
  UserReportUserInputDTO: UserReportUserInputDto;
  UserTimeSheetExportField: UserTimeSheetExportField;
  UserTimeSpentBreakdown: UserTimeSpentBreakdown;
  UserTimeSpentStatsField: UserTimeSpentStatsField;
  UsersTimeSpentData: UsersTimeSpentData;
  VerifyAccount: VerifyAccount;
  VerifyCodeField: VerifyCodeField;
  VideoContent: VideoContent;
  VideoFile: VideoFile;
  VideoSession: VideoSession;
  VideoSessionField: VideoSessionField;
  VideoSessionToUpdateField: VideoSessionToUpdateField;
  VideoUploadLink: VideoUploadLink;
  VideoUploadLinkInput: VideoUploadLinkInput;
  VideoUploadPresignedFields: VideoUploadPresignedFields;
  VideoUrl: VideoUrl;
  ViewBlogMutation: Omit<ViewBlogMutation, 'post'> & { post?: Maybe<ResolversParentTypes['BlogPostField']> };
  VirtualEvent: Omit<VirtualEvent, 'university'> & { university: ResolversParentTypes['UniversityField'] };
  WidgetConversationDto: WidgetConversationDto;
  WidgetSnippetField: WidgetSnippetField;
  WidgetUrlField: WidgetUrlField;
  WidgetUrlsInput: WidgetUrlsInput;
  WillReplyField: WillReplyField;
  YearOfStudyField: YearOfStudyField;
  pinMessageDTO: PinMessageDto;
  unpinMessageDTO: UnpinMessageDto;
};

export type ActivateApplicantsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateApplicantsMutation'] = ResolversParentTypes['ActivateApplicantsMutation']> = {
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateMentorsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateMentorsMutation'] = ResolversParentTypes['ActivateMentorsMutation']> = {
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityField'] = ResolversParentTypes['ActivityField']> = {
  activitySource?: Resolver<Maybe<ResolversTypes['ActivitySourceField']>, ParentType, ContextType>;
  app?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivitySourceFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivitySourceField'] = ResolversParentTypes['ActivitySourceField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddAttributeOptionMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddAttributeOptionMutation'] = ResolversParentTypes['AddAttributeOptionMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddBotToChatGroupMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddBotToChatGroupMutation'] = ResolversParentTypes['AddBotToChatGroupMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddCustomAttributeMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCustomAttributeMutation'] = ResolversParentTypes['AddCustomAttributeMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddDegreeLevelsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddDegreeLevelsMutation'] = ResolversParentTypes['AddDegreeLevelsMutation']> = {
  degreeLevels?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeLevelField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddDegreesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddDegreesMutation'] = ResolversParentTypes['AddDegreesMutation']> = {
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddHobsonsConnectIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddHobsonsConnectIntegration'] = ResolversParentTypes['AddHobsonsConnectIntegration']> = {
  integration?: Resolver<Maybe<ResolversTypes['CampusManagementConnectIntegrationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddLocalesToAppResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddLocalesToApp'] = ResolversParentTypes['AddLocalesToApp']> = {
  appLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppLocaleField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddResearchTimeMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddResearchTimeMutation'] = ResolversParentTypes['AddResearchTimeMutation']> = {
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddYearOfStudyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddYearOfStudyMutation'] = ResolversParentTypes['AddYearOfStudyMutation']> = {
  yearOfStudy?: Resolver<Maybe<Array<Maybe<ResolversTypes['YearOfStudyField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminDeleteApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminDeleteApplicantMutation'] = ResolversParentTypes['AdminDeleteApplicantMutation']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRecommendation'] = ResolversParentTypes['AdminRecommendation']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cohort?: Resolver<Maybe<ResolversTypes['Cohort']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forDecisionStage?: Resolver<ResolversTypes['DecisionStageEnum'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  resourceType?: Resolver<ResolversTypes['RecommendationResourceType'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminRecommendationCountPerDecisionStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRecommendationCountPerDecisionStage'] = ResolversParentTypes['AdminRecommendationCountPerDecisionStage']> = {
  forDecisionStage?: Resolver<ResolversTypes['DecisionStageEnum'], ParentType, ContextType>;
  recommendationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminUpdateMentorMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUpdateMentorMutation'] = ResolversParentTypes['AdminUpdateMentorMutation']> = {
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserField'] = ResolversParentTypes['AdminUserField']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgeVerificationInfoFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgeVerificationInfoField'] = ResolversParentTypes['AgeVerificationInfoField']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consentAgeForCountry?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isMinor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertField'] = ResolversParentTypes['AlertField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllPostsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllPostsField'] = ResolversParentTypes['AllPostsField']> = {
  blogPosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>>, ParentType, ContextType>;
  blogPostsAuthors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  blogPostsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  blogPostsDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  blogPostsTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmbassadorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmbassadorField'] = ResolversParentTypes['AmbassadorField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reply?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmbassadorProfileInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmbassadorProfileInformation'] = ResolversParentTypes['AmbassadorProfileInformation']> = {
  accountRole?: Resolver<ResolversTypes['Buddies'], ParentType, ContextType>;
  bio?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  degreeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhoto?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmbassadorRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmbassadorRecommendation'] = ResolversParentTypes['AmbassadorRecommendation']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ambassadorId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  forDecisionStage?: Resolver<Maybe<ResolversTypes['DecisionStageEnum']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  resourceType?: Resolver<ResolversTypes['AmbassadorRecommendationResourceType'], ParentType, ContextType>;
  resourceURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sharedWithUser?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AmbassadorRecommendationResourceTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmbassadorRecommendationResourceType'] = ResolversParentTypes['AmbassadorRecommendationResourceType']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['AmbassadorRecommendationResourceTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Analytics'] = ResolversParentTypes['Analytics']> = {
  attendees?: Resolver<ResolversTypes['Attendees'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  messagesSent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  signups?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  virtualEventId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalyticsBuddyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalyticsBuddyField'] = ResolversParentTypes['AnalyticsBuddyField']> = {
  buddyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalyticsDashboardAuthFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalyticsDashboardAuthField'] = ResolversParentTypes['AnalyticsDashboardAuthField']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalyticsMentorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalyticsMentorField'] = ResolversParentTypes['AnalyticsMentorField']> = {
  data?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnyChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnyChatUserField'] = ResolversParentTypes['AnyChatUserField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatIntroMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headlineInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inboxInfoOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inboxInfoTwo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnterprise?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<AnyChatUserFieldProfilePhotoArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnyUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnyUserField'] = ResolversParentTypes['AnyUserField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, ParentType, ContextType>;
  domesticRegion?: Resolver<Maybe<ResolversTypes['DomesticRegionField']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prospectWelcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  staffFields?: Resolver<Maybe<ResolversTypes['StaffUserField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppLocaleFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppLocaleField'] = ResolversParentTypes['AppLocaleField']> = {
  locales?: Resolver<Maybe<Array<Maybe<ResolversTypes['Locale']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityLocalePreferenceApplies?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantBroadcastMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantBroadcastMessageMutation'] = ResolversParentTypes['ApplicantBroadcastMessageMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantCollectionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantCollectionField'] = ResolversParentTypes['ApplicantCollectionField']> = {
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustomField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantConversationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantConversationField'] = ResolversParentTypes['ApplicantConversationField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantCountFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantCountField'] = ResolversParentTypes['ApplicantCountField']> = {
  applicantCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantField'] = ResolversParentTypes['ApplicantField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ageVerificationInfo?: Resolver<Maybe<ResolversTypes['AgeVerificationInfoField']>, ParentType, ContextType>;
  applicantUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantUniversityLinkField']>>>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  degreesInterested?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasAcceptedMarketing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAppliedToCurrentUniversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReadChatRules?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkWithUniversity?: Resolver<Maybe<ResolversTypes['ApplicantUniversityLinkField']>, ParentType, ContextType, Partial<ApplicantFieldLinkWithUniversityArgs>>;
  localePreference?: Resolver<Maybe<ResolversTypes['UserLocalePreference']>, ParentType, ContextType>;
  marketplaces?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantMarketplaceObjectField']>>>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['ApplicantPreferencesField']>, ParentType, ContextType>;
  primaryApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schoolHistory?: Resolver<Maybe<ResolversTypes['ApplicantSchoolHistory']>, ParentType, ContextType>;
  signUpLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unibuddyServicesConsentAccepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  universitiesApplied?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantUniversityLinkField']>>>, ParentType, ContextType>;
  universitiesInterested?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantInboxField'] = ResolversParentTypes['ApplicantInboxField']> = {
  botChatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  chatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType>;
  universityClearingChatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantInvite'] = ResolversParentTypes['ApplicantInvite']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantLabelFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantLabelField'] = ResolversParentTypes['ApplicantLabelField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantMarketplaceObjectFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantMarketplaceObjectField'] = ResolversParentTypes['ApplicantMarketplaceObjectField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['MarketplaceApplicantUserData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantPreferencesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantPreferencesField'] = ResolversParentTypes['ApplicantPreferencesField']> = {
  newMessageNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantSchoolHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantSchoolHistory'] = ResolversParentTypes['ApplicantSchoolHistory']> = {
  highSchool?: Resolver<Maybe<ResolversTypes['HighSchoolField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantSignupStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantSignupStats'] = ResolversParentTypes['ApplicantSignupStats']> = {
  xAxis?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  yAxis?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantUniversityLinkFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantUniversityLinkField'] = ResolversParentTypes['ApplicantUniversityLinkField']> = {
  applied?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, ParentType, ContextType, Partial<ApplicantUniversityLinkFieldCustomAttributesArgs>>;
  dateOfEntry?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  degreesInterested?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  delinked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasAcceptedMarketing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  setupComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantUserField'] = ResolversParentTypes['ApplicantUserField']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantsAppliedStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantsAppliedStats'] = ResolversParentTypes['ApplicantsAppliedStats']> = {
  applied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notApplied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notReplied?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicantsMessagedCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicantsMessagedCount'] = ResolversParentTypes['ApplicantsMessagedCount']> = {
  messagedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationField'] = ResolversParentTypes['ApplicationField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationInsightModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationInsightModel'] = ResolversParentTypes['ApplicationInsightModel']> = {
  entryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalApplied?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedUsersCountModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedUsersCountModel'] = ResolversParentTypes['AppliedUsersCountModel']> = {
  appliedUsersCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantConversationFeedbackResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantConversationFeedback'] = ResolversParentTypes['AssistantConversationFeedback']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantConversationHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantConversationHistory'] = ResolversParentTypes['AssistantConversationHistory']> = {
  feedback?: Resolver<Maybe<ResolversTypes['AssistantConversationFeedback']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leadGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['AssistantConversationMessage']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantConversationHistoryWithTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantConversationHistoryWithToken'] = ResolversParentTypes['AssistantConversationHistoryWithToken']> = {
  feedback?: Resolver<Maybe<ResolversTypes['AssistantConversationFeedback']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leadGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['AssistantConversationMessage']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantConversationLeadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantConversationLead'] = ResolversParentTypes['AssistantConversationLead']> = {
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  marketingConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ubConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantConversationMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantConversationMessage'] = ResolversParentTypes['AssistantConversationMessage']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['AssistantMessageFeedback']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['MessageMetadata']>, ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['SenderRole'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssistantMessageFeedbackResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssistantMessageFeedback'] = ResolversParentTypes['AssistantMessageFeedback']> = {
  freeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AssistantMessageFeedbackType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = {
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AttachmentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttachmentFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttachmentField'] = ResolversParentTypes['AttachmentField']> = {
  payload?: Resolver<Maybe<ResolversTypes['PayloadField']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeeAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttendeeAnalytics'] = ResolversParentTypes['AttendeeAnalytics']> = {
  accountRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  virtualEventId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttendeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attendees'] = ResolversParentTypes['Attendees']> = {
  activeApplicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  applicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthField'] = ResolversParentTypes['AuthField']> = {
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['DeviceField']>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorSnippetField'] = ResolversParentTypes['AuthorSnippetField']> = {
  author?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseCustomAttributeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseCustomAttributeField'] = ResolversParentTypes['BaseCustomAttributeField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSyncedWithCrm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeOptionField']>>>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockUserMutation'] = ResolversParentTypes['BlockUserMutation']> = {
  objectsBlockedIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockUserMutationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockUserMutationV2'] = ResolversParentTypes['BlockUserMutationV2']> = {
  objectsBlockedIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockerFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockerField'] = ResolversParentTypes['BlockerField']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlogCommentFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlogCommentField'] = ResolversParentTypes['BlogCommentField']> = {
  author?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlogPostFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlogPostField'] = ResolversParentTypes['BlogPostField']> = {
  approved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  author?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogCommentField']>>>, ParentType, ContextType>;
  coverImages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType, Partial<BlogPostFieldCoverImagesArgs>>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  flaggedByUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<BlogPostFieldImageArgs>>;
  lastUpdatedBy?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  modified?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfViews?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ogShareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  readingTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BlogStatus']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['BlogTopicField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  videoContent?: Resolver<Maybe<ResolversTypes['VideoContent']>, ParentType, ContextType>;
  wordCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  youtubeVideo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlogTopicFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlogTopicField'] = ResolversParentTypes['BlogTopicField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlogcardSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlogcardSnippetField'] = ResolversParentTypes['BlogcardSnippetField']> = {
  authorSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuthorSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  topicSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopicSnippetField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BotUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BotUserField'] = ResolversParentTypes['BotUserField']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddiesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddiesField'] = ResolversParentTypes['BuddiesField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  randomizeListSeed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddiesFilterOptionsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddiesFilterOptionsField'] = ResolversParentTypes['BuddiesFilterOptionsField']> = {
  customAttributesFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributesFilterField']>>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddiesListFilterFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddiesListFilterField'] = ResolversParentTypes['BuddiesListFilterField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyApplicantChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyApplicantChatGroupField'] = ResolversParentTypes['BuddyApplicantChatGroupField']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationSource?: Resolver<Maybe<ResolversTypes['CreationSource']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unanswered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyApplicantChatGroupFieldV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyApplicantChatGroupFieldV2'] = ResolversParentTypes['BuddyApplicantChatGroupFieldV2']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  creationSource?: Resolver<Maybe<ResolversTypes['CreationSource']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastMessageSentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMessageText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  staff?: Resolver<Maybe<ResolversTypes['StaffField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyApplicantChatInterventionBuddyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyApplicantChatInterventionBuddyField'] = ResolversParentTypes['BuddyApplicantChatInterventionBuddyField']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<BuddyApplicantChatInterventionBuddyFieldProfilePhotoArgs>>;
  unansweredCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyField'] = ResolversParentTypes['BuddyField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, ParentType, ContextType, Partial<BuddyFieldCustomAttributesArgs>>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['GroupField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<BuddyFieldProfilePhotoArgs>>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  staffFields?: Resolver<Maybe<ResolversTypes['StaffUserFieldsField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyInviteFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyInviteField'] = ResolversParentTypes['BuddyInviteField']> = {
  buddyInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyInviteListField']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuddyInviteListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuddyInviteListField'] = ResolversParentTypes['BuddyInviteListField']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  notFound?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkApplicantFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkApplicantField'] = ResolversParentTypes['BulkApplicantField']> = {
  acceptMarketing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  applied?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  blockedByUniversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributesField']>>>, ParentType, ContextType>;
  dateOfEntry?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  degreesInterested?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  domesticRegion?: Resolver<Maybe<ResolversTypes['DomesticRegionField']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantLabelField']>>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schoolHistory?: Resolver<Maybe<ResolversTypes['ApplicantSchoolHistory']>, ParentType, ContextType>;
  signUpLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTrackingParams?: Resolver<Maybe<ResolversTypes['SourceTrackingParamsField']>, ParentType, ContextType>;
  universitiesInterested?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkOptOutMarketplaceUniversityMarketingMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkOptOutMarketplaceUniversityMarketingMutation'] = ResolversParentTypes['BulkOptOutMarketplaceUniversityMarketingMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ButtonFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ButtonField'] = ResolversParentTypes['ButtonField']> = {
  inline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmApplicantFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CRMApplicantField'] = ResolversParentTypes['CRMApplicantField']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CRMField'] = ResolversParentTypes['CRMField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  additionalInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmMetaData?: Resolver<Maybe<ResolversTypes['CRMMetaDataField']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmIntegrationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CRMIntegrationField'] = ResolversParentTypes['CRMIntegrationField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  connection?: Resolver<Maybe<ResolversTypes['CrmConnectionField']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<ResolversTypes['CRMField']>, ParentType, ContextType>;
  crmApplicantRecords?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmApplicantRecordField']>>>, ParentType, ContextType, Partial<CrmIntegrationFieldCrmApplicantRecordsArgs>>;
  crmIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldMapping?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldMappingField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobs?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmSyncJobField']>>>, ParentType, ContextType>;
  lastSyncJob?: Resolver<Maybe<ResolversTypes['CrmSyncJobField']>, ParentType, ContextType>;
  syncErrorCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  syncSuccessCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmMetaDataFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CRMMetaDataField'] = ResolversParentTypes['CRMMetaDataField']> = {
  additionalInfoLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalInfoText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoData?: Resolver<Maybe<Array<Maybe<ResolversTypes['LogoDataField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CsvUploadAmbassadorFieldsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CSVUploadAmbassadorFieldsMutation'] = ResolversParentTypes['CSVUploadAmbassadorFieldsMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CsvUploadApplicantsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CSVUploadApplicantsMutation'] = ResolversParentTypes['CSVUploadApplicantsMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CampusManagementConnectIntegrationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CampusManagementConnectIntegrationField'] = ResolversParentTypes['CampusManagementConnectIntegrationField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  clientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webServiceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CanonicalQuestionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CanonicalQuestionField'] = ResolversParentTypes['CanonicalQuestionField']> = {
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FaqAnswerField']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subTopic?: Resolver<Maybe<ResolversTypes['SubTopicField']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CarouselSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CarouselSnippetField'] = ResolversParentTypes['CarouselSnippetField']> = {
  defaultSnippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatConversation'] = ResolversParentTypes['ChatConversation']> = {
  communityChatDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communityChatDynamicLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communityChatMembers?: Resolver<Maybe<Array<ResolversTypes['UserField']>>, ParentType, ContextType, RequireFields<ChatConversationCommunityChatMembersArgs, 'offsetPagination'>>;
  communityChatTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDirect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNewsFeed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<ResolversTypes['Labels']>>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<ResolversTypes['UserField']>>, ParentType, ContextType, Partial<ChatConversationMembersArgs>>;
  mutedBy?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  pinnedMessages?: Resolver<Array<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  pinnedMessagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['ConversationTag']>>, ParentType, ContextType>;
  totalMemberCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  unreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatGroupAndMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatGroupAndMessages'] = ResolversParentTypes['ChatGroupAndMessages']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType>;
  offsetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatGroupAuxiliaryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatGroupAuxiliaryField'] = ResolversParentTypes['ChatGroupAuxiliaryField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupLabelField']>>>, ParentType, ContextType>;
  willReply?: Resolver<Maybe<ResolversTypes['WillReplyField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatGroupField'] = ResolversParentTypes['ChatGroupField']> = {
  applicant?: Resolver<Maybe<ResolversTypes['AnyChatUserField']>, ParentType, ContextType>;
  aux?: Resolver<Maybe<ResolversTypes['ChatGroupAuxiliaryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationSource?: Resolver<Maybe<ResolversTypes['CreationSource']>, ParentType, ContextType>;
  delinked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['LastMessageField']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnyUserField']>>>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType, Partial<ChatGroupFieldMessagesArgs>>;
  messagesForModeration?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType, Partial<ChatGroupFieldMessagesForModerationArgs>>;
  opponent?: Resolver<Maybe<ResolversTypes['AnyChatUserField']>, ParentType, ContextType>;
  pinnedMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['PinnedMessageField']>>>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendbirdChannelUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unansweredByMentor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  unreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatGroupLabelFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatGroupLabelField'] = ResolversParentTypes['ChatGroupLabelField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatInboxField'] = ResolversParentTypes['ChatInboxField']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['InboxItemLastMessageField']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatUserField']>>>, ParentType, ContextType>;
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessage'] = ResolversParentTypes['ChatMessage']> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSenderBlocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  likes?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  likesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reactions?: Resolver<Maybe<Array<ResolversTypes['Reaction']>>, ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  richContent?: Resolver<Maybe<ResolversTypes['RichMessageContent']>, ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatPermission'] = ResolversParentTypes['ChatPermission']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isMember?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatReport'] = ResolversParentTypes['ChatReport']> = {
  actionTaken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  community?: Resolver<ResolversTypes['Community'], ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType>;
  creationTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType>;
  moderationTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  moderator?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  moderatorComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modificationTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  reportee?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  reporter?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  reporterComment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reporterReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatRoomResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatRoom'] = ResolversParentTypes['ChatRoom']> = {
  chatRoomAnalytics?: Resolver<ResolversTypes['ChatRoomAnalytics'], ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatRoomAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatRoomAnalytics'] = ResolversParentTypes['ChatRoomAnalytics']> = {
  chatRoomAttendees?: Resolver<ResolversTypes['ChatRoomAttendees'], ParentType, ContextType>;
  chatRoomId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  chatRoomMessagesSent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  virtualEventId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatRoomAttendeeAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatRoomAttendeeAnalytics'] = ResolversParentTypes['ChatRoomAttendeeAnalytics']> = {
  accountRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  chatRoomId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatRoomAttendeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatRoomAttendees'] = ResolversParentTypes['ChatRoomAttendees']> = {
  activeApplicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  applicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatSummaryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSummaryField'] = ResolversParentTypes['ChatSummaryField']> = {
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chatSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generatedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  prospectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatUserField'] = ResolversParentTypes['ChatUserField']> = {
  __resolveType: TypeResolveFn<'ApplicantUserField' | 'MentorChatUserField' | 'StaffChatUserField', ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CheckEmailMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckEmailMutation'] = ResolversParentTypes['CheckEmailMutation']> = {
  emailExists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  passwordSetEmailSent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChildOrganisationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChildOrganisationField'] = ResolversParentTypes['ChildOrganisationField']> = {
  hasOrganisationAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClassificationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClassificationField'] = ResolversParentTypes['ClassificationField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sentence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topSubTopic?: Resolver<Maybe<ResolversTypes['TopSubTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloneLiveEventAndChannelsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloneLiveEventAndChannelsMutation'] = ResolversParentTypes['CloneLiveEventAndChannelsMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CohortResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cohort'] = ResolversParentTypes['Cohort']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  areaOfStudies?: Resolver<Maybe<Array<ResolversTypes['DegreeField']>>, ParentType, ContextType>;
  areaOfStudyIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['CountryField']>>, ParentType, ContextType>;
  countryIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  degreeLevelIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  degreeLevels?: Resolver<Maybe<Array<ResolversTypes['DegreeLevelField']>>, ParentType, ContextType>;
  domesticRegionIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  domesticRegions?: Resolver<Maybe<Array<ResolversTypes['DomesticRegionField']>>, ParentType, ContextType>;
  expectedEntryFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  expectedEntryTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentMutation'] = ResolversParentTypes['CommentMutation']> = {
  comment?: Resolver<Maybe<ResolversTypes['BlogCommentField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Community'] = ResolversParentTypes['Community']> = {
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blockedMembers?: Resolver<Maybe<Array<ResolversTypes['UserField']>>, ParentType, ContextType>;
  communityChatGroups?: Resolver<Array<ResolversTypes['CommunityChatGroup']>, ParentType, ContextType>;
  communityMemberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutions?: Resolver<Maybe<Array<ResolversTypes['UniversityField']>>, ParentType, ContextType>;
  inviteLinks?: Resolver<Array<ResolversTypes['InviteLinkDto']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<ResolversTypes['UserField']>>, ParentType, ContextType>;
  newsFeedGroups?: Resolver<Maybe<Array<ResolversTypes['NewsFeedGroup']>>, ParentType, ContextType>;
  requestedPublicGroups?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  settings?: Resolver<Maybe<ResolversTypes['SettingsObjectType']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  welcomeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityChatGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityChatGroup'] = ResolversParentTypes['CommunityChatGroup']> = {
  communityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamicLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDirect?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<ResolversTypes['Labels']>>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<ResolversTypes['UserField']>>, ParentType, ContextType>;
  mutedBy?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityField'] = ResolversParentTypes['CommunityField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityInviteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityInviteResponse'] = ResolversParentTypes['CommunityInviteResponse']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  communityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityInvitesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityInvites'] = ResolversParentTypes['CommunityInvites']> = {
  accepted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedInviteLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommunityJoinResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommunityJoinResponse'] = ResolversParentTypes['CommunityJoinResponse']> = {
  alreadyJoined?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  community?: Resolver<ResolversTypes['Community'], ParentType, ContextType>;
  joined?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompletedEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompletedEvent'] = ResolversParentTypes['CompletedEvent']> = {
  activeAttendees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  attendees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messagesSent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newSignUps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompletedEventsOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompletedEventsOverview'] = ResolversParentTypes['CompletedEventsOverview']> = {
  events?: Resolver<Maybe<Array<Maybe<ResolversTypes['CompletedEvent']>>>, ParentType, ContextType>;
  eventsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentBriefFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentBriefField'] = ResolversParentTypes['ContentBriefField']> = {
  brief?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isArchived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isValuable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maxDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceMetrics?: Resolver<Maybe<Array<Maybe<ResolversTypes['MetricDataPoint']>>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['Context'] = ResolversParentTypes['Context']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ContextType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationContextChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConversationContextChatGroupField'] = ResolversParentTypes['ConversationContextChatGroupField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationContextFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConversationContextField'] = ResolversParentTypes['ConversationContextField']> = {
  ambassador?: Resolver<Maybe<ResolversTypes['AmbassadorField']>, ParentType, ContextType>;
  applicantMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ConversationContextChatGroupField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationInboxResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConversationInbox'] = ResolversParentTypes['ConversationInbox']> = {
  contexts?: Resolver<Array<ResolversTypes['Context']>, ParentType, ContextType>;
  conversations?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConversationTag'] = ResolversParentTypes['ConversationTag']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CookieConsentOutputDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CookieConsentOutputDTO'] = ResolversParentTypes['CookieConsentOutputDTO']> = {
  preferences?: Resolver<ResolversTypes['PreferencesOutputType'], ParentType, ContextType>;
  uniqueId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountPerEpochResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountPerEpoch'] = ResolversParentTypes['CountPerEpoch']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  epoch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryAnalyticsValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryAnalyticsValue'] = ResolversParentTypes['CountryAnalyticsValue']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryField'] = ResolversParentTypes['CountryField']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountrySnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountrySnippetField'] = ResolversParentTypes['CountrySnippetField']> = {
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryStatField'] = ResolversParentTypes['CountryStatField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CourseSnippetField'] = ResolversParentTypes['CourseSnippetField']> = {
  degreeSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAlertMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAlertMutation'] = ResolversParentTypes['CreateAlertMutation']> = {
  alert?: Resolver<Maybe<ResolversTypes['AlertField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateApplicantMutation'] = ResolversParentTypes['CreateApplicantMutation']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicantMutationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateApplicantMutationV2'] = ResolversParentTypes['CreateApplicantMutationV2']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateBlogTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBlogTopicMutation'] = ResolversParentTypes['CreateBlogTopicMutation']> = {
  blogTopic?: Resolver<Maybe<ResolversTypes['BlogTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateBuddyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBuddyMutation'] = ResolversParentTypes['CreateBuddyMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  existingUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noInvite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCanonicalQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCanonicalQuestion'] = ResolversParentTypes['CreateCanonicalQuestion']> = {
  question?: Resolver<Maybe<ResolversTypes['CanonicalQuestionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCommunityApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCommunityApplicantMutation'] = ResolversParentTypes['CreateCommunityApplicantMutation']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCommunityApplicantMutationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCommunityApplicantMutationV2'] = ResolversParentTypes['CreateCommunityApplicantMutationV2']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCrmServiceUniversityConfigMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCrmServiceUniversityConfigMutation'] = ResolversParentTypes['CreateCrmServiceUniversityConfigMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityConfiguration?: Resolver<Maybe<ResolversTypes['CrmServiceUniversityConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateExternalEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateExternalEventMutation'] = ResolversParentTypes['CreateExternalEventMutation']> = {
  externalEvent?: Resolver<Maybe<ResolversTypes['ExternalEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFaqAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFaqAnswer'] = ResolversParentTypes['CreateFaqAnswer']> = {
  faqAnswer?: Resolver<Maybe<ResolversTypes['FaqAnswerField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFresherMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFresherMutation'] = ResolversParentTypes['CreateFresherMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fresher?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLiveEventDetailsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLiveEventDetailsMutation'] = ResolversParentTypes['CreateLiveEventDetailsMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLiveEventFeedMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLiveEventFeedMutation'] = ResolversParentTypes['CreateLiveEventFeedMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEventFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLiveEventFeedSessionsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLiveEventFeedSessionsMutation'] = ResolversParentTypes['CreateLiveEventFeedSessionsMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEventFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLiveEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLiveEventMutation'] = ResolversParentTypes['CreateLiveEventMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMarketplaceApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMarketplaceApplicantMutation'] = ResolversParentTypes['CreateMarketplaceApplicantMutation']> = {
  authenticatedApplicant?: Resolver<Maybe<ResolversTypes['AuthField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMarketplaceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMarketplaceMutation'] = ResolversParentTypes['CreateMarketplaceMutation']> = {
  marketplace?: Resolver<Maybe<ResolversTypes['MarketplaceField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMentorMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMentorMutation'] = ResolversParentTypes['CreateMentorMutation']> = {
  existingUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  noInvite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOpenDayMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOpenDayMutation'] = ResolversParentTypes['CreateOpenDayMutation']> = {
  openDay?: Resolver<Maybe<ResolversTypes['OpenDayField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrganisationBuddyLinkMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganisationBuddyLinkMutation'] = ResolversParentTypes['CreateOrganisationBuddyLinkMutation']> = {
  organisationBuddyLink?: Resolver<Maybe<ResolversTypes['OrganisationBuddyLinkField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOrganisationMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganisationMutation'] = ResolversParentTypes['CreateOrganisationMutation']> = {
  organisation?: Resolver<Maybe<ResolversTypes['OrganisationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePostMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePostMutation'] = ResolversParentTypes['CreatePostMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['BlogPostField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSubTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSubTopicMutation'] = ResolversParentTypes['CreateSubTopicMutation']> = {
  subTopic?: Resolver<Maybe<ResolversTypes['SubTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTagMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTagMutation'] = ResolversParentTypes['CreateTagMutation']> = {
  tag?: Resolver<Maybe<ResolversTypes['TagField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTopicMutation'] = ResolversParentTypes['CreateTopicMutation']> = {
  topic?: Resolver<Maybe<ResolversTypes['TopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUniversityBlockReportMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUniversityBlockReportMutation'] = ResolversParentTypes['CreateUniversityBlockReportMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityBlockReport?: Resolver<Maybe<ResolversTypes['UniversityBlockReportField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUniversityMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUniversityMutation'] = ResolversParentTypes['CreateUniversityMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUniversityUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUniversityUserMutation'] = ResolversParentTypes['CreateUniversityUserMutation']> = {
  universityUser?: Resolver<Maybe<ResolversTypes['UniversityUserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserMutation'] = ResolversParentTypes['CreateUserMutation']> = {
  user?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreationSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreationSource'] = ResolversParentTypes['CreationSource']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmApplicantRecordFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmApplicantRecordField'] = ResolversParentTypes['CrmApplicantRecordField']> = {
  applicant?: Resolver<Maybe<ResolversTypes['CRMApplicantField']>, ParentType, ContextType>;
  crmApplicantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSync?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmAttributeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmAttributeField'] = ResolversParentTypes['CrmAttributeField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmConnectionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmConnectionField'] = ResolversParentTypes['CrmConnectionField']> = {
  connectionError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isConnected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDataFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDataField'] = ResolversParentTypes['CrmDataField']> = {
  deprecated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustomField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sampleValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmFieldSyncStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmFieldSyncStatus'] = ResolversParentTypes['CrmFieldSyncStatus']> = {
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSyncActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmServiceUniversityConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmServiceUniversityConfig'] = ResolversParentTypes['CrmServiceUniversityConfig']> = {
  allFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmDataField']>>>, ParentType, ContextType>;
  connectorEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataFormatConfigs?: Resolver<Maybe<Array<Maybe<ResolversTypes['DataFormatConfig']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmDataField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSyncActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  universityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universitySlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zapierWebhook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSyncJobFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSyncJobField'] = ResolversParentTypes['CrmSyncJobField']> = {
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  synced?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toSync?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentDecisionStageOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentDecisionStageOutput'] = ResolversParentTypes['CurrentDecisionStageOutput']> = {
  decisionStage?: Resolver<Maybe<ResolversTypes['DecisionStageEnum']>, ParentType, ContextType>;
  decisionStageLocation?: Resolver<Maybe<ResolversTypes['DecisionStageLocationEnum']>, ParentType, ContextType>;
  notInterestedReason?: Resolver<Maybe<ResolversTypes['NotInterestedReasonEnum']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributeField'] = ResolversParentTypes['CustomAttributeField']> = {
  __resolveType: TypeResolveFn<'BaseCustomAttributeField' | 'SingleChoiceAttributeField', ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSyncedWithCrm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeOptionField']>>>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CustomAttributeOptionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributeOptionField'] = ResolversParentTypes['CustomAttributeOptionField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributeValueFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributeValueField'] = ResolversParentTypes['CustomAttributeValueField']> = {
  __resolveType: TypeResolveFn<'DateValueField' | 'OpenTextFieldValueField' | 'SingleChoiceValueField', ParentType, ContextType>;
  attribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CustomAttributesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributesField'] = ResolversParentTypes['CustomAttributesField']> = {
  attribute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  option?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributesFilterFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributesFilterField'] = ResolversParentTypes['CustomAttributesFilterField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributesFilterOptionField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributesFilterOptionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAttributesFilterOptionField'] = ResolversParentTypes['CustomAttributesFilterOptionField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataFormatConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['DataFormatConfig'] = ResolversParentTypes['DataFormatConfig']> = {
  dataFormatConfigName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataFormatConfigValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DateValueFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateValueField'] = ResolversParentTypes['DateValueField']> = {
  attribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeactivateApplicantsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateApplicantsMutation'] = ResolversParentTypes['DeactivateApplicantsMutation']> = {
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeactivateMentorsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateMentorsMutation'] = ResolversParentTypes['DeactivateMentorsMutation']> = {
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DefaultQuestionsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultQuestionsField'] = ResolversParentTypes['DefaultQuestionsField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTopic?: Resolver<Maybe<ResolversTypes['SubTopicField']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeCategoriesAnalyticsValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeCategoriesAnalyticsValue'] = ResolversParentTypes['DegreeCategoriesAnalyticsValue']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeCategoryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeCategoryField'] = ResolversParentTypes['DegreeCategoryField']> = {
  categoryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hierarchyRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parents?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeCategoryParentField']>>>, ParentType, ContextType>;
  relatedKeywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeCategoryParentFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeCategoryParentField'] = ResolversParentTypes['DegreeCategoryParentField']> = {
  categoryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hierarchyRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeChatUserField'] = ResolversParentTypes['DegreeChatUserField']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeField'] = ResolversParentTypes['DegreeField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeCategoryField']>>>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  degreeType?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeType']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeLevelFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeLevelField'] = ResolversParentTypes['DegreeLevelField']> = {
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  yearOfStudy?: Resolver<Maybe<Array<Maybe<ResolversTypes['YearOfStudyField']>>>, ParentType, ContextType, RequireFields<DegreeLevelFieldYearOfStudyArgs, 'includeArchived'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeSnippetField'] = ResolversParentTypes['DegreeSnippetField']> = {
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeStatField'] = ResolversParentTypes['DegreeStatField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DegreeTypeOrderFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DegreeTypeOrderField'] = ResolversParentTypes['DegreeTypeOrderField']> = {
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DegreeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteApplicantMutation'] = ResolversParentTypes['DeleteApplicantMutation']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAttributeOptionsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAttributeOptionsMutation'] = ResolversParentTypes['DeleteAttributeOptionsMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCanonicalQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteCanonicalQuestion'] = ResolversParentTypes['DeleteCanonicalQuestion']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCustomAttributesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteCustomAttributesMutation'] = ResolversParentTypes['DeleteCustomAttributesMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDegreeLevelMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteDegreeLevelMutation'] = ResolversParentTypes['DeleteDegreeLevelMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFaqAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteFaqAnswer'] = ResolversParentTypes['DeleteFaqAnswer']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteKnowledgeBaseEntriesOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteKnowledgeBaseEntriesOutput'] = ResolversParentTypes['DeleteKnowledgeBaseEntriesOutput']> = {
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urls?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteLiveEventFeedMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteLiveEventFeedMutation'] = ResolversParentTypes['DeleteLiveEventFeedMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEventFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteLiveEventMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteLiveEventMessageMutation'] = ResolversParentTypes['DeleteLiveEventMessageMutation']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteLiveEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteLiveEventMutation'] = ResolversParentTypes['DeleteLiveEventMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletePostMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePostMutation'] = ResolversParentTypes['DeletePostMutation']> = {
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRecordingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteRecordingResponse'] = ResolversParentTypes['DeleteRecordingResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteResearchTimeMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteResearchTimeMutation'] = ResolversParentTypes['DeleteResearchTimeMutation']> = {
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSubTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSubTopicMutation'] = ResolversParentTypes['DeleteSubTopicMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTopicMutation'] = ResolversParentTypes['DeleteTopicMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUniversityUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUniversityUserMutation'] = ResolversParentTypes['DeleteUniversityUserMutation']> = {
  universityUser?: Resolver<Maybe<ResolversTypes['UniversityUserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserMutation'] = ResolversParentTypes['DeleteUserMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteYearOfStudyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteYearOfStudyMutation'] = ResolversParentTypes['DeleteYearOfStudyMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepartmentSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepartmentSnippetField'] = ResolversParentTypes['DepartmentSnippetField']> = {
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DescriptionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescriptionField'] = ResolversParentTypes['DescriptionField']> = {
  descriptionTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instructionTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceField'] = ResolversParentTypes['DeviceField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceMutation'] = ResolversParentTypes['DeviceMutation']> = {
  device?: Resolver<Maybe<ResolversTypes['DeviceField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceToken'] = ResolversParentTypes['DeviceToken']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deviceToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  system?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectMessagingApplicantResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectMessagingApplicant'] = ResolversParentTypes['DirectMessagingApplicant']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectMessagingEnquiryTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectMessagingEnquiryTeam'] = ResolversParentTypes['DirectMessagingEnquiryTeam']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectMessagingMentorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectMessagingMentor'] = ResolversParentTypes['DirectMessagingMentor']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  mentor?: Resolver<Maybe<ResolversTypes['PublicMentorField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectMessagingStaffMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectMessagingStaffMember'] = ResolversParentTypes['DirectMessagingStaffMember']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  staffMember?: Resolver<Maybe<ResolversTypes['BuddyField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayResolvers<ContextType = any, ParentType extends ResolversParentTypes['Display'] = ResolversParentTypes['Display']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticRegionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticRegionField'] = ResolversParentTypes['DomesticRegionField']> = {
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditAlertMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditAlertMutation'] = ResolversParentTypes['EditAlertMutation']> = {
  alert?: Resolver<Maybe<ResolversTypes['AlertField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditAttributeOptionMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditAttributeOptionMutation'] = ResolversParentTypes['EditAttributeOptionMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditBlogTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditBlogTopicMutation'] = ResolversParentTypes['EditBlogTopicMutation']> = {
  blogTopic?: Resolver<Maybe<ResolversTypes['BlogTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditCustomAttributeMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditCustomAttributeMutation'] = ResolversParentTypes['EditCustomAttributeMutation']> = {
  customAttribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditCustomAttributesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditCustomAttributesMutation'] = ResolversParentTypes['EditCustomAttributesMutation']> = {
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeField']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditCustomWelcomeMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditCustomWelcomeMessageMutation'] = ResolversParentTypes['EditCustomWelcomeMessageMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditDegreeLevelMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditDegreeLevelMutation'] = ResolversParentTypes['EditDegreeLevelMutation']> = {
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditDegreeNameMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditDegreeNameMutation'] = ResolversParentTypes['EditDegreeNameMutation']> = {
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditDegreesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditDegreesMutation'] = ResolversParentTypes['EditDegreesMutation']> = {
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditExternalEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditExternalEventMutation'] = ResolversParentTypes['EditExternalEventMutation']> = {
  externalEvent?: Resolver<Maybe<ResolversTypes['ExternalEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditLiveEventDetailsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditLiveEventDetailsMutation'] = ResolversParentTypes['EditLiveEventDetailsMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditLiveEventFeedMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditLiveEventFeedMutation'] = ResolversParentTypes['EditLiveEventFeedMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEventFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditLiveEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditLiveEventMutation'] = ResolversParentTypes['EditLiveEventMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['FormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditLiveEventsLandingPageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditLiveEventsLandingPageMutation'] = ResolversParentTypes['EditLiveEventsLandingPageMutation']> = {
  liveEventLandingPage?: Resolver<Maybe<ResolversTypes['LiveEventLandingPageField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditOpenDayMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditOpenDayMutation'] = ResolversParentTypes['EditOpenDayMutation']> = {
  openDay?: Resolver<Maybe<ResolversTypes['OpenDayField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditOrganisationMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditOrganisationMutation'] = ResolversParentTypes['EditOrganisationMutation']> = {
  organisation?: Resolver<Maybe<ResolversTypes['OrganisationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditPostMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditPostMutation'] = ResolversParentTypes['EditPostMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['BlogPostField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditUniversityMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditUniversityMutation'] = ResolversParentTypes['EditUniversityMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditYearOfStudyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditYearOfStudyMutation'] = ResolversParentTypes['EditYearOfStudyMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearOfStudy?: Resolver<Maybe<ResolversTypes['YearOfStudyField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmbeddedEventFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmbeddedEventField'] = ResolversParentTypes['EmbeddedEventField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmbeddedEventSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmbeddedEventSnippetField'] = ResolversParentTypes['EmbeddedEventSnippetField']> = {
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  embeddedEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmbeddedEventField']>>>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnableCustomWelcomeMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnableCustomWelcomeMessageMutation'] = ResolversParentTypes['EnableCustomWelcomeMessageMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnableCustomWelcomeMessageStaffMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnableCustomWelcomeMessageStaffMutation'] = ResolversParentTypes['EnableCustomWelcomeMessageStaffMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnableFeaturesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnableFeaturesMutation'] = ResolversParentTypes['EnableFeaturesMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrolledInsightResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnrolledInsightResponse'] = ResolversParentTypes['EnrolledInsightResponse']> = {
  community?: Resolver<ResolversTypes['CommunityField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalApplicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEnrolled?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnterpriseAddOnsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnterpriseAddOns'] = ResolversParentTypes['EnterpriseAddOns']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnterpriseMentorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnterpriseMentorField'] = ResolversParentTypes['EnterpriseMentorField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  blogPostCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedToOrganisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationField']>>>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceOrganisation?: Resolver<Maybe<ResolversTypes['OrganisationField']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntriesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntriesField'] = ResolversParentTypes['EntriesField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  entryMonths?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventPage'] = ResolversParentTypes['EventPage']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventPagesDisplayedOnResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventPagesDisplayedOn'] = ResolversParentTypes['EventPagesDisplayedOn']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportAnalyticsCsvMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportAnalyticsCsvMutation'] = ResolversParentTypes['ExportAnalyticsCsvMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportTimeSheetDataFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportTimeSheetDataField'] = ResolversParentTypes['ExportTimeSheetDataField']> = {
  usersTimesheetData?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserTimeSheetExportField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportedReportFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportedReportField'] = ResolversParentTypes['ExportedReportField']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalContent'] = ResolversParentTypes['ExternalContent']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventPagesDisplayedOn?: Resolver<Array<ResolversTypes['EventPagesDisplayedOn']>, ParentType, ContextType>;
  eventPagesIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  externalContentImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalContentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showOnHomepage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalEventFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalEventField'] = ResolversParentTypes['ExternalEventField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaqAnswerFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaqAnswerField'] = ResolversParentTypes['FaqAnswerField']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mentor?: Resolver<ResolversTypes['MentorField'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureField'] = ResolversParentTypes['FeatureField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionClickablePart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureRulesDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureRulesDTO'] = ResolversParentTypes['FeatureRulesDTO']> = {
  roles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  universities?: Resolver<Maybe<Array<ResolversTypes['UniversityOutput']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldMappingFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldMappingField'] = ResolversParentTypes['FieldMappingField']> = {
  applicationField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlagFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlagField'] = ResolversParentTypes['FlagField']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FormFieldValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FormFieldValidationError'] = ResolversParentTypes['FormFieldValidationError']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForwardApplicantToUniversityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForwardApplicantToUniversity'] = ResolversParentTypes['ForwardApplicantToUniversity']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeckoUniversityDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeckoUniversityData'] = ResolversParentTypes['GeckoUniversityData']> = {
  geckoUniversityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geckoUniversityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateAnalyticsDashboardTokenMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateAnalyticsDashboardTokenMutation'] = ResolversParentTypes['GenerateAnalyticsDashboardTokenMutation']> = {
  analyticsAuth?: Resolver<Maybe<ResolversTypes['AnalyticsDashboardAuthField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateLiveEventReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateLiveEventReport'] = ResolversParentTypes['GenerateLiveEventReport']> = {
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GenericScalarScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GenericScalar'], any> {
  name: 'GenericScalar';
}

export type GetDownloadableUrlMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetDownloadableURLMutation'] = ResolversParentTypes['GetDownloadableURLMutation']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetInvitesForEmailDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetInvitesForEmailDTO'] = ResolversParentTypes['GetInvitesForEmailDTO']> = {
  community?: Resolver<ResolversTypes['Community'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetMarketplaceApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetMarketplaceApplicantMutation'] = ResolversParentTypes['GetMarketplaceApplicantMutation']> = {
  authenticatedApplicant?: Resolver<Maybe<ResolversTypes['AuthField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOrCreateApiKeyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrCreateApiKeyMutation'] = ResolversParentTypes['GetOrCreateApiKeyMutation']> = {
  apiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetRecordingFailureIdsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetRecordingFailureIdsResponse'] = ResolversParentTypes['GetRecordingFailureIdsResponse']> = {
  failedIds?: Resolver<Array<ResolversTypes['RecordingFailureId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSignedS3PostFieldsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSignedS3PostFieldsMutation'] = ResolversParentTypes['GetSignedS3PostFieldsMutation']> = {
  postFieldsObject?: Resolver<Maybe<ResolversTypes['SignedS3POSTFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSignedS3UrlMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSignedS3UrlMutation'] = ResolversParentTypes['GetSignedS3UrlMutation']> = {
  signedObject?: Resolver<Maybe<ResolversTypes['SignedS3URLField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiphyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Giphy'] = ResolversParentTypes['Giphy']> = {
  aspectRatio?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GifType'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['GraphField'] = ResolversParentTypes['GraphField']> = {
  xAxis?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  yAxis?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  yWeights?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupField'] = ResolversParentTypes['GroupField']> = {
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HideMentorInMarketplaceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['HideMentorInMarketplaceMutation'] = ResolversParentTypes['HideMentorInMarketplaceMutation']> = {
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighSchoolFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighSchoolField'] = ResolversParentTypes['HighSchoolField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighSchoolTypeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighSchoolTypeField'] = ResolversParentTypes['HighSchoolTypeField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HousingObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['HousingObject'] = ResolversParentTypes['HousingObject']> = {
  category?: Resolver<ResolversTypes['HousingCategory'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboxItemInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxItemInterface'] = ResolversParentTypes['InboxItemInterface']> = {
  __resolveType: TypeResolveFn<'ChatInboxField' | 'UniversityChatInboxField', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['InboxItemLastMessageField']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatUserField']>>>, ParentType, ContextType>;
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type InboxItemLastMessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxItemLastMessageField'] = ResolversParentTypes['InboxItemLastMessageField']> = {
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isFromUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboxItemUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxItemUnion'] = ResolversParentTypes['InboxItemUnion']> = {
  __resolveType: TypeResolveFn<'ChatInboxField' | 'UniversityChatInboxField', ParentType, ContextType>;
};

export type InboxPromptAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxPromptAnswer'] = ResolversParentTypes['InboxPromptAnswer']> = {
  answeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboxPromptOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxPromptOption'] = ResolversParentTypes['InboxPromptOption']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboxPromptQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxPromptQuestion'] = ResolversParentTypes['InboxPromptQuestion']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  answers?: Resolver<Array<ResolversTypes['InboxPromptAnswer']>, ParentType, ContextType, RequireFields<InboxPromptQuestionAnswersArgs, 'inboxPromptInput'>>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['InboxPromptOption']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboxUniversityFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboxUniversityField'] = ResolversParentTypes['InboxUniversityField']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  squareLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialiseRecordingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitialiseRecordingResponse'] = ResolversParentTypes['InitialiseRecordingResponse']> = {
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  layoutMode?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  layoutStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InputFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputField'] = ResolversParentTypes['InputField']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InsightsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Insights'] = ResolversParentTypes['Insights']> = {
  communityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  totalApplicantsInCommunity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalEnrolled?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InsightsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InsightsField'] = ResolversParentTypes['InsightsField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopicStatisticField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestResolvers<ContextType = any, ParentType extends ResolversParentTypes['Interest'] = ResolversParentTypes['Interest']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterestObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterestObject'] = ResolversParentTypes['InterestObject']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterventionMessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterventionMessageField'] = ResolversParentTypes['InterventionMessageField']> = {
  message?: Resolver<Maybe<ResolversTypes['MessageField']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invite'] = ResolversParentTypes['Invite']> = {
  communityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invitedEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reminderStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendUnibuddyEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteApplicantsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteApplicantsMutation'] = ResolversParentTypes['InviteApplicantsMutation']> = {
  alreadyExistingInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  failedInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  successfulInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteBuddiesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteBuddiesMutation'] = ResolversParentTypes['InviteBuddiesMutation']> = {
  failedInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  successfulInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyInviteListField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteInformation'] = ResolversParentTypes['InviteInformation']> = {
  community?: Resolver<ResolversTypes['Community'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invite?: Resolver<Maybe<ResolversTypes['Invite']>, ParentType, ContextType>;
  isPartOfCommunity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteLinkDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteLinkDto'] = ResolversParentTypes['InviteLinkDto']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  communityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiringAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  labels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteLinkInfoDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteLinkInfoDto'] = ResolversParentTypes['InviteLinkInfoDto']> = {
  communityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  communityTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privacyPolicyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  squareLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universitySlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteMentorsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteMentorsMutation'] = ResolversParentTypes['InviteMentorsMutation']> = {
  successfulInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInviteField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface IsoDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['IsoDateTime'], any> {
  name: 'IsoDateTime';
}

export interface JsonStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONString'], any> {
  name: 'JSONString';
}

export type JoinChatGroupMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JoinChatGroupMutation'] = ResolversParentTypes['JoinChatGroupMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KnowledgeBaseDeleteEntryOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['KnowledgeBaseDeleteEntryOutput'] = ResolversParentTypes['KnowledgeBaseDeleteEntryOutput']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KnowledgeBaseEmbeddingResolvers<ContextType = any, ParentType extends ResolversParentTypes['KnowledgeBaseEmbedding'] = ResolversParentTypes['KnowledgeBaseEmbedding']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  ids?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KnowledgeBaseSourcesByUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['KnowledgeBaseSourcesByUrl'] = ResolversParentTypes['KnowledgeBaseSourcesByUrl']> = {
  ids?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabelSentenceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabelSentenceMutation'] = ResolversParentTypes['LabelSentenceMutation']> = {
  labelSentence?: Resolver<ResolversTypes['LabellingField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabellingFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabellingField'] = ResolversParentTypes['LabellingField']> = {
  chatGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classifiedSentenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embeddedSubTopic?: Resolver<Maybe<ResolversTypes['TopSubTopicField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTopicExternalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topicExternalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabellingSentenceCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabellingSentenceCandidate'] = ResolversParentTypes['LabellingSentenceCandidate']> = {
  classifiedSentenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topSubTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopSubTopicField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabelsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Labels'] = ResolversParentTypes['Labels']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LanguageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LanguageField'] = ResolversParentTypes['LanguageField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastMessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastMessageField'] = ResolversParentTypes['LastMessageField']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastReadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastRead'] = ResolversParentTypes['LastRead']> = {
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaveChatGroupMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaveChatGroupMutation'] = ResolversParentTypes['LeaveChatGroupMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LevelSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LevelSnippetField'] = ResolversParentTypes['LevelSnippetField']> = {
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LikeMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LikeMessageMutation'] = ResolversParentTypes['LikeMessageMutation']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LimitedIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LimitedInt'], any> {
  name: 'LimitedInt';
}

export type LinkOrganisationsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkOrganisationsMutation'] = ResolversParentTypes['LinkOrganisationsMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListBuddyApplicantConversationsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListBuddyApplicantConversationsField'] = ResolversParentTypes['ListBuddyApplicantConversationsField']> = {
  conversations?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyApplicantChatGroupFieldV2']>>>, ParentType, ContextType>;
  totalConversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListMentorApplicantConversationsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListMentorApplicantConversationsField'] = ResolversParentTypes['ListMentorApplicantConversationsField']> = {
  conversations?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorApplicantChatGroupField']>>>, ParentType, ContextType>;
  totalConversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListUniversityAssistantConversationsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListUniversityAssistantConversationsOutput'] = ResolversParentTypes['ListUniversityAssistantConversationsOutput']> = {
  conversationCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  conversations?: Resolver<Array<ResolversTypes['UniversityAssistantConversation']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventChatGroupField'] = ResolversParentTypes['LiveEventChatGroupField']> = {
  applicantCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantField']>>>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasEnquiryTeam?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hostIdsVideoSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordingEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  staff?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserField']>>>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  universityUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityUserField']>>>, ParentType, ContextType>;
  videoEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  videoSessions?: Resolver<Maybe<Array<Maybe<ResolversTypes['VideoSessionField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventDetailedReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventDetailedReport'] = ResolversParentTypes['LiveEventDetailedReport']> = {
  applicantCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventDetailedReportCountryStats']>>>, ParentType, ContextType>;
  liveEventId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messagesPerChannel?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventDetailedReportChannelStats']>>>, ParentType, ContextType>;
  prospectInLiveEvent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prospectLoggedIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prospectSignUps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prospectsInLiveEventChatGroups?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prospectsSendDirectMessage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prospectsSendMessage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventDetailedReportChannelStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventDetailedReportChannelStats'] = ResolversParentTypes['LiveEventDetailedReportChannelStats']> = {
  applicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  len?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventDetailedReportCountryStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventDetailedReportCountryStats'] = ResolversParentTypes['LiveEventDetailedReportCountryStats']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventDetailsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventDetailsField'] = ResolversParentTypes['LiveEventDetailsField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isUserRegistered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventDirectMessagingResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventDirectMessaging'] = ResolversParentTypes['LiveEventDirectMessaging']> = {
  applicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['DirectMessagingApplicant']>>>, ParentType, ContextType>;
  enquiryTeam?: Resolver<Maybe<ResolversTypes['DirectMessagingEnquiryTeam']>, ParentType, ContextType>;
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DirectMessagingMentor']>>>, ParentType, ContextType>;
  staff?: Resolver<Maybe<Array<Maybe<ResolversTypes['DirectMessagingStaffMember']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventFeedbackFormMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventFeedbackFormMutation'] = ResolversParentTypes['LiveEventFeedbackFormMutation']> = {
  feedBackForm?: Resolver<Maybe<ResolversTypes['LiveEventProspectFeedbackFormField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventField'] = ResolversParentTypes['LiveEventField']> = {
  allMentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType>;
  allStaff?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyField']>>>, ParentType, ContextType>;
  applicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUniversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailedReport?: Resolver<Maybe<ResolversTypes['LiveEventDetailedReport']>, ParentType, ContextType>;
  directMessagingMentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType>;
  directMessagingStaff?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyField']>>>, ParentType, ContextType>;
  directMessagingUniversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inbox?: Resolver<Maybe<ResolversTypes['LiveEventInboxField']>, ParentType, ContextType, RequireFields<LiveEventFieldInboxArgs, 'limit'>>;
  liveFeeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventChatGroupField']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  setupCompleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventInboxField'] = ResolversParentTypes['LiveEventInboxField']> = {
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['InboxItemUnion']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventLandingPageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventLandingPageField'] = ResolversParentTypes['LiveEventLandingPageField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExternalEventField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventDetailsField']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventProspectFeedbackFormFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventProspectFeedbackFormField'] = ResolversParentTypes['LiveEventProspectFeedbackFormField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveEventsFormFieldValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveEventsFormFieldValidationError'] = ResolversParentTypes['LiveEventsFormFieldValidationError']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveSession'] = ResolversParentTypes['LiveSession']> = {
  conversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  eventPagesDisplayedOn?: Resolver<Array<ResolversTypes['EventPagesDisplayedOn']>, ParentType, ContextType>;
  eventPagesIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  isSavedByMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  presenters?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType>;
  recordingEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionAnalytics?: Resolver<ResolversTypes['SessionAnalytics'], ParentType, ContextType>;
  sessionImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showOnHomepage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Locale'] = ResolversParentTypes['Locale']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocaleFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocaleField'] = ResolversParentTypes['LocaleField']> = {
  androidCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dialectOf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  osxCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  osxLocale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textDirection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threeLettersCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  twoLettersCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoDataFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoDataField'] = ResolversParentTypes['LogoDataField']> = {
  logoText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutMutation'] = ResolversParentTypes['LogoutMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManageOrganisationAccessMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManageOrganisationAccessMutation'] = ResolversParentTypes['ManageOrganisationAccessMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManuallyClassifyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManuallyClassifyMutation'] = ResolversParentTypes['ManuallyClassifyMutation']> = {
  classification?: Resolver<ResolversTypes['ClassificationField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceApplicantCountriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceApplicantCountries'] = ResolversParentTypes['MarketplaceApplicantCountries']> = {
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryAnalyticsValue']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceApplicantDegreeCategoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceApplicantDegreeCategories'] = ResolversParentTypes['MarketplaceApplicantDegreeCategories']> = {
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeCategoriesAnalyticsValue']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceApplicantUserDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceApplicantUserData'] = ResolversParentTypes['MarketplaceApplicantUserData']> = {
  custom?: Resolver<Maybe<ResolversTypes['GenericScalar']>, ParentType, ContextType>;
  degreeCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketingConsentAccepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  personalDataCollectionAccepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  yearOfEntry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceField'] = ResolversParentTypes['MarketplaceField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowUniversityProspectDataAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  colour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customBuddyWord?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['MarketplaceFilters']>>>, ParentType, ContextType>;
  disableExternalNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  faAppId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSsoEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  marketplaceMarketingConsentCollectionEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  marketplaceMarketingConsentMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalDataApiEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  privacyPolicyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unibuddyMarketingConsentEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  universityMarketingConsentEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  webhookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceFiltersResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceFilters'] = ResolversParentTypes['MarketplaceFilters']> = {
  filterSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceInboxField'] = ResolversParentTypes['MarketplaceInboxField']> = {
  chatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceMentorListResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceMentorList'] = ResolversParentTypes['MarketplaceMentorList']> = {
  mentorSeed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>>, ParentType, ContextType>;
  totalMentors?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  universitySeed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketplaceSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketplaceSnippetField'] = ResolversParentTypes['MarketplaceSnippetField']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['MatchedUser'] = ResolversParentTypes['MatchedUser']> = {
  matchingCriteria?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  matchingPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeField'] = ResolversParentTypes['MeField']> = {
  admin?: Resolver<Maybe<ResolversTypes['AdminUserField']>, ParentType, ContextType>;
  anyUser?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  staff?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  universityUser?: Resolver<Maybe<ResolversTypes['UniversityUserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorApplicantChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorApplicantChatGroupField'] = ResolversParentTypes['MentorApplicantChatGroupField']> = {
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationSource?: Resolver<Maybe<ResolversTypes['CreationSource']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastMessageSentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMessageText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unansweredByMentor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorBroadcastMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorBroadcastMessageMutation'] = ResolversParentTypes['MentorBroadcastMessageMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorChatUserField'] = ResolversParentTypes['MentorChatUserField']> = {
  degree?: Resolver<Maybe<ResolversTypes['DegreeChatUserField']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MentorChatUserFieldProfilePhotoArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorDegreeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorDegreeField'] = ResolversParentTypes['MentorDegreeField']> = {
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  degreeType?: Resolver<Maybe<ResolversTypes['DegreeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorDegreeHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorDegreeHistory'] = ResolversParentTypes['MentorDegreeHistory']> = {
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorField'] = ResolversParentTypes['MentorField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blogPostCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cardComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chatIntro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, ParentType, ContextType, Partial<MentorFieldCustomAttributesArgs>>;
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  degreeHistory?: Resolver<Maybe<ResolversTypes['MentorDegreeHistory']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  favouriteModules?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorModuleField']>>>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasUnansweredConversation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInterestField']>>>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<Array<Maybe<ResolversTypes['LanguageField']>>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifecycleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentorFields?: Resolver<Maybe<ResolversTypes['MentorFields']>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pastQualification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['MentorPreferencesField']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MentorFieldProfilePhotoArgs>>;
  prospectWelcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedUnansweredConversations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  schoolHistory?: Resolver<Maybe<ResolversTypes['MentorSchoolHistoryField']>, ParentType, ContextType>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortBio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showIn?: Resolver<Maybe<Array<Maybe<ResolversTypes['Display']>>>, ParentType, ContextType>;
  societies?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorSocietyField']>>>, ParentType, ContextType>;
  stageOneComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stageTwoComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unansweredCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  unreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorFieldOrderFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorFieldOrderField'] = ResolversParentTypes['MentorFieldOrderField']> = {
  field?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorFields'] = ResolversParentTypes['MentorFields']> = {
  primaryFlag?: Resolver<Maybe<ResolversTypes['FlagField']>, ParentType, ContextType>;
  secondaryFlag?: Resolver<Maybe<ResolversTypes['FlagField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorFilterFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorFilterField'] = ResolversParentTypes['MentorFilterField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorFilterOptionField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorFilterOptionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorFilterOptionField'] = ResolversParentTypes['MentorFilterOptionField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorInboxField'] = ResolversParentTypes['MentorInboxField']> = {
  chatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType>;
  chatGroupsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorInterestFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorInterestField'] = ResolversParentTypes['MentorInterestField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorInterventionQueryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorInterventionQueryField'] = ResolversParentTypes['MentorInterventionQueryField']> = {
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorIntroMessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorIntroMessageField'] = ResolversParentTypes['MentorIntroMessageField']> = {
  introMessage?: Resolver<Maybe<ResolversTypes['MessageField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorInviteCountFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorInviteCountField'] = ResolversParentTypes['MentorInviteCountField']> = {
  mentorInviteCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorInviteFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorInviteField'] = ResolversParentTypes['MentorInviteField']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notFound?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorListField'] = ResolversParentTypes['MentorListField']> = {
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  levels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>>, ParentType, ContextType>;
  validCombination?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorListFilterChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorListFilterChoice'] = ResolversParentTypes['MentorListFilterChoice']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorModuleFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorModuleField'] = ResolversParentTypes['MentorModuleField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorPreferencesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorPreferencesField'] = ResolversParentTypes['MentorPreferencesField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newMessageNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorSchoolHistoryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorSchoolHistoryField'] = ResolversParentTypes['MentorSchoolHistoryField']> = {
  highSchool?: Resolver<Maybe<ResolversTypes['HighSchoolField']>, ParentType, ContextType>;
  highSchoolType?: Resolver<Maybe<ResolversTypes['HighSchoolTypeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorSnippetField'] = ResolversParentTypes['MentorSnippetField']> = {
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorSocietyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorSocietyField'] = ResolversParentTypes['MentorSocietyField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MentorcardSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentorcardSnippetField'] = ResolversParentTypes['MentorcardSnippetField']> = {
  countrySnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountrySnippetField']>>>, ParentType, ContextType>;
  degreeSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  mentorSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorSnippetField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageField'] = ResolversParentTypes['MessageField']> = {
  attachment?: Resolver<Maybe<ResolversTypes['AttachmentField']>, ParentType, ContextType>;
  chatGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  input?: Resolver<Maybe<ResolversTypes['InputField']>, ParentType, ContextType>;
  instantAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSenderBlocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  likes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  ownMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  read?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  richContent?: Resolver<Maybe<ResolversTypes['RichContentOutputField']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageMetadata'] = ResolversParentTypes['MessageMetadata']> = {
  ambassadorProfile?: Resolver<Maybe<ResolversTypes['AmbassadorProfileInformation']>, ParentType, ContextType>;
  staffProfile?: Resolver<Maybe<ResolversTypes['StaffProfileInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagePublicBotMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagePublicBotMutation'] = ResolversParentTypes['MessagePublicBotMutation']> = {
  botMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetricDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricDataPoint'] = ResolversParentTypes['MetricDataPoint']> = {
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  metricName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metricType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptRequestedPublicGroup?: Resolver<ResolversTypes['RequestedPublicGroup'], ParentType, ContextType, RequireFields<MutationAcceptRequestedPublicGroupArgs, 'acceptRequestedPublicGroupInput'>>;
  activateApplicants?: Resolver<Maybe<ResolversTypes['ActivateApplicantsMutation']>, ParentType, ContextType, Partial<MutationActivateApplicantsArgs>>;
  activateMentors?: Resolver<Maybe<ResolversTypes['ActivateMentorsMutation']>, ParentType, ContextType, Partial<MutationActivateMentorsArgs>>;
  addAttendees?: Resolver<Maybe<ResolversTypes['AttendeeAnalytics']>, ParentType, ContextType, RequireFields<MutationAddAttendeesArgs, 'attendeeData'>>;
  addBotToChatGroup?: Resolver<Maybe<ResolversTypes['AddBotToChatGroupMutation']>, ParentType, ContextType, Partial<MutationAddBotToChatGroupArgs>>;
  addChatRoomAttendees?: Resolver<Maybe<ResolversTypes['ChatRoomAttendeeAnalytics']>, ParentType, ContextType, RequireFields<MutationAddChatRoomAttendeesArgs, 'chatRoomAttendeeData'>>;
  addCustomAttribute?: Resolver<Maybe<ResolversTypes['AddCustomAttributeMutation']>, ParentType, ContextType, Partial<MutationAddCustomAttributeArgs>>;
  addCustomAttributeOption?: Resolver<Maybe<ResolversTypes['AddAttributeOptionMutation']>, ParentType, ContextType, Partial<MutationAddCustomAttributeOptionArgs>>;
  addDegreeLevels?: Resolver<Maybe<ResolversTypes['AddDegreeLevelsMutation']>, ParentType, ContextType, Partial<MutationAddDegreeLevelsArgs>>;
  addDegrees?: Resolver<Maybe<ResolversTypes['AddDegreesMutation']>, ParentType, ContextType, Partial<MutationAddDegreesArgs>>;
  addDevice?: Resolver<Maybe<ResolversTypes['DeviceMutation']>, ParentType, ContextType, Partial<MutationAddDeviceArgs>>;
  addHobsonsConnectIntegration?: Resolver<Maybe<ResolversTypes['AddHobsonsConnectIntegration']>, ParentType, ContextType, Partial<MutationAddHobsonsConnectIntegrationArgs>>;
  addLocalesToApp?: Resolver<Maybe<ResolversTypes['AddLocalesToApp']>, ParentType, ContextType, RequireFields<MutationAddLocalesToAppArgs, 'appLocales'>>;
  addMatchingCriteria?: Resolver<ResolversTypes['UpdatedResults'], ParentType, ContextType>;
  addReactionToMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationAddReactionToMessageArgs, 'reactionDto'>>;
  addResearchTime?: Resolver<Maybe<ResolversTypes['AddResearchTimeMutation']>, ParentType, ContextType, RequireFields<MutationAddResearchTimeArgs, 'researchTimeData'>>;
  addSessionAttendees?: Resolver<Maybe<ResolversTypes['SessionAttendeeAnalytics']>, ParentType, ContextType, RequireFields<MutationAddSessionAttendeesArgs, 'sessionAttendeeData'>>;
  addToFeatureExperiment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddToFeatureExperimentArgs, 'experimentName' | 'metadata'>>;
  addUserToCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationAddUserToCommunityConversationArgs, 'conversationId' | 'memberId'>>;
  addVote?: Resolver<ResolversTypes['Poll'], ParentType, ContextType, RequireFields<MutationAddVoteArgs, 'chatMessageId' | 'option'>>;
  addYearOfStudy?: Resolver<Maybe<ResolversTypes['AddYearOfStudyMutation']>, ParentType, ContextType, RequireFields<MutationAddYearOfStudyArgs, 'degreeLevelName' | 'universitySlug' | 'yearOfStudyNames'>>;
  adminDeleteApplicant?: Resolver<Maybe<ResolversTypes['AdminDeleteApplicantMutation']>, ParentType, ContextType, Partial<MutationAdminDeleteApplicantArgs>>;
  adminDeleteBuddy?: Resolver<Maybe<ResolversTypes['DeleteUserMutation']>, ParentType, ContextType, RequireFields<MutationAdminDeleteBuddyArgs, 'userId'>>;
  adminUpdateMentor?: Resolver<Maybe<ResolversTypes['AdminUpdateMentorMutation']>, ParentType, ContextType, Partial<MutationAdminUpdateMentorArgs>>;
  applicantBroadcastMessage?: Resolver<Maybe<ResolversTypes['ApplicantBroadcastMessageMutation']>, ParentType, ContextType, Partial<MutationApplicantBroadcastMessageArgs>>;
  bulkOptOutMarketplaceUniversityMarketing?: Resolver<Maybe<ResolversTypes['BulkOptOutMarketplaceUniversityMarketingMutation']>, ParentType, ContextType, RequireFields<MutationBulkOptOutMarketplaceUniversityMarketingArgs, 'marketplaceSlug' | 'universitySlugs'>>;
  checkEmail?: Resolver<Maybe<ResolversTypes['CheckEmailMutation']>, ParentType, ContextType, Partial<MutationCheckEmailArgs>>;
  cloneCommunity?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<MutationCloneCommunityArgs, 'sourceCommmunityId'>>;
  cloneLiveEventAndChannels?: Resolver<Maybe<ResolversTypes['CloneLiveEventAndChannelsMutation']>, ParentType, ContextType, Partial<MutationCloneLiveEventAndChannelsArgs>>;
  createAlert?: Resolver<Maybe<ResolversTypes['CreateAlertMutation']>, ParentType, ContextType, Partial<MutationCreateAlertArgs>>;
  createApplicant?: Resolver<Maybe<ResolversTypes['CreateApplicantMutation']>, ParentType, ContextType, Partial<MutationCreateApplicantArgs>>;
  createApplicantV2?: Resolver<Maybe<ResolversTypes['CreateApplicantMutationV2']>, ParentType, ContextType, Partial<MutationCreateApplicantV2Args>>;
  createApplicationInsight?: Resolver<ResolversTypes['ApplicationInsightModel'], ParentType, ContextType, RequireFields<MutationCreateApplicationInsightArgs, 'createApplicantInsightInput'>>;
  createAssistantConversation?: Resolver<ResolversTypes['AssistantConversationHistoryWithToken'], ParentType, ContextType, RequireFields<MutationCreateAssistantConversationArgs, 'createAssistantConversationInput'>>;
  createAssistantMessageFeedback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateAssistantMessageFeedbackArgs, 'assistantMessageFeedbackInput'>>;
  createBlogTopic?: Resolver<Maybe<ResolversTypes['CreateBlogTopicMutation']>, ParentType, ContextType, Partial<MutationCreateBlogTopicArgs>>;
  createBuddy?: Resolver<Maybe<ResolversTypes['CreateBuddyMutation']>, ParentType, ContextType, Partial<MutationCreateBuddyArgs>>;
  createCanonicalQuestion?: Resolver<Maybe<ResolversTypes['CreateCanonicalQuestion']>, ParentType, ContextType, RequireFields<MutationCreateCanonicalQuestionArgs, 'question' | 'subTopic'>>;
  createChatReport?: Resolver<ResolversTypes['ChatReport'], ParentType, ContextType, RequireFields<MutationCreateChatReportArgs, 'chatReportUserInputDTO'>>;
  createChatRoom?: Resolver<ResolversTypes['ChatRoom'], ParentType, ContextType, RequireFields<MutationCreateChatRoomArgs, 'description' | 'name' | 'virtualEventId'>>;
  createComment?: Resolver<Maybe<ResolversTypes['CommentMutation']>, ParentType, ContextType, Partial<MutationCreateCommentArgs>>;
  createCommunity?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<MutationCreateCommunityArgs, 'CreateCommunityDTO'>>;
  createCommunityApplicant?: Resolver<Maybe<ResolversTypes['CreateCommunityApplicantMutation']>, ParentType, ContextType, Partial<MutationCreateCommunityApplicantArgs>>;
  createCommunityApplicantV2?: Resolver<Maybe<ResolversTypes['CreateCommunityApplicantMutationV2']>, ParentType, ContextType, Partial<MutationCreateCommunityApplicantV2Args>>;
  createCommunityChatGroup?: Resolver<ResolversTypes['CommunityChatGroup'], ParentType, ContextType, RequireFields<MutationCreateCommunityChatGroupArgs, 'createCommunityChatGroupInput'>>;
  createCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationCreateCommunityConversationArgs, 'CreateCommunityConversationDTO'>>;
  createCommunityFromTemplate?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<MutationCreateCommunityFromTemplateArgs, 'CreateCommunityDTO' | 'communityUseCase'>>;
  createCrmServiceUniversityConfig?: Resolver<Maybe<ResolversTypes['CreateCrmServiceUniversityConfigMutation']>, ParentType, ContextType, Partial<MutationCreateCrmServiceUniversityConfigArgs>>;
  createDirectConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationCreateDirectConversationArgs, 'DirectConversationDTO'>>;
  createEventPage?: Resolver<ResolversTypes['EventPage'], ParentType, ContextType, RequireFields<MutationCreateEventPageArgs, 'eventPageData' | 'virtualEventId'>>;
  createExternalContent?: Resolver<ResolversTypes['ExternalContent'], ParentType, ContextType, RequireFields<MutationCreateExternalContentArgs, 'externalContentData' | 'virtualEventId'>>;
  createExternalEvent?: Resolver<Maybe<ResolversTypes['CreateExternalEventMutation']>, ParentType, ContextType, RequireFields<MutationCreateExternalEventArgs, 'description' | 'name'>>;
  createFaqAnswer?: Resolver<Maybe<ResolversTypes['CreateFaqAnswer']>, ParentType, ContextType, RequireFields<MutationCreateFaqAnswerArgs, 'answer' | 'canonicalQuestion'>>;
  createFresher?: Resolver<Maybe<ResolversTypes['CreateFresherMutation']>, ParentType, ContextType, Partial<MutationCreateFresherArgs>>;
  createInviteLink?: Resolver<ResolversTypes['InviteLinkDto'], ParentType, ContextType, RequireFields<MutationCreateInviteLinkArgs, 'inviteLinkInput'>>;
  createLiveEvent?: Resolver<Maybe<ResolversTypes['CreateLiveEventMutation']>, ParentType, ContextType, Partial<MutationCreateLiveEventArgs>>;
  createLiveEventDetails?: Resolver<Maybe<ResolversTypes['CreateLiveEventDetailsMutation']>, ParentType, ContextType, Partial<MutationCreateLiveEventDetailsArgs>>;
  createLiveEventFeed?: Resolver<Maybe<ResolversTypes['CreateLiveEventFeedMutation']>, ParentType, ContextType, Partial<MutationCreateLiveEventFeedArgs>>;
  createLiveEventFeedSessions?: Resolver<Maybe<ResolversTypes['CreateLiveEventFeedSessionsMutation']>, ParentType, ContextType, Partial<MutationCreateLiveEventFeedSessionsArgs>>;
  createLiveSession?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<MutationCreateLiveSessionArgs, 'sessionData' | 'virtualEventId'>>;
  createMarketplace?: Resolver<Maybe<ResolversTypes['CreateMarketplaceMutation']>, ParentType, ContextType, RequireFields<MutationCreateMarketplaceArgs, 'name' | 'slug' | 'widgetUrl'>>;
  createMarketplaceApplicant?: Resolver<Maybe<ResolversTypes['CreateMarketplaceApplicantMutation']>, ParentType, ContextType, RequireFields<MutationCreateMarketplaceApplicantArgs, 'country' | 'email' | 'firstName' | 'lastName' | 'marketplace' | 'password'>>;
  createMentor?: Resolver<Maybe<ResolversTypes['CreateMentorMutation']>, ParentType, ContextType, Partial<MutationCreateMentorArgs>>;
  createOpenDay?: Resolver<Maybe<ResolversTypes['CreateOpenDayMutation']>, ParentType, ContextType, RequireFields<MutationCreateOpenDayArgs, 'description' | 'externalEventIds' | 'liveEventIds' | 'title'>>;
  createOrUpdateUniversityAssistantPromptContext?: Resolver<ResolversTypes['UniversityAssistantConfigurationPromptContextOutput'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateUniversityAssistantPromptContextArgs, 'universityAssistantConfigurationPromptContextInput'>>;
  createOrUpdateUniversityAssistantScrapeIgnoreUrls?: Resolver<ResolversTypes['UniversityAssistantConfigurationScrapeIgnoreUrlsOutput'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateUniversityAssistantScrapeIgnoreUrlsArgs, 'universityAssistantConfigurationScrapeIgnoreUrlsInput'>>;
  createOrganisation?: Resolver<Maybe<ResolversTypes['CreateOrganisationMutation']>, ParentType, ContextType, RequireFields<MutationCreateOrganisationArgs, 'name' | 'organisationType'>>;
  createOrganisationBuddyLink?: Resolver<Maybe<ResolversTypes['CreateOrganisationBuddyLinkMutation']>, ParentType, ContextType, RequireFields<MutationCreateOrganisationBuddyLinkArgs, 'organisation' | 'status' | 'user'>>;
  createPost?: Resolver<Maybe<ResolversTypes['CreatePostMutation']>, ParentType, ContextType, Partial<MutationCreatePostArgs>>;
  createStaffContact?: Resolver<ResolversTypes['StaffContactOutput'], ParentType, ContextType, RequireFields<MutationCreateStaffContactArgs, 'staffContactInput'>>;
  createSubTopic?: Resolver<Maybe<ResolversTypes['CreateSubTopicMutation']>, ParentType, ContextType, RequireFields<MutationCreateSubTopicArgs, 'externalId' | 'name' | 'topic'>>;
  createTag?: Resolver<Maybe<ResolversTypes['CreateTagMutation']>, ParentType, ContextType, RequireFields<MutationCreateTagArgs, 'name'>>;
  createTodo?: Resolver<ResolversTypes['TodosEntity'], ParentType, ContextType, RequireFields<MutationCreateTodoArgs, 'CreateTodoInputDto'>>;
  createTopic?: Resolver<Maybe<ResolversTypes['CreateTopicMutation']>, ParentType, ContextType, RequireFields<MutationCreateTopicArgs, 'externalId' | 'name'>>;
  createUniversity?: Resolver<Maybe<ResolversTypes['CreateUniversityMutation']>, ParentType, ContextType, Partial<MutationCreateUniversityArgs>>;
  createUniversityAssistantEventLink?: Resolver<ResolversTypes['UniversityAssistantConfigurationEventOutput'], ParentType, ContextType, RequireFields<MutationCreateUniversityAssistantEventLinkArgs, 'universityAssistantConfigurationEventInput'>>;
  createUniversityBlockReport?: Resolver<Maybe<ResolversTypes['CreateUniversityBlockReportMutation']>, ParentType, ContextType, Partial<MutationCreateUniversityBlockReportArgs>>;
  createUniversityScrape?: Resolver<ResolversTypes['UniversityScrapeOutput'], ParentType, ContextType, RequireFields<MutationCreateUniversityScrapeArgs, 'universityScrapeInput'>>;
  createUniversityScrapeBatch?: Resolver<ResolversTypes['UniversityScrapeOutput'], ParentType, ContextType, RequireFields<MutationCreateUniversityScrapeBatchArgs, 'universityScrapeManualInput'>>;
  createUniversityScrapeOne?: Resolver<ResolversTypes['UniversityScrapeOutput'], ParentType, ContextType, RequireFields<MutationCreateUniversityScrapeOneArgs, 'universityScrapeInput'>>;
  createUniversityUser?: Resolver<Maybe<ResolversTypes['CreateUniversityUserMutation']>, ParentType, ContextType, Partial<MutationCreateUniversityUserArgs>>;
  createUserMutation?: Resolver<Maybe<ResolversTypes['CreateUserMutation']>, ParentType, ContextType, RequireFields<MutationCreateUserMutationArgs, 'email' | 'firstName'>>;
  createUserReport?: Resolver<ResolversTypes['UserReport'], ParentType, ContextType, RequireFields<MutationCreateUserReportArgs, 'userReportUserInputDTO'>>;
  createVideoUploadLink?: Resolver<ResolversTypes['VideoUploadLink'], ParentType, ContextType, RequireFields<MutationCreateVideoUploadLinkArgs, 'videoUploadLinkInput'>>;
  createVirtualEvent?: Resolver<ResolversTypes['VirtualEvent'], ParentType, ContextType, RequireFields<MutationCreateVirtualEventArgs, 'createVirtualEventInput' | 'universityId'>>;
  createVirtualEventProspectReport?: Resolver<Maybe<ResolversTypes['ReportAnalytics']>, ParentType, ContextType, RequireFields<MutationCreateVirtualEventProspectReportArgs, 'virtualEventId'>>;
  csvUploadAmbassadorFields?: Resolver<Maybe<ResolversTypes['CSVUploadAmbassadorFieldsMutation']>, ParentType, ContextType, RequireFields<MutationCsvUploadAmbassadorFieldsArgs, 'file' | 'uniSlug'>>;
  csvUploadApplicants?: Resolver<Maybe<ResolversTypes['CSVUploadApplicantsMutation']>, ParentType, ContextType, RequireFields<MutationCsvUploadApplicantsArgs, 'file' | 'password' | 'uniSlug'>>;
  deactivateApplicants?: Resolver<Maybe<ResolversTypes['DeactivateApplicantsMutation']>, ParentType, ContextType, Partial<MutationDeactivateApplicantsArgs>>;
  deactivateMentors?: Resolver<Maybe<ResolversTypes['DeactivateMentorsMutation']>, ParentType, ContextType, Partial<MutationDeactivateMentorsArgs>>;
  deleteAdminRecommendation?: Resolver<ResolversTypes['AdminRecommendation'], ParentType, ContextType, RequireFields<MutationDeleteAdminRecommendationArgs, 'recommendationId'>>;
  deleteApplicant?: Resolver<Maybe<ResolversTypes['DeleteApplicantMutation']>, ParentType, ContextType>;
  deleteBlogPost?: Resolver<Maybe<ResolversTypes['DeletePostMutation']>, ParentType, ContextType, Partial<MutationDeleteBlogPostArgs>>;
  deleteCanonicalQuestion?: Resolver<Maybe<ResolversTypes['DeleteCanonicalQuestion']>, ParentType, ContextType, RequireFields<MutationDeleteCanonicalQuestionArgs, 'question'>>;
  deleteChatRoom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteChatRoomArgs, 'chatRoomId'>>;
  deleteCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationDeleteCommunityConversationArgs, 'DeleteCommunityConversationDTO'>>;
  deleteConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationDeleteConversationMessageArgs, 'deleteMessageDto'>>;
  deleteCustomAttributeOptions?: Resolver<Maybe<ResolversTypes['DeleteAttributeOptionsMutation']>, ParentType, ContextType, Partial<MutationDeleteCustomAttributeOptionsArgs>>;
  deleteCustomAttributes?: Resolver<Maybe<ResolversTypes['DeleteCustomAttributesMutation']>, ParentType, ContextType, Partial<MutationDeleteCustomAttributesArgs>>;
  deleteDegreeLevel?: Resolver<Maybe<ResolversTypes['DeleteDegreeLevelMutation']>, ParentType, ContextType, RequireFields<MutationDeleteDegreeLevelArgs, 'degreeLevelId' | 'universitySlug'>>;
  deleteEventPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEventPageArgs, 'eventPageId'>>;
  deleteExternalContent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteExternalContentArgs, 'externalContentId'>>;
  deleteFaqAnswer?: Resolver<Maybe<ResolversTypes['DeleteFaqAnswer']>, ParentType, ContextType, RequireFields<MutationDeleteFaqAnswerArgs, 'answer'>>;
  deleteLiveEvent?: Resolver<Maybe<ResolversTypes['DeleteLiveEventMutation']>, ParentType, ContextType, Partial<MutationDeleteLiveEventArgs>>;
  deleteLiveEventFeed?: Resolver<Maybe<ResolversTypes['DeleteLiveEventFeedMutation']>, ParentType, ContextType, Partial<MutationDeleteLiveEventFeedArgs>>;
  deleteLiveEventMessageMutation?: Resolver<Maybe<ResolversTypes['DeleteLiveEventMessageMutation']>, ParentType, ContextType, Partial<MutationDeleteLiveEventMessageMutationArgs>>;
  deleteLiveSession?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteLiveSessionArgs, 'liveSessionId'>>;
  deleteRecording?: Resolver<ResolversTypes['DeleteRecordingResponse'], ParentType, ContextType, RequireFields<MutationDeleteRecordingArgs, 'sid' | 'universityId'>>;
  deleteResearchTime?: Resolver<Maybe<ResolversTypes['DeleteResearchTimeMutation']>, ParentType, ContextType, RequireFields<MutationDeleteResearchTimeArgs, 'id'>>;
  deleteSubTopic?: Resolver<Maybe<ResolversTypes['DeleteSubTopicMutation']>, ParentType, ContextType, RequireFields<MutationDeleteSubTopicArgs, 'id'>>;
  deleteTopic?: Resolver<Maybe<ResolversTypes['DeleteTopicMutation']>, ParentType, ContextType, RequireFields<MutationDeleteTopicArgs, 'id'>>;
  deleteUniversityKnowledgeBaseSourceById?: Resolver<ResolversTypes['KnowledgeBaseDeleteEntryOutput'], ParentType, ContextType, RequireFields<MutationDeleteUniversityKnowledgeBaseSourceByIdArgs, 'knowledgeBaseDeleteEntryInput'>>;
  deleteUniversityKnowledgeBaseSourceByPatternMatch?: Resolver<ResolversTypes['DeleteKnowledgeBaseEntriesOutput'], ParentType, ContextType, RequireFields<MutationDeleteUniversityKnowledgeBaseSourceByPatternMatchArgs, 'deleteKnowledgeBaseEntriesByPatternMatchInput'>>;
  deleteUniversityKnowledgeBaseSourceByPatternMismatch?: Resolver<ResolversTypes['DeleteKnowledgeBaseEntriesOutput'], ParentType, ContextType, RequireFields<MutationDeleteUniversityKnowledgeBaseSourceByPatternMismatchArgs, 'deleteKnowledgeBaseEntriesByPatternMismatchInput'>>;
  deleteUniversityKnowledgeBaseSourceByUrlList?: Resolver<ResolversTypes['DeleteKnowledgeBaseEntriesOutput'], ParentType, ContextType, RequireFields<MutationDeleteUniversityKnowledgeBaseSourceByUrlListArgs, 'deleteKnowledgeBaseEntriesByUrlListInput'>>;
  deleteUniversityUser?: Resolver<Maybe<ResolversTypes['DeleteUniversityUserMutation']>, ParentType, ContextType, Partial<MutationDeleteUniversityUserArgs>>;
  deleteVirtualEvent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteVirtualEventArgs, 'virtualEventId'>>;
  deleteYearOfStudy?: Resolver<Maybe<ResolversTypes['DeleteYearOfStudyMutation']>, ParentType, ContextType, RequireFields<MutationDeleteYearOfStudyArgs, 'yearOfStudyId'>>;
  editAdminRecommendation?: Resolver<ResolversTypes['AdminRecommendation'], ParentType, ContextType, RequireFields<MutationEditAdminRecommendationArgs, 'adminRecommendationInput' | 'recommendationId'>>;
  editAlert?: Resolver<Maybe<ResolversTypes['EditAlertMutation']>, ParentType, ContextType, Partial<MutationEditAlertArgs>>;
  editBlogPost?: Resolver<Maybe<ResolversTypes['EditPostMutation']>, ParentType, ContextType, Partial<MutationEditBlogPostArgs>>;
  editBlogTopic?: Resolver<Maybe<ResolversTypes['EditBlogTopicMutation']>, ParentType, ContextType, Partial<MutationEditBlogTopicArgs>>;
  editCommunity?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<MutationEditCommunityArgs, 'EditCommunityDTO'>>;
  editCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationEditCommunityConversationArgs, 'EditCommunityConversationDTO'>>;
  editCookieConsentPreferences?: Resolver<ResolversTypes['CookieConsentOutputDTO'], ParentType, ContextType, RequireFields<MutationEditCookieConsentPreferencesArgs, 'CookieConsentInputDTO'>>;
  editCustomAttribute?: Resolver<Maybe<ResolversTypes['EditCustomAttributeMutation']>, ParentType, ContextType, Partial<MutationEditCustomAttributeArgs>>;
  editCustomAttributeOption?: Resolver<Maybe<ResolversTypes['EditAttributeOptionMutation']>, ParentType, ContextType, Partial<MutationEditCustomAttributeOptionArgs>>;
  editCustomAttributes?: Resolver<Maybe<ResolversTypes['EditCustomAttributesMutation']>, ParentType, ContextType, Partial<MutationEditCustomAttributesArgs>>;
  editCustomWelcomeMessage?: Resolver<Maybe<ResolversTypes['EditCustomWelcomeMessageMutation']>, ParentType, ContextType, Partial<MutationEditCustomWelcomeMessageArgs>>;
  editDegreeLevel?: Resolver<Maybe<ResolversTypes['EditDegreeLevelMutation']>, ParentType, ContextType, Partial<MutationEditDegreeLevelArgs>>;
  editDegreeName?: Resolver<Maybe<ResolversTypes['EditDegreeNameMutation']>, ParentType, ContextType, Partial<MutationEditDegreeNameArgs>>;
  editDegrees?: Resolver<Maybe<ResolversTypes['EditDegreesMutation']>, ParentType, ContextType, Partial<MutationEditDegreesArgs>>;
  editExternalEvent?: Resolver<Maybe<ResolversTypes['EditExternalEventMutation']>, ParentType, ContextType, RequireFields<MutationEditExternalEventArgs, 'description' | 'name'>>;
  editLiveEvent?: Resolver<Maybe<ResolversTypes['EditLiveEventMutation']>, ParentType, ContextType, Partial<MutationEditLiveEventArgs>>;
  editLiveEventDetails?: Resolver<Maybe<ResolversTypes['EditLiveEventDetailsMutation']>, ParentType, ContextType, Partial<MutationEditLiveEventDetailsArgs>>;
  editLiveEventFeed?: Resolver<Maybe<ResolversTypes['EditLiveEventFeedMutation']>, ParentType, ContextType, Partial<MutationEditLiveEventFeedArgs>>;
  editLiveEventsLandingPage?: Resolver<Maybe<ResolversTypes['EditLiveEventsLandingPageMutation']>, ParentType, ContextType, RequireFields<MutationEditLiveEventsLandingPageArgs, 'description' | 'externalEventIds' | 'liveEventIds' | 'title'>>;
  editOpenDay?: Resolver<Maybe<ResolversTypes['EditOpenDayMutation']>, ParentType, ContextType, RequireFields<MutationEditOpenDayArgs, 'description' | 'externalEventIds' | 'liveEventIds' | 'openDayId' | 'title'>>;
  editOrganisation?: Resolver<Maybe<ResolversTypes['EditOrganisationMutation']>, ParentType, ContextType, RequireFields<MutationEditOrganisationArgs, 'organisationId'>>;
  editUniversity?: Resolver<Maybe<ResolversTypes['EditUniversityMutation']>, ParentType, ContextType, Partial<MutationEditUniversityArgs>>;
  editYearOfStudy?: Resolver<Maybe<ResolversTypes['EditYearOfStudyMutation']>, ParentType, ContextType, RequireFields<MutationEditYearOfStudyArgs, 'degreeLevelName' | 'name' | 'universitySlug' | 'yearOfStudyId'>>;
  emailInvitesDataForCommunity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationEmailInvitesDataForCommunityArgs, 'communityId' | 'filters' | 'retrieveArchived'>>;
  enableCustomWelcomeMessage?: Resolver<Maybe<ResolversTypes['EnableCustomWelcomeMessageMutation']>, ParentType, ContextType, Partial<MutationEnableCustomWelcomeMessageArgs>>;
  enableCustomWelcomeMessageStaff?: Resolver<Maybe<ResolversTypes['EnableCustomWelcomeMessageStaffMutation']>, ParentType, ContextType, Partial<MutationEnableCustomWelcomeMessageStaffArgs>>;
  enableFeatures?: Resolver<Maybe<ResolversTypes['EnableFeaturesMutation']>, ParentType, ContextType, Partial<MutationEnableFeaturesArgs>>;
  exportAnalyticsCsv?: Resolver<Maybe<ResolversTypes['ExportAnalyticsCsvMutation']>, ParentType, ContextType, Partial<MutationExportAnalyticsCsvArgs>>;
  forwardApplicantToUniversity?: Resolver<Maybe<ResolversTypes['ForwardApplicantToUniversity']>, ParentType, ContextType, Partial<MutationForwardApplicantToUniversityArgs>>;
  generateAnalyticsDashboardToken?: Resolver<Maybe<ResolversTypes['GenerateAnalyticsDashboardTokenMutation']>, ParentType, ContextType, Partial<MutationGenerateAnalyticsDashboardTokenArgs>>;
  generateDownloadUrl?: Resolver<Maybe<ResolversTypes['GetDownloadableURLMutation']>, ParentType, ContextType, Partial<MutationGenerateDownloadUrlArgs>>;
  generateLiveEventReport?: Resolver<Maybe<ResolversTypes['GenerateLiveEventReport']>, ParentType, ContextType, Partial<MutationGenerateLiveEventReportArgs>>;
  generateRecommendations?: Resolver<Array<ResolversTypes['Recommendation']>, ParentType, ContextType, RequireFields<MutationGenerateRecommendationsArgs, 'generateRecommendationsInput'>>;
  getMarketplaceApplicant?: Resolver<Maybe<ResolversTypes['GetMarketplaceApplicantMutation']>, ParentType, ContextType, Partial<MutationGetMarketplaceApplicantArgs>>;
  getOrCreateApiKey?: Resolver<Maybe<ResolversTypes['GetOrCreateApiKeyMutation']>, ParentType, ContextType, RequireFields<MutationGetOrCreateApiKeyArgs, 'integration' | 'universityId'>>;
  getOrCreateWidgetConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationGetOrCreateWidgetConversationArgs, 'widgetConversationDto'>>;
  getSignedS3PostFields?: Resolver<Maybe<ResolversTypes['GetSignedS3PostFieldsMutation']>, ParentType, ContextType, Partial<MutationGetSignedS3PostFieldsArgs>>;
  getSignedS3Url?: Resolver<Maybe<ResolversTypes['GetSignedS3UrlMutation']>, ParentType, ContextType, Partial<MutationGetSignedS3UrlArgs>>;
  hideMentorInMarketplace?: Resolver<Maybe<ResolversTypes['HideMentorInMarketplaceMutation']>, ParentType, ContextType, RequireFields<MutationHideMentorInMarketplaceArgs, 'mentorId'>>;
  initialiseRecording?: Resolver<ResolversTypes['InitialiseRecordingResponse'], ParentType, ContextType, RequireFields<MutationInitialiseRecordingArgs, 'data'>>;
  initiateUserDeletion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inviteApplicants?: Resolver<Maybe<ResolversTypes['InviteApplicantsMutation']>, ParentType, ContextType, Partial<MutationInviteApplicantsArgs>>;
  inviteBuddies?: Resolver<Maybe<ResolversTypes['InviteBuddiesMutation']>, ParentType, ContextType, Partial<MutationInviteBuddiesArgs>>;
  inviteEmailsToCommunity?: Resolver<ResolversTypes['CommunityInviteResponse'], ParentType, ContextType, RequireFields<MutationInviteEmailsToCommunityArgs, 'communityId' | 'emails'>>;
  inviteMentors?: Resolver<Maybe<ResolversTypes['InviteMentorsMutation']>, ParentType, ContextType, Partial<MutationInviteMentorsArgs>>;
  joinChatGroup?: Resolver<Maybe<ResolversTypes['JoinChatGroupMutation']>, ParentType, ContextType, Partial<MutationJoinChatGroupArgs>>;
  joinCommunity?: Resolver<ResolversTypes['CommunityJoinResponse'], ParentType, ContextType, RequireFields<MutationJoinCommunityArgs, 'communityId'>>;
  joinCommunityByInviteLink?: Resolver<ResolversTypes['CommunityJoinResponse'], ParentType, ContextType, RequireFields<MutationJoinCommunityByInviteLinkArgs, 'communityId'>>;
  joinCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationJoinCommunityConversationArgs, 'conversationId'>>;
  joinCommunityForAdmins?: Resolver<ResolversTypes['CommunityJoinResponse'], ParentType, ContextType, RequireFields<MutationJoinCommunityForAdminsArgs, 'communityId'>>;
  labelSentence?: Resolver<Maybe<ResolversTypes['LabelSentenceMutation']>, ParentType, ContextType, RequireFields<MutationLabelSentenceArgs, 'chatGroupId' | 'classifiedSentenceId' | 'messageId' | 'subTopicExternalId' | 'text' | 'topicExternalId'>>;
  leaveChatGroup?: Resolver<Maybe<ResolversTypes['LeaveChatGroupMutation']>, ParentType, ContextType, Partial<MutationLeaveChatGroupArgs>>;
  leaveCommunityChatGroup?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationLeaveCommunityChatGroupArgs, 'conversationId'>>;
  likeConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationLikeConversationMessageArgs, 'likeMessageDto'>>;
  likeMessage?: Resolver<Maybe<ResolversTypes['LikeMessageMutation']>, ParentType, ContextType, Partial<MutationLikeMessageArgs>>;
  linkOrganisations?: Resolver<Maybe<ResolversTypes['LinkOrganisationsMutation']>, ParentType, ContextType, RequireFields<MutationLinkOrganisationsArgs, 'childOrganisationId' | 'parentOrganisationId'>>;
  liveEventFeedbackForm?: Resolver<Maybe<ResolversTypes['LiveEventFeedbackFormMutation']>, ParentType, ContextType, Partial<MutationLiveEventFeedbackFormArgs>>;
  logout?: Resolver<Maybe<ResolversTypes['LogoutMutation']>, ParentType, ContextType>;
  manageOrganisationAccess?: Resolver<Maybe<ResolversTypes['ManageOrganisationAccessMutation']>, ParentType, ContextType, RequireFields<MutationManageOrganisationAccessArgs, 'access' | 'organisationId'>>;
  manuallyClassify?: Resolver<Maybe<ResolversTypes['ManuallyClassifyMutation']>, ParentType, ContextType, RequireFields<MutationManuallyClassifyArgs, 'classificationId'>>;
  markAssistantConversationAsViewed?: Resolver<ResolversTypes['AssistantConversationHistory'], ParentType, ContextType, RequireFields<MutationMarkAssistantConversationAsViewedArgs, 'markAssistantConversationAsViewedInput'>>;
  mentorBroadcastMessage?: Resolver<Maybe<ResolversTypes['MentorBroadcastMessageMutation']>, ParentType, ContextType, Partial<MutationMentorBroadcastMessageArgs>>;
  messagePublicBot?: Resolver<Maybe<ResolversTypes['MessagePublicBotMutation']>, ParentType, ContextType, Partial<MutationMessagePublicBotArgs>>;
  moderateChatReport?: Resolver<ResolversTypes['ChatReport'], ParentType, ContextType, RequireFields<MutationModerateChatReportArgs, 'chatReportModeratorInputDTO'>>;
  moderateUserReport?: Resolver<ResolversTypes['UserReport'], ParentType, ContextType, RequireFields<MutationModerateUserReportArgs, 'userReportModeratorInputDTO'>>;
  pinMessage?: Resolver<Maybe<ResolversTypes['PinMessageMutation']>, ParentType, ContextType, Partial<MutationPinMessageArgs>>;
  pinMessageInConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationPinMessageInConversationArgs, 'pinMessageDTO'>>;
  readChat?: Resolver<Maybe<ResolversTypes['ReadChatMutation']>, ParentType, ContextType, Partial<MutationReadChatArgs>>;
  recordConsent?: Resolver<ResolversTypes['RecordingConsent'], ParentType, ContextType, RequireFields<MutationRecordConsentArgs, 'channelId' | 'time' | 'universityId'>>;
  recordFailure?: Resolver<ResolversTypes['RecordingFailureResponse'], ParentType, ContextType, RequireFields<MutationRecordFailureArgs, 'data'>>;
  recordLastMessageReadByUser?: Resolver<ResolversTypes['LastRead'], ParentType, ContextType, RequireFields<MutationRecordLastMessageReadByUserArgs, 'markReadMessageDto'>>;
  recordUserActivity?: Resolver<Maybe<ResolversTypes['RecordUserActivityMutation']>, ParentType, ContextType, Partial<MutationRecordUserActivityArgs>>;
  registerToLiveEvent?: Resolver<Maybe<ResolversTypes['RegisterToLiveEvent']>, ParentType, ContextType, RequireFields<MutationRegisterToLiveEventArgs, 'liveEventSlug' | 'universitySlug'>>;
  rejectRequestedPublicGroup?: Resolver<ResolversTypes['RequestedPublicGroup'], ParentType, ContextType, RequireFields<MutationRejectRequestedPublicGroupArgs, 'rejectRequestedPublicGroupInput'>>;
  removeApplicationInsight?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveApplicationInsightArgs, 'removeApplicantInsightInput'>>;
  removeBuddyInvites?: Resolver<Maybe<ResolversTypes['RemoveBuddyInvitesMutation']>, ParentType, ContextType, Partial<MutationRemoveBuddyInvitesArgs>>;
  removeDevice?: Resolver<Maybe<ResolversTypes['RemoveDeviceMutation']>, ParentType, ContextType, Partial<MutationRemoveDeviceArgs>>;
  removeMembersFromCommunity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveMembersFromCommunityArgs, 'removeMembersDTO'>>;
  removeMentorInvites?: Resolver<Maybe<ResolversTypes['RemoveMentorInvitesMutation']>, ParentType, ContextType, Partial<MutationRemoveMentorInvitesArgs>>;
  removeReactionFromMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationRemoveReactionFromMessageArgs, 'reactionDto'>>;
  removeUserFromCommunityChatGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveUserFromCommunityChatGroupArgs, 'conversationId' | 'userId'>>;
  removeVote?: Resolver<ResolversTypes['Poll'], ParentType, ContextType, RequireFields<MutationRemoveVoteArgs, 'chatMessageId' | 'option'>>;
  requestAnalyticsExport?: Resolver<Maybe<ResolversTypes['RequestAnalyticsExportMutation']>, ParentType, ContextType, Partial<MutationRequestAnalyticsExportArgs>>;
  requestPasswordReset?: Resolver<Maybe<ResolversTypes['RequestPasswordResetMutation']>, ParentType, ContextType, Partial<MutationRequestPasswordResetArgs>>;
  requestPasswordSet?: Resolver<Maybe<ResolversTypes['RequestPasswordSetMutation']>, ParentType, ContextType, Partial<MutationRequestPasswordSetArgs>>;
  requestPublicGroup?: Resolver<ResolversTypes['RequestedPublicGroup'], ParentType, ContextType, RequireFields<MutationRequestPublicGroupArgs, 'requestPublicGroupInput'>>;
  requestResetPassword?: Resolver<Maybe<ResolversTypes['ResetPasswordMobileMutation']>, ParentType, ContextType, Partial<MutationRequestResetPasswordArgs>>;
  requestResetPasswordMobile?: Resolver<Maybe<ResolversTypes['PasswordResetMobileMutation']>, ParentType, ContextType, Partial<MutationRequestResetPasswordMobileArgs>>;
  requestResetPasswordMobileV2?: Resolver<Maybe<ResolversTypes['PasswordResetMobileMutationV2']>, ParentType, ContextType, Partial<MutationRequestResetPasswordMobileV2Args>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['ResetPasswordMutation']>, ParentType, ContextType, Partial<MutationResetPasswordArgs>>;
  resetPasswordEmail?: Resolver<Maybe<ResolversTypes['SendResetPasswordEmail']>, ParentType, ContextType, Partial<MutationResetPasswordEmailArgs>>;
  resetPasswordV2?: Resolver<Maybe<ResolversTypes['ResetPasswordMutationV2']>, ParentType, ContextType, Partial<MutationResetPasswordV2Args>>;
  resolveChats?: Resolver<Maybe<ResolversTypes['ResolveUniversityChatsMutation']>, ParentType, ContextType, Partial<MutationResolveChatsArgs>>;
  resolveConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationResolveConversationMessageArgs, 'resolveMessageDto'>>;
  runManageCommand?: Resolver<Maybe<ResolversTypes['RunManageCommandMutation']>, ParentType, ContextType, Partial<MutationRunManageCommandArgs>>;
  saveAdminRecommendation?: Resolver<ResolversTypes['AdminRecommendation'], ParentType, ContextType, RequireFields<MutationSaveAdminRecommendationArgs, 'adminRecommendationInput'>>;
  saveAmbassadorRecommendation?: Resolver<ResolversTypes['AmbassadorRecommendation'], ParentType, ContextType, RequireFields<MutationSaveAmbassadorRecommendationArgs, 'ambassadorRecommendationInput'>>;
  saveAppliedUsers?: Resolver<ResolversTypes['SaveAppliedUsersModel'], ParentType, ContextType, RequireFields<MutationSaveAppliedUsersArgs, 'saveAppliedUsersInput'>>;
  saveAssistantConversationEmailLead?: Resolver<ResolversTypes['AssistantConversationLead'], ParentType, ContextType, RequireFields<MutationSaveAssistantConversationEmailLeadArgs, 'saveAssistantConversationEmailLeadInput'>>;
  saveAssistantConversationFeedback?: Resolver<ResolversTypes['AssistantConversationFeedback'], ParentType, ContextType, RequireFields<MutationSaveAssistantConversationFeedbackArgs, 'saveAssistantConversationFeedbackInput'>>;
  saveCookieConsentPreferences?: Resolver<ResolversTypes['CookieConsentOutputDTO'], ParentType, ContextType, RequireFields<MutationSaveCookieConsentPreferencesArgs, 'CookieConsentInputDTO'>>;
  saveInboxPromptAnswer?: Resolver<Array<ResolversTypes['InboxPromptAnswer']>, ParentType, ContextType, RequireFields<MutationSaveInboxPromptAnswerArgs, 'inboxPromptAnswerInput'>>;
  saveInsightsByCommunity?: Resolver<ResolversTypes['Insights'], ParentType, ContextType, RequireFields<MutationSaveInsightsByCommunityArgs, 'communityId' | 'emails'>>;
  saveNotInterestedStage?: Resolver<ResolversTypes['UserDecisionStageOutput'], ParentType, ContextType, RequireFields<MutationSaveNotInterestedStageArgs, 'notInterestedStageInput'>>;
  saveSatisfactionSurvey?: Resolver<ResolversTypes['SatisfactionSurveyEntity'], ParentType, ContextType, RequireFields<MutationSaveSatisfactionSurveyArgs, 'SatisfactionSurveyDTO'>>;
  saveUniversityInterested?: Resolver<ResolversTypes['UniversityInterestedEntity'], ParentType, ContextType, RequireFields<MutationSaveUniversityInterestedArgs, 'UniversityInterestedDTO'>>;
  saveUniversityQuestionAnswer?: Resolver<Array<ResolversTypes['UniversityQuestionAnswer']>, ParentType, ContextType, RequireFields<MutationSaveUniversityQuestionAnswerArgs, 'saveUniversityQuestionAnswerInput'>>;
  saveUserDecisionStage?: Resolver<ResolversTypes['UserDecisionStageOutput'], ParentType, ContextType, RequireFields<MutationSaveUserDecisionStageArgs, 'decisionStageInput'>>;
  saveVisitedRecommendation?: Resolver<ResolversTypes['Recommendation'], ParentType, ContextType, RequireFields<MutationSaveVisitedRecommendationArgs, 'saveVisitedRecommendationInput'>>;
  sendAssistantMessage?: Resolver<ResolversTypes['AssistantConversationMessage'], ParentType, ContextType, RequireFields<MutationSendAssistantMessageArgs, 'sendAssistantMessageInput'>>;
  sendCommunityVerificationCode?: Resolver<Maybe<ResolversTypes['SendCommunityVerificationCode']>, ParentType, ContextType>;
  sendConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationSendConversationMessageArgs, 'messageDto'>>;
  sendFeatureNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendFeatureNotificationArgs, 'FeatureNotificationRequestDTO'>>;
  sendFeedMessage?: Resolver<Maybe<ResolversTypes['SendFeedMessageMutation']>, ParentType, ContextType, Partial<MutationSendFeedMessageArgs>>;
  sendLiveEventMessage?: Resolver<Maybe<ResolversTypes['SendLiveEventMessageMutation']>, ParentType, ContextType, Partial<MutationSendLiveEventMessageArgs>>;
  sendMessage?: Resolver<Maybe<ResolversTypes['SendMessageMutation']>, ParentType, ContextType, Partial<MutationSendMessageArgs>>;
  sendOpenDayProspectReport?: Resolver<Maybe<ResolversTypes['SendOpenDayProspectReport']>, ParentType, ContextType, RequireFields<MutationSendOpenDayProspectReportArgs, 'openDayId'>>;
  sendVerificationCode?: Resolver<Maybe<ResolversTypes['SendVerificationCode']>, ParentType, ContextType, RequireFields<MutationSendVerificationCodeArgs, 'source'>>;
  setActiveBlogTopics?: Resolver<Maybe<ResolversTypes['SetActiveBlogTopicsMutation']>, ParentType, ContextType, Partial<MutationSetActiveBlogTopicsArgs>>;
  setAllNotificationsRead?: Resolver<Maybe<ResolversTypes['SetAllNotificationsReadMutation']>, ParentType, ContextType>;
  setArchivedContentBrief?: Resolver<Maybe<ResolversTypes['SetArchivedContentBriefMutation']>, ParentType, ContextType, RequireFields<MutationSetArchivedContentBriefArgs, 'archived' | 'contentBriefId' | 'universityId'>>;
  setArchivedDegreeLevel?: Resolver<Maybe<ResolversTypes['SetArchivedDegreeLevelMutation']>, ParentType, ContextType, RequireFields<MutationSetArchivedDegreeLevelArgs, 'archived' | 'degreeLevelId' | 'universitySlug'>>;
  setArchivedYearOfStudy?: Resolver<Maybe<ResolversTypes['SetArchivedYearOfStudyMutation']>, ParentType, ContextType, RequireFields<MutationSetArchivedYearOfStudyArgs, 'archived' | 'universitySlug' | 'yearOfStudyId'>>;
  setBlockUser?: Resolver<Maybe<ResolversTypes['BlockUserMutation']>, ParentType, ContextType, Partial<MutationSetBlockUserArgs>>;
  setBlockUserV2?: Resolver<Maybe<ResolversTypes['BlockUserMutationV2']>, ParentType, ContextType, Partial<MutationSetBlockUserV2Args>>;
  setBlogPostStatus?: Resolver<Maybe<ResolversTypes['UpdatePostStatusMutation']>, ParentType, ContextType, Partial<MutationSetBlogPostStatusArgs>>;
  setBuddiesListFilters?: Resolver<Maybe<ResolversTypes['SetBuddiesListFilters']>, ParentType, ContextType, Partial<MutationSetBuddiesListFiltersArgs>>;
  setChatGroupLabels?: Resolver<Maybe<ResolversTypes['SetChatGroupLabelsMutation']>, ParentType, ContextType, Partial<MutationSetChatGroupLabelsArgs>>;
  setDeviceToken?: Resolver<ResolversTypes['DeviceToken'], ParentType, ContextType, RequireFields<MutationSetDeviceTokenArgs, 'SetDeviceTokenDTO'>>;
  setInterestsForUser?: Resolver<Array<ResolversTypes['UserInterest']>, ParentType, ContextType, RequireFields<MutationSetInterestsForUserArgs, 'setUserInterestsInput'>>;
  setMentorFieldOrder?: Resolver<Maybe<ResolversTypes['SetMentorFieldOrderMutation']>, ParentType, ContextType, Partial<MutationSetMentorFieldOrderArgs>>;
  setMentorListFilterSelection?: Resolver<Maybe<ResolversTypes['SetMentorListFilterSelection']>, ParentType, ContextType, Partial<MutationSetMentorListFilterSelectionArgs>>;
  setOnline?: Resolver<Maybe<ResolversTypes['SetOnlineMutation']>, ParentType, ContextType, Partial<MutationSetOnlineArgs>>;
  setResolveChatGroup?: Resolver<Maybe<ResolversTypes['SetResolveChatGroupMutation']>, ParentType, ContextType, Partial<MutationSetResolveChatGroupArgs>>;
  setUniversityUnblockUsers?: Resolver<Maybe<ResolversTypes['UniversityBlockUsersMutation']>, ParentType, ContextType, Partial<MutationSetUniversityUnblockUsersArgs>>;
  setUserProfile?: Resolver<ResolversTypes['UserProfile'], ParentType, ContextType, RequireFields<MutationSetUserProfileArgs, 'data'>>;
  setWillReply?: Resolver<Maybe<ResolversTypes['SetWillReplyMutation']>, ParentType, ContextType, Partial<MutationSetWillReplyArgs>>;
  showMentorInMarketplace?: Resolver<Maybe<ResolversTypes['ShowMentorInMarketplaceMutation']>, ParentType, ContextType, RequireFields<MutationShowMentorInMarketplaceArgs, 'mentorId'>>;
  startRecordingVideo?: Resolver<Maybe<ResolversTypes['RecordingResponse']>, ParentType, ContextType, RequireFields<MutationStartRecordingVideoArgs, 'data'>>;
  stopRecordingVideo?: Resolver<Maybe<ResolversTypes['RecordingResponse']>, ParentType, ContextType, RequireFields<MutationStopRecordingVideoArgs, 'data'>>;
  stopUniversityCrawl?: Resolver<Maybe<ResolversTypes['UniversityScrapeStopOutput']>, ParentType, ContextType, RequireFields<MutationStopUniversityCrawlArgs, 'universityStopCrawlInput'>>;
  toggleCommunityChatGroupMute?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationToggleCommunityChatGroupMuteArgs, 'conversationId' | 'status'>>;
  toggleCrmIntegrationSync?: Resolver<Maybe<ResolversTypes['ToggleCrmIntegrationSync']>, ParentType, ContextType, Partial<MutationToggleCrmIntegrationSyncArgs>>;
  toggleCustomAttributeCrmSync?: Resolver<Maybe<ResolversTypes['ToggleCustomAttributeCrmSyncMutation']>, ParentType, ContextType, Partial<MutationToggleCustomAttributeCrmSyncArgs>>;
  toggleDegreesActive?: Resolver<Maybe<ResolversTypes['ToggleDegreesActiveMutation']>, ParentType, ContextType, Partial<MutationToggleDegreesActiveArgs>>;
  toggleFeatureAvailability?: Resolver<Maybe<ResolversTypes['ToggleFeatureAvailabilityMutation']>, ParentType, ContextType, Partial<MutationToggleFeatureAvailabilityArgs>>;
  trackLiveEvent?: Resolver<Maybe<ResolversTypes['TrackLiveEventMutation']>, ParentType, ContextType, Partial<MutationTrackLiveEventArgs>>;
  trackOpenDay?: Resolver<Maybe<ResolversTypes['TrackOpenDayMutation']>, ParentType, ContextType, RequireFields<MutationTrackOpenDayArgs, 'name' | 'openDayId' | 'product' | 'universitySlug'>>;
  unlikeConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationUnlikeConversationMessageArgs, 'likeMessageDto'>>;
  unpinMessage?: Resolver<Maybe<ResolversTypes['UnpinMessageMutation']>, ParentType, ContextType, Partial<MutationUnpinMessageArgs>>;
  unpinMessageInConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<MutationUnpinMessageInConversationArgs, 'unpinMessageDTO'>>;
  unresolveConversationMessage?: Resolver<ResolversTypes['ChatMessage'], ParentType, ContextType, RequireFields<MutationUnresolveConversationMessageArgs, 'resolveMessageDto'>>;
  updateApplicant?: Resolver<Maybe<ResolversTypes['UpdateApplicantMutation']>, ParentType, ContextType, Partial<MutationUpdateApplicantArgs>>;
  updateApplicantPreferences?: Resolver<Maybe<ResolversTypes['UpdateApplicantPreferencesMutation']>, ParentType, ContextType, Partial<MutationUpdateApplicantPreferencesArgs>>;
  updateCanonicalQuestion?: Resolver<Maybe<ResolversTypes['UpdateCanonicalQuestion']>, ParentType, ContextType, RequireFields<MutationUpdateCanonicalQuestionArgs, 'questionId'>>;
  updateChatRoom?: Resolver<ResolversTypes['ChatRoom'], ParentType, ContextType, RequireFields<MutationUpdateChatRoomArgs, 'chatRoomId' | 'updateChatRoomInput'>>;
  updateCommunityApplicantSignupsource?: Resolver<Maybe<ResolversTypes['UpdateCommunityApplicantSignupSourceMutation']>, ParentType, ContextType, Partial<MutationUpdateCommunityApplicantSignupsourceArgs>>;
  updateCrmServiceUniversityConfig?: Resolver<Maybe<ResolversTypes['UpdateUniversityConfigMutation']>, ParentType, ContextType, Partial<MutationUpdateCrmServiceUniversityConfigArgs>>;
  updateDirectMessagingMembersForLiveEvent?: Resolver<Maybe<ResolversTypes['UpdateDirectMessagingMembersForLiveEventMutation']>, ParentType, ContextType, Partial<MutationUpdateDirectMessagingMembersForLiveEventArgs>>;
  updateEventPage?: Resolver<ResolversTypes['EventPage'], ParentType, ContextType, RequireFields<MutationUpdateEventPageArgs, 'eventPageId' | 'updateEventPageInput'>>;
  updateExternalContent?: Resolver<ResolversTypes['ExternalContent'], ParentType, ContextType, RequireFields<MutationUpdateExternalContentArgs, 'externalContentId' | 'updateExternalContentInput'>>;
  updateFaqAnswer?: Resolver<Maybe<ResolversTypes['UpdateFaqAnswer']>, ParentType, ContextType, RequireFields<MutationUpdateFaqAnswerArgs, 'answerId'>>;
  updateHobsonsConnectIntegration?: Resolver<Maybe<ResolversTypes['UpdateHobsonsConnectIntegration']>, ParentType, ContextType, Partial<MutationUpdateHobsonsConnectIntegrationArgs>>;
  updateIntegrationFieldMapping?: Resolver<Maybe<ResolversTypes['UpdateIntegrationFieldMapping']>, ParentType, ContextType, Partial<MutationUpdateIntegrationFieldMappingArgs>>;
  updateLiveEventFeedSessionData?: Resolver<Maybe<ResolversTypes['UpdateLiveEventFeedSessionDataMutation']>, ParentType, ContextType, Partial<MutationUpdateLiveEventFeedSessionDataArgs>>;
  updateLiveSession?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<MutationUpdateLiveSessionArgs, 'liveSessionId' | 'updateLiveSessionInput'>>;
  updateLiveSessionAnyUser?: Resolver<ResolversTypes['LiveSession'], ParentType, ContextType, RequireFields<MutationUpdateLiveSessionAnyUserArgs, 'liveSessionId' | 'updateLiveSessionInput'>>;
  updateManyUserMutation?: Resolver<Maybe<ResolversTypes['UpdateManyUserMutation']>, ParentType, ContextType, Partial<MutationUpdateManyUserMutationArgs>>;
  updateMarketplace?: Resolver<Maybe<ResolversTypes['UpdateMarketplaceMutation']>, ParentType, ContextType, RequireFields<MutationUpdateMarketplaceArgs, 'id'>>;
  updateMarketplaceApplicant?: Resolver<Maybe<ResolversTypes['UpdateMarketplaceApplicantMutation']>, ParentType, ContextType, RequireFields<MutationUpdateMarketplaceApplicantArgs, 'marketplace'>>;
  updateMarketplaceApplicantUniversityLink?: Resolver<Maybe<ResolversTypes['UpdateMarketplaceApplicantUniversityLinkMutation']>, ParentType, ContextType, RequireFields<MutationUpdateMarketplaceApplicantUniversityLinkArgs, 'marketplaceSlug' | 'universitySlug'>>;
  updateMentor?: Resolver<Maybe<ResolversTypes['UpdateMentorMutation']>, ParentType, ContextType, Partial<MutationUpdateMentorArgs>>;
  updateMentorPreferences?: Resolver<Maybe<ResolversTypes['UpdateMentorPreferences']>, ParentType, ContextType, Partial<MutationUpdateMentorPreferencesArgs>>;
  updateMyUniversityLink?: Resolver<Maybe<ResolversTypes['UpdateMyUniversityLinkMutation']>, ParentType, ContextType, Partial<MutationUpdateMyUniversityLinkArgs>>;
  updateRecordingLayout?: Resolver<Maybe<ResolversTypes['RecordingResponse']>, ParentType, ContextType, RequireFields<MutationUpdateRecordingLayoutArgs, 'data'>>;
  updateResearchTime?: Resolver<Maybe<ResolversTypes['UpdateResearchTimeMutation']>, ParentType, ContextType, RequireFields<MutationUpdateResearchTimeArgs, 'researchTimeData'>>;
  updateStaff?: Resolver<Maybe<ResolversTypes['UpdateStaffMutation']>, ParentType, ContextType, Partial<MutationUpdateStaffArgs>>;
  updateStaffContact?: Resolver<ResolversTypes['StaffContactOutput'], ParentType, ContextType, RequireFields<MutationUpdateStaffContactArgs, 'updateStaffContactInput'>>;
  updateSubTopic?: Resolver<Maybe<ResolversTypes['UpdateSubTopicMutation']>, ParentType, ContextType, RequireFields<MutationUpdateSubTopicArgs, 'id'>>;
  updateTag?: Resolver<Maybe<ResolversTypes['UpdateTagMutation']>, ParentType, ContextType, RequireFields<MutationUpdateTagArgs, 'id'>>;
  updateTodoAction?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateTodoActionArgs, 'action' | 'id'>>;
  updateTodoStatus?: Resolver<ResolversTypes['TodosEntity'], ParentType, ContextType, RequireFields<MutationUpdateTodoStatusArgs, 'id' | 'status'>>;
  updateTopic?: Resolver<Maybe<ResolversTypes['UpdateTopicMutation']>, ParentType, ContextType, RequireFields<MutationUpdateTopicArgs, 'id'>>;
  updateUniversityAssistantScrapeStartingPoint?: Resolver<ResolversTypes['UniversityAssistantConfigurationScrapeStartPointOutput'], ParentType, ContextType, RequireFields<MutationUpdateUniversityAssistantScrapeStartingPointArgs, 'universityAssistantConfigurationScrapeStartPointInput'>>;
  updateUniversityBlockReport?: Resolver<Maybe<ResolversTypes['UpdateUniversityBlockReportMutation']>, ParentType, ContextType, Partial<MutationUpdateUniversityBlockReportArgs>>;
  updateUniversityUser?: Resolver<Maybe<ResolversTypes['UpdateUniversityUserMutation']>, ParentType, ContextType, Partial<MutationUpdateUniversityUserArgs>>;
  updateUniversityUserPreferences?: Resolver<Maybe<ResolversTypes['UpdateUniversityUserPreferencesMutation']>, ParentType, ContextType, Partial<MutationUpdateUniversityUserPreferencesArgs>>;
  updateUserMutation?: Resolver<Maybe<ResolversTypes['UpdateUserMutation']>, ParentType, ContextType, RequireFields<MutationUpdateUserMutationArgs, 'id'>>;
  updateUserPreferencesMutation?: Resolver<Maybe<ResolversTypes['UpdateUserPreferences']>, ParentType, ContextType, Partial<MutationUpdateUserPreferencesMutationArgs>>;
  updateVirtualEvent?: Resolver<ResolversTypes['VirtualEvent'], ParentType, ContextType, RequireFields<MutationUpdateVirtualEventArgs, 'updateVirtualEventInput' | 'virtualEventId'>>;
  verifyAccount?: Resolver<Maybe<ResolversTypes['VerifyAccount']>, ParentType, ContextType, RequireFields<MutationVerifyAccountArgs, 'code'>>;
  viewBlog?: Resolver<Maybe<ResolversTypes['ViewBlogMutation']>, ParentType, ContextType, RequireFields<MutationViewBlogArgs, 'blogId'>>;
};

export type NewsFeedGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsFeedGroup'] = ResolversParentTypes['NewsFeedGroup']> = {
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationField'] = ResolversParentTypes['NotificationField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObjectID'], any> {
  name: 'ObjectID';
}

export interface ObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObjectId'], any> {
  name: 'ObjectId';
}

export type OpenDayFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenDayField'] = ResolversParentTypes['OpenDayField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExternalEventField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isStaffCarouselEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStudentsCarouselEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventDetailsField']>>>, ParentType, ContextType>;
  navigateOpenDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['OpenDayField']>>>, ParentType, ContextType>;
  navigateTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['TagField']>>>, ParentType, ContextType>;
  prospectLogins?: Resolver<Maybe<ResolversTypes['OpenDaysLoginField']>, ParentType, ContextType>;
  prospectSignups?: Resolver<Maybe<ResolversTypes['OpenDaysSignupField']>, ParentType, ContextType>;
  prospectsAttending?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['TagField']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenDaysLoginFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenDaysLoginField'] = ResolversParentTypes['OpenDaysLoginField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openDay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  widget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenDaysSignupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenDaysSignupField'] = ResolversParentTypes['OpenDaysSignupField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  openDay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  widget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenTextFieldValueFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenTextFieldValueField'] = ResolversParentTypes['OpenTextFieldValueField']> = {
  attribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganisationBuddyLinkFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganisationBuddyLinkField'] = ResolversParentTypes['OrganisationBuddyLinkField']> = {
  organisation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganisationFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganisationField'] = ResolversParentTypes['OrganisationField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  childOrganisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChildOrganisationField']>>>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedInstance?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentOrganisation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutboxChatGroupFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutboxChatGroupField'] = ResolversParentTypes['OutboxChatGroupField']> = {
  aux?: Resolver<Maybe<ResolversTypes['ChatGroupAuxiliaryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['LastMessageField']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnyUserField']>>>, ParentType, ContextType>;
  opponent?: Resolver<Maybe<ResolversTypes['AnyChatUserField']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sendbirdChannelUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unansweredByMentor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutputField'] = ResolversParentTypes['OutputField']> = {
  returncode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stderr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stdout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageMentorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageMentorField'] = ResolversParentTypes['PageMentorField']> = {
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedAdminRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedAdminRecommendation'] = ResolversParentTypes['PaginatedAdminRecommendation']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['AdminRecommendation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedApplicantInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedApplicantInvite'] = ResolversParentTypes['PaginatedApplicantInvite']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantInvite']>>>, ParentType, ContextType>;
  totalNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedApplicationInsightModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedApplicationInsightModel'] = ResolversParentTypes['PaginatedApplicationInsightModel']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ApplicationInsightModel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedChatMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedChatMessages'] = ResolversParentTypes['PaginatedChatMessages']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedChatRoomsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedChatRooms'] = ResolversParentTypes['PaginatedChatRooms']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ChatRoom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedEventPagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedEventPages'] = ResolversParentTypes['PaginatedEventPages']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['EventPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedExternalContentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedExternalContents'] = ResolversParentTypes['PaginatedExternalContents']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['ExternalContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedLiveSessionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedLiveSessions'] = ResolversParentTypes['PaginatedLiveSessions']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['LiveSession']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedVirtualEventsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedVirtualEvents'] = ResolversParentTypes['PaginatedVirtualEvents']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['VirtualEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordResetMobileMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetMobileMutation'] = ResolversParentTypes['PasswordResetMobileMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PasswordResetMobileMutationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PasswordResetMobileMutationV2'] = ResolversParentTypes['PasswordResetMobileMutationV2']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayloadFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayloadField'] = ResolversParentTypes['PayloadField']> = {
  buttons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ButtonField']>>>, ParentType, ContextType>;
  relativePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PinMessageMutation'] = ResolversParentTypes['PinMessageMutation']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinnedMessageFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PinnedMessageField'] = ResolversParentTypes['PinnedMessageField']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['PinnedMessageSenderField']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinnedMessageSenderFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PinnedMessageSenderField'] = ResolversParentTypes['PinnedMessageSenderField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollResolvers<ContextType = any, ParentType extends ResolversParentTypes['Poll'] = ResolversParentTypes['Poll']> = {
  allowMultipleAnswers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['PollOption']>, ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PollOption'] = ResolversParentTypes['PollOption']> = {
  option?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  votes?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopCardDegreeSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopCardDegreeSnippetField'] = ResolversParentTypes['PopCardDegreeSnippetField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeSnippetField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopCardLevelSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopCardLevelSnippetField'] = ResolversParentTypes['PopCardLevelSnippetField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['LevelSnippetField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopCardWidgetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopCardWidgetField'] = ResolversParentTypes['PopCardWidgetField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopcardSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopcardSnippetField'] = ResolversParentTypes['PopcardSnippetField']> = {
  defaultSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['PopCardWidgetField']>>>, ParentType, ContextType>;
  degreeSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['PopCardDegreeSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  internationalSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['PopCardWidgetField']>>>, ParentType, ContextType>;
  levelSnippets?: Resolver<Maybe<Array<Maybe<ResolversTypes['PopCardLevelSnippetField']>>>, ParentType, ContextType>;
  nationalSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['PopCardWidgetField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostFields'] = ResolversParentTypes['PostFields']> = {
  acl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awsAccessKeyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  policy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xAmzSecurityToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreferencesObjectTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferencesObjectType'] = ResolversParentTypes['PreferencesObjectType']> = {
  analyticsCookies?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  strictCookies?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreferencesOutputTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferencesOutputType'] = ResolversParentTypes['PreferencesOutputType']> = {
  analyticsCookies?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  strictCookies?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProspectStageStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProspectStageStatField'] = ResolversParentTypes['ProspectStageStatField']> = {
  changeComparedToLastPeriod?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProspectStageSummaryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProspectStageSummaryField'] = ResolversParentTypes['ProspectStageSummaryField']> = {
  summary?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProspectStageStatField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicMentorFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicMentorField'] = ResolversParentTypes['PublicMentorField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatIntro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, ParentType, ContextType, Partial<PublicMentorFieldCustomAttributesArgs>>;
  degree?: Resolver<Maybe<ResolversTypes['DegreeField']>, ParentType, ContextType>;
  degreeHistory?: Resolver<Maybe<ResolversTypes['MentorDegreeHistory']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorDegreeField']>>>, ParentType, ContextType>;
  favouriteModules?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorModuleField']>>>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInterestField']>>>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<Array<Maybe<ResolversTypes['LanguageField']>>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentorFields?: Resolver<Maybe<ResolversTypes['MentorFields']>, ParentType, ContextType>;
  pastQualification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<PublicMentorFieldProfilePhotoArgs>>;
  prospectWelcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schoolHistory?: Resolver<Maybe<ResolversTypes['MentorSchoolHistoryField']>, ParentType, ContextType>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<PublicMentorFieldShareUrlArgs>>;
  shortBio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slowSocieties?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorSocietyField']>>>, ParentType, ContextType>;
  societies?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorSocietyField']>>>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicUserField'] = ResolversParentTypes['PublicUserField']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activeUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType>;
  adminMentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType, Partial<QueryAdminMentorArgs>>;
  adminRecommendationCountPerDecisionStage?: Resolver<Array<ResolversTypes['AdminRecommendationCountPerDecisionStage']>, ParentType, ContextType, RequireFields<QueryAdminRecommendationCountPerDecisionStageArgs, 'universityId'>>;
  adminSearchMentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType, Partial<QueryAdminSearchMentorsArgs>>;
  agenda?: Resolver<ResolversTypes['PaginatedLiveSessions'], ParentType, ContextType, RequireFields<QueryAgendaArgs, 'pagination' | 'virtualEventId'>>;
  alert?: Resolver<Maybe<ResolversTypes['AlertField']>, ParentType, ContextType, Partial<QueryAlertArgs>>;
  allAdminApplicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['BulkApplicantField']>>>, ParentType, ContextType, RequireFields<QueryAllAdminApplicantsArgs, 'degreeLevel' | 'email' | 'firstName' | 'itemsPerPage' | 'lastName' | 'order' | 'pageNum' | 'uniId'>>;
  allAppLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppLocaleField']>>>, ParentType, ContextType>;
  allApplicantConversations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantConversationField']>>>, ParentType, ContextType, RequireFields<QueryAllApplicantConversationsArgs, 'uniId'>>;
  allApplicantCount?: Resolver<Maybe<ResolversTypes['ApplicantCountField']>, ParentType, ContextType, RequireFields<QueryAllApplicantCountArgs, 'degreeLevel' | 'email' | 'firstName' | 'lastName' | 'uniId'>>;
  allApplicantSignUps?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountPerEpoch']>>>, ParentType, ContextType, Partial<QueryAllApplicantSignUpsArgs>>;
  allApplicants?: Resolver<Maybe<Array<Maybe<ResolversTypes['BulkApplicantField']>>>, ParentType, ContextType, RequireFields<QueryAllApplicantsArgs, 'itemsPerPage' | 'order' | 'pageNum'>>;
  allBuddyInvites?: Resolver<Maybe<ResolversTypes['BuddyInviteField']>, ParentType, ContextType, RequireFields<QueryAllBuddyInvitesArgs, 'accepted' | 'itemsPerPage' | 'order' | 'pageNum' | 'roleSelected'>>;
  allChatGroupCount?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountPerEpoch']>>>, ParentType, ContextType, Partial<QueryAllChatGroupCountArgs>>;
  allChatGroupsByDay?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType, Partial<QueryAllChatGroupsByDayArgs>>;
  allContentBriefs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContentBriefField']>>>, ParentType, ContextType, Partial<QueryAllContentBriefsArgs>>;
  allCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, ParentType, ContextType>;
  allCrmIntegrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['CRMIntegrationField']>>>, ParentType, ContextType>;
  allCrms?: Resolver<Maybe<Array<Maybe<ResolversTypes['CRMField']>>>, ParentType, ContextType>;
  allDegreeLevels?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeLevelField']>>>, ParentType, ContextType, Partial<QueryAllDegreeLevelsArgs>>;
  allDegreeTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeType']>>>, ParentType, ContextType>;
  allDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType, Partial<QueryAllDegreesArgs>>;
  allHighSchoolTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighSchoolTypeField']>>>, ParentType, ContextType>;
  allHighSchools?: Resolver<Maybe<Array<Maybe<ResolversTypes['HighSchoolField']>>>, ParentType, ContextType, Partial<QueryAllHighSchoolsArgs>>;
  allLanguages?: Resolver<Maybe<Array<Maybe<ResolversTypes['LanguageField']>>>, ParentType, ContextType>;
  allLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocaleField']>>>, ParentType, ContextType>;
  allMentorInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInviteField']>>>, ParentType, ContextType, RequireFields<QueryAllMentorInvitesArgs, 'accepted' | 'itemsPerPage' | 'order' | 'pageNum'>>;
  allMentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorField']>>>, ParentType, ContextType, RequireFields<QueryAllMentorsArgs, 'email' | 'firstName' | 'lastName'>>;
  allMentorsOfEnterprise?: Resolver<Maybe<Array<Maybe<ResolversTypes['EnterpriseMentorField']>>>, ParentType, ContextType, RequireFields<QueryAllMentorsOfEnterpriseArgs, 'email' | 'firstName' | 'lastName' | 'organisationId'>>;
  allMentorsTimeSpent?: Resolver<Maybe<ResolversTypes['UsersTimeSpentData']>, ParentType, ContextType, RequireFields<QueryAllMentorsTimeSpentArgs, 'orderBy'>>;
  allPosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>>, ParentType, ContextType, Partial<QueryAllPostsArgs>>;
  allPostsInfo?: Resolver<Maybe<ResolversTypes['AllPostsField']>, ParentType, ContextType, Partial<QueryAllPostsInfoArgs>>;
  allStaff?: Resolver<Maybe<ResolversTypes['StaffUserListField']>, ParentType, ContextType, Partial<QueryAllStaffArgs>>;
  allSubCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopCountryField']>>>, ParentType, ContextType, Partial<QueryAllSubCountriesArgs>>;
  allSubRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopRegionField']>>>, ParentType, ContextType, Partial<QueryAllSubRegionsArgs>>;
  allTopCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopCountryField']>>>, ParentType, ContextType, Partial<QueryAllTopCountriesArgs>>;
  allTopDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopDegreeField']>>>, ParentType, ContextType, Partial<QueryAllTopDegreesArgs>>;
  allTopRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopRegionField']>>>, ParentType, ContextType, Partial<QueryAllTopRegionsArgs>>;
  allUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType, Partial<QueryAllUniversitiesArgs>>;
  allUserIds?: Resolver<Maybe<ResolversTypes['UserIdsListField']>, ParentType, ContextType, Partial<QueryAllUserIdsArgs>>;
  allUsers?: Resolver<Maybe<ResolversTypes['UserListField']>, ParentType, ContextType, Partial<QueryAllUsersArgs>>;
  allYearOfStudy?: Resolver<Maybe<Array<Maybe<ResolversTypes['YearOfStudyField']>>>, ParentType, ContextType, Partial<QueryAllYearOfStudyArgs>>;
  analytics?: Resolver<ResolversTypes['Analytics'], ParentType, ContextType, RequireFields<QueryAnalyticsArgs, 'virtualEventId'>>;
  appLocales?: Resolver<Maybe<ResolversTypes['AppLocaleField']>, ParentType, ContextType, Partial<QueryAppLocalesArgs>>;
  applicant?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType, Partial<QueryApplicantArgs>>;
  applicantCollectionFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantCollectionField']>>>, ParentType, ContextType, Partial<QueryApplicantCollectionFieldsArgs>>;
  applicantCount?: Resolver<Maybe<ResolversTypes['ApplicantCountField']>, ParentType, ContextType, Partial<QueryApplicantCountArgs>>;
  applicantCountryCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicantDegreeCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicantDomesticRegionCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicantInbox?: Resolver<Maybe<ResolversTypes['ApplicantInboxField']>, ParentType, ContextType, RequireFields<QueryApplicantInboxArgs, 'allowDelinked'>>;
  applicantInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicantInvite']>>>, ParentType, ContextType, RequireFields<QueryApplicantInvitesArgs, 'universityId'>>;
  applicantSignUps?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountPerEpoch']>>>, ParentType, ContextType, Partial<QueryApplicantSignUpsArgs>>;
  applicantsApplied?: Resolver<Maybe<ResolversTypes['ApplicantsAppliedStats']>, ParentType, ContextType, RequireFields<QueryApplicantsAppliedArgs, 'endDate' | 'startDate'>>;
  applicantsMessaged?: Resolver<Maybe<ResolversTypes['ApplicantsMessagedCount']>, ParentType, ContextType, RequireFields<QueryApplicantsMessagedArgs, 'endDate' | 'startDate'>>;
  applicationInsights?: Resolver<ResolversTypes['PaginatedApplicationInsightModel'], ParentType, ContextType, RequireFields<QueryApplicationInsightsArgs, 'paginatedApplicantInsightInput' | 'pagination'>>;
  appliedUsersCount?: Resolver<ResolversTypes['AppliedUsersCountModel'], ParentType, ContextType, RequireFields<QueryAppliedUsersCountArgs, 'appliedUsersCountInput'>>;
  askQuestion?: Resolver<Maybe<Array<Maybe<ResolversTypes['CanonicalQuestionField']>>>, ParentType, ContextType, RequireFields<QueryAskQuestionArgs, 'question' | 'universitySlug'>>;
  availableDegreeTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeType']>>>, ParentType, ContextType, RequireFields<QueryAvailableDegreeTypesArgs, 'universitySlug'>>;
  blockedUsersByMe?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  blogTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogTopicField']>>>, ParentType, ContextType, Partial<QueryBlogTopicsArgs>>;
  botUser?: Resolver<Maybe<ResolversTypes['BotUserField']>, ParentType, ContextType, Partial<QueryBotUserArgs>>;
  buddies?: Resolver<Maybe<ResolversTypes['BuddiesField']>, ParentType, ContextType, RequireFields<QueryBuddiesArgs, 'active' | 'useRandomizeStaffFeature'>>;
  buddiesFilterOptions?: Resolver<Maybe<ResolversTypes['BuddiesFilterOptionsField']>, ParentType, ContextType, RequireFields<QueryBuddiesFilterOptionsArgs, 'active' | 'all'>>;
  buddy?: Resolver<Maybe<ResolversTypes['BuddyField']>, ParentType, ContextType, RequireFields<QueryBuddyArgs, 'id'>>;
  buddyApplicantChatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryBuddyApplicantChatGroupCountArgs>>;
  buddyApplicantChatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyApplicantChatGroupField']>>>, ParentType, ContextType, Partial<QueryBuddyApplicantChatGroupsArgs>>;
  buddyApplicantChatIntervention?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyApplicantChatInterventionBuddyField']>>>, ParentType, ContextType, Partial<QueryBuddyApplicantChatInterventionArgs>>;
  buddyApplicantChatInterventionTotalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryBuddyApplicantChatInterventionTotalCountArgs>>;
  buddyInvite?: Resolver<Maybe<ResolversTypes['BuddyInviteListField']>, ParentType, ContextType, Partial<QueryBuddyInviteArgs>>;
  buddyResponseTime?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsBuddyField']>>>, ParentType, ContextType, Partial<QueryBuddyResponseTimeArgs>>;
  canonicalQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CanonicalQuestionField']>>>, ParentType, ContextType, Partial<QueryCanonicalQuestionsArgs>>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType, RequireFields<QueryChatGroupArgs, 'allowDelinked'>>;
  chatGroupAux?: Resolver<Maybe<ResolversTypes['ChatGroupAuxiliaryField']>, ParentType, ContextType, Partial<QueryChatGroupAuxArgs>>;
  chatGroupById?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType, RequireFields<QueryChatGroupByIdArgs, 'allowDelinked'>>;
  chatGroupCount?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountPerEpoch']>>>, ParentType, ContextType, Partial<QueryChatGroupCountArgs>>;
  chatGroupLabellingCandidates?: Resolver<Maybe<Array<Maybe<ResolversTypes['LabellingSentenceCandidate']>>>, ParentType, ContextType, RequireFields<QueryChatGroupLabellingCandidatesArgs, 'chatGroupId'>>;
  chatGroupLabels?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupLabelField']>>>, ParentType, ContextType>;
  chatGroupSuggestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SuggestionField']>>>, ParentType, ContextType, RequireFields<QueryChatGroupSuggestionsArgs, 'chatGroupId'>>;
  chatGroupsByDay?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType, Partial<QueryChatGroupsByDayArgs>>;
  chatInterventionMentors?: Resolver<Maybe<ResolversTypes['MentorInterventionQueryField']>, ParentType, ContextType, RequireFields<QueryChatInterventionMentorsArgs, 'onlyMentorsWithUnreads'>>;
  chatRoom?: Resolver<Maybe<ResolversTypes['ChatRoom']>, ParentType, ContextType, RequireFields<QueryChatRoomArgs, 'id'>>;
  chatRoomAnalytics?: Resolver<Maybe<ResolversTypes['ChatRoomAnalytics']>, ParentType, ContextType, RequireFields<QueryChatRoomAnalyticsArgs, 'chatRoomId'>>;
  chatRooms?: Resolver<ResolversTypes['PaginatedChatRooms'], ParentType, ContextType, RequireFields<QueryChatRoomsArgs, 'pagination' | 'virtualEventId'>>;
  communityUserDirectory?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType, RequireFields<QueryCommunityUserDirectoryArgs, 'filterUsersDTO' | 'pagination'>>;
  communityUserSearch?: Resolver<ResolversTypes['UserDirectoryResult'], ParentType, ContextType, RequireFields<QueryCommunityUserSearchArgs, 'filterUsersDTO' | 'pagination'>>;
  completedEvents?: Resolver<Maybe<ResolversTypes['CompletedEventsOverview']>, ParentType, ContextType, RequireFields<QueryCompletedEventsArgs, 'endDate' | 'filterByName' | 'filterByType' | 'limit' | 'sortBy' | 'sortOrder' | 'startDate'>>;
  conversationContext?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConversationContextField']>>>, ParentType, ContextType, RequireFields<QueryConversationContextArgs, 'endDate' | 'startDate' | 'subTopic' | 'topic'>>;
  conversationInboxDoNotUse?: Resolver<Array<ResolversTypes['ConversationInbox']>, ParentType, ContextType>;
  conversationStats?: Resolver<Maybe<Array<Maybe<ResolversTypes['TrendingTopicsField']>>>, ParentType, ContextType, RequireFields<QueryConversationStatsArgs, 'endDate' | 'groupBy' | 'startDate'>>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType, Partial<QueryCountryArgs>>;
  crmApplicationFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationField']>>>, ParentType, ContextType>;
  crmAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmAttributeField']>>>, ParentType, ContextType, Partial<QueryCrmAttributesArgs>>;
  crmDateFormats?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  crmIntegration?: Resolver<Maybe<ResolversTypes['CRMIntegrationField']>, ParentType, ContextType, Partial<QueryCrmIntegrationArgs>>;
  crmServiceUniversityConfig?: Resolver<Maybe<ResolversTypes['CrmServiceUniversityConfig']>, ParentType, ContextType, Partial<QueryCrmServiceUniversityConfigArgs>>;
  crmSyncJob?: Resolver<Maybe<ResolversTypes['CrmSyncJobField']>, ParentType, ContextType, Partial<QueryCrmSyncJobArgs>>;
  currentUserDecisionStage?: Resolver<ResolversTypes['CurrentDecisionStageOutput'], ParentType, ContextType, RequireFields<QueryCurrentUserDecisionStageArgs, 'currentUserDecisionStageQueryInput'>>;
  degreeCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeCategoryField']>>>, ParentType, ContextType, Partial<QueryDegreeCategoriesArgs>>;
  degreeCategoriesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryDegreeCategoriesCountArgs>>;
  degreeCategory?: Resolver<Maybe<ResolversTypes['DegreeCategoryField']>, ParentType, ContextType, Partial<QueryDegreeCategoryArgs>>;
  discoverableUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType, Partial<QueryDiscoverableUniversitiesArgs>>;
  domesticRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['DomesticRegionField']>>>, ParentType, ContextType, Partial<QueryDomesticRegionsArgs>>;
  enrolledInsightsByCommunity?: Resolver<ResolversTypes['EnrolledInsightResponse'], ParentType, ContextType, RequireFields<QueryEnrolledInsightsByCommunityArgs, 'enrolledInsightsInput'>>;
  enterpriseAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['EnterpriseAddOns']>>>, ParentType, ContextType>;
  enterpriseDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType, Partial<QueryEnterpriseDegreesArgs>>;
  enterpriseMentorCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryEnterpriseMentorCountArgs, 'degreeLevel' | 'degreeName' | 'email' | 'firstName' | 'lastName' | 'year'>>;
  eventAnalytics?: Resolver<ResolversTypes['Analytics'], ParentType, ContextType, RequireFields<QueryEventAnalyticsArgs, 'virtualEventId'>>;
  eventPage?: Resolver<Maybe<ResolversTypes['EventPage']>, ParentType, ContextType, RequireFields<QueryEventPageArgs, 'id'>>;
  eventPages?: Resolver<ResolversTypes['PaginatedEventPages'], ParentType, ContextType, RequireFields<QueryEventPagesArgs, 'pagination' | 'virtualEventId'>>;
  exampleGraphQLQuery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exportTimesheetReport?: Resolver<Maybe<ResolversTypes['ExportTimeSheetDataField']>, ParentType, ContextType, RequireFields<QueryExportTimesheetReportArgs, 'country' | 'degreeLevel' | 'degreeName' | 'email' | 'firstName' | 'lastName' | 'year'>>;
  externalContent?: Resolver<Maybe<ResolversTypes['ExternalContent']>, ParentType, ContextType, RequireFields<QueryExternalContentArgs, 'id'>>;
  externalContents?: Resolver<ResolversTypes['PaginatedExternalContents'], ParentType, ContextType, RequireFields<QueryExternalContentsArgs, 'pagination' | 'virtualEventId'>>;
  externalEvent?: Resolver<Maybe<ResolversTypes['ExternalEventField']>, ParentType, ContextType, Partial<QueryExternalEventArgs>>;
  externalEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExternalEventField']>>>, ParentType, ContextType, Partial<QueryExternalEventsArgs>>;
  filterUsersEnterprise?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserCustomAttributesFilterField']>>>, ParentType, ContextType, Partial<QueryFilterUsersEnterpriseArgs>>;
  getAssistantConversation?: Resolver<Maybe<ResolversTypes['AssistantConversationHistory']>, ParentType, ContextType, RequireFields<QueryGetAssistantConversationArgs, 'getAssistantConversationInput'>>;
  getChatConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<QueryGetChatConversationArgs, 'id'>>;
  getChatConversationFromLegacyId?: Resolver<Maybe<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetChatConversationFromLegacyIdArgs, 'id'>>;
  getChatConversationInbox?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetChatConversationInboxArgs, 'ChatConversationInboxInputDto'>>;
  getChatConversationMessages?: Resolver<ResolversTypes['PaginatedChatMessages'], ParentType, ContextType, RequireFields<QueryGetChatConversationMessagesArgs, 'getMessageDto'>>;
  getChatConversationsForUser?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, Partial<QueryGetChatConversationsForUserArgs>>;
  getChatGroupsForCommunity?: Resolver<Array<ResolversTypes['CommunityChatGroup']>, ParentType, ContextType, RequireFields<QueryGetChatGroupsForCommunityArgs, 'communityId'>>;
  getChatReports?: Resolver<Array<ResolversTypes['ChatReport']>, ParentType, ContextType, RequireFields<QueryGetChatReportsArgs, 'getChatReportsDTO'>>;
  getCommunityChatMembers?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType, RequireFields<QueryGetCommunityChatMembersArgs, 'conversationId' | 'offsetPagination'>>;
  getCommunityConversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType, RequireFields<QueryGetCommunityConversationArgs, 'id'>>;
  getCommunityConversations?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetCommunityConversationsArgs, 'communityId' | 'retrieveArchived'>>;
  getCommunityForUniOrAdmin?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<QueryGetCommunityForUniOrAdminArgs, 'communityId' | 'retrieveArchived'>>;
  getCommunityForUser?: Resolver<ResolversTypes['Community'], ParentType, ContextType, RequireFields<QueryGetCommunityForUserArgs, 'communityId'>>;
  getCommunityMembers?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType, RequireFields<QueryGetCommunityMembersArgs, 'communityId'>>;
  getCommunityTemplates?: Resolver<Array<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  getConversationPermission?: Resolver<ResolversTypes['ChatPermission'], ParentType, ContextType, RequireFields<QueryGetConversationPermissionArgs, 'id'>>;
  getExperimentalTodos?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  getGeckoUniversityId?: Resolver<Maybe<ResolversTypes['GeckoUniversityData']>, ParentType, ContextType, RequireFields<QueryGetGeckoUniversityIdArgs, 'universityId'>>;
  getIdpToken?: Resolver<Maybe<ResolversTypes['AuthField']>, ParentType, ContextType, Partial<QueryGetIdpTokenArgs>>;
  getInterests?: Resolver<Array<ResolversTypes['Interest']>, ParentType, ContextType>;
  getInterestsForUser?: Resolver<Array<ResolversTypes['UserInterest']>, ParentType, ContextType>;
  getInviteFromId?: Resolver<ResolversTypes['Invite'], ParentType, ContextType, RequireFields<QueryGetInviteFromIdArgs, 'inviteId'>>;
  getInviteInformation?: Resolver<ResolversTypes['InviteInformation'], ParentType, ContextType, RequireFields<QueryGetInviteInformationArgs, 'InviteInformationInput'>>;
  getInviteLinkInfo?: Resolver<ResolversTypes['InviteLinkInfoDto'], ParentType, ContextType, RequireFields<QueryGetInviteLinkInfoArgs, 'inviteLinkId'>>;
  getInvitesForCommunity?: Resolver<Array<ResolversTypes['CommunityInvites']>, ParentType, ContextType, RequireFields<QueryGetInvitesForCommunityArgs, 'communityId' | 'filters' | 'retrieveArchived'>>;
  getInvitesForEmail?: Resolver<Array<ResolversTypes['GetInvitesForEmailDTO']>, ParentType, ContextType, RequireFields<QueryGetInvitesForEmailArgs, 'email'>>;
  getLabels?: Resolver<Array<ResolversTypes['Labels']>, ParentType, ContextType>;
  getLiveEventsById?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventField']>>>, ParentType, ContextType, RequireFields<QueryGetLiveEventsByIdArgs, 'universityId'>>;
  getMessagesForChatConversation?: Resolver<Array<ResolversTypes['ChatMessage']>, ParentType, ContextType, RequireFields<QueryGetMessagesForChatConversationArgs, 'getMessageDto'>>;
  getOrCreateBotChatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType, Partial<QueryGetOrCreateBotChatGroupArgs>>;
  getOrCreateChatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType, Partial<QueryGetOrCreateChatGroupArgs>>;
  getOrCreateCommunitiesForInstitution?: Resolver<Array<ResolversTypes['Community']>, ParentType, ContextType, RequireFields<QueryGetOrCreateCommunitiesForInstitutionArgs, 'universityId'>>;
  getOrCreateUniversityChatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupAndMessages']>, ParentType, ContextType, Partial<QueryGetOrCreateUniversityChatGroupArgs>>;
  getRandomAmbassadors?: Resolver<Maybe<Array<ResolversTypes['AmbassadorProfileInformation']>>, ParentType, ContextType, RequireFields<QueryGetRandomAmbassadorsArgs, 'getRandomAmbassadorsInput'>>;
  getRecommendedConversations?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetRecommendedConversationsArgs, 'communityId'>>;
  getRecommendedUsers?: Resolver<ResolversTypes['UserRecommendation'], ParentType, ContextType, RequireFields<QueryGetRecommendedUsersArgs, 'communityId'>>;
  getRecording?: Resolver<Maybe<ResolversTypes['RecordingDownloadResponse']>, ParentType, ContextType, RequireFields<QueryGetRecordingArgs, 'path'>>;
  getRecordingFailuresByChannelId?: Resolver<ResolversTypes['GetRecordingFailureIdsResponse'], ParentType, ContextType, RequireFields<QueryGetRecordingFailuresByChannelIdArgs, 'data'>>;
  getRecordingFailuresByEventId?: Resolver<ResolversTypes['GetRecordingFailureIdsResponse'], ParentType, ContextType, RequireFields<QueryGetRecordingFailuresByEventIdArgs, 'data'>>;
  getRecordingList?: Resolver<Maybe<ResolversTypes['RecordingListResponse']>, ParentType, ContextType, RequireFields<QueryGetRecordingListArgs, 'channelId' | 'universityId'>>;
  getRecordingUploadingCount?: Resolver<ResolversTypes['RecordingUploadingResponse'], ParentType, ContextType, RequireFields<QueryGetRecordingUploadingCountArgs, 'channelId' | 'universityId'>>;
  getTodosForUniversity?: Resolver<Array<ResolversTypes['TodosEntity']>, ParentType, ContextType, RequireFields<QueryGetTodosForUniversityArgs, 'universityId'>>;
  getTodosForUser?: Resolver<Array<ResolversTypes['TodosEntity']>, ParentType, ContextType>;
  getToken?: Resolver<Maybe<ResolversTypes['AuthField']>, ParentType, ContextType, Partial<QueryGetTokenArgs>>;
  getTokenForEnterpriseView?: Resolver<Maybe<ResolversTypes['AuthField']>, ParentType, ContextType, Partial<QueryGetTokenForEnterpriseViewArgs>>;
  getUniversitiesByFeatureFlag?: Resolver<ResolversTypes['FeatureRulesDTO'], ParentType, ContextType, RequireFields<QueryGetUniversitiesByFeatureFlagArgs, 'featureFlag'>>;
  getUniversityAssistantConfig?: Resolver<Maybe<ResolversTypes['UniversityAssistantConfiguration']>, ParentType, ContextType, RequireFields<QueryGetUniversityAssistantConfigArgs, 'universityId'>>;
  getUser?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType, Partial<QueryGetUserArgs>>;
  getUserByEmail?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType, Partial<QueryGetUserByEmailArgs>>;
  getUserByIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserField']>>>, ParentType, ContextType, Partial<QueryGetUserByIdsArgs>>;
  getUserProfile?: Resolver<ResolversTypes['UserProfile'], ParentType, ContextType>;
  getUserReports?: Resolver<Array<ResolversTypes['UserReport']>, ParentType, ContextType, RequireFields<QueryGetUserReportsArgs, 'getUserReportsDTO'>>;
  getUsersCommunityConversations?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetUsersCommunityConversationsArgs, 'communityId'>>;
  getUsersCommunityPrivateConversations?: Resolver<Array<ResolversTypes['ChatConversation']>, ParentType, ContextType, RequireFields<QueryGetUsersCommunityPrivateConversationsArgs, 'communityId'>>;
  getVideoContent?: Resolver<ResolversTypes['VideoContent'], ParentType, ContextType>;
  globalAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['AlertField']>>>, ParentType, ContextType, Partial<QueryGlobalAlertsArgs>>;
  hasContent?: Resolver<ResolversTypes['UniversityContent'], ParentType, ContextType, RequireFields<QueryHasContentArgs, 'universityContentInput'>>;
  hasMore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  helloCommunityService?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryHelloCommunityServiceArgs, 'throwError'>>;
  hobsonsConnectIntegration?: Resolver<Maybe<ResolversTypes['CampusManagementConnectIntegrationField']>, ParentType, ContextType, Partial<QueryHobsonsConnectIntegrationArgs>>;
  inboxPromptQuestionByQuestionId?: Resolver<ResolversTypes['InboxPromptQuestion'], ParentType, ContextType, RequireFields<QueryInboxPromptQuestionByQuestionIdArgs, 'questionId'>>;
  inboxPromptQuestions?: Resolver<Array<ResolversTypes['InboxPromptQuestion']>, ParentType, ContextType, RequireFields<QueryInboxPromptQuestionsArgs, 'inboxPromptInput'>>;
  interventionMessageList?: Resolver<Maybe<Array<Maybe<ResolversTypes['InterventionMessageField']>>>, ParentType, ContextType, Partial<QueryInterventionMessageListArgs>>;
  isModerationHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isProspectGuidanceHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUserInDirectMessages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryIsUserInDirectMessagesArgs, 'liveEventSlug' | 'universityId' | 'userId'>>;
  isUserProfilingHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVideoContentHealthy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latestExportedReport?: Resolver<Maybe<ResolversTypes['ExportedReportField']>, ParentType, ContextType, Partial<QueryLatestExportedReportArgs>>;
  listAdminRecommendationResourceTypes?: Resolver<Array<ResolversTypes['RecommendationResourceType']>, ParentType, ContextType>;
  listAdminRecommendations?: Resolver<ResolversTypes['PaginatedAdminRecommendation'], ParentType, ContextType, RequireFields<QueryListAdminRecommendationsArgs, 'listAdminRecommendationInput' | 'pagination'>>;
  listArchivedCommunitiesForAnInstitution?: Resolver<Array<ResolversTypes['Community']>, ParentType, ContextType, RequireFields<QueryListArchivedCommunitiesForAnInstitutionArgs, 'institutionId'>>;
  listBuddyApplicantConversations?: Resolver<Maybe<ResolversTypes['ListBuddyApplicantConversationsField']>, ParentType, ContextType, RequireFields<QueryListBuddyApplicantConversationsArgs, 'limit' | 'offset' | 'sort'>>;
  listCommunitiesForAnInstitution?: Resolver<Array<ResolversTypes['Community']>, ParentType, ContextType, RequireFields<QueryListCommunitiesForAnInstitutionArgs, 'institutionId'>>;
  listMentorApplicantConversations?: Resolver<Maybe<ResolversTypes['ListMentorApplicantConversationsField']>, ParentType, ContextType, RequireFields<QueryListMentorApplicantConversationsArgs, 'limit' | 'offset' | 'sort'>>;
  listUniversityAssistantConversations?: Resolver<Maybe<ResolversTypes['ListUniversityAssistantConversationsOutput']>, ParentType, ContextType, RequireFields<QueryListUniversityAssistantConversationsArgs, 'listUniversityAssistantConversationsInput'>>;
  listUniversityKnowledgeBaseSources?: Resolver<Array<ResolversTypes['KnowledgeBaseEmbedding']>, ParentType, ContextType, RequireFields<QueryListUniversityKnowledgeBaseSourcesArgs, 'knowledgeBaseSourceQueryInput'>>;
  listUniversityKnowledgeBaseSourcesByUrlPattern?: Resolver<Array<ResolversTypes['KnowledgeBaseSourcesByUrl']>, ParentType, ContextType, RequireFields<QueryListUniversityKnowledgeBaseSourcesByUrlPatternArgs, 'knowledgeBaseSourcesListInput'>>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType, Partial<QueryLiveEventArgs>>;
  liveEventLandingPage?: Resolver<Maybe<ResolversTypes['LiveEventLandingPageField']>, ParentType, ContextType, Partial<QueryLiveEventLandingPageArgs>>;
  liveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventField']>>>, ParentType, ContextType, RequireFields<QueryLiveEventsArgs, 'viewFilter'>>;
  liveFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType, Partial<QueryLiveFeedArgs>>;
  liveSession?: Resolver<Maybe<ResolversTypes['LiveSession']>, ParentType, ContextType, RequireFields<QueryLiveSessionArgs, 'id'>>;
  liveSessions?: Resolver<ResolversTypes['PaginatedLiveSessions'], ParentType, ContextType, RequireFields<QueryLiveSessionsArgs, 'orderBy' | 'pagination' | 'virtualEventId'>>;
  marketplace?: Resolver<Maybe<ResolversTypes['MarketplaceField']>, ParentType, ContextType, Partial<QueryMarketplaceArgs>>;
  marketplaceApplicantChatGroupsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryMarketplaceApplicantChatGroupsCountArgs>>;
  marketplaceApplicantCountries?: Resolver<Maybe<ResolversTypes['MarketplaceApplicantCountries']>, ParentType, ContextType, RequireFields<QueryMarketplaceApplicantCountriesArgs, 'marketplaceSlug'>>;
  marketplaceApplicantDegreeCategories?: Resolver<Maybe<ResolversTypes['MarketplaceApplicantDegreeCategories']>, ParentType, ContextType, RequireFields<QueryMarketplaceApplicantDegreeCategoriesArgs, 'marketplaceSlug'>>;
  marketplaceApplicantsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryMarketplaceApplicantsCountArgs>>;
  marketplaceInbox?: Resolver<Maybe<ResolversTypes['MarketplaceInboxField']>, ParentType, ContextType, Partial<QueryMarketplaceInboxArgs>>;
  marketplaceMentorCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, ParentType, ContextType, Partial<QueryMarketplaceMentorCountriesArgs>>;
  marketplaceMentorDegreeCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType, Partial<QueryMarketplaceMentorDegreeCategoriesArgs>>;
  marketplaceMentorList?: Resolver<Maybe<ResolversTypes['MarketplaceMentorList']>, ParentType, ContextType, RequireFields<QueryMarketplaceMentorListArgs, 'limit'>>;
  marketplaceMentorRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['DomesticRegionField']>>>, ParentType, ContextType, Partial<QueryMarketplaceMentorRegionsArgs>>;
  marketplaceMentorUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType, Partial<QueryMarketplaceMentorUniversitiesArgs>>;
  marketplaceSnippets?: Resolver<Maybe<ResolversTypes['MarketplaceSnippetField']>, ParentType, ContextType, Partial<QueryMarketplaceSnippetsArgs>>;
  marketplaceUniversitiesSlugs?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType, Partial<QueryMarketplaceUniversitiesSlugsArgs>>;
  marketplaceUniversityCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, ParentType, ContextType, Partial<QueryMarketplaceUniversityCountriesArgs>>;
  marketplaceUnreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryMarketplaceUnreadMessageCountArgs>>;
  marketplaces?: Resolver<Maybe<Array<Maybe<ResolversTypes['MarketplaceField']>>>, ParentType, ContextType, Partial<QueryMarketplacesArgs>>;
  marketplacesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryMarketplacesCountArgs>>;
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  memberOrganisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationField']>>>, ParentType, ContextType>;
  mentorApplicantChatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryMentorApplicantChatGroupCountArgs>>;
  mentorApplicantChatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorApplicantChatGroupField']>>>, ParentType, ContextType, Partial<QueryMentorApplicantChatGroupsArgs>>;
  mentorCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryMentorCountArgs, 'degreeLevel' | 'degreeName' | 'email' | 'firstName' | 'lastName' | 'onlyMentorsWithUnreads' | 'year'>>;
  mentorInbox?: Resolver<Maybe<ResolversTypes['MentorInboxField']>, ParentType, ContextType, Partial<QueryMentorInboxArgs>>;
  mentorInterests?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInterestField']>>>, ParentType, ContextType, Partial<QueryMentorInterestsArgs>>;
  mentorIntroMessage?: Resolver<Maybe<ResolversTypes['MentorIntroMessageField']>, ParentType, ContextType, Partial<QueryMentorIntroMessageArgs>>;
  mentorInvite?: Resolver<Maybe<ResolversTypes['MentorInviteField']>, ParentType, ContextType, Partial<QueryMentorInviteArgs>>;
  mentorInviteCount?: Resolver<Maybe<ResolversTypes['MentorInviteCountField']>, ParentType, ContextType, RequireFields<QueryMentorInviteCountArgs, 'accepted'>>;
  mentorList?: Resolver<Maybe<ResolversTypes['MentorListField']>, ParentType, ContextType, RequireFields<QueryMentorListArgs, 'filterIncompleteProfiles'>>;
  mentorModules?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorModuleField']>>>, ParentType, ContextType, Partial<QueryMentorModulesArgs>>;
  mentorPosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>>, ParentType, ContextType, Partial<QueryMentorPostsArgs>>;
  mentorResponseTime?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsMentorField']>>>, ParentType, ContextType, Partial<QueryMentorResponseTimeArgs>>;
  mentorSocieties?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorSocietyField']>>>, ParentType, ContextType, Partial<QueryMentorSocietiesArgs>>;
  mentorTimeSpent?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsMentorField']>>>, ParentType, ContextType, Partial<QueryMentorTimeSpentArgs>>;
  messages?: Resolver<Maybe<ResolversTypes['ChatGroupAndMessages']>, ParentType, ContextType, RequireFields<QueryMessagesArgs, 'allowDelinked'>>;
  myAgenda?: Resolver<ResolversTypes['PaginatedLiveSessions'], ParentType, ContextType, RequireFields<QueryMyAgendaArgs, 'pagination' | 'virtualEventId'>>;
  myBlogTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogTopicField']>>>, ParentType, ContextType>;
  myLiveEventDirectMessaging?: Resolver<Maybe<ResolversTypes['LiveEventDirectMessaging']>, ParentType, ContextType, Partial<QueryMyLiveEventDirectMessagingArgs>>;
  myLiveEventFeeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventChatGroupField']>>>, ParentType, ContextType, Partial<QueryMyLiveEventFeedsArgs>>;
  myRegisteredEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventDetailsField']>>>, ParentType, ContextType>;
  myUniversityDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType, Partial<QueryMyUniversityDegreesArgs>>;
  myUniversityLink?: Resolver<Maybe<ResolversTypes['ApplicantUniversityLinkField']>, ParentType, ContextType, Partial<QueryMyUniversityLinkArgs>>;
  offsetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openDay?: Resolver<Maybe<ResolversTypes['OpenDayField']>, ParentType, ContextType, Partial<QueryOpenDayArgs>>;
  openDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['OpenDayField']>>>, ParentType, ContextType, Partial<QueryOpenDaysArgs>>;
  openDaysWithViewFilter?: Resolver<Maybe<Array<Maybe<ResolversTypes['OpenDayField']>>>, ParentType, ContextType, RequireFields<QueryOpenDaysWithViewFilterArgs, 'viewFilter'>>;
  organisation?: Resolver<Maybe<ResolversTypes['OrganisationField']>, ParentType, ContextType, Partial<QueryOrganisationArgs>>;
  organisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationField']>>>, ParentType, ContextType, Partial<QueryOrganisationsArgs>>;
  outbox?: Resolver<Maybe<Array<Maybe<ResolversTypes['OutboxChatGroupField']>>>, ParentType, ContextType, RequireFields<QueryOutboxArgs, 'itemsPerPage' | 'pageNum'>>;
  outboxCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageMentors?: Resolver<Maybe<ResolversTypes['PageMentorField']>, ParentType, ContextType, RequireFields<QueryPageMentorsArgs, 'countryName' | 'email' | 'firstName' | 'lastName' | 'lifecycleStatus'>>;
  paginatedApplicantInvites?: Resolver<Maybe<ResolversTypes['PaginatedApplicantInvite']>, ParentType, ContextType, RequireFields<QueryPaginatedApplicantInvitesArgs, 'universityId'>>;
  pingUserDirectory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  popularSession?: Resolver<Maybe<ResolversTypes['SessionAnalytics']>, ParentType, ContextType, RequireFields<QueryPopularSessionArgs, 'virtualEventId'>>;
  post?: Resolver<Maybe<ResolversTypes['BlogPostField']>, ParentType, ContextType, Partial<QueryPostArgs>>;
  prospectChatSummary?: Resolver<Maybe<ResolversTypes['ChatSummaryField']>, ParentType, ContextType, Partial<QueryProspectChatSummaryArgs>>;
  prospectChatSummaryV2?: Resolver<Maybe<ResolversTypes['ChatSummaryField']>, ParentType, ContextType, RequireFields<QueryProspectChatSummaryV2Args, 'prospectId'>>;
  prospectStageStats?: Resolver<Maybe<ResolversTypes['ProspectStageSummaryField']>, ParentType, ContextType, RequireFields<QueryProspectStageStatsArgs, 'endDate' | 'startDate'>>;
  publicLiveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventField']>>>, ParentType, ContextType, Partial<QueryPublicLiveEventsArgs>>;
  publicMentor?: Resolver<Maybe<ResolversTypes['PublicMentorField']>, ParentType, ContextType, Partial<QueryPublicMentorArgs>>;
  publicMentorIntroMessage?: Resolver<Maybe<ResolversTypes['MentorIntroMessageField']>, ParentType, ContextType, Partial<QueryPublicMentorIntroMessageArgs>>;
  publicStaffCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryPublicStaffCountArgs>>;
  publicUser?: Resolver<Maybe<ResolversTypes['PublicUserField']>, ParentType, ContextType, Partial<QueryPublicUserArgs>>;
  qssQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['QuestionField']>>>, ParentType, ContextType>;
  queryRecording?: Resolver<ResolversTypes['QueryRecordingResponse'], ParentType, ContextType, RequireFields<QueryQueryRecordingArgs, 'data'>>;
  queryUniversityIndexing?: Resolver<Maybe<ResolversTypes['UniversityScrapeIndexingOutput']>, ParentType, ContextType, RequireFields<QueryQueryUniversityIndexingArgs, 'UniversityScrapeIndexingQueryInput'>>;
  randomBuddy?: Resolver<Maybe<ResolversTypes['BuddyField']>, ParentType, ContextType, Partial<QueryRandomBuddyArgs>>;
  randomDefaultQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['DefaultQuestionsField']>>>, ParentType, ContextType, RequireFields<QueryRandomDefaultQuestionsArgs, 'limit'>>;
  randomMentor?: Resolver<Maybe<ResolversTypes['PublicMentorField']>, ParentType, ContextType, RequireFields<QueryRandomMentorArgs, 'universitySlug'>>;
  randomMentorsList?: Resolver<Maybe<ResolversTypes['RandomMentorsListField']>, ParentType, ContextType, RequireFields<QueryRandomMentorsListArgs, 'limit' | 'universitySlug'>>;
  requestedPublicGroups?: Resolver<Array<ResolversTypes['RequestedPublicGroup']>, ParentType, ContextType, RequireFields<QueryRequestedPublicGroupsArgs, 'communityId'>>;
  researchTime?: Resolver<Maybe<ResolversTypes['ResearchTimeResult']>, ParentType, ContextType, Partial<QueryResearchTimeArgs>>;
  researchTimeLog?: Resolver<Maybe<Array<Maybe<ResolversTypes['ResearchTimeLogResult']>>>, ParentType, ContextType, Partial<QueryResearchTimeLogArgs>>;
  searchUniversityKnowledgeBase?: Resolver<Array<ResolversTypes['SearchResult']>, ParentType, ContextType, RequireFields<QuerySearchUniversityKnowledgeBaseArgs, 'limit' | 'searchTerm' | 'universityId'>>;
  sequenceFilterMentorList?: Resolver<Maybe<ResolversTypes['SequenceFilterMentorListField']>, ParentType, ContextType, Partial<QuerySequenceFilterMentorListArgs>>;
  serverTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupsOverTime?: Resolver<Maybe<ResolversTypes['ApplicantSignupStats']>, ParentType, ContextType, RequireFields<QuerySignupsOverTimeArgs, 'endDate' | 'startDate'>>;
  singleInstanceOrganisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationField']>>>, ParentType, ContextType, RequireFields<QuerySingleInstanceOrganisationsArgs, 'active'>>;
  staffContactByUniversityId?: Resolver<Maybe<ResolversTypes['StaffContactOutput']>, ParentType, ContextType, RequireFields<QueryStaffContactByUniversityIdArgs, 'staffContactByUniversityIdInput'>>;
  subTopic?: Resolver<Maybe<ResolversTypes['SubTopicField']>, ParentType, ContextType>;
  subTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubTopicField']>>>, ParentType, ContextType, Partial<QuerySubTopicsArgs>>;
  switchUniversities?: Resolver<Maybe<ResolversTypes['SwitchUniversitiesField']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['TagField']>, ParentType, ContextType, RequireFields<QueryTagArgs, 'id'>>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['TagField']>>>, ParentType, ContextType, Partial<QueryTagsArgs>>;
  timeTaken?: Resolver<Maybe<ResolversTypes['TimeTakenField']>, ParentType, ContextType, Partial<QueryTimeTakenArgs>>;
  topCountries?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopCountryField']>>>, ParentType, ContextType, Partial<QueryTopCountriesArgs>>;
  topDegrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopDegreeField']>>>, ParentType, ContextType, Partial<QueryTopDegreesArgs>>;
  topDomesticRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopDomesticRegionField']>>>, ParentType, ContextType, Partial<QueryTopDomesticRegionsArgs>>;
  topSignupsByCountry?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryStatField']>>>, ParentType, ContextType, RequireFields<QueryTopSignupsByCountryArgs, 'endDate' | 'startDate' | 'topX'>>;
  topSignupsByDegree?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeStatField']>>>, ParentType, ContextType, RequireFields<QueryTopSignupsByDegreeArgs, 'endDate' | 'startDate' | 'topX'>>;
  topSignupsByState?: Resolver<Maybe<Array<Maybe<ResolversTypes['StateStatField']>>>, ParentType, ContextType, RequireFields<QueryTopSignupsByStateArgs, 'endDate' | 'startDate' | 'topX'>>;
  topic?: Resolver<Maybe<ResolversTypes['TopicField']>, ParentType, ContextType, Partial<QueryTopicArgs>>;
  topicStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['InsightsField']>>>, ParentType, ContextType, RequireFields<QueryTopicStatisticsArgs, 'groupBy'>>;
  topics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopicField']>>>, ParentType, ContextType>;
  totalSignups?: Resolver<Maybe<ResolversTypes['SignUpsCount']>, ParentType, ContextType, RequireFields<QueryTotalSignupsArgs, 'endDate' | 'startDate'>>;
  triggerDegreeExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryTriggerDegreeExportArgs>>;
  triggerMentorExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTriggerMentorExportArgs, 'countryName' | 'department' | 'email' | 'firstName' | 'lastName' | 'onlyMentorsWithUnreads' | 'staffRole'>>;
  triggerProspectExportEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTriggerProspectExportEmailArgs, 'includeSmudged' | 'order'>>;
  triggerReportExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryTriggerReportExportArgs>>;
  triggerTopicStatisticsExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryTriggerTopicStatisticsExportArgs>>;
  uniApplicantSignUps?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniApplicantSignUpsArgs>>;
  uniApplicantSignUpsBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniApplicantSignUpsBenchmarkArgs>>;
  uniChatGroups?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniChatGroupsArgs>>;
  uniChatGroupsBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniChatGroupsBenchmarkArgs>>;
  uniConversionRate?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniConversionRateArgs>>;
  uniConversionRateBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniConversionRateBenchmarkArgs>>;
  uniMessages?: Resolver<Maybe<ResolversTypes['ChatGroupAndMessages']>, ParentType, ContextType, Partial<QueryUniMessagesArgs>>;
  uniMessagesPerChatGroup?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniMessagesPerChatGroupArgs>>;
  uniResponseTime?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniResponseTimeArgs>>;
  uniResponseTimeBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniResponseTimeBenchmarkArgs>>;
  uniSentences?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniSentencesArgs>>;
  uniSentencesBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniSentencesBenchmarkArgs>>;
  uniSentencesPerChatGroup?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniSentencesPerChatGroupArgs>>;
  uniSentencesPerChatGroupBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniSentencesPerChatGroupBenchmarkArgs>>;
  uniTimeSpent?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniTimeSpentArgs>>;
  uniTimeSpentBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniTimeSpentBenchmarkArgs>>;
  uniUniqueVisits?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniUniqueVisitsArgs>>;
  uniUniqueVisitsBenchmark?: Resolver<Maybe<ResolversTypes['GraphField']>, ParentType, ContextType, Partial<QueryUniUniqueVisitsBenchmarkArgs>>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType, Partial<QueryUniversityArgs>>;
  universityAdmins?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityUserField']>>>, ParentType, ContextType>;
  universityAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['AlertField']>>>, ParentType, ContextType, Partial<QueryUniversityAlertsArgs>>;
  universityBlockReports?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityBlockReportField']>>>, ParentType, ContextType, RequireFields<QueryUniversityBlockReportsArgs, 'itemsPerPage' | 'order' | 'pageNum' | 'resolved' | 'triggeredFrom'>>;
  universityBlockReportsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryUniversityBlockReportsCountArgs, 'resolved' | 'triggeredFrom'>>;
  universityBlogPosts?: Resolver<Maybe<ResolversTypes['UniversityBlogPostsField']>, ParentType, ContextType, Partial<QueryUniversityBlogPostsArgs>>;
  universityBlogPostsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryUniversityBlogPostsCountArgs>>;
  universityBlogTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogTopicField']>>>, ParentType, ContextType>;
  universityInbox?: Resolver<Maybe<ResolversTypes['UniversityInboxField']>, ParentType, ContextType, RequireFields<QueryUniversityInboxArgs, 'limit' | 'offset'>>;
  universityMentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType, RequireFields<QueryUniversityMentorArgs, 'id'>>;
  universityQuestionById?: Resolver<ResolversTypes['UniversityQuestion'], ParentType, ContextType, RequireFields<QueryUniversityQuestionByIdArgs, 'universityQuestionByIdInput'>>;
  universityQuestions?: Resolver<Array<ResolversTypes['UniversityQuestion']>, ParentType, ContextType, RequireFields<QueryUniversityQuestionsArgs, 'universityQuestionInput'>>;
  universitySnippets?: Resolver<Maybe<ResolversTypes['UniversitySnippetField']>, ParentType, ContextType, Partial<QueryUniversitySnippetsArgs>>;
  universityUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityUserField']>>>, ParentType, ContextType, Partial<QueryUniversityUsersArgs>>;
  unreadCount?: Resolver<Maybe<ResolversTypes['UnreadCountField']>, ParentType, ContextType>;
  upcomingExternalEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExternalEventField']>>>, ParentType, ContextType, Partial<QueryUpcomingExternalEventsArgs>>;
  upcomingLiveEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventField']>>>, ParentType, ContextType, Partial<QueryUpcomingLiveEventsArgs>>;
  userChatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType, Partial<QueryUserChatGroupsArgs>>;
  userPartialSearch?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserCustomAttributesFilterField']>>>, ParentType, ContextType, Partial<QueryUserPartialSearchArgs>>;
  userPartialSearchMultipleFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserPartialSearchFields']>>>, ParentType, ContextType, Partial<QueryUserPartialSearchMultipleFieldsArgs>>;
  userPermissions?: Resolver<Maybe<ResolversTypes['UserPermissionsListField']>, ParentType, ContextType>;
  userTimeSpentBreakdown?: Resolver<Maybe<ResolversTypes['UserTimeSpentBreakdown']>, ParentType, ContextType, Partial<QueryUserTimeSpentBreakdownArgs>>;
  userUnreadMessageCount?: Resolver<Maybe<ResolversTypes['UnreadMessageCountField']>, ParentType, ContextType>;
  verifyCode?: Resolver<Maybe<ResolversTypes['VerifyCodeField']>, ParentType, ContextType, Partial<QueryVerifyCodeArgs>>;
  virtualEvent?: Resolver<Maybe<ResolversTypes['VirtualEvent']>, ParentType, ContextType, RequireFields<QueryVirtualEventArgs, 'id'>>;
  virtualEventAttendees?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType, RequireFields<QueryVirtualEventAttendeesArgs, 'virtualEventId'>>;
  virtualEventProspectReport?: Resolver<Maybe<ResolversTypes['ReportAnalytics']>, ParentType, ContextType, RequireFields<QueryVirtualEventProspectReportArgs, 'virtualEventId'>>;
  virtualEvents?: Resolver<ResolversTypes['PaginatedVirtualEvents'], ParentType, ContextType, RequireFields<QueryVirtualEventsArgs, 'pagination' | 'universityId'>>;
  virtualEventsByUniversityIds?: Resolver<ResolversTypes['PaginatedVirtualEvents'], ParentType, ContextType, RequireFields<QueryVirtualEventsByUniversityIdsArgs, 'pagination' | 'universityIds'>>;
};

export type QueryRecordingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueryRecordingResponse'] = ResolversParentTypes['QueryRecordingResponse']> = {
  recording?: Resolver<Maybe<ResolversTypes['RecordingModel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionField'] = ResolversParentTypes['QuestionField']> = {
  questionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RandomMentorsListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['RandomMentorsListField'] = ResolversParentTypes['RandomMentorsListField']> = {
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reaction'] = ResolversParentTypes['Reaction']> = {
  reaction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reactionUnicode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReadChatMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReadChatMutation'] = ResolversParentTypes['ReadChatMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Recommendation'] = ResolversParentTypes['Recommendation']> = {
  batchId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['RecommendationSource'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['RecommendationResourceTypeEnum'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendationResourceTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendationResourceType'] = ResolversParentTypes['RecommendationResourceType']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['RecommendationResourceTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordUserActivityMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordUserActivityMutation'] = ResolversParentTypes['RecordUserActivityMutation']> = {
  newActivity?: Resolver<Maybe<ResolversTypes['ActivityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingConsent'] = ResolversParentTypes['RecordingConsent']> = {
  channelId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingDownloadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingDownloadResponse'] = ResolversParentTypes['RecordingDownloadResponse']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingFailureIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingFailureId'] = ResolversParentTypes['RecordingFailureId']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingFailureResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingFailureResponse'] = ResolversParentTypes['RecordingFailureResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingListResponse'] = ResolversParentTypes['RecordingListResponse']> = {
  files?: Resolver<Array<ResolversTypes['VideoFile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingModel'] = ResolversParentTypes['RecordingModel']> = {
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  layoutMode?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  layoutStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingResponse'] = ResolversParentTypes['RecordingResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordingUploadingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordingUploadingResponse'] = ResolversParentTypes['RecordingUploadingResponse']> = {
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterToLiveEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterToLiveEvent'] = ResolversParentTypes['RegisterToLiveEvent']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveBuddyInvitesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveBuddyInvitesMutation'] = ResolversParentTypes['RemoveBuddyInvitesMutation']> = {
  successfulInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddyInviteListField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveDeviceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveDeviceMutation'] = ResolversParentTypes['RemoveDeviceMutation']> = {
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveMentorInvitesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveMentorInvitesMutation'] = ResolversParentTypes['RemoveMentorInvitesMutation']> = {
  mentorInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorInviteField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplyMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReplyMessage'] = ResolversParentTypes['ReplyMessage']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReplyOutputFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReplyOutputField'] = ResolversParentTypes['ReplyOutputField']> = {
  isSenderBlocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messageCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalMessageText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderAccountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportAnalytics'] = ResolversParentTypes['ReportAnalytics']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  reportLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  virtualEventId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestAnalyticsExportMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestAnalyticsExportMutation'] = ResolversParentTypes['RequestAnalyticsExportMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestPasswordResetMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestPasswordResetMutation'] = ResolversParentTypes['RequestPasswordResetMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestPasswordSetMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestPasswordSetMutation'] = ResolversParentTypes['RequestPasswordSetMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestedPublicGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestedPublicGroup'] = ResolversParentTypes['RequestedPublicGroup']> = {
  community?: Resolver<ResolversTypes['Community'], ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['ChatConversation'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  requestedBy?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  resolvedBy?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PublicGroupStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResearchTimeLogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResearchTimeLogResult'] = ResolversParentTypes['ResearchTimeLogResult']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timeSpentSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResearchTimeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResearchTimeResult'] = ResolversParentTypes['ResearchTimeResult']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeSpentSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordMobileMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordMobileMutation'] = ResolversParentTypes['ResetPasswordMobileMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordMutation'] = ResolversParentTypes['ResetPasswordMutation']> = {
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResetPasswordMutationV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetPasswordMutationV2'] = ResolversParentTypes['ResetPasswordMutationV2']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResolveUniversityChatsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResolveUniversityChatsMutation'] = ResolversParentTypes['ResolveUniversityChatsMutation']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RichContentOutputFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichContentOutputField'] = ResolversParentTypes['RichContentOutputField']> = {
  reply?: Resolver<Maybe<ResolversTypes['ReplyOutputField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RichMessageContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichMessageContent'] = ResolversParentTypes['RichMessageContent']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  giphy?: Resolver<Maybe<ResolversTypes['Giphy']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<ResolversTypes['Image']>>, ParentType, ContextType>;
  poll?: Resolver<Maybe<ResolversTypes['Poll']>, ParentType, ContextType>;
  reply?: Resolver<Maybe<ResolversTypes['ChatMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunManageCommandMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RunManageCommandMutation'] = ResolversParentTypes['RunManageCommandMutation']> = {
  output?: Resolver<Maybe<ResolversTypes['OutputField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SatisfactionSurveyEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SatisfactionSurveyEntity'] = ResolversParentTypes['SatisfactionSurveyEntity']> = {
  communityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universitySlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveAppliedUsersModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveAppliedUsersModel'] = ResolversParentTypes['SaveAppliedUsersModel']> = {
  saved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResult'] = ResolversParentTypes['SearchResult']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendCommunityVerificationCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCommunityVerificationCode'] = ResolversParentTypes['SendCommunityVerificationCode']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendFeedMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendFeedMessageMutation'] = ResolversParentTypes['SendFeedMessageMutation']> = {
  message?: Resolver<Maybe<ResolversTypes['MessageField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendLiveEventMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendLiveEventMessageMutation'] = ResolversParentTypes['SendLiveEventMessageMutation']> = {
  botMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['MessageField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendMessageMutation'] = ResolversParentTypes['SendMessageMutation']> = {
  botMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessageField']>>>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['MessageField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendOpenDayProspectReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendOpenDayProspectReport'] = ResolversParentTypes['SendOpenDayProspectReport']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendResetPasswordEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendResetPasswordEmail'] = ResolversParentTypes['SendResetPasswordEmail']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendVerificationCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendVerificationCode'] = ResolversParentTypes['SendVerificationCode']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SequenceFilterMentorListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SequenceFilterMentorListField'] = ResolversParentTypes['SequenceFilterMentorListField']> = {
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryField']>>>, ParentType, ContextType>;
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  filters?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorFilterField']>>>, ParentType, ContextType>;
  levels?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  mentorSeed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['PublicMentorField']>>>, ParentType, ContextType>;
  validCombination?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionAnalytics'] = ResolversParentTypes['SessionAnalytics']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  liveSessionId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  session?: Resolver<Maybe<ResolversTypes['LiveSession']>, ParentType, ContextType>;
  sessionAttendees?: Resolver<ResolversTypes['SessionAttendees'], ParentType, ContextType>;
  sessionMessagesSent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  virtualEventId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionAttendeeAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionAttendeeAnalytics'] = ResolversParentTypes['SessionAttendeeAnalytics']> = {
  accountRole?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  liveSessionId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionAttendeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionAttendees'] = ResolversParentTypes['SessionAttendees']> = {
  activeApplicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  applicants?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetActiveBlogTopicsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetActiveBlogTopicsMutation'] = ResolversParentTypes['SetActiveBlogTopicsMutation']> = {
  blogTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogTopicField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetAllNotificationsReadMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetAllNotificationsReadMutation'] = ResolversParentTypes['SetAllNotificationsReadMutation']> = {
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetArchivedContentBriefMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetArchivedContentBriefMutation'] = ResolversParentTypes['SetArchivedContentBriefMutation']> = {
  contentBrief?: Resolver<Maybe<ResolversTypes['ContentBriefField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetArchivedDegreeLevelMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetArchivedDegreeLevelMutation'] = ResolversParentTypes['SetArchivedDegreeLevelMutation']> = {
  degreeLevel?: Resolver<Maybe<ResolversTypes['DegreeLevelField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetArchivedYearOfStudyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetArchivedYearOfStudyMutation'] = ResolversParentTypes['SetArchivedYearOfStudyMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearOfStudy?: Resolver<Maybe<ResolversTypes['YearOfStudyField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetBuddiesListFiltersResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetBuddiesListFilters'] = ResolversParentTypes['SetBuddiesListFilters']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetChatGroupLabelsMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetChatGroupLabelsMutation'] = ResolversParentTypes['SetChatGroupLabelsMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetMentorFieldOrderMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetMentorFieldOrderMutation'] = ResolversParentTypes['SetMentorFieldOrderMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetMentorListFilterSelectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetMentorListFilterSelection'] = ResolversParentTypes['SetMentorListFilterSelection']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetOnlineMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetOnlineMutation'] = ResolversParentTypes['SetOnlineMutation']> = {
  online?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetResolveChatGroupMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetResolveChatGroupMutation'] = ResolversParentTypes['SetResolveChatGroupMutation']> = {
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetWillReplyMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetWillReplyMutation'] = ResolversParentTypes['SetWillReplyMutation']> = {
  chatGroupAux?: Resolver<Maybe<ResolversTypes['ChatGroupAuxiliaryField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SettingsObjectTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettingsObjectType'] = ResolversParentTypes['SettingsObjectType']> = {
  allowDirectChat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowExternalEventsIntegration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowGifs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowImages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowNewsFeed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowPrivateGroups?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShowMentorInMarketplaceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShowMentorInMarketplaceMutation'] = ResolversParentTypes['ShowMentorInMarketplaceMutation']> = {
  mentor?: Resolver<Maybe<ResolversTypes['MentorField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignUpsCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignUpsCount'] = ResolversParentTypes['SignUpsCount']> = {
  totalSignups?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignedS3PostFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignedS3POSTFields'] = ResolversParentTypes['SignedS3POSTFields']> = {
  fields?: Resolver<Maybe<ResolversTypes['PostFields']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignedS3UrlFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignedS3URLField'] = ResolversParentTypes['SignedS3URLField']> = {
  mediaUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleChoiceAttributeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleChoiceAttributeField'] = ResolversParentTypes['SingleChoiceAttributeField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSyncedWithCrm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeOptionField']>>>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleChoiceValueFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleChoiceValueField'] = ResolversParentTypes['SingleChoiceValueField']> = {
  attribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  option?: Resolver<Maybe<ResolversTypes['CustomAttributeOptionField']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceTrackingParamsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SourceTrackingParamsField'] = ResolversParentTypes['SourceTrackingParamsField']> = {
  ubCampaign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ubContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ubMedium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ubSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffBuddycardSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffBuddycardSnippetField'] = ResolversParentTypes['StaffBuddycardSnippetField']> = {
  departmentSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DepartmentSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffChatUserField'] = ResolversParentTypes['StaffChatUserField']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<StaffChatUserFieldProfilePhotoArgs>>;
  staffFields?: Resolver<Maybe<ResolversTypes['StaffFieldsChatUserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffContactOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffContactOutput'] = ResolversParentTypes['StaffContactOutput']> = {
  contact?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffField'] = ResolversParentTypes['StaffField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifecycleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<StaffFieldProfilePhotoArgs>>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  staffFields?: Resolver<Maybe<ResolversTypes['StaffUserFieldsField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffFieldsChatUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffFieldsChatUserField'] = ResolversParentTypes['StaffFieldsChatUserField']> = {
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffPopcardSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffPopcardSnippetField'] = ResolversParentTypes['StaffPopcardSnippetField']> = {
  departmentSnippet?: Resolver<Maybe<Array<Maybe<ResolversTypes['DepartmentSnippetField']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffProfileInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffProfileInformation'] = ResolversParentTypes['StaffProfileInformation']> = {
  accountRole?: Resolver<ResolversTypes['Buddies'], ParentType, ContextType>;
  bio?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  department?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhoto?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffUserField'] = ResolversParentTypes['StaffUserField']> = {
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffUserFieldsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffUserFieldsField'] = ResolversParentTypes['StaffUserFieldsField']> = {
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaffUserListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaffUserListField'] = ResolversParentTypes['StaffUserListField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['StaffField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StateStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['StateStatField'] = ResolversParentTypes['StateStatField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubTopicFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubTopicField'] = ResolversParentTypes['SubTopicField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['TopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubTopicStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubTopicStatField'] = ResolversParentTypes['SubTopicStatField']> = {
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubTopicStatisticFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubTopicStatisticField'] = ResolversParentTypes['SubTopicStatisticField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionField'] = ResolversParentTypes['SuggestionField']> = {
  canonicalQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CanonicalQuestionField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sentence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topSubTopic?: Resolver<Maybe<ResolversTypes['TopSubTopicField']>, ParentType, ContextType>;
  topSubTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopSubTopicField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwitchUniversitiesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchUniversitiesField'] = ResolversParentTypes['SwitchUniversitiesField']> = {
  universities?: Resolver<Maybe<Array<Maybe<ResolversTypes['SwitchUniversityListField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwitchUniversityFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchUniversityField'] = ResolversParentTypes['SwitchUniversityField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  squareLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whiteLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwitchUniversityListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwitchUniversityListField'] = ResolversParentTypes['SwitchUniversityListField']> = {
  university?: Resolver<Maybe<ResolversTypes['SwitchUniversityField']>, ParentType, ContextType>;
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TagField'] = ResolversParentTypes['TagField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextInLocaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextInLocale'] = ResolversParentTypes['TextInLocale']> = {
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeTakenFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeTakenField'] = ResolversParentTypes['TimeTakenField']> = {
  totalTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TodoTargetAudienceResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodoTargetAudience'] = ResolversParentTypes['TodoTargetAudience']> = {
  __resolveType: TypeResolveFn<'Community', ParentType, ContextType>;
};

export type TodosEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodosEntity'] = ResolversParentTypes['TodosEntity']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TodoStatus'], ParentType, ContextType>;
  targetAudience?: Resolver<Array<ResolversTypes['TodoTargetAudience']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToggleCrmIntegrationSyncResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToggleCrmIntegrationSync'] = ResolversParentTypes['ToggleCrmIntegrationSync']> = {
  integration?: Resolver<Maybe<ResolversTypes['CRMIntegrationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToggleCustomAttributeCrmSyncMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToggleCustomAttributeCrmSyncMutation'] = ResolversParentTypes['ToggleCustomAttributeCrmSyncMutation']> = {
  customAttributeNewSyncStatus?: Resolver<Maybe<ResolversTypes['CrmFieldSyncStatus']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToggleDegreesActiveMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToggleDegreesActiveMutation'] = ResolversParentTypes['ToggleDegreesActiveMutation']> = {
  degrees?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToggleFeatureAvailabilityMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToggleFeatureAvailabilityMutation'] = ResolversParentTypes['ToggleFeatureAvailabilityMutation']> = {
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopCountryFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopCountryField'] = ResolversParentTypes['TopCountryField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopDegreeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopDegreeField'] = ResolversParentTypes['TopDegreeField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopDomesticRegionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopDomesticRegionField'] = ResolversParentTypes['TopDomesticRegionField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  domesticRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopRegionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopRegionField'] = ResolversParentTypes['TopRegionField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopSubTopicFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopSubTopicField'] = ResolversParentTypes['TopSubTopicField']> = {
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['TopTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopTopicFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopTopicField'] = ResolversParentTypes['TopTopicField']> = {
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicField'] = ResolversParentTypes['TopicField']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubTopicField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicSnippetField'] = ResolversParentTypes['TopicSnippetField']> = {
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['BlogTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicStatisticFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicStatisticField'] = ResolversParentTypes['TopicStatisticField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubTopicStatisticField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicsStatFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicsStatField'] = ResolversParentTypes['TopicsStatField']> = {
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subTopics?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubTopicStatField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrackLiveEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackLiveEventMutation'] = ResolversParentTypes['TrackLiveEventMutation']> = {
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrackOpenDayMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackOpenDayMutation'] = ResolversParentTypes['TrackOpenDayMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingTopicsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingTopicsField'] = ResolversParentTypes['TrendingTopicsField']> = {
  aggregatedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopicsStatField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfiguration'] = ResolversParentTypes['UniversityAssistantConfiguration']> = {
  eventUrls?: Resolver<Maybe<Array<ResolversTypes['UniversityAssistantConfigurationEventUrls']>>, ParentType, ContextType>;
  promptContext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scrapeIgnoreUrls?: Resolver<Maybe<Array<ResolversTypes['UniversityAssistantScrapeIgnoreUrls']>>, ParentType, ContextType>;
  scrapeScope?: Resolver<Maybe<ResolversTypes['ScrapeScope']>, ParentType, ContextType>;
  scrapeStartingPoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationEventOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfigurationEventOutput'] = ResolversParentTypes['UniversityAssistantConfigurationEventOutput']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationEventUrlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfigurationEventUrls'] = ResolversParentTypes['UniversityAssistantConfigurationEventUrls']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationPromptContextOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfigurationPromptContextOutput'] = ResolversParentTypes['UniversityAssistantConfigurationPromptContextOutput']> = {
  promptContext?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationScrapeIgnoreUrlsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfigurationScrapeIgnoreUrlsOutput'] = ResolversParentTypes['UniversityAssistantConfigurationScrapeIgnoreUrlsOutput']> = {
  scrapeIgnoreUrls?: Resolver<Array<ResolversTypes['UniversityAssistantScrapeIgnoreUrls']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConfigurationScrapeStartPointOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConfigurationScrapeStartPointOutput'] = ResolversParentTypes['UniversityAssistantConfigurationScrapeStartPointOutput']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scrapeScope?: Resolver<Maybe<ResolversTypes['ScrapeScope']>, ParentType, ContextType>;
  scrapeStartingPoint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantConversation'] = ResolversParentTypes['UniversityAssistantConversation']> = {
  conversationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityAssistantScrapeIgnoreUrlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityAssistantScrapeIgnoreUrls'] = ResolversParentTypes['UniversityAssistantScrapeIgnoreUrls']> = {
  ignoreSubpages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityBlockReportFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityBlockReportField'] = ResolversParentTypes['UniversityBlockReportField']> = {
  blocked?: Resolver<Maybe<ResolversTypes['ApplicantField']>, ParentType, ContextType>;
  blocker?: Resolver<Maybe<ResolversTypes['AnyUserField']>, ParentType, ContextType>;
  chatGroup?: Resolver<Maybe<ResolversTypes['ChatGroupField']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  triggeredFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityBlockUsersMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityBlockUsersMutation'] = ResolversParentTypes['UniversityBlockUsersMutation']> = {
  count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityBlogPostsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityBlogPostsField'] = ResolversParentTypes['UniversityBlogPostsField']> = {
  blogPostCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  blogPosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlogPostField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityChatInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityChatInboxField'] = ResolversParentTypes['UniversityChatInboxField']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['InboxItemLastMessageField']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatUserField']>>>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['InboxUniversityField']>, ParentType, ContextType>;
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityConfigFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityConfigField'] = ResolversParentTypes['UniversityConfigField']> = {
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityFeatureField']>>>, ParentType, ContextType>;
  featuresWithUniversityControl?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityFeatureField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityContent'] = ResolversParentTypes['UniversityContent']> = {
  hasContent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityFeatureFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityFeatureField'] = ResolversParentTypes['UniversityFeatureField']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enabledByUnibuddy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enabledByUniversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  feature?: Resolver<Maybe<ResolversTypes['FeatureField']>, ParentType, ContextType>;
  isReadOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  universityCanToggleFeature?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityField'] = ResolversParentTypes['UniversityField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowWelcomeMessageCustomization?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowWelcomeMessageCustomizationStaff?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buddiesListFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuddiesListFilterField']>>>, ParentType, ContextType>;
  chatboxUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  churned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  colour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['UniversityConfigField']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  customAttribute?: Resolver<Maybe<ResolversTypes['CustomAttributeField']>, ParentType, ContextType, Partial<UniversityFieldCustomAttributeArgs>>;
  customAttributeOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeOptionField']>>>, ParentType, ContextType, Partial<UniversityFieldCustomAttributeOptionsArgs>>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeField']>>>, ParentType, ContextType, Partial<UniversityFieldCustomAttributesArgs>>;
  customChatBubbleTextInLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['TextInLocale']>>>, ParentType, ContextType>;
  customMarketingConsentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customMarketingConsentTextInLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['TextInLocale']>>>, ParentType, ContextType>;
  customPreSignupText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customPreSignupTextInLocales?: Resolver<Maybe<Array<Maybe<ResolversTypes['TextInLocale']>>>, ParentType, ContextType>;
  defaultProspectWelcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultProspectWelcomeMessageStaff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degreeTypeOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['DegreeTypeOrderField']>>>, ParentType, ContextType>;
  domesticRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['DomesticRegionField']>>>, ParentType, ContextType>;
  entries?: Resolver<Maybe<ResolversTypes['EntriesField']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isEnterprise?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFeatureEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<UniversityFieldIsFeatureEnabledArgs>>;
  isFeatureReadOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<UniversityFieldIsFeatureReadOnlyArgs>>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReadyToLaunch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSyncedWithCrm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  launchDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localePreference?: Resolver<Maybe<ResolversTypes['Locale']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketplaces?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityMarketplaceField']>>>, ParentType, ContextType>;
  mentorFieldOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorFieldOrderField']>>>, ParentType, ContextType>;
  mentorListFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['MentorListFilterChoice']>>>, ParentType, ContextType>;
  mentorMessagesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onlineMentorAvatars?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  privacyPolicyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  segment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  squareLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whiteLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  widgetUrls?: Resolver<Maybe<Array<Maybe<ResolversTypes['WidgetUrlField']>>>, ParentType, ContextType, Partial<UniversityFieldWidgetUrlsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityInboxFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityInboxField'] = ResolversParentTypes['UniversityInboxField']> = {
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chatGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['ChatGroupField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityInterestedEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityInterestedEntity'] = ResolversParentTypes['UniversityInterestedEntity']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityMarketplaceFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityMarketplaceField'] = ResolversParentTypes['UniversityMarketplaceField']> = {
  allowProspectDataAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketingOptInWording?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tncWording?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityMarketplaceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityOutput'] = ResolversParentTypes['UniversityOutput']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isFeatureEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityQuestion'] = ResolversParentTypes['UniversityQuestion']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  answers?: Resolver<Array<ResolversTypes['UniversityQuestionAnswer']>, ParentType, ContextType, RequireFields<UniversityQuestionAnswersArgs, 'universityQuestionAnswerInput'>>;
  contexts?: Resolver<Array<ResolversTypes['UniversityQuestionContext']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  isMultipleAnswersAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  options?: Resolver<Maybe<Array<ResolversTypes['UniversityQuestionOption']>>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['UniversityQuestionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityQuestionAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityQuestionAnswer'] = ResolversParentTypes['UniversityQuestionAnswer']> = {
  answeredAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['UniversityQuestionContext']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityQuestionContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityQuestionContext'] = ResolversParentTypes['UniversityQuestionContext']> = {
  id?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityQuestionOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityQuestionOption'] = ResolversParentTypes['UniversityQuestionOption']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityScrapeIndexingOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityScrapeIndexingOutput'] = ResolversParentTypes['UniversityScrapeIndexingOutput']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  jobStatus?: Resolver<ResolversTypes['ScraperJobStatus'], ParentType, ContextType>;
  taskCompletedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  taskInFlightCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  taskQueuedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['UniversityScrapeTask']>, ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityScrapeOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityScrapeOutput'] = ResolversParentTypes['UniversityScrapeOutput']> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStatus?: Resolver<ResolversTypes['ScraperJobStatus'], ParentType, ContextType>;
  rootUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  started?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityScrapeStopOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityScrapeStopOutput'] = ResolversParentTypes['UniversityScrapeStopOutput']> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStatus?: Resolver<ResolversTypes['ScraperJobStatus'], ParentType, ContextType>;
  rootUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityScrapeTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityScrapeTask'] = ResolversParentTypes['UniversityScrapeTask']> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  depth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  httpStatus?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestDurationMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rootUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskStatus?: Resolver<ResolversTypes['ScraperTaskStatus'], ParentType, ContextType>;
  universityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversitySnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversitySnippetField'] = ResolversParentTypes['UniversitySnippetField']> = {
  blogcardSnippets?: Resolver<Maybe<ResolversTypes['BlogcardSnippetField']>, ParentType, ContextType>;
  carouselWidgetSnippets?: Resolver<Maybe<ResolversTypes['CarouselSnippetField']>, ParentType, ContextType>;
  courseWidgetSnippets?: Resolver<Maybe<ResolversTypes['CourseSnippetField']>, ParentType, ContextType>;
  embeddedEventSnippet?: Resolver<Maybe<ResolversTypes['EmbeddedEventSnippetField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mentorcardExternalSnippets?: Resolver<Maybe<ResolversTypes['MentorcardSnippetField']>, ParentType, ContextType>;
  mentorcardInternalSnippets?: Resolver<Maybe<ResolversTypes['MentorcardSnippetField']>, ParentType, ContextType>;
  popcardSnippets?: Resolver<Maybe<ResolversTypes['PopcardSnippetField']>, ParentType, ContextType>;
  staffBuddycardExternalSnippet?: Resolver<Maybe<ResolversTypes['StaffBuddycardSnippetField']>, ParentType, ContextType>;
  staffBuddycardInternalSnippet?: Resolver<Maybe<ResolversTypes['StaffBuddycardSnippetField']>, ParentType, ContextType>;
  staffPopcardSnippet?: Resolver<Maybe<ResolversTypes['StaffPopcardSnippetField']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  widgetSnippet?: Resolver<Maybe<ResolversTypes['WidgetSnippetField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityUserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityUserField'] = ResolversParentTypes['UniversityUserField']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['GroupField']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['UniversityUserPreferencesField']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityUserPreferencesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityUserPreferencesField'] = ResolversParentTypes['UniversityUserPreferencesField']> = {
  newMessageNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnpinMessageMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnpinMessageMutation'] = ResolversParentTypes['UnpinMessageMutation']> = {
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnreadCountFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnreadCountField'] = ResolversParentTypes['UnreadCountField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnreadMessageCountFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnreadMessageCountField'] = ResolversParentTypes['UnreadMessageCountField']> = {
  unreadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateApplicantMutation'] = ResolversParentTypes['UpdateApplicantMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicantPreferencesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateApplicantPreferencesMutation'] = ResolversParentTypes['UpdateApplicantPreferencesMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCanonicalQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCanonicalQuestion'] = ResolversParentTypes['UpdateCanonicalQuestion']> = {
  canonicalQuestion?: Resolver<Maybe<ResolversTypes['CanonicalQuestionField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCommunityApplicantSignupSourceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCommunityApplicantSignupSourceMutation'] = ResolversParentTypes['UpdateCommunityApplicantSignupSourceMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDirectMessagingMembersForLiveEventMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDirectMessagingMembersForLiveEventMutation'] = ResolversParentTypes['UpdateDirectMessagingMembersForLiveEventMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEvent?: Resolver<Maybe<ResolversTypes['LiveEventField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFaqAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateFaqAnswer'] = ResolversParentTypes['UpdateFaqAnswer']> = {
  faqAnswer?: Resolver<Maybe<ResolversTypes['FaqAnswerField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateHobsonsConnectIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateHobsonsConnectIntegration'] = ResolversParentTypes['UpdateHobsonsConnectIntegration']> = {
  integration?: Resolver<Maybe<ResolversTypes['CampusManagementConnectIntegrationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateIntegrationFieldMappingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateIntegrationFieldMapping'] = ResolversParentTypes['UpdateIntegrationFieldMapping']> = {
  integration?: Resolver<Maybe<ResolversTypes['CRMIntegrationField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateLiveEventFeedSessionDataMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateLiveEventFeedSessionDataMutation'] = ResolversParentTypes['UpdateLiveEventFeedSessionDataMutation']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveEventsFormFieldValidationError']>>>, ParentType, ContextType>;
  liveEventFeed?: Resolver<Maybe<ResolversTypes['LiveEventChatGroupField']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateManyUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateManyUserMutation'] = ResolversParentTypes['UpdateManyUserMutation']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMarketplaceApplicantMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMarketplaceApplicantMutation'] = ResolversParentTypes['UpdateMarketplaceApplicantMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMarketplaceApplicantUniversityLinkMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMarketplaceApplicantUniversityLinkMutation'] = ResolversParentTypes['UpdateMarketplaceApplicantUniversityLinkMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMarketplaceMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMarketplaceMutation'] = ResolversParentTypes['UpdateMarketplaceMutation']> = {
  marketplace?: Resolver<Maybe<ResolversTypes['MarketplaceField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMentorMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMentorMutation'] = ResolversParentTypes['UpdateMentorMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMentorPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMentorPreferences'] = ResolversParentTypes['UpdateMentorPreferences']> = {
  preferences?: Resolver<Maybe<ResolversTypes['MentorPreferencesField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMyUniversityLinkMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMyUniversityLinkMutation'] = ResolversParentTypes['UpdateMyUniversityLinkMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePostStatusMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePostStatusMutation'] = ResolversParentTypes['UpdatePostStatusMutation']> = {
  blogPost?: Resolver<Maybe<ResolversTypes['BlogPostField']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateResearchTimeMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateResearchTimeMutation'] = ResolversParentTypes['UpdateResearchTimeMutation']> = {
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateStaffMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStaffMutation'] = ResolversParentTypes['UpdateStaffMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSubTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSubTopicMutation'] = ResolversParentTypes['UpdateSubTopicMutation']> = {
  subTopic?: Resolver<Maybe<ResolversTypes['SubTopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTagMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTagMutation'] = ResolversParentTypes['UpdateTagMutation']> = {
  tag?: Resolver<Maybe<ResolversTypes['TagField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTopicMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateTopicMutation'] = ResolversParentTypes['UpdateTopicMutation']> = {
  topic?: Resolver<Maybe<ResolversTypes['TopicField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUniversityBlockReportMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUniversityBlockReportMutation'] = ResolversParentTypes['UpdateUniversityBlockReportMutation']> = {
  universityBlockReport?: Resolver<Maybe<ResolversTypes['UniversityBlockReportField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUniversityConfigMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUniversityConfigMutation'] = ResolversParentTypes['UpdateUniversityConfigMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  universityConfiguration?: Resolver<Maybe<ResolversTypes['CrmServiceUniversityConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUniversityUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUniversityUserMutation'] = ResolversParentTypes['UpdateUniversityUserMutation']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUniversityUserPreferencesMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUniversityUserPreferencesMutation'] = ResolversParentTypes['UpdateUniversityUserPreferencesMutation']> = {
  me?: Resolver<Maybe<ResolversTypes['MeField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserMutation'] = ResolversParentTypes['UpdateUserMutation']> = {
  user?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserPreferences'] = ResolversParentTypes['UpdateUserPreferences']> = {
  preferences?: Resolver<Maybe<ResolversTypes['UserPreferencesField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatedResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatedResults'] = ResolversParentTypes['UpdatedResults']> = {
  acknowledged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  matchedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  modifiedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  upsertedCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  upsertedId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserCustomAttributesFilterFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCustomAttributesFilterField'] = ResolversParentTypes['UserCustomAttributesFilterField']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDecisionStageOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDecisionStageOutput'] = ResolversParentTypes['UserDecisionStageOutput']> = {
  decisionStage?: Resolver<ResolversTypes['DecisionStageEnum'], ParentType, ContextType>;
  decisionStageLocation?: Resolver<ResolversTypes['DecisionStageLocationEnum'], ParentType, ContextType>;
  notInterestedReason?: Resolver<Maybe<ResolversTypes['NotInterestedReasonEnum']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDegreeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDegreeField'] = ResolversParentTypes['UserDegreeField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDirectoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDirectoryResult'] = ResolversParentTypes['UserDirectoryResult']> = {
  result?: Resolver<Array<ResolversTypes['UserField']>, ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserField'] = ResolversParentTypes['UserField']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockedByMentors?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlockerField']>>>, ParentType, ContextType>;
  blockedByUniversities?: Resolver<Maybe<Array<Maybe<ResolversTypes['UniversityField']>>>, ParentType, ContextType>;
  chatGroupCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chatIntro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communities?: Resolver<Maybe<Array<ResolversTypes['Community']>>, ParentType, ContextType>;
  communityProfile?: Resolver<Maybe<ResolversTypes['UserProfile']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryField']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  customAttributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomAttributeValueField']>>>, ParentType, ContextType, Partial<UserFieldCustomAttributesArgs>>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['GroupField']>>>, ParentType, ContextType>;
  hasUnansweredConversation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Array<ResolversTypes['Interest']>, ParentType, ContextType>;
  isOnline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<Array<Maybe<ResolversTypes['LanguageField']>>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['UserPreferencesField']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<UserFieldProfilePhotoArgs>>;
  prospectWelcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedUnansweredConversations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shareUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smudged?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  staffFields?: Resolver<Maybe<ResolversTypes['StaffUserFieldsField']>, ParentType, ContextType>;
  stageOneComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stageTwoComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unansweredCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['UniversityField']>, ParentType, ContextType>;
  unreadMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserIdsListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIdsListField'] = ResolversParentTypes['UserIdsListField']> = {
  ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInterestResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInterest'] = ResolversParentTypes['UserInterest']> = {
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserListField'] = ResolversParentTypes['UserListField']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLocalePreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLocalePreference'] = ResolversParentTypes['UserLocalePreference']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPartialSearchFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPartialSearchFields'] = ResolversParentTypes['UserPartialSearchFields']> = {
  accountRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  concatenatedFields?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPermissionsListFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPermissionsListField'] = ResolversParentTypes['UserPermissionsListField']> = {
  permissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPreferencesFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPreferencesField'] = ResolversParentTypes['UserPreferencesField']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newMessageNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProfile'] = ResolversParentTypes['UserProfile']> = {
  areaOfStudy?: Resolver<Maybe<Array<ResolversTypes['DegreeField']>>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communities?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  housing?: Resolver<Maybe<ResolversTypes['HousingObject']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interests?: Resolver<Maybe<Array<ResolversTypes['InterestObject']>>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pronouns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRecommendationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRecommendation'] = ResolversParentTypes['UserRecommendation']> = {
  currentUser?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  matches?: Resolver<Array<ResolversTypes['MatchedUser']>, ParentType, ContextType>;
  totalMatches?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserReport'] = ResolversParentTypes['UserReport']> = {
  actionTaken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  community?: Resolver<Maybe<ResolversTypes['Community']>, ParentType, ContextType>;
  creationTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  moderationTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  moderator?: Resolver<Maybe<ResolversTypes['UserField']>, ParentType, ContextType>;
  moderatorComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modificationTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  reportee?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  reporter?: Resolver<ResolversTypes['UserField'], ParentType, ContextType>;
  reporterComment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reporterReason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTimeSheetExportFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTimeSheetExportField'] = ResolversParentTypes['UserTimeSheetExportField']> = {
  blogs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degreeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  research?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalTimeSpent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTimeSpentBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTimeSpentBreakdown'] = ResolversParentTypes['UserTimeSpentBreakdown']> = {
  blogs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  research?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalTimeSpent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserTimeSpentStatsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserTimeSpentStatsField'] = ResolversParentTypes['UserTimeSpentStatsField']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  blogs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  degree?: Resolver<Maybe<ResolversTypes['UserDegreeField']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveEvents?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profilePhotoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  research?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalTimeSpent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersTimeSpentDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersTimeSpentData'] = ResolversParentTypes['UsersTimeSpentData']> = {
  userCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  userTimeStats?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserTimeSpentStatsField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyAccount'] = ResolversParentTypes['VerifyAccount']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerifyCodeFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerifyCodeField'] = ResolversParentTypes['VerifyCodeField']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoContent'] = ResolversParentTypes['VideoContent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VideoStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VideoTypeEnum'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['VideoUrl'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoFile'] = ResolversParentTypes['VideoFile']> = {
  end?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fileIndex?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordingNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  splitNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoSessionFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoSessionField'] = ResolversParentTypes['VideoSessionField']> = {
  coverS3Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoUploadLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoUploadLink'] = ResolversParentTypes['VideoUploadLink']> = {
  fields?: Resolver<Array<ResolversTypes['VideoUploadPresignedFields']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoUploadPresignedFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoUploadPresignedFields'] = ResolversParentTypes['VideoUploadPresignedFields']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoUrl'] = ResolversParentTypes['VideoUrl']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewBlogMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewBlogMutation'] = ResolversParentTypes['ViewBlogMutation']> = {
  post?: Resolver<Maybe<ResolversTypes['BlogPostField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualEvent'] = ResolversParentTypes['VirtualEvent']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  university?: Resolver<ResolversTypes['UniversityField'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetSnippetFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['WidgetSnippetField'] = ResolversParentTypes['WidgetSnippetField']> = {
  description?: Resolver<Maybe<ResolversTypes['DescriptionField']>, ParentType, ContextType>;
  embeddedEventSnippet?: Resolver<Maybe<ResolversTypes['EmbeddedEventSnippetField']>, ParentType, ContextType>;
  snippet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WidgetUrlFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['WidgetUrlField'] = ResolversParentTypes['WidgetUrlField']> = {
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WillReplyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['WillReplyField'] = ResolversParentTypes['WillReplyField']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dismissed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mobileAdded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YearOfStudyFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['YearOfStudyField'] = ResolversParentTypes['YearOfStudyField']> = {
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  degreeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActivateApplicantsMutation?: ActivateApplicantsMutationResolvers<ContextType>;
  ActivateMentorsMutation?: ActivateMentorsMutationResolvers<ContextType>;
  ActivityField?: ActivityFieldResolvers<ContextType>;
  ActivitySourceField?: ActivitySourceFieldResolvers<ContextType>;
  AddAttributeOptionMutation?: AddAttributeOptionMutationResolvers<ContextType>;
  AddBotToChatGroupMutation?: AddBotToChatGroupMutationResolvers<ContextType>;
  AddCustomAttributeMutation?: AddCustomAttributeMutationResolvers<ContextType>;
  AddDegreeLevelsMutation?: AddDegreeLevelsMutationResolvers<ContextType>;
  AddDegreesMutation?: AddDegreesMutationResolvers<ContextType>;
  AddHobsonsConnectIntegration?: AddHobsonsConnectIntegrationResolvers<ContextType>;
  AddLocalesToApp?: AddLocalesToAppResolvers<ContextType>;
  AddResearchTimeMutation?: AddResearchTimeMutationResolvers<ContextType>;
  AddYearOfStudyMutation?: AddYearOfStudyMutationResolvers<ContextType>;
  AdminDeleteApplicantMutation?: AdminDeleteApplicantMutationResolvers<ContextType>;
  AdminRecommendation?: AdminRecommendationResolvers<ContextType>;
  AdminRecommendationCountPerDecisionStage?: AdminRecommendationCountPerDecisionStageResolvers<ContextType>;
  AdminUpdateMentorMutation?: AdminUpdateMentorMutationResolvers<ContextType>;
  AdminUserField?: AdminUserFieldResolvers<ContextType>;
  AgeVerificationInfoField?: AgeVerificationInfoFieldResolvers<ContextType>;
  AlertField?: AlertFieldResolvers<ContextType>;
  AllPostsField?: AllPostsFieldResolvers<ContextType>;
  AmbassadorField?: AmbassadorFieldResolvers<ContextType>;
  AmbassadorProfileInformation?: AmbassadorProfileInformationResolvers<ContextType>;
  AmbassadorRecommendation?: AmbassadorRecommendationResolvers<ContextType>;
  AmbassadorRecommendationResourceType?: AmbassadorRecommendationResourceTypeResolvers<ContextType>;
  Analytics?: AnalyticsResolvers<ContextType>;
  AnalyticsBuddyField?: AnalyticsBuddyFieldResolvers<ContextType>;
  AnalyticsDashboardAuthField?: AnalyticsDashboardAuthFieldResolvers<ContextType>;
  AnalyticsMentorField?: AnalyticsMentorFieldResolvers<ContextType>;
  AnyChatUserField?: AnyChatUserFieldResolvers<ContextType>;
  AnyUserField?: AnyUserFieldResolvers<ContextType>;
  AppLocaleField?: AppLocaleFieldResolvers<ContextType>;
  ApplicantBroadcastMessageMutation?: ApplicantBroadcastMessageMutationResolvers<ContextType>;
  ApplicantCollectionField?: ApplicantCollectionFieldResolvers<ContextType>;
  ApplicantConversationField?: ApplicantConversationFieldResolvers<ContextType>;
  ApplicantCountField?: ApplicantCountFieldResolvers<ContextType>;
  ApplicantField?: ApplicantFieldResolvers<ContextType>;
  ApplicantInboxField?: ApplicantInboxFieldResolvers<ContextType>;
  ApplicantInvite?: ApplicantInviteResolvers<ContextType>;
  ApplicantLabelField?: ApplicantLabelFieldResolvers<ContextType>;
  ApplicantMarketplaceObjectField?: ApplicantMarketplaceObjectFieldResolvers<ContextType>;
  ApplicantPreferencesField?: ApplicantPreferencesFieldResolvers<ContextType>;
  ApplicantSchoolHistory?: ApplicantSchoolHistoryResolvers<ContextType>;
  ApplicantSignupStats?: ApplicantSignupStatsResolvers<ContextType>;
  ApplicantUniversityLinkField?: ApplicantUniversityLinkFieldResolvers<ContextType>;
  ApplicantUserField?: ApplicantUserFieldResolvers<ContextType>;
  ApplicantsAppliedStats?: ApplicantsAppliedStatsResolvers<ContextType>;
  ApplicantsMessagedCount?: ApplicantsMessagedCountResolvers<ContextType>;
  ApplicationField?: ApplicationFieldResolvers<ContextType>;
  ApplicationInsightModel?: ApplicationInsightModelResolvers<ContextType>;
  AppliedUsersCountModel?: AppliedUsersCountModelResolvers<ContextType>;
  AssistantConversationFeedback?: AssistantConversationFeedbackResolvers<ContextType>;
  AssistantConversationHistory?: AssistantConversationHistoryResolvers<ContextType>;
  AssistantConversationHistoryWithToken?: AssistantConversationHistoryWithTokenResolvers<ContextType>;
  AssistantConversationLead?: AssistantConversationLeadResolvers<ContextType>;
  AssistantConversationMessage?: AssistantConversationMessageResolvers<ContextType>;
  AssistantMessageFeedback?: AssistantMessageFeedbackResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  AttachmentField?: AttachmentFieldResolvers<ContextType>;
  AttendeeAnalytics?: AttendeeAnalyticsResolvers<ContextType>;
  Attendees?: AttendeesResolvers<ContextType>;
  AuthField?: AuthFieldResolvers<ContextType>;
  AuthorSnippetField?: AuthorSnippetFieldResolvers<ContextType>;
  BaseCustomAttributeField?: BaseCustomAttributeFieldResolvers<ContextType>;
  BlockUserMutation?: BlockUserMutationResolvers<ContextType>;
  BlockUserMutationV2?: BlockUserMutationV2Resolvers<ContextType>;
  BlockerField?: BlockerFieldResolvers<ContextType>;
  BlogCommentField?: BlogCommentFieldResolvers<ContextType>;
  BlogPostField?: BlogPostFieldResolvers<ContextType>;
  BlogTopicField?: BlogTopicFieldResolvers<ContextType>;
  BlogcardSnippetField?: BlogcardSnippetFieldResolvers<ContextType>;
  BotUserField?: BotUserFieldResolvers<ContextType>;
  BuddiesField?: BuddiesFieldResolvers<ContextType>;
  BuddiesFilterOptionsField?: BuddiesFilterOptionsFieldResolvers<ContextType>;
  BuddiesListFilterField?: BuddiesListFilterFieldResolvers<ContextType>;
  BuddyApplicantChatGroupField?: BuddyApplicantChatGroupFieldResolvers<ContextType>;
  BuddyApplicantChatGroupFieldV2?: BuddyApplicantChatGroupFieldV2Resolvers<ContextType>;
  BuddyApplicantChatInterventionBuddyField?: BuddyApplicantChatInterventionBuddyFieldResolvers<ContextType>;
  BuddyField?: BuddyFieldResolvers<ContextType>;
  BuddyInviteField?: BuddyInviteFieldResolvers<ContextType>;
  BuddyInviteListField?: BuddyInviteListFieldResolvers<ContextType>;
  BulkApplicantField?: BulkApplicantFieldResolvers<ContextType>;
  BulkOptOutMarketplaceUniversityMarketingMutation?: BulkOptOutMarketplaceUniversityMarketingMutationResolvers<ContextType>;
  ButtonField?: ButtonFieldResolvers<ContextType>;
  CRMApplicantField?: CrmApplicantFieldResolvers<ContextType>;
  CRMField?: CrmFieldResolvers<ContextType>;
  CRMIntegrationField?: CrmIntegrationFieldResolvers<ContextType>;
  CRMMetaDataField?: CrmMetaDataFieldResolvers<ContextType>;
  CSVUploadAmbassadorFieldsMutation?: CsvUploadAmbassadorFieldsMutationResolvers<ContextType>;
  CSVUploadApplicantsMutation?: CsvUploadApplicantsMutationResolvers<ContextType>;
  CampusManagementConnectIntegrationField?: CampusManagementConnectIntegrationFieldResolvers<ContextType>;
  CanonicalQuestionField?: CanonicalQuestionFieldResolvers<ContextType>;
  CarouselSnippetField?: CarouselSnippetFieldResolvers<ContextType>;
  ChatConversation?: ChatConversationResolvers<ContextType>;
  ChatGroupAndMessages?: ChatGroupAndMessagesResolvers<ContextType>;
  ChatGroupAuxiliaryField?: ChatGroupAuxiliaryFieldResolvers<ContextType>;
  ChatGroupField?: ChatGroupFieldResolvers<ContextType>;
  ChatGroupLabelField?: ChatGroupLabelFieldResolvers<ContextType>;
  ChatInboxField?: ChatInboxFieldResolvers<ContextType>;
  ChatMessage?: ChatMessageResolvers<ContextType>;
  ChatPermission?: ChatPermissionResolvers<ContextType>;
  ChatReport?: ChatReportResolvers<ContextType>;
  ChatRoom?: ChatRoomResolvers<ContextType>;
  ChatRoomAnalytics?: ChatRoomAnalyticsResolvers<ContextType>;
  ChatRoomAttendeeAnalytics?: ChatRoomAttendeeAnalyticsResolvers<ContextType>;
  ChatRoomAttendees?: ChatRoomAttendeesResolvers<ContextType>;
  ChatSummaryField?: ChatSummaryFieldResolvers<ContextType>;
  ChatUserField?: ChatUserFieldResolvers<ContextType>;
  CheckEmailMutation?: CheckEmailMutationResolvers<ContextType>;
  ChildOrganisationField?: ChildOrganisationFieldResolvers<ContextType>;
  ClassificationField?: ClassificationFieldResolvers<ContextType>;
  CloneLiveEventAndChannelsMutation?: CloneLiveEventAndChannelsMutationResolvers<ContextType>;
  Cohort?: CohortResolvers<ContextType>;
  CommentMutation?: CommentMutationResolvers<ContextType>;
  Community?: CommunityResolvers<ContextType>;
  CommunityChatGroup?: CommunityChatGroupResolvers<ContextType>;
  CommunityField?: CommunityFieldResolvers<ContextType>;
  CommunityInviteResponse?: CommunityInviteResponseResolvers<ContextType>;
  CommunityInvites?: CommunityInvitesResolvers<ContextType>;
  CommunityJoinResponse?: CommunityJoinResponseResolvers<ContextType>;
  CompletedEvent?: CompletedEventResolvers<ContextType>;
  CompletedEventsOverview?: CompletedEventsOverviewResolvers<ContextType>;
  ContentBriefField?: ContentBriefFieldResolvers<ContextType>;
  Context?: ContextResolvers<ContextType>;
  ConversationContextChatGroupField?: ConversationContextChatGroupFieldResolvers<ContextType>;
  ConversationContextField?: ConversationContextFieldResolvers<ContextType>;
  ConversationInbox?: ConversationInboxResolvers<ContextType>;
  ConversationTag?: ConversationTagResolvers<ContextType>;
  CookieConsentOutputDTO?: CookieConsentOutputDtoResolvers<ContextType>;
  CountPerEpoch?: CountPerEpochResolvers<ContextType>;
  CountryAnalyticsValue?: CountryAnalyticsValueResolvers<ContextType>;
  CountryField?: CountryFieldResolvers<ContextType>;
  CountrySnippetField?: CountrySnippetFieldResolvers<ContextType>;
  CountryStatField?: CountryStatFieldResolvers<ContextType>;
  CourseSnippetField?: CourseSnippetFieldResolvers<ContextType>;
  CreateAlertMutation?: CreateAlertMutationResolvers<ContextType>;
  CreateApplicantMutation?: CreateApplicantMutationResolvers<ContextType>;
  CreateApplicantMutationV2?: CreateApplicantMutationV2Resolvers<ContextType>;
  CreateBlogTopicMutation?: CreateBlogTopicMutationResolvers<ContextType>;
  CreateBuddyMutation?: CreateBuddyMutationResolvers<ContextType>;
  CreateCanonicalQuestion?: CreateCanonicalQuestionResolvers<ContextType>;
  CreateCommunityApplicantMutation?: CreateCommunityApplicantMutationResolvers<ContextType>;
  CreateCommunityApplicantMutationV2?: CreateCommunityApplicantMutationV2Resolvers<ContextType>;
  CreateCrmServiceUniversityConfigMutation?: CreateCrmServiceUniversityConfigMutationResolvers<ContextType>;
  CreateExternalEventMutation?: CreateExternalEventMutationResolvers<ContextType>;
  CreateFaqAnswer?: CreateFaqAnswerResolvers<ContextType>;
  CreateFresherMutation?: CreateFresherMutationResolvers<ContextType>;
  CreateLiveEventDetailsMutation?: CreateLiveEventDetailsMutationResolvers<ContextType>;
  CreateLiveEventFeedMutation?: CreateLiveEventFeedMutationResolvers<ContextType>;
  CreateLiveEventFeedSessionsMutation?: CreateLiveEventFeedSessionsMutationResolvers<ContextType>;
  CreateLiveEventMutation?: CreateLiveEventMutationResolvers<ContextType>;
  CreateMarketplaceApplicantMutation?: CreateMarketplaceApplicantMutationResolvers<ContextType>;
  CreateMarketplaceMutation?: CreateMarketplaceMutationResolvers<ContextType>;
  CreateMentorMutation?: CreateMentorMutationResolvers<ContextType>;
  CreateOpenDayMutation?: CreateOpenDayMutationResolvers<ContextType>;
  CreateOrganisationBuddyLinkMutation?: CreateOrganisationBuddyLinkMutationResolvers<ContextType>;
  CreateOrganisationMutation?: CreateOrganisationMutationResolvers<ContextType>;
  CreatePostMutation?: CreatePostMutationResolvers<ContextType>;
  CreateSubTopicMutation?: CreateSubTopicMutationResolvers<ContextType>;
  CreateTagMutation?: CreateTagMutationResolvers<ContextType>;
  CreateTopicMutation?: CreateTopicMutationResolvers<ContextType>;
  CreateUniversityBlockReportMutation?: CreateUniversityBlockReportMutationResolvers<ContextType>;
  CreateUniversityMutation?: CreateUniversityMutationResolvers<ContextType>;
  CreateUniversityUserMutation?: CreateUniversityUserMutationResolvers<ContextType>;
  CreateUserMutation?: CreateUserMutationResolvers<ContextType>;
  CreationSource?: CreationSourceResolvers<ContextType>;
  CrmApplicantRecordField?: CrmApplicantRecordFieldResolvers<ContextType>;
  CrmAttributeField?: CrmAttributeFieldResolvers<ContextType>;
  CrmConnectionField?: CrmConnectionFieldResolvers<ContextType>;
  CrmDataField?: CrmDataFieldResolvers<ContextType>;
  CrmFieldSyncStatus?: CrmFieldSyncStatusResolvers<ContextType>;
  CrmServiceUniversityConfig?: CrmServiceUniversityConfigResolvers<ContextType>;
  CrmSyncJobField?: CrmSyncJobFieldResolvers<ContextType>;
  CurrentDecisionStageOutput?: CurrentDecisionStageOutputResolvers<ContextType>;
  CustomAttributeField?: CustomAttributeFieldResolvers<ContextType>;
  CustomAttributeOptionField?: CustomAttributeOptionFieldResolvers<ContextType>;
  CustomAttributeValueField?: CustomAttributeValueFieldResolvers<ContextType>;
  CustomAttributesField?: CustomAttributesFieldResolvers<ContextType>;
  CustomAttributesFilterField?: CustomAttributesFilterFieldResolvers<ContextType>;
  CustomAttributesFilterOptionField?: CustomAttributesFilterOptionFieldResolvers<ContextType>;
  DataFormatConfig?: DataFormatConfigResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DateValueField?: DateValueFieldResolvers<ContextType>;
  DeactivateApplicantsMutation?: DeactivateApplicantsMutationResolvers<ContextType>;
  DeactivateMentorsMutation?: DeactivateMentorsMutationResolvers<ContextType>;
  DefaultQuestionsField?: DefaultQuestionsFieldResolvers<ContextType>;
  DegreeCategoriesAnalyticsValue?: DegreeCategoriesAnalyticsValueResolvers<ContextType>;
  DegreeCategoryField?: DegreeCategoryFieldResolvers<ContextType>;
  DegreeCategoryParentField?: DegreeCategoryParentFieldResolvers<ContextType>;
  DegreeChatUserField?: DegreeChatUserFieldResolvers<ContextType>;
  DegreeField?: DegreeFieldResolvers<ContextType>;
  DegreeLevelField?: DegreeLevelFieldResolvers<ContextType>;
  DegreeSnippetField?: DegreeSnippetFieldResolvers<ContextType>;
  DegreeStatField?: DegreeStatFieldResolvers<ContextType>;
  DegreeTypeOrderField?: DegreeTypeOrderFieldResolvers<ContextType>;
  DeleteApplicantMutation?: DeleteApplicantMutationResolvers<ContextType>;
  DeleteAttributeOptionsMutation?: DeleteAttributeOptionsMutationResolvers<ContextType>;
  DeleteCanonicalQuestion?: DeleteCanonicalQuestionResolvers<ContextType>;
  DeleteCustomAttributesMutation?: DeleteCustomAttributesMutationResolvers<ContextType>;
  DeleteDegreeLevelMutation?: DeleteDegreeLevelMutationResolvers<ContextType>;
  DeleteFaqAnswer?: DeleteFaqAnswerResolvers<ContextType>;
  DeleteKnowledgeBaseEntriesOutput?: DeleteKnowledgeBaseEntriesOutputResolvers<ContextType>;
  DeleteLiveEventFeedMutation?: DeleteLiveEventFeedMutationResolvers<ContextType>;
  DeleteLiveEventMessageMutation?: DeleteLiveEventMessageMutationResolvers<ContextType>;
  DeleteLiveEventMutation?: DeleteLiveEventMutationResolvers<ContextType>;
  DeletePostMutation?: DeletePostMutationResolvers<ContextType>;
  DeleteRecordingResponse?: DeleteRecordingResponseResolvers<ContextType>;
  DeleteResearchTimeMutation?: DeleteResearchTimeMutationResolvers<ContextType>;
  DeleteSubTopicMutation?: DeleteSubTopicMutationResolvers<ContextType>;
  DeleteTopicMutation?: DeleteTopicMutationResolvers<ContextType>;
  DeleteUniversityUserMutation?: DeleteUniversityUserMutationResolvers<ContextType>;
  DeleteUserMutation?: DeleteUserMutationResolvers<ContextType>;
  DeleteYearOfStudyMutation?: DeleteYearOfStudyMutationResolvers<ContextType>;
  DepartmentSnippetField?: DepartmentSnippetFieldResolvers<ContextType>;
  DescriptionField?: DescriptionFieldResolvers<ContextType>;
  DeviceField?: DeviceFieldResolvers<ContextType>;
  DeviceMutation?: DeviceMutationResolvers<ContextType>;
  DeviceToken?: DeviceTokenResolvers<ContextType>;
  DirectMessagingApplicant?: DirectMessagingApplicantResolvers<ContextType>;
  DirectMessagingEnquiryTeam?: DirectMessagingEnquiryTeamResolvers<ContextType>;
  DirectMessagingMentor?: DirectMessagingMentorResolvers<ContextType>;
  DirectMessagingStaffMember?: DirectMessagingStaffMemberResolvers<ContextType>;
  Display?: DisplayResolvers<ContextType>;
  DomesticRegionField?: DomesticRegionFieldResolvers<ContextType>;
  EditAlertMutation?: EditAlertMutationResolvers<ContextType>;
  EditAttributeOptionMutation?: EditAttributeOptionMutationResolvers<ContextType>;
  EditBlogTopicMutation?: EditBlogTopicMutationResolvers<ContextType>;
  EditCustomAttributeMutation?: EditCustomAttributeMutationResolvers<ContextType>;
  EditCustomAttributesMutation?: EditCustomAttributesMutationResolvers<ContextType>;
  EditCustomWelcomeMessageMutation?: EditCustomWelcomeMessageMutationResolvers<ContextType>;
  EditDegreeLevelMutation?: EditDegreeLevelMutationResolvers<ContextType>;
  EditDegreeNameMutation?: EditDegreeNameMutationResolvers<ContextType>;
  EditDegreesMutation?: EditDegreesMutationResolvers<ContextType>;
  EditExternalEventMutation?: EditExternalEventMutationResolvers<ContextType>;
  EditLiveEventDetailsMutation?: EditLiveEventDetailsMutationResolvers<ContextType>;
  EditLiveEventFeedMutation?: EditLiveEventFeedMutationResolvers<ContextType>;
  EditLiveEventMutation?: EditLiveEventMutationResolvers<ContextType>;
  EditLiveEventsLandingPageMutation?: EditLiveEventsLandingPageMutationResolvers<ContextType>;
  EditOpenDayMutation?: EditOpenDayMutationResolvers<ContextType>;
  EditOrganisationMutation?: EditOrganisationMutationResolvers<ContextType>;
  EditPostMutation?: EditPostMutationResolvers<ContextType>;
  EditUniversityMutation?: EditUniversityMutationResolvers<ContextType>;
  EditYearOfStudyMutation?: EditYearOfStudyMutationResolvers<ContextType>;
  EmbeddedEventField?: EmbeddedEventFieldResolvers<ContextType>;
  EmbeddedEventSnippetField?: EmbeddedEventSnippetFieldResolvers<ContextType>;
  EnableCustomWelcomeMessageMutation?: EnableCustomWelcomeMessageMutationResolvers<ContextType>;
  EnableCustomWelcomeMessageStaffMutation?: EnableCustomWelcomeMessageStaffMutationResolvers<ContextType>;
  EnableFeaturesMutation?: EnableFeaturesMutationResolvers<ContextType>;
  EnrolledInsightResponse?: EnrolledInsightResponseResolvers<ContextType>;
  EnterpriseAddOns?: EnterpriseAddOnsResolvers<ContextType>;
  EnterpriseMentorField?: EnterpriseMentorFieldResolvers<ContextType>;
  EntriesField?: EntriesFieldResolvers<ContextType>;
  EventPage?: EventPageResolvers<ContextType>;
  EventPagesDisplayedOn?: EventPagesDisplayedOnResolvers<ContextType>;
  ExportAnalyticsCsvMutation?: ExportAnalyticsCsvMutationResolvers<ContextType>;
  ExportTimeSheetDataField?: ExportTimeSheetDataFieldResolvers<ContextType>;
  ExportedReportField?: ExportedReportFieldResolvers<ContextType>;
  ExternalContent?: ExternalContentResolvers<ContextType>;
  ExternalEventField?: ExternalEventFieldResolvers<ContextType>;
  FaqAnswerField?: FaqAnswerFieldResolvers<ContextType>;
  FeatureField?: FeatureFieldResolvers<ContextType>;
  FeatureRulesDTO?: FeatureRulesDtoResolvers<ContextType>;
  FieldMappingField?: FieldMappingFieldResolvers<ContextType>;
  FlagField?: FlagFieldResolvers<ContextType>;
  FormFieldValidationError?: FormFieldValidationErrorResolvers<ContextType>;
  ForwardApplicantToUniversity?: ForwardApplicantToUniversityResolvers<ContextType>;
  GeckoUniversityData?: GeckoUniversityDataResolvers<ContextType>;
  GenerateAnalyticsDashboardTokenMutation?: GenerateAnalyticsDashboardTokenMutationResolvers<ContextType>;
  GenerateLiveEventReport?: GenerateLiveEventReportResolvers<ContextType>;
  GenericScalar?: GraphQLScalarType;
  GetDownloadableURLMutation?: GetDownloadableUrlMutationResolvers<ContextType>;
  GetInvitesForEmailDTO?: GetInvitesForEmailDtoResolvers<ContextType>;
  GetMarketplaceApplicantMutation?: GetMarketplaceApplicantMutationResolvers<ContextType>;
  GetOrCreateApiKeyMutation?: GetOrCreateApiKeyMutationResolvers<ContextType>;
  GetRecordingFailureIdsResponse?: GetRecordingFailureIdsResponseResolvers<ContextType>;
  GetSignedS3PostFieldsMutation?: GetSignedS3PostFieldsMutationResolvers<ContextType>;
  GetSignedS3UrlMutation?: GetSignedS3UrlMutationResolvers<ContextType>;
  Giphy?: GiphyResolvers<ContextType>;
  GraphField?: GraphFieldResolvers<ContextType>;
  GroupField?: GroupFieldResolvers<ContextType>;
  HideMentorInMarketplaceMutation?: HideMentorInMarketplaceMutationResolvers<ContextType>;
  HighSchoolField?: HighSchoolFieldResolvers<ContextType>;
  HighSchoolTypeField?: HighSchoolTypeFieldResolvers<ContextType>;
  HousingObject?: HousingObjectResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  InboxItemInterface?: InboxItemInterfaceResolvers<ContextType>;
  InboxItemLastMessageField?: InboxItemLastMessageFieldResolvers<ContextType>;
  InboxItemUnion?: InboxItemUnionResolvers<ContextType>;
  InboxPromptAnswer?: InboxPromptAnswerResolvers<ContextType>;
  InboxPromptOption?: InboxPromptOptionResolvers<ContextType>;
  InboxPromptQuestion?: InboxPromptQuestionResolvers<ContextType>;
  InboxUniversityField?: InboxUniversityFieldResolvers<ContextType>;
  InitialiseRecordingResponse?: InitialiseRecordingResponseResolvers<ContextType>;
  InputField?: InputFieldResolvers<ContextType>;
  Insights?: InsightsResolvers<ContextType>;
  InsightsField?: InsightsFieldResolvers<ContextType>;
  Interest?: InterestResolvers<ContextType>;
  InterestObject?: InterestObjectResolvers<ContextType>;
  InterventionMessageField?: InterventionMessageFieldResolvers<ContextType>;
  Invite?: InviteResolvers<ContextType>;
  InviteApplicantsMutation?: InviteApplicantsMutationResolvers<ContextType>;
  InviteBuddiesMutation?: InviteBuddiesMutationResolvers<ContextType>;
  InviteInformation?: InviteInformationResolvers<ContextType>;
  InviteLinkDto?: InviteLinkDtoResolvers<ContextType>;
  InviteLinkInfoDto?: InviteLinkInfoDtoResolvers<ContextType>;
  InviteMentorsMutation?: InviteMentorsMutationResolvers<ContextType>;
  IsoDateTime?: GraphQLScalarType;
  JSONString?: GraphQLScalarType;
  JoinChatGroupMutation?: JoinChatGroupMutationResolvers<ContextType>;
  KnowledgeBaseDeleteEntryOutput?: KnowledgeBaseDeleteEntryOutputResolvers<ContextType>;
  KnowledgeBaseEmbedding?: KnowledgeBaseEmbeddingResolvers<ContextType>;
  KnowledgeBaseSourcesByUrl?: KnowledgeBaseSourcesByUrlResolvers<ContextType>;
  LabelSentenceMutation?: LabelSentenceMutationResolvers<ContextType>;
  LabellingField?: LabellingFieldResolvers<ContextType>;
  LabellingSentenceCandidate?: LabellingSentenceCandidateResolvers<ContextType>;
  Labels?: LabelsResolvers<ContextType>;
  LanguageField?: LanguageFieldResolvers<ContextType>;
  LastMessageField?: LastMessageFieldResolvers<ContextType>;
  LastRead?: LastReadResolvers<ContextType>;
  LeaveChatGroupMutation?: LeaveChatGroupMutationResolvers<ContextType>;
  LevelSnippetField?: LevelSnippetFieldResolvers<ContextType>;
  LikeMessageMutation?: LikeMessageMutationResolvers<ContextType>;
  LimitedInt?: GraphQLScalarType;
  LinkOrganisationsMutation?: LinkOrganisationsMutationResolvers<ContextType>;
  ListBuddyApplicantConversationsField?: ListBuddyApplicantConversationsFieldResolvers<ContextType>;
  ListMentorApplicantConversationsField?: ListMentorApplicantConversationsFieldResolvers<ContextType>;
  ListUniversityAssistantConversationsOutput?: ListUniversityAssistantConversationsOutputResolvers<ContextType>;
  LiveEventChatGroupField?: LiveEventChatGroupFieldResolvers<ContextType>;
  LiveEventDetailedReport?: LiveEventDetailedReportResolvers<ContextType>;
  LiveEventDetailedReportChannelStats?: LiveEventDetailedReportChannelStatsResolvers<ContextType>;
  LiveEventDetailedReportCountryStats?: LiveEventDetailedReportCountryStatsResolvers<ContextType>;
  LiveEventDetailsField?: LiveEventDetailsFieldResolvers<ContextType>;
  LiveEventDirectMessaging?: LiveEventDirectMessagingResolvers<ContextType>;
  LiveEventFeedbackFormMutation?: LiveEventFeedbackFormMutationResolvers<ContextType>;
  LiveEventField?: LiveEventFieldResolvers<ContextType>;
  LiveEventInboxField?: LiveEventInboxFieldResolvers<ContextType>;
  LiveEventLandingPageField?: LiveEventLandingPageFieldResolvers<ContextType>;
  LiveEventProspectFeedbackFormField?: LiveEventProspectFeedbackFormFieldResolvers<ContextType>;
  LiveEventsFormFieldValidationError?: LiveEventsFormFieldValidationErrorResolvers<ContextType>;
  LiveSession?: LiveSessionResolvers<ContextType>;
  Locale?: LocaleResolvers<ContextType>;
  LocaleField?: LocaleFieldResolvers<ContextType>;
  LogoDataField?: LogoDataFieldResolvers<ContextType>;
  LogoutMutation?: LogoutMutationResolvers<ContextType>;
  ManageOrganisationAccessMutation?: ManageOrganisationAccessMutationResolvers<ContextType>;
  ManuallyClassifyMutation?: ManuallyClassifyMutationResolvers<ContextType>;
  MarketplaceApplicantCountries?: MarketplaceApplicantCountriesResolvers<ContextType>;
  MarketplaceApplicantDegreeCategories?: MarketplaceApplicantDegreeCategoriesResolvers<ContextType>;
  MarketplaceApplicantUserData?: MarketplaceApplicantUserDataResolvers<ContextType>;
  MarketplaceField?: MarketplaceFieldResolvers<ContextType>;
  MarketplaceFilters?: MarketplaceFiltersResolvers<ContextType>;
  MarketplaceInboxField?: MarketplaceInboxFieldResolvers<ContextType>;
  MarketplaceMentorList?: MarketplaceMentorListResolvers<ContextType>;
  MarketplaceSnippetField?: MarketplaceSnippetFieldResolvers<ContextType>;
  MatchedUser?: MatchedUserResolvers<ContextType>;
  MeField?: MeFieldResolvers<ContextType>;
  MentorApplicantChatGroupField?: MentorApplicantChatGroupFieldResolvers<ContextType>;
  MentorBroadcastMessageMutation?: MentorBroadcastMessageMutationResolvers<ContextType>;
  MentorChatUserField?: MentorChatUserFieldResolvers<ContextType>;
  MentorDegreeField?: MentorDegreeFieldResolvers<ContextType>;
  MentorDegreeHistory?: MentorDegreeHistoryResolvers<ContextType>;
  MentorField?: MentorFieldResolvers<ContextType>;
  MentorFieldOrderField?: MentorFieldOrderFieldResolvers<ContextType>;
  MentorFields?: MentorFieldsResolvers<ContextType>;
  MentorFilterField?: MentorFilterFieldResolvers<ContextType>;
  MentorFilterOptionField?: MentorFilterOptionFieldResolvers<ContextType>;
  MentorInboxField?: MentorInboxFieldResolvers<ContextType>;
  MentorInterestField?: MentorInterestFieldResolvers<ContextType>;
  MentorInterventionQueryField?: MentorInterventionQueryFieldResolvers<ContextType>;
  MentorIntroMessageField?: MentorIntroMessageFieldResolvers<ContextType>;
  MentorInviteCountField?: MentorInviteCountFieldResolvers<ContextType>;
  MentorInviteField?: MentorInviteFieldResolvers<ContextType>;
  MentorListField?: MentorListFieldResolvers<ContextType>;
  MentorListFilterChoice?: MentorListFilterChoiceResolvers<ContextType>;
  MentorModuleField?: MentorModuleFieldResolvers<ContextType>;
  MentorPreferencesField?: MentorPreferencesFieldResolvers<ContextType>;
  MentorSchoolHistoryField?: MentorSchoolHistoryFieldResolvers<ContextType>;
  MentorSnippetField?: MentorSnippetFieldResolvers<ContextType>;
  MentorSocietyField?: MentorSocietyFieldResolvers<ContextType>;
  MentorcardSnippetField?: MentorcardSnippetFieldResolvers<ContextType>;
  MessageField?: MessageFieldResolvers<ContextType>;
  MessageMetadata?: MessageMetadataResolvers<ContextType>;
  MessagePublicBotMutation?: MessagePublicBotMutationResolvers<ContextType>;
  MetricDataPoint?: MetricDataPointResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewsFeedGroup?: NewsFeedGroupResolvers<ContextType>;
  NotificationField?: NotificationFieldResolvers<ContextType>;
  ObjectID?: GraphQLScalarType;
  ObjectId?: GraphQLScalarType;
  OpenDayField?: OpenDayFieldResolvers<ContextType>;
  OpenDaysLoginField?: OpenDaysLoginFieldResolvers<ContextType>;
  OpenDaysSignupField?: OpenDaysSignupFieldResolvers<ContextType>;
  OpenTextFieldValueField?: OpenTextFieldValueFieldResolvers<ContextType>;
  OrganisationBuddyLinkField?: OrganisationBuddyLinkFieldResolvers<ContextType>;
  OrganisationField?: OrganisationFieldResolvers<ContextType>;
  OutboxChatGroupField?: OutboxChatGroupFieldResolvers<ContextType>;
  OutputField?: OutputFieldResolvers<ContextType>;
  PageMentorField?: PageMentorFieldResolvers<ContextType>;
  PaginatedAdminRecommendation?: PaginatedAdminRecommendationResolvers<ContextType>;
  PaginatedApplicantInvite?: PaginatedApplicantInviteResolvers<ContextType>;
  PaginatedApplicationInsightModel?: PaginatedApplicationInsightModelResolvers<ContextType>;
  PaginatedChatMessages?: PaginatedChatMessagesResolvers<ContextType>;
  PaginatedChatRooms?: PaginatedChatRoomsResolvers<ContextType>;
  PaginatedEventPages?: PaginatedEventPagesResolvers<ContextType>;
  PaginatedExternalContents?: PaginatedExternalContentsResolvers<ContextType>;
  PaginatedLiveSessions?: PaginatedLiveSessionsResolvers<ContextType>;
  PaginatedVirtualEvents?: PaginatedVirtualEventsResolvers<ContextType>;
  PasswordResetMobileMutation?: PasswordResetMobileMutationResolvers<ContextType>;
  PasswordResetMobileMutationV2?: PasswordResetMobileMutationV2Resolvers<ContextType>;
  PayloadField?: PayloadFieldResolvers<ContextType>;
  PinMessageMutation?: PinMessageMutationResolvers<ContextType>;
  PinnedMessageField?: PinnedMessageFieldResolvers<ContextType>;
  PinnedMessageSenderField?: PinnedMessageSenderFieldResolvers<ContextType>;
  Poll?: PollResolvers<ContextType>;
  PollOption?: PollOptionResolvers<ContextType>;
  PopCardDegreeSnippetField?: PopCardDegreeSnippetFieldResolvers<ContextType>;
  PopCardLevelSnippetField?: PopCardLevelSnippetFieldResolvers<ContextType>;
  PopCardWidgetField?: PopCardWidgetFieldResolvers<ContextType>;
  PopcardSnippetField?: PopcardSnippetFieldResolvers<ContextType>;
  PostFields?: PostFieldsResolvers<ContextType>;
  PreferencesObjectType?: PreferencesObjectTypeResolvers<ContextType>;
  PreferencesOutputType?: PreferencesOutputTypeResolvers<ContextType>;
  ProspectStageStatField?: ProspectStageStatFieldResolvers<ContextType>;
  ProspectStageSummaryField?: ProspectStageSummaryFieldResolvers<ContextType>;
  PublicMentorField?: PublicMentorFieldResolvers<ContextType>;
  PublicUserField?: PublicUserFieldResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryRecordingResponse?: QueryRecordingResponseResolvers<ContextType>;
  QuestionField?: QuestionFieldResolvers<ContextType>;
  RandomMentorsListField?: RandomMentorsListFieldResolvers<ContextType>;
  Reaction?: ReactionResolvers<ContextType>;
  ReadChatMutation?: ReadChatMutationResolvers<ContextType>;
  Recommendation?: RecommendationResolvers<ContextType>;
  RecommendationResourceType?: RecommendationResourceTypeResolvers<ContextType>;
  RecordUserActivityMutation?: RecordUserActivityMutationResolvers<ContextType>;
  RecordingConsent?: RecordingConsentResolvers<ContextType>;
  RecordingDownloadResponse?: RecordingDownloadResponseResolvers<ContextType>;
  RecordingFailureId?: RecordingFailureIdResolvers<ContextType>;
  RecordingFailureResponse?: RecordingFailureResponseResolvers<ContextType>;
  RecordingListResponse?: RecordingListResponseResolvers<ContextType>;
  RecordingModel?: RecordingModelResolvers<ContextType>;
  RecordingResponse?: RecordingResponseResolvers<ContextType>;
  RecordingUploadingResponse?: RecordingUploadingResponseResolvers<ContextType>;
  RegisterToLiveEvent?: RegisterToLiveEventResolvers<ContextType>;
  RemoveBuddyInvitesMutation?: RemoveBuddyInvitesMutationResolvers<ContextType>;
  RemoveDeviceMutation?: RemoveDeviceMutationResolvers<ContextType>;
  RemoveMentorInvitesMutation?: RemoveMentorInvitesMutationResolvers<ContextType>;
  ReplyMessage?: ReplyMessageResolvers<ContextType>;
  ReplyOutputField?: ReplyOutputFieldResolvers<ContextType>;
  ReportAnalytics?: ReportAnalyticsResolvers<ContextType>;
  RequestAnalyticsExportMutation?: RequestAnalyticsExportMutationResolvers<ContextType>;
  RequestPasswordResetMutation?: RequestPasswordResetMutationResolvers<ContextType>;
  RequestPasswordSetMutation?: RequestPasswordSetMutationResolvers<ContextType>;
  RequestedPublicGroup?: RequestedPublicGroupResolvers<ContextType>;
  ResearchTimeLogResult?: ResearchTimeLogResultResolvers<ContextType>;
  ResearchTimeResult?: ResearchTimeResultResolvers<ContextType>;
  ResetPasswordMobileMutation?: ResetPasswordMobileMutationResolvers<ContextType>;
  ResetPasswordMutation?: ResetPasswordMutationResolvers<ContextType>;
  ResetPasswordMutationV2?: ResetPasswordMutationV2Resolvers<ContextType>;
  ResolveUniversityChatsMutation?: ResolveUniversityChatsMutationResolvers<ContextType>;
  RichContentOutputField?: RichContentOutputFieldResolvers<ContextType>;
  RichMessageContent?: RichMessageContentResolvers<ContextType>;
  RunManageCommandMutation?: RunManageCommandMutationResolvers<ContextType>;
  SatisfactionSurveyEntity?: SatisfactionSurveyEntityResolvers<ContextType>;
  SaveAppliedUsersModel?: SaveAppliedUsersModelResolvers<ContextType>;
  SearchResult?: SearchResultResolvers<ContextType>;
  SendCommunityVerificationCode?: SendCommunityVerificationCodeResolvers<ContextType>;
  SendFeedMessageMutation?: SendFeedMessageMutationResolvers<ContextType>;
  SendLiveEventMessageMutation?: SendLiveEventMessageMutationResolvers<ContextType>;
  SendMessageMutation?: SendMessageMutationResolvers<ContextType>;
  SendOpenDayProspectReport?: SendOpenDayProspectReportResolvers<ContextType>;
  SendResetPasswordEmail?: SendResetPasswordEmailResolvers<ContextType>;
  SendVerificationCode?: SendVerificationCodeResolvers<ContextType>;
  SequenceFilterMentorListField?: SequenceFilterMentorListFieldResolvers<ContextType>;
  SessionAnalytics?: SessionAnalyticsResolvers<ContextType>;
  SessionAttendeeAnalytics?: SessionAttendeeAnalyticsResolvers<ContextType>;
  SessionAttendees?: SessionAttendeesResolvers<ContextType>;
  SetActiveBlogTopicsMutation?: SetActiveBlogTopicsMutationResolvers<ContextType>;
  SetAllNotificationsReadMutation?: SetAllNotificationsReadMutationResolvers<ContextType>;
  SetArchivedContentBriefMutation?: SetArchivedContentBriefMutationResolvers<ContextType>;
  SetArchivedDegreeLevelMutation?: SetArchivedDegreeLevelMutationResolvers<ContextType>;
  SetArchivedYearOfStudyMutation?: SetArchivedYearOfStudyMutationResolvers<ContextType>;
  SetBuddiesListFilters?: SetBuddiesListFiltersResolvers<ContextType>;
  SetChatGroupLabelsMutation?: SetChatGroupLabelsMutationResolvers<ContextType>;
  SetMentorFieldOrderMutation?: SetMentorFieldOrderMutationResolvers<ContextType>;
  SetMentorListFilterSelection?: SetMentorListFilterSelectionResolvers<ContextType>;
  SetOnlineMutation?: SetOnlineMutationResolvers<ContextType>;
  SetResolveChatGroupMutation?: SetResolveChatGroupMutationResolvers<ContextType>;
  SetWillReplyMutation?: SetWillReplyMutationResolvers<ContextType>;
  SettingsObjectType?: SettingsObjectTypeResolvers<ContextType>;
  ShowMentorInMarketplaceMutation?: ShowMentorInMarketplaceMutationResolvers<ContextType>;
  SignUpsCount?: SignUpsCountResolvers<ContextType>;
  SignedS3POSTFields?: SignedS3PostFieldsResolvers<ContextType>;
  SignedS3URLField?: SignedS3UrlFieldResolvers<ContextType>;
  SingleChoiceAttributeField?: SingleChoiceAttributeFieldResolvers<ContextType>;
  SingleChoiceValueField?: SingleChoiceValueFieldResolvers<ContextType>;
  SourceTrackingParamsField?: SourceTrackingParamsFieldResolvers<ContextType>;
  StaffBuddycardSnippetField?: StaffBuddycardSnippetFieldResolvers<ContextType>;
  StaffChatUserField?: StaffChatUserFieldResolvers<ContextType>;
  StaffContactOutput?: StaffContactOutputResolvers<ContextType>;
  StaffField?: StaffFieldResolvers<ContextType>;
  StaffFieldsChatUserField?: StaffFieldsChatUserFieldResolvers<ContextType>;
  StaffPopcardSnippetField?: StaffPopcardSnippetFieldResolvers<ContextType>;
  StaffProfileInformation?: StaffProfileInformationResolvers<ContextType>;
  StaffUserField?: StaffUserFieldResolvers<ContextType>;
  StaffUserFieldsField?: StaffUserFieldsFieldResolvers<ContextType>;
  StaffUserListField?: StaffUserListFieldResolvers<ContextType>;
  StateStatField?: StateStatFieldResolvers<ContextType>;
  SubTopicField?: SubTopicFieldResolvers<ContextType>;
  SubTopicStatField?: SubTopicStatFieldResolvers<ContextType>;
  SubTopicStatisticField?: SubTopicStatisticFieldResolvers<ContextType>;
  SuggestionField?: SuggestionFieldResolvers<ContextType>;
  SwitchUniversitiesField?: SwitchUniversitiesFieldResolvers<ContextType>;
  SwitchUniversityField?: SwitchUniversityFieldResolvers<ContextType>;
  SwitchUniversityListField?: SwitchUniversityListFieldResolvers<ContextType>;
  TagField?: TagFieldResolvers<ContextType>;
  TextInLocale?: TextInLocaleResolvers<ContextType>;
  TimeTakenField?: TimeTakenFieldResolvers<ContextType>;
  TodoTargetAudience?: TodoTargetAudienceResolvers<ContextType>;
  TodosEntity?: TodosEntityResolvers<ContextType>;
  ToggleCrmIntegrationSync?: ToggleCrmIntegrationSyncResolvers<ContextType>;
  ToggleCustomAttributeCrmSyncMutation?: ToggleCustomAttributeCrmSyncMutationResolvers<ContextType>;
  ToggleDegreesActiveMutation?: ToggleDegreesActiveMutationResolvers<ContextType>;
  ToggleFeatureAvailabilityMutation?: ToggleFeatureAvailabilityMutationResolvers<ContextType>;
  TopCountryField?: TopCountryFieldResolvers<ContextType>;
  TopDegreeField?: TopDegreeFieldResolvers<ContextType>;
  TopDomesticRegionField?: TopDomesticRegionFieldResolvers<ContextType>;
  TopRegionField?: TopRegionFieldResolvers<ContextType>;
  TopSubTopicField?: TopSubTopicFieldResolvers<ContextType>;
  TopTopicField?: TopTopicFieldResolvers<ContextType>;
  TopicField?: TopicFieldResolvers<ContextType>;
  TopicSnippetField?: TopicSnippetFieldResolvers<ContextType>;
  TopicStatisticField?: TopicStatisticFieldResolvers<ContextType>;
  TopicsStatField?: TopicsStatFieldResolvers<ContextType>;
  TrackLiveEventMutation?: TrackLiveEventMutationResolvers<ContextType>;
  TrackOpenDayMutation?: TrackOpenDayMutationResolvers<ContextType>;
  TrendingTopicsField?: TrendingTopicsFieldResolvers<ContextType>;
  UniversityAssistantConfiguration?: UniversityAssistantConfigurationResolvers<ContextType>;
  UniversityAssistantConfigurationEventOutput?: UniversityAssistantConfigurationEventOutputResolvers<ContextType>;
  UniversityAssistantConfigurationEventUrls?: UniversityAssistantConfigurationEventUrlsResolvers<ContextType>;
  UniversityAssistantConfigurationPromptContextOutput?: UniversityAssistantConfigurationPromptContextOutputResolvers<ContextType>;
  UniversityAssistantConfigurationScrapeIgnoreUrlsOutput?: UniversityAssistantConfigurationScrapeIgnoreUrlsOutputResolvers<ContextType>;
  UniversityAssistantConfigurationScrapeStartPointOutput?: UniversityAssistantConfigurationScrapeStartPointOutputResolvers<ContextType>;
  UniversityAssistantConversation?: UniversityAssistantConversationResolvers<ContextType>;
  UniversityAssistantScrapeIgnoreUrls?: UniversityAssistantScrapeIgnoreUrlsResolvers<ContextType>;
  UniversityBlockReportField?: UniversityBlockReportFieldResolvers<ContextType>;
  UniversityBlockUsersMutation?: UniversityBlockUsersMutationResolvers<ContextType>;
  UniversityBlogPostsField?: UniversityBlogPostsFieldResolvers<ContextType>;
  UniversityChatInboxField?: UniversityChatInboxFieldResolvers<ContextType>;
  UniversityConfigField?: UniversityConfigFieldResolvers<ContextType>;
  UniversityContent?: UniversityContentResolvers<ContextType>;
  UniversityFeatureField?: UniversityFeatureFieldResolvers<ContextType>;
  UniversityField?: UniversityFieldResolvers<ContextType>;
  UniversityInboxField?: UniversityInboxFieldResolvers<ContextType>;
  UniversityInterestedEntity?: UniversityInterestedEntityResolvers<ContextType>;
  UniversityMarketplaceField?: UniversityMarketplaceFieldResolvers<ContextType>;
  UniversityOutput?: UniversityOutputResolvers<ContextType>;
  UniversityQuestion?: UniversityQuestionResolvers<ContextType>;
  UniversityQuestionAnswer?: UniversityQuestionAnswerResolvers<ContextType>;
  UniversityQuestionContext?: UniversityQuestionContextResolvers<ContextType>;
  UniversityQuestionOption?: UniversityQuestionOptionResolvers<ContextType>;
  UniversityScrapeIndexingOutput?: UniversityScrapeIndexingOutputResolvers<ContextType>;
  UniversityScrapeOutput?: UniversityScrapeOutputResolvers<ContextType>;
  UniversityScrapeStopOutput?: UniversityScrapeStopOutputResolvers<ContextType>;
  UniversityScrapeTask?: UniversityScrapeTaskResolvers<ContextType>;
  UniversitySnippetField?: UniversitySnippetFieldResolvers<ContextType>;
  UniversityUserField?: UniversityUserFieldResolvers<ContextType>;
  UniversityUserPreferencesField?: UniversityUserPreferencesFieldResolvers<ContextType>;
  UnpinMessageMutation?: UnpinMessageMutationResolvers<ContextType>;
  UnreadCountField?: UnreadCountFieldResolvers<ContextType>;
  UnreadMessageCountField?: UnreadMessageCountFieldResolvers<ContextType>;
  UpdateApplicantMutation?: UpdateApplicantMutationResolvers<ContextType>;
  UpdateApplicantPreferencesMutation?: UpdateApplicantPreferencesMutationResolvers<ContextType>;
  UpdateCanonicalQuestion?: UpdateCanonicalQuestionResolvers<ContextType>;
  UpdateCommunityApplicantSignupSourceMutation?: UpdateCommunityApplicantSignupSourceMutationResolvers<ContextType>;
  UpdateDirectMessagingMembersForLiveEventMutation?: UpdateDirectMessagingMembersForLiveEventMutationResolvers<ContextType>;
  UpdateFaqAnswer?: UpdateFaqAnswerResolvers<ContextType>;
  UpdateHobsonsConnectIntegration?: UpdateHobsonsConnectIntegrationResolvers<ContextType>;
  UpdateIntegrationFieldMapping?: UpdateIntegrationFieldMappingResolvers<ContextType>;
  UpdateLiveEventFeedSessionDataMutation?: UpdateLiveEventFeedSessionDataMutationResolvers<ContextType>;
  UpdateManyUserMutation?: UpdateManyUserMutationResolvers<ContextType>;
  UpdateMarketplaceApplicantMutation?: UpdateMarketplaceApplicantMutationResolvers<ContextType>;
  UpdateMarketplaceApplicantUniversityLinkMutation?: UpdateMarketplaceApplicantUniversityLinkMutationResolvers<ContextType>;
  UpdateMarketplaceMutation?: UpdateMarketplaceMutationResolvers<ContextType>;
  UpdateMentorMutation?: UpdateMentorMutationResolvers<ContextType>;
  UpdateMentorPreferences?: UpdateMentorPreferencesResolvers<ContextType>;
  UpdateMyUniversityLinkMutation?: UpdateMyUniversityLinkMutationResolvers<ContextType>;
  UpdatePostStatusMutation?: UpdatePostStatusMutationResolvers<ContextType>;
  UpdateResearchTimeMutation?: UpdateResearchTimeMutationResolvers<ContextType>;
  UpdateStaffMutation?: UpdateStaffMutationResolvers<ContextType>;
  UpdateSubTopicMutation?: UpdateSubTopicMutationResolvers<ContextType>;
  UpdateTagMutation?: UpdateTagMutationResolvers<ContextType>;
  UpdateTopicMutation?: UpdateTopicMutationResolvers<ContextType>;
  UpdateUniversityBlockReportMutation?: UpdateUniversityBlockReportMutationResolvers<ContextType>;
  UpdateUniversityConfigMutation?: UpdateUniversityConfigMutationResolvers<ContextType>;
  UpdateUniversityUserMutation?: UpdateUniversityUserMutationResolvers<ContextType>;
  UpdateUniversityUserPreferencesMutation?: UpdateUniversityUserPreferencesMutationResolvers<ContextType>;
  UpdateUserMutation?: UpdateUserMutationResolvers<ContextType>;
  UpdateUserPreferences?: UpdateUserPreferencesResolvers<ContextType>;
  UpdatedResults?: UpdatedResultsResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  UserCustomAttributesFilterField?: UserCustomAttributesFilterFieldResolvers<ContextType>;
  UserDecisionStageOutput?: UserDecisionStageOutputResolvers<ContextType>;
  UserDegreeField?: UserDegreeFieldResolvers<ContextType>;
  UserDirectoryResult?: UserDirectoryResultResolvers<ContextType>;
  UserField?: UserFieldResolvers<ContextType>;
  UserIdsListField?: UserIdsListFieldResolvers<ContextType>;
  UserInterest?: UserInterestResolvers<ContextType>;
  UserListField?: UserListFieldResolvers<ContextType>;
  UserLocalePreference?: UserLocalePreferenceResolvers<ContextType>;
  UserPartialSearchFields?: UserPartialSearchFieldsResolvers<ContextType>;
  UserPermissionsListField?: UserPermissionsListFieldResolvers<ContextType>;
  UserPreferencesField?: UserPreferencesFieldResolvers<ContextType>;
  UserProfile?: UserProfileResolvers<ContextType>;
  UserRecommendation?: UserRecommendationResolvers<ContextType>;
  UserReport?: UserReportResolvers<ContextType>;
  UserTimeSheetExportField?: UserTimeSheetExportFieldResolvers<ContextType>;
  UserTimeSpentBreakdown?: UserTimeSpentBreakdownResolvers<ContextType>;
  UserTimeSpentStatsField?: UserTimeSpentStatsFieldResolvers<ContextType>;
  UsersTimeSpentData?: UsersTimeSpentDataResolvers<ContextType>;
  VerifyAccount?: VerifyAccountResolvers<ContextType>;
  VerifyCodeField?: VerifyCodeFieldResolvers<ContextType>;
  VideoContent?: VideoContentResolvers<ContextType>;
  VideoFile?: VideoFileResolvers<ContextType>;
  VideoSessionField?: VideoSessionFieldResolvers<ContextType>;
  VideoUploadLink?: VideoUploadLinkResolvers<ContextType>;
  VideoUploadPresignedFields?: VideoUploadPresignedFieldsResolvers<ContextType>;
  VideoUrl?: VideoUrlResolvers<ContextType>;
  ViewBlogMutation?: ViewBlogMutationResolvers<ContextType>;
  VirtualEvent?: VirtualEventResolvers<ContextType>;
  WidgetSnippetField?: WidgetSnippetFieldResolvers<ContextType>;
  WidgetUrlField?: WidgetUrlFieldResolvers<ContextType>;
  WillReplyField?: WillReplyFieldResolvers<ContextType>;
  YearOfStudyField?: YearOfStudyFieldResolvers<ContextType>;
};


export type GetEmailAddressFromInviteIdQueryVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type GetEmailAddressFromInviteIdQuery = { __typename?: 'Query', getInviteFromId: { __typename?: 'Invite', valid?: boolean | null, id: string, invitedEmail: string, communityId: string } };

export type GetInviteInformationQueryVariables = Exact<{
  inviteInformationInput: InviteInformationInput;
}>;


export type GetInviteInformationQuery = { __typename?: 'Query', getInviteInformation: { __typename?: 'InviteInformation', id: string, community: { __typename?: 'Community', description?: string | null, title?: string | null, id: string }, university: { __typename?: 'UniversityField', name?: string | null, slug?: string | null, id?: string | null, squareLogo?: string | null } } };

export type AdminLobbyQueryVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type AdminLobbyQuery = { __typename?: 'Query', listCommunitiesForAnInstitution: Array<{ __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, members?: Array<{ __typename?: 'UserField', id?: string | null }> | null, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }> };

export type CommunityLobbyQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type CommunityLobbyQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserField', id?: string | null, communities?: Array<{ __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }> | null } | null, getInvitesForEmail: Array<{ __typename?: 'GetInvitesForEmailDTO', id: string, community: { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } }> };

export type JoinCommunityMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type JoinCommunityMutation = { __typename?: 'Mutation', joinCommunity: { __typename?: 'CommunityJoinResponse', joined: boolean, community: { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } } };

export type JoinCommunityForAdminsMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type JoinCommunityForAdminsMutation = { __typename?: 'Mutation', joinCommunityForAdmins: { __typename?: 'CommunityJoinResponse', joined: boolean, community: { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, members?: Array<{ __typename?: 'UserField', id?: string | null }> | null, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } } };

export type UpdateApplicantSignupSourceMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type UpdateApplicantSignupSourceMutation = { __typename?: 'Mutation', updateCommunityApplicantSignupsource?: { __typename?: 'UpdateCommunityApplicantSignupSourceMutation', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', id?: string | null } | null } | null } | null };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', getUserProfile: { __typename?: 'UserProfile', id: string, userId: string, profilePhoto?: string | null, bio?: string | null, interests?: Array<{ __typename?: 'InterestObject', id: string, type: string }> | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null }> | null } };

export type SetCommunityDeviceTokenMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  deviceToken: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  system: Scalars['String']['input'];
}>;


export type SetCommunityDeviceTokenMutation = { __typename?: 'Mutation', setDeviceToken: { __typename?: 'DeviceToken', active: boolean } };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename?: 'Query', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', verified?: boolean | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, email?: string | null, id?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', name?: string | null, id?: string | null, code?: string | null } | null, university?: { __typename?: 'UniversityField', id?: string | null, slug?: string | null, name?: string | null } | null } | null } | null };

export type RegisterCommunityApplicantMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterCommunityApplicantMutation = { __typename?: 'Mutation', createCommunityApplicantV2?: { __typename?: 'CreateCommunityApplicantMutationV2', error?: string | null, applicant?: { __typename?: 'ApplicantField', id?: string | null } | null } | null };

export type RequestCommunityVerificationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestCommunityVerificationCodeMutation = { __typename?: 'Mutation', sendCommunityVerificationCode?: { __typename?: 'SendCommunityVerificationCode', success?: boolean | null } | null };

export type VerifyCommunityEmailMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyCommunityEmailMutation = { __typename?: 'Mutation', verifyAccount?: { __typename?: 'VerifyAccount', success?: boolean | null, error?: string | null } | null };

export type DeleteApplicantMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteApplicantMutationMutation = { __typename?: 'Mutation', deleteApplicant?: { __typename?: 'DeleteApplicantMutation', applicant?: { __typename?: 'ApplicantField', id?: string | null } | null } | null };

export type CreateUserReportMutationVariables = Exact<{
  userReportUserInputDTO: UserReportUserInputDto;
}>;


export type CreateUserReportMutation = { __typename?: 'Mutation', createUserReport: { __typename?: 'UserReport', id: string } };

export type ToggleMuteConversationMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
}>;


export type ToggleMuteConversationMutation = { __typename?: 'Mutation', toggleCommunityChatGroupMute: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityId?: string | null, communityChatDynamicLink?: string | null, mutedBy: Array<string>, totalMemberCount?: number | null, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, profilePhoto?: string | null, firstName?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, allMembers?: Array<{ __typename?: 'UserField', id?: string | null }> | null } };

export type GetAmbassadorProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAmbassadorProfileQuery = { __typename?: 'Query', publicMentor?: { __typename?: 'PublicMentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, degreeLevel?: string | null, accountRole?: string | null, placeName?: string | null, year?: string | null, pastQualification?: string | null, bio?: string | null, shareUrl?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null, languages?: Array<{ __typename?: 'LanguageField', id?: string | null, name?: string | null } | null> | null, favouriteModules?: Array<{ __typename?: 'MentorModuleField', id?: string | null, name?: string | null } | null> | null, interests?: Array<{ __typename?: 'MentorInterestField', id?: string | null, name?: string | null } | null> | null, societies?: Array<{ __typename?: 'MentorSocietyField', id?: string | null, name?: string | null } | null> | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, widgetUrl?: string | null } | null, customAttributes?: Array<{ __typename?: 'DateValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | { __typename?: 'OpenTextFieldValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | { __typename?: 'SingleChoiceValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | null> | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', code?: string | null, name?: string | null } | null } | null } | null };

export type GetOrCreateWidgetConversationMutationVariables = Exact<{
  widgetConversationDto: WidgetConversationDto;
}>;


export type GetOrCreateWidgetConversationMutation = { __typename?: 'Mutation', getOrCreateWidgetConversation: { __typename?: 'ChatConversation', id: string, product: Product, communityChatTitle?: string | null, mutedBy: Array<string>, isNewsFeed: boolean, isPrivate?: boolean | null, isDirect?: boolean | null, unreadMessageCount?: number | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null }, members?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null } };

export type GetStaffProfileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStaffProfileQuery = { __typename?: 'Query', buddy?: { __typename?: 'BuddyField', id?: string | null, active?: boolean | null, firstName?: string | null, lastName?: string | null, shareUrl?: string | null, profilePhoto?: string | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, widgetUrl?: string | null, logo?: string | null, slug?: string | null } | null, customAttributes?: Array<{ __typename?: 'DateValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | { __typename?: 'OpenTextFieldValueField', value?: string | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | { __typename?: 'SingleChoiceValueField', value?: string | null, option?: { __typename?: 'CustomAttributeOptionField', id?: string | null, value?: string | null } | null, attribute?: { __typename?: 'BaseCustomAttributeField', id?: string | null, name?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, name?: string | null, type?: string | null } | null } | null> | null, staffFields?: { __typename?: 'StaffUserFieldsField', bio?: string | null, department?: string | null, role?: string | null } | null } | null };

export type AddUserToGroupMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', addUserToCommunityConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, allMembers?: Array<{ __typename?: 'UserField', id?: string | null }> | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } } };

export type GetCommunityConversationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCommunityConversationQuery = { __typename?: 'Query', getChatConversation: { __typename?: 'ChatConversation', id: string, product: Product, communityChatTitle?: string | null, communityChatDescription?: string | null, communityId?: string | null, communityChatDynamicLink?: string | null, mutedBy: Array<string>, totalMemberCount?: number | null, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, university: { __typename?: 'UniversityField', id?: string | null, slug?: string | null, name?: string | null }, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, profilePhoto?: string | null, firstName?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null } };

export type CommunityFieldsFragment = { __typename?: 'ChatConversation', communityChatTitle?: string | null, communityChatDescription?: string | null, communityId?: string | null, communityChatDynamicLink?: string | null, mutedBy: Array<string>, totalMemberCount?: number | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, profilePhoto?: string | null, firstName?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null };

export type AllMembersFragment = { __typename?: 'ChatConversation', allMembers?: Array<{ __typename?: 'UserField', id?: string | null }> | null };

export type GroupTypesFragment = { __typename?: 'ChatConversation', isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null };

export type GetFullConversationMembersListQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFullConversationMembersListQuery = { __typename?: 'Query', getChatConversation: { __typename?: 'ChatConversation', id: string, totalMemberCount?: number | null } };

export type GetCommunityChatMembersQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
  offsetPagination: OffsetPagination;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetCommunityChatMembersQuery = { __typename?: 'Query', getCommunityChatMembers: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null }>, getUserByIds?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null } | null> | null };

export type GetUserByUserIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserByUserIdQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserField', id?: string | null, firstName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, pronouns?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, housing?: { __typename?: 'HousingObject', category: HousingCategory, name?: string | null } | null } | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, interests: Array<{ __typename?: 'Interest', id: any, name: string }> } | null };

export type CountryFragment = { __typename?: 'UserField', country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null };

export type CommunityProfileFragment = { __typename?: 'UserField', communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null };

export type InterestsFragment = { __typename?: 'UserField', interests: Array<{ __typename?: 'Interest', id: any, name: string }> };

export type HousingFragment = { __typename?: 'UserProfile', housing?: { __typename?: 'HousingObject', category: HousingCategory, name?: string | null } | null };

export type CommunityInboxPrivateQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type CommunityInboxPrivateQuery = { __typename?: 'Query', getUsersCommunityPrivateConversations: Array<{ __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, allMembers?: Array<{ __typename?: 'UserField', id?: string | null }> | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } }> };

export type AddVoteMutationVariables = Exact<{
  option: Scalars['String']['input'];
  chatMessageId: Scalars['ObjectId']['input'];
}>;


export type AddVoteMutation = { __typename?: 'Mutation', addVote: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } };

export type RemoveVoteMutationVariables = Exact<{
  option: Scalars['String']['input'];
  chatMessageId: Scalars['ObjectId']['input'];
}>;


export type RemoveVoteMutation = { __typename?: 'Mutation', removeVote: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } };

export type AddReactionToMessageMutationVariables = Exact<{
  reactionDto: ReactionDto;
}>;


export type AddReactionToMessageMutation = { __typename?: 'Mutation', addReactionToMessage: { __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null } };

export type RemoveReactionFromMessageMutationVariables = Exact<{
  reactionDto: ReactionDto;
}>;


export type RemoveReactionFromMessageMutation = { __typename?: 'Mutation', removeReactionFromMessage: { __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null } };

export type BlockCommunityUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockCommunityUserMutation = { __typename?: 'Mutation', createUniversityBlockReport?: { __typename?: 'CreateUniversityBlockReportMutation', error?: string | null, universityBlockReport?: { __typename?: 'UniversityBlockReportField', id?: string | null } | null } | null };

export type SetBlockUserV2MutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  setBlocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetBlockUserV2Mutation = { __typename?: 'Mutation', setBlockUserV2?: { __typename?: 'BlockUserMutationV2', objectsBlockedIds?: Array<string | null> | null } | null };

export type BlockedUsersListQueryVariables = Exact<{ [key: string]: never; }>;


export type BlockedUsersListQuery = { __typename?: 'Query', blockedUsersByMe?: Array<string | null> | null };

export type CreateDirectConversationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  userToConverseWith: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDirectConversationMutation = { __typename?: 'Mutation', createDirectConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } } };

export type DeleteConversationMessageMutationVariables = Exact<{
  deleteMessageDto: DeleteMessageDto;
}>;


export type DeleteConversationMessageMutation = { __typename?: 'Mutation', deleteConversationMessage: { __typename?: 'ChatMessage', id: string, created: any, text: string, deleted: boolean } };

export type CommunityLikeMessageMutationVariables = Exact<{
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
}>;


export type CommunityLikeMessageMutation = { __typename?: 'Mutation', likeConversationMessage: { __typename?: 'ChatMessage', id: string, likesCount: number, likes: Array<any> } };

export type CommunityChatMessagesQueryVariables = Exact<{
  getMessageDto: GetMessageDto;
}>;


export type CommunityChatMessagesQuery = { __typename?: 'Query', getChatConversationMessages: { __typename?: 'PaginatedChatMessages', hasMore: boolean, messages: Array<{ __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null }> } };

export type FullCommunityChatMessageFragment = { __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null };

export type CommunityChatMessageFragment = { __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null };

export type CommunityReplyRichContentFragment = { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } };

export type CommunityGiphyRichContentFragment = { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number };

export type CommunityImagesRichContentFragment = { __typename?: 'Image', url: string };

export type ReactionsFragment = { __typename?: 'ChatMessage', reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null };

export type CommunityAttachmentRichContentFragment = { __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null };

export type CommunityPollRichContentFragment = { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> };

export type CommunityPinMessageMutationVariables = Exact<{
  pinMessageDTO: PinMessageDto;
}>;


export type CommunityPinMessageMutation = { __typename?: 'Mutation', pinMessageInConversation: { __typename?: 'ChatConversation', pinnedMessages: Array<{ __typename?: 'ChatMessage', id: string }> } };

export type CommunityPinnedMessagesQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type CommunityPinnedMessagesQuery = { __typename?: 'Query', getChatConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, pinnedMessages: Array<{ __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null }> } };

export type CommunityPinnedMessageIdFragment = { __typename?: 'ChatConversation', pinnedMessages: Array<{ __typename?: 'ChatMessage', id: string }> };

export type CommunityConversationReadMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ObjectId']['input'];
}>;


export type CommunityConversationReadMutation = { __typename?: 'Mutation', recordLastMessageReadByUser: { __typename?: 'LastRead', userId: string, messageId: any, conversationId: string } };

export type CreateChatReportMutationVariables = Exact<{
  chatReportUserInputDTO: ChatReportUserInputDto;
}>;


export type CreateChatReportMutation = { __typename?: 'Mutation', createChatReport: { __typename?: 'ChatReport', id: string } };

export type SendCommunityChatMessageMutationVariables = Exact<{
  messageDto: MessageDto;
}>;


export type SendCommunityChatMessageMutation = { __typename?: 'Mutation', sendConversationMessage: { __typename?: 'ChatMessage', id: string, text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, reply?: { __typename?: 'ChatMessage', text: string, deleted: boolean, created: any, likes: Array<any>, likesCount: number, richContent?: { __typename?: 'RichMessageContent', giphy?: { __typename?: 'Giphy', id: string, type: GifType, width: number, height: number, aspectRatio: number } | null, images?: Array<{ __typename?: 'Image', url: string }> | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null } } | null, images?: Array<{ __typename?: 'Image', url: string }> | null, attachments?: Array<{ __typename?: 'Attachment', link: string, type: AttachmentType, size?: string | null, fileName?: string | null }> | null, poll?: { __typename?: 'Poll', allowMultipleAnswers: boolean, question: string, options: Array<{ __typename?: 'PollOption', option: string, votes: Array<any> }> } | null } | null, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, reactions?: Array<{ __typename?: 'Reaction', reaction: string, reactionUnicode: string, userIds: Array<string> }> | null } };

export type CommunityUnlikeMessageMutationVariables = Exact<{
  conversationId: Scalars['ObjectId']['input'];
  messageId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
}>;


export type CommunityUnlikeMessageMutation = { __typename?: 'Mutation', unlikeConversationMessage: { __typename?: 'ChatMessage', id: string, likesCount: number, likes: Array<any> } };

export type CommunityUnpinMessageMutationVariables = Exact<{
  unpinMessageDTO: UnpinMessageDto;
}>;


export type CommunityUnpinMessageMutation = { __typename?: 'Mutation', unpinMessageInConversation: { __typename?: 'ChatConversation', pinnedMessages: Array<{ __typename?: 'ChatMessage', id: string }> } };

export type GetCommunitiesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCommunitiesQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserField', id?: string | null, communities?: Array<{ __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }> | null } | null };

export type NewsFeedGroupsFragment = { __typename?: 'Community', newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null };

export type CommunitySettingsFragment = { __typename?: 'Community', settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null };

export type BlogPostsQueryQueryVariables = Exact<{
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  universityId?: InputMaybe<Scalars['String']['input']>;
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  degrees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  randomise?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogPostsQueryQuery = { __typename?: 'Query', allPostsInfo?: { __typename?: 'AllPostsField', blogPosts?: Array<{ __typename?: 'BlogPostField', id?: string | null, body?: string | null, title?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, topic?: { __typename?: 'BlogTopicField', name?: string | null } | null, videoContent?: { __typename?: 'VideoContent', id: string, status: VideoStatus, type: VideoTypeEnum, url: { __typename?: 'VideoUrl', url?: string | null } } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type BlogPostPreviewFragmentFragment = { __typename?: 'BlogPostField', id?: string | null, body?: string | null, title?: string | null, coverImages?: Array<string | null> | null, youtubeVideo?: string | null, topic?: { __typename?: 'BlogTopicField', name?: string | null } | null, videoContent?: { __typename?: 'VideoContent', id: string, status: VideoStatus, type: VideoTypeEnum, url: { __typename?: 'VideoUrl', url?: string | null } } | null, author?: { __typename?: 'MentorField', id?: string | null, firstName?: string | null, lastName?: string | null, profilePhoto?: string | null, degree?: { __typename?: 'DegreeField', id?: string | null, name?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, code?: string | null, name?: string | null } | null } | null };

export type GetUniversityFeaturesQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniversityFeaturesQuery = { __typename?: 'Query', university?: { __typename?: 'UniversityField', id?: string | null, config?: { __typename?: 'UniversityConfigField', features?: Array<{ __typename?: 'UniversityFeatureField', enabledByUnibuddy?: boolean | null, enabledByUniversity?: boolean | null, universityCanToggleFeature?: boolean | null, feature?: { __typename?: 'FeatureField', name?: string | null } | null } | null> | null } | null } | null };

export type CommunityCreatePrivateGroupMutationVariables = Exact<{
  createCommunityConversationDTO: CreateCommunityConversationDto;
}>;


export type CommunityCreatePrivateGroupMutation = { __typename?: 'Mutation', createCommunityConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } } };

export type LeaveCommunityChatGroupMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type LeaveCommunityChatGroupMutation = { __typename?: 'Mutation', leaveCommunityChatGroup: { __typename?: 'ChatConversation', id: string } };

export type CommunityInboxQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  offsetPagination?: InputMaybe<OffsetPagination>;
}>;


export type CommunityInboxQuery = { __typename?: 'Query', getUsersCommunityConversations: Array<{ __typename?: 'ChatConversation', id: string, product: Product, communityChatTitle?: string | null, mutedBy: Array<string>, isNewsFeed: boolean, isPrivate?: boolean | null, isDirect?: boolean | null, unreadMessageCount?: number | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null }, members?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null }> };

export type InboxConversationFragment = { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } };

export type GetInviteLinkInfoQueryVariables = Exact<{
  inviteLinkId: Scalars['String']['input'];
}>;


export type GetInviteLinkInfoQuery = { __typename?: 'Query', getInviteLinkInfo: { __typename?: 'InviteLinkInfoDto', id: string, valid: boolean, communityId: string, communityTitle: string, universityName: string, squareLogo?: string | null, universitySlug: string, privacyPolicyUrl?: string | null } };

export type JoinCommunityByInviteLinkMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type JoinCommunityByInviteLinkMutation = { __typename?: 'Mutation', joinCommunityByInviteLink: { __typename?: 'CommunityJoinResponse', alreadyJoined?: boolean | null, joined: boolean, community: { __typename?: 'Community', id: string, title?: string | null, members?: Array<{ __typename?: 'UserField', id?: string | null }> | null, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } } };

export type GetJoinGroupDataQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
}>;


export type GetJoinGroupDataQuery = { __typename?: 'Query', getCommunityForUser: { __typename?: 'Community', id: string, title?: string | null, description?: string | null, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }, getCommunityConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null } };

export type GetAreaOfStudyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAreaOfStudyQuery = { __typename?: 'Query', getUserProfile: { __typename?: 'UserProfile', areaOfStudy?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null }> | null } };

export type GetCommunityUserSearchQueryVariables = Exact<{
  pagination: OffsetPagination;
  filterUsers: FilterUsersDto;
}>;


export type GetCommunityUserSearchQuery = { __typename?: 'Query', communityUserSearch: { __typename?: 'UserDirectoryResult', totalUsers: number, result: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null }> } };

export type GetRecommendedUsersQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchingCriterion?: InputMaybe<MatchingCriteriaEnum>;
}>;


export type GetRecommendedUsersQuery = { __typename?: 'Query', getRecommendedUsers: { __typename?: 'UserRecommendation', totalMatches: number, type: string, currentUser: { __typename?: 'UserField', id?: string | null, accountRole?: string | null, firstName?: string | null, lastName?: string | null, university?: { __typename?: 'UniversityField', name?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, matches: Array<{ __typename?: 'MatchedUser', matchingCriteria: Array<string>, matchingPercentage: number, user: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, lastName?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null } }> } };

export type RecommendedUsersFragment = { __typename?: 'UserRecommendation', totalMatches: number, type: string, currentUser: { __typename?: 'UserField', id?: string | null, accountRole?: string | null, firstName?: string | null, lastName?: string | null, university?: { __typename?: 'UniversityField', name?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, matches: Array<{ __typename?: 'MatchedUser', matchingCriteria: Array<string>, matchingPercentage: number, user: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, lastName?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null } }> };

export type GetRecommendedUsersByNationalityCriterionQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  nationalityCriterion: MatchingCriteriaEnum;
}>;


export type GetRecommendedUsersByNationalityCriterionQuery = { __typename?: 'Query', nationalityRecommendedUsers: { __typename?: 'UserRecommendation', totalMatches: number, type: string, currentUser: { __typename?: 'UserField', id?: string | null, accountRole?: string | null, firstName?: string | null, lastName?: string | null, university?: { __typename?: 'UniversityField', name?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, matches: Array<{ __typename?: 'MatchedUser', matchingCriteria: Array<string>, matchingPercentage: number, user: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, lastName?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null } }> } };

export type GetRecommendedUsersByCriterionQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<OffsetPagination>;
  matchingCriterion?: InputMaybe<MatchingCriteriaEnum>;
}>;


export type GetRecommendedUsersByCriterionQuery = { __typename?: 'Query', recommendedUsers: { __typename?: 'UserRecommendation', totalMatches: number, type: string, currentUser: { __typename?: 'UserField', id?: string | null, accountRole?: string | null, firstName?: string | null, lastName?: string | null, university?: { __typename?: 'UniversityField', name?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }, matches: Array<{ __typename?: 'MatchedUser', matchingCriteria: Array<string>, matchingPercentage: number, user: { __typename?: 'UserField', id?: string | null, firstName?: string | null, profilePhoto?: string | null, accountRole?: string | null, lastName?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null } }> } };

export type GetRecommendedGroupsQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type GetRecommendedGroupsQuery = { __typename?: 'Query', getRecommendedConversations: Array<{ __typename?: 'ChatConversation', id: string, title?: string | null, description?: string | null, members?: Array<{ __typename?: 'UserField', id?: string | null }> | null, membersWithProfilePhoto?: Array<{ __typename?: 'UserField', id?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null }> };

export type GetTopicsAndUserInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopicsAndUserInterestsQuery = { __typename?: 'Query', topics?: Array<{ __typename?: 'TopicField', id?: string | null, name?: string | null, description?: string | null } | null> | null, getUserProfile: { __typename?: 'UserProfile', id: string, userId: string, interests?: Array<{ __typename?: 'InterestObject', id: string, type: string }> | null } };

export type SetUserProfileMutationVariables = Exact<{
  data: UpdateUserProfile;
}>;


export type SetUserProfileMutation = { __typename?: 'Mutation', setUserProfile: { __typename?: 'UserProfile', id: string, userId: string, profilePhoto?: string | null, bio?: string | null, pronouns?: string | null, interests?: Array<{ __typename?: 'InterestObject', id: string, type: string }> | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null }> | null, housing?: { __typename?: 'HousingObject', category: HousingCategory, name?: string | null } | null } };

export type AddToFeatureExperimentMutationVariables = Exact<{
  metadata: Scalars['String']['input'];
  experimentName: Scalars['String']['input'];
}>;


export type AddToFeatureExperimentMutation = { __typename?: 'Mutation', addToFeatureExperiment: boolean };

export type RequestPublicGroupMutationVariables = Exact<{
  requestPublicGroupInput: CreateRequestedPublicGroupInput;
}>;


export type RequestPublicGroupMutation = { __typename?: 'Mutation', requestPublicGroup: { __typename?: 'RequestedPublicGroup', id?: string | null } };

export type AllCommunityChatGroupsQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type AllCommunityChatGroupsQuery = { __typename?: 'Query', getChatGroupsForCommunity: Array<{ __typename?: 'CommunityChatGroup', id: string, title: string, description?: string | null, conversation: { __typename?: 'ChatConversation', id: string }, members?: Array<{ __typename?: 'UserField', id?: string | null, profilePhoto?: string | null }> | null }> };

export type GetCommunityConversationsGroupsQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  offsetPagination: OffsetPagination;
}>;


export type GetCommunityConversationsGroupsQuery = { __typename?: 'Query', getCommunityConversations: Array<{ __typename?: 'ChatConversation', totalMemberCount?: number | null, id: string, deleted?: boolean | null, communityId?: string | null, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, communityProfile?: { __typename?: 'UserProfile', profilePhoto?: string | null } | null }> | null, labels?: Array<{ __typename?: 'Labels', id: string, name?: string | null }> | null }> };

export type JoinCommunityConversationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JoinCommunityConversationMutation = { __typename?: 'Mutation', joinCommunityConversation: { __typename?: 'ChatConversation', id: string, communityChatTitle?: string | null, communityChatDescription?: string | null, communityChatDynamicLink?: string | null, unreadMessageCount?: number | null, mutedBy: Array<string>, product: Product, isPrivate?: boolean | null, isNewsFeed: boolean, isDirect?: boolean | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null, communityChatMembers?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null } } };

export type GetAllDegreesQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllDegreesQuery = { __typename?: 'Query', allDegrees?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null } | null> | null, getUserProfile: { __typename?: 'UserProfile', id: string, areaOfStudy?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null }> | null } };

export type DegreeFragment = { __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null };

export type GetExperimentalTodosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExperimentalTodosQuery = { __typename?: 'Query', getExperimentalTodos: string };

export type GetTodosForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTodosForUserQuery = { __typename?: 'Query', getTodosForUser: Array<{ __typename?: 'TodosEntity', id: string, title: string, status: TodoStatus, externalLink?: string | null, description?: string | null, deadline?: any | null }> };

export type UpdateTodoActionMutationVariables = Exact<{
  updateTodoActionId: Scalars['String']['input'];
  action: TodoAction;
}>;


export type UpdateTodoActionMutation = { __typename?: 'Mutation', updateTodoAction: string };

export type GetCommunityForUserQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type GetCommunityForUserQuery = { __typename?: 'Query', getCommunityForUser: { __typename?: 'Community', id: string, title?: string | null, description?: string | null, members?: Array<{ __typename?: 'UserField', id?: string | null }> | null, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null }> | null } };

export type GetDiscoverableUniversitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  randomizeSeed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDiscoverableUniversitiesQuery = { __typename?: 'Query', discoverableUniversities?: Array<{ __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null, slug?: string | null, privacyPolicyUrl?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null } | null> | null };

export type GetUniversityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniversityQuery = { __typename?: 'Query', university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null, slug?: string | null, privacyPolicyUrl?: string | null, customAttributes?: Array<{ __typename?: 'BaseCustomAttributeField', id?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, type?: string | null } | null> | null, entries?: { __typename?: 'EntriesField', active?: boolean | null, entryMonths?: Array<number | null> | null } | null } | null };

export type DiscoverableUniversityFragment = { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null, slug?: string | null, privacyPolicyUrl?: string | null };

export type DiscoverableUniversityCountryFieldFragment = { __typename?: 'UniversityField', country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null };

export type DiscoverableUniversityCustomAttributesFragment = { __typename?: 'UniversityField', customAttributes?: Array<{ __typename?: 'BaseCustomAttributeField', id?: string | null, type?: string | null } | { __typename?: 'SingleChoiceAttributeField', id?: string | null, type?: string | null } | null> | null };

export type DiscoverableUniversityEntriesFragment = { __typename?: 'UniversityField', entries?: { __typename?: 'EntriesField', active?: boolean | null, entryMonths?: Array<number | null> | null } | null };

export type SaveUniversityInterestedMutationVariables = Exact<{
  universityInterestedDto: UniversityInterestedDto;
}>;


export type SaveUniversityInterestedMutation = { __typename?: 'Mutation', saveUniversityInterested: { __typename?: 'UniversityInterestedEntity', name: string } };

export type UpdateUniversityLinkMutationVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  sourceTrackingParams?: InputMaybe<Scalars['JSONString']['input']>;
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUniversityLinkMutation = { __typename?: 'Mutation', updateMyUniversityLink?: { __typename?: 'UpdateMyUniversityLinkMutation', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', id?: string | null } | null } | null } | null };

export type UpdateUniversityLinkStep2MutationVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  degreesInterested?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateOfEntry?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateUniversityLinkStep2Mutation = { __typename?: 'Mutation', updateMyUniversityLink?: { __typename?: 'UpdateMyUniversityLinkMutation', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', id?: string | null } | null } | null } | null };

export type GetLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabelsQuery = { __typename?: 'Query', getLabels: Array<{ __typename?: 'Labels', id: string, name?: string | null }> };

export type GetGeckoUniversityQueryVariables = Exact<{
  universityId: Scalars['String']['input'];
}>;


export type GetGeckoUniversityQuery = { __typename?: 'Query', getGeckoUniversityId?: { __typename?: 'GeckoUniversityData', geckoUniversityId?: string | null, geckoUniversityName?: string | null } | null };

export type UniversityQuestionsQueryVariables = Exact<{
  confidenceRatingQuestionInput: UniversityQuestionByIdInput;
  feelConfidentQuestionInput: UniversityQuestionByIdInput;
}>;


export type UniversityQuestionsQuery = { __typename?: 'Query', question1: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null }, question2: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null } };

export type SaveUniversityQuestionAnswerMutationVariables = Exact<{
  saveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput;
}>;


export type SaveUniversityQuestionAnswerMutation = { __typename?: 'Mutation', saveUniversityQuestionAnswer: Array<{ __typename?: 'UniversityQuestionAnswer', id: any }> };

export type EnrolledUniversityQuestionsQueryVariables = Exact<{
  haveEnrolledQuestionInput: UniversityQuestionByIdInput;
  enrolledCommunityInfluenceRatingQuestionInput: UniversityQuestionByIdInput;
  enrolledMoreInfo: UniversityQuestionByIdInput;
  enroledWhatInfluencedDecision: UniversityQuestionByIdInput;
  didCommunityHelpedInDecision: UniversityQuestionByIdInput;
}>;


export type EnrolledUniversityQuestionsQuery = { __typename?: 'Query', question1: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null }, question2: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null }, question3: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null }, question4: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null }, question5: { __typename?: 'UniversityQuestion', id: any, active: boolean, text: string, options?: Array<{ __typename?: 'UniversityQuestionOption', text: string, id: any }> | null } };

export type SendCommunityFeedbackMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  universitySlug: Scalars['String']['input'];
  question: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendCommunityFeedbackMutation = { __typename?: 'Mutation', saveSatisfactionSurvey: { __typename?: 'SatisfactionSurveyEntity', userId: string, communityId: string, universitySlug: string } };

export type InboxPromptQuestionsQueryVariables = Exact<{
  inboxPromptInput: InboxPromptInput;
}>;


export type InboxPromptQuestionsQuery = { __typename?: 'Query', inboxPromptQuestions: Array<{ __typename?: 'InboxPromptQuestion', id: any, tags: Array<string>, options: Array<{ __typename?: 'InboxPromptOption', id: any, text: string, active: boolean }> }> };

export type SaveInboxPromptAnswerMutationVariables = Exact<{
  inboxPromptAnswerInput: InboxPromptAnswerInput;
}>;


export type SaveInboxPromptAnswerMutation = { __typename?: 'Mutation', saveInboxPromptAnswer: Array<{ __typename?: 'InboxPromptAnswer', id: any }> };

export type GetUserCreatedByUserIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserCreatedByUserIdQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserField', id?: string | null, firstName?: string | null, created?: any | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null } | null };

export type SaveNotInterestedStageMutationVariables = Exact<{
  notInterestedStageInput: UserNotInterestedStageInput;
}>;


export type SaveNotInterestedStageMutation = { __typename?: 'Mutation', saveNotInterestedStage: { __typename?: 'UserDecisionStageOutput', decisionStage: DecisionStageEnum, decisionStageLocation: DecisionStageLocationEnum, notInterestedReason?: NotInterestedReasonEnum | null, userId: any } };

export type SaveUserDecisionStageMutationVariables = Exact<{
  decisionStageInput: UserDecisionStageInput;
}>;


export type SaveUserDecisionStageMutation = { __typename?: 'Mutation', saveUserDecisionStage: { __typename?: 'UserDecisionStageOutput', decisionStage: DecisionStageEnum, decisionStageLocation: DecisionStageLocationEnum, notInterestedReason?: NotInterestedReasonEnum | null, userId: any } };

export type GetConversationPermissionQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type GetConversationPermissionQuery = { __typename?: 'Query', getConversationPermission: { __typename?: 'ChatPermission', id: string, isMember: boolean } };

export type GetInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterestsQuery = { __typename?: 'Query', getInterests: Array<{ __typename?: 'Interest', id: any, name: string }> };

export type GetCommunityUserDirectoryQueryVariables = Exact<{
  pagination: OffsetPagination;
  filterUsers: FilterUsersDto;
}>;


export type GetCommunityUserDirectoryQuery = { __typename?: 'Query', communityUserSearch: { __typename?: 'UserDirectoryResult', totalUsers: number, result: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null, bio?: string | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', name?: string | null }> | null, interests?: Array<{ __typename?: 'InterestObject', type: string }> | null } | null }> } };

export type SetInterestsForUserMutationVariables = Exact<{
  setUserInterestsInput: SetUserInterestsInput;
}>;


export type SetInterestsForUserMutation = { __typename?: 'Mutation', setInterestsForUser: Array<{ __typename?: 'UserInterest', id: any, name: string }> };

export type GetAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesQuery = { __typename?: 'Query', allCountries?: Array<{ __typename?: 'CountryField', code?: string | null, id?: string | null, name?: string | null } | null> | null };

export type UpdateApplicantDetailsMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateApplicantDetailsMutation = { __typename?: 'Mutation', updateApplicant?: { __typename?: 'UpdateApplicantMutation', me?: { __typename?: 'MeField', applicant?: { __typename?: 'ApplicantField', id?: string | null } | null, anyUser?: { __typename?: 'AnyUserField', firstName?: string | null, lastName?: string | null, country?: { __typename?: 'CountryField', name?: string | null, code?: string | null, id?: string | null } | null } | null } | null } | null };

export type GetAccountInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountInformationQuery = { __typename?: 'Query', getUserProfile: { __typename?: 'UserProfile', id: string, userId: string, profilePhoto?: string | null, bio?: string | null, pronouns?: string | null, interests?: Array<{ __typename?: 'InterestObject', id: string, type: string }> | null, areaOfStudy?: Array<{ __typename?: 'DegreeField', id?: string | null, name?: string | null, degreeType?: Array<DegreeType | null> | null, active?: boolean | null }> | null, housing?: { __typename?: 'HousingObject', category: HousingCategory, name?: string | null } | null }, getInterests: Array<{ __typename?: 'Interest', id: any, name: string }>, getInterestsForUser: Array<{ __typename?: 'UserInterest', id: any, name: string }> };

export type InitiateUserDeletionMutationVariables = Exact<{ [key: string]: never; }>;


export type InitiateUserDeletionMutation = { __typename?: 'Mutation', initiateUserDeletion: boolean };

export type SequenceFilterMentorListQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['LimitedInt']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  mentorSeed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SequenceFilterMentorListQuery = { __typename?: 'Query', sequenceFilterMentorList?: { __typename?: 'SequenceFilterMentorListField', mentors?: Array<{ __typename?: 'PublicMentorField', lastSeen?: string | null, bio?: string | null, isOnline?: boolean | null, id?: string | null, firstName?: string | null, accountRole?: string | null, profilePhoto?: string | null, degree?: { __typename?: 'DegreeField', name?: string | null } | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, slug?: string | null } | null, country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null, mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null } | null } | null> | null } | null };

export type BuddiesQueryVariables = Exact<{
  universitySlug?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BuddiesQuery = { __typename?: 'Query', buddies?: { __typename?: 'BuddiesField', count?: number | null, users?: Array<{ __typename?: 'BuddyField', id?: string | null, active?: boolean | null, firstName?: string | null, lastName?: string | null, shareUrl?: string | null, profilePhoto?: string | null, staffFields?: { __typename?: 'StaffUserFieldsField', bio?: string | null, department?: string | null, role?: string | null } | null } | null> | null } | null };

export type GetSpacesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type GetSpacesQuery = { __typename?: 'Query', me?: { __typename?: 'MeField', anyUser?: { __typename?: 'AnyUserField', id?: string | null } | null, applicant?: { __typename?: 'ApplicantField', id?: string | null, applicantUniversities?: Array<{ __typename?: 'ApplicantUniversityLinkField', university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, slug?: string | null, squareLogo?: string | null } | null } | null> | null } | null } | null, getUser?: { __typename?: 'UserField', id?: string | null, communities?: Array<{ __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }> | null } | null, getInvitesForEmail: Array<{ __typename?: 'GetInvitesForEmailDTO', id: string, community: { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } }> };

export type CommunitySpacesFragment = { __typename?: 'UserField', communities?: Array<{ __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null }> | null };

export type CommunityInviteSpacesFragment = { __typename?: 'GetInvitesForEmailDTO', community: { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null } };

export type CommunityFragment = { __typename?: 'Community', id: string, title?: string | null, communityMemberCount: number, institutions?: Array<{ __typename?: 'UniversityField', id?: string | null, logo?: string | null, slug?: string | null, name?: string | null, squareLogo?: string | null, colour?: string | null, privacyPolicyUrl?: string | null, isFeatureEnabled?: boolean | null }> | null, settings?: { __typename?: 'SettingsObjectType', allowGifs?: boolean | null, allowPrivateGroups: boolean, allowImages: boolean, allowDirectChat: boolean, allowNewsFeed: boolean, allowExternalEventsIntegration: boolean } | null, newsFeedGroups?: Array<{ __typename?: 'NewsFeedGroup', conversationId: string }> | null };

export type ApplicantUniversityFieldFragment = { __typename?: 'UniversityField', id?: string | null, name?: string | null, slug?: string | null, squareLogo?: string | null };

export type UniversalInboxQueryVariables = Exact<{
  offsetPagination?: InputMaybe<OffsetPaginationDto>;
}>;


export type UniversalInboxQuery = { __typename?: 'Query', getChatConversationsForUser: Array<{ __typename?: 'ChatConversation', id: string, product: Product, communityChatTitle?: string | null, mutedBy: Array<string>, isNewsFeed: boolean, isPrivate?: boolean | null, isDirect?: boolean | null, unreadMessageCount?: number | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null }, members?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null }> };

export type LastMessageFragmentFragment = { __typename?: 'ChatConversation', id: string, unreadMessageCount?: number | null, lastMessage?: { __typename?: 'ChatMessage', id: string, created: any, text: string, sender: { __typename?: 'UserField', id?: string | null, firstName?: string | null } } | null };

export type UniversalInboxConversationFragment = { __typename?: 'ChatConversation', id: string, product: Product, communityChatTitle?: string | null, mutedBy: Array<string>, isNewsFeed: boolean, isPrivate?: boolean | null, isDirect?: boolean | null, university: { __typename?: 'UniversityField', id?: string | null, name?: string | null, squareLogo?: string | null }, members?: Array<{ __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null, communityProfile?: { __typename?: 'UserProfile', id: string, profilePhoto?: string | null } | null }> | null };

export type UserFieldProfileDataFragment = { __typename?: 'UserField', id?: string | null, firstName?: string | null, lastName?: string | null, accountRole?: string | null, profilePhoto?: string | null };

export type UserFieldProfileCountryFragment = { __typename?: 'UserField', country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null };

export type PublicMentorFieldProfileDataFragment = { __typename?: 'PublicMentorField', id?: string | null, firstName?: string | null, accountRole?: string | null, profilePhoto?: string | null, university?: { __typename?: 'UniversityField', id?: string | null, name?: string | null, slug?: string | null } | null };

export type PublicMentorFieldProfileCountryFragment = { __typename?: 'PublicMentorField', country?: { __typename?: 'CountryField', id?: string | null, name?: string | null, code?: string | null } | null };

export type PublicMentorFieldFlagsFragment = { __typename?: 'PublicMentorField', mentorFields?: { __typename?: 'MentorFields', primaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null, secondaryFlag?: { __typename?: 'FlagField', name?: string | null, code?: string | null } | null } | null };

export type PublicBuddyFieldProfileDataFragment = { __typename?: 'BuddyField', id?: string | null, active?: boolean | null, firstName?: string | null, lastName?: string | null, shareUrl?: string | null, profilePhoto?: string | null };

export type PublicStaffFieldsFragment = { __typename?: 'BuddyField', staffFields?: { __typename?: 'StaffUserFieldsField', bio?: string | null, department?: string | null, role?: string | null } | null };

export type ChangeCommunityPasswordMutationVariables = Exact<{
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeCommunityPasswordMutation = { __typename?: 'Mutation', resetPasswordV2?: { __typename?: 'ResetPasswordMutationV2', success?: boolean | null, redirectUrl?: string | null, error?: string | null } | null };

export type CommunityRequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type CommunityRequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'RequestPasswordResetMutation', success?: boolean | null } | null };

export type SaveCookieConsentPreferencesMutationVariables = Exact<{
  input: CookieConsentInputDto;
}>;


export type SaveCookieConsentPreferencesMutation = { __typename?: 'Mutation', saveCookieConsentPreferences: { __typename?: 'CookieConsentOutputDTO', uniqueId: string, preferences: { __typename?: 'PreferencesOutputType', strictCookies: boolean, analyticsCookies: boolean } } };

export type EditCookieConsentPreferencesMutationVariables = Exact<{
  input: CookieConsentInputDto;
}>;


export type EditCookieConsentPreferencesMutation = { __typename?: 'Mutation', editCookieConsentPreferences: { __typename?: 'CookieConsentOutputDTO', uniqueId: string, preferences: { __typename?: 'PreferencesOutputType', strictCookies: boolean, analyticsCookies: boolean } } };

export const CommunityFieldsFragmentDoc = gql`
    fragment CommunityFields on ChatConversation {
  communityChatTitle
  communityChatDescription
  communityId
  communityChatDynamicLink
  mutedBy
  totalMemberCount
  communityChatMembers: members(offsetPagination: {limit: 15}) {
    id
    profilePhoto
    firstName
    accountRole
    communityProfile {
      id
      profilePhoto
    }
  }
}
    `;
export const AllMembersFragmentDoc = gql`
    fragment AllMembers on ChatConversation {
  allMembers: communityChatMembers(offsetPagination: {limit: 999}) {
    id
  }
}
    `;
export const InterestsFragmentDoc = gql`
    fragment Interests on UserField {
  interests {
    id
    name
  }
}
    `;
export const HousingFragmentDoc = gql`
    fragment Housing on UserProfile {
  housing {
    category
    name
  }
}
    `;
export const ReactionsFragmentDoc = gql`
    fragment Reactions on ChatMessage {
  reactions {
    reaction
    reactionUnicode
    userIds
  }
}
    `;
export const CommunityChatMessageFragmentDoc = gql`
    fragment CommunityChatMessage on ChatMessage {
  id
  text
  deleted
  created
  likes
  likesCount
  sender {
    id
    firstName
    profilePhoto
    accountRole
    country {
      id
      name
      code
    }
    communityProfile {
      id
      profilePhoto
    }
  }
  ...Reactions
}
    ${ReactionsFragmentDoc}`;
export const CommunityGiphyRichContentFragmentDoc = gql`
    fragment CommunityGiphyRichContent on Giphy {
  id
  type
  width
  height
  aspectRatio
}
    `;
export const CommunityReplyRichContentFragmentDoc = gql`
    fragment CommunityReplyRichContent on ChatMessage {
  text
  deleted
  created
  likes
  likesCount
  sender {
    id
    firstName
    profilePhoto
    accountRole
    communityProfile {
      id
      profilePhoto
    }
  }
}
    `;
export const CommunityImagesRichContentFragmentDoc = gql`
    fragment CommunityImagesRichContent on Image {
  url
}
    `;
export const CommunityAttachmentRichContentFragmentDoc = gql`
    fragment CommunityAttachmentRichContent on Attachment {
  link
  type
  size
  fileName
}
    `;
export const CommunityPollRichContentFragmentDoc = gql`
    fragment CommunityPollRichContent on Poll {
  allowMultipleAnswers
  question
  options {
    option
    votes
  }
}
    `;
export const FullCommunityChatMessageFragmentDoc = gql`
    fragment FullCommunityChatMessage on ChatMessage {
  ...CommunityChatMessage
  richContent {
    giphy {
      ...CommunityGiphyRichContent
    }
    reply {
      ...CommunityReplyRichContent
      richContent {
        giphy {
          ...CommunityGiphyRichContent
        }
        images {
          ...CommunityImagesRichContent
        }
        attachments {
          ...CommunityAttachmentRichContent
        }
      }
    }
    images {
      ...CommunityImagesRichContent
    }
    attachments {
      ...CommunityAttachmentRichContent
    }
    poll {
      ...CommunityPollRichContent
    }
  }
}
    ${CommunityChatMessageFragmentDoc}
${CommunityGiphyRichContentFragmentDoc}
${CommunityReplyRichContentFragmentDoc}
${CommunityImagesRichContentFragmentDoc}
${CommunityAttachmentRichContentFragmentDoc}
${CommunityPollRichContentFragmentDoc}`;
export const CommunityPinnedMessageIdFragmentDoc = gql`
    fragment CommunityPinnedMessageId on ChatConversation {
  pinnedMessages {
    id
  }
}
    `;
export const BlogPostPreviewFragmentFragmentDoc = gql`
    fragment BlogPostPreviewFragment on BlogPostField {
  id
  body
  title
  coverImages(raw: true)
  youtubeVideo
  topic {
    name
  }
  videoContent {
    id
    status
    type
    url {
      url
    }
  }
  author {
    id
    firstName
    lastName
    profilePhoto
    degree {
      id
      name
    }
    country {
      id
      code
      name
    }
  }
}
    `;
export const GroupTypesFragmentDoc = gql`
    fragment GroupTypes on ChatConversation {
  isPrivate
  isNewsFeed
  isDirect
}
    `;
export const InboxConversationFragmentDoc = gql`
    fragment InboxConversation on ChatConversation {
  id
  communityChatTitle
  communityChatDescription
  communityChatDynamicLink
  unreadMessageCount
  mutedBy
  ...GroupTypes
  lastMessage {
    id
    sender {
      id
      firstName
    }
    created
    text
  }
  communityChatMembers(offsetPagination: {offset: 0, limit: 2}) {
    id
    firstName
    lastName
    accountRole
    profilePhoto
    communityProfile {
      id
      profilePhoto
    }
  }
  university {
    id
    name
    squareLogo
  }
  product
}
    ${GroupTypesFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on UserField {
  country {
    id
    name
    code
  }
}
    `;
export const CommunityProfileFragmentDoc = gql`
    fragment CommunityProfile on UserField {
  communityProfile {
    id
    profilePhoto
    bio
    areaOfStudy {
      name
    }
    interests {
      type
    }
  }
}
    `;
export const RecommendedUsersFragmentDoc = gql`
    fragment RecommendedUsers on UserRecommendation {
  currentUser {
    id
    accountRole
    firstName
    lastName
    university {
      name
    }
    communityProfile {
      id
      profilePhoto
    }
  }
  matches {
    matchingCriteria
    matchingPercentage
    user {
      id
      firstName
      profilePhoto
      accountRole
      lastName
      ...Country
      ...CommunityProfile
    }
  }
  totalMatches
  type
}
    ${CountryFragmentDoc}
${CommunityProfileFragmentDoc}`;
export const DegreeFragmentDoc = gql`
    fragment Degree on DegreeField {
  id
  name
  degreeType
  active
}
    `;
export const DiscoverableUniversityFragmentDoc = gql`
    fragment DiscoverableUniversity on UniversityField {
  id
  name
  squareLogo
  slug
  privacyPolicyUrl
}
    `;
export const DiscoverableUniversityCountryFieldFragmentDoc = gql`
    fragment DiscoverableUniversityCountryField on UniversityField {
  country {
    id
    name
    code
  }
}
    `;
export const DiscoverableUniversityCustomAttributesFragmentDoc = gql`
    fragment DiscoverableUniversityCustomAttributes on UniversityField {
  customAttributes(destination: "applicant_profile", active: true) {
    id
    type
  }
}
    `;
export const DiscoverableUniversityEntriesFragmentDoc = gql`
    fragment DiscoverableUniversityEntries on UniversityField {
  entries {
    active
    entryMonths
  }
}
    `;
export const CommunitySettingsFragmentDoc = gql`
    fragment CommunitySettings on Community {
  settings {
    allowGifs
    allowPrivateGroups
    allowImages
    allowDirectChat
    allowNewsFeed
    allowExternalEventsIntegration
  }
}
    `;
export const NewsFeedGroupsFragmentDoc = gql`
    fragment NewsFeedGroups on Community {
  newsFeedGroups {
    conversationId
  }
}
    `;
export const CommunityFragmentDoc = gql`
    fragment Community on Community {
  id
  title
  communityMemberCount
  institutions {
    id
    logo
    slug
    name
    squareLogo
    colour
    privacyPolicyUrl
    isFeatureEnabled(feature: "community")
  }
  ...CommunitySettings
  ...NewsFeedGroups
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}`;
export const CommunitySpacesFragmentDoc = gql`
    fragment CommunitySpaces on UserField {
  communities {
    ...Community
  }
}
    ${CommunityFragmentDoc}`;
export const CommunityInviteSpacesFragmentDoc = gql`
    fragment CommunityInviteSpaces on GetInvitesForEmailDTO {
  community {
    ...Community
  }
}
    ${CommunityFragmentDoc}`;
export const ApplicantUniversityFieldFragmentDoc = gql`
    fragment ApplicantUniversityField on UniversityField {
  id
  name
  slug
  squareLogo
}
    `;
export const LastMessageFragmentFragmentDoc = gql`
    fragment LastMessageFragment on ChatConversation {
  id
  unreadMessageCount
  lastMessage {
    id
    sender {
      id
      firstName
    }
    created
    text
  }
}
    `;
export const UserFieldProfileDataFragmentDoc = gql`
    fragment UserFieldProfileData on UserField {
  id
  firstName
  lastName
  accountRole
  profilePhoto
}
    `;
export const UniversalInboxConversationFragmentDoc = gql`
    fragment UniversalInboxConversation on ChatConversation {
  id
  product
  communityChatTitle
  mutedBy
  isNewsFeed
  isPrivate
  isDirect
  university {
    id
    name
    squareLogo
  }
  members(offsetPagination: {offset: 0, limit: 2}) {
    ...UserFieldProfileData
    communityProfile {
      id
      profilePhoto
    }
  }
}
    ${UserFieldProfileDataFragmentDoc}`;
export const UserFieldProfileCountryFragmentDoc = gql`
    fragment UserFieldProfileCountry on UserField {
  country {
    id
    name
    code
  }
}
    `;
export const PublicMentorFieldProfileDataFragmentDoc = gql`
    fragment PublicMentorFieldProfileData on PublicMentorField {
  id
  firstName
  accountRole
  profilePhoto
  university {
    id
    name
    slug
  }
}
    `;
export const PublicMentorFieldProfileCountryFragmentDoc = gql`
    fragment PublicMentorFieldProfileCountry on PublicMentorField {
  country {
    id
    name
    code
  }
}
    `;
export const PublicMentorFieldFlagsFragmentDoc = gql`
    fragment PublicMentorFieldFlags on PublicMentorField {
  mentorFields {
    primaryFlag {
      name
      code
    }
    secondaryFlag {
      name
      code
    }
  }
}
    `;
export const PublicBuddyFieldProfileDataFragmentDoc = gql`
    fragment PublicBuddyFieldProfileData on BuddyField {
  id
  active
  firstName
  lastName
  shareUrl
  profilePhoto(raw: true)
}
    `;
export const PublicStaffFieldsFragmentDoc = gql`
    fragment PublicStaffFields on BuddyField {
  staffFields {
    bio
    department
    role
  }
}
    `;
export const GetEmailAddressFromInviteIdDocument = gql`
    query GetEmailAddressFromInviteId($inviteId: String!) {
  getInviteFromId(inviteId: $inviteId) {
    valid
    id
    invitedEmail
    communityId
  }
}
    `;

/**
 * __useGetEmailAddressFromInviteIdQuery__
 *
 * To run a query within a React component, call `useGetEmailAddressFromInviteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAddressFromInviteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAddressFromInviteIdQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useGetEmailAddressFromInviteIdQuery(baseOptions: Apollo.QueryHookOptions<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables> & ({ variables: GetEmailAddressFromInviteIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>(GetEmailAddressFromInviteIdDocument, options);
      }
export function useGetEmailAddressFromInviteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>(GetEmailAddressFromInviteIdDocument, options);
        }
export function useGetEmailAddressFromInviteIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>(GetEmailAddressFromInviteIdDocument, options);
        }
export type GetEmailAddressFromInviteIdQueryHookResult = ReturnType<typeof useGetEmailAddressFromInviteIdQuery>;
export type GetEmailAddressFromInviteIdLazyQueryHookResult = ReturnType<typeof useGetEmailAddressFromInviteIdLazyQuery>;
export type GetEmailAddressFromInviteIdSuspenseQueryHookResult = ReturnType<typeof useGetEmailAddressFromInviteIdSuspenseQuery>;
export type GetEmailAddressFromInviteIdQueryResult = Apollo.QueryResult<GetEmailAddressFromInviteIdQuery, GetEmailAddressFromInviteIdQueryVariables>;
export const GetInviteInformationDocument = gql`
    query GetInviteInformation($inviteInformationInput: InviteInformationInput!) {
  getInviteInformation(InviteInformationInput: $inviteInformationInput) {
    community {
      description
      title
      id
    }
    id
    university {
      name
      slug
      id
      squareLogo
    }
  }
}
    `;

/**
 * __useGetInviteInformationQuery__
 *
 * To run a query within a React component, call `useGetInviteInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteInformationQuery({
 *   variables: {
 *      inviteInformationInput: // value for 'inviteInformationInput'
 *   },
 * });
 */
export function useGetInviteInformationQuery(baseOptions: Apollo.QueryHookOptions<GetInviteInformationQuery, GetInviteInformationQueryVariables> & ({ variables: GetInviteInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteInformationQuery, GetInviteInformationQueryVariables>(GetInviteInformationDocument, options);
      }
export function useGetInviteInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteInformationQuery, GetInviteInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteInformationQuery, GetInviteInformationQueryVariables>(GetInviteInformationDocument, options);
        }
export function useGetInviteInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInviteInformationQuery, GetInviteInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInviteInformationQuery, GetInviteInformationQueryVariables>(GetInviteInformationDocument, options);
        }
export type GetInviteInformationQueryHookResult = ReturnType<typeof useGetInviteInformationQuery>;
export type GetInviteInformationLazyQueryHookResult = ReturnType<typeof useGetInviteInformationLazyQuery>;
export type GetInviteInformationSuspenseQueryHookResult = ReturnType<typeof useGetInviteInformationSuspenseQuery>;
export type GetInviteInformationQueryResult = Apollo.QueryResult<GetInviteInformationQuery, GetInviteInformationQueryVariables>;
export const AdminLobbyDocument = gql`
    query AdminLobby($institutionId: String!) {
  listCommunitiesForAnInstitution(institutionId: $institutionId) {
    id
    title
    members {
      id
    }
    communityMemberCount
    institutions {
      id
      logo
      slug
      name
      squareLogo
      colour
      privacyPolicyUrl
      isFeatureEnabled(feature: "community")
    }
    ...CommunitySettings
    ...NewsFeedGroups
  }
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}`;

/**
 * __useAdminLobbyQuery__
 *
 * To run a query within a React component, call `useAdminLobbyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLobbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLobbyQuery({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *   },
 * });
 */
export function useAdminLobbyQuery(baseOptions: Apollo.QueryHookOptions<AdminLobbyQuery, AdminLobbyQueryVariables> & ({ variables: AdminLobbyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLobbyQuery, AdminLobbyQueryVariables>(AdminLobbyDocument, options);
      }
export function useAdminLobbyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLobbyQuery, AdminLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLobbyQuery, AdminLobbyQueryVariables>(AdminLobbyDocument, options);
        }
export function useAdminLobbySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminLobbyQuery, AdminLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminLobbyQuery, AdminLobbyQueryVariables>(AdminLobbyDocument, options);
        }
export type AdminLobbyQueryHookResult = ReturnType<typeof useAdminLobbyQuery>;
export type AdminLobbyLazyQueryHookResult = ReturnType<typeof useAdminLobbyLazyQuery>;
export type AdminLobbySuspenseQueryHookResult = ReturnType<typeof useAdminLobbySuspenseQuery>;
export type AdminLobbyQueryResult = Apollo.QueryResult<AdminLobbyQuery, AdminLobbyQueryVariables>;
export const CommunityLobbyDocument = gql`
    query CommunityLobby($userId: String!, $email: String!) {
  getUser(id: $userId) {
    id
    communities {
      id
      title
      communityMemberCount
      institutions {
        id
        logo
        slug
        name
        squareLogo
        colour
        privacyPolicyUrl
        isFeatureEnabled(feature: "community")
      }
      ...CommunitySettings
      ...NewsFeedGroups
    }
  }
  getInvitesForEmail(email: $email) {
    id
    community {
      id
      title
      communityMemberCount
      institutions {
        id
        logo
        slug
        name
        squareLogo
        colour
        privacyPolicyUrl
        isFeatureEnabled(feature: "community")
      }
      ...CommunitySettings
      ...NewsFeedGroups
    }
  }
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}`;

/**
 * __useCommunityLobbyQuery__
 *
 * To run a query within a React component, call `useCommunityLobbyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityLobbyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityLobbyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCommunityLobbyQuery(baseOptions: Apollo.QueryHookOptions<CommunityLobbyQuery, CommunityLobbyQueryVariables> & ({ variables: CommunityLobbyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityLobbyQuery, CommunityLobbyQueryVariables>(CommunityLobbyDocument, options);
      }
export function useCommunityLobbyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityLobbyQuery, CommunityLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityLobbyQuery, CommunityLobbyQueryVariables>(CommunityLobbyDocument, options);
        }
export function useCommunityLobbySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityLobbyQuery, CommunityLobbyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityLobbyQuery, CommunityLobbyQueryVariables>(CommunityLobbyDocument, options);
        }
export type CommunityLobbyQueryHookResult = ReturnType<typeof useCommunityLobbyQuery>;
export type CommunityLobbyLazyQueryHookResult = ReturnType<typeof useCommunityLobbyLazyQuery>;
export type CommunityLobbySuspenseQueryHookResult = ReturnType<typeof useCommunityLobbySuspenseQuery>;
export type CommunityLobbyQueryResult = Apollo.QueryResult<CommunityLobbyQuery, CommunityLobbyQueryVariables>;
export const JoinCommunityDocument = gql`
    mutation JoinCommunity($communityId: String!) {
  joinCommunity(communityId: $communityId) {
    joined
    community {
      ...Community
    }
  }
}
    ${CommunityFragmentDoc}`;
export type JoinCommunityMutationFn = Apollo.MutationFunction<JoinCommunityMutation, JoinCommunityMutationVariables>;

/**
 * __useJoinCommunityMutation__
 *
 * To run a mutation, you first call `useJoinCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityMutation, { data, loading, error }] = useJoinCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useJoinCommunityMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityMutation, JoinCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityMutation, JoinCommunityMutationVariables>(JoinCommunityDocument, options);
      }
export type JoinCommunityMutationHookResult = ReturnType<typeof useJoinCommunityMutation>;
export type JoinCommunityMutationResult = Apollo.MutationResult<JoinCommunityMutation>;
export type JoinCommunityMutationOptions = Apollo.BaseMutationOptions<JoinCommunityMutation, JoinCommunityMutationVariables>;
export const JoinCommunityForAdminsDocument = gql`
    mutation JoinCommunityForAdmins($communityId: String!) {
  joinCommunityForAdmins(communityId: $communityId) {
    joined
    community {
      id
      title
      members {
        id
      }
      communityMemberCount
      institutions {
        id
        logo
        slug
        name
        squareLogo
        colour
        privacyPolicyUrl
        isFeatureEnabled(feature: "community")
      }
      ...CommunitySettings
      ...NewsFeedGroups
    }
  }
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}`;
export type JoinCommunityForAdminsMutationFn = Apollo.MutationFunction<JoinCommunityForAdminsMutation, JoinCommunityForAdminsMutationVariables>;

/**
 * __useJoinCommunityForAdminsMutation__
 *
 * To run a mutation, you first call `useJoinCommunityForAdminsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityForAdminsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityForAdminsMutation, { data, loading, error }] = useJoinCommunityForAdminsMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useJoinCommunityForAdminsMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityForAdminsMutation, JoinCommunityForAdminsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityForAdminsMutation, JoinCommunityForAdminsMutationVariables>(JoinCommunityForAdminsDocument, options);
      }
export type JoinCommunityForAdminsMutationHookResult = ReturnType<typeof useJoinCommunityForAdminsMutation>;
export type JoinCommunityForAdminsMutationResult = Apollo.MutationResult<JoinCommunityForAdminsMutation>;
export type JoinCommunityForAdminsMutationOptions = Apollo.BaseMutationOptions<JoinCommunityForAdminsMutation, JoinCommunityForAdminsMutationVariables>;
export const UpdateApplicantSignupSourceDocument = gql`
    mutation UpdateApplicantSignupSource($communityId: String!) {
  updateCommunityApplicantSignupsource(communityId: $communityId) {
    me {
      anyUser {
        id
      }
    }
  }
}
    `;
export type UpdateApplicantSignupSourceMutationFn = Apollo.MutationFunction<UpdateApplicantSignupSourceMutation, UpdateApplicantSignupSourceMutationVariables>;

/**
 * __useUpdateApplicantSignupSourceMutation__
 *
 * To run a mutation, you first call `useUpdateApplicantSignupSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicantSignupSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicantSignupSourceMutation, { data, loading, error }] = useUpdateApplicantSignupSourceMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useUpdateApplicantSignupSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicantSignupSourceMutation, UpdateApplicantSignupSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicantSignupSourceMutation, UpdateApplicantSignupSourceMutationVariables>(UpdateApplicantSignupSourceDocument, options);
      }
export type UpdateApplicantSignupSourceMutationHookResult = ReturnType<typeof useUpdateApplicantSignupSourceMutation>;
export type UpdateApplicantSignupSourceMutationResult = Apollo.MutationResult<UpdateApplicantSignupSourceMutation>;
export type UpdateApplicantSignupSourceMutationOptions = Apollo.BaseMutationOptions<UpdateApplicantSignupSourceMutation, UpdateApplicantSignupSourceMutationVariables>;
export const GetUserProfileDocument = gql`
    query GetUserProfile {
  getUserProfile {
    id
    userId
    interests {
      id
      type
    }
    profilePhoto
    areaOfStudy {
      ...Degree
    }
    bio
  }
}
    ${DegreeFragmentDoc}`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const SetCommunityDeviceTokenDocument = gql`
    mutation SetCommunityDeviceToken($active: Boolean!, $deviceToken: String!, $userId: String!, $system: String!) {
  setDeviceToken(
    SetDeviceTokenDTO: {active: $active, deviceToken: $deviceToken, system: $system, userId: $userId}
  ) {
    active
  }
}
    `;
export type SetCommunityDeviceTokenMutationFn = Apollo.MutationFunction<SetCommunityDeviceTokenMutation, SetCommunityDeviceTokenMutationVariables>;

/**
 * __useSetCommunityDeviceTokenMutation__
 *
 * To run a mutation, you first call `useSetCommunityDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommunityDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommunityDeviceTokenMutation, { data, loading, error }] = useSetCommunityDeviceTokenMutation({
 *   variables: {
 *      active: // value for 'active'
 *      deviceToken: // value for 'deviceToken'
 *      userId: // value for 'userId'
 *      system: // value for 'system'
 *   },
 * });
 */
export function useSetCommunityDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetCommunityDeviceTokenMutation, SetCommunityDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCommunityDeviceTokenMutation, SetCommunityDeviceTokenMutationVariables>(SetCommunityDeviceTokenDocument, options);
      }
export type SetCommunityDeviceTokenMutationHookResult = ReturnType<typeof useSetCommunityDeviceTokenMutation>;
export type SetCommunityDeviceTokenMutationResult = Apollo.MutationResult<SetCommunityDeviceTokenMutation>;
export type SetCommunityDeviceTokenMutationOptions = Apollo.BaseMutationOptions<SetCommunityDeviceTokenMutation, SetCommunityDeviceTokenMutationVariables>;
export const MeQueryDocument = gql`
    query MeQuery {
  me {
    anyUser {
      verified
      firstName
      lastName
      profilePhoto
      email
      id
      accountRole
      country {
        name
        id
        code
      }
      university {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useMeQueryQuery__
 *
 * To run a query within a React component, call `useMeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQueryQuery(baseOptions?: Apollo.QueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
      }
export function useMeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
        }
export function useMeQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
        }
export type MeQueryQueryHookResult = ReturnType<typeof useMeQueryQuery>;
export type MeQueryLazyQueryHookResult = ReturnType<typeof useMeQueryLazyQuery>;
export type MeQuerySuspenseQueryHookResult = ReturnType<typeof useMeQuerySuspenseQuery>;
export type MeQueryQueryResult = Apollo.QueryResult<MeQueryQuery, MeQueryQueryVariables>;
export const RegisterCommunityApplicantDocument = gql`
    mutation RegisterCommunityApplicant($email: String!, $password: String!, $firstName: String!, $lastName: String!, $country: String) {
  createCommunityApplicantV2(
    email: $email
    password: $password
    firstName: $firstName
    lastName: $lastName
    country: $country
  ) {
    applicant {
      id
    }
    error
  }
}
    `;
export type RegisterCommunityApplicantMutationFn = Apollo.MutationFunction<RegisterCommunityApplicantMutation, RegisterCommunityApplicantMutationVariables>;

/**
 * __useRegisterCommunityApplicantMutation__
 *
 * To run a mutation, you first call `useRegisterCommunityApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCommunityApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCommunityApplicantMutation, { data, loading, error }] = useRegisterCommunityApplicantMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useRegisterCommunityApplicantMutation(baseOptions?: Apollo.MutationHookOptions<RegisterCommunityApplicantMutation, RegisterCommunityApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterCommunityApplicantMutation, RegisterCommunityApplicantMutationVariables>(RegisterCommunityApplicantDocument, options);
      }
export type RegisterCommunityApplicantMutationHookResult = ReturnType<typeof useRegisterCommunityApplicantMutation>;
export type RegisterCommunityApplicantMutationResult = Apollo.MutationResult<RegisterCommunityApplicantMutation>;
export type RegisterCommunityApplicantMutationOptions = Apollo.BaseMutationOptions<RegisterCommunityApplicantMutation, RegisterCommunityApplicantMutationVariables>;
export const RequestCommunityVerificationCodeDocument = gql`
    mutation RequestCommunityVerificationCode {
  sendCommunityVerificationCode {
    success
  }
}
    `;
export type RequestCommunityVerificationCodeMutationFn = Apollo.MutationFunction<RequestCommunityVerificationCodeMutation, RequestCommunityVerificationCodeMutationVariables>;

/**
 * __useRequestCommunityVerificationCodeMutation__
 *
 * To run a mutation, you first call `useRequestCommunityVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCommunityVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCommunityVerificationCodeMutation, { data, loading, error }] = useRequestCommunityVerificationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestCommunityVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<RequestCommunityVerificationCodeMutation, RequestCommunityVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCommunityVerificationCodeMutation, RequestCommunityVerificationCodeMutationVariables>(RequestCommunityVerificationCodeDocument, options);
      }
export type RequestCommunityVerificationCodeMutationHookResult = ReturnType<typeof useRequestCommunityVerificationCodeMutation>;
export type RequestCommunityVerificationCodeMutationResult = Apollo.MutationResult<RequestCommunityVerificationCodeMutation>;
export type RequestCommunityVerificationCodeMutationOptions = Apollo.BaseMutationOptions<RequestCommunityVerificationCodeMutation, RequestCommunityVerificationCodeMutationVariables>;
export const VerifyCommunityEmailDocument = gql`
    mutation VerifyCommunityEmail($code: String!) {
  verifyAccount(code: $code) {
    success
    error
  }
}
    `;
export type VerifyCommunityEmailMutationFn = Apollo.MutationFunction<VerifyCommunityEmailMutation, VerifyCommunityEmailMutationVariables>;

/**
 * __useVerifyCommunityEmailMutation__
 *
 * To run a mutation, you first call `useVerifyCommunityEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCommunityEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCommunityEmailMutation, { data, loading, error }] = useVerifyCommunityEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyCommunityEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCommunityEmailMutation, VerifyCommunityEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCommunityEmailMutation, VerifyCommunityEmailMutationVariables>(VerifyCommunityEmailDocument, options);
      }
export type VerifyCommunityEmailMutationHookResult = ReturnType<typeof useVerifyCommunityEmailMutation>;
export type VerifyCommunityEmailMutationResult = Apollo.MutationResult<VerifyCommunityEmailMutation>;
export type VerifyCommunityEmailMutationOptions = Apollo.BaseMutationOptions<VerifyCommunityEmailMutation, VerifyCommunityEmailMutationVariables>;
export const DeleteApplicantMutationDocument = gql`
    mutation DeleteApplicantMutation {
  deleteApplicant {
    applicant {
      id
    }
  }
}
    `;
export type DeleteApplicantMutationMutationFn = Apollo.MutationFunction<DeleteApplicantMutationMutation, DeleteApplicantMutationMutationVariables>;

/**
 * __useDeleteApplicantMutationMutation__
 *
 * To run a mutation, you first call `useDeleteApplicantMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicantMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicantMutationMutation, { data, loading, error }] = useDeleteApplicantMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteApplicantMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicantMutationMutation, DeleteApplicantMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicantMutationMutation, DeleteApplicantMutationMutationVariables>(DeleteApplicantMutationDocument, options);
      }
export type DeleteApplicantMutationMutationHookResult = ReturnType<typeof useDeleteApplicantMutationMutation>;
export type DeleteApplicantMutationMutationResult = Apollo.MutationResult<DeleteApplicantMutationMutation>;
export type DeleteApplicantMutationMutationOptions = Apollo.BaseMutationOptions<DeleteApplicantMutationMutation, DeleteApplicantMutationMutationVariables>;
export const CreateUserReportDocument = gql`
    mutation CreateUserReport($userReportUserInputDTO: UserReportUserInputDTO!) {
  createUserReport(userReportUserInputDTO: $userReportUserInputDTO) {
    id
  }
}
    `;
export type CreateUserReportMutationFn = Apollo.MutationFunction<CreateUserReportMutation, CreateUserReportMutationVariables>;

/**
 * __useCreateUserReportMutation__
 *
 * To run a mutation, you first call `useCreateUserReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserReportMutation, { data, loading, error }] = useCreateUserReportMutation({
 *   variables: {
 *      userReportUserInputDTO: // value for 'userReportUserInputDTO'
 *   },
 * });
 */
export function useCreateUserReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserReportMutation, CreateUserReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserReportMutation, CreateUserReportMutationVariables>(CreateUserReportDocument, options);
      }
export type CreateUserReportMutationHookResult = ReturnType<typeof useCreateUserReportMutation>;
export type CreateUserReportMutationResult = Apollo.MutationResult<CreateUserReportMutation>;
export type CreateUserReportMutationOptions = Apollo.BaseMutationOptions<CreateUserReportMutation, CreateUserReportMutationVariables>;
export const ToggleMuteConversationDocument = gql`
    mutation ToggleMuteConversation($conversationId: String!, $status: Boolean!) {
  toggleCommunityChatGroupMute(conversationId: $conversationId, status: $status) {
    id
    ...CommunityFields
    ...GroupTypes
    ...AllMembers
  }
}
    ${CommunityFieldsFragmentDoc}
${GroupTypesFragmentDoc}
${AllMembersFragmentDoc}`;
export type ToggleMuteConversationMutationFn = Apollo.MutationFunction<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>;

/**
 * __useToggleMuteConversationMutation__
 *
 * To run a mutation, you first call `useToggleMuteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMuteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMuteConversationMutation, { data, loading, error }] = useToggleMuteConversationMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useToggleMuteConversationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>(ToggleMuteConversationDocument, options);
      }
export type ToggleMuteConversationMutationHookResult = ReturnType<typeof useToggleMuteConversationMutation>;
export type ToggleMuteConversationMutationResult = Apollo.MutationResult<ToggleMuteConversationMutation>;
export type ToggleMuteConversationMutationOptions = Apollo.BaseMutationOptions<ToggleMuteConversationMutation, ToggleMuteConversationMutationVariables>;
export const GetAmbassadorProfileDocument = gql`
    query GetAmbassadorProfile($id: String) {
  publicMentor(id: $id) {
    id
    firstName
    lastName
    profilePhoto
    degree {
      id
      name
    }
    degreeLevel
    accountRole
    placeName
    country {
      id
      code
      name
    }
    languages {
      id
      name
    }
    year
    favouriteModules {
      id
      name
    }
    pastQualification
    interests {
      id
      name
    }
    societies {
      id
      name
    }
    bio
    university {
      id
      name
      widgetUrl
    }
    shareUrl
    customAttributes {
      value
      attribute {
        id
        name
        type
      }
    }
    mentorFields {
      primaryFlag {
        code
        name
      }
      secondaryFlag {
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetAmbassadorProfileQuery__
 *
 * To run a query within a React component, call `useGetAmbassadorProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmbassadorProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmbassadorProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAmbassadorProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>(GetAmbassadorProfileDocument, options);
      }
export function useGetAmbassadorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>(GetAmbassadorProfileDocument, options);
        }
export function useGetAmbassadorProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>(GetAmbassadorProfileDocument, options);
        }
export type GetAmbassadorProfileQueryHookResult = ReturnType<typeof useGetAmbassadorProfileQuery>;
export type GetAmbassadorProfileLazyQueryHookResult = ReturnType<typeof useGetAmbassadorProfileLazyQuery>;
export type GetAmbassadorProfileSuspenseQueryHookResult = ReturnType<typeof useGetAmbassadorProfileSuspenseQuery>;
export type GetAmbassadorProfileQueryResult = Apollo.QueryResult<GetAmbassadorProfileQuery, GetAmbassadorProfileQueryVariables>;
export const GetOrCreateWidgetConversationDocument = gql`
    mutation GetOrCreateWidgetConversation($widgetConversationDto: WidgetConversationDto!) {
  getOrCreateWidgetConversation(widgetConversationDto: $widgetConversationDto) {
    ...UniversalInboxConversation
    ...LastMessageFragment
  }
}
    ${UniversalInboxConversationFragmentDoc}
${LastMessageFragmentFragmentDoc}`;
export type GetOrCreateWidgetConversationMutationFn = Apollo.MutationFunction<GetOrCreateWidgetConversationMutation, GetOrCreateWidgetConversationMutationVariables>;

/**
 * __useGetOrCreateWidgetConversationMutation__
 *
 * To run a mutation, you first call `useGetOrCreateWidgetConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateWidgetConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateWidgetConversationMutation, { data, loading, error }] = useGetOrCreateWidgetConversationMutation({
 *   variables: {
 *      widgetConversationDto: // value for 'widgetConversationDto'
 *   },
 * });
 */
export function useGetOrCreateWidgetConversationMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateWidgetConversationMutation, GetOrCreateWidgetConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateWidgetConversationMutation, GetOrCreateWidgetConversationMutationVariables>(GetOrCreateWidgetConversationDocument, options);
      }
export type GetOrCreateWidgetConversationMutationHookResult = ReturnType<typeof useGetOrCreateWidgetConversationMutation>;
export type GetOrCreateWidgetConversationMutationResult = Apollo.MutationResult<GetOrCreateWidgetConversationMutation>;
export type GetOrCreateWidgetConversationMutationOptions = Apollo.BaseMutationOptions<GetOrCreateWidgetConversationMutation, GetOrCreateWidgetConversationMutationVariables>;
export const GetStaffProfileDocument = gql`
    query GetStaffProfile($id: String!) {
  buddy(id: $id) {
    ...PublicBuddyFieldProfileData
    ...PublicStaffFields
    university {
      id
      name
      widgetUrl
      logo
      slug
    }
    customAttributes(active: true) {
      value
      attribute {
        id
        name
        type
      }
      ... on SingleChoiceValueField {
        option {
          id
          value
        }
      }
    }
  }
}
    ${PublicBuddyFieldProfileDataFragmentDoc}
${PublicStaffFieldsFragmentDoc}`;

/**
 * __useGetStaffProfileQuery__
 *
 * To run a query within a React component, call `useGetStaffProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStaffProfileQuery(baseOptions: Apollo.QueryHookOptions<GetStaffProfileQuery, GetStaffProfileQueryVariables> & ({ variables: GetStaffProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffProfileQuery, GetStaffProfileQueryVariables>(GetStaffProfileDocument, options);
      }
export function useGetStaffProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffProfileQuery, GetStaffProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffProfileQuery, GetStaffProfileQueryVariables>(GetStaffProfileDocument, options);
        }
export function useGetStaffProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStaffProfileQuery, GetStaffProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStaffProfileQuery, GetStaffProfileQueryVariables>(GetStaffProfileDocument, options);
        }
export type GetStaffProfileQueryHookResult = ReturnType<typeof useGetStaffProfileQuery>;
export type GetStaffProfileLazyQueryHookResult = ReturnType<typeof useGetStaffProfileLazyQuery>;
export type GetStaffProfileSuspenseQueryHookResult = ReturnType<typeof useGetStaffProfileSuspenseQuery>;
export type GetStaffProfileQueryResult = Apollo.QueryResult<GetStaffProfileQuery, GetStaffProfileQueryVariables>;
export const AddUserToGroupDocument = gql`
    mutation AddUserToGroup($memberId: String!, $conversationId: String!) {
  addUserToCommunityConversation(
    memberId: $memberId
    conversationId: $conversationId
  ) {
    ...InboxConversation
    allMembers: communityChatMembers(offsetPagination: {limit: 999}) {
      id
    }
  }
}
    ${InboxConversationFragmentDoc}`;
export type AddUserToGroupMutationFn = Apollo.MutationFunction<AddUserToGroupMutation, AddUserToGroupMutationVariables>;

/**
 * __useAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToGroupMutation, { data, loading, error }] = useAddUserToGroupMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useAddUserToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument, options);
      }
export type AddUserToGroupMutationHookResult = ReturnType<typeof useAddUserToGroupMutation>;
export type AddUserToGroupMutationResult = Apollo.MutationResult<AddUserToGroupMutation>;
export type AddUserToGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>;
export const GetCommunityConversationDocument = gql`
    query GetCommunityConversation($id: String!) {
  getChatConversation(id: $id) {
    id
    product
    university {
      id
      slug
      name
    }
    ...CommunityFields
    ...GroupTypes
  }
}
    ${CommunityFieldsFragmentDoc}
${GroupTypesFragmentDoc}`;

/**
 * __useGetCommunityConversationQuery__
 *
 * To run a query within a React component, call `useGetCommunityConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommunityConversationQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityConversationQuery, GetCommunityConversationQueryVariables> & ({ variables: GetCommunityConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>(GetCommunityConversationDocument, options);
      }
export function useGetCommunityConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>(GetCommunityConversationDocument, options);
        }
export function useGetCommunityConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>(GetCommunityConversationDocument, options);
        }
export type GetCommunityConversationQueryHookResult = ReturnType<typeof useGetCommunityConversationQuery>;
export type GetCommunityConversationLazyQueryHookResult = ReturnType<typeof useGetCommunityConversationLazyQuery>;
export type GetCommunityConversationSuspenseQueryHookResult = ReturnType<typeof useGetCommunityConversationSuspenseQuery>;
export type GetCommunityConversationQueryResult = Apollo.QueryResult<GetCommunityConversationQuery, GetCommunityConversationQueryVariables>;
export const GetFullConversationMembersListDocument = gql`
    query GetFullConversationMembersList($id: String!) {
  getChatConversation(id: $id) {
    id
    totalMemberCount
  }
}
    `;

/**
 * __useGetFullConversationMembersListQuery__
 *
 * To run a query within a React component, call `useGetFullConversationMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullConversationMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullConversationMembersListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullConversationMembersListQuery(baseOptions: Apollo.QueryHookOptions<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables> & ({ variables: GetFullConversationMembersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>(GetFullConversationMembersListDocument, options);
      }
export function useGetFullConversationMembersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>(GetFullConversationMembersListDocument, options);
        }
export function useGetFullConversationMembersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>(GetFullConversationMembersListDocument, options);
        }
export type GetFullConversationMembersListQueryHookResult = ReturnType<typeof useGetFullConversationMembersListQuery>;
export type GetFullConversationMembersListLazyQueryHookResult = ReturnType<typeof useGetFullConversationMembersListLazyQuery>;
export type GetFullConversationMembersListSuspenseQueryHookResult = ReturnType<typeof useGetFullConversationMembersListSuspenseQuery>;
export type GetFullConversationMembersListQueryResult = Apollo.QueryResult<GetFullConversationMembersListQuery, GetFullConversationMembersListQueryVariables>;
export const GetCommunityChatMembersDocument = gql`
    query GetCommunityChatMembers($conversationId: String!, $offsetPagination: OffsetPagination!, $idIn: [String]) {
  getCommunityChatMembers(
    conversationId: $conversationId
    offsetPagination: $offsetPagination
  ) {
    id
    firstName
    lastName
    accountRole
    profilePhoto
    ...Country
    ...CommunityProfile
  }
  getUserByIds(idIn: $idIn) {
    id
    firstName
    lastName
    accountRole
    ...Country
    ...CommunityProfile
  }
}
    ${CountryFragmentDoc}
${CommunityProfileFragmentDoc}`;

/**
 * __useGetCommunityChatMembersQuery__
 *
 * To run a query within a React component, call `useGetCommunityChatMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityChatMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityChatMembersQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      offsetPagination: // value for 'offsetPagination'
 *      idIn: // value for 'idIn'
 *   },
 * });
 */
export function useGetCommunityChatMembersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables> & ({ variables: GetCommunityChatMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>(GetCommunityChatMembersDocument, options);
      }
export function useGetCommunityChatMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>(GetCommunityChatMembersDocument, options);
        }
export function useGetCommunityChatMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>(GetCommunityChatMembersDocument, options);
        }
export type GetCommunityChatMembersQueryHookResult = ReturnType<typeof useGetCommunityChatMembersQuery>;
export type GetCommunityChatMembersLazyQueryHookResult = ReturnType<typeof useGetCommunityChatMembersLazyQuery>;
export type GetCommunityChatMembersSuspenseQueryHookResult = ReturnType<typeof useGetCommunityChatMembersSuspenseQuery>;
export type GetCommunityChatMembersQueryResult = Apollo.QueryResult<GetCommunityChatMembersQuery, GetCommunityChatMembersQueryVariables>;
export const GetUserByUserIdDocument = gql`
    query GetUserByUserId($id: String!) {
  getUser(id: $id) {
    id
    firstName
    accountRole
    ...Country
    ...Interests
    profilePhoto
    communityProfile {
      id
      profilePhoto
      bio
      areaOfStudy {
        name
      }
      pronouns
      ...Housing
    }
  }
}
    ${CountryFragmentDoc}
${InterestsFragmentDoc}
${HousingFragmentDoc}`;

/**
 * __useGetUserByUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByUserIdQuery, GetUserByUserIdQueryVariables> & ({ variables: GetUserByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>(GetUserByUserIdDocument, options);
      }
export function useGetUserByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>(GetUserByUserIdDocument, options);
        }
export function useGetUserByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>(GetUserByUserIdDocument, options);
        }
export type GetUserByUserIdQueryHookResult = ReturnType<typeof useGetUserByUserIdQuery>;
export type GetUserByUserIdLazyQueryHookResult = ReturnType<typeof useGetUserByUserIdLazyQuery>;
export type GetUserByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByUserIdSuspenseQuery>;
export type GetUserByUserIdQueryResult = Apollo.QueryResult<GetUserByUserIdQuery, GetUserByUserIdQueryVariables>;
export const CommunityInboxPrivateDocument = gql`
    query CommunityInboxPrivate($communityId: String!) {
  getUsersCommunityPrivateConversations(communityId: $communityId) {
    ...InboxConversation
    allMembers: communityChatMembers(offsetPagination: {limit: 999}) {
      id
    }
  }
}
    ${InboxConversationFragmentDoc}`;

/**
 * __useCommunityInboxPrivateQuery__
 *
 * To run a query within a React component, call `useCommunityInboxPrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityInboxPrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityInboxPrivateQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityInboxPrivateQuery(baseOptions: Apollo.QueryHookOptions<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables> & ({ variables: CommunityInboxPrivateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>(CommunityInboxPrivateDocument, options);
      }
export function useCommunityInboxPrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>(CommunityInboxPrivateDocument, options);
        }
export function useCommunityInboxPrivateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>(CommunityInboxPrivateDocument, options);
        }
export type CommunityInboxPrivateQueryHookResult = ReturnType<typeof useCommunityInboxPrivateQuery>;
export type CommunityInboxPrivateLazyQueryHookResult = ReturnType<typeof useCommunityInboxPrivateLazyQuery>;
export type CommunityInboxPrivateSuspenseQueryHookResult = ReturnType<typeof useCommunityInboxPrivateSuspenseQuery>;
export type CommunityInboxPrivateQueryResult = Apollo.QueryResult<CommunityInboxPrivateQuery, CommunityInboxPrivateQueryVariables>;
export const AddVoteDocument = gql`
    mutation AddVote($option: String!, $chatMessageId: ObjectId!) {
  addVote(option: $option, chatMessageId: $chatMessageId) {
    ...CommunityPollRichContent
  }
}
    ${CommunityPollRichContentFragmentDoc}`;
export type AddVoteMutationFn = Apollo.MutationFunction<AddVoteMutation, AddVoteMutationVariables>;

/**
 * __useAddVoteMutation__
 *
 * To run a mutation, you first call `useAddVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVoteMutation, { data, loading, error }] = useAddVoteMutation({
 *   variables: {
 *      option: // value for 'option'
 *      chatMessageId: // value for 'chatMessageId'
 *   },
 * });
 */
export function useAddVoteMutation(baseOptions?: Apollo.MutationHookOptions<AddVoteMutation, AddVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVoteMutation, AddVoteMutationVariables>(AddVoteDocument, options);
      }
export type AddVoteMutationHookResult = ReturnType<typeof useAddVoteMutation>;
export type AddVoteMutationResult = Apollo.MutationResult<AddVoteMutation>;
export type AddVoteMutationOptions = Apollo.BaseMutationOptions<AddVoteMutation, AddVoteMutationVariables>;
export const RemoveVoteDocument = gql`
    mutation RemoveVote($option: String!, $chatMessageId: ObjectId!) {
  removeVote(option: $option, chatMessageId: $chatMessageId) {
    ...CommunityPollRichContent
  }
}
    ${CommunityPollRichContentFragmentDoc}`;
export type RemoveVoteMutationFn = Apollo.MutationFunction<RemoveVoteMutation, RemoveVoteMutationVariables>;

/**
 * __useRemoveVoteMutation__
 *
 * To run a mutation, you first call `useRemoveVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoteMutation, { data, loading, error }] = useRemoveVoteMutation({
 *   variables: {
 *      option: // value for 'option'
 *      chatMessageId: // value for 'chatMessageId'
 *   },
 * });
 */
export function useRemoveVoteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVoteMutation, RemoveVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVoteMutation, RemoveVoteMutationVariables>(RemoveVoteDocument, options);
      }
export type RemoveVoteMutationHookResult = ReturnType<typeof useRemoveVoteMutation>;
export type RemoveVoteMutationResult = Apollo.MutationResult<RemoveVoteMutation>;
export type RemoveVoteMutationOptions = Apollo.BaseMutationOptions<RemoveVoteMutation, RemoveVoteMutationVariables>;
export const AddReactionToMessageDocument = gql`
    mutation AddReactionToMessage($reactionDto: ReactionDto!) {
  addReactionToMessage(reactionDto: $reactionDto) {
    ...FullCommunityChatMessage
  }
}
    ${FullCommunityChatMessageFragmentDoc}`;
export type AddReactionToMessageMutationFn = Apollo.MutationFunction<AddReactionToMessageMutation, AddReactionToMessageMutationVariables>;

/**
 * __useAddReactionToMessageMutation__
 *
 * To run a mutation, you first call `useAddReactionToMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToMessageMutation, { data, loading, error }] = useAddReactionToMessageMutation({
 *   variables: {
 *      reactionDto: // value for 'reactionDto'
 *   },
 * });
 */
export function useAddReactionToMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddReactionToMessageMutation, AddReactionToMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReactionToMessageMutation, AddReactionToMessageMutationVariables>(AddReactionToMessageDocument, options);
      }
export type AddReactionToMessageMutationHookResult = ReturnType<typeof useAddReactionToMessageMutation>;
export type AddReactionToMessageMutationResult = Apollo.MutationResult<AddReactionToMessageMutation>;
export type AddReactionToMessageMutationOptions = Apollo.BaseMutationOptions<AddReactionToMessageMutation, AddReactionToMessageMutationVariables>;
export const RemoveReactionFromMessageDocument = gql`
    mutation RemoveReactionFromMessage($reactionDto: ReactionDto!) {
  removeReactionFromMessage(reactionDto: $reactionDto) {
    ...FullCommunityChatMessage
  }
}
    ${FullCommunityChatMessageFragmentDoc}`;
export type RemoveReactionFromMessageMutationFn = Apollo.MutationFunction<RemoveReactionFromMessageMutation, RemoveReactionFromMessageMutationVariables>;

/**
 * __useRemoveReactionFromMessageMutation__
 *
 * To run a mutation, you first call `useRemoveReactionFromMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionFromMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionFromMessageMutation, { data, loading, error }] = useRemoveReactionFromMessageMutation({
 *   variables: {
 *      reactionDto: // value for 'reactionDto'
 *   },
 * });
 */
export function useRemoveReactionFromMessageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReactionFromMessageMutation, RemoveReactionFromMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReactionFromMessageMutation, RemoveReactionFromMessageMutationVariables>(RemoveReactionFromMessageDocument, options);
      }
export type RemoveReactionFromMessageMutationHookResult = ReturnType<typeof useRemoveReactionFromMessageMutation>;
export type RemoveReactionFromMessageMutationResult = Apollo.MutationResult<RemoveReactionFromMessageMutation>;
export type RemoveReactionFromMessageMutationOptions = Apollo.BaseMutationOptions<RemoveReactionFromMessageMutation, RemoveReactionFromMessageMutationVariables>;
export const BlockCommunityUserDocument = gql`
    mutation BlockCommunityUser($userId: String!, $conversationId: String!, $comment: String) {
  createUniversityBlockReport(
    blocked: $userId
    conversation: $conversationId
    reason: "Spam"
    comment: $comment
    triggeredFrom: "community"
  ) {
    universityBlockReport {
      id
    }
    error
  }
}
    `;
export type BlockCommunityUserMutationFn = Apollo.MutationFunction<BlockCommunityUserMutation, BlockCommunityUserMutationVariables>;

/**
 * __useBlockCommunityUserMutation__
 *
 * To run a mutation, you first call `useBlockCommunityUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCommunityUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCommunityUserMutation, { data, loading, error }] = useBlockCommunityUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      conversationId: // value for 'conversationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useBlockCommunityUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockCommunityUserMutation, BlockCommunityUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockCommunityUserMutation, BlockCommunityUserMutationVariables>(BlockCommunityUserDocument, options);
      }
export type BlockCommunityUserMutationHookResult = ReturnType<typeof useBlockCommunityUserMutation>;
export type BlockCommunityUserMutationResult = Apollo.MutationResult<BlockCommunityUserMutation>;
export type BlockCommunityUserMutationOptions = Apollo.BaseMutationOptions<BlockCommunityUserMutation, BlockCommunityUserMutationVariables>;
export const SetBlockUserV2Document = gql`
    mutation SetBlockUserV2($userId: String, $setBlocked: Boolean) {
  setBlockUserV2(userId: $userId, setBlocked: $setBlocked) {
    objectsBlockedIds
  }
}
    `;
export type SetBlockUserV2MutationFn = Apollo.MutationFunction<SetBlockUserV2Mutation, SetBlockUserV2MutationVariables>;

/**
 * __useSetBlockUserV2Mutation__
 *
 * To run a mutation, you first call `useSetBlockUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockUserV2Mutation, { data, loading, error }] = useSetBlockUserV2Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      setBlocked: // value for 'setBlocked'
 *   },
 * });
 */
export function useSetBlockUserV2Mutation(baseOptions?: Apollo.MutationHookOptions<SetBlockUserV2Mutation, SetBlockUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockUserV2Mutation, SetBlockUserV2MutationVariables>(SetBlockUserV2Document, options);
      }
export type SetBlockUserV2MutationHookResult = ReturnType<typeof useSetBlockUserV2Mutation>;
export type SetBlockUserV2MutationResult = Apollo.MutationResult<SetBlockUserV2Mutation>;
export type SetBlockUserV2MutationOptions = Apollo.BaseMutationOptions<SetBlockUserV2Mutation, SetBlockUserV2MutationVariables>;
export const BlockedUsersListDocument = gql`
    query BlockedUsersList {
  blockedUsersByMe
}
    `;

/**
 * __useBlockedUsersListQuery__
 *
 * To run a query within a React component, call `useBlockedUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockedUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockedUsersListQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlockedUsersListQuery(baseOptions?: Apollo.QueryHookOptions<BlockedUsersListQuery, BlockedUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockedUsersListQuery, BlockedUsersListQueryVariables>(BlockedUsersListDocument, options);
      }
export function useBlockedUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockedUsersListQuery, BlockedUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockedUsersListQuery, BlockedUsersListQueryVariables>(BlockedUsersListDocument, options);
        }
export function useBlockedUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlockedUsersListQuery, BlockedUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlockedUsersListQuery, BlockedUsersListQueryVariables>(BlockedUsersListDocument, options);
        }
export type BlockedUsersListQueryHookResult = ReturnType<typeof useBlockedUsersListQuery>;
export type BlockedUsersListLazyQueryHookResult = ReturnType<typeof useBlockedUsersListLazyQuery>;
export type BlockedUsersListSuspenseQueryHookResult = ReturnType<typeof useBlockedUsersListSuspenseQuery>;
export type BlockedUsersListQueryResult = Apollo.QueryResult<BlockedUsersListQuery, BlockedUsersListQueryVariables>;
export const CreateDirectConversationDocument = gql`
    mutation CreateDirectConversation($communityId: String!, $userToConverseWith: String!, $source: String) {
  createDirectConversation(
    DirectConversationDTO: {communityId: $communityId, userToConverseWith: $userToConverseWith, source: $source}
  ) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}`;
export type CreateDirectConversationMutationFn = Apollo.MutationFunction<CreateDirectConversationMutation, CreateDirectConversationMutationVariables>;

/**
 * __useCreateDirectConversationMutation__
 *
 * To run a mutation, you first call `useCreateDirectConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectConversationMutation, { data, loading, error }] = useCreateDirectConversationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      userToConverseWith: // value for 'userToConverseWith'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateDirectConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectConversationMutation, CreateDirectConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectConversationMutation, CreateDirectConversationMutationVariables>(CreateDirectConversationDocument, options);
      }
export type CreateDirectConversationMutationHookResult = ReturnType<typeof useCreateDirectConversationMutation>;
export type CreateDirectConversationMutationResult = Apollo.MutationResult<CreateDirectConversationMutation>;
export type CreateDirectConversationMutationOptions = Apollo.BaseMutationOptions<CreateDirectConversationMutation, CreateDirectConversationMutationVariables>;
export const DeleteConversationMessageDocument = gql`
    mutation DeleteConversationMessage($deleteMessageDto: DeleteMessageDto!) {
  deleteConversationMessage(deleteMessageDto: $deleteMessageDto) {
    id
    created
    text
    deleted
  }
}
    `;
export type DeleteConversationMessageMutationFn = Apollo.MutationFunction<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>;

/**
 * __useDeleteConversationMessageMutation__
 *
 * To run a mutation, you first call `useDeleteConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationMessageMutation, { data, loading, error }] = useDeleteConversationMessageMutation({
 *   variables: {
 *      deleteMessageDto: // value for 'deleteMessageDto'
 *   },
 * });
 */
export function useDeleteConversationMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>(DeleteConversationMessageDocument, options);
      }
export type DeleteConversationMessageMutationHookResult = ReturnType<typeof useDeleteConversationMessageMutation>;
export type DeleteConversationMessageMutationResult = Apollo.MutationResult<DeleteConversationMessageMutation>;
export type DeleteConversationMessageMutationOptions = Apollo.BaseMutationOptions<DeleteConversationMessageMutation, DeleteConversationMessageMutationVariables>;
export const CommunityLikeMessageDocument = gql`
    mutation CommunityLikeMessage($conversationId: ObjectId!, $messageId: ObjectId!, $userId: ObjectId!) {
  likeConversationMessage(
    likeMessageDto: {conversationId: $conversationId, messageId: $messageId, userId: $userId}
  ) {
    id
    likesCount
    likes
  }
}
    `;
export type CommunityLikeMessageMutationFn = Apollo.MutationFunction<CommunityLikeMessageMutation, CommunityLikeMessageMutationVariables>;

/**
 * __useCommunityLikeMessageMutation__
 *
 * To run a mutation, you first call `useCommunityLikeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityLikeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityLikeMessageMutation, { data, loading, error }] = useCommunityLikeMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      messageId: // value for 'messageId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCommunityLikeMessageMutation(baseOptions?: Apollo.MutationHookOptions<CommunityLikeMessageMutation, CommunityLikeMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityLikeMessageMutation, CommunityLikeMessageMutationVariables>(CommunityLikeMessageDocument, options);
      }
export type CommunityLikeMessageMutationHookResult = ReturnType<typeof useCommunityLikeMessageMutation>;
export type CommunityLikeMessageMutationResult = Apollo.MutationResult<CommunityLikeMessageMutation>;
export type CommunityLikeMessageMutationOptions = Apollo.BaseMutationOptions<CommunityLikeMessageMutation, CommunityLikeMessageMutationVariables>;
export const CommunityChatMessagesDocument = gql`
    query CommunityChatMessages($getMessageDto: GetMessageDto!) {
  getChatConversationMessages(getMessageDto: $getMessageDto) {
    hasMore
    messages {
      ...FullCommunityChatMessage
    }
  }
}
    ${FullCommunityChatMessageFragmentDoc}`;

/**
 * __useCommunityChatMessagesQuery__
 *
 * To run a query within a React component, call `useCommunityChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityChatMessagesQuery({
 *   variables: {
 *      getMessageDto: // value for 'getMessageDto'
 *   },
 * });
 */
export function useCommunityChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables> & ({ variables: CommunityChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>(CommunityChatMessagesDocument, options);
      }
export function useCommunityChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>(CommunityChatMessagesDocument, options);
        }
export function useCommunityChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>(CommunityChatMessagesDocument, options);
        }
export type CommunityChatMessagesQueryHookResult = ReturnType<typeof useCommunityChatMessagesQuery>;
export type CommunityChatMessagesLazyQueryHookResult = ReturnType<typeof useCommunityChatMessagesLazyQuery>;
export type CommunityChatMessagesSuspenseQueryHookResult = ReturnType<typeof useCommunityChatMessagesSuspenseQuery>;
export type CommunityChatMessagesQueryResult = Apollo.QueryResult<CommunityChatMessagesQuery, CommunityChatMessagesQueryVariables>;
export const CommunityPinMessageDocument = gql`
    mutation CommunityPinMessage($pinMessageDTO: pinMessageDTO!) {
  pinMessageInConversation(pinMessageDTO: $pinMessageDTO) {
    pinnedMessages {
      id
    }
  }
}
    `;
export type CommunityPinMessageMutationFn = Apollo.MutationFunction<CommunityPinMessageMutation, CommunityPinMessageMutationVariables>;

/**
 * __useCommunityPinMessageMutation__
 *
 * To run a mutation, you first call `useCommunityPinMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityPinMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityPinMessageMutation, { data, loading, error }] = useCommunityPinMessageMutation({
 *   variables: {
 *      pinMessageDTO: // value for 'pinMessageDTO'
 *   },
 * });
 */
export function useCommunityPinMessageMutation(baseOptions?: Apollo.MutationHookOptions<CommunityPinMessageMutation, CommunityPinMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityPinMessageMutation, CommunityPinMessageMutationVariables>(CommunityPinMessageDocument, options);
      }
export type CommunityPinMessageMutationHookResult = ReturnType<typeof useCommunityPinMessageMutation>;
export type CommunityPinMessageMutationResult = Apollo.MutationResult<CommunityPinMessageMutation>;
export type CommunityPinMessageMutationOptions = Apollo.BaseMutationOptions<CommunityPinMessageMutation, CommunityPinMessageMutationVariables>;
export const CommunityPinnedMessagesDocument = gql`
    query CommunityPinnedMessages($conversationId: String!) {
  getChatConversation(id: $conversationId) {
    id
    communityChatTitle
    pinnedMessages {
      ...FullCommunityChatMessage
    }
  }
}
    ${FullCommunityChatMessageFragmentDoc}`;

/**
 * __useCommunityPinnedMessagesQuery__
 *
 * To run a query within a React component, call `useCommunityPinnedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityPinnedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityPinnedMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useCommunityPinnedMessagesQuery(baseOptions: Apollo.QueryHookOptions<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables> & ({ variables: CommunityPinnedMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>(CommunityPinnedMessagesDocument, options);
      }
export function useCommunityPinnedMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>(CommunityPinnedMessagesDocument, options);
        }
export function useCommunityPinnedMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>(CommunityPinnedMessagesDocument, options);
        }
export type CommunityPinnedMessagesQueryHookResult = ReturnType<typeof useCommunityPinnedMessagesQuery>;
export type CommunityPinnedMessagesLazyQueryHookResult = ReturnType<typeof useCommunityPinnedMessagesLazyQuery>;
export type CommunityPinnedMessagesSuspenseQueryHookResult = ReturnType<typeof useCommunityPinnedMessagesSuspenseQuery>;
export type CommunityPinnedMessagesQueryResult = Apollo.QueryResult<CommunityPinnedMessagesQuery, CommunityPinnedMessagesQueryVariables>;
export const CommunityConversationReadDocument = gql`
    mutation CommunityConversationRead($conversationId: ID!, $messageId: ObjectId!) {
  recordLastMessageReadByUser(
    markReadMessageDto: {conversationId: $conversationId, messageId: $messageId}
  ) {
    userId
    messageId
    conversationId
  }
}
    `;
export type CommunityConversationReadMutationFn = Apollo.MutationFunction<CommunityConversationReadMutation, CommunityConversationReadMutationVariables>;

/**
 * __useCommunityConversationReadMutation__
 *
 * To run a mutation, you first call `useCommunityConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityConversationReadMutation, { data, loading, error }] = useCommunityConversationReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useCommunityConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<CommunityConversationReadMutation, CommunityConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityConversationReadMutation, CommunityConversationReadMutationVariables>(CommunityConversationReadDocument, options);
      }
export type CommunityConversationReadMutationHookResult = ReturnType<typeof useCommunityConversationReadMutation>;
export type CommunityConversationReadMutationResult = Apollo.MutationResult<CommunityConversationReadMutation>;
export type CommunityConversationReadMutationOptions = Apollo.BaseMutationOptions<CommunityConversationReadMutation, CommunityConversationReadMutationVariables>;
export const CreateChatReportDocument = gql`
    mutation CreateChatReport($chatReportUserInputDTO: ChatReportUserInputDTO!) {
  createChatReport(chatReportUserInputDTO: $chatReportUserInputDTO) {
    id
  }
}
    `;
export type CreateChatReportMutationFn = Apollo.MutationFunction<CreateChatReportMutation, CreateChatReportMutationVariables>;

/**
 * __useCreateChatReportMutation__
 *
 * To run a mutation, you first call `useCreateChatReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatReportMutation, { data, loading, error }] = useCreateChatReportMutation({
 *   variables: {
 *      chatReportUserInputDTO: // value for 'chatReportUserInputDTO'
 *   },
 * });
 */
export function useCreateChatReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatReportMutation, CreateChatReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatReportMutation, CreateChatReportMutationVariables>(CreateChatReportDocument, options);
      }
export type CreateChatReportMutationHookResult = ReturnType<typeof useCreateChatReportMutation>;
export type CreateChatReportMutationResult = Apollo.MutationResult<CreateChatReportMutation>;
export type CreateChatReportMutationOptions = Apollo.BaseMutationOptions<CreateChatReportMutation, CreateChatReportMutationVariables>;
export const SendCommunityChatMessageDocument = gql`
    mutation SendCommunityChatMessage($messageDto: MessageDto!) {
  sendConversationMessage(messageDto: $messageDto) {
    ...CommunityChatMessage
    richContent {
      giphy {
        ...CommunityGiphyRichContent
      }
      reply {
        ...CommunityReplyRichContent
        richContent {
          giphy {
            ...CommunityGiphyRichContent
          }
          images {
            ...CommunityImagesRichContent
          }
        }
      }
      images {
        ...CommunityImagesRichContent
      }
      attachments {
        ...CommunityAttachmentRichContent
      }
      poll {
        ...CommunityPollRichContent
      }
    }
  }
}
    ${CommunityChatMessageFragmentDoc}
${CommunityGiphyRichContentFragmentDoc}
${CommunityReplyRichContentFragmentDoc}
${CommunityImagesRichContentFragmentDoc}
${CommunityAttachmentRichContentFragmentDoc}
${CommunityPollRichContentFragmentDoc}`;
export type SendCommunityChatMessageMutationFn = Apollo.MutationFunction<SendCommunityChatMessageMutation, SendCommunityChatMessageMutationVariables>;

/**
 * __useSendCommunityChatMessageMutation__
 *
 * To run a mutation, you first call `useSendCommunityChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommunityChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommunityChatMessageMutation, { data, loading, error }] = useSendCommunityChatMessageMutation({
 *   variables: {
 *      messageDto: // value for 'messageDto'
 *   },
 * });
 */
export function useSendCommunityChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendCommunityChatMessageMutation, SendCommunityChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommunityChatMessageMutation, SendCommunityChatMessageMutationVariables>(SendCommunityChatMessageDocument, options);
      }
export type SendCommunityChatMessageMutationHookResult = ReturnType<typeof useSendCommunityChatMessageMutation>;
export type SendCommunityChatMessageMutationResult = Apollo.MutationResult<SendCommunityChatMessageMutation>;
export type SendCommunityChatMessageMutationOptions = Apollo.BaseMutationOptions<SendCommunityChatMessageMutation, SendCommunityChatMessageMutationVariables>;
export const CommunityUnlikeMessageDocument = gql`
    mutation CommunityUnlikeMessage($conversationId: ObjectId!, $messageId: ObjectId!, $userId: ObjectId!) {
  unlikeConversationMessage(
    likeMessageDto: {conversationId: $conversationId, messageId: $messageId, userId: $userId}
  ) {
    id
    likesCount
    likes
  }
}
    `;
export type CommunityUnlikeMessageMutationFn = Apollo.MutationFunction<CommunityUnlikeMessageMutation, CommunityUnlikeMessageMutationVariables>;

/**
 * __useCommunityUnlikeMessageMutation__
 *
 * To run a mutation, you first call `useCommunityUnlikeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityUnlikeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityUnlikeMessageMutation, { data, loading, error }] = useCommunityUnlikeMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      messageId: // value for 'messageId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCommunityUnlikeMessageMutation(baseOptions?: Apollo.MutationHookOptions<CommunityUnlikeMessageMutation, CommunityUnlikeMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityUnlikeMessageMutation, CommunityUnlikeMessageMutationVariables>(CommunityUnlikeMessageDocument, options);
      }
export type CommunityUnlikeMessageMutationHookResult = ReturnType<typeof useCommunityUnlikeMessageMutation>;
export type CommunityUnlikeMessageMutationResult = Apollo.MutationResult<CommunityUnlikeMessageMutation>;
export type CommunityUnlikeMessageMutationOptions = Apollo.BaseMutationOptions<CommunityUnlikeMessageMutation, CommunityUnlikeMessageMutationVariables>;
export const CommunityUnpinMessageDocument = gql`
    mutation CommunityUnpinMessage($unpinMessageDTO: unpinMessageDTO!) {
  unpinMessageInConversation(unpinMessageDTO: $unpinMessageDTO) {
    pinnedMessages {
      id
    }
  }
}
    `;
export type CommunityUnpinMessageMutationFn = Apollo.MutationFunction<CommunityUnpinMessageMutation, CommunityUnpinMessageMutationVariables>;

/**
 * __useCommunityUnpinMessageMutation__
 *
 * To run a mutation, you first call `useCommunityUnpinMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityUnpinMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityUnpinMessageMutation, { data, loading, error }] = useCommunityUnpinMessageMutation({
 *   variables: {
 *      unpinMessageDTO: // value for 'unpinMessageDTO'
 *   },
 * });
 */
export function useCommunityUnpinMessageMutation(baseOptions?: Apollo.MutationHookOptions<CommunityUnpinMessageMutation, CommunityUnpinMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityUnpinMessageMutation, CommunityUnpinMessageMutationVariables>(CommunityUnpinMessageDocument, options);
      }
export type CommunityUnpinMessageMutationHookResult = ReturnType<typeof useCommunityUnpinMessageMutation>;
export type CommunityUnpinMessageMutationResult = Apollo.MutationResult<CommunityUnpinMessageMutation>;
export type CommunityUnpinMessageMutationOptions = Apollo.BaseMutationOptions<CommunityUnpinMessageMutation, CommunityUnpinMessageMutationVariables>;
export const GetCommunitiesDocument = gql`
    query GetCommunities($userId: String!) {
  getUser(id: $userId) {
    id
    communities {
      ...Community
    }
  }
}
    ${CommunityFragmentDoc}`;

/**
 * __useGetCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCommunitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables> & ({ variables: GetCommunitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
      }
export function useGetCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
        }
export function useGetCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
        }
export type GetCommunitiesQueryHookResult = ReturnType<typeof useGetCommunitiesQuery>;
export type GetCommunitiesLazyQueryHookResult = ReturnType<typeof useGetCommunitiesLazyQuery>;
export type GetCommunitiesSuspenseQueryHookResult = ReturnType<typeof useGetCommunitiesSuspenseQuery>;
export type GetCommunitiesQueryResult = Apollo.QueryResult<GetCommunitiesQuery, GetCommunitiesQueryVariables>;
export const BlogPostsQueryDocument = gql`
    query BlogPostsQuery($topics: [String], $universityId: String, $universitySlug: String, $degrees: [String], $authorId: String, $limit: LimitedInt, $offset: Int, $title: String, $order: String, $randomise: Boolean) {
  allPostsInfo(
    topics: $topics
    universityId: $universityId
    universitySlug: $universitySlug
    degrees: $degrees
    authorId: $authorId
    safeLimit: $limit
    offset: $offset
    title: $title
    order: $order
    randomise: $randomise
  ) {
    blogPosts {
      ...BlogPostPreviewFragment
    }
  }
}
    ${BlogPostPreviewFragmentFragmentDoc}`;

/**
 * __useBlogPostsQueryQuery__
 *
 * To run a query within a React component, call `useBlogPostsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostsQueryQuery({
 *   variables: {
 *      topics: // value for 'topics'
 *      universityId: // value for 'universityId'
 *      universitySlug: // value for 'universitySlug'
 *      degrees: // value for 'degrees'
 *      authorId: // value for 'authorId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      title: // value for 'title'
 *      order: // value for 'order'
 *      randomise: // value for 'randomise'
 *   },
 * });
 */
export function useBlogPostsQueryQuery(baseOptions?: Apollo.QueryHookOptions<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>(BlogPostsQueryDocument, options);
      }
export function useBlogPostsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>(BlogPostsQueryDocument, options);
        }
export function useBlogPostsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>(BlogPostsQueryDocument, options);
        }
export type BlogPostsQueryQueryHookResult = ReturnType<typeof useBlogPostsQueryQuery>;
export type BlogPostsQueryLazyQueryHookResult = ReturnType<typeof useBlogPostsQueryLazyQuery>;
export type BlogPostsQuerySuspenseQueryHookResult = ReturnType<typeof useBlogPostsQuerySuspenseQuery>;
export type BlogPostsQueryQueryResult = Apollo.QueryResult<BlogPostsQueryQuery, BlogPostsQueryQueryVariables>;
export const GetUniversityFeaturesDocument = gql`
    query GetUniversityFeatures($universitySlug: String) {
  university(slug: $universitySlug) {
    id
    config {
      features {
        enabledByUnibuddy
        enabledByUniversity
        universityCanToggleFeature
        feature {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetUniversityFeaturesQuery__
 *
 * To run a query within a React component, call `useGetUniversityFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversityFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversityFeaturesQuery({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *   },
 * });
 */
export function useGetUniversityFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>(GetUniversityFeaturesDocument, options);
      }
export function useGetUniversityFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>(GetUniversityFeaturesDocument, options);
        }
export function useGetUniversityFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>(GetUniversityFeaturesDocument, options);
        }
export type GetUniversityFeaturesQueryHookResult = ReturnType<typeof useGetUniversityFeaturesQuery>;
export type GetUniversityFeaturesLazyQueryHookResult = ReturnType<typeof useGetUniversityFeaturesLazyQuery>;
export type GetUniversityFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetUniversityFeaturesSuspenseQuery>;
export type GetUniversityFeaturesQueryResult = Apollo.QueryResult<GetUniversityFeaturesQuery, GetUniversityFeaturesQueryVariables>;
export const CommunityCreatePrivateGroupDocument = gql`
    mutation CommunityCreatePrivateGroup($createCommunityConversationDTO: CreateCommunityConversationDTO!) {
  createCommunityConversation(
    CreateCommunityConversationDTO: $createCommunityConversationDTO
  ) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}`;
export type CommunityCreatePrivateGroupMutationFn = Apollo.MutationFunction<CommunityCreatePrivateGroupMutation, CommunityCreatePrivateGroupMutationVariables>;

/**
 * __useCommunityCreatePrivateGroupMutation__
 *
 * To run a mutation, you first call `useCommunityCreatePrivateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityCreatePrivateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityCreatePrivateGroupMutation, { data, loading, error }] = useCommunityCreatePrivateGroupMutation({
 *   variables: {
 *      createCommunityConversationDTO: // value for 'createCommunityConversationDTO'
 *   },
 * });
 */
export function useCommunityCreatePrivateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CommunityCreatePrivateGroupMutation, CommunityCreatePrivateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityCreatePrivateGroupMutation, CommunityCreatePrivateGroupMutationVariables>(CommunityCreatePrivateGroupDocument, options);
      }
export type CommunityCreatePrivateGroupMutationHookResult = ReturnType<typeof useCommunityCreatePrivateGroupMutation>;
export type CommunityCreatePrivateGroupMutationResult = Apollo.MutationResult<CommunityCreatePrivateGroupMutation>;
export type CommunityCreatePrivateGroupMutationOptions = Apollo.BaseMutationOptions<CommunityCreatePrivateGroupMutation, CommunityCreatePrivateGroupMutationVariables>;
export const LeaveCommunityChatGroupDocument = gql`
    mutation LeaveCommunityChatGroup($conversationId: String!) {
  leaveCommunityChatGroup(conversationId: $conversationId) {
    id
  }
}
    `;
export type LeaveCommunityChatGroupMutationFn = Apollo.MutationFunction<LeaveCommunityChatGroupMutation, LeaveCommunityChatGroupMutationVariables>;

/**
 * __useLeaveCommunityChatGroupMutation__
 *
 * To run a mutation, you first call `useLeaveCommunityChatGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCommunityChatGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCommunityChatGroupMutation, { data, loading, error }] = useLeaveCommunityChatGroupMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useLeaveCommunityChatGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCommunityChatGroupMutation, LeaveCommunityChatGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCommunityChatGroupMutation, LeaveCommunityChatGroupMutationVariables>(LeaveCommunityChatGroupDocument, options);
      }
export type LeaveCommunityChatGroupMutationHookResult = ReturnType<typeof useLeaveCommunityChatGroupMutation>;
export type LeaveCommunityChatGroupMutationResult = Apollo.MutationResult<LeaveCommunityChatGroupMutation>;
export type LeaveCommunityChatGroupMutationOptions = Apollo.BaseMutationOptions<LeaveCommunityChatGroupMutation, LeaveCommunityChatGroupMutationVariables>;
export const CommunityInboxDocument = gql`
    query CommunityInbox($communityId: String!, $offsetPagination: OffsetPagination) {
  getUsersCommunityConversations(
    communityId: $communityId
    offsetPagination: $offsetPagination
  ) {
    ...UniversalInboxConversation
    ...LastMessageFragment
  }
}
    ${UniversalInboxConversationFragmentDoc}
${LastMessageFragmentFragmentDoc}`;

/**
 * __useCommunityInboxQuery__
 *
 * To run a query within a React component, call `useCommunityInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityInboxQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      offsetPagination: // value for 'offsetPagination'
 *   },
 * });
 */
export function useCommunityInboxQuery(baseOptions: Apollo.QueryHookOptions<CommunityInboxQuery, CommunityInboxQueryVariables> & ({ variables: CommunityInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityInboxQuery, CommunityInboxQueryVariables>(CommunityInboxDocument, options);
      }
export function useCommunityInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityInboxQuery, CommunityInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityInboxQuery, CommunityInboxQueryVariables>(CommunityInboxDocument, options);
        }
export function useCommunityInboxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityInboxQuery, CommunityInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityInboxQuery, CommunityInboxQueryVariables>(CommunityInboxDocument, options);
        }
export type CommunityInboxQueryHookResult = ReturnType<typeof useCommunityInboxQuery>;
export type CommunityInboxLazyQueryHookResult = ReturnType<typeof useCommunityInboxLazyQuery>;
export type CommunityInboxSuspenseQueryHookResult = ReturnType<typeof useCommunityInboxSuspenseQuery>;
export type CommunityInboxQueryResult = Apollo.QueryResult<CommunityInboxQuery, CommunityInboxQueryVariables>;
export const GetInviteLinkInfoDocument = gql`
    query GetInviteLinkInfo($inviteLinkId: String!) {
  getInviteLinkInfo(inviteLinkId: $inviteLinkId) {
    id
    valid
    communityId
    communityTitle
    universityName
    squareLogo
    universitySlug
    privacyPolicyUrl
  }
}
    `;

/**
 * __useGetInviteLinkInfoQuery__
 *
 * To run a query within a React component, call `useGetInviteLinkInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteLinkInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteLinkInfoQuery({
 *   variables: {
 *      inviteLinkId: // value for 'inviteLinkId'
 *   },
 * });
 */
export function useGetInviteLinkInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables> & ({ variables: GetInviteLinkInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>(GetInviteLinkInfoDocument, options);
      }
export function useGetInviteLinkInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>(GetInviteLinkInfoDocument, options);
        }
export function useGetInviteLinkInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>(GetInviteLinkInfoDocument, options);
        }
export type GetInviteLinkInfoQueryHookResult = ReturnType<typeof useGetInviteLinkInfoQuery>;
export type GetInviteLinkInfoLazyQueryHookResult = ReturnType<typeof useGetInviteLinkInfoLazyQuery>;
export type GetInviteLinkInfoSuspenseQueryHookResult = ReturnType<typeof useGetInviteLinkInfoSuspenseQuery>;
export type GetInviteLinkInfoQueryResult = Apollo.QueryResult<GetInviteLinkInfoQuery, GetInviteLinkInfoQueryVariables>;
export const JoinCommunityByInviteLinkDocument = gql`
    mutation JoinCommunityByInviteLink($communityId: String!) {
  joinCommunityByInviteLink(communityId: $communityId) {
    alreadyJoined
    joined
    community {
      id
      title
      members {
        id
      }
      institutions {
        id
        logo
        slug
        name
        squareLogo
        colour
        privacyPolicyUrl
      }
      ...CommunitySettings
      ...NewsFeedGroups
    }
  }
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}`;
export type JoinCommunityByInviteLinkMutationFn = Apollo.MutationFunction<JoinCommunityByInviteLinkMutation, JoinCommunityByInviteLinkMutationVariables>;

/**
 * __useJoinCommunityByInviteLinkMutation__
 *
 * To run a mutation, you first call `useJoinCommunityByInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityByInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityByInviteLinkMutation, { data, loading, error }] = useJoinCommunityByInviteLinkMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useJoinCommunityByInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityByInviteLinkMutation, JoinCommunityByInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityByInviteLinkMutation, JoinCommunityByInviteLinkMutationVariables>(JoinCommunityByInviteLinkDocument, options);
      }
export type JoinCommunityByInviteLinkMutationHookResult = ReturnType<typeof useJoinCommunityByInviteLinkMutation>;
export type JoinCommunityByInviteLinkMutationResult = Apollo.MutationResult<JoinCommunityByInviteLinkMutation>;
export type JoinCommunityByInviteLinkMutationOptions = Apollo.BaseMutationOptions<JoinCommunityByInviteLinkMutation, JoinCommunityByInviteLinkMutationVariables>;
export const GetJoinGroupDataDocument = gql`
    query GetJoinGroupData($communityId: String!, $conversationId: String!) {
  getCommunityForUser(communityId: $communityId) {
    id
    title
    description
    ...CommunitySettings
    ...NewsFeedGroups
    institutions {
      id
      logo
      slug
      name
      squareLogo
      colour
      privacyPolicyUrl
    }
  }
  getCommunityConversation(id: $conversationId) {
    id
    communityChatTitle
    communityChatDescription
    communityChatDynamicLink
    ...GroupTypes
  }
}
    ${CommunitySettingsFragmentDoc}
${NewsFeedGroupsFragmentDoc}
${GroupTypesFragmentDoc}`;

/**
 * __useGetJoinGroupDataQuery__
 *
 * To run a query within a React component, call `useGetJoinGroupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoinGroupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoinGroupDataQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetJoinGroupDataQuery(baseOptions: Apollo.QueryHookOptions<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables> & ({ variables: GetJoinGroupDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>(GetJoinGroupDataDocument, options);
      }
export function useGetJoinGroupDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>(GetJoinGroupDataDocument, options);
        }
export function useGetJoinGroupDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>(GetJoinGroupDataDocument, options);
        }
export type GetJoinGroupDataQueryHookResult = ReturnType<typeof useGetJoinGroupDataQuery>;
export type GetJoinGroupDataLazyQueryHookResult = ReturnType<typeof useGetJoinGroupDataLazyQuery>;
export type GetJoinGroupDataSuspenseQueryHookResult = ReturnType<typeof useGetJoinGroupDataSuspenseQuery>;
export type GetJoinGroupDataQueryResult = Apollo.QueryResult<GetJoinGroupDataQuery, GetJoinGroupDataQueryVariables>;
export const GetAreaOfStudyDocument = gql`
    query GetAreaOfStudy {
  getUserProfile {
    areaOfStudy {
      ...Degree
    }
  }
}
    ${DegreeFragmentDoc}`;

/**
 * __useGetAreaOfStudyQuery__
 *
 * To run a query within a React component, call `useGetAreaOfStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaOfStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaOfStudyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAreaOfStudyQuery(baseOptions?: Apollo.QueryHookOptions<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>(GetAreaOfStudyDocument, options);
      }
export function useGetAreaOfStudyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>(GetAreaOfStudyDocument, options);
        }
export function useGetAreaOfStudySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>(GetAreaOfStudyDocument, options);
        }
export type GetAreaOfStudyQueryHookResult = ReturnType<typeof useGetAreaOfStudyQuery>;
export type GetAreaOfStudyLazyQueryHookResult = ReturnType<typeof useGetAreaOfStudyLazyQuery>;
export type GetAreaOfStudySuspenseQueryHookResult = ReturnType<typeof useGetAreaOfStudySuspenseQuery>;
export type GetAreaOfStudyQueryResult = Apollo.QueryResult<GetAreaOfStudyQuery, GetAreaOfStudyQueryVariables>;
export const GetCommunityUserSearchDocument = gql`
    query GetCommunityUserSearch($pagination: OffsetPagination!, $filterUsers: FilterUsersDTO!) {
  communityUserSearch(pagination: $pagination, filterUsersDTO: $filterUsers) {
    result {
      id
      firstName
      lastName
      accountRole
      profilePhoto
      ...Country
      ...CommunityProfile
    }
    totalUsers
  }
}
    ${CountryFragmentDoc}
${CommunityProfileFragmentDoc}`;

/**
 * __useGetCommunityUserSearchQuery__
 *
 * To run a query within a React component, call `useGetCommunityUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityUserSearchQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filterUsers: // value for 'filterUsers'
 *   },
 * });
 */
export function useGetCommunityUserSearchQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables> & ({ variables: GetCommunityUserSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>(GetCommunityUserSearchDocument, options);
      }
export function useGetCommunityUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>(GetCommunityUserSearchDocument, options);
        }
export function useGetCommunityUserSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>(GetCommunityUserSearchDocument, options);
        }
export type GetCommunityUserSearchQueryHookResult = ReturnType<typeof useGetCommunityUserSearchQuery>;
export type GetCommunityUserSearchLazyQueryHookResult = ReturnType<typeof useGetCommunityUserSearchLazyQuery>;
export type GetCommunityUserSearchSuspenseQueryHookResult = ReturnType<typeof useGetCommunityUserSearchSuspenseQuery>;
export type GetCommunityUserSearchQueryResult = Apollo.QueryResult<GetCommunityUserSearchQuery, GetCommunityUserSearchQueryVariables>;
export const GetRecommendedUsersDocument = gql`
    query getRecommendedUsers($communityId: String!, $limit: Int, $matchingCriterion: MatchingCriteriaEnum) {
  getRecommendedUsers(
    communityId: $communityId
    limit: $limit
    matchingCriterion: $matchingCriterion
  ) {
    ...RecommendedUsers
  }
}
    ${RecommendedUsersFragmentDoc}`;

/**
 * __useGetRecommendedUsersQuery__
 *
 * To run a query within a React component, call `useGetRecommendedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedUsersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      limit: // value for 'limit'
 *      matchingCriterion: // value for 'matchingCriterion'
 *   },
 * });
 */
export function useGetRecommendedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables> & ({ variables: GetRecommendedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>(GetRecommendedUsersDocument, options);
      }
export function useGetRecommendedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>(GetRecommendedUsersDocument, options);
        }
export function useGetRecommendedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>(GetRecommendedUsersDocument, options);
        }
export type GetRecommendedUsersQueryHookResult = ReturnType<typeof useGetRecommendedUsersQuery>;
export type GetRecommendedUsersLazyQueryHookResult = ReturnType<typeof useGetRecommendedUsersLazyQuery>;
export type GetRecommendedUsersSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedUsersSuspenseQuery>;
export type GetRecommendedUsersQueryResult = Apollo.QueryResult<GetRecommendedUsersQuery, GetRecommendedUsersQueryVariables>;
export const GetRecommendedUsersByNationalityCriterionDocument = gql`
    query getRecommendedUsersByNationalityCriterion($communityId: String!, $limit: Int!, $nationalityCriterion: MatchingCriteriaEnum!) {
  nationalityRecommendedUsers: getRecommendedUsers(
    communityId: $communityId
    limit: $limit
    matchingCriterion: $nationalityCriterion
  ) {
    ...RecommendedUsers
  }
}
    ${RecommendedUsersFragmentDoc}`;

/**
 * __useGetRecommendedUsersByNationalityCriterionQuery__
 *
 * To run a query within a React component, call `useGetRecommendedUsersByNationalityCriterionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedUsersByNationalityCriterionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedUsersByNationalityCriterionQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      limit: // value for 'limit'
 *      nationalityCriterion: // value for 'nationalityCriterion'
 *   },
 * });
 */
export function useGetRecommendedUsersByNationalityCriterionQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables> & ({ variables: GetRecommendedUsersByNationalityCriterionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>(GetRecommendedUsersByNationalityCriterionDocument, options);
      }
export function useGetRecommendedUsersByNationalityCriterionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>(GetRecommendedUsersByNationalityCriterionDocument, options);
        }
export function useGetRecommendedUsersByNationalityCriterionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>(GetRecommendedUsersByNationalityCriterionDocument, options);
        }
export type GetRecommendedUsersByNationalityCriterionQueryHookResult = ReturnType<typeof useGetRecommendedUsersByNationalityCriterionQuery>;
export type GetRecommendedUsersByNationalityCriterionLazyQueryHookResult = ReturnType<typeof useGetRecommendedUsersByNationalityCriterionLazyQuery>;
export type GetRecommendedUsersByNationalityCriterionSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedUsersByNationalityCriterionSuspenseQuery>;
export type GetRecommendedUsersByNationalityCriterionQueryResult = Apollo.QueryResult<GetRecommendedUsersByNationalityCriterionQuery, GetRecommendedUsersByNationalityCriterionQueryVariables>;
export const GetRecommendedUsersByCriterionDocument = gql`
    query getRecommendedUsersByCriterion($communityId: String!, $limit: Int, $pagination: OffsetPagination, $matchingCriterion: MatchingCriteriaEnum) {
  recommendedUsers: getRecommendedUsers(
    communityId: $communityId
    limit: $limit
    pagination: $pagination
    matchingCriterion: $matchingCriterion
  ) {
    ...RecommendedUsers
  }
}
    ${RecommendedUsersFragmentDoc}`;

/**
 * __useGetRecommendedUsersByCriterionQuery__
 *
 * To run a query within a React component, call `useGetRecommendedUsersByCriterionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedUsersByCriterionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedUsersByCriterionQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      limit: // value for 'limit'
 *      pagination: // value for 'pagination'
 *      matchingCriterion: // value for 'matchingCriterion'
 *   },
 * });
 */
export function useGetRecommendedUsersByCriterionQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables> & ({ variables: GetRecommendedUsersByCriterionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>(GetRecommendedUsersByCriterionDocument, options);
      }
export function useGetRecommendedUsersByCriterionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>(GetRecommendedUsersByCriterionDocument, options);
        }
export function useGetRecommendedUsersByCriterionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>(GetRecommendedUsersByCriterionDocument, options);
        }
export type GetRecommendedUsersByCriterionQueryHookResult = ReturnType<typeof useGetRecommendedUsersByCriterionQuery>;
export type GetRecommendedUsersByCriterionLazyQueryHookResult = ReturnType<typeof useGetRecommendedUsersByCriterionLazyQuery>;
export type GetRecommendedUsersByCriterionSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedUsersByCriterionSuspenseQuery>;
export type GetRecommendedUsersByCriterionQueryResult = Apollo.QueryResult<GetRecommendedUsersByCriterionQuery, GetRecommendedUsersByCriterionQueryVariables>;
export const GetRecommendedGroupsDocument = gql`
    query GetRecommendedGroups($communityId: String!) {
  getRecommendedConversations(communityId: $communityId) {
    id
    title: communityChatTitle
    description: communityChatDescription
    members: communityChatMembers(offsetPagination: {offset: 0, limit: 999}) {
      id
    }
    membersWithProfilePhoto: communityChatMembers(
      offsetPagination: {offset: 0, limit: 15}
    ) {
      id
      communityProfile {
        id
        profilePhoto
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedGroupsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedGroupsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetRecommendedGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables> & ({ variables: GetRecommendedGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>(GetRecommendedGroupsDocument, options);
      }
export function useGetRecommendedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>(GetRecommendedGroupsDocument, options);
        }
export function useGetRecommendedGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>(GetRecommendedGroupsDocument, options);
        }
export type GetRecommendedGroupsQueryHookResult = ReturnType<typeof useGetRecommendedGroupsQuery>;
export type GetRecommendedGroupsLazyQueryHookResult = ReturnType<typeof useGetRecommendedGroupsLazyQuery>;
export type GetRecommendedGroupsSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedGroupsSuspenseQuery>;
export type GetRecommendedGroupsQueryResult = Apollo.QueryResult<GetRecommendedGroupsQuery, GetRecommendedGroupsQueryVariables>;
export const GetTopicsAndUserInterestsDocument = gql`
    query GetTopicsAndUserInterests {
  topics {
    id
    name
    description
  }
  getUserProfile {
    id
    userId
    interests {
      id
      type
    }
  }
}
    `;

/**
 * __useGetTopicsAndUserInterestsQuery__
 *
 * To run a query within a React component, call `useGetTopicsAndUserInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsAndUserInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsAndUserInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicsAndUserInterestsQuery(baseOptions?: Apollo.QueryHookOptions<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>(GetTopicsAndUserInterestsDocument, options);
      }
export function useGetTopicsAndUserInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>(GetTopicsAndUserInterestsDocument, options);
        }
export function useGetTopicsAndUserInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>(GetTopicsAndUserInterestsDocument, options);
        }
export type GetTopicsAndUserInterestsQueryHookResult = ReturnType<typeof useGetTopicsAndUserInterestsQuery>;
export type GetTopicsAndUserInterestsLazyQueryHookResult = ReturnType<typeof useGetTopicsAndUserInterestsLazyQuery>;
export type GetTopicsAndUserInterestsSuspenseQueryHookResult = ReturnType<typeof useGetTopicsAndUserInterestsSuspenseQuery>;
export type GetTopicsAndUserInterestsQueryResult = Apollo.QueryResult<GetTopicsAndUserInterestsQuery, GetTopicsAndUserInterestsQueryVariables>;
export const SetUserProfileDocument = gql`
    mutation SetUserProfile($data: UpdateUserProfile!) {
  setUserProfile(data: $data) {
    id
    userId
    interests {
      id
      type
    }
    profilePhoto
    areaOfStudy {
      id
      name
    }
    bio
    pronouns
    ...Housing
  }
}
    ${HousingFragmentDoc}`;
export type SetUserProfileMutationFn = Apollo.MutationFunction<SetUserProfileMutation, SetUserProfileMutationVariables>;

/**
 * __useSetUserProfileMutation__
 *
 * To run a mutation, you first call `useSetUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserProfileMutation, { data, loading, error }] = useSetUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SetUserProfileMutation, SetUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserProfileMutation, SetUserProfileMutationVariables>(SetUserProfileDocument, options);
      }
export type SetUserProfileMutationHookResult = ReturnType<typeof useSetUserProfileMutation>;
export type SetUserProfileMutationResult = Apollo.MutationResult<SetUserProfileMutation>;
export type SetUserProfileMutationOptions = Apollo.BaseMutationOptions<SetUserProfileMutation, SetUserProfileMutationVariables>;
export const AddToFeatureExperimentDocument = gql`
    mutation AddToFeatureExperiment($metadata: String!, $experimentName: String!) {
  addToFeatureExperiment(metadata: $metadata, experimentName: $experimentName)
}
    `;
export type AddToFeatureExperimentMutationFn = Apollo.MutationFunction<AddToFeatureExperimentMutation, AddToFeatureExperimentMutationVariables>;

/**
 * __useAddToFeatureExperimentMutation__
 *
 * To run a mutation, you first call `useAddToFeatureExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToFeatureExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToFeatureExperimentMutation, { data, loading, error }] = useAddToFeatureExperimentMutation({
 *   variables: {
 *      metadata: // value for 'metadata'
 *      experimentName: // value for 'experimentName'
 *   },
 * });
 */
export function useAddToFeatureExperimentMutation(baseOptions?: Apollo.MutationHookOptions<AddToFeatureExperimentMutation, AddToFeatureExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToFeatureExperimentMutation, AddToFeatureExperimentMutationVariables>(AddToFeatureExperimentDocument, options);
      }
export type AddToFeatureExperimentMutationHookResult = ReturnType<typeof useAddToFeatureExperimentMutation>;
export type AddToFeatureExperimentMutationResult = Apollo.MutationResult<AddToFeatureExperimentMutation>;
export type AddToFeatureExperimentMutationOptions = Apollo.BaseMutationOptions<AddToFeatureExperimentMutation, AddToFeatureExperimentMutationVariables>;
export const RequestPublicGroupDocument = gql`
    mutation RequestPublicGroup($requestPublicGroupInput: CreateRequestedPublicGroupInput!) {
  requestPublicGroup(requestPublicGroupInput: $requestPublicGroupInput) {
    id
  }
}
    `;
export type RequestPublicGroupMutationFn = Apollo.MutationFunction<RequestPublicGroupMutation, RequestPublicGroupMutationVariables>;

/**
 * __useRequestPublicGroupMutation__
 *
 * To run a mutation, you first call `useRequestPublicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPublicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPublicGroupMutation, { data, loading, error }] = useRequestPublicGroupMutation({
 *   variables: {
 *      requestPublicGroupInput: // value for 'requestPublicGroupInput'
 *   },
 * });
 */
export function useRequestPublicGroupMutation(baseOptions?: Apollo.MutationHookOptions<RequestPublicGroupMutation, RequestPublicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPublicGroupMutation, RequestPublicGroupMutationVariables>(RequestPublicGroupDocument, options);
      }
export type RequestPublicGroupMutationHookResult = ReturnType<typeof useRequestPublicGroupMutation>;
export type RequestPublicGroupMutationResult = Apollo.MutationResult<RequestPublicGroupMutation>;
export type RequestPublicGroupMutationOptions = Apollo.BaseMutationOptions<RequestPublicGroupMutation, RequestPublicGroupMutationVariables>;
export const AllCommunityChatGroupsDocument = gql`
    query AllCommunityChatGroups($communityId: String!) {
  getChatGroupsForCommunity(communityId: $communityId) {
    id
    title
    description
    conversation {
      id
    }
    members {
      id
      profilePhoto
    }
  }
}
    `;

/**
 * __useAllCommunityChatGroupsQuery__
 *
 * To run a query within a React component, call `useAllCommunityChatGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommunityChatGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommunityChatGroupsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useAllCommunityChatGroupsQuery(baseOptions: Apollo.QueryHookOptions<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables> & ({ variables: AllCommunityChatGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>(AllCommunityChatGroupsDocument, options);
      }
export function useAllCommunityChatGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>(AllCommunityChatGroupsDocument, options);
        }
export function useAllCommunityChatGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>(AllCommunityChatGroupsDocument, options);
        }
export type AllCommunityChatGroupsQueryHookResult = ReturnType<typeof useAllCommunityChatGroupsQuery>;
export type AllCommunityChatGroupsLazyQueryHookResult = ReturnType<typeof useAllCommunityChatGroupsLazyQuery>;
export type AllCommunityChatGroupsSuspenseQueryHookResult = ReturnType<typeof useAllCommunityChatGroupsSuspenseQuery>;
export type AllCommunityChatGroupsQueryResult = Apollo.QueryResult<AllCommunityChatGroupsQuery, AllCommunityChatGroupsQueryVariables>;
export const GetCommunityConversationsGroupsDocument = gql`
    query GetCommunityConversationsGroups($communityId: String!, $offsetPagination: OffsetPagination!) {
  getCommunityConversations(communityId: $communityId) {
    communityChatMembers(offsetPagination: $offsetPagination) {
      id
      communityProfile {
        profilePhoto
      }
    }
    totalMemberCount
    id
    deleted
    communityId
    communityChatTitle
    communityChatDescription
    labels {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCommunityConversationsGroupsQuery__
 *
 * To run a query within a React component, call `useGetCommunityConversationsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityConversationsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityConversationsGroupsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      offsetPagination: // value for 'offsetPagination'
 *   },
 * });
 */
export function useGetCommunityConversationsGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables> & ({ variables: GetCommunityConversationsGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>(GetCommunityConversationsGroupsDocument, options);
      }
export function useGetCommunityConversationsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>(GetCommunityConversationsGroupsDocument, options);
        }
export function useGetCommunityConversationsGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>(GetCommunityConversationsGroupsDocument, options);
        }
export type GetCommunityConversationsGroupsQueryHookResult = ReturnType<typeof useGetCommunityConversationsGroupsQuery>;
export type GetCommunityConversationsGroupsLazyQueryHookResult = ReturnType<typeof useGetCommunityConversationsGroupsLazyQuery>;
export type GetCommunityConversationsGroupsSuspenseQueryHookResult = ReturnType<typeof useGetCommunityConversationsGroupsSuspenseQuery>;
export type GetCommunityConversationsGroupsQueryResult = Apollo.QueryResult<GetCommunityConversationsGroupsQuery, GetCommunityConversationsGroupsQueryVariables>;
export const JoinCommunityConversationDocument = gql`
    mutation JoinCommunityConversation($id: String!) {
  joinCommunityConversation(conversationId: $id) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}`;
export type JoinCommunityConversationMutationFn = Apollo.MutationFunction<JoinCommunityConversationMutation, JoinCommunityConversationMutationVariables>;

/**
 * __useJoinCommunityConversationMutation__
 *
 * To run a mutation, you first call `useJoinCommunityConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityConversationMutation, { data, loading, error }] = useJoinCommunityConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJoinCommunityConversationMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityConversationMutation, JoinCommunityConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityConversationMutation, JoinCommunityConversationMutationVariables>(JoinCommunityConversationDocument, options);
      }
export type JoinCommunityConversationMutationHookResult = ReturnType<typeof useJoinCommunityConversationMutation>;
export type JoinCommunityConversationMutationResult = Apollo.MutationResult<JoinCommunityConversationMutation>;
export type JoinCommunityConversationMutationOptions = Apollo.BaseMutationOptions<JoinCommunityConversationMutation, JoinCommunityConversationMutationVariables>;
export const GetAllDegreesDocument = gql`
    query GetAllDegrees($universitySlug: String) {
  allDegrees(universitySlug: $universitySlug) {
    ...Degree
  }
  getUserProfile {
    id
    areaOfStudy {
      ...Degree
    }
  }
}
    ${DegreeFragmentDoc}`;

/**
 * __useGetAllDegreesQuery__
 *
 * To run a query within a React component, call `useGetAllDegreesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDegreesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDegreesQuery({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *   },
 * });
 */
export function useGetAllDegreesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDegreesQuery, GetAllDegreesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDegreesQuery, GetAllDegreesQueryVariables>(GetAllDegreesDocument, options);
      }
export function useGetAllDegreesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDegreesQuery, GetAllDegreesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDegreesQuery, GetAllDegreesQueryVariables>(GetAllDegreesDocument, options);
        }
export function useGetAllDegreesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDegreesQuery, GetAllDegreesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDegreesQuery, GetAllDegreesQueryVariables>(GetAllDegreesDocument, options);
        }
export type GetAllDegreesQueryHookResult = ReturnType<typeof useGetAllDegreesQuery>;
export type GetAllDegreesLazyQueryHookResult = ReturnType<typeof useGetAllDegreesLazyQuery>;
export type GetAllDegreesSuspenseQueryHookResult = ReturnType<typeof useGetAllDegreesSuspenseQuery>;
export type GetAllDegreesQueryResult = Apollo.QueryResult<GetAllDegreesQuery, GetAllDegreesQueryVariables>;
export const GetExperimentalTodosDocument = gql`
    query GetExperimentalTodos {
  getExperimentalTodos
}
    `;

/**
 * __useGetExperimentalTodosQuery__
 *
 * To run a query within a React component, call `useGetExperimentalTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExperimentalTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExperimentalTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExperimentalTodosQuery(baseOptions?: Apollo.QueryHookOptions<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>(GetExperimentalTodosDocument, options);
      }
export function useGetExperimentalTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>(GetExperimentalTodosDocument, options);
        }
export function useGetExperimentalTodosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>(GetExperimentalTodosDocument, options);
        }
export type GetExperimentalTodosQueryHookResult = ReturnType<typeof useGetExperimentalTodosQuery>;
export type GetExperimentalTodosLazyQueryHookResult = ReturnType<typeof useGetExperimentalTodosLazyQuery>;
export type GetExperimentalTodosSuspenseQueryHookResult = ReturnType<typeof useGetExperimentalTodosSuspenseQuery>;
export type GetExperimentalTodosQueryResult = Apollo.QueryResult<GetExperimentalTodosQuery, GetExperimentalTodosQueryVariables>;
export const GetTodosForUserDocument = gql`
    query GetTodosForUser {
  getTodosForUser {
    id
    title
    status
    externalLink
    description
    deadline
  }
}
    `;

/**
 * __useGetTodosForUserQuery__
 *
 * To run a query within a React component, call `useGetTodosForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodosForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodosForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTodosForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetTodosForUserQuery, GetTodosForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodosForUserQuery, GetTodosForUserQueryVariables>(GetTodosForUserDocument, options);
      }
export function useGetTodosForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodosForUserQuery, GetTodosForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodosForUserQuery, GetTodosForUserQueryVariables>(GetTodosForUserDocument, options);
        }
export function useGetTodosForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTodosForUserQuery, GetTodosForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTodosForUserQuery, GetTodosForUserQueryVariables>(GetTodosForUserDocument, options);
        }
export type GetTodosForUserQueryHookResult = ReturnType<typeof useGetTodosForUserQuery>;
export type GetTodosForUserLazyQueryHookResult = ReturnType<typeof useGetTodosForUserLazyQuery>;
export type GetTodosForUserSuspenseQueryHookResult = ReturnType<typeof useGetTodosForUserSuspenseQuery>;
export type GetTodosForUserQueryResult = Apollo.QueryResult<GetTodosForUserQuery, GetTodosForUserQueryVariables>;
export const UpdateTodoActionDocument = gql`
    mutation UpdateTodoAction($updateTodoActionId: String!, $action: TodoAction!) {
  updateTodoAction(id: $updateTodoActionId, action: $action)
}
    `;
export type UpdateTodoActionMutationFn = Apollo.MutationFunction<UpdateTodoActionMutation, UpdateTodoActionMutationVariables>;

/**
 * __useUpdateTodoActionMutation__
 *
 * To run a mutation, you first call `useUpdateTodoActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTodoActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTodoActionMutation, { data, loading, error }] = useUpdateTodoActionMutation({
 *   variables: {
 *      updateTodoActionId: // value for 'updateTodoActionId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateTodoActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTodoActionMutation, UpdateTodoActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTodoActionMutation, UpdateTodoActionMutationVariables>(UpdateTodoActionDocument, options);
      }
export type UpdateTodoActionMutationHookResult = ReturnType<typeof useUpdateTodoActionMutation>;
export type UpdateTodoActionMutationResult = Apollo.MutationResult<UpdateTodoActionMutation>;
export type UpdateTodoActionMutationOptions = Apollo.BaseMutationOptions<UpdateTodoActionMutation, UpdateTodoActionMutationVariables>;
export const GetCommunityForUserDocument = gql`
    query GetCommunityForUser($communityId: String!) {
  getCommunityForUser(communityId: $communityId) {
    id
    title
    description
    members {
      id
    }
    institutions {
      id
      logo
      slug
      name
      squareLogo
      colour
      privacyPolicyUrl
    }
  }
}
    `;

/**
 * __useGetCommunityForUserQuery__
 *
 * To run a query within a React component, call `useGetCommunityForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityForUserQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityForUserQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityForUserQuery, GetCommunityForUserQueryVariables> & ({ variables: GetCommunityForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>(GetCommunityForUserDocument, options);
      }
export function useGetCommunityForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>(GetCommunityForUserDocument, options);
        }
export function useGetCommunityForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>(GetCommunityForUserDocument, options);
        }
export type GetCommunityForUserQueryHookResult = ReturnType<typeof useGetCommunityForUserQuery>;
export type GetCommunityForUserLazyQueryHookResult = ReturnType<typeof useGetCommunityForUserLazyQuery>;
export type GetCommunityForUserSuspenseQueryHookResult = ReturnType<typeof useGetCommunityForUserSuspenseQuery>;
export type GetCommunityForUserQueryResult = Apollo.QueryResult<GetCommunityForUserQuery, GetCommunityForUserQueryVariables>;
export const GetDiscoverableUniversitiesDocument = gql`
    query GetDiscoverableUniversities($limit: Int, $offset: Int, $name: String, $randomizeSeed: Int) {
  discoverableUniversities(
    limit: $limit
    offset: $offset
    name: $name
    randomizeSeed: $randomizeSeed
  ) {
    ...DiscoverableUniversity
    ...DiscoverableUniversityCountryField
  }
}
    ${DiscoverableUniversityFragmentDoc}
${DiscoverableUniversityCountryFieldFragmentDoc}`;

/**
 * __useGetDiscoverableUniversitiesQuery__
 *
 * To run a query within a React component, call `useGetDiscoverableUniversitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverableUniversitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverableUniversitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      randomizeSeed: // value for 'randomizeSeed'
 *   },
 * });
 */
export function useGetDiscoverableUniversitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>(GetDiscoverableUniversitiesDocument, options);
      }
export function useGetDiscoverableUniversitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>(GetDiscoverableUniversitiesDocument, options);
        }
export function useGetDiscoverableUniversitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>(GetDiscoverableUniversitiesDocument, options);
        }
export type GetDiscoverableUniversitiesQueryHookResult = ReturnType<typeof useGetDiscoverableUniversitiesQuery>;
export type GetDiscoverableUniversitiesLazyQueryHookResult = ReturnType<typeof useGetDiscoverableUniversitiesLazyQuery>;
export type GetDiscoverableUniversitiesSuspenseQueryHookResult = ReturnType<typeof useGetDiscoverableUniversitiesSuspenseQuery>;
export type GetDiscoverableUniversitiesQueryResult = Apollo.QueryResult<GetDiscoverableUniversitiesQuery, GetDiscoverableUniversitiesQueryVariables>;
export const GetUniversityDocument = gql`
    query GetUniversity($id: String) {
  university(id: $id) {
    ...DiscoverableUniversity
    ...DiscoverableUniversityCustomAttributes
    ...DiscoverableUniversityEntries
  }
}
    ${DiscoverableUniversityFragmentDoc}
${DiscoverableUniversityCustomAttributesFragmentDoc}
${DiscoverableUniversityEntriesFragmentDoc}`;

/**
 * __useGetUniversityQuery__
 *
 * To run a query within a React component, call `useGetUniversityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUniversityQuery(baseOptions?: Apollo.QueryHookOptions<GetUniversityQuery, GetUniversityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniversityQuery, GetUniversityQueryVariables>(GetUniversityDocument, options);
      }
export function useGetUniversityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversityQuery, GetUniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniversityQuery, GetUniversityQueryVariables>(GetUniversityDocument, options);
        }
export function useGetUniversitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUniversityQuery, GetUniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniversityQuery, GetUniversityQueryVariables>(GetUniversityDocument, options);
        }
export type GetUniversityQueryHookResult = ReturnType<typeof useGetUniversityQuery>;
export type GetUniversityLazyQueryHookResult = ReturnType<typeof useGetUniversityLazyQuery>;
export type GetUniversitySuspenseQueryHookResult = ReturnType<typeof useGetUniversitySuspenseQuery>;
export type GetUniversityQueryResult = Apollo.QueryResult<GetUniversityQuery, GetUniversityQueryVariables>;
export const SaveUniversityInterestedDocument = gql`
    mutation SaveUniversityInterested($universityInterestedDto: UniversityInterestedDTO!) {
  saveUniversityInterested(UniversityInterestedDTO: $universityInterestedDto) {
    name
  }
}
    `;
export type SaveUniversityInterestedMutationFn = Apollo.MutationFunction<SaveUniversityInterestedMutation, SaveUniversityInterestedMutationVariables>;

/**
 * __useSaveUniversityInterestedMutation__
 *
 * To run a mutation, you first call `useSaveUniversityInterestedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUniversityInterestedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUniversityInterestedMutation, { data, loading, error }] = useSaveUniversityInterestedMutation({
 *   variables: {
 *      universityInterestedDto: // value for 'universityInterestedDto'
 *   },
 * });
 */
export function useSaveUniversityInterestedMutation(baseOptions?: Apollo.MutationHookOptions<SaveUniversityInterestedMutation, SaveUniversityInterestedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUniversityInterestedMutation, SaveUniversityInterestedMutationVariables>(SaveUniversityInterestedDocument, options);
      }
export type SaveUniversityInterestedMutationHookResult = ReturnType<typeof useSaveUniversityInterestedMutation>;
export type SaveUniversityInterestedMutationResult = Apollo.MutationResult<SaveUniversityInterestedMutation>;
export type SaveUniversityInterestedMutationOptions = Apollo.BaseMutationOptions<SaveUniversityInterestedMutation, SaveUniversityInterestedMutationVariables>;
export const UpdateUniversityLinkDocument = gql`
    mutation UpdateUniversityLink($universitySlug: String, $sourceTrackingParams: JSONString, $acceptMarketing: Boolean) {
  updateMyUniversityLink(
    universitySlug: $universitySlug
    sourceTrackingParams: $sourceTrackingParams
    acceptMarketing: $acceptMarketing
  ) {
    me {
      anyUser {
        id
      }
    }
  }
}
    `;
export type UpdateUniversityLinkMutationFn = Apollo.MutationFunction<UpdateUniversityLinkMutation, UpdateUniversityLinkMutationVariables>;

/**
 * __useUpdateUniversityLinkMutation__
 *
 * To run a mutation, you first call `useUpdateUniversityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUniversityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUniversityLinkMutation, { data, loading, error }] = useUpdateUniversityLinkMutation({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *      sourceTrackingParams: // value for 'sourceTrackingParams'
 *      acceptMarketing: // value for 'acceptMarketing'
 *   },
 * });
 */
export function useUpdateUniversityLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUniversityLinkMutation, UpdateUniversityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUniversityLinkMutation, UpdateUniversityLinkMutationVariables>(UpdateUniversityLinkDocument, options);
      }
export type UpdateUniversityLinkMutationHookResult = ReturnType<typeof useUpdateUniversityLinkMutation>;
export type UpdateUniversityLinkMutationResult = Apollo.MutationResult<UpdateUniversityLinkMutation>;
export type UpdateUniversityLinkMutationOptions = Apollo.BaseMutationOptions<UpdateUniversityLinkMutation, UpdateUniversityLinkMutationVariables>;
export const UpdateUniversityLinkStep2Document = gql`
    mutation UpdateUniversityLinkStep2($universitySlug: String, $countryId: String, $degreesInterested: [String], $dateOfEntry: Date) {
  updateMyUniversityLink(
    universitySlug: $universitySlug
    countryId: $countryId
    degreesInterested: $degreesInterested
    dateOfEntry: $dateOfEntry
  ) {
    me {
      anyUser {
        id
      }
    }
  }
}
    `;
export type UpdateUniversityLinkStep2MutationFn = Apollo.MutationFunction<UpdateUniversityLinkStep2Mutation, UpdateUniversityLinkStep2MutationVariables>;

/**
 * __useUpdateUniversityLinkStep2Mutation__
 *
 * To run a mutation, you first call `useUpdateUniversityLinkStep2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUniversityLinkStep2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUniversityLinkStep2Mutation, { data, loading, error }] = useUpdateUniversityLinkStep2Mutation({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *      countryId: // value for 'countryId'
 *      degreesInterested: // value for 'degreesInterested'
 *      dateOfEntry: // value for 'dateOfEntry'
 *   },
 * });
 */
export function useUpdateUniversityLinkStep2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateUniversityLinkStep2Mutation, UpdateUniversityLinkStep2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUniversityLinkStep2Mutation, UpdateUniversityLinkStep2MutationVariables>(UpdateUniversityLinkStep2Document, options);
      }
export type UpdateUniversityLinkStep2MutationHookResult = ReturnType<typeof useUpdateUniversityLinkStep2Mutation>;
export type UpdateUniversityLinkStep2MutationResult = Apollo.MutationResult<UpdateUniversityLinkStep2Mutation>;
export type UpdateUniversityLinkStep2MutationOptions = Apollo.BaseMutationOptions<UpdateUniversityLinkStep2Mutation, UpdateUniversityLinkStep2MutationVariables>;
export const GetLabelsDocument = gql`
    query GetLabels {
  getLabels {
    id
    name
  }
}
    `;

/**
 * __useGetLabelsQuery__
 *
 * To run a query within a React component, call `useGetLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, options);
      }
export function useGetLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, options);
        }
export function useGetLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLabelsQuery, GetLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLabelsQuery, GetLabelsQueryVariables>(GetLabelsDocument, options);
        }
export type GetLabelsQueryHookResult = ReturnType<typeof useGetLabelsQuery>;
export type GetLabelsLazyQueryHookResult = ReturnType<typeof useGetLabelsLazyQuery>;
export type GetLabelsSuspenseQueryHookResult = ReturnType<typeof useGetLabelsSuspenseQuery>;
export type GetLabelsQueryResult = Apollo.QueryResult<GetLabelsQuery, GetLabelsQueryVariables>;
export const GetGeckoUniversityDocument = gql`
    query GetGeckoUniversity($universityId: String!) {
  getGeckoUniversityId(universityId: $universityId) {
    geckoUniversityId
    geckoUniversityName
  }
}
    `;

/**
 * __useGetGeckoUniversityQuery__
 *
 * To run a query within a React component, call `useGetGeckoUniversityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeckoUniversityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeckoUniversityQuery({
 *   variables: {
 *      universityId: // value for 'universityId'
 *   },
 * });
 */
export function useGetGeckoUniversityQuery(baseOptions: Apollo.QueryHookOptions<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables> & ({ variables: GetGeckoUniversityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>(GetGeckoUniversityDocument, options);
      }
export function useGetGeckoUniversityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>(GetGeckoUniversityDocument, options);
        }
export function useGetGeckoUniversitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>(GetGeckoUniversityDocument, options);
        }
export type GetGeckoUniversityQueryHookResult = ReturnType<typeof useGetGeckoUniversityQuery>;
export type GetGeckoUniversityLazyQueryHookResult = ReturnType<typeof useGetGeckoUniversityLazyQuery>;
export type GetGeckoUniversitySuspenseQueryHookResult = ReturnType<typeof useGetGeckoUniversitySuspenseQuery>;
export type GetGeckoUniversityQueryResult = Apollo.QueryResult<GetGeckoUniversityQuery, GetGeckoUniversityQueryVariables>;
export const UniversityQuestionsDocument = gql`
    query UniversityQuestions($confidenceRatingQuestionInput: UniversityQuestionByIdInput!, $feelConfidentQuestionInput: UniversityQuestionByIdInput!) {
  question1: universityQuestionById(
    universityQuestionByIdInput: $confidenceRatingQuestionInput
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
  question2: universityQuestionById(
    universityQuestionByIdInput: $feelConfidentQuestionInput
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
}
    `;

/**
 * __useUniversityQuestionsQuery__
 *
 * To run a query within a React component, call `useUniversityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversityQuestionsQuery({
 *   variables: {
 *      confidenceRatingQuestionInput: // value for 'confidenceRatingQuestionInput'
 *      feelConfidentQuestionInput: // value for 'feelConfidentQuestionInput'
 *   },
 * });
 */
export function useUniversityQuestionsQuery(baseOptions: Apollo.QueryHookOptions<UniversityQuestionsQuery, UniversityQuestionsQueryVariables> & ({ variables: UniversityQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>(UniversityQuestionsDocument, options);
      }
export function useUniversityQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>(UniversityQuestionsDocument, options);
        }
export function useUniversityQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>(UniversityQuestionsDocument, options);
        }
export type UniversityQuestionsQueryHookResult = ReturnType<typeof useUniversityQuestionsQuery>;
export type UniversityQuestionsLazyQueryHookResult = ReturnType<typeof useUniversityQuestionsLazyQuery>;
export type UniversityQuestionsSuspenseQueryHookResult = ReturnType<typeof useUniversityQuestionsSuspenseQuery>;
export type UniversityQuestionsQueryResult = Apollo.QueryResult<UniversityQuestionsQuery, UniversityQuestionsQueryVariables>;
export const SaveUniversityQuestionAnswerDocument = gql`
    mutation SaveUniversityQuestionAnswer($saveUniversityQuestionAnswerInput: SaveUniversityQuestionAnswerInput!) {
  saveUniversityQuestionAnswer(
    saveUniversityQuestionAnswerInput: $saveUniversityQuestionAnswerInput
  ) {
    id
  }
}
    `;
export type SaveUniversityQuestionAnswerMutationFn = Apollo.MutationFunction<SaveUniversityQuestionAnswerMutation, SaveUniversityQuestionAnswerMutationVariables>;

/**
 * __useSaveUniversityQuestionAnswerMutation__
 *
 * To run a mutation, you first call `useSaveUniversityQuestionAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUniversityQuestionAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUniversityQuestionAnswerMutation, { data, loading, error }] = useSaveUniversityQuestionAnswerMutation({
 *   variables: {
 *      saveUniversityQuestionAnswerInput: // value for 'saveUniversityQuestionAnswerInput'
 *   },
 * });
 */
export function useSaveUniversityQuestionAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveUniversityQuestionAnswerMutation, SaveUniversityQuestionAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUniversityQuestionAnswerMutation, SaveUniversityQuestionAnswerMutationVariables>(SaveUniversityQuestionAnswerDocument, options);
      }
export type SaveUniversityQuestionAnswerMutationHookResult = ReturnType<typeof useSaveUniversityQuestionAnswerMutation>;
export type SaveUniversityQuestionAnswerMutationResult = Apollo.MutationResult<SaveUniversityQuestionAnswerMutation>;
export type SaveUniversityQuestionAnswerMutationOptions = Apollo.BaseMutationOptions<SaveUniversityQuestionAnswerMutation, SaveUniversityQuestionAnswerMutationVariables>;
export const EnrolledUniversityQuestionsDocument = gql`
    query EnrolledUniversityQuestions($haveEnrolledQuestionInput: UniversityQuestionByIdInput!, $enrolledCommunityInfluenceRatingQuestionInput: UniversityQuestionByIdInput!, $enrolledMoreInfo: UniversityQuestionByIdInput!, $enroledWhatInfluencedDecision: UniversityQuestionByIdInput!, $didCommunityHelpedInDecision: UniversityQuestionByIdInput!) {
  question1: universityQuestionById(
    universityQuestionByIdInput: $haveEnrolledQuestionInput
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
  question2: universityQuestionById(
    universityQuestionByIdInput: $enrolledCommunityInfluenceRatingQuestionInput
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
  question3: universityQuestionById(
    universityQuestionByIdInput: $enrolledMoreInfo
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
  question4: universityQuestionById(
    universityQuestionByIdInput: $enroledWhatInfluencedDecision
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
  question5: universityQuestionById(
    universityQuestionByIdInput: $didCommunityHelpedInDecision
  ) {
    id
    active
    text
    options {
      text
      id
    }
  }
}
    `;

/**
 * __useEnrolledUniversityQuestionsQuery__
 *
 * To run a query within a React component, call `useEnrolledUniversityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrolledUniversityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrolledUniversityQuestionsQuery({
 *   variables: {
 *      haveEnrolledQuestionInput: // value for 'haveEnrolledQuestionInput'
 *      enrolledCommunityInfluenceRatingQuestionInput: // value for 'enrolledCommunityInfluenceRatingQuestionInput'
 *      enrolledMoreInfo: // value for 'enrolledMoreInfo'
 *      enroledWhatInfluencedDecision: // value for 'enroledWhatInfluencedDecision'
 *      didCommunityHelpedInDecision: // value for 'didCommunityHelpedInDecision'
 *   },
 * });
 */
export function useEnrolledUniversityQuestionsQuery(baseOptions: Apollo.QueryHookOptions<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables> & ({ variables: EnrolledUniversityQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>(EnrolledUniversityQuestionsDocument, options);
      }
export function useEnrolledUniversityQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>(EnrolledUniversityQuestionsDocument, options);
        }
export function useEnrolledUniversityQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>(EnrolledUniversityQuestionsDocument, options);
        }
export type EnrolledUniversityQuestionsQueryHookResult = ReturnType<typeof useEnrolledUniversityQuestionsQuery>;
export type EnrolledUniversityQuestionsLazyQueryHookResult = ReturnType<typeof useEnrolledUniversityQuestionsLazyQuery>;
export type EnrolledUniversityQuestionsSuspenseQueryHookResult = ReturnType<typeof useEnrolledUniversityQuestionsSuspenseQuery>;
export type EnrolledUniversityQuestionsQueryResult = Apollo.QueryResult<EnrolledUniversityQuestionsQuery, EnrolledUniversityQuestionsQueryVariables>;
export const SendCommunityFeedbackDocument = gql`
    mutation SendCommunityFeedback($communityId: String!, $universitySlug: String!, $question: String!, $rating: Float!, $feedback: String) {
  saveSatisfactionSurvey(
    SatisfactionSurveyDTO: {communityId: $communityId, universitySlug: $universitySlug, question: $question, rating: $rating, feedback: $feedback}
  ) {
    userId
    communityId
    universitySlug
  }
}
    `;
export type SendCommunityFeedbackMutationFn = Apollo.MutationFunction<SendCommunityFeedbackMutation, SendCommunityFeedbackMutationVariables>;

/**
 * __useSendCommunityFeedbackMutation__
 *
 * To run a mutation, you first call `useSendCommunityFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommunityFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommunityFeedbackMutation, { data, loading, error }] = useSendCommunityFeedbackMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      universitySlug: // value for 'universitySlug'
 *      question: // value for 'question'
 *      rating: // value for 'rating'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSendCommunityFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendCommunityFeedbackMutation, SendCommunityFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommunityFeedbackMutation, SendCommunityFeedbackMutationVariables>(SendCommunityFeedbackDocument, options);
      }
export type SendCommunityFeedbackMutationHookResult = ReturnType<typeof useSendCommunityFeedbackMutation>;
export type SendCommunityFeedbackMutationResult = Apollo.MutationResult<SendCommunityFeedbackMutation>;
export type SendCommunityFeedbackMutationOptions = Apollo.BaseMutationOptions<SendCommunityFeedbackMutation, SendCommunityFeedbackMutationVariables>;
export const InboxPromptQuestionsDocument = gql`
    query InboxPromptQuestions($inboxPromptInput: InboxPromptInput!) {
  inboxPromptQuestions(inboxPromptInput: $inboxPromptInput) {
    id
    options {
      id
      text
      active
    }
    tags
  }
}
    `;

/**
 * __useInboxPromptQuestionsQuery__
 *
 * To run a query within a React component, call `useInboxPromptQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPromptQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPromptQuestionsQuery({
 *   variables: {
 *      inboxPromptInput: // value for 'inboxPromptInput'
 *   },
 * });
 */
export function useInboxPromptQuestionsQuery(baseOptions: Apollo.QueryHookOptions<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables> & ({ variables: InboxPromptQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>(InboxPromptQuestionsDocument, options);
      }
export function useInboxPromptQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>(InboxPromptQuestionsDocument, options);
        }
export function useInboxPromptQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>(InboxPromptQuestionsDocument, options);
        }
export type InboxPromptQuestionsQueryHookResult = ReturnType<typeof useInboxPromptQuestionsQuery>;
export type InboxPromptQuestionsLazyQueryHookResult = ReturnType<typeof useInboxPromptQuestionsLazyQuery>;
export type InboxPromptQuestionsSuspenseQueryHookResult = ReturnType<typeof useInboxPromptQuestionsSuspenseQuery>;
export type InboxPromptQuestionsQueryResult = Apollo.QueryResult<InboxPromptQuestionsQuery, InboxPromptQuestionsQueryVariables>;
export const SaveInboxPromptAnswerDocument = gql`
    mutation SaveInboxPromptAnswer($inboxPromptAnswerInput: InboxPromptAnswerInput!) {
  saveInboxPromptAnswer(inboxPromptAnswerInput: $inboxPromptAnswerInput) {
    id
  }
}
    `;
export type SaveInboxPromptAnswerMutationFn = Apollo.MutationFunction<SaveInboxPromptAnswerMutation, SaveInboxPromptAnswerMutationVariables>;

/**
 * __useSaveInboxPromptAnswerMutation__
 *
 * To run a mutation, you first call `useSaveInboxPromptAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInboxPromptAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInboxPromptAnswerMutation, { data, loading, error }] = useSaveInboxPromptAnswerMutation({
 *   variables: {
 *      inboxPromptAnswerInput: // value for 'inboxPromptAnswerInput'
 *   },
 * });
 */
export function useSaveInboxPromptAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveInboxPromptAnswerMutation, SaveInboxPromptAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInboxPromptAnswerMutation, SaveInboxPromptAnswerMutationVariables>(SaveInboxPromptAnswerDocument, options);
      }
export type SaveInboxPromptAnswerMutationHookResult = ReturnType<typeof useSaveInboxPromptAnswerMutation>;
export type SaveInboxPromptAnswerMutationResult = Apollo.MutationResult<SaveInboxPromptAnswerMutation>;
export type SaveInboxPromptAnswerMutationOptions = Apollo.BaseMutationOptions<SaveInboxPromptAnswerMutation, SaveInboxPromptAnswerMutationVariables>;
export const GetUserCreatedByUserIdDocument = gql`
    query GetUserCreatedByUserId($id: String!) {
  getUser(id: $id) {
    id
    firstName
    created
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useGetUserCreatedByUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserCreatedByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreatedByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreatedByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCreatedByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables> & ({ variables: GetUserCreatedByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>(GetUserCreatedByUserIdDocument, options);
      }
export function useGetUserCreatedByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>(GetUserCreatedByUserIdDocument, options);
        }
export function useGetUserCreatedByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>(GetUserCreatedByUserIdDocument, options);
        }
export type GetUserCreatedByUserIdQueryHookResult = ReturnType<typeof useGetUserCreatedByUserIdQuery>;
export type GetUserCreatedByUserIdLazyQueryHookResult = ReturnType<typeof useGetUserCreatedByUserIdLazyQuery>;
export type GetUserCreatedByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetUserCreatedByUserIdSuspenseQuery>;
export type GetUserCreatedByUserIdQueryResult = Apollo.QueryResult<GetUserCreatedByUserIdQuery, GetUserCreatedByUserIdQueryVariables>;
export const SaveNotInterestedStageDocument = gql`
    mutation saveNotInterestedStage($notInterestedStageInput: UserNotInterestedStageInput!) {
  saveNotInterestedStage(notInterestedStageInput: $notInterestedStageInput) {
    decisionStage
    decisionStageLocation
    notInterestedReason
    userId
  }
}
    `;
export type SaveNotInterestedStageMutationFn = Apollo.MutationFunction<SaveNotInterestedStageMutation, SaveNotInterestedStageMutationVariables>;

/**
 * __useSaveNotInterestedStageMutation__
 *
 * To run a mutation, you first call `useSaveNotInterestedStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNotInterestedStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNotInterestedStageMutation, { data, loading, error }] = useSaveNotInterestedStageMutation({
 *   variables: {
 *      notInterestedStageInput: // value for 'notInterestedStageInput'
 *   },
 * });
 */
export function useSaveNotInterestedStageMutation(baseOptions?: Apollo.MutationHookOptions<SaveNotInterestedStageMutation, SaveNotInterestedStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNotInterestedStageMutation, SaveNotInterestedStageMutationVariables>(SaveNotInterestedStageDocument, options);
      }
export type SaveNotInterestedStageMutationHookResult = ReturnType<typeof useSaveNotInterestedStageMutation>;
export type SaveNotInterestedStageMutationResult = Apollo.MutationResult<SaveNotInterestedStageMutation>;
export type SaveNotInterestedStageMutationOptions = Apollo.BaseMutationOptions<SaveNotInterestedStageMutation, SaveNotInterestedStageMutationVariables>;
export const SaveUserDecisionStageDocument = gql`
    mutation saveUserDecisionStage($decisionStageInput: UserDecisionStageInput!) {
  saveUserDecisionStage(decisionStageInput: $decisionStageInput) {
    decisionStage
    decisionStageLocation
    notInterestedReason
    userId
  }
}
    `;
export type SaveUserDecisionStageMutationFn = Apollo.MutationFunction<SaveUserDecisionStageMutation, SaveUserDecisionStageMutationVariables>;

/**
 * __useSaveUserDecisionStageMutation__
 *
 * To run a mutation, you first call `useSaveUserDecisionStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserDecisionStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserDecisionStageMutation, { data, loading, error }] = useSaveUserDecisionStageMutation({
 *   variables: {
 *      decisionStageInput: // value for 'decisionStageInput'
 *   },
 * });
 */
export function useSaveUserDecisionStageMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserDecisionStageMutation, SaveUserDecisionStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserDecisionStageMutation, SaveUserDecisionStageMutationVariables>(SaveUserDecisionStageDocument, options);
      }
export type SaveUserDecisionStageMutationHookResult = ReturnType<typeof useSaveUserDecisionStageMutation>;
export type SaveUserDecisionStageMutationResult = Apollo.MutationResult<SaveUserDecisionStageMutation>;
export type SaveUserDecisionStageMutationOptions = Apollo.BaseMutationOptions<SaveUserDecisionStageMutation, SaveUserDecisionStageMutationVariables>;
export const GetConversationPermissionDocument = gql`
    query GetConversationPermission($conversationId: String!) {
  getConversationPermission(id: $conversationId) {
    id
    isMember
  }
}
    `;

/**
 * __useGetConversationPermissionQuery__
 *
 * To run a query within a React component, call `useGetConversationPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationPermissionQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetConversationPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetConversationPermissionQuery, GetConversationPermissionQueryVariables> & ({ variables: GetConversationPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>(GetConversationPermissionDocument, options);
      }
export function useGetConversationPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>(GetConversationPermissionDocument, options);
        }
export function useGetConversationPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>(GetConversationPermissionDocument, options);
        }
export type GetConversationPermissionQueryHookResult = ReturnType<typeof useGetConversationPermissionQuery>;
export type GetConversationPermissionLazyQueryHookResult = ReturnType<typeof useGetConversationPermissionLazyQuery>;
export type GetConversationPermissionSuspenseQueryHookResult = ReturnType<typeof useGetConversationPermissionSuspenseQuery>;
export type GetConversationPermissionQueryResult = Apollo.QueryResult<GetConversationPermissionQuery, GetConversationPermissionQueryVariables>;
export const GetInterestsDocument = gql`
    query GetInterests {
  getInterests {
    id
    name
  }
}
    `;

/**
 * __useGetInterestsQuery__
 *
 * To run a query within a React component, call `useGetInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterestsQuery(baseOptions?: Apollo.QueryHookOptions<GetInterestsQuery, GetInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterestsQuery, GetInterestsQueryVariables>(GetInterestsDocument, options);
      }
export function useGetInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterestsQuery, GetInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterestsQuery, GetInterestsQueryVariables>(GetInterestsDocument, options);
        }
export function useGetInterestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInterestsQuery, GetInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInterestsQuery, GetInterestsQueryVariables>(GetInterestsDocument, options);
        }
export type GetInterestsQueryHookResult = ReturnType<typeof useGetInterestsQuery>;
export type GetInterestsLazyQueryHookResult = ReturnType<typeof useGetInterestsLazyQuery>;
export type GetInterestsSuspenseQueryHookResult = ReturnType<typeof useGetInterestsSuspenseQuery>;
export type GetInterestsQueryResult = Apollo.QueryResult<GetInterestsQuery, GetInterestsQueryVariables>;
export const GetCommunityUserDirectoryDocument = gql`
    query GetCommunityUserDirectory($pagination: OffsetPagination!, $filterUsers: FilterUsersDTO!) {
  communityUserSearch(pagination: $pagination, filterUsersDTO: $filterUsers) {
    result {
      id
      firstName
      lastName
      accountRole
      profilePhoto
      ...Country
      ...CommunityProfile
    }
    totalUsers
  }
}
    ${CountryFragmentDoc}
${CommunityProfileFragmentDoc}`;

/**
 * __useGetCommunityUserDirectoryQuery__
 *
 * To run a query within a React component, call `useGetCommunityUserDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityUserDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityUserDirectoryQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filterUsers: // value for 'filterUsers'
 *   },
 * });
 */
export function useGetCommunityUserDirectoryQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables> & ({ variables: GetCommunityUserDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>(GetCommunityUserDirectoryDocument, options);
      }
export function useGetCommunityUserDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>(GetCommunityUserDirectoryDocument, options);
        }
export function useGetCommunityUserDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>(GetCommunityUserDirectoryDocument, options);
        }
export type GetCommunityUserDirectoryQueryHookResult = ReturnType<typeof useGetCommunityUserDirectoryQuery>;
export type GetCommunityUserDirectoryLazyQueryHookResult = ReturnType<typeof useGetCommunityUserDirectoryLazyQuery>;
export type GetCommunityUserDirectorySuspenseQueryHookResult = ReturnType<typeof useGetCommunityUserDirectorySuspenseQuery>;
export type GetCommunityUserDirectoryQueryResult = Apollo.QueryResult<GetCommunityUserDirectoryQuery, GetCommunityUserDirectoryQueryVariables>;
export const SetInterestsForUserDocument = gql`
    mutation SetInterestsForUser($setUserInterestsInput: SetUserInterestsInput!) {
  setInterestsForUser(setUserInterestsInput: $setUserInterestsInput) {
    id
    name
  }
}
    `;
export type SetInterestsForUserMutationFn = Apollo.MutationFunction<SetInterestsForUserMutation, SetInterestsForUserMutationVariables>;

/**
 * __useSetInterestsForUserMutation__
 *
 * To run a mutation, you first call `useSetInterestsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInterestsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInterestsForUserMutation, { data, loading, error }] = useSetInterestsForUserMutation({
 *   variables: {
 *      setUserInterestsInput: // value for 'setUserInterestsInput'
 *   },
 * });
 */
export function useSetInterestsForUserMutation(baseOptions?: Apollo.MutationHookOptions<SetInterestsForUserMutation, SetInterestsForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInterestsForUserMutation, SetInterestsForUserMutationVariables>(SetInterestsForUserDocument, options);
      }
export type SetInterestsForUserMutationHookResult = ReturnType<typeof useSetInterestsForUserMutation>;
export type SetInterestsForUserMutationResult = Apollo.MutationResult<SetInterestsForUserMutation>;
export type SetInterestsForUserMutationOptions = Apollo.BaseMutationOptions<SetInterestsForUserMutation, SetInterestsForUserMutationVariables>;
export const GetAllCountriesDocument = gql`
    query getAllCountries {
  allCountries {
    code
    id
    name
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesSuspenseQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const UpdateApplicantDetailsDocument = gql`
    mutation UpdateApplicantDetails($firstName: String, $lastName: String, $country: String) {
  updateApplicant(firstName: $firstName, lastName: $lastName, country: $country) {
    me {
      applicant {
        id
      }
      anyUser {
        firstName
        lastName
        country {
          name
          code
          id
        }
      }
    }
  }
}
    `;
export type UpdateApplicantDetailsMutationFn = Apollo.MutationFunction<UpdateApplicantDetailsMutation, UpdateApplicantDetailsMutationVariables>;

/**
 * __useUpdateApplicantDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateApplicantDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicantDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicantDetailsMutation, { data, loading, error }] = useUpdateApplicantDetailsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useUpdateApplicantDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicantDetailsMutation, UpdateApplicantDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicantDetailsMutation, UpdateApplicantDetailsMutationVariables>(UpdateApplicantDetailsDocument, options);
      }
export type UpdateApplicantDetailsMutationHookResult = ReturnType<typeof useUpdateApplicantDetailsMutation>;
export type UpdateApplicantDetailsMutationResult = Apollo.MutationResult<UpdateApplicantDetailsMutation>;
export type UpdateApplicantDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateApplicantDetailsMutation, UpdateApplicantDetailsMutationVariables>;
export const GetAccountInformationDocument = gql`
    query GetAccountInformation {
  getUserProfile {
    id
    userId
    interests {
      id
      type
    }
    profilePhoto
    areaOfStudy {
      ...Degree
    }
    bio
    pronouns
    housing {
      category
      name
    }
  }
  getInterests {
    id
    name
  }
  getInterestsForUser {
    id
    name
  }
}
    ${DegreeFragmentDoc}`;

/**
 * __useGetAccountInformationQuery__
 *
 * To run a query within a React component, call `useGetAccountInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountInformationQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(GetAccountInformationDocument, options);
      }
export function useGetAccountInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(GetAccountInformationDocument, options);
        }
export function useGetAccountInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(GetAccountInformationDocument, options);
        }
export type GetAccountInformationQueryHookResult = ReturnType<typeof useGetAccountInformationQuery>;
export type GetAccountInformationLazyQueryHookResult = ReturnType<typeof useGetAccountInformationLazyQuery>;
export type GetAccountInformationSuspenseQueryHookResult = ReturnType<typeof useGetAccountInformationSuspenseQuery>;
export type GetAccountInformationQueryResult = Apollo.QueryResult<GetAccountInformationQuery, GetAccountInformationQueryVariables>;
export const InitiateUserDeletionDocument = gql`
    mutation InitiateUserDeletion {
  initiateUserDeletion
}
    `;
export type InitiateUserDeletionMutationFn = Apollo.MutationFunction<InitiateUserDeletionMutation, InitiateUserDeletionMutationVariables>;

/**
 * __useInitiateUserDeletionMutation__
 *
 * To run a mutation, you first call `useInitiateUserDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateUserDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateUserDeletionMutation, { data, loading, error }] = useInitiateUserDeletionMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitiateUserDeletionMutation(baseOptions?: Apollo.MutationHookOptions<InitiateUserDeletionMutation, InitiateUserDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateUserDeletionMutation, InitiateUserDeletionMutationVariables>(InitiateUserDeletionDocument, options);
      }
export type InitiateUserDeletionMutationHookResult = ReturnType<typeof useInitiateUserDeletionMutation>;
export type InitiateUserDeletionMutationResult = Apollo.MutationResult<InitiateUserDeletionMutation>;
export type InitiateUserDeletionMutationOptions = Apollo.BaseMutationOptions<InitiateUserDeletionMutation, InitiateUserDeletionMutationVariables>;
export const SequenceFilterMentorListDocument = gql`
    query SequenceFilterMentorList($universitySlug: String, $limit: LimitedInt, $offset: Int, $mentorSeed: Int) {
  sequenceFilterMentorList(
    universitySlug: $universitySlug
    safeLimit: $limit
    offset: $offset
    mentorSeed: $mentorSeed
  ) {
    mentors {
      ...PublicMentorFieldProfileData
      ...PublicMentorFieldProfileCountry
      ...PublicMentorFieldFlags
      lastSeen
      bio
      isOnline
      degree {
        name
      }
    }
  }
}
    ${PublicMentorFieldProfileDataFragmentDoc}
${PublicMentorFieldProfileCountryFragmentDoc}
${PublicMentorFieldFlagsFragmentDoc}`;

/**
 * __useSequenceFilterMentorListQuery__
 *
 * To run a query within a React component, call `useSequenceFilterMentorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSequenceFilterMentorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSequenceFilterMentorListQuery({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      mentorSeed: // value for 'mentorSeed'
 *   },
 * });
 */
export function useSequenceFilterMentorListQuery(baseOptions?: Apollo.QueryHookOptions<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>(SequenceFilterMentorListDocument, options);
      }
export function useSequenceFilterMentorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>(SequenceFilterMentorListDocument, options);
        }
export function useSequenceFilterMentorListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>(SequenceFilterMentorListDocument, options);
        }
export type SequenceFilterMentorListQueryHookResult = ReturnType<typeof useSequenceFilterMentorListQuery>;
export type SequenceFilterMentorListLazyQueryHookResult = ReturnType<typeof useSequenceFilterMentorListLazyQuery>;
export type SequenceFilterMentorListSuspenseQueryHookResult = ReturnType<typeof useSequenceFilterMentorListSuspenseQuery>;
export type SequenceFilterMentorListQueryResult = Apollo.QueryResult<SequenceFilterMentorListQuery, SequenceFilterMentorListQueryVariables>;
export const BuddiesDocument = gql`
    query Buddies($universitySlug: String, $role: String, $limit: Int, $offset: Int) {
  buddies(
    universitySlug: $universitySlug
    role: $role
    limit: $limit
    offset: $offset
  ) {
    users {
      ...PublicBuddyFieldProfileData
      ...PublicStaffFields
    }
    count
  }
}
    ${PublicBuddyFieldProfileDataFragmentDoc}
${PublicStaffFieldsFragmentDoc}`;

/**
 * __useBuddiesQuery__
 *
 * To run a query within a React component, call `useBuddiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuddiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuddiesQuery({
 *   variables: {
 *      universitySlug: // value for 'universitySlug'
 *      role: // value for 'role'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBuddiesQuery(baseOptions?: Apollo.QueryHookOptions<BuddiesQuery, BuddiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuddiesQuery, BuddiesQueryVariables>(BuddiesDocument, options);
      }
export function useBuddiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuddiesQuery, BuddiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuddiesQuery, BuddiesQueryVariables>(BuddiesDocument, options);
        }
export function useBuddiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuddiesQuery, BuddiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuddiesQuery, BuddiesQueryVariables>(BuddiesDocument, options);
        }
export type BuddiesQueryHookResult = ReturnType<typeof useBuddiesQuery>;
export type BuddiesLazyQueryHookResult = ReturnType<typeof useBuddiesLazyQuery>;
export type BuddiesSuspenseQueryHookResult = ReturnType<typeof useBuddiesSuspenseQuery>;
export type BuddiesQueryResult = Apollo.QueryResult<BuddiesQuery, BuddiesQueryVariables>;
export const GetSpacesDocument = gql`
    query GetSpaces($userId: String!, $email: String!) {
  me {
    anyUser {
      id
    }
    applicant {
      id
      applicantUniversities {
        university {
          ...ApplicantUniversityField
        }
      }
    }
  }
  getUser(id: $userId) {
    id
    ...CommunitySpaces
  }
  getInvitesForEmail(email: $email) {
    id
    ...CommunityInviteSpaces
  }
}
    ${ApplicantUniversityFieldFragmentDoc}
${CommunitySpacesFragmentDoc}
${CommunityInviteSpacesFragmentDoc}`;

/**
 * __useGetSpacesQuery__
 *
 * To run a query within a React component, call `useGetSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpacesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetSpacesQuery(baseOptions: Apollo.QueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables> & ({ variables: GetSpacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
      }
export function useGetSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
        }
export function useGetSpacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSpacesQuery, GetSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpacesQuery, GetSpacesQueryVariables>(GetSpacesDocument, options);
        }
export type GetSpacesQueryHookResult = ReturnType<typeof useGetSpacesQuery>;
export type GetSpacesLazyQueryHookResult = ReturnType<typeof useGetSpacesLazyQuery>;
export type GetSpacesSuspenseQueryHookResult = ReturnType<typeof useGetSpacesSuspenseQuery>;
export type GetSpacesQueryResult = Apollo.QueryResult<GetSpacesQuery, GetSpacesQueryVariables>;
export const UniversalInboxDocument = gql`
    query UniversalInbox($offsetPagination: OffsetPaginationDto) {
  getChatConversationsForUser(offsetPagination: $offsetPagination) {
    ...UniversalInboxConversation
    ...LastMessageFragment
  }
}
    ${UniversalInboxConversationFragmentDoc}
${LastMessageFragmentFragmentDoc}`;

/**
 * __useUniversalInboxQuery__
 *
 * To run a query within a React component, call `useUniversalInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalInboxQuery({
 *   variables: {
 *      offsetPagination: // value for 'offsetPagination'
 *   },
 * });
 */
export function useUniversalInboxQuery(baseOptions?: Apollo.QueryHookOptions<UniversalInboxQuery, UniversalInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalInboxQuery, UniversalInboxQueryVariables>(UniversalInboxDocument, options);
      }
export function useUniversalInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalInboxQuery, UniversalInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalInboxQuery, UniversalInboxQueryVariables>(UniversalInboxDocument, options);
        }
export function useUniversalInboxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversalInboxQuery, UniversalInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalInboxQuery, UniversalInboxQueryVariables>(UniversalInboxDocument, options);
        }
export type UniversalInboxQueryHookResult = ReturnType<typeof useUniversalInboxQuery>;
export type UniversalInboxLazyQueryHookResult = ReturnType<typeof useUniversalInboxLazyQuery>;
export type UniversalInboxSuspenseQueryHookResult = ReturnType<typeof useUniversalInboxSuspenseQuery>;
export type UniversalInboxQueryResult = Apollo.QueryResult<UniversalInboxQuery, UniversalInboxQueryVariables>;
export const ChangeCommunityPasswordDocument = gql`
    mutation ChangeCommunityPassword($password: String, $token: String, $userId: String) {
  resetPasswordV2(userId: $userId, password: $password, token: $token) {
    success
    redirectUrl
    error
  }
}
    `;
export type ChangeCommunityPasswordMutationFn = Apollo.MutationFunction<ChangeCommunityPasswordMutation, ChangeCommunityPasswordMutationVariables>;

/**
 * __useChangeCommunityPasswordMutation__
 *
 * To run a mutation, you first call `useChangeCommunityPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCommunityPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCommunityPasswordMutation, { data, loading, error }] = useChangeCommunityPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChangeCommunityPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCommunityPasswordMutation, ChangeCommunityPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCommunityPasswordMutation, ChangeCommunityPasswordMutationVariables>(ChangeCommunityPasswordDocument, options);
      }
export type ChangeCommunityPasswordMutationHookResult = ReturnType<typeof useChangeCommunityPasswordMutation>;
export type ChangeCommunityPasswordMutationResult = Apollo.MutationResult<ChangeCommunityPasswordMutation>;
export type ChangeCommunityPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeCommunityPasswordMutation, ChangeCommunityPasswordMutationVariables>;
export const CommunityRequestPasswordResetDocument = gql`
    mutation CommunityRequestPasswordReset($email: String!, $redirectUrl: String!) {
  requestPasswordReset(
    email: $email
    redirectUrl: $redirectUrl
    rootUrl: COMMUNITY_URL
  ) {
    success
  }
}
    `;
export type CommunityRequestPasswordResetMutationFn = Apollo.MutationFunction<CommunityRequestPasswordResetMutation, CommunityRequestPasswordResetMutationVariables>;

/**
 * __useCommunityRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useCommunityRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityRequestPasswordResetMutation, { data, loading, error }] = useCommunityRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useCommunityRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CommunityRequestPasswordResetMutation, CommunityRequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommunityRequestPasswordResetMutation, CommunityRequestPasswordResetMutationVariables>(CommunityRequestPasswordResetDocument, options);
      }
export type CommunityRequestPasswordResetMutationHookResult = ReturnType<typeof useCommunityRequestPasswordResetMutation>;
export type CommunityRequestPasswordResetMutationResult = Apollo.MutationResult<CommunityRequestPasswordResetMutation>;
export type CommunityRequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<CommunityRequestPasswordResetMutation, CommunityRequestPasswordResetMutationVariables>;
export const SaveCookieConsentPreferencesDocument = gql`
    mutation SaveCookieConsentPreferences($input: CookieConsentInputDTO!) {
  saveCookieConsentPreferences(CookieConsentInputDTO: $input) {
    uniqueId
    preferences {
      strictCookies
      analyticsCookies
    }
  }
}
    `;
export type SaveCookieConsentPreferencesMutationFn = Apollo.MutationFunction<SaveCookieConsentPreferencesMutation, SaveCookieConsentPreferencesMutationVariables>;

/**
 * __useSaveCookieConsentPreferencesMutation__
 *
 * To run a mutation, you first call `useSaveCookieConsentPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCookieConsentPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCookieConsentPreferencesMutation, { data, loading, error }] = useSaveCookieConsentPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCookieConsentPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SaveCookieConsentPreferencesMutation, SaveCookieConsentPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCookieConsentPreferencesMutation, SaveCookieConsentPreferencesMutationVariables>(SaveCookieConsentPreferencesDocument, options);
      }
export type SaveCookieConsentPreferencesMutationHookResult = ReturnType<typeof useSaveCookieConsentPreferencesMutation>;
export type SaveCookieConsentPreferencesMutationResult = Apollo.MutationResult<SaveCookieConsentPreferencesMutation>;
export type SaveCookieConsentPreferencesMutationOptions = Apollo.BaseMutationOptions<SaveCookieConsentPreferencesMutation, SaveCookieConsentPreferencesMutationVariables>;
export const EditCookieConsentPreferencesDocument = gql`
    mutation EditCookieConsentPreferences($input: CookieConsentInputDTO!) {
  editCookieConsentPreferences(CookieConsentInputDTO: $input) {
    uniqueId
    preferences {
      strictCookies
      analyticsCookies
    }
  }
}
    `;
export type EditCookieConsentPreferencesMutationFn = Apollo.MutationFunction<EditCookieConsentPreferencesMutation, EditCookieConsentPreferencesMutationVariables>;

/**
 * __useEditCookieConsentPreferencesMutation__
 *
 * To run a mutation, you first call `useEditCookieConsentPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCookieConsentPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCookieConsentPreferencesMutation, { data, loading, error }] = useEditCookieConsentPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCookieConsentPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<EditCookieConsentPreferencesMutation, EditCookieConsentPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCookieConsentPreferencesMutation, EditCookieConsentPreferencesMutationVariables>(EditCookieConsentPreferencesDocument, options);
      }
export type EditCookieConsentPreferencesMutationHookResult = ReturnType<typeof useEditCookieConsentPreferencesMutation>;
export type EditCookieConsentPreferencesMutationResult = Apollo.MutationResult<EditCookieConsentPreferencesMutation>;
export type EditCookieConsentPreferencesMutationOptions = Apollo.BaseMutationOptions<EditCookieConsentPreferencesMutation, EditCookieConsentPreferencesMutationVariables>;